(function() {
  'use strict';

  angular
  .module('frontend', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'mgcrea.ngStrap', 'toastr', 'satellizer',
          'fixed.table.header' , 'angularLocalStorage', 'permission', 'ncy-angular-breadcrumb', 'angularUtils.directives.dirPagination','ngCsv','remoteValidation',
          'angucomplete-alt','ui.utils','ngmodel.format','disableAll','angular.filter','ngValidate','cgBusy','TreeView','DualMultiSelect']);//'ngLoadingSpinner',

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('IvsPrintController', IvsPrintController);

  /** @ngInject */
  function IvsPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('IvsPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.datasPerPage = 3;
    vm.nowDate = Math.round(+new Date()/1000);
    vm.zeroDataSwitch = false;
    
    // 合計値計算
    vm.mathtotal = function(sumKin){
        return sumKin.reduce(function(pre, curr) {
            return Number(pre) + Number(curr);
        });
    }
    vm.ivsPrint_id = 'ivsPrint';
    
    
    vm.pageEngneerInit = function(flg){
        vm.title = '';
        vm.mode = 1;
        vm.allItems = [];
        vm.datas = [];
        vm.zeroDataSwitch = flg;
        
        vm.title = 'スタジオ別　出庫集計表';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printIvsData');
        
        var printTargetData = data.data;
        vm.fromDate = data.fromDate;
        vm.toDate = data.toDate;
        
        
        var groupItems = $filter('groupBy')(printTargetData, 'bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFilter;
        var i = 0;
        angular.forEach(groupItems, function(datas, bumon_cd){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'ivspr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFilter = bumon_cd;
                vm.bumonName = datas[0].bumon_nm;
            }
            var chunk_size = 30;
            var dtl = $filter('orderBy')(datas, 'bumon_cd');
            var itemsArr = dtl.map( function(e,i){
                return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            allTemp.push(itemsArr);

            i++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
      //console.log(vm.allItems);
        //$log.debug(vm.allItems);
 
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            var items = angular.copy(vm.allItems);
            var filterd = $filter('filter')(items, { 'bumon_cd': vm.defaultFilter });
            vm.datas = filterd.slice(start, end);
            $log.debug(vm.datas);
        };
        
        // 部門選択
        vm.bumonSelect = function(group_no,name){
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.parentBumonName = name;
            vm.defaultFilter = group_no;
            var items = angular.copy(vm.allItems);
            var filterd = $filter('filter')(items, { 'bumon_cd': group_no });
            $log.debug(filterd);
            vm.totalCount = filterd.length;
            vm.datas = filterd.slice(0, vm.datasPerPage );
        };
        
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFilter, vm.bumonName);
    };

    vm.pageEngneerInit(false);
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('IviPrintController', IviPrintController);

  /** @ngInject */
  function IviPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('IviPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.datasPerPage = 3;
    vm.nowDate = Math.round(+new Date()/1000);
    vm.zeroDataSwitch = false;
    
    // 合計値計算
    vm.mathtotal = function(sumKin){
        return sumKin.reduce(function(pre, curr) {
            return Number(pre) + Number(curr);
        });
    }
    vm.ivsPrint_id = 'iviPrint';
    
    
    vm.pageEngneerInit = function(flg){
        vm.title = '';
        vm.mode = 1;
        vm.allItems = [];
        vm.datas = [];
        vm.zeroDataSwitch = flg;
        
        vm.title = '商品別　出庫集計表';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printIviData');
        
        var printTargetData = data.data;
        var tmp = [];
        angular.forEach(printTargetData, function(val){
            tmp.push(val);
        });
        vm.fromDate = data.fromDate;
        vm.toDate = data.toDate;
        
        var chunk_size = 26;
        var dtl = $filter('orderBy')(printTargetData, 'sg_item_cd');
        vm.allItems = dtl.map( function(e,i){
            return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
        }).filter(function(e){ return e; });
 
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            var items = angular.copy(vm.allItems);
            vm.datas = items.slice(start, end);
            $log.debug(vm.datas);
        };
        
        // 部門選択
        vm.pageInit = function(){
            vm.pagination = {current:1};
            var items = angular.copy(vm.allItems);
            vm.totalCount = items.length;
            vm.datas = items.slice(0, vm.datasPerPage );
        };
        vm.pageInit();
    };

    vm.pageEngneerInit(false);
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('IvlPrintController', IvlPrintController);

  /** @ngInject */
  function IvlPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('IvlPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.datasPerPage = 3;
    vm.nowDate = Math.round(+new Date()/1000);
    vm.zeroDataSwitch = false;
    
    // 合計値計算
    vm.mathtotal = function(sumKin){
        return sumKin.reduce(function(pre, curr) {
            return Number(pre) + Number(curr);
        });
    }
    /*
     * ■データ項目取得先
     * 最新単価    期間内における最終仕入単価を印字します。
     * 平均単価    （繰越金額＋入荷（仕入）金額＋調整（振替）金額）÷（繰越数量＋入荷（仕入）数量＋調整（振替）数量）
     *        （円未満切り捨て）
     * 繰越数量    期間（自）の前日時点の在庫数量を印字します。
     * 繰越金額    繰越数量×前日繰越単価
     * 入庫数量    期間内における入庫数量を印字します。
     * 入庫金額    期間内における入庫金額を印字します。
    
     * 出庫数量    期間内における出庫数量を印字します。
     * 出庫金額    出庫数量×平均単価を印字します。
     * 調整金額    平均単価を使用した場合の誤差を印字します。
     *         調整金額＝（繰越金額＋入庫（仕入）金額）－（出庫（売上）金額＋在庫金額）
     * 在庫数量    期間（至）時点の在庫数量を印字します。
     * 在庫金額    期間（至）時点の在庫金額（在庫数量×平均単価）を印字します。
     */
    vm.pageEngneerInit = function(flg){
        vm.title = '';
        vm.mode = 1;
        vm.allItems = [];
        vm.datas = [];
        vm.zeroDataSwitch = flg;
        
        vm.title = '在庫一覧';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printIvlData');
        var printTargetData = data.data;
        vm.fromDate = data.fromDate;
        vm.toDate = data.toDate;
        
        var geoupItems = $filter('groupBy')(printTargetData, 'bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFilter;
        var y=0;
        angular.forEach(geoupItems, function(datas,group){
            
            var tmp = [];
            if( !vm.zeroDataSwitch ){
                var x=0;
                // データの振り分け
                angular.forEach(datas, function(val, key){
                    if( val.kuri_suryo > 0 || ( val.nyuko_suryo > 0 || val.zai_nyuko_suryo > 0 || val.syukko_suryo > 0 || val.zai_ido_suryo > 0 ) ) {
                        if(x === 0) {
                            if( vm.bumonDropdown.length === 0) {
                                vm.defaultFilter = val.bumon_cd;
                                vm.bumonName = val.bumon_nm;
                            }
                            vm.bumonDropdown.push({'text':val.bumon_nm, 'click': 'ivlpr.bumonSelect("'+ val.bumon_cd +'","'+ val.bumon_nm +'")'});
                        }
                        tmp.push(val);
                        x++;
                    }
                });
            }else{
                vm.defaultFilter = datas[0].bumon_cd;
                vm.bumonName = datas[0].bumon_nm;
                vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'ivlpr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
                tmp = datas;
            }
            if( tmp.length > 0){
                
                var sum_kuri_kin=[],sum_nyuko_kin=[],sum_syukko_kin=[],sum_zai_ido_kin=[],sum_zai_nyuko_kin=[],sum_sou_kin=[];
                angular.forEach(tmp, function(val, key){
                    sum_kuri_kin.push(val.kuri_kin);
                    sum_nyuko_kin.push(val.nyuko_kin);
                    sum_syukko_kin.push(val.syukko_kin);
                    sum_zai_ido_kin.push(val.zai_ido_kin);
                    sum_zai_nyuko_kin.push(val.zai_nyuko_kin);
                    sum_sou_kin.push(val.sou_kin);
                });
                // 部門ごとの合計値
                var total = {
                        'bumon_cd':datas[0].bumon_cd,
                        'media_cd':'99999',
                        'bumon_nm':datas[0].bumon_nm+'合計',
                        'sum_kuri_kin':vm.mathtotal(sum_kuri_kin),
                        'sum_nyuko_kin':vm.mathtotal(sum_nyuko_kin),
                        'sum_syukko_kin':vm.mathtotal(sum_syukko_kin),
                        'sum_zai_ido_kin':vm.mathtotal(sum_zai_ido_kin),
                        'sum_zai_nyuko_kin':vm.mathtotal(sum_zai_nyuko_kin),
                        'sum_sou_kin':vm.mathtotal(sum_sou_kin)
                    };
                tmp.push(total);
                tmp  = $filter('orderBy')(tmp, ['media_cd_num']);
                var chunk_size = 15;
                //var tmp = $filter('orderBy')(datas, 'media_cd');
                //var items = $filter('orderBy')(tmp, 'media_cd');
                // 明細の数がn以上の場合nページに分ける
                var itemsArr = tmp.map( function(e,i){
                    return i%chunk_size===0 ? tmp.slice(i,i+chunk_size) : null;
                }).filter(function(e){ return e; });
                //console.log(itemsArr);
                allTemp.push(itemsArr);
                //console.log(itemsArr);
            }
            y++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        
        //$log.debug(vm.allItems);
 
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            var items = angular.copy(vm.allItems);
            var filterd = $filter('filter')(items, { 'bumon_cd': vm.defaultFilter });
            vm.datas = filterd.slice(start, end);
            $log.debug(vm.datas);
        };

        // 部門選択
        vm.bumonSelect = function(group_no,name){
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.parentBumonName = name;
            vm.defaultFilter = group_no;
            var items = angular.copy(vm.allItems);
            var filterd = $filter('filter')(items, { 'bumon_cd': group_no });
            //$log.debug(filterd);
            vm.totalCount = filterd.length;
            vm.datas = filterd.slice(0, vm.datasPerPage );
        };
        //　調整金額 （繰越金額＋入庫（仕入）金額）－（出庫（売上）金額＋在庫金額）
        //dtl.kuri_kin ,dtl.nyuko_kin,dtl.zai_nyuko_kin,dtl.syukko_kin,dtl.zai_ido_kin,dtl.sou_kin
        vm.chouseiSum = function(kuri, nyu, zai_nyu, syu, zai_syu, zai){
            var kun = Number(kuri)+Number(nyu)+Number(zai_nyu);
            var sun = Number(syu)+Number(zai)+Number(zai_syu);
            return (kun - sun);
        }
        
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFilter, vm.bumonName);
    };

    vm.pageEngneerInit(false);
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('IvisPrintController', IvisPrintController);

  /** @ngInject */
  function IvisPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('IvisPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.datasPerPage = 3;
    vm.nowDate = Math.round(+new Date()/1000);
    vm.zeroDataSwitch = false;
    
    // 合計値計算
    vm.mathtotal = function(sumKin){
        return sumKin.reduce(function(pre, curr) {
            return Number(pre) + Number(curr);
        });
    }
    vm.ivsPrint_id = 'ivisPrint';
    
    
    vm.pageEngneerInit = function(flg){
        vm.title = '';
        vm.mode = 1;
        vm.allItems = [];
        vm.datas = [];
        vm.zeroDataSwitch = flg;
        
        vm.title = '出庫一覧表';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printIvisData');
        
        var printTargetData = data.data;
        vm.fromDate = data.fromDate;
        vm.toDate = data.toDate;
        
        var groupItems = $filter('groupBy')(printTargetData, 'bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFilter;
        var i = 0;
        angular.forEach(groupItems, function(datas, bumon_cd){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'ivispr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFilter = bumon_cd;
                vm.bumonName = datas[0].bumon_nm;
            }
            var chunk_size = 15;
            var gpItems = $filter('groupBy')(datas, 'studio_cd');
            angular.forEach(gpItems, function(dt, gp){
                var gpItems2 = $filter('groupBy')(dt, 'sg_item_cd');
                
                // 明細の数がn以上の場合nページに分ける
                angular.forEach(gpItems2, function(dt,grp){
                    var dtl = $filter('orderBy')(dt, 'sg_day_time');
                    var itemsArr = dtl.map( function(e,i){
                        return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
                    }).filter(function(e){ return e; });
                    allTemp.push(itemsArr);
                });
            });
            //console.log(allTemp);

            //allTemp.push(gpItems);
            i++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });

        //console.log(vm.allItems);
        //$log.debug(vm.allItems);
 
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            var items = angular.copy(vm.allItems);
            var filterd = $filter('filter')(items, { 'bumon_cd': vm.defaultFilter });
            vm.datas = filterd.slice(start, end);
            $log.debug(vm.datas);
        };
        
        // 部門選択
        vm.bumonSelect = function(group_no,name){
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.parentBumonName = name;
            vm.defaultFilter = group_no;
            var items = angular.copy(vm.allItems);
            var filterd = $filter('filter')(items, { 'bumon_cd': group_no });
            $log.debug(filterd);
            vm.totalCount = filterd.length;
            vm.datas = filterd.slice(0, vm.datasPerPage );
        };
        
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFilter, vm.bumonName);
    };

    vm.pageEngneerInit(false);
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('urkPrintController', urkPrintController);

  /** @ngInject */
  function urkPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('urkPrintController');

    var vm = this;

    vm.printMode = null;
    // ページ初期化
    vm.datas = [];
    vm.datasPerPage = 15;
    vm.uriage_origin = [];
    vm.allItems = [];

    vm.commondata = storage.get('commondata');
    var printTargetData = storage.get('printUrkData');
    vm.printTarget_origin = angular.copy(printTargetData);
    vm.mode = printTargetData.sort;//sortモード
    var toDate = printTargetData.toDate;
    var fromDate = printTargetData.fromDate;
    vm.frm = moment(new Date(fromDate)).unix();
    vm.to = moment(new Date(toDate)).unix();
    vm.nowDate = Math.round(+new Date()/1000);

    // 入金予定（売上）
    vm.init = function(){
        // pagenation 設定
        vm.pagination = {current:1};
        // 使いましデータ取得

        vm.data = printTargetData.data;
        var bmnItems = $filter('groupBy')(vm.data, 'bumon_cd');

        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        var dataItems = [];
        vm.bumonList = [];
        angular.forEach(bmnItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'urkpr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            vm.bumonList.push(datas[0].bumon_cd);
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].bumon_nm;
            }
            // 明細の数が多いとページオーバーしちゃうので
            // 最大30件とし、配列を分ける
            var chunk = 25;
            var dtl = [];
            var itemsArr = [];
            dtl = $filter('orderBy')(datas, 'toku_km');
            //console.log(dtl);
            if(dtl.length > chunk ){
                itemsArr = dtl.map( function(e,i){
                    return i%chunk===0 ? dtl.slice(i,i+chunk) : null;
                }).filter(function(e){ return e; });
            }else{
                itemsArr.push(dtl);
            }
            allTemp.push(itemsArr);
            i++;
        });

        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });

        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            vm.filterd = $filter('filter')(vm.allItems, { 'bumon_cd': vm.defaultFiler });
            vm.datas = vm.filterd.slice(start, end);
            //$log.debug(vm.datas);
        };

        // 部門選択
        vm.bumonSelect = function(group_no,name){
            //console.log('group > ' + group_no);
            //console.log('name > ' + name);
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.defaultFiler = group_no;

            vm.filterd = $filter('filter')(vm.allItems, { 'bumon_cd': group_no });
            $log.debug(vm.filterd);
            vm.totalCount = vm.filterd.length;
            vm.datas = vm.filterd.slice(0, vm.datasPerPage );

        };
        // 最後の部門かどうか
        vm.checkLastBmn = function(bumon_cd){
            var no = vm.bumonList.indexOf(bumon_cd);
            var check = false;
            if(vm.bumonList.length === (no+1)) check = true;
            return check;
        }

        // 当月残高計算
        vm.setGetsuZan = function(dtIndex,key,itm){
            var zan = 0;
            zan = ((Number(itm.goukei) + Number(itm.zen_zan)) - ( Number(itm.furi_nk_kin) + Number(itm.furi_tes_kin) + Number(itm.ta_nk_kin))) -Number(itm.zatsu_son);
            vm.datas[dtIndex][key].getsu_zan = zan;
        }
        /*********************** 部門 **************************/
        // 部門前月残高合計
        vm.setBmnZenZanKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.zen_zan);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門売上合計
        vm.setBmnUriageKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.uriage);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門税金合計
        vm.setBmnZeiKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.zei);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門合計売上合計
        vm.setBmnGoukeiKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.goukei);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門振込入金合計
        vm.setBmnFuriNkKinKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.furi_nk_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門その他入金合計
        vm.setBmnTaNkKinKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.ta_nk_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門振込手数料合計
        vm.setBmnFuriTesKinKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.furi_tes_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門雑損合計
        vm.setBmnZatsuSonKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.zatsu_son);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門当月残高合計
        vm.setBmnGetsuZanKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.getsu_zan);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }

        /*********************** 総合計 **************************/
        // 総前月残高合計
        vm.setSoZenZanKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.zen_zan);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総売上合計
        vm.setSoUriageKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.uriage);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総税金合計
        vm.setSoZeiKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.zei);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総合計売上合計
        vm.setSoGoukeiKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.goukei);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総振込入金合計
        vm.setSoFuriNkKinKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.furi_nk_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総その他入金合計
        vm.setSoTaNkKinKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.ta_nk_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総振込手数料合計
        vm.setSoFuriTesKinKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.furi_tes_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総雑損合計
        vm.setSoZatsuSonKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.zatsu_son);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 総当月残高合計
        vm.setSoGetsuZanKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.getsu_zan);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }

        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
    }
    vm.init();

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('urSgItem', urSgItem);

  /** @ngInject */
  function urSgItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" style="width:100px"/>',
      controller: UrSgItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function UrSgItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('UrSgItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      // ng-repeatのアイテム中から取得するのでは無く、上位のscopeから取得する(変更時にも反映させるため)
      $attrs.$observe('sgKtcd', function(value){
          //vm.sg_keitai_cd = value;
      });
      //console.log($attrs);
      vm.origin_value;
      if( $scope.$parent.item.sg_item_cd ){
          $scope.dirValue = $scope.$parent.item.sg_item_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      //console.log($scope.$parent.item);
      // ng-repeat アイテムの変更をキャッチ
      $scope.$watch(function() { return $scope.$parent.item;}, function(newVal, oldVal) {
          //console.log(newVal);
          //vm.sg_keitai_cd = newVal.sg_keitai_cd;
          vm.sg_bunrui_cd = newVal.sg_bunrui_cd;
      }, true);

      // 初期化
      vm.itemInit = function(){
          vm.sagyoDtl = [];
          vm.sagyoDtl = vm.sgItemKit.sgItem;
          
          // 作業分類Dropdown
          vm.bunruiDropdown = [{'name':'--', 'id':''}];
          angular.forEach(vm.sgItemKit.sgBunrui ,function(v,k){
              vm.bunruiDropdown.push({'name':v.sg_bunrui_nm, 'id':v.sg_bunrui_cd});
          });
          // 作業分類Dropdown
          vm.bumonDropdown = [{'name':'--', 'id':''}];
          angular.forEach(vm.sgItemKit.sgBumon ,function(v,k){
              vm.bumonDropdown.push({'name':v.bumon_nm, 'id':v.bumon_cd});
          });
      }
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/ur-print/urSgItem/ursgitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(item){
          
          //console.log(item);
          //console.log($scope.$parent.item);
          
          $scope.$parent.item.tani_1 = item.tani_1;
          $scope.$parent.item.tani_2 = item.tani_2;
          $scope.$parent.item.suryo_kbn_1 = item.suryo_kbn_1;
          $scope.$parent.item.suryo_kbn_2 = item.suryo_kbn_2;
          $scope.$parent.item.time_fl = item.time_fl;
          if( Number(item.time_fl) !== 1 ){
              $scope.$parent.item.stt_tm = '';
              $scope.$parent.item.stt_tm_str = '';
              $scope.$parent.item.end_tm = '';
              $scope.$parent.item.end_tm_str = '';
          }
          $scope.$parent.item.studio_cd = item.studio_cd;
          $scope.$parent.item.sg_bunrui_cd = item.sg_bunrui_cd;
          $scope.$parent.item.sg_item_cd = item.sg_item_cd;
          $scope.$parent.item.sg_item_nms = item.sg_item_nms;
          $scope.$parent.item.tanka = item.base_tanka;
          
          $scope.dirValue = item.sg_item_cd;
          $scope.$parent.urprint.tankaChange($scope.$parent.prKey,$scope.$parent.sgNo,$scope.$parent.idx);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('tkmtPrintController', tkmtPrintController);

  /** @ngInject */
  function tkmtPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('tkmtPrintController');

    var vm = this;

    vm.printMode = null;
    // ページ初期化
    vm.datas = [];
    vm.datasPerPage = 15;
    vm.uriage_origin = [];
    vm.allItems = [];

    vm.commondata = storage.get('commondata');
    var printTargetData = storage.get('printTkmtData');
    vm.printTarget_origin = angular.copy(printTargetData);
    vm.mode = printTargetData.nkyt;//モード
    var toDate = printTargetData.toDate;
    var fromDate = printTargetData.fromDate;
    vm.frm = moment(new Date(fromDate)).unix();
    vm.to = moment(new Date(toDate)).unix();
    vm.nowDate = Math.round(+new Date()/1000);
    
    // 入金予定（売上）
    vm.uriageInit = function(){
        // pagenation 設定
        vm.pagination = {current:1};
        // 使いましデータ取得
        
        var data = printTargetData.data;
        vm.data = $filter('orderBy')(data, 'bumon_cd');
        var bmnItems = $filter('groupBy')(vm.data, 'bumon_cd');
        
        //console.log(vm.data);
        
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        var dataItems = [];
        angular.forEach(bmnItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'tkmtpr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].bumon_nm;
            }
            
            var inTmp = [];
            var inTmp2 = [];
            // さらに得意先でグループ
            var tmp = $filter('groupBy')(datas, 'toku_cd');
            
            angular.forEach(tmp, function(v){
                inTmp.push(v);
            });
            // 明細の数が多いとページオーバーしちゃうので
            // 最大20件とし、配列を分ける
            var chunk = 28;
            angular.forEach(tmp, function(dt,grp){
                var dtl = $filter('orderBy')(dt, 'ur_day');
                if(dtl.length > chunk ){
                    var itemsArr = dtl.map( function(e,i){
                        return i%chunk===0 ? dtl.slice(i,i+chunk) : null;
                    }).filter(function(e){ return e; });
                    angular.forEach(itemsArr, function(v){
                        inTmp2.push(v);
                    });
                }else{
                    inTmp2.push(dtl);
                }
            });
            dataItems.push(inTmp2)
            i++;
        });
        //console.log(dataItems);
        // 明細の数がn以上の場合nページに分ける
        var chunk_size = 1;
        angular.forEach(dataItems, function(dt,grp){
            var dtl = $filter('orderBy')(dt, '-toku_cd');
            var itemsArr = dtl.map( function(e,i){
                return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            allTemp.push(itemsArr);
        });

        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': vm.defaultFiler });
            //filterd = $filter('orderBy')(filterd, 'toku_cd');
            vm.datas = filterd.slice(start, end);
            //$log.debug(vm.datas);
        };

        // 部門選択
        vm.bumonSelect = function(group_no,name){
            //console.log('group > ' + group_no);
            //console.log('name > ' + name);
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.defaultFiler = group_no;
           
            var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': group_no });
            //filterd = $filter('orderBy')(filterd, {'toku_cd':true});
            $log.debug(filterd);
            vm.totalCount = filterd.length;
            vm.datas = filterd.slice(0, vm.datasPerPage );
            
        };
        
        // 次のページにまたがっているかのチェック
        vm.nextCheck = function(dtIndex){
            var check = false;
            var nextObject = vm.datas[dtIndex+1];
            var next_cd = '';
            if( angular.isObject(nextObject) ) {
                next_cd = nextObject[0][0].toku_cd;
            }
            var current_cd = vm.datas[dtIndex][0][0].toku_cd;
            if(current_cd !== next_cd || !next_cd){
                check = true;
            }
            //console.log(check);
            return check;
        }
        
        // 各合計算出
        vm.getGoukei = function(zen,kon){
            return Number(zen) + Number(kon);
        }
        
        /******************* 明細 **********************/
        // 行差引残高
        vm.getSasiZan = function(index, items){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(items, function(v, k){
                if( k <= index ){
                    var kin = Number(v.jt_ur_kin)+Number(v.zei_kin);
                    if( v.sk_no === '999999'){
                        kin = v.nk_kin*-1;
                        //console.log('入金 : ' + kin);
                    }
                    kei.push(kin);
                }
            });
            //console.log(kei);
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        
        /******************* 期間合計 **********************/
        // 売上合計
        vm.setKikanGoukeiUri = function(items){
            var kei = [];
            angular.forEach(items, function(v){
                if( v.sk_no !== '000000') {
                    kei.push(v.jt_ur_kin);
                }
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 税金合計
        vm.setKikanGoukeiZei = function(items){
            var kei = [];
            angular.forEach(items, function(v){
                if( v.sk_no !== '000000') kei.push(v.zei_kin);
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 入金合計
        vm.setKikanGoukeiNyukin = function(items){
            var kei = [];
            angular.forEach(items, function(v){
                if( v.sk_no !== '000000') kei.push(v.nk_kin);
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 差引き残高合計
        vm.setKikanGoukeiHikikin = function(items){
            var kei = [];
            angular.forEach(items, function(v){
                //console.log(v.sk_no);
                //console.log(v.sasi_zan);
                if(v.sasi_zan) kei.push(v.sasi_zan);
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        
        
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
        //$log.debug(vm.allItems);
    };
    vm.uriageInit();
    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('nkytPrintController', nkytPrintController);

  /** @ngInject */
  function nkytPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('nkytPrintController');

    var vm = this;

    vm.printMode = null;
    // ページ初期化
    vm.datas = [];
    vm.datasPerPage = 5;
    vm.uriage_origin = [];
    vm.allItems = [];

    vm.commondata = storage.get('commondata');
    var printTargetData = storage.get('printNkytData');
    vm.printTarget_origin = angular.copy(printTargetData);
    vm.mode = printTargetData.nkyt;//モード
    var toDate = printTargetData.toDate;
    var fromDate = printTargetData.fromDate;
    vm.frm = moment(new Date(fromDate)).unix();
    vm.to = moment(new Date(toDate)).unix();
    vm.nowDate = Math.round(+new Date()/1000);
    vm.bumonList = [];
    
    // 入金予定（売上）
    vm.uriageInit = function(){
        // pagenation 設定
        vm.pagination = {current:1};
        // 使いましデータ取得
        
        vm.data = printTargetData.data;
        var bmnItems = $filter('groupBy')(vm.data, 'bumon_cd');
        $log.debug(bmnItems);
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        var dataItems = [];
        angular.forEach(bmnItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'nkytpr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            vm.bumonList.push(datas[0].bumon_cd);
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].bumon_nm;
            }
            
            var inTmp = [];
            var inTmp2 = [];
            // さらに入金予定日でグループ
            var tmp = $filter('groupBy')(datas, 'nk_yt_day')
            angular.forEach(tmp, function(v){
                inTmp.push(v);
            });
            // 明細の数が多いとページオーバーしちゃうので
            // 最大８件とし、配列を分ける
            var chunk = 8;
            angular.forEach(inTmp, function(dt,grp){
                var dtl = $filter('orderBy')(dt, '-toku_cd');
                if(dtl.length > chunk ){
                    var itemsArr = dtl.map( function(e,i){
                        return i%chunk===0 ? dtl.slice(i,i+chunk) : null;
                    }).filter(function(e){ return e; });
                    angular.forEach(itemsArr, function(v){
                        inTmp2.push(v);
                    });
                }else{
                    inTmp2.push(dtl);
                }
            });
            dataItems.push(inTmp2)
            i++;
        });
        //console.log(dataItems);
        // 明細の数がn以上の場合nページに分ける
        var chunk_size = 3;
        angular.forEach(dataItems, function(dt,grp){
            var dtl = $filter('orderBy')(dt, 'toku_cd');
            var itemsArr = dtl.map( function(e,i){
                return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            allTemp.push(itemsArr);
        });

        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': vm.defaultFiler });
            vm.datas = filterd.slice(start, end);
            //$log.debug(vm.datas);
        };

        // 部門選択
        vm.bumonSelect = function(group_no,name){
            //console.log('group > ' + group_no);
            //console.log('name > ' + name);
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.defaultFiler = group_no;
           
            var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': group_no });
            //$log.debug(filterd);
            vm.totalCount = filterd.length;
            vm.datas = filterd.slice(0, vm.datasPerPage );
            
        };
        
        /******************* 売上 **********************/
        // 部門合計
        vm.getBmnKei = function(){
            var kei = [];
            angular.forEach(vm.datas, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if( v.toku_cd === '000000') kei.push(v.yotei_kin);
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 期間合計
        vm.getKikanKei = function(){
            var kei = [];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if( v.toku_cd === '000000') kei.push(v.yotei_kin);
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        /******************* /売上 **********************/
        
        /******************* /請求 **********************/
        // 各合計算出
        vm.getGoukei = function(zen,kon){
            return Number(zen) + Number(kon);
        }
        
        // 今回回収額 
        vm.getZenGoukei = function(items){
            var kei = [];
            angular.forEach(items, function(v){
                if( v.toku_cd !== '000000') kei.push(v.zen_zan_kin);
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 振込回収額
        vm.getNyukinYotei = function(item,modes){
            
            if(item.toku_cd !== '000000'){
                var mode = Number(modes);
                var keiKin = Number(item.yotei_kin) + Number(item.zen_zan_kin);
                var genkai_kin1 = Number(item.genkai_kin1);
                var genkai_kin2 = Number(item.genkai_kin2);
                var genkai_kin3 = Number(item.genkai_kin3);
                var nk_ketai1 = Number(item.nk_ketai1);
                var nk_ketai2 = Number(item.nk_ketai2);
                var nk_ketai3 = Number(item.nk_ketai3);

                //console.log(nk_ketai1 + ' : ' + nk_ketai2)
                // 入金形態１
                if( nk_ketai1 === 1 && !nk_ketai2 ){
                    //console.log('if 1 > ' +item.toku_cd);
                    if( mode == 1) return keiKin;
                    if( mode == 2) return 0;
                    if( mode == 3) return 0;
                // 入金形態２の設定がある企業
                }else if( nk_ketai1 === 1 && nk_ketai2 === 2 ){
                    if( genkai_kin1 < keiKin && genkai_kin2 > keiKin ){
                        //console.log('if 2 > ' +item.toku_cd);
                        if( mode == 1) return 0;
                        if( mode == 2) return keiKin;
                        if( mode == 3) return 0;
                    }else{
                        //console.log('if 3 > ' +item.toku_cd);
                        if( mode == 1) return keiKin;
                        if( mode == 2) return 0;
                        if( mode == 3) return 0;
                    }
                // 入金形態がその他の場合
                }else if( nk_ketai1 !== 1 || nk_ketai2 !== 2 ){
                    //console.log('other > ' +item.toku_cd);
                    if( mode == 1) return 0;
                    if( mode == 2) return 0;
                    if( mode == 3) return keiKin;
                }
            }
        }
        // 振込回収額
        vm.getFuriGoukei = function(mode, filter){
            var kei = [];
            var tmp = [];
            angular.forEach(vm.datas, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        tmp.push(v);
                    });
                });
            });
            var filterd = $filter('filter')(tmp, { 'nk_yt_day_time': filter });
            angular.forEach(filterd, function(v){
                if(v.toku_cd !== '000000'){
                    if( mode === 1 ){
                        if(v.furi_kai_kin) kei.push(v.furi_kai_kin);
                    }else if( mode === 2 ){
                        //console.log(v);
                        if(v.tegata_kai_kin) kei.push(v.tegata_kai_kin);
                    }else if( mode === 3 ){
                        if(v.sonota_kai_kin) kei.push(v.sonota_kai_kin);
                    }
                }
            });

            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門別 前回合計
        vm.getBmnZenKei = function(){
            var kei = [];
            angular.forEach(vm.datas, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if( v.toku_cd !== '000000') kei.push(v.zen_zan_kin);
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門別 今回合計
        vm.getBmnKonKei = function(){
            var kei = [];
            angular.forEach(vm.datas, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if( v.toku_cd !== '000000') kei.push(v.yotei_kin);
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        
        // 部門別 振込回収合計額
        vm.getBmnFuriKei = function(mode){
            var kei = [];
            angular.forEach(vm.datas, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if(v.toku_cd !== '000000'){
                            if( mode === 1 ){
                                if(v.furi_kai_kin) kei.push(v.furi_kai_kin);
                            }else if( mode === 2 ){
                                //console.log(v);
                                if(v.tegata_kai_kin) kei.push(v.tegata_kai_kin);
                            }else if( mode === 3 ){
                                if(v.sonota_kai_kin) kei.push(v.sonota_kai_kin);
                            }
                        }
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        
        // 前回合計 総計
        vm.getZenSouKei = function(){
            var kei = [];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if( v.toku_cd !== '000000') kei.push(v.zen_zan_kin);
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        
        // 今回回収合計 総計
        vm.getKonSouKei = function(){
            var kei = [];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if( v.toku_cd !== '000000') kei.push(v.yotei_kin);
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        //　回収額 総計
        vm.getFuriSouKei = function(mode){
            var kei = [];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(itm){
                    angular.forEach(itm, function(v){
                        if(v.toku_cd !== '000000'){
                            if( mode === 1 ){
                                if(v.furi_kai_kin) kei.push(v.furi_kai_kin);
                            }else if( mode === 2 ){
                                //console.log(v);
                                if(v.tegata_kai_kin) kei.push(v.tegata_kai_kin);
                            }else if( mode === 3 ){
                                if(v.sonota_kai_kin) kei.push(v.sonota_kai_kin);
                            }
                        }
                    });
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        
        // 最後の部門かどうか
        vm.checkLastBmn = function(bumon_cd){
            var no = vm.bumonList.indexOf(bumon_cd);
            var check = false;
            if(vm.bumonList.length === (no+1)) check = true;
            return check;
        }
        
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
        //$log.debug(vm.allItems);
    };
    
    
    
    if(vm.mode === '1'){
        vm.uriageInit();
    }else if(vm.mode === '2'){
        vm.uriageInit();
    }
    

    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MprintController', MprintController);

  /** @ngInject */
  function MprintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MprintController');

    var vm = this;

    // ページ初期化
    var names = {
       'sgHkcheck' : '作業報告承認',
       'sgUrCheck' : '作業売上承認',
       'khCheck' : '経費承認',
       'uriageCntCheck' : '複数売上承認',
       'sgUrCntCheck' : '複数作業売上承認',
       'uriageCheck' : '売上承認'
    };
    vm.datasPerPage = 1;
    vm.pageInit = function(){
        // pagenation 設定
        vm.datasPerPage;
        vm.now = moment().unix();
        var printTargetData = storage.get('mPrintData');
        vm.errorPrint = true;

        //console.log(printTargetData);
        var printData = [];
        var chunk_size = 30;
        vm.pageLengthArr = [];
        angular.forEach(printTargetData, function(itm, i){
            var dataArr = [];
            if( itm.data.length > chunk_size ){
                dataArr = itm.data.map( function(e,i){
                    return i%chunk_size===0 ? itm.data.slice(i,i+chunk_size) : null;
                }).filter(function(e){ return e; });
            }else{
                dataArr.push(itm.data);
            }
            vm.pageLengthArr.push(dataArr.length);
            printData.push({type:itm.name,name:names[itm.name],data:dataArr});
        });
        vm.pageLength = vm.pageLengthArr.reduce(function(pre, curr) {
            return Number(pre) + Number(curr);
        });
        //console.log(printData);
        vm.printData = printData;
        /*vm.datas = vm.invoiceData.slice(0, vm.datasPerPage);

        $log.debug(vm.datas);
        vm.pagination = {current:1};

        // 使いましデータ取得
        vm.commondata = storage.get('commondata');

        $log.debug(vm.datas);
        vm.pagination = {current:1};
        */


        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
    };
    vm.pageInit();
    
    vm.goPrint = function(){
        $window.print();
    };
    // 内側のページ数
    vm.getInnerPageCnt = function(key,child){
        var i=0,nowLen=[];
        while(i <= key ){
            nowLen.push(vm.pageLengthArr[i]-child);
            i++;
        }
        if(nowLen.length > 0){
            return nowLen.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }else{
            return 1;
        }
    };
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.totalDatas = vm.invoiceData.length;
        vm.datas = vm.invoiceData.slice(pageNumber-1, (pageNumber-1) + vm.datasPerPage );
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('mklistPrintController', mklistPrintController);

  /** @ngInject */
  function mklistPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('mklistPrintController');

    var vm = this;

    vm.printMode = null;
    // ページ初期化
    vm.datas = [];
    vm.datasPerPage = 20;
    vm.uriage_origin = [];
    vm.allItems = [];

    vm.commondata = storage.get('commondata');
    var printTargetData = storage.get('printMklistData');
    vm.printTarget_origin = angular.copy(printTargetData);
    vm.mode = printTargetData.sort;//sortモード
    var toDate = printTargetData.toDate;
    var fromDate = printTargetData.fromDate;
    vm.frm = moment(new Date(fromDate)).unix();
    vm.to = moment(new Date(toDate)).unix();
    vm.nowDate = Math.round(+new Date()/1000);
    
    // 入金予定（売上）
    vm.init = function(){
        // pagenation 設定
        vm.pagination = {current:1};
        // 使いましデータ取得
        
        vm.data = printTargetData.data;
        var bmnItems = $filter('groupBy')(vm.data, 'bumon_cd');
        
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        var dataItems = [];
        vm.bumonList = [];
        angular.forEach(bmnItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'mklistpr.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            vm.bumonList.push(datas[0].bumon_cd);
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].bumon_nm;
            }
            // 明細の数が多いとページオーバーしちゃうので
            // 最大30件とし、配列を分ける
            var chunk = 25;
            var itemsArr = [];
            var dtl = [];
            if( Number(vm.mode) === 1){
                dtl = $filter('orderBy')(datas, 'toku_km');
            }else{
                dtl = $filter('orderBy')(datas, 'tan_km');
            }
            
            if(dtl.length > chunk ){
                itemsArr = dtl.map( function(e,i){
                    return i%chunk===0 ? dtl.slice(i,i+chunk) : null;
                }).filter(function(e){ return e; });
            }else{
                itemsArr.push(dtl);
            }
            allTemp.push(itemsArr);
            i++;
        });

        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        
        // 次のページ/前のページ
        vm.pageChanged = function(newPage) {
            var start = 0;
            var end = vm.datasPerPage;
            if(newPage > 1){
                start = (newPage - 1) * vm.datasPerPage;
                end = start + start;
            }
            vm.filterd = $filter('filter')(vm.allItems, { 'bumon_cd': vm.defaultFiler });
            vm.datas = vm.filterd.slice(start, end);
            //$log.debug(vm.datas);
        };

        // 部門選択
        vm.bumonSelect = function(group_no,name){
            //console.log('group > ' + group_no);
            //console.log('name > ' + name);
            vm.pagination = {current:1};
            vm.bumonName = name;
            vm.defaultFiler = group_no;
           
            vm.filterd = $filter('filter')(vm.allItems, { 'bumon_cd': group_no });
            //$log.debug(vm.filterd);
            vm.totalCount = vm.filterd.length;
            vm.datas = vm.filterd.slice(0, vm.datasPerPage );
            
        };
        // 最後の部門かどうか
        vm.checkLastBmn = function(bumon_cd){
            var no = vm.bumonList.indexOf(bumon_cd);
            var check = false;
            if(vm.bumonList.length === (no+1)) check = true;
            return check;
        }
        // 部門請求合計
        vm.setBmnSkKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.ur_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 部門未入金合計
        vm.setBmnMiKei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.filterd, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.ur_kin)-Number(v.nk_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 請求総合計
        vm.setSouGouSkkei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.ur_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }
        // 未入金総合計
        vm.setSouGouMikei = function(){
            // 明細を足してゆく
            var kei=[];
            angular.forEach(vm.allItems, function(items){
                angular.forEach(items, function(v, k){
                    var kin = Number(v.ur_kin)-Number(v.nk_kin);
                    kei.push(kin);
                });
            });
            if(kei.length > 0){
                return kei.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }else{
                return 0;
            }
        }

        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
    }
    vm.init();
    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('TransferControllController', TransferControllController);

  /** @ngInject */
  function TransferControllController($log, $timeout, $http, $auth, $stateParams,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, toastr) {

    $log.debug('TransferControllController');

    var vm = this;
    vm.user = storage.get('user');
    
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    //console.log('isEditDisabled : ' + vm.isEditDisabled);
    
    // Menu
    $rootScope.panelSelected(3,'082');
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    // sgItemセレクト用
    vm.controllerAliasName = 'trf';
    
    // Tooltip
    //vm.editTooltip1 = {'title': '-受注編集-<br />受注の編集を行います'};

    /****************************************************** Search Area ************************************************/
    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.editScope = {};
        vm.bmn_nm = '';
        vm.tan_nm = '';
        
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-12);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        //console.log(vm.form.fromDate);
        vm.form.untilDate = new Date();

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        getResultsPage(1);
        vm.pagination = {
            current: 1
        };
        vm.getFurikaeOptionData();
    };
    
    // 関係データ取得
    vm.getFurikaeOptionData = function() {
        $http({
            url: dev.api + 'api/v1/getfurikaeoptiondata',
            method: 'GET'
        }).success(function(data) {
            // 各部門Dropdown
            vm.frBumonDropdown = [{'text':'－－', 'click': 'trf.frBumonSelect()'}];
            vm.editScope.frBumonDropdown = [{'text':'－－', 'click': 'trf.editScope.frBumonSelect()'}];
            vm.editScope.frItemBumonDropdown = [{'text':'－－', 'click': 'trf.editScope.frItemBumonSelect()'}];
            angular.forEach(data.bumon ,function(v,k){
                vm.frBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'trf.frBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.frBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'trf.editScope.frBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.frItemBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'trf.editScope.frItemBumonSelect(key,"'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            // 伝票区分
            vm.denKubunDropdown = [{'text':'－－', 'click': 'trf.denKubunSelect()'}];
            vm.editScope.denKubunDropdown = [{'text':'－－', 'click': 'trf.denKubunSelect()'}];
            angular.forEach(data.kubun ,function(v,k){
                vm.denKubunDropdown.push({'text':v.den_kb + ' : '+ v.den_kb_nm, 'click': 'trf.denKubunSelect("'+ v.den_kb +'","'+ v.den_kb_nm +'")'});
                vm.editScope.denKubunDropdown.push({'text':v.den_kb + ' : '+ v.den_kb_nm, 'click': 'trf.editScope.denKubunSelect("'+ v.den_kb +'","'+ v.den_kb_nm +'")'});
            });
        });
    };
    
    vm.formInit();

    // 伝票区分選択
    vm.denKubunSelect = function(den_kb, den_kb_nm){
        if(den_kb && den_kb_nm){
            vm.den_kb_nm = den_kb_nm;
            vm.form.den_kb = den_kb;
        }else{
            vm.den_kb_nm = '';
            vm.form.den_kb = '';
        }
    };
    // 振り替え部門選択
    vm.frBumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.sr_bmn_cd = bumon_cd;
            vm.sr_bmn_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        }else{
            vm.form.sr_bmn_cd = '';
            vm.sr_bmn_nm = '';
        }
    };
    // 振り替え担当取得
    vm.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.editScope.eigyoDropdown = [];
            angular.forEach(data ,function(v,k){
                vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'icc.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
            });
        });
    };
    // 振り替え担当選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.tan_cd = syain_cd;
            vm.tan_nm = syain_nm;
        }else{
            vm.form.tan_cd = '';
            vm.tan_nm = '';
        }
    };
    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
                if(!v) delete search[k];//不要なparamは削除
             });
        }
        $http({
            url: dev.api + 'api/v1/transfer',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            vm.totalKin = datas.totalKin;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }
    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.form.tori_cd = '';
        vm.formInit();
    };

    
    /****************************************************** Edit Area ************************************************/
    // Scopeに注意

    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/inventory/inventory-transfer/transferedit.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    // ModalClose
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };
    $scope.$on('modal.hide',function(){
        //console.log('modal.hide');
        toastr.clear();
    });
    // Edit Disabled
    vm.isFromDisabled = false;
    vm.isFromDetailError = false;

    // EditMode init
    vm.editForm = {};
    vm.editModeInit = function(mode, item){
        vm.editScope.editMode = mode;
        
        // 最終月次月
        var ym = vm.commondata.kihon.getuji_ym.toString();
        // 現在日時
        vm.now = moment().unix();
        // 最終月次実施月末
        vm.getuji_last_daytime = moment(ym, 'YYYYMMDD').endOf('month').unix();
        // 月次未済最小月
        vm.getuji_next_first_daytime = moment(ym, 'YYYYMMDD').add({months:1}).startOf('month').unix();
        vm.editScope.min_day = new Date(vm.getuji_next_first_daytime*1000);
        
        
        // Table Row追加
        vm.editScope.tableExtend = function(){
            var detail = {
                    gyo_no:'',
                    mei_kb: 1,
                    den_type:'',
                    bumon_cd:'',
                    hin_cd: 0,
                    suryo:'',
                    tani: 0,
                    tanka: 0,
                    total_kn: 0
            };
            var base = angular.copy(vm.editForm.detail);
            base.push(detail);
            vm.editForm.detail = base;
        };
        // Table Row 複写
        vm.editScope.tableRowCopy = function($index){
            //console.log($index);
            var base = angular.copy(vm.editForm.detail);
            var detail = angular.copy(base[$index]);
            base.splice($index+1, 0, detail);
            vm.editForm.detail = base;
            $log.debug(vm.editForm.detail);
        };
        // Table Row削除
        vm.editScope.tableCellDelete = function($index){
            //console.log($index);
            var base = angular.copy(vm.editForm.detail);
            base.splice($index , 1);
            vm.editForm.detail = base;
            $log.debug(vm.editForm.detail);
        };
        
        // 新規登録
        if(mode === 1 && !item){

            vm.isFromDisabled = false;

            // From初期化
            vm.editForm = {};
            vm.editForm.detail = [];
            vm.editForm.den_kb = '1';
            vm.editForm.ido_day = new Date();
            vm.editScope.tableExtend();

        // 編集モード
        }else if(mode === 2 && item){
            vm.editForm = {};
            vm.editForm.detail = [];
            $log.debug(item);
            
            vm.editForm = item;
            vm.isFromDisabled = false;
            if(vm.editForm.ido_day_time > 0){
                // 月次済みチェック
                if( vm.getuji_last_daytime > item.ido_day_time ){
                    toastr.info('月次処理済みのため、編集できません', 'Info');
                    vm.isFromDisabled = true;
                }
                vm.editForm.ido_day = new Date(item.ido_day_time*1000);
            }
            //console.log(vm.editForm);
        }
        
        // 振り替え部門選択
        vm.editScope.frBumonSelect = function(bumon_cd, bumon_nm){
            vm.editForm.tan_cd = '';
            vm.editForm.tan_nm = '';
            if(bumon_cd && bumon_nm){
                vm.editForm.bmn_cd = bumon_cd;
                vm.editForm.bmn_nm = bumon_nm;
                vm.editScope.getTantoEigyo(bumon_cd);
            }else{
                vm.editForm.bmn_cd = '';
                vm.editForm.bmn_nm = '';
            }
        };
        // 在庫部門選択
        vm.editScope.frItemBumonSelect = function(index, bumon_cd, bumon_nm){
            if(bumon_cd && bumon_nm){
                vm.editForm.detail[index].bumon_cd = bumon_cd;
                vm.editForm.detail[index].bumon_nm = bumon_nm;
            }else{
                vm.editForm.detail[index].bumon_cd = '';
                vm.editForm.detail[index].bumon_nm = '';
            }
        };
        // 伝票区分選択
        vm.editScope.denKubunSelect = function(den_kb, den_kb_nm){
            if(den_kb && den_kb_nm){
                vm.editForm.den_kb_nm = den_kb_nm;
                vm.editForm.den_kb = den_kb;   
            }else{
                vm.editForm.den_kb_nm = '';
                vm.editForm.den_kb = '';
            }
        };
        // 振り替え担当取得
        vm.editScope.getTantoEigyo = function(bumon_cd){
            $http({
                url: dev.api + 'api/v1/tantoueigyo',
                method: "GET",
                params: {'cd': bumon_cd}
            }).success(function(data) {
                vm.editScope.eigyoDropdown = [];
                angular.forEach(data ,function(v,k){
                    vm.editScope.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'trf.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            });
        };
        // 振り替え担当選択
        vm.editScope.eigyoSelect = function(syain_cd, syain_nm){
            if(syain_cd && syain_nm){
                vm.editForm.tan_cd = syain_cd;
                vm.editForm.tan_nm = syain_nm;
            }else{
                vm.editForm.tan_cd = '';
                vm.editForm.tan_nm = '';
            }
        };
        
        // 金額算出
        vm.setTotalKin = function(){
            angular.forEach(vm.editForm.detail, function(v,k){
                var suryo = (Number(v.suryo) !== 0) ? Number(v.suryo):0;
                var tanka = (Number(v.tanka) !== 0) ? Number(v.tanka):0;
                vm.editForm.detail[k].total_kn = suryo * tanka;
            });
        }
        
        // 合計金額算出 : 明細区分チェック
        $scope.$watch(function() {
            return vm.editForm.detail;
        }, function(newVal, oldVal) {
            if(newVal !== oldVal){
                var check = [];
                // 明細から金額を計算
                if( !vm.isFromDisabled ){ //編集可能状態のみ
                    vm.setTotalKin();
                }
                // 明細区分チェック
                if( Number(vm.editForm.den_kb) === 1){
                    //console.log('check den_kb');
                    check = [1,2,3,4,5];
                    angular.forEach(vm.editForm.detail ,function(v,k){
                        vm.isFromDetailError = false;
                        vm.editForm.detail[k].error = false;
                        if( check.indexOf(Number(v.mei_kb)) === -1){
                            vm.editForm.detail[k].mei_kb = '';
                            vm.editForm.detail[k].error = true;
                            vm.isFromDetailError = true;
                        }
                    });
                }else if( Number(vm.editForm.den_kb) === 2){
                    //console.log('check den_kb');
                    check = [6,7,8,9];
                    angular.forEach(vm.editForm.detail ,function(v,k){
                        vm.isFromDetailError = false;
                        vm.editForm.detail[k].error = false;
                        if( check.indexOf(Number(v.mei_kb)) === -1){
                            vm.editForm.detail[k].mei_kb = '';
                            vm.editForm.detail[k].error = true;
                            vm.isFromDetailError = true;
                        }
                    });
                }
            }
        },true);
        
        // 伝票区分チェック
        $scope.$watch(function() {
            return vm.editForm.den_kb;
        }, function(newVal, oldVal) {
            if(newVal !== oldVal){
                angular.forEach(vm.editForm.detail ,function(v,k){
                    vm.editForm.detail[k].mei_kb = '';
                    vm.isFromDetailError = true;
                });
            }
        },true);
        

        // 画面Open
        vm.openEdit();
    };
    
   

    // formSubmit
    vm.editScope.formSubmit = function(method){
        $log.debug(vm.editForm);
        // 日付Fromat整形
        if( vm.editForm.ido_day && angular.isDate(vm.editForm.ido_day) ){
            vm.editForm.ido_day = moment(vm.editForm.ido_day).format('YYYY/MM/DD');
        }

        var completeMessage = 'が完了しました';
        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.ido_no){
                return false;
            }
            completeMessage = '更新'+completeMessage;
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.ido_no){
                return false;
            }
            var ido_no = vm.editForm.ido_no;
            vm.editForm = {};
            vm.editForm.ido_no = ido_no;
            completeMessage = '削除'+completeMessage;
        }else{
            completeMessage = '登録'+completeMessage;
        }

        $http({
            url: dev.api + 'api/v1/transfer' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            // formクリア
            if(method === 'POST'){
                vm.hideEdit();
                $state.go($state.current, null, {reload: true});
            }else{
                getResultsPage(1);//一覧更新
                vm.hideEdit();
            }
            toastr.info(completeMessage, 'Info');
        });

    };
    
    // 登録/更新Formクリア
    vm.editScope.cancel = function(mode){
        vm.editModeInit(mode);
    };

    
    
    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InventoryStudioController', InventoryStudioController);

  /** @ngInject */
  function InventoryStudioController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('InventoryStudioController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(3,'084');
    vm.commondata = storage.get('commondata');
    
    
    vm.init = function(){
        
        vm.form = {};
        vm.form.sgItem = [];
        var targetUnix = moment().add({months:-3}).unix();
        vm.form.fromDate = new Date(targetUnix*1000);

        vm.bumonListCheckAll = 1;
        vm.mediaListCheckAll = 1;
        vm.formError = false;
        vm.formDateError = false;
        
        $http({
            url: dev.api + 'api/v1/getinventorystudiooptions',
            method: 'GET',
        }).success(function(datas) {
            $log.debug(datas);
            vm.bumonList = datas.bumon;
            //vm.mediaList = datas.media;
        });
    }
    vm.init();
    
    // すべてチェック
    vm.bumonListCheck = function(){
        var check = !vm.bumonListCheckAll;
        var flg = check?1:0;
        angular.forEach(vm.bumonList ,function(v,k){
            vm.bumonList[k].checked = flg;
        });
        vm.bumonListCheckAll = flg;
    };
    // すべてチェック
    vm.mediaListCheck = function(){
        var check = !vm.mediaListCheckAll;
        var flg = check?1:0;
        if(!flg) vm.form.sgItem = [];
    };
    
    
    // 帳票生成実行
    vm.generateInventoryStudio = function() {
        var form = angular.copy(vm.form);
        delete form.sgItem; 
        $log.debug(form);
        vm.formError = false;
        vm.formDateError = false;
        var bCnt=0,bumonList=[],mediaList=[];
        angular.forEach(vm.bumonList ,function(v,k){
            if(v.checked) {
                bumonList.push(v.bumon_cd);
                bCnt++;
            }
        });
        if( bCnt === 0 ){
            vm.formError = true;
        }else{
            if( form.fromDate ){
                if( angular.isDate(form.fromDate) ){
                    form.fromDate = moment(form.fromDate).format('YYYY/MM/DD');
                }
                if( angular.isDate(form.untilDate) ){
                    form.untilDate = moment(form.untilDate).format('YYYY/MM/DD');
                }
                if( bCnt === vm.bumonList.length ){
                    form.bumon = 'all';
                }else{
                    form.bumon = bumonList;
                }
                if( vm.form.sgItem.length > 0){
                    form.media = vm.form.sgItem;
                }else{
                    form.media = 'all';
                }
                $log.debug(form);
                $http({
                    url: dev.api + 'api/v1/generateinventorystudio',
                    method: 'GET',
                    params: {values:angular.toJson(form)}
                }).success(function(datas) {
                    $log.debug(datas);
                    if(!datas.data || datas.data.length === 0 ){
                        vm.error = 'データが存在しません'
                    }else{
                        storage.set('printIvsData', datas);
                        if( $rootScope.openWindow ){
                            $rootScope.openWindow.focus();
                            $rootScope.openWindow.close();
                        }
                        $rootScope.openWindow = $window.open('#/ivs-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                    }
                });
            }else{
                vm.formDateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InventorySgItemController', InventorySgItemController);

  /** @ngInject */
  function InventorySgItemController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('InventorySgItemController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(3,'085');
    vm.commondata = storage.get('commondata');
    
    
    vm.init = function(){
        
        vm.form = {};
        vm.form.sgItem = [];
        vm.form.sgswitch = 1;
        var targetUnix = moment().add({months:-3}).unix();
        vm.form.fromDate = new Date(targetUnix*1000);

        vm.bumonListCheckAll = 1;
        vm.mediaListCheckAll = 1;
        vm.formError = false;
        vm.formDateError = false;
        /*
        $http({
            url: dev.api + 'api/v1/getinventorysgitemoptions',
            method: 'GET',
        }).success(function(datas) {
            $log.debug(datas);
            vm.bumonList = datas.bumon;
            //vm.mediaList = datas.media;
        });
        */
    }
    vm.init();
    
    // すべてチェック
    vm.bumonListCheck = function(){
        var check = !vm.bumonListCheckAll;
        var flg = check?1:0;
        angular.forEach(vm.bumonList ,function(v,k){
            vm.bumonList[k].checked = flg;
        });
        vm.bumonListCheckAll = flg;
    };
    // すべてチェック
    vm.mediaListCheck = function(){
        var check = !vm.mediaListCheckAll;
        var flg = check?1:0;
        if(!flg) vm.form.sgItem = [];
    };
    
    
    // 帳票生成実行
    vm.generateInventoryStudio = function() {
        var form = angular.copy(vm.form);
        delete form.sgItem; 
        $log.debug(form);
        vm.formError = false;
        vm.formDateError = false;
        
        var bCnt=1,bumonList=[],mediaList=[];
        /*
        angular.forEach(vm.bumonList ,function(v,k){
            if(v.checked) {
                bumonList.push(v.bumon_cd);
                bCnt++;
            }
        });
        */
        if( bCnt === 0 ){
            vm.formError = true;
        }else{
            if( form.fromDate ){
                if( angular.isDate(form.fromDate) ){
                    form.fromDate = moment(form.fromDate).format('YYYY/MM/DD');
                }
                if( angular.isDate(form.untilDate) ){
                    form.untilDate = moment(form.untilDate).format('YYYY/MM/DD');
                }
                /*
                if( bCnt === vm.bumonList.length ){
                    form.bumon = 'all';
                }else{
                    form.bumon = bumonList;
                }
                */
                form.bumon = [];
                if( vm.form.sgItem.length > 0){
                    form.media = vm.form.sgItem;
                }else{
                    form.media = 'all';
                }
                $log.debug(form);
                $http({
                    url: dev.api + 'api/v1/generateinventorysgitem',
                    method: 'GET',
                    params: {values:angular.toJson(form)}
                }).success(function(datas) {
                    $log.debug(datas);
                    if(!datas.data || datas.data.length === 0 ){
                        vm.error = 'データが存在しません'
                    }else{
                        storage.set('printIviData', datas);
                        if( $rootScope.openWindow ){
                            $rootScope.openWindow.focus();
                            $rootScope.openWindow.close();
                        }
                        $rootScope.openWindow = $window.open('#/ivi-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                    }
                });
            }else{
                vm.formDateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InventoryListController', InventoryListController);

  /** @ngInject */
  function InventoryListController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('InventoryListController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(3,'083');
    vm.commondata = storage.get('commondata');
    
    vm.init = function(){
        
        vm.form = {};
        vm.form.sgItem = [];
        var targetUnix = moment().add({months:-2}).unix();
        vm.form.fromDate = new Date(targetUnix*1000);
        vm.form.untilDate = new Date(moment(vm.form.fromDate).add({months:+1}).add({day:-1}).unix()*1000);
        
        vm.bumonListCheckAll = 1;
        vm.mediaListCheckAll = 1;
        vm.formError = false;
        vm.formDateError = false;
        
        vm.form.bumon_cd = '0110';
        
        $http({
            url: dev.api + 'api/v1/getinventorylistoptions',
            method: 'GET',
        }).success(function(datas) {
            $log.debug(datas);
            vm.bumonList = datas.bumon;
            //vm.mediaList = datas.media;
        });
        
        $scope.$watch(function() {
            return vm.form.fromDate;
        }, function(curr, org) {
            var max = new Date(moment(vm.form.fromDate).add({months:+1}).add({day:-1}).unix()*1000);
            vm.maxDate = max;
            vm.form.untilDate = max;
        });
    }
    vm.init();
    
    // すべてチェック
    vm.bumonListCheck = function(){
        var check = !vm.bumonListCheckAll;
        var flg = check?1:0;
        angular.forEach(vm.bumonList ,function(v,k){
            vm.bumonList[k].checked = flg;
        });
        vm.bumonListCheckAll = flg;
    };
    // すべてチェック
    vm.mediaListCheck = function(){
        var check = !vm.mediaListCheckAll;
        var flg = check?1:0;
        if(!flg) vm.form.sgItem = [];
    };
    
    
    // 帳票生成実行
    vm.generateInventoryList = function() {
        var form = angular.copy(vm.form);
        $log.debug(form);
        vm.formError = false;
        vm.formDateError = false;
        var bCnt=1,bumonList=[],mediaList=[];
        /*angular.forEach(vm.bumonList ,function(v,k){
            if(v.checked) {
                bumonList.push(v.bumon_cd);
                bCnt++;
            }
        });
        */
        if( bCnt === 0 ){
            vm.formError = true;
        }else{
            if( form.fromDate ){
                if( angular.isDate(form.fromDate) ){
                    form.fromDate = moment(form.fromDate).format('YYYY/MM/DD');
                }
                if( angular.isDate(form.untilDate) ){
                    form.untilDate = moment(form.untilDate).format('YYYY/MM/DD');
                }
                /*
                if( bCnt === vm.bumonList.length ){
                    form.bumon = 'all';
                }else{
                    form.bumon = bumonList;
                }
                */
                form.bumon = [];
                form.bumon.push(vm.form.bumon_cd);
                if( vm.form.sgItem.length > 0){
                    form.media = vm.form.sgItem;
                }else{
                    form.media = 'all';
                }
                $log.debug(form);
                $http({
                    url: dev.api + 'api/v1/generateinventorylist',
                    method: 'GET',
                    params: {values:angular.toJson(form)}
                }).success(function(datas) {
                    $log.debug(datas);
                    if(!datas.data || datas.data.length === 0 ){
                        vm.error = 'データが存在しません'
                    }else{
                        storage.set('printIvlData', datas);
                        if( $rootScope.openWindow ){
                            $rootScope.openWindow.focus();
                            $rootScope.openWindow.close();
                        }
                        $rootScope.openWindow = $window.open('#/ivl-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                    }
                });
            }else{
                vm.formDateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InventoryControllController', InventoryControllController);

  /** @ngInject */
  function InventoryControllController($log, $timeout, $http, $auth, $stateParams,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, toastr) {

    $log.debug('InventoryControllController');

    var vm = this;
    vm.user = storage.get('user');
    
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    //console.log('isEditDisabled : ' + vm.isEditDisabled);
    
    // Menu
    $rootScope.panelSelected(3,'081');
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    // sgItemセレクト用
    vm.controllerAliasName = 'icc';
    
    // Tooltip
    //vm.editTooltip1 = {'title': '-受注編集-<br />受注の編集を行います'};

    /****************************************************** Search Area ************************************************/
    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.editScope = {};
        vm.sr_bmn_nm = '';
        vm.zaiko_bmn_nm = '';
        vm.tori_nm = '';
        vm.form.tori_cd = '';
        vm.sr_kb_nm = '';
        
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-24);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        //console.log(vm.form.fromDate);
        vm.form.untilDate = new Date();

        vm.siireKubun = [{'sr_kb':'1','sr_kb_nm':'掛仕入'},{'sr_kb':'2','sr_kb_nm':'現金仕入'}];
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        getResultsPage(1);
        vm.pagination = {
            current: 1
        };
        vm.getZaikoOptionData();
    };
    
    // 関係データ取得
    vm.getZaikoOptionData = function() {
        $http({
            url: dev.api + 'api/v1/getzaikooptiondata',
            method: 'GET'
        }).success(function(data) {
            // 各部門Dropdown
            vm.srBumonDropdown = [{'text':'－－', 'click': 'icc.srBumonSelect()'}];
            vm.zaikoBumonDropdown = [{'text':'－－', 'click': 'icc.zaikoBumonSelect()'}];
            vm.editScope.srBumonDropdown = [{'text':'－－', 'click': 'icc.editScope.srBumonSelect()'}];
            vm.editScope.zaikoBumonDropdown = [{'text':'－－', 'click': 'icc.editScope.zaikoBumonSelect()'}];
            angular.forEach(data.bumon ,function(v,k){
                vm.srBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'icc.srBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.zaikoBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'icc.zaikoBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.srBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'icc.editScope.srBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.zaikoBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'icc.editScope.zaikoBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            // 税率一覧
            vm.taxrate = data.taxrate;
            // 仕入区分
            vm.srDropdown = [{'text':'－－', 'click': 'icc.srKubunSelect()'}];
            vm.editScope.srDropdown = [{'text':'－－', 'click': 'icc.srKubunSelect()'}];
            angular.forEach(data.kubun ,function(v,k){
                vm.srDropdown.push({'text':v.sr_kb + ' : '+ v.sr_kb_nm, 'click': 'icc.srKubunSelect("'+ v.sr_kb +'","'+ v.sr_kb_nm +'")'});
                vm.editScope.srDropdown.push({'text':v.sr_kb + ' : '+ v.sr_kb_nm, 'click': 'icc.editScope.srKubunSelect("'+ v.sr_kb +'","'+ v.sr_kb_nm +'")'});
            });
        });
    };
    
    vm.formInit();

    // 表示用
    vm.getKubunName = function(cd){
        var name;
        angular.forEach(vm.siireKubun, function(v,k){
            if(v.sr_kb === cd ) name = v.sr_kb_nm;
        });
        return name;
    };
    // 業務区分選択
    vm.srKubunSelect = function(sr_kb, sr_kb_nm){
        if(sr_kb && sr_kb_nm){
            vm.sr_kb_nm = sr_kb_nm;
            vm.form.sr_kb = sr_kb;
        }else{
            vm.sr_kb_nm = '';
            vm.form.sr_kb = '';
        }
    };
    // 仕入部門選択
    vm.srBumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.sr_bmn_cd = bumon_cd;
            vm.sr_bmn_nm = bumon_nm;
        }else{
            vm.form.sr_bmn_cd = '';
            vm.sr_bmn_nm = '';
        }
    };
    // 在庫部門選択
    vm.zaikoBumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.zaiko_bmn_cd = bumon_cd;
            vm.zaiko_bmn_nm = bumon_nm;
        }else{
            vm.form.zaiko_bmn_cd = '';
            vm.zaiko_bmn_nm = '';
        }
    };
    
    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
                if(!v) delete search[k];//不要なparamは削除
             });
        }
        $http({
            url: dev.api + 'api/v1/controll',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            vm.totalKin = datas.totalKin;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }
    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.form.tori_cd = '';
        vm.formInit();
    };

    
    /****************************************************** Edit Area ************************************************/
    // Scopeに注意

    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/inventory/inventory-controll/controlledit.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    // ModalClose
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };
    $scope.$on('modal.hide',function(){
        //console.log('modal.hide');
        toastr.clear();
    });
    // Edit Disabled
    vm.isFromDisabled = false;

    // EditMode init
    vm.editForm = {};
    vm.editModeInit = function(mode, item){
        vm.editScope.editMode = mode;
        vm.isFromDetailError = false;
        
        // 最終月次月
        var ym = vm.commondata.kihon.getuji_ym.toString();
        // 現在日時
        vm.now = moment().unix();
        // 最終月次実施月末
        vm.getuji_last_daytime = moment(ym, 'YYYYMMDD').endOf('month').unix();
        // 月次未済最小月
        vm.getuji_next_first_daytime = moment(ym, 'YYYYMMDD').add({months:1}).startOf('month').unix();
        vm.editScope.min_day = new Date(vm.getuji_next_first_daytime*1000);
        
        // 支払日設定
        vm.editScope.set_siharai_date = function(sr_day){
            if( !sr_day )return;
            var next_siharai_daytime,sr_date;
            //console.log('set_siharai_date');
            if( angular.isDate(sr_day) ){
                var siharai_dd = Number(vm.commondata.kihon.sh_dd);
                if( siharai_dd === 99){
                    // 月末の場合
                    sr_date = moment(sr_day).format('YYYYMMDD');
                    next_siharai_daytime = moment(sr_date, 'YYYYMMDD').add({months:1}).endOf('month').unix();
                    //vm.editForm.yotei_day = new Date(next_siharai_daytime*1000);
                }else{
                    // 日付指定の場合
                    sr_date = moment(sr_day).format('YYYYMMDD');
                    var year = moment(sr_date, 'YYYYMMDD').year();
                    var month = moment(sr_date, 'YYYYMMDD').month()+1;
                    var pre_sh = year +'/'+ month +'/'+ vm.siharai_dd;
                    next_siharai_daytime = moment(pre_sh, 'YYYYMMDD').add({months:1}).unix();
                    //vm.editForm.yotei_day = new Date(next_siharai_daytime*1000);
                }
            }
        }
        
        // Table Row追加
        vm.editScope.tableExtend = function(){
            var detail = {
                    gyo_no:'',
                    mei_kb: 1,
                    hin_cd:'',
                    hin_nm:'',
                    suryo: 0,
                    tani:'',
                    tanka: 0,
                    total_kn: 0,
                    zei_kn: 0
            };
            var base = angular.copy(vm.editForm.detail);
            base.push(detail);
            vm.editForm.detail = base;
        };
        // Table Row 複写
        vm.editScope.tableRowCopy = function($index){
            //console.log($index);
            var base = angular.copy(vm.editForm.detail);
            var detail = angular.copy(base[$index]);
            base.splice($index+1, 0, detail);
            vm.editForm.detail = base;
            $log.debug(vm.editForm.detail);
        };
        // Table Row削除
        vm.editScope.tableCellDelete = function($index){
            //console.log($index);
            var base = angular.copy(vm.editForm.detail);
            base.splice($index , 1);
            vm.editForm.detail = base;
            $log.debug(vm.editForm.detail);
        };
        
        
        // 新規登録
        if(mode === 1 && !item){

            vm.isFromDisabled = false;

            // From初期化
            vm.editForm = {};
            vm.editForm.detail = [];
            vm.editForm.sr_kb = '1';
            vm.editForm.sr_day = new Date();
            // 支払日調整
            //vm.editScope.set_siharai_date(vm.editForm.sr_day);
            vm.editForm.yotei_day = '';
            vm.editScope.tableExtend();

        // 編集モード
        }else if(mode === 2 && item){
            vm.editForm = {};
            vm.editForm.detail = [];
            $log.debug(item);
            
            vm.editForm = angular.copy(item);
            vm.isFromDisabled = false;
            if(vm.editForm.sr_day_time > 0){
                // 月次済みチェック
                if( vm.getuji_last_daytime > item.sr_day_time ){
                    vm.toastr_1 = toastr.info('月次処理済みのため、編集できません', 'Info');
                    vm.isFromDisabled = true;
                }
                vm.editForm.sr_day = new Date(item.sr_day_time*1000);
            }
            //console.log(vm.editForm.yotei_day);
            //console.log(vm.editForm.yotei_day_time);
            //console.log(new Date(item.yotei_day_time*1000));
            if(vm.editForm.yotei_day_time > 0){
                
                //console.log('time change');
                
                vm.editForm.yotei_day = new Date(item.yotei_day_time*1000);
            }
            //console.log(vm.editForm.yotei_day);
            //console.log(vm.editForm);
        }
        
        // 表示用
        vm.editScope.getKubunName = function(cd){
            var name;
            angular.forEach(vm.siireKubun, function(v,k){
                if(v.sr_kb === cd ) name = v.sr_kb_nm;
            });
            return name;
        };
        // 業務区分選択
        vm.editScope.srKubunSelect = function(sr_kb, sr_kb_nm){
            if(sr_kb && sr_kb_nm){
                vm.editForm.sr_kb_nm = sr_kb_nm;
                vm.editForm.sr_kb = sr_kb;   
            }else{
                vm.editForm.sr_kb_nm = '';
                vm.editForm.sr_kb = '';
            }
        };
        // 仕入部門選択
        vm.editScope.srBumonSelect = function(bumon_cd, bumon_nm){
            //console.log(bumon_cd +':'+bumon_nm)
            if(bumon_cd && bumon_nm){
                vm.editForm.sr_bmn_cd = bumon_cd;
                vm.editForm.sr_bmn_nm = bumon_nm;
                vm.getTantoEigyo(bumon_cd);
            }else{
                vm.editForm.sr_bmn_cd = '';
                vm.editForm.sr_bmn_nm = '';
                vm.editScope.eigyoDropdown = [];
                vm.editScope.eigyoSelect();
            }
        };
        // 在庫部門選択
        vm.editScope.zaikoBumonSelect = function(bumon_cd, bumon_nm){
            if(bumon_cd && bumon_nm){
                vm.editForm.zaiko_bmn_cd = bumon_cd;
                vm.editForm.zaiko_bmn_nm = bumon_nm;
            }else{
                vm.editForm.zaiko_bmn_cd = '';
                vm.editForm.zaiko_bmn_nm = '';
            }
        };
        // 仕入担当取得
        vm.getTantoEigyo = function(bumon_cd){
            $http({
                url: dev.api + 'api/v1/tantoueigyo',
                method: "GET",
                params: {'cd': bumon_cd}
            }).success(function(data) {
                vm.editScope.eigyoDropdown = [];
                angular.forEach(data ,function(v,k){
                    vm.editScope.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'icc.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            });
        };
        // 仕入担当選択
        vm.editScope.eigyoSelect = function(syain_cd, syain_nm){
            if(syain_cd && syain_nm){
                vm.editForm.sr_tan_cd = syain_cd;
                vm.editForm.sr_tan_nm = syain_nm;
            }else{
                vm.editForm.sr_tan_cd = '';
                vm.editForm.sr_tan_nm = '';
            }
        };
        
        // 消費税計算時に％切り替えがあった場合を想定して入力（変更）時に判定させる
        $scope.$watch(function() { return vm.editForm.sr_day;}, function(newVal,oldVal) {
            if(newVal !== oldVal){
                vm.editForm.sr_day_time = moment(new Date(vm.editForm.sr_day)).unix();
                vm.editScope.set_siharai_date(new Date(vm.editForm.sr_day));// 支払日調整
            }
        });
        
        vm.editScope.setMeiKbName = function(mei_kb){
            var kb = Number(mei_kb),name;
            if(kb === 1){
                name = '税抜';
            }else if(kb === 2){
                name = '税込';
            }else if(kb === 3){
                name = '非課税';
            }
            return name;
        }
        
        // 画面Open
        vm.openEdit();
    };
    
    

    // 税抜き商品税金合計算出
    vm.getZeinukiItemZei = function(index){
        var zeinuki_total=[];
        angular.forEach(vm.editForm.detail, function(v,k){
            if( Number(v.mei_kb) === 1 ) zeinuki_total.push(v.zei_kn);
        });
        if(zeinuki_total.length > 0){
            var total_kn = zeinuki_total.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            //console.log(total_kn);
            vm.editForm.detail[index].total_kn = total_kn;
            //console.log(vm.editForm.detail[index]);
        }
    };
    
    // 金額算出
    vm.setTotalKin = function(sr_day){
        // 消費税が10%になる日を想定。日付の境界をきちんと設定
        var taxrate = 0;
        //console.log(sr_day);
        angular.forEach(vm.taxrate, function(v, k){
            var start_day = v.start_day_time*1000;
            var end_day = null;
            if( v.end_day_time ) {
                end_day = v.end_day_time*1000;
            }
            // 現在
            if( start_day <= sr_day && !end_day){
                taxrate = parseFloat(v.tax_rate);
            }else if(end_day && (start_day <= sr_day) && (sr_day <= end_day) ){
                // 古い値
                taxrate = parseFloat(v.tax_rate);
            }
        });
        var totalKin=[],totalZeiKin=[],kei_kin=0,zei_kin=0;
        angular.forEach(vm.editForm.detail, function(v,k){
            var zei_kn=0,total_hiki_kin = 0;
            var suryo = (Number(v.suryo) !== 0) ? Number(v.suryo):0;
            var tanka = (Number(v.tanka) !== 0) ? Number(v.tanka):0;
            var mei_kb = Number(v.mei_kb);
            var total_kn = suryo * tanka;
            // 内税/外税/非課税
            switch( mei_kb ){
                case 1:
                    zei_kn =  Math.floor(total_kn * taxrate);
                    break;
                case 2:
                    var nukiKin = Math.floor(total_kn / (1+taxrate));
                    zei_kn = total_kn-nukiKin;
                    total_hiki_kin = total_kn - zei_kn;
                    totalZeiKin.push(zei_kn);
                    break;
                case 3:
                    break;
                case 7:
                case 9:
                    total_kn = v.total_kn;
                    break;
            }
            // アイテム毎の税金
            vm.editForm.detail[k].zei_kn = zei_kn;
            // アイテム毎のトータル
            vm.editForm.detail[k].total_kn = total_kn;
            // 内税/外税で合計の数値を分ける
            var tl = (total_hiki_kin !== 0) ? total_hiki_kin:total_kn;
            totalKin.push(tl);
        });
        if(totalKin.length > 0){
            // 全体合計金額(表示用)
            kei_kin = totalKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        if(totalZeiKin.length > 0){
            // 全体合計税金(表示用)
            zei_kin = totalZeiKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        // 表示用
        vm.editScope.goukei_kin = kei_kin + zei_kin;
        $log.debug(vm.editForm.detail);
    }
    
    //　合計金額
    $scope.$watch(function() {
        return vm.editForm.detail;
    }, function(newVal, oldVal) {
        if(newVal !== oldVal){
            // 明細から金額を計算
            if( !vm.isFromDisabled ){ //編集可能状態のみ
                var sr_day;
                if( vm.editForm.sr_day && angular.isDate(vm.editForm.sr_day) ){
                    var tmp_date = moment(vm.editForm.sr_day).format('YYYYMMDD');
                    sr_day = moment(tmp_date, 'YYYYMMDD').unix()*1000;
                }else{
                    sr_day = vm.editForm.sr_day_time*1000;
                }
                vm.setTotalKin(sr_day);
                var check = [1,2,3,7,9];
                angular.forEach(vm.editForm.detail ,function(v,k){
                    vm.isFromDetailError = false;
                    vm.editForm.detail[k].error = false;
                    if( check.indexOf(Number(v.mei_kb)) === -1){
                        vm.editForm.detail[k].mei_kb = '';
                        vm.editForm.detail[k].error = true;
                        vm.isFromDetailError = true;
                    }
                });
            }else{
                vm.editScope.goukei_kin = vm.editForm.kei_kn;
            }
        }
    },true);
    
    // 商品明細区分チェンジ
    vm.editScope.changeMeiKb = function(index){
        if( Number(vm.editForm.detail[index].mei_kb) === 9){
            vm.editForm.detail[index].hin_cd = '';
            vm.editForm.detail[index].hin_nm = '【税抜商品・消費税額】';
            vm.editForm.detail[index].suryo = '';
            vm.editForm.detail[index].tani = '';
            vm.editForm.detail[index].tanka = '';
            vm.editForm.detail[index].total_kn = 0;
            // 税金計算
            var totalZeiKin=[];
            angular.forEach(vm.editForm.detail, function(v,k){
                if( Number(v.mei_kb) === 1 ){
                    totalZeiKin.push(v.zei_kn);
                }
            });
            if(totalZeiKin.length > 0){
                vm.editForm.detail[index].total_kn = totalZeiKin.reduce(function(pre, curr) {
                    return Number(pre) + Number(curr);
                });
            }
        }else  if( Number(vm.editForm.detail[index].mei_kb) === 7){
            vm.editForm.detail[index].hin_cd = '';
            vm.editForm.detail[index].hin_nm = '【値引】';
            vm.editForm.detail[index].suryo = '';
            vm.editForm.detail[index].tani = '';
            vm.editForm.detail[index].tanka = '';
            vm.editForm.detail[index].total_kn = 0;
        }
    }
    
   
    // formSubmit
    vm.editScope.formSubmit = function(method){
        $log.debug(vm.editForm);
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.sr_day && is('Date', vm.editForm.sr_day) ){
            vm.editForm.sr_day = moment(vm.editForm.sr_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.yotei_day && is('Date', vm.editForm.yotei_day) ){
            vm.editForm.yotei_day = moment(vm.editForm.yotei_day).format('YYYY/MM/DD HH:mm');
        }

        var completeMessage = 'が完了しました';
        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.sr_no){
                return false;
            }
            completeMessage = '更新'+completeMessage;
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.sr_no){
                return false;
            }
            var sr_no = vm.editForm.sr_no;
            vm.editForm = {};
            vm.editForm.sr_no = sr_no;
            completeMessage = '削除'+completeMessage;
        }else{
            completeMessage = '登録'+completeMessage;
        }

        $http({
            url: dev.api + 'api/v1/controll' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            // formクリア
            if(method === 'POST'){
                vm.hideEdit();
                $state.go($state.current, null, {reload: true});
            }else{
                getResultsPage(1);//一覧更新
                vm.hideEdit();
            }
            toastr.info(completeMessage, 'Info');
        });

    };
    
    // 登録/更新Formクリア
    vm.editScope.cancel = function(mode){
        vm.editModeInit(mode);
    };

    
    
    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InventoryIssueController', InventoryIssueController);

  /** @ngInject */
  function InventoryIssueController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('InventoryIssueController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(3,'086');
    vm.commondata = storage.get('commondata');
    
    
    vm.init = function(){
        
        vm.form = {};
        vm.form.sgItem = [];
        var targetUnix = moment().add({months:-3}).unix();
        vm.form.fromDate = new Date(targetUnix*1000);

        vm.bumonListCheckAll = 1;
        vm.mediaListCheckAll = 1;
        vm.formError = false;
        vm.formDateError = false;
        
        $http({
            url: dev.api + 'api/v1/getinventoryissueoptions',
            method: 'GET',
        }).success(function(datas) {
            $log.debug(datas);
            vm.bumonList = datas.bumon;
            //vm.mediaList = datas.media;
        });
    }
    vm.init();
    
    // すべてチェック
    vm.bumonListCheck = function(){
        var check = !vm.bumonListCheckAll;
        var flg = check?1:0;
        angular.forEach(vm.bumonList ,function(v,k){
            vm.bumonList[k].checked = flg;
        });
        vm.bumonListCheckAll = flg;
    };
    // すべてチェック
    vm.mediaListCheck = function(){
        var check = !vm.mediaListCheckAll;
        var flg = check?1:0;
        if(!flg) vm.form.sgItem = [];
    };
    
    
    // 帳票生成実行
    vm.generateInventoryIssue = function() {
        var form = angular.copy(vm.form);
        delete form.sgItem; 
        $log.debug(form);
        vm.formError = false;
        vm.formDateError = false;
        var bCnt=0,bumonList=[],mediaList=[];
        angular.forEach(vm.bumonList ,function(v,k){
            if(v.checked) {
                bumonList.push(v.bumon_cd);
                bCnt++;
            }
        });
        if( bCnt === 0 ){
            vm.formError = true;
        }else{
            if( form.fromDate ){
                if( angular.isDate(form.fromDate) ){
                    form.fromDate = moment(form.fromDate).format('YYYY/MM/DD');
                }
                if( angular.isDate(form.untilDate) ){
                    form.untilDate = moment(form.untilDate).format('YYYY/MM/DD');
                }
                if( bCnt === vm.bumonList.length ){
                    form.bumon = 'all';
                }else{
                    form.bumon = bumonList;
                }
                if( vm.form.sgItem.length > 0){
                    form.media = vm.form.sgItem;
                }else{
                    form.media = 'all';
                }
                $log.debug(form);
                $http({
                    url: dev.api + 'api/v1/generateinventoryissue',
                    method: 'GET',
                    params: {values:angular.toJson(form)}
                }).success(function(datas) {
                    $log.debug(datas);
                    if(!datas.data || datas.data.length === 0 ){
                        vm.error = 'データが存在しません'
                    }else{
                        storage.set('printIvisData', datas);
                        if( $rootScope.openWindow ){
                            $rootScope.openWindow.focus();
                            $rootScope.openWindow.close();
                        }
                        $rootScope.openWindow = $window.open('#/ivis-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                    }
                });
            }else{
                vm.formDateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('trfItem', trfItem);

  /** @ngInject */
  function trfItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" numeric-only />',
      controller: trfItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function trfItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('trfItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      //console.log(vm.sgItemKit);
      //$attrs.$observe('sgKtcd', function(value){
      //    vm.sg_keitai_cd = value;
      //});
      vm.index = $scope.$parent.$index;
      vm.origin_value;
      if( $scope.$parent.trf.editForm.detail[vm.index].hin_cd ){
          $scope.dirValue = $scope.$parent.trf.editForm.detail[vm.index].hin_cd;
          //vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.form = {};
          vm.sagyoDtl = [];
          vm.sgItem = [];
          angular.forEach(vm.sgItemKit.sgItem, function(v,k){
              if(Number(v.zaiko_kb) === 1) vm.sgItem.push(v);
          });
          // メディアDropdown
          vm.mediaDropdown = [{'text':'－－', 'click': 'vm.mediaSelect()'}];
          angular.forEach(vm.commondata.media ,function(v,k){
              vm.mediaDropdown.push({'text':v.media_nm, 'click': 'vm.mediaSelect("'+ v.media_cd +'","'+ v.media_nm +'")'});
          });
          vm.mediaSelect = function(media_cd, media_nm){
              if(media_cd && media_nm){
                  vm.form.media_cd = media_cd;
                  vm.media_nm = media_nm;
              }else{
                  vm.form.media_cd = '';
                  vm.media_nm = '';
              }
          };
      };
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/trfItem/trfitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(item){
          $scope.dirValue = item.sg_item_cd;
          $scope.$parent.trf.editForm.detail[vm.index].hin_cd = item.sg_item_cd;
          $scope.$parent.trf.editForm.detail[vm.index].hin_nm = item.sg_item_nm;
          $scope.$parent.trf.editForm.detail[vm.index].tani = item.tani_1;
          $scope.$parent.trf.editForm.detail[vm.index].tanka = item.zaiko_tanka;
          
          $log.debug($scope.$parent);
          //var conNm = $scope.$parent.controllerAliasName;
          //var index = $scope.$parent.$index;
          //$scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('torihikisakiEdit', torihikisakiEdit);

  /** @ngInject */
  function torihikisakiEdit() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:90px;"/>',
      controller: TorihikisakiEditController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function TorihikisakiEditController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('TorihikisakiEditController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.origin_value;
      if( $scope.$parent.exp.form.tori_cd ){
          $scope.dirValue = $scope.$parent.exp.editForm.tori_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.tori_cd = '';
          vm.form = {};
          vm.torihikisaki = [];
          vm.getTorihikisakiData();
          
      }
      // 取引先（支払先）データ取得
      vm.getTorihikisakiData = function(){
          $http({
              url: dev.api + 'api/v1/gettorihikisaki',
              method: "GET",
          }).success(function(data) {
              vm.toriKbnDropdown = [{'text':'－－', 'click': 'vm.toriKbnSelect()'}];
              angular.forEach(data.kubun ,function(v,k){
                  vm.toriKbnDropdown.push({'text':v.tori_kb + ' : '+ v.tori_kb_nm, 'click': 'vm.toriKbnSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
              });
              vm.datas = data.torihiki;
          });
          
          // 支払先選択
          vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
              if(tori_kb && tori_kb_nm){
                  vm.form.tori_kb = tori_kb;
                  vm.tori_kb_nm = tori_kb_nm;
              }else{
                  vm.form.tori_kb = '';
                  vm.tori_kb_nm = '';
              }
          };
          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/torihikisaki/torihikisaki.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.exp.editForm.tori_nm = itemNm;
          $scope.$parent.exp.editForm.tori_cd = itemCd;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('torihikisaki', torihikisaki);

  /** @ngInject */
  function torihikisaki() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:90px;"/>',
      controller: TorihikisakiSrController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function TorihikisakiSrController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('TorihikisakiSrController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.origin_value;
      if( $scope.$parent.exp.form.tori_cd ){
          $scope.dirValue = $scope.$parent.exp.form.tori_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.tori_cd = '';
          vm.form = {};
          vm.torihikisaki = [];
          vm.getTorihikisakiData();
          
      }
      // 取引先（支払先）データ取得
      vm.getTorihikisakiData = function(){
          $http({
              url: dev.api + 'api/v1/gettorihikisaki',
              method: "GET",
          }).success(function(data) {
              vm.toriKbnDropdown = [{'text':'－－', 'click': 'vm.toriKbnSelect()'}];
              angular.forEach(data.kubun ,function(v,k){
                  vm.toriKbnDropdown.push({'text':v.tori_kb + ' : '+ v.tori_kb_nm, 'click': 'vm.toriKbnSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
              });
              vm.datas = data.torihiki;
          });
          
          // 支払先選択
          vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
              if(tori_kb && tori_kb_nm){
                  vm.form.tori_kb = tori_kb;
                  vm.tori_kb_nm = tori_kb_nm;
              }else{
                  vm.form.tori_kb = '';
                  vm.tori_kb_nm = '';
              }
          };
          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/torihikisaki/torihikisaki.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.exp.tori_nm = itemNm;
          $scope.$parent.exp.form.tori_cd = itemCd;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('tokuCdSearch', tokuCdSearch);

  /** @ngInject */
  function tokuCdSearch() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input  type="text" placeholder="スペース検索" ng-model="dirValue" />',
      controller: TokuCdSearchController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function TokuCdSearchController($log, $window, $scope, $http, $parse, $element, $attrs, $timeout, $state, storage, $modal, dev) {
      var vm = this;

      /*
       * このdirectiveを使う場合は
       * ng-repeatの展開変数名を かならず item とする
       * また、親scope側(parentController)の選択したアイテムの反映ロジック名を
       * sgItemModalSelected　とすること！
       * また、親Controller内に $scope.controllerAliasName = [エイリアスコントローラー名]　必須
       */
      $log.debug('TokuCdSearchController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      // ng-repeatのアイテム中から取得するのでは無く、上位のscopeから取得する(変更時にも反映させるため)
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      //console.log($scope.$parent);
      vm.origin_value;
      if( $scope.$parent.item.toku_cd ){
          $scope.dirValue = $scope.$parent.item.toku_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          // From初期化
          vm.form = {};
          vm.toku_nm = '';
          vm.toku_km = '';
          vm.tan_nm= '';
          vm.bumon_nm= '';
          vm.toku_kb_nm= '';

          // pagenation 設定
          vm.datas = [];
          vm.totalDatas = 0;
          vm.datasPerPage = 25;
          vm.pagination = {current:1};
          
          // 付随データ取得
          $http({
              url: dev.api + 'api/v1/gettokukankei',
              method: 'GET'
          }).success(function(datas) {
              vm.bumon = datas.bumon;
              vm.kubun = datas.kubun;
              vm.nk_keitai = datas.nk_keitai;
              vm.hakko_kubun = datas.hakko_kubun;
              vm.sk_tani = datas.sk_tani;
              vm.makeSgPtnItem();
          });
          
      }
      
      // アイテム構築
      vm.makeSgPtnItem = function(){

          // 部門Dropdown
          vm.bumonDropdown = [];
          angular.forEach(vm.bumon ,function(v){
              vm.bumonDropdown.push({'text':v.bumon_nm, 'click': 'vm.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
          });
         // 区分Dropdown
          vm.kubunDropdown = [];
          angular.forEach(vm.kubun ,function(v){
              vm.kubunDropdown.push({'text':v.toku_kb_nm, 'click': 'vm.kubunSelect("'+ v.toku_kb +'","'+ v.toku_kb_nm +'")'});
          });
          
          // 区分選択
          vm.kubunSelect = function(toku_kb, toku_kb_nm){
              vm.form.toku_kb = toku_kb;
              vm.toku_kb_nm = toku_kb_nm;
          };
          // 受注部門選択
          vm.bumonSelect = function(bumon_cd, bumon_nm){
              vm.form.bumon_cd = bumon_cd;
              vm.bumon_nm = bumon_nm;
              vm.getTantoEigyo(bumon_cd,1);
          };
          //営業選択
          vm.eigyoSelect = function(syain_cd, syain_nm){
              vm.form.tan_cd = syain_cd;
              vm.tan_nm = syain_nm;
          };
          // 担当営業取得
          vm.eigyoDropdown = [];
          vm.getTantoEigyo = function(bumon_cd, mode){
              $http({
                  url: dev.api + 'api/v1/geteigyo',
                  method: "GET",
                  params: {'cd': bumon_cd}
              }).success(function(data, status, headers, config) {
                  vm.eigyoDropdown = [];
                  vm.modalEigyoDropdown = [];
                  if(data){
                      angular.forEach(data ,function(v,k){
                          vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'vm.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                      });
                  }
              });
          };
      };
      // 次のページ/前のページ
      vm.pageChanged = function(newPage) {
          getResultsPage(newPage);
      };
      // ページデータ取得
      function getResultsPage(pageNumber) {
          var search = null;
          if(vm.form){
              search = vm.form;
              angular.forEach(search,function(v,k){
                 if(!v) delete search[k];//不要なparamは削除
              });
          }
          $http({
              url: dev.api + 'api/v1/toku',
              method: 'GET',
              params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
          }).success(function(datas) {
              vm.datas = datas.data;
              vm.totalDatas = datas.total;
              if(vm.form) vm.search = vm.form;
              $log.debug(datas);
              vm.currentpage = datas.current_page;
          });
      }

      // 検索実行
      vm.goSearch = function(){
          $log.debug(vm.form);
          getResultsPage(1);
          vm.pagination = { current: 1};
      };
      // 検索Formクリア
      vm.clear = function(){
          vm.itemInit();
      };

      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/tokucd/tokucd.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          //console.log(itemNm);
          $scope.$parent.item.toku_nm = itemNm;
          $scope.$parent.item.toku_cd = itemCd;
          $log.debug($scope.$parent);
          var conNm = $scope.$parent.controllerAliasName;
          var index = $scope.$parent.$index;
          //$scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,itemNm,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress keyup', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('sgItemNoReq', sgItemNoReq);

  /** @ngInject */
  function sgItemNoReq() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" />',
      controller: SgItemNoRequiredController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SgItemNoRequiredController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      /*
       * このdirectiveを使う場合は
       * ng-repeatの展開変数名を かならず item とする
       * また、親scope側(parentController)の選択したアイテムの反映ロジック名を
       * sgItemModalSelected　とすること！
       * また、親Controller内に $scope.controllerAliasName = [エイリアスコントローラー名]　必須
       */
      $log.debug('SgItemNoRequiredController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      // ng-repeatのアイテム中から取得するのでは無く、上位のscopeから取得する(変更時にも反映させるため)
      $attrs.$observe('sgKtcd', function(value){
          vm.sg_keitai_cd = value;
      });
      //console.log($attrs);
      vm.origin_value;
      if( $scope.$parent.item.sg_item_cd ){
          $scope.dirValue = $scope.$parent.item.sg_item_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      //console.log($scope.$parent.item);
      // ng-repeat アイテムの変更をキャッチ
      $scope.$watch(function() { return $scope.$parent.item;}, function(newVal, oldVal) {
          //console.log(newVal);
          //vm.sg_keitai_cd = newVal.sg_keitai_cd;
          vm.sg_bunrui_cd = newVal.sg_bunrui_cd;
      }, true);
                  
      // 作業形態名
      vm.setSgKeitaiName = function(sg_keitai_cd){
          if(!sg_keitai_cd) return;
          var sgKeitaiNm;
          angular.forEach(vm.sgItemKit.sgKeitai, function(v){
              if(Number(v.sg_keitai_cd) === Number(sg_keitai_cd)) sgKeitaiNm = v.sg_keitai_nm;
          });
          return sgKeitaiNm;
      };
      
      // 初期化
      vm.itemInit = function(){
          //console.log(vm.sg_keitai_cd);
          //console.log(vm.sg_bunrui_cd);
          vm.sg_ptn_cd = '';
          vm.sg_bunrui_cd_selected = false;
          if(vm.sg_bunrui_cd){
              vm.sg_bunrui_cd_selected = true;
          }
          vm.sagyoDtl = [];
          
          // 作業パターンアイテムからsg_item_cdを取り出す
          //console.log(vm.sgItemKit);
          vm.makeSgPtnItem();
          
          // 作業分類Dropdown
          vm.bunruiDropdown = [];
          angular.forEach(vm.sgItemKit.sgBunrui ,function(v,k){
              vm.bunruiDropdown.push({'name':v.sg_bunrui_nm, 'id':v.sg_bunrui_cd});
          });
          // 作業パターンドロップダウン生成
          vm.makeSgPtrnDropDown();
          //console.log(vm.sagyoDtl);
      }
      // アイテム構築
      vm.makeSgPtnItem = function(){
          vm.sagyoDtl = [];
          angular.forEach(vm.sgItemKit.sgPtnItem, function(v){
              if( vm.sg_keitai_cd == v.sg_keitai_cd && vm.sg_bunrui_cd == v.sg_bunrui_cd ) {
                  // 該当する作業アイテムを収集
                  angular.forEach(vm.sgItemKit.sgItem, function(iv){
                      if( iv.sg_item_cd == v.sg_item_cd ) {
                          iv.sg_ptn_cd = v.sg_ptn_cd;
                          vm.sagyoDtl.push(iv);
                      }
                  });
              }else if(vm.sg_keitai_cd == v.sg_keitai_cd && !vm.sg_bunrui_cd ){
                  angular.forEach(vm.sgItemKit.sgItem, function(iv){
                      if( iv.sg_item_cd == v.sg_item_cd ) {
                          iv.sg_ptn_cd = v.sg_ptn_cd;
                          vm.sagyoDtl.push(iv);
                      }
                  });
              }
          });
          //console.log(vm.sgItemKit.sgPtnItem);
          //console.log('vm.sg_keitai_cd : ' + vm.sg_keitai_cd);
          //console.log('vm.sg_bunrui_cd : ' + vm.sg_bunrui_cd);
          //console.log(vm.sgItemKit.sgItem);
          vm.makeSgPtrnDropDown();
      };
      
      // 作業パターンDropdown
      vm.makeSgPtrnDropDown = function(){
          vm.ptrnDropdown = [{'name':'- -', 'id':''}];
          angular.forEach(vm.sgItemKit.sgPtn ,function(v,k){
              if(!vm.sg_keitai_cd){
                  // 作業形態不明の場合
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }else if( vm.sg_keitai_cd == v.sg_keitai_cd ){
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }
          });
          //console.log(vm.ptrnDropdown);
      }
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/sgitem/sgitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.item.sg_item_nm = itemNm;
          $log.debug($scope.$parent);
          var conNm = $scope.$parent.controllerAliasName;
          var index = $scope.$parent.$index;
          $scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('sgItem', sgItem);

  /** @ngInject */
  function sgItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" required />',
      controller: SgItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SgItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      /*
       * このdirectiveを使う場合は
       * ng-repeatの展開変数名を かならず item とする
       * また、親scope側(parentController)の選択したアイテムの反映ロジック名を
       * sgItemModalSelected　とすること！
       * また、親Controller内に $scope.controllerAliasName = [エイリアスコントローラー名]　必須
       */
      $log.debug('SgItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      // ng-repeatのアイテム中から取得するのでは無く、上位のscopeから取得する(変更時にも反映させるため)
      $attrs.$observe('sgKtcd', function(value){
          vm.sg_keitai_cd = value;
      });
      //console.log($attrs);
      vm.origin_value;
      if( $scope.$parent.item.sg_item_cd ){
          $scope.dirValue = $scope.$parent.item.sg_item_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      //console.log($scope.$parent.item);
      // ng-repeat アイテムの変更をキャッチ
      $scope.$watch(function() { return $scope.$parent.item;}, function(newVal, oldVal) {
          //console.log(newVal);
          //vm.sg_keitai_cd = newVal.sg_keitai_cd;
          vm.sg_bunrui_cd = newVal.sg_bunrui_cd;
      }, true);
                  
      // 作業形態名
      vm.setSgKeitaiName = function(sg_keitai_cd){
          if(!sg_keitai_cd) return;
          var sgKeitaiNm;
          angular.forEach(vm.sgItemKit.sgKeitai, function(v){
              if(Number(v.sg_keitai_cd) === Number(sg_keitai_cd)) sgKeitaiNm = v.sg_keitai_nm;
          });
          return sgKeitaiNm;
      };
      
      // 初期化
      vm.itemInit = function(){
          //console.log(vm.sg_keitai_cd);
          //console.log(vm.sg_bunrui_cd);
          vm.sg_ptn_cd = '';
          vm.sg_bunrui_cd_selected = false;
          if(vm.sg_bunrui_cd){
              vm.sg_bunrui_cd_selected = true;
          }
          vm.sagyoDtl = [];
          
          // 作業パターンアイテムからsg_item_cdを取り出す
          //console.log(vm.sgItemKit);
          vm.makeSgPtnItem();
          
          // 作業分類Dropdown
          vm.bunruiDropdown = [];
          angular.forEach(vm.sgItemKit.sgBunrui ,function(v,k){
              vm.bunruiDropdown.push({'name':v.sg_bunrui_nm, 'id':v.sg_bunrui_cd});
          });
          // 作業パターンドロップダウン生成
          vm.makeSgPtrnDropDown();
          //console.log(vm.sagyoDtl);
      }
      // アイテム構築
      vm.makeSgPtnItem = function(){
          vm.sagyoDtl = [];
          angular.forEach(vm.sgItemKit.sgPtnItem, function(v){
              if( vm.sg_keitai_cd == v.sg_keitai_cd && vm.sg_bunrui_cd == v.sg_bunrui_cd ) {
                  // 該当する作業アイテムを収集
                  angular.forEach(vm.sgItemKit.sgItem, function(iv){
                      if( iv.sg_item_cd == v.sg_item_cd ) {
                          iv.sg_ptn_cd = v.sg_ptn_cd;
                          vm.sagyoDtl.push(iv);
                      }
                  });
              }else if(vm.sg_keitai_cd == v.sg_keitai_cd && !vm.sg_bunrui_cd ){
                  angular.forEach(vm.sgItemKit.sgItem, function(iv){
                      if( iv.sg_item_cd == v.sg_item_cd ) {
                          iv.sg_ptn_cd = v.sg_ptn_cd;
                          vm.sagyoDtl.push(iv);
                      }
                  });
              }
          });
          //console.log(vm.sgItemKit.sgPtnItem);
          //console.log('vm.sg_keitai_cd : ' + vm.sg_keitai_cd);
          //console.log('vm.sg_bunrui_cd : ' + vm.sg_bunrui_cd);
          //console.log(vm.sgItemKit.sgItem);
          vm.makeSgPtrnDropDown();
      };
      
      // 作業パターンDropdown
      vm.makeSgPtrnDropDown = function(){
          vm.ptrnDropdown = [{'name':'- -', 'id':''}];
          angular.forEach(vm.sgItemKit.sgPtn ,function(v,k){
              if(!vm.sg_keitai_cd){
                  // 作業形態不明の場合
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }else if( vm.sg_keitai_cd == v.sg_keitai_cd ){
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }
          });
          //console.log(vm.ptrnDropdown);
      }
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/sgitem/sgitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.item.sg_item_nm = itemNm;
          $log.debug($scope.$parent);
          var conNm = $scope.$parent.controllerAliasName;
          var index = $scope.$parent.$index;
          $scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($log, $auth, $timeout, $state, storage) {
      var vm = this;

      vm.user = storage.get('user');
      vm.logout = function(){
          $log.debug('logout');
          $timeout(function () {
              $auth.logout();
              //if( $auth.logout() ){
                  $state.go('/login');
              //}
          },1500);
      };
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('mstSgItem', mstSgItem);

  /** @ngInject */
  function mstSgItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" />',
      controller: MstSgItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MstSgItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      /*
       * このdirectiveを使う場合は
       * ng-repeatの展開変数名を かならず item とする
       * また、親scope側(parentController)の選択したアイテムの反映ロジック名を
       * sgItemModalSelected　とすること！
       * また、親Controller内に $scope.controllerAliasName = [エイリアスコントローラー名]　必須
       */
      $log.debug('MstSgItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      // ng-repeatのアイテム中から取得するのでは無く、上位のscopeから取得する(変更時にも反映させるため)
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      //console.log($attrs);
      vm.origin_value;
      if( $scope.$parent.item.sg_item_cd ){
          $scope.dirValue = $scope.$parent.item.sg_item_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          //console.log(vm.bumon_cd);
          //console.log(vm.sg_bunrui_cd);
          vm.sg_ptn_cd = '';
          vm.sg_bunrui_cd_selected = false;
          if(vm.sg_bunrui_cd){
              vm.sg_bunrui_cd_selected = true;
          }
          vm.sagyoDtl = [];
          vm.sagyoDtl = vm.sgItemKit.sgItem;
          
          // 作業パターンアイテムからsg_item_cdを取り出す
          //console.log(vm.sgItemKit);
          //vm.makeSgPtnItem();
          
          // 作業分類Dropdown
          vm.bunruiDropdown = [{'name':'--', 'id':''}];
          angular.forEach(vm.sgItemKit.sgBunrui ,function(v,k){
              vm.bunruiDropdown.push({'name':v.sg_bunrui_nm, 'id':v.sg_bunrui_cd});
          });
          // 作業分類Dropdown
          vm.bumonDropdown = [{'name':'--', 'id':''}];
          angular.forEach(vm.sgItemKit.sgBumon ,function(v,k){
              vm.bumonDropdown.push({'name':v.bumon_nm, 'id':v.bumon_cd});
          });
          // 作業パターンドロップダウン生成
          //vm.makeSgPtrnDropDown();
          //console.log(vm.sagyoDtl);
      }
      // アイテム構築
      vm.makeSgPtnItem = function(){
          vm.sagyoDtl = [];
          angular.forEach(vm.sgItemKit.sgPtnItem, function(v){
              if( vm.bumon_cd == v.bumon_cd) {
                  angular.forEach(vm.sgItemKit.sgItem, function(iv){
                      if( iv.sg_item_cd == v.sg_item_cd ) {
                          iv.sg_ptn_cd = v.sg_ptn_cd;
                          vm.sagyoDtl.push(iv);
                      }
                  });
              }
          });
          if(vm.sagyoDtl.length === 0){
              vm.sagyoDtl = vm.sgItemKit.sgItem;
          }
          //console.log(vm.sgItemKit.sgPtnItem);
          //console.log('vm.sg_keitai_cd : ' + vm.sg_keitai_cd);
          //console.log('vm.sg_bunrui_cd : ' + vm.sg_bunrui_cd);
          //console.log(vm.sgItemKit.sgItem);
          //vm.makeSgPtrnDropDown();
      };
      
      // 作業パターンDropdown
      vm.makeSgPtrnDropDown = function(){
          vm.ptrnDropdown = [{'name':'- -', 'id':''}];
          angular.forEach(vm.sgItemKit.sgPtn ,function(v,k){
              if(!vm.sg_keitai_cd){
                  // 作業形態不明の場合
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }else if( vm.sg_keitai_cd == v.sg_keitai_cd ){
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }
          });
          //console.log(vm.ptrnDropdown);
      }
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/mstsgitem/mstsgitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.item.sg_item_nms = itemNm;
          $scope.$parent.item.sg_item_cd = itemCd;
          $log.debug($scope.$parent);
          var conNm = $scope.$parent.controllerAliasName;
          var index = $scope.$parent.$index;
          //$scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,itemNm,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress keyup', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('mstKamokuItem', mstKamokuItem);

  /** @ngInject */
  function mstKamokuItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="Space" ng-model="dirValue"/>',
      controller: MstKamokuController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MstKamokuController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      //$log.debug('MstKamokuController');
      
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('kmkcd', function(value){
          //console.log(value);
          $scope.dirValue = value;
      });
      $attrs.$observe('alias', function(value){
          //console.log(value);
          vm.aliasName = value;
      });
      $attrs.$observe('target', function(value){
          //console.log(value);
          vm.target = value;
      });
      
      vm.inited = false;
      vm.origin_value;
      // 初期化
      vm.itemInit = function(){
          if( $scope.$parent[vm.target].kmk_cd ){
              $scope.dirValue = $scope.$parent[vm.target].kmk_cd;
              vm.origin_value = $scope.dirValue;
          }
          vm.kasi_hj_cd = '';
          vm.form = {};
          vm.hojoKamoku = [];
          vm.getHojoKamokuData();
          
      }
      // 科目データ取得
      vm.getHojoKamokuData = function(){
          $http({
              url: dev.api + 'api/v1/getkeihikamoku',
              method: "GET",
              params: {type:1}
          }).success(function(data) {
              vm.datas = data.kamoku;
          });

          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/mstkamokuitem/mstkamokuitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent[vm.target].kmk_nm = itemNm;
          $scope.$parent[vm.target].kmk_cd = itemCd;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      if(!vm.inited){
          $element.bind('keydown keypress', function(event) {
              // SpaceClick
              if(event.keyCode === 32) {
                  //console.log('Space Click');
                  var type = event.type;
                  vm.itemInit();
                  vm.openSgItemModal();
                  // keyupになってしまった場合
                  if(type === 'keyup'){
                      //　元の値に戻す(space入力をなくす)
                      if(vm.origin_value) $scope.dirValue = vm.origin_value;
                  }
                  vm.inited = true;
                  event.preventDefault();
              }
          });
      }
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('mstHojyoKamokuItem', mstHojyoKamokuItem);

  /** @ngInject */
  function mstHojyoKamokuItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="Space" ng-model="hojyokmkcd"/>',
      controller: MstHojyoKamokuController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MstHojyoKamokuController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
        var vm = this;

        //$log.debug('MstHojyoKamokuController');
        
        
        // 親からscope.model data を取得する場合
        $attrs.$observe('kmkcd', function(value){
            vm.kmk_cd = value;
        });
        $attrs.$observe('hojyokmkcd', function(value){
            //console.log(value);
            $scope.hojyokmkcd = value;
        });
        $attrs.$observe('alias', function(value){
            //console.log(value);
            vm.aliasName = value;
        });
        $attrs.$observe('target', function(value){
            //console.log(value);
            vm.target = value;
        });
        
        vm.inited = false;
        vm.origin_value;
        // 初期化
        vm.itemInit = function(){
            if( $scope.$parent[vm.target].hojyo_kmk_cd ){
                $scope.dirValue = $scope.$parent[vm.target].hojyo_kmk_cd;
                vm.origin_value = $scope.dirValue;
            }
            vm.form = {};
            vm.getHojoKamokuData();
            
        }
        // 科目データ取得
        vm.getHojoKamokuData = function(){
            $http({
                url: dev.api + 'api/v1/getkeihikamoku',
                method: "GET",
                params: {type:2,kmk_cd:vm.kmk_cd}
            }).success(function(data) {
                vm.datas = data.kamoku;
                //console.log(vm.datas);
            });
            // 検索Formクリア
            vm.clear = function(){
                vm.form = {};
            };
        };
        
        
        // 検索Modal
        vm.sgItemModal = $modal({
            templateUrl:'app/components/msthojyokamokuitem/msthojyokamoku.html',
            scope: $scope,
            show:false
        });
        vm.openSgItemModal = function(){
            vm.sgItemModal.$promise.then(vm.sgItemModal.show);
        };
        vm.hideSgItemModal = function(){
            vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
        };
        
        // 選択したアイテムの値を親scopeに返す
        vm.setToriCd = function(itemCd,itemNm){
            $scope.hojyokmkcd = itemCd;
            $scope.$parent[vm.target].hojyo_kmk_nm = itemNm;
            $scope.$parent[vm.target].hojyo_kmk_cd = itemCd;
            $log.debug($scope.$parent);
            vm.hideSgItemModal();
        }
        
        // Space Click Event
        // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
        if(!vm.inited){
            $element.bind('keydown keypress', function(event) {
                // SpaceClick
                if(event.keyCode === 32) {
                    //console.log('Space Click');
                    var type = event.type;
                    vm.itemInit();
                    vm.openSgItemModal();
                    // keyupになってしまった場合
                    if(type === 'keyup'){
                        //　元の値に戻す(space入力をなくす)
                        if(vm.origin_value) $scope.dirValue = vm.origin_value;
                    }
                    vm.inited = true;
                    event.preventDefault();
                }
            });
        }
        
      }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('mSgItem', mSgItem);

  /** @ngInject */
  function mSgItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input  type="text" placeholder="スペース検索" ng-model="dirValue" />',
      controller: MSgItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MSgItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      /*
       * このdirectiveを使う場合は
       * ng-repeatの展開変数名を かならず item とする
       * また、親scope側(parentController)の選択したアイテムの反映ロジック名を
       * sgItemModalSelected　とすること！
       * また、親Controller内に $scope.controllerAliasName = [エイリアスコントローラー名]　必須
       */
      $log.debug('MstSgItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      // ng-repeatのアイテム中から取得するのでは無く、上位のscopeから取得する(変更時にも反映させるため)
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      //console.log($attrs);
      vm.origin_value;
      if( $scope.$parent.sgi.detailForm.ov_sg_item_cd ){
          $scope.dirValue = $scope.$parent.sgi.detailForm.ov_sg_item_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          //console.log(vm.bumon_cd);
          //console.log(vm.sg_bunrui_cd);
          vm.sg_ptn_cd = '';
          vm.sg_bunrui_cd_selected = false;
          if(vm.sg_bunrui_cd){
              vm.sg_bunrui_cd_selected = true;
          }
          vm.sagyoDtl = [];
          vm.sagyoDtl = vm.sgItemKit.sgItem;
          
          // 作業パターンアイテムからsg_item_cdを取り出す
          //console.log(vm.sgItemKit);
          //vm.makeSgPtnItem();
          
          // 作業分類Dropdown
          vm.bunruiDropdown = [{'name':'--', 'id':''}];
          angular.forEach(vm.sgItemKit.sgBunrui ,function(v,k){
              vm.bunruiDropdown.push({'name':v.sg_bunrui_nm, 'id':v.sg_bunrui_cd});
          });
          // 作業分類Dropdown
          vm.bumonDropdown = [{'name':'--', 'id':''}];
          angular.forEach(vm.sgItemKit.sgBumon ,function(v,k){
              vm.bumonDropdown.push({'name':v.bumon_nm, 'id':v.bumon_cd});
          });
          // 作業パターンドロップダウン生成
          //vm.makeSgPtrnDropDown();
          //console.log(vm.sagyoDtl);
      }
      // アイテム構築
      vm.makeSgPtnItem = function(){
          vm.sagyoDtl = [];
          angular.forEach(vm.sgItemKit.sgPtnItem, function(v){
              if( vm.bumon_cd == v.bumon_cd) {
                  angular.forEach(vm.sgItemKit.sgItem, function(iv){
                      if( iv.sg_item_cd == v.sg_item_cd ) {
                          iv.sg_ptn_cd = v.sg_ptn_cd;
                          vm.sagyoDtl.push(iv);
                      }
                  });
              }
          });
          if(vm.sagyoDtl.length === 0){
              vm.sagyoDtl = vm.sgItemKit.sgItem;
          }
          //console.log(vm.sgItemKit.sgPtnItem);
          //console.log('vm.sg_keitai_cd : ' + vm.sg_keitai_cd);
          //console.log('vm.sg_bunrui_cd : ' + vm.sg_bunrui_cd);
          //console.log(vm.sgItemKit.sgItem);
          //vm.makeSgPtrnDropDown();
      };
      
      // 作業パターンDropdown
      vm.makeSgPtrnDropDown = function(){
          vm.ptrnDropdown = [{'name':'- -', 'id':''}];
          angular.forEach(vm.sgItemKit.sgPtn ,function(v,k){
              if(!vm.sg_keitai_cd){
                  // 作業形態不明の場合
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }else if( vm.sg_keitai_cd == v.sg_keitai_cd ){
                  vm.ptrnDropdown.push({'name':v.sg_ptn_nm, 'id':v.sg_ptn_cd});
              }
          });
          //console.log(vm.ptrnDropdown);
      }
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/msgitem/msgitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          //console.log(itemNm);
          $scope.$parent.sgi.detailForm.ov_sg_item_nms = itemNm;
          $scope.$parent.sgi.detailForm.ov_sg_item_cd = itemCd;
          $log.debug($scope.$parent);
          var conNm = $scope.$parent.controllerAliasName;
          var index = $scope.$parent.$index;
          //$scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,itemNm,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress keyup', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('ivItem', ivItem);

  /** @ngInject */
  function ivItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" style="width:120px" placeholder="スペース検索" ng-model="dirValue" numeric-only />',
      controller: ivItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function ivItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('ivItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      //console.log(vm.sgItemKit);
      $attrs.$observe('contName', function(value){
          vm.controller_name = value;
          //console.log(vm.controller_name );
      });
      vm.index = $scope.$parent.$index;
      vm.origin_value;
      /*if( $scope.$parent.trf.editForm.detail[vm.index].hin_cd ){
          $scope.dirValue = $scope.$parent.trf.editForm.detail[vm.index].hin_cd;
          //vm.origin_value = $scope.dirValue;
      }
      */
      
      // 初期化
      vm.itemInit = function(){
          vm.form = {};
          vm.sagyoDtl = [];
          vm.sgItem = [];
          angular.forEach(vm.sgItemKit.sgItem, function(v,k){
              if(Number(v.zaiko_kb) === 1) {
                  angular.forEach(vm.commondata.media, function(mv,mk){
                      if(v.media_cd === mv.media_cd){
                          v.media_nm = mv.media_nm;
                          vm.sgItem.push(v);
                      }
                  });
              }
          });
          // メディアDropdown
          vm.mediaDropdown = [{'text':'－－', 'click': 'vm.mediaSelect()'}];
          angular.forEach(vm.commondata.media ,function(v,k){
              vm.mediaDropdown.push({'text':v.media_nm, 'click': 'vm.mediaSelect("'+ v.media_cd +'","'+ v.media_nm +'")'});
          });
          vm.mediaSelect = function(media_cd, media_nm){
              if(media_cd && media_nm){
                  vm.form.media_cd = media_cd;
                  vm.media_nm = media_nm;
              }else{
                  vm.form.media_cd = '';
                  vm.media_nm = '';
              }
          };
      };
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/ivItem/ivitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(item){
          //$scope.dirValue = item.sg_item_cd;
          $scope.$parent[vm.controller_name].form.sgItem.push(item.sg_item_cd);
          //$scope.$parent.trf.editForm.detail[vm.index].hin_nm = item.sg_item_nm;
          //$scope.$parent.trf.editForm.detail[vm.index].tani = item.tani_1;
          //$scope.$parent.trf.editForm.detail[vm.index].tanka = item.zaiko_tanka;
          
          $log.debug($scope.$parent);
          //var conNm = $scope.$parent.controllerAliasName;
          //var index = $scope.$parent.$index;
          //$scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('iccTorihikisakiEdit', iccTorihikisakiEdit);

  /** @ngInject */
  function iccTorihikisakiEdit() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" required numeric-only />',
      controller: iccTorihikisakiEditController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function iccTorihikisakiEditController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('iccTorihikisakiEditController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.origin_value;
      if( $scope.$parent.icc.editForm.tori_cd ){
          $scope.dirValue = $scope.$parent.icc.editForm.tori_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.tori_cd = '';
          vm.form = {};
          vm.torihikisaki = [];
          
          // pagenation 設定
          vm.datas = [];
          vm.totalDatas = 0;
          vm.datasPerPage = 25;
          vm.pagination = {current:1};
          
          getResultsPage(1);

          // 付随データ取得
          $http({
              url: dev.api + 'api/v1/gettorikankei',
              method: 'GET'
          }).success(function(datas) {
              vm.kubun = datas.kubun;
              vm.toriKbnDropdown = [{'text':'－－', 'click': 'vm.toriKbnSelect()'}];
              angular.forEach(datas.kubun ,function(v,k){
                  vm.toriKbnDropdown.push({'text':v.tori_kb + ' : '+ v.tori_kb_nm, 'click': 'vm.toriKbnSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
              });
              // 支払先選択
              vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
                  if(tori_kb && tori_kb_nm){
                      vm.form.tori_kb = tori_kb;
                      vm.tori_kb_nm = tori_kb_nm;
                  }else{
                      vm.form.tori_kb = '';
                      vm.tori_kb_nm = '';
                  }
              };
          });
      }
      
      // 次のページ/前のページ
      vm.pageChanged = function(newPage) {
          getResultsPage(newPage);
      };
      // ページデータ取得
      function getResultsPage(pageNumber) {
          var search = null;
          if(vm.form){
              search = vm.form;
              angular.forEach(search,function(v,k){
                 if(!v) delete search[k];//不要なparamは削除
              });
          }
          $http({
              url: dev.api + 'api/v1/gettorihikisakiall',
              method: "GET",
              params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
          }).success(function(datas) {
              vm.datas = datas.data;
              vm.totalDatas = datas.total;
              if(vm.form) vm.search = vm.form;
              $log.debug(datas);
              vm.currentpage = datas.current_page;
          });
      }

      // 検索実行
      vm.goSearch = function(){
          $log.debug(vm.form);
          getResultsPage(1);
          vm.pagination = { current: 1};
      };
      // 検索Formクリア
      vm.clear = function(){
          vm.itemInit();
      };
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/icctorihikisakiedit/icctorihikisakiedit.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(item){
          $scope.dirValue = item.tori_cd;
          $scope.$parent.icc.editForm.tori_nm = item.tori_nm;
          $scope.$parent.icc.editForm.tori_cd = item.tori_cd;
          $scope.$parent.icc.editForm.tori_busyo = item.tori_busyo;
          $scope.$parent.icc.editForm.tori_tanto = item.tori_tanto;
          $scope.$parent.icc.editForm.keisyo = item.keisyo;
          $scope.$parent.icc.editForm.yubin_no = item.yubin_no;
          $scope.$parent.icc.editForm.adrs1 = item.adrs1;
          $scope.$parent.icc.editForm.adrs2 = item.adrs2;
          $scope.$parent.icc.editForm.adrs2 = item.adrs2;
          $scope.$parent.icc.editForm.tel_no = item.tel_no;
          $scope.$parent.icc.editForm.fax_no = item.fax_no;
          
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('iccTorihikisaki', iccTorihikisaki);

  /** @ngInject */
  function iccTorihikisaki() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:95px;" numeric-only />',
      controller: iccTorihikisakiController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function iccTorihikisakiController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('iccTorihikisakiController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.origin_value;
      if( $scope.$parent.icc.form.tori_cd ){
          $scope.dirValue = $scope.$parent.icc.form.tori_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.tori_cd = '';
          vm.form = {};
          vm.torihikisaki = [];
          
          // pagenation 設定
          vm.datas = [];
          vm.totalDatas = 0;
          vm.datasPerPage = 25;
          vm.pagination = {current:1};
          
          getResultsPage(1);

          // 付随データ取得
          $http({
              url: dev.api + 'api/v1/gettorikankei',
              method: 'GET'
          }).success(function(datas) {
              vm.kubun = datas.kubun;
              vm.toriKbnDropdown = [{'text':'－－', 'click': 'vm.toriKbnSelect()'}];
              angular.forEach(datas.kubun ,function(v,k){
                  vm.toriKbnDropdown.push({'text':v.tori_kb + ' : '+ v.tori_kb_nm, 'click': 'vm.toriKbnSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
              });
              // 支払先選択
              vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
                  if(tori_kb && tori_kb_nm){
                      vm.form.tori_kb = tori_kb;
                      vm.tori_kb_nm = tori_kb_nm;
                  }else{
                      vm.form.tori_kb = '';
                      vm.tori_kb_nm = '';
                  }
              };
          });
      }
      
      // 次のページ/前のページ
      vm.pageChanged = function(newPage) {
          getResultsPage(newPage);
      };
      // ページデータ取得
      function getResultsPage(pageNumber) {
          var search = null;
          if(vm.form){
              search = vm.form;
              angular.forEach(search,function(v,k){
                 if(!v) delete search[k];//不要なparamは削除
              });
          }
          $http({
              url: dev.api + 'api/v1/gettorihikisakiall',
              method: "GET",
              params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
          }).success(function(datas) {
              vm.datas = datas.data;
              vm.totalDatas = datas.total;
              if(vm.form) vm.search = vm.form;
              $log.debug(datas);
              vm.currentpage = datas.current_page;
          });
      }

      // 検索実行
      vm.goSearch = function(){
          $log.debug(vm.form);
          getResultsPage(1);
          vm.pagination = { current: 1};
      };
      // 検索Formクリア
      vm.clear = function(){
          vm.itemInit();
      };
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/icctorihikisakiedit/icctorihikisakiedit.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(item){
          $scope.dirValue = item.tori_cd;
          $scope.$parent.icc.tori_nm = item.tori_nm;
          $scope.$parent.icc.form.tori_cd = item.tori_cd;
          
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('iccItem', iccItem);

  /** @ngInject */
  function iccItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" numeric-only />',
      controller: iccItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function iccItemController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('iccItemController');
      vm.commondata = storage.get('commondata');
      vm.sgItemKit = vm.commondata.sgItemKit;
      
      //$attrs.$observe('sgKtcd', function(value){
      //    vm.sg_keitai_cd = value;
      //});
      vm.index = $scope.$parent.$index;
      vm.origin_value;
      if( $scope.$parent.icc.editForm.detail[vm.index].hin_cd ){
          $scope.dirValue = $scope.$parent.icc.editForm.detail[vm.index].hin_cd;
          //vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.form = {};
          vm.sagyoDtl = [];
          vm.sgItem = [];
          angular.forEach(vm.sgItemKit.sgItem, function(v,k){
              if(Number(v.zaiko_kb) === 1) vm.sgItem.push(v);
          });
          // メディアDropdown
          vm.mediaDropdown = [{'text':'－－', 'click': 'vm.mediaSelect()'}];
          angular.forEach(vm.commondata.media ,function(v,k){
              vm.mediaDropdown.push({'text':v.media_nm, 'click': 'vm.mediaSelect("'+ v.media_cd +'","'+ v.media_nm +'")'});
          });
          vm.mediaSelect = function(media_cd, media_nm){
              if(media_cd && media_nm){
                  vm.form.media_cd = media_cd;
                  vm.media_nm = media_nm;
              }else{
                  vm.form.media_cd = '';
                  vm.media_nm = '';
              }
          };
      };
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/iccItem/iccitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSgItemCd = function(item){
          $scope.dirValue = item.sg_item_cd;
          $scope.$parent.icc.editForm.detail[vm.index].hin_cd = item.sg_item_cd;
          $scope.$parent.icc.editForm.detail[vm.index].hin_nm = item.sg_item_nm;
          $scope.$parent.icc.editForm.detail[vm.index].tani = item.tani_1;
          $scope.$parent.icc.editForm.detail[vm.index].tanka = item.zaiko_tanka;
          
          $log.debug($scope.$parent);
          //var conNm = $scope.$parent.controllerAliasName;
          //var index = $scope.$parent.$index;
          //$scope.$parent[conNm].editScope.sgItemModalSelected(itemCd,index);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.itemInit();
              vm.openSgItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
    'use strict';

    angular
      .module('frontend')
      .filter('totime', totime)
      .filter('timeformat', timeformat)
      .filter('formatitem', formatitem)
      .filter('formatNumber', formatNumber)
      .filter('formatZen2Han', formatZen2Han)
      .filter('getById', getById)
      .filter('orderObjectBy', orderObjectBy)
      .filter('toArray', toArray)
      .filter('objSearch', objSearch);

    // ゼロサプレス
    function zeroSuppress(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    function zeroPadding(val,num) {
        return ('0' + val).slice(-num);
    }
    
    /** @ngInject */
    function totime() {
        return function(input){
            if( is('String', input) ||  is('Number' , input)){
                if( is('Number' , input) ){
                    input = input.toString();
                }
                if(input.length >= 3){
                    var out1,out2;
                    if( input.length === 3){
                        out1 = input.substring(0,1);
                        out2 = input.substring(1,3);
                    }else{
                        out1 = input.substring(0,2);
                        out2 = input.substring(2,4);
                    }
                    var out = out1 + ':' + out2;
                    return out;
                }
                return input;
            }else{
                return input;
            }
        };
    }

    /* 時間表記 */
    function timeformat(){
        return function (input) {
            if ( is('String', input) || is('Number' , input) ){
                return number_format(input, 1, '.', '.')+'H';
            }else{
                return;
            }
            //return input.toString()+'H';
        };
    }

    /* 任意 */
    function formatitem(){
        return function (input,format) {
            if ( is('String', input) || is('Number' , input) ){
                if(format){
                    //console.log(input);
                    return number_format(input, 1, '.', '.')+format;
                }else{
                    return number_format(input, 1, '.', '.');
                }

            }else{
                return;
            }
            //return input.toString()+'H';
        };
    }
    /* 任意 */
    function formatNumber(){
        return function (input,format) {
            if ( is('String', input) || is('Number' , input) ){
                if(format){
                    return number_format(input, 0)+format;
                }else{
                    return number_format(input, 0);
                }

            }else{
                return;
            }
            //return input.toString()+'H';
        };
    }
    // 全角カナ→半角カナ
    function formatZen2Han(){
        return function (input) {
            return kanaConverter.convertKanaToOneByte(input);
        };
    }
    /**
     * 全角から半角に置き換え
     */
    var kanaConverter = (function() {

      // マップ作成用関数
      var createKanaMap = function(properties, values) {
        var kanaMap = {};
        // 念のため文字数が同じかどうかをチェックする(ちゃんとマッピングできるか)
        if(properties.length === values.length) {
          for(var i=0, len=properties.length; i<len; i++) {
            var property= properties.charCodeAt(i),
                value = values.charCodeAt(i);
            kanaMap[property] = value;
          }
        }
        return kanaMap;
      };
    
      // 全角から半角への変換用マップ
      var m = createKanaMap(
        'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォッャュョ',
        'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮ'
        );
      // 半角から全角への変換用マップ
      var mm = createKanaMap(
        'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｯｬｭｮ',
        'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンァィゥェォッャュョ'
        );
    
      // 全角から半角への変換用マップ
      var g = createKanaMap(
        'ガギグゲゴザジズゼゾダヂヅデドバビブベボ',
        'ｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ'
        );
      // 半角から全角への変換用マップ
      var gg = createKanaMap(
        'ｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ',
        'ガギグゲゴザジズゼゾダヂヅデドバビブベボ'
        );
      
      // 全角から半角への変換用マップ
      var p = createKanaMap(
        'パピプペポ',
        'ﾊﾋﾌﾍﾎ'
        );
      // 半角から全角への変換用マップ
      var pp = createKanaMap(
        'ﾊﾋﾌﾍﾎ',
        'パピプペポ'
        );
    
      var gMark = 'ﾞ'.charCodeAt(0),
          pMark = 'ﾟ'.charCodeAt(0);
    
       return {
        /**
         * 全角から半角への変換用関数
         * @param  {[type]} str 変換対象文字列
         * @return {[type]}     変換後文字列
         */
        convertKanaToOneByte : function(str) {
          for(var i=0, len=str.length; i<len; i++) {
            // 濁音もしくは半濁音文字
            if(g.hasOwnProperty(str.charCodeAt(i)) || p.hasOwnProperty(str.charCodeAt(i))) {
              // 濁音
              if(g[str.charCodeAt(i)]) {
                str = str.replace(str[i], String.fromCharCode(g[str.charCodeAt(i)])+String.fromCharCode(gMark));
              }
              // 半濁音
              else if(p[str.charCodeAt(i)]) {
                str = str.replace(str[i], String.fromCharCode(p[str.charCodeAt(i)])+String.fromCharCode(pMark));
              }
              else {
                break;
              }
              // 文字列数が増加するため調整
              i++;
              len = str.length;
            }
            else {
              if(m[str.charCodeAt(i)]) {
                str = str.replace(str[i], String.fromCharCode(m[str.charCodeAt(i)]));
              }
            }
          }
          return str;
        },
        /**
         * 半角から全角への変換用関数
         * @param  {[type]} str 変換対象文字列
         * @return {[type]}     変換後文字列
         */
        convertKanaToTwoByte : function(str) {
            for(var i=0, len=str.length; i<len; i++) {
            // console.log(str[i]);
            // 濁音もしくは半濁音文字
            if(str.charCodeAt(i) === gMark || str.charCodeAt(i) === pMark) {
              // 濁音
              if(str.charCodeAt(i) === gMark && gg[str.charCodeAt(i-1)]) {
                str = str.replace(str[i-1], String.fromCharCode(gg[str.charCodeAt(i-1)]))
                         .replace(str[i], '');
              }
              // 半濁音
              else if(str.charCodeAt(i) === pMark && pp[str.charCodeAt(i-1)]) {
                str = str.replace(str[i-1], String.fromCharCode(pp[str.charCodeAt(i-1)]))
                         .replace(str[i], '');
              }
              else {
                break;
              }
              // 文字列数が減少するため調整
              i--;
              len = str.length;
            }
            else {
              // １つ先の文字を見て濁音もしくは半濁音でないことを確認
              if(mm[str.charCodeAt(i)] && str.charCodeAt(i+1) !== gMark && str.charCodeAt(i+1) !== pMark) {
                str = str.replace(str[i], String.fromCharCode(mm[str.charCodeAt(i)]));
              }
            }
          }
            return str;
        }
      };
    })();
    
    //Filter用 NumberFormat
    function number_format(number, decimals, dec_point, thousands_sep) {
        // *     example 1: number_format(1234.56);
        // *     returns 1: '1,235'
        // *     example 2: number_format(1234.56, 2, ',', ' ');
        // *     returns 2: '1 234,56'
        // *     example 3: number_format(1234.5678, 2, '.', '');
        // *     returns 3: '1234.57'
        // *     example 4: number_format(67, 2, ',', '.');
        // *     returns 4: '67,00'
        // *     example 5: number_format(1000);
        // *     returns 5: '1,000'
        // *     example 6: number_format(67.311, 2);
        // *     returns 6: '67.31'
        // *     example 7: number_format(1000.55, 1);
        // *     returns 7: '1,000.6'
        // *     example 8: number_format(67000, 5, ',', '.');
        // *     returns 8: '67.000,00000'
        // *     example 9: number_format(0.9, 0);
        // *     returns 9: '1'
        // *    example 10: number_format('1.20', 2);
        // *    returns 10: '1.20'
        // *    example 11: number_format('1.20', 4);
        // *    returns 11: '1.2000'
        // *    example 12: number_format('1.2000', 3);
        // *    returns 12: '1.200'
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            toFixedFix = function (n, prec) {
                // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                var k = Math.pow(10, prec);
                return Math.round(n * k) / k;
            },
            s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    // 未使用 angular.filter に変更
    function groupBy() {
        var results={};
        var vm = this;
        return function (data, key) {
            if (!(data && key)) return;
            var result;
            if(!vm.$id){
                result={};
            }else{
                var scopeId = vm.$id;
                if(!results[scopeId]){
                    results[scopeId]={};
                    vm.$on("$destroy", function() {
                        delete results[scopeId];
                    });
                }
                result = results[scopeId];
            }

            for(var groupKey in result)
              result[groupKey].splice(0,result[groupKey].length);

            for (var i=0; i<data.length; i++) {
                if (!result[data[i][key]])
                    result[data[i][key]]=[];
                result[data[i][key]].push(data[i]);
            }

            var keys = Object.keys(result);
            for(var k=0; k<keys.length; k++){
              if(result[keys[k]].length===0)
                delete result[keys[k]];
            }
            return result;
        };
    }
    // object検索
    function getById() {
        return function(input, id) {
            var i=0, len=input.length;
            for (; i<len; i++) {
                if (+input[i].id == +id) {
                    return input[i];
                }
            }
            return null;
        }
    }
    // Obj指定filter
    function objSearch(){
        return function(items, target_nm, target) {
            if ( item && target ) {
                var temp = [];
                angular.forEach(item, function (val) {
                    if(target === val[target_nm]) {
                        temp.push(val);
                    }
                });
                return temp;
            } else {
                return item;
            }
        }
    }
    // 配列再帰的フィルタ
    function orderObjectBy(){
        return function(items, field, reverse) {
            var filtered = [];
            angular.forEach(items, function(item) {
              filtered.push(item);
            });
            filtered.sort(function (a, b) {
              return (a[field] > b[field] ? 1 : -1);
            });
            if(reverse) filtered.reverse();
            return filtered;
          };
    }
    // toArray
    function toArray(){
        return function (obj, addKey) {
            if (!angular.isObject(obj)) return obj;
            if ( addKey === false ) {
                return Object.keys(obj).map(function(key) {
                    return obj[key];
                });
            } else {
                return Object.keys(obj).map(function (key) {
                    var value = obj[key];
                    return angular.isObject(value) ?
                            Object.defineProperty(value, '$key', { enumerable: false, value: key}) :
                            { $key: key, $value: value };
                });
            }
        };
    }
    function emptyToEnd () {
        return function (array, key) {
            if(!angular.isArray(array)) return;
            var present = array.filter(function (item) {
                return item[key];
            });
            var empty = array.filter(function (item) {
                return !item[key]
            });
            return present.concat(empty);
        };
    }




  })();
(function() {
    'use strict';

    angular
      .module('frontend')
      .factory('busyInterceptor', busyInterceptor)
      .factory('toExcel', toExcel);

    /** @ngInject */
    //busyInterceptor.$inject = ['$rootScope', '$q'];
    function busyInterceptor($q, $rootScope) {
        return {
            request: onRequest,
            response: onResponse,
            responseError: onResponseError
        };

        function onResponseError(response) {
            if (response.config && response.config.defer) {
                response.config.defer.reject();
            }
            return $q.reject(response);
        }

        function onResponse(response) {
            if (response.config && response.config.defer) {
                response.config.defer.resolve();
            }
            return $q.when(response);
        }

        function onRequest(config) {
            // filter for specific URLs only
            if (config.url.indexOf('/api/') > -1) {
            //console.log(config.url + ' :: ' + config.url.indexOf('/api/'));
                registerPromise(config);
            }
            return $q.when(config);
        }

        function registerPromise(config) {
            var defer = $q.defer();
            $rootScope.activePromises.push(defer.promise);
            config.defer = defer;
            // once the promise is fulfilled we remove it from the activePromises array
            defer.promise.finally(function () {
                angular.forEach($rootScope.activePromises, function (promise, index) {
                    if (promise === defer.promise) {
                        $rootScope.activePromises.splice(index, 1);
                    }
                });
            });
        }
    }
    
    /*
     * Excel export
     */
    function toExcel($window){
        var uri='data:application/vnd.ms-excel;base64,',
            template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
            format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};
        return {
            tableToExcel:function(tableId,worksheetName){
                var table=$(tableId),
                    ctx={worksheet:worksheetName,table:table.html()},
                    href=uri+base64(format(template,ctx));
                return href;
            }
        };
    }
    

  })();
(function() {
    'use strict';

    angular
      .module('frontend')
      .directive('ntTriggerIf', ntTriggerIf)
      .directive('fixedTableHeaders', fixedTableHeaders)
      .directive('myInclude', myInclude)
      .directive('dynamicModel', dynamicModel)
      .directive('numericOnly',numericOnly)
      .directive('ngPrint', printDirective)
      .directive('aDisabled', aDisabled)
      .directive('strMatching', strMatching)
      .directive('strReverseMatching', strReverseMatching);

    /** @ngInject */
    function ntTriggerIf($timeout) {
        /*
        Intended use:
            <div nt-trigger-if={ 'triggerName':{{someCodition === SomeValue}},'anotherTriggerName':{{someOtherCodition === someOtherValue}} } ></div>
        */
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('ntTriggerIf', function (val) {
                    try {
                        var ob_options = JSON.parse(attrs.ntTriggerIf.split("'").join('"') || "");
                    } catch (e) {
                        return
                    }
                    $timeout(function () {
                        for (var st_name in ob_options) {
                            var condition = ob_options[st_name];
                            if (condition) {
                                element.trigger(st_name);
                            }
                        }
                    });
                });
            }
        };
    }

    // TableのHeaderをCSSで固定しているように見せる
    function fixedTableHeaders($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                $timeout(function () {
                    var container = element.parentsUntil(attrs.fixedTableHeaders);
                    //console.log( angular.element(document.querySelector('#scrollable-area')).prop('offsetLeft') );
                    // Modal内でoffsetLeft取ると、右へずれるのでcss:leftをinjectさせないようにstickytablehader.jsを修正してある
                    element.stickyTableHeaders({ scrollableArea: container, 'leftOffset': -89,'marginTop': 0.6 });
                }, 0);
            }
        };
    }

    // HTML Includeでscopeを親と共有できるように
    function myInclude($http, $compile) {
        return function(scope, element, attr) {
            $http.get(attr.myInclude).success(function(response) {
                element.html(response);
                $compile(element.contents())(scope);
            });
        };
    }

    // Model名を動的に設定
    function dynamicModel($compile, $parse){
        return {
            restrict: 'A',
            terminal: true,
            priority: 100000,
            link: function (scope, elem) {
                var name = $parse(elem.attr('dynamic-model'))(scope);
                elem.removeAttr('dynamic-model');
                elem.attr('ng-model', name);
                $compile(elem)(scope);
            }
        };
    }

    function numericOnly(){
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, modelCtrl) {

                modelCtrl.$parsers.push(function (inputValue) {
                    var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g,'') : null;

                    if (transformedInput!=inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    }
    // print
    function printDirective() {
        var printSection = document.getElementById('printSection');
        // if there is no printing section, create one
        if (!printSection) {
            printSection = document.createElement('div');
            printSection.id = 'printSection';
            document.body.appendChild(printSection);
        }
        var beforePrint = function() {
            //console.log('Functionality to run before printing.');
        };
        var afterPrint = function() {
            printSection.innerHTML = '';
        };
        function link(scope, element, attrs) {
            element.on('click', function () {
                var elemToPrint = document.getElementById(attrs.printElementId);
                //console.log(printSection);
                if (elemToPrint) {
                    printElement(elemToPrint);
                }
            });
            // Chrome before & after Listener
            if (window.matchMedia) {
                var mediaQueryList = window.matchMedia('print');
                mediaQueryList.addListener(function(mql) {
                    if (mql.matches) {
                        beforePrint();
                    } else {
                        afterPrint();
                    }
                });
            }
            // other browser
            window.onbeforeprint = beforePrint;
            window.onafterprint = afterPrint;
        }
        function printElement(elem) {
            // clones the element you want to print
            var domClone = elem.cloneNode(true);
            printSection.appendChild(domClone);
            window.print();
        };
        return {
            link: link,
            restrict: 'A'
        };
    }
    // a href disabled
    function aDisabled() {
        return {
            compile: function(tElement, tAttrs, transclude) {
                //Disable ngClick
                tAttrs["ngClick"] = "!("+tAttrs["aDisabled"]+") && ("+tAttrs["ngClick"]+")";
                //Toggle "disabled" to class when aDisabled becomes true
                return function (scope, iElement, iAttrs) {
                    scope.$watch(iAttrs["aDisabled"], function(newValue) {
                        if (newValue !== undefined) {
                            iElement.toggleClass("disabled", newValue);
                        }
                    });
                    //Disable href on click
                    iElement.on("click", function(e) {
                        if (scope.$eval(iAttrs["aDisabled"])) {
                            e.preventDefault();
                        }
                    });
                };
            }
        };
    }
    /*
     * 文字列マッチチェック
     */
    function strMatching() {
        return {
            restrict: 'A',
            scope:true,
            require: 'ngModel',
            link: function (scope, elem , attrs,control) {
                var checker = function () {
                    var e1 = scope.$eval(attrs.ngModel);
                    var e2 = scope.$eval(attrs.strMatching);
                    return e1 === e2;
                };
                scope.$watch(checker, function (n) {
                    control.$setValidity('strMatching', n);
                });
            }
        };
    }
    /*
     * 文字列マッチチェック(逆)
     */
    function strReverseMatching() {
        return {
            restrict: 'A',
            scope:true,
            require: 'ngModel',
            link: function (scope, elem , attrs,control) {
                var checker = function () {
                    var e1 = scope.$eval(attrs.ngModel);
                    var e2 = scope.$eval(attrs.strReverseMatching);
                    return e1 !== e2;
                };
                scope.$watch(checker, function (n) {
                    control.$setValidity('strReverseMatching', n);
                });
            }
        };
    }
    
  })();
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acTorihikisaki', acTorihikisaki);

  /** @ngInject */
  function acTorihikisaki() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:90px;"/>',
      controller: AcTorihikisakiSrController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AcTorihikisakiSrController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('AcTorihikisakiSrController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.inited = false;
      vm.origin_value;
      if( $scope.$parent.acc.form.tori_cd ){
          $scope.dirValue = $scope.$parent.acc.form.tori_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.tori_cd = '';
          vm.form = {};
          vm.torihikisaki = [];
          vm.getTorihikisakiData();
          
      }
      // 取引先（支払先）データ取得
      vm.getTorihikisakiData = function(){
          $http({
              url: dev.api + 'api/v1/gettorihikisaki',
              method: "GET",
          }).success(function(data) {
              vm.toriKbnDropdown = [{'text':'－－', 'click': 'vm.toriKbnSelect()'}];
              angular.forEach(data.kubun ,function(v,k){
                  vm.toriKbnDropdown.push({'text':v.tori_kb + ' : '+ v.tori_kb_nm, 'click': 'vm.toriKbnSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
              });
              vm.datas = data.torihiki;
          });
          
          // 支払先選択
          vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
              if(tori_kb && tori_kb_nm){
                  vm.form.tori_kb = tori_kb;
                  vm.tori_kb_nm = tori_kb_nm;
              }else{
                  vm.form.tori_kb = '';
                  vm.tori_kb_nm = '';
              }
          };
          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/actorihikisaki/actorihikisaki.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.acc.tori_nm = itemNm;
          $scope.$parent.acc.form.tori_cd = itemCd;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      if(!vm.inited){
          $element.bind('keydown keypress', function(event) {
              // SpaceClick
              if(event.keyCode === 32) {
                  //console.log('Space Click');
                  var type = event.type;
                  vm.itemInit();
                  vm.openSgItemModal();
                  // keyupになってしまった場合
                  if(type === 'keyup'){
                      //　元の値に戻す(space入力をなくす)
                      if(vm.origin_value) $scope.dirValue = vm.origin_value;
                  }
                  vm.inited = true;
                  event.preventDefault();
              }
          });
      }
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acKamokuItem', acKamokuItem);

  /** @ngInject */
  function acKamokuItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:90px;"/>',
      controller: AcKamokuController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AcKamokuController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('AcKamokuController');
      
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.inited = false;
      vm.origin_value;
      if( $scope.$parent.item.kmk_cd ){
          $scope.dirValue = $scope.$parent.item.kmk_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.kasi_hj_cd = '';
          vm.form = {};
          vm.hojoKamoku = [];
          vm.getHojoKamokuData();
          
      }
      // 取引先（支払先）データ取得
      vm.getHojoKamokuData = function(){
          $http({
              url: dev.api + 'api/v1/getkamokudata',
              method: "GET",
              params: {type:1}
          }).success(function(data) {
              vm.khBunruiDropdown = [{'text':'－－', 'click': 'vm.khBunruiSelect()'}];
              angular.forEach(data.khBunrui ,function(v,k){
                  vm.khBunruiDropdown.push({'text':v.kh_bunrui_cd + ' : '+ v.kh_bunrui_nm, 'click': 'vm.khBunruiSelect("'+ v.kh_bunrui_cd +'","'+ v.kh_bunrui_nm +'")'});
              });
              vm.datas = data.kamoku;
          });
          
          // 経費分類選択
          vm.khBunruiSelect = function(kh_bunrui_cd, kh_bunrui_nm){
              if(kh_bunrui_cd && kh_bunrui_nm){
                  vm.form.kh_bunrui_cd = kh_bunrui_cd;
                  vm.kh_bunrui_nm = kh_bunrui_nm;
              }else{
                  vm.form.kh_bunrui_cd = '';
                  vm.kh_bunrui_nm = '';
              }
          };
          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/ackamokuitem/ackamokuitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.item.kmk_nm = itemNm;
          $scope.$parent.item.kmk_cd = itemCd;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      if(!vm.inited){
          $element.bind('keydown keypress', function(event) {
              // SpaceClick
              if(event.keyCode === 32) {
                  //console.log('Space Click');
                  var type = event.type;
                  vm.itemInit();
                  vm.openSgItemModal();
                  // keyupになってしまった場合
                  if(type === 'keyup'){
                      //　元の値に戻す(space入力をなくす)
                      if(vm.origin_value) $scope.dirValue = vm.origin_value;
                  }
                  vm.inited = true;
                  event.preventDefault();
              }
          });
      }
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acHojoKamokuItem', acHojoKamokuItem);

  /** @ngInject */
  function acHojoKamokuItem() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:90px;"/>',
      controller: AcHojoKamokuItemController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AcHojoKamokuItemController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('AcHojoKamokuItemController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('kmkcd', function(value){
          //console.log(value);
          vm.kmk_cd = value;
      });
      
      vm.inited = false;
      vm.origin_value;
      if( $scope.$parent.item.hojyo_kmk_cd ){
          $scope.dirValue = $scope.$parent.item.hojyo_kmk_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.kasi_hj_cd = '';
          vm.form = {};
          vm.hojoKamoku = [];
          vm.getHojoKamokuData();
          
      }
      // 取引先（支払先）データ取得
      vm.getHojoKamokuData = function(){
          $http({
              url: dev.api + 'api/v1/getkamokudata',
              method: "GET",
              params: {type:2,kmk_cd:vm.kmk_cd}
          }).success(function(data) {
              
              vm.datas = data;
          });
          
          // 支払先選択
          vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
              if(tori_kb && tori_kb_nm){
                  vm.form.tori_kb = tori_kb;
                  vm.tori_kb_nm = tori_kb_nm;
              }else{
                  vm.form.tori_kb = '';
                  vm.tori_kb_nm = '';
              }
          };
          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/ achojokamokuitem/achojokamokuitem.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.item.hojyo_kmk_cd = itemCd;
          $scope.$parent.item.hojyo_kmk_nm = itemNm;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      if(!vm.inited){
          $element.bind('keydown keypress', function(event) {
              // SpaceClick
              if(event.keyCode === 32) {
                  //console.log('Space Click');
                  var type = event.type;
                  vm.itemInit();
                  vm.openSgItemModal();
                  // keyupになってしまった場合
                  if(type === 'keyup'){
                      //　元の値に戻す(space入力をなくす)
                      if(vm.origin_value) $scope.dirValue = vm.origin_value;
                  }
                  vm.inited = true;
                  event.preventDefault();
              }
          });
      }
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acHojoKamoku', acHojoKamoku);

  /** @ngInject */
  function acHojoKamoku() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control input-sm" type="text" placeholder="スペース検索" ng-model="dirValue" style="width:90px;"/>',
      controller: AcHojoKamokuController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AcHojoKamokuController($log, $window, $scope, $http, dev, $parse, $element, $attrs, $timeout, $state, storage, $modal) {
      var vm = this;

      $log.debug('AcHojoKamokuController');
      
      // 親からscope.model data を取得する場合
      $attrs.$observe('sgKtcd', function(value){
          //console.log(value);
          //vm.bumon_cd = value;
      });
      
      vm.inited = false;
      vm.origin_value;
      if( $scope.$parent.acc.editForm.kasi_hj_cd ){
          $scope.dirValue = $scope.$parent.acc.editForm.kasi_hj_cd;
          vm.origin_value = $scope.dirValue;
      }
      
      // 初期化
      vm.itemInit = function(){
          vm.kasi_hj_cd = '';
          vm.form = {};
          vm.hojoKamoku = [];
          vm.getHojoKamokuData();
          
      }
      // 取引先（支払先）データ取得
      vm.getHojoKamokuData = function(){
          $http({
              url: dev.api + 'api/v1/getkamokudata',
              method: "GET",
              params: {type:2}
          }).success(function(data) {
              /*vm.toriKbnDropdown = [{'text':'－－', 'click': 'vm.toriKbnSelect()'}];
              angular.forEach(data.kubun ,function(v,k){
                  vm.toriKbnDropdown.push({'text':v.tori_kb + ' : '+ v.tori_kb_nm, 'click': 'vm.toriKbnSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
              });
              */
              vm.datas = data;
          });
          
          // 支払先選択
          vm.toriKbnSelect = function(tori_kb, tori_kb_nm){
              if(tori_kb && tori_kb_nm){
                  vm.form.tori_kb = tori_kb;
                  vm.tori_kb_nm = tori_kb_nm;
              }else{
                  vm.form.tori_kb = '';
                  vm.tori_kb_nm = '';
              }
          };
          // 検索Formクリア
          vm.clear = function(){
              vm.form = {};
          };
      };
      
      
      // 検索Modal
      vm.sgItemModal = $modal({
          templateUrl:'app/components/achojokamoku/achojokamoku.html',
          scope: $scope,
          show:false
      });
      vm.openSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.show);
      };
      vm.hideSgItemModal = function(){
          vm.sgItemModal.$promise.then(vm.sgItemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setToriCd = function(itemCd,itemNm){
          $scope.dirValue = itemCd;
          $scope.$parent.acc.editForm.kasi_hj_nm = itemNm;
          $scope.$parent.acc.editForm.kasi_hj_cd = itemCd;
          $log.debug($scope.$parent);
          vm.hideSgItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      if(!vm.inited){
          $element.bind('keydown keypress', function(event) {
              //console.log('keydown keypress');
              // SpaceClick
              if(event.keyCode === 32) {
                  //console.log('Space Click');
                  var type = event.type;
                  vm.itemInit();
                  vm.openSgItemModal();
                  // keyupになってしまった場合
                  if(type === 'keyup'){
                      //　元の値に戻す(space入力をなくす)
                      if(vm.origin_value) $scope.dirValue = vm.origin_value;
                  }
                  vm.inited = true;
                  event.preventDefault();
              }
          });
      }
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('sgHkSr', sgHkSr);

  /** @ngInject */
  function sgHkSr() {
    var directive = {
      restrict: 'E',
      require: '^ngModel',
      scope: {
        ngModel: '=dirValue',
        //sgKtcd: '@'
      },
      template: '<input class="form-control form-control-small input-sm" placeholder="スペース検索" ng-model="dirValue" />',
      controller: SgHkSearchController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SgHkSearchController($log, $window, $scope, $parse, $element, $attrs, $timeout, $state, storage, $modal, $http, dev) {
      var vm = this;

      $log.debug('SgHkSearchController');
      vm.commondata = storage.get('commondata');
      vm.user = storage.get('user');
      
      //
      $attrs.$observe('sgno', function(value){
          vm.sg_no = value;
      });
      //console.log($attrs);
      vm.origin_value;
      if( angular.isDefined($scope.$parent.exp.editForm) ){
          if( angular.isDefined($scope.$parent.exp.editForm.sg_no) ){
              $scope.dirValue = $scope.$parent.exp.editForm.sg_no;
              vm.origin_value = $scope.dirValue;
          }
      }
      
      // 初期化
      vm.init = function(){
       // From初期化
          vm.form = {};
          //vm.form.sn_fl_1 = '0';
          vm.bumon_nm = '';// 受注部門名
          vm.ju_tanto_nm = '';// 担当営業名
          vm.sg_bmn_nm = ''; // 作業予定部門名
          vm.simei_gj_nm_1 = '';// 作業予定担当者名
          vm.studio_nm = ''; //スタジオ名
          vm.form.sn_fl = '00';// 承認状態
          vm.sn_fl_nm = '問わず';
          vm.selectedDate = new Date();
          vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
          // 3年前の1/1を基準とする
          var fromBaseDate = new Date();
          //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
          //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
          fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
          vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);

          vm.form.untilDate = new Date();
          // pagenation 設定
          vm.datas = [];
          vm.totalDatas = 0;
          vm.datasPerPage = 50;
          
          if( vm.user.tan_cd !== '9999' && vm.user.tan_cd !== '9998' ){
              var stChk = false;
              // 部門選択初期値
              angular.forEach(vm.commondata.bumon ,function(v,k){
                  if(!stChk && vm.user.bumon_cd == v.bumon_cd){
                      vm.bumonSelect(v.bumon_cd, v.bumon_nm);
                      stChk = true;
                  }
              });
              // 担当営業初期値
              if(stChk) vm.eigyoSelect(vm.user.tan_cd,　vm.user.syain_nm);
          }
          vm.pagination = {
              current: 1
          };
      }
      
      // 受注部門
      vm.bumonDropdown = [{'text':'－－', 'click': 'vm.bumonSelect()'}];
      angular.forEach(vm.commondata.bumon ,function(v,k){
          vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'vm.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
      });
      // 作業部門
      vm.sghtDropdown = [{'text':'－－', 'click': 'vm.sghtSelect()'}];
      angular.forEach(vm.commondata.sgytbumon ,function(v,k){
          vm.sghtDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'vm.sghtSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
      });
      //$log.debug(vm.sghtDropdown);
      // Studio
      vm.studioDropdown = [{'text':'－－', 'click': 'vm.studioSelect()'}];
      angular.forEach(vm.commondata.studio ,function(v,k){
          vm.studioDropdown.push({'text':v.studio_cd + ' : '+ v.studio_nm, 'click': 'vm.studioSelect("'+ v.studio_cd +'","'+ v.studio_nm +'")'});
      });

      // スタジオ表示用
      vm.getStudioName = function(cd){
          var name;
          angular.forEach(vm.commondata.studio, function(v,k){
              if(v.studio_cd === cd ){
                  name = v.studio_nm;
              }
          });
          return name;
      };
      // Studio選択
      vm.studioSelect = function(studio_cd, studio_nm){
          if(studio_cd && studio_nm){
              vm.form.studio_cd = studio_cd;
              vm.studio_nm = studio_nm;
          }else{
              vm.form.studio_cd = '';
              vm.studio_nm = '';
          }
      };

      // 作業部門選択
      vm.sghtSelect = function(bumon_cd, bumon_nm){
          if(bumon_cd && bumon_nm){
              vm.sg_bmn_nm = bumon_nm;
              vm.form.sg_bmn_cd = bumon_cd;
              vm.getsghtsyain(bumon_cd);
          }else{
              vm.sg_bmn_nm = '';
              vm.form.sg_bmn_cd = '';
          }
      };

      // 受注部門選択
      vm.bumonSelect = function(bumon_cd, bumon_nm){
          if(bumon_cd && bumon_nm){
              vm.form.ju_bumon_cd = bumon_cd;
              vm.bumon_nm = bumon_nm;
              vm.getTantoEigyo(bumon_cd);
          }else{
              vm.form.ju_bumon_cd = '';
              vm.bumon_nm = '';
          }
      };

      // 担当営業取得
      vm.eigyoDropdown = [];
      vm.getTantoEigyo = function(bumon_cd){
          $http({
              url: dev.api + 'api/v1/tantoueigyo',
              method: "GET",
              params: {'cd': bumon_cd}
          }).success(function(data, status, headers, config) {
              vm.eigyoDropdown = [{'text':'－－', 'click': 'vm.eigyoSelect()'}];
              if(data){
                  angular.forEach(data ,function(v,k){
                      vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'vm.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                  });
              }
          });
      };
      // 担当営業選択
      vm.eigyoSelect = function(syain_cd, syain_nm){
          if(syain_cd && syain_nm){
              vm.form.ju_tanto_cd = syain_cd;
              vm.ju_tanto_nm = syain_nm;
          }else{
              vm.form.ju_tanto_cd = '';
              vm.ju_tanto_nm = '';
          }
      };

      // 作業予定担当取得
      vm.sghtsyaDropdown = [];
      vm.getsghtsyain = function(bumon_cd){
          $http({
              url: dev.api + 'api/v1/tantoueigyo',
              method: "GET",
              params: {'cd': bumon_cd}
          }).success(function(data) {
              vm.sghtsyaDropdown = [{'text':'－－', 'click': 'vm.sghtSyaSelect()'}];
              if(data){
                  angular.forEach(data ,function(v,k){
                      vm.sghtsyaDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'vm.sghtSyaSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                  });
              }
          });
      };
      // 作業予定担当選択
      vm.sghtSyaSelect = function(syain_cd, syain_nm){
          if(syain_cd && syain_nm){
              vm.form.gj_cd_1 = syain_cd;
              vm.gj_nm_1 = syain_nm;
          }else{
              vm.form.gj_cd_1 = '';
              vm.gj_nm_1 = '';
          }
      };

      // 承認状態
      vm.snflStatus = [{id:'00', name:'問わず'},{id:'01', name:'承認済み'}, {id:'02', name:'未承認'}];
      vm.snflStatusDropdown = [];
      angular.forEach(vm.snflStatus ,function(v,k){
          vm.snflStatusDropdown.push({'text':v.name, 'click': 'vm.snflStatusSelect("'+ v.id +'","'+ v.name +'")'});
      });
      // 承認状態選択
      vm.snflStatusSelect = function(id, name){
          vm.form.sn_fl = id;
          vm.sn_fl_nm = name;
      };

      // 次のページ/前のページ
      vm.pageChanged = function(newPage) {
          getResultsPage(newPage);
      };
      // ページデータ取得
      function getResultsPage(pageNumber) {
          var search = null;
          if(vm.form){
              // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
              // (一度でも画面から日付の変更操作を行えば整う)
              if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                  vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
              }
              if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                  vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
              }
              search = vm.form;
              angular.forEach(search,function(v,k){
                 if(!v) delete search[k];//不要なparamは削除
              });
          }
          $http({
              url: dev.api + 'api/v1/report',
              method: 'GET',
              params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
          }).success(function(datas) {
              vm.datas = datas.data;
              vm.totalDatas = datas.total;
              if(vm.form) vm.search = vm.form;
              $log.debug(datas);
              vm.currentpage = datas.current_page;
          });
      }

      // 得意先検索実行
      vm.tokuisakiApiSearch = function(str) {
          return $http({
              url: dev.api + 'api/v1/tokuisaki',
              method: 'GET',
              params: {m:'ids',q:str}
          });
      };

      // 得意先の選択
      vm.tokuisakiSelected = function(selected) {
          if (selected) {
              var res = selected.title.split(':');
              vm.form.toku_cd = res[0];
              vm.toku_nm = res[1];
          }
      };

      // 検索実行
      vm.goSearch = function(){
          $log.debug(vm.form);
          getResultsPage(1);
          vm.pagination = { current: 1};
      };
      // 検索Formクリア
      vm.clear = function(){
          vm.formInit();
      };
      
      // 検索Modal
      vm.itemModal = $modal({
          templateUrl:'app/business-expenses/sghksr/index.html',
          scope: $scope,
          show:false
      });
      vm.openItemModal = function(){
          vm.itemModal.$promise.then(vm.itemModal.show);
      };
      vm.hideItemModal = function(){
          vm.itemModal.$promise.then(vm.itemModal.hide);
      };
      
      // 選択したアイテムの値を親scopeに返す
      vm.setSghkItem = function(item){
          $scope.dirValue = item.sg_no;
          $scope.$parent.exp.editForm.sg_no = item.sg_no;
          $log.debug($scope.$parent);
          vm.hideItemModal();
      }
      
      // Space Click Event
      // たまに(firefox firebug出している時限定？？)spaceの場合、keyupしか取得できないことがある
      $element.bind('keydown keypress', function(event) {
          // SpaceClick
          if(event.keyCode === 32) {
              //console.log('Space Click');
              var type = event.type;
              vm.init();
              vm.openItemModal();
              // keyupになってしまった場合
              if(type === 'keyup'){
                  //　元の値に戻す(space入力をなくす)
                  if(vm.origin_value) $scope.dirValue = vm.origin_value;
              }
              event.preventDefault();
          }
      });
      
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('ExpPrintController', ExpPrintController);

  /** @ngInject */
  function ExpPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {


    // 経費印刷
    $log.debug('ExpPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.nowDate = Math.round(+new Date()/1000);
    
    vm.datasPerPage = 5;
    vm.printInit = function(){
        
        vm.title = '経費明細書';
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        vm.printTargetData = storage.get('printExpData');
        //console.log(vm.printTargetData);
        var printDetail = vm.printTargetData.detail;
        
        $log.debug(vm.datas);
        vm.pagination = {current:1};
        
        var chunk_size = 8;
        var newArr = [];
        vm.itemDetail = [];
        // 明細の数が20以上の場合nページに分ける
        if( printDetail.length > chunk_size ){
            newArr = printDetail.map( function(e,i){
                return i%chunk_size===0 ? printDetail.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            vm.itemDetail = newArr;
        }else{
            vm.itemDetail.push(printDetail);
        }
        vm.totalDatas = vm.itemDetail.length;
        vm.totalCount = 1;
        vm.pageChanged(1);
    };
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        //getResultsPage(newPage);
        var start = 0;
        var end = vm.datasPerPage;
        if(newPage > 1){
            start = (newPage - 1) * vm.datasPerPage;
            end = start + start;
        }
        vm.totalCount = vm.itemDetail.length;
        vm.datas = vm.itemDetail.slice(start, end);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        //vm.totalDatas = vm.itemDetail.length;
        //vm.datas = vm.itemDetail.slice(pageNumber-1, (pageNumber-1) + vm.datasPerPage );
        //vm.totalCount = vm.totalDatas.length;
    }
    vm.printInit();
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('accPrintController', accPrintController);

  /** @ngInject */
  function accPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {


    // 経費印刷
    $log.debug('accPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.nowDate = Math.round(+new Date()/1000);

    vm.printInit = function(){
        vm.title = '経費明細書';
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        vm.printTargetData = storage.get('printExpData');
        $log.debug(vm.allItems);
    };
    vm.printInit();
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('workSpecificationController', workSpecificationController);

  /** @ngInject */
  function workSpecificationController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('workSpecificationController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'028');
    
    vm.form = {};
    vm.downloadPath = '';
    vm.common = {};
    vm.kihon = {};
    vm.getCommondata = function (){
        $http({
            url: dev.api + 'api/v1/commondata',
            method: "GET",
        }).success(function(data) {
            vm.common = data;
            vm.kihon = vm.common.kihon;
            var ym = vm.common.kihon.getuji_ym.toString();
            var y = ym.substring(0 ,4);
            var m = ym.substring(4 ,6);
            vm.form.fromDate = ym;

            vm.form.base_rate_over_1 = vm.kihon.base_rate_over_1;
            vm.form.base_rate_over_2 = vm.kihon.base_rate_over_2;
            vm.form.base_rate_over_3 = vm.kihon.base_rate_over_3;
            vm.form.base_rate_over_4 = vm.kihon.base_rate_over_4;
        });
    };
    vm.getCommondata();

    // DownloadModal
    vm.downloadModal = $modal({
        templateUrl:'app/analysis/work-specification/modal1.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openModal = function(){
        vm.downloadModal.$promise.then(vm.downloadModal.show);
    };
    // ModalClose
    vm.hideModal = function(){
        vm.downloadModal.$promise.then(vm.downloadModal.hide);
    };
    $scope.$on('vm.downloadModal.hide',function(){
        //console.log('editModal.hide');
    });
    vm.generateAnalysis = function() {
        $http({
            url: dev.api + 'api/v1/genaratespec',
            method: 'GET',
            params: {form:angular.toJson(vm.form)}
        }).success(function(data) {
            vm.downloadPath = dev.api + data.url;
            vm.openModal();
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('StudioTransitionController', StudioTransitionController);

  /** @ngInject */
  function StudioTransitionController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('StudioTransitionController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'025');
    vm.commondata = storage.get('commondata');
    
    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.form = {};
    vm.from_date = y + '/04';
    vm.form.target_date = y + '/' + m;
    vm.mainDatas = [];
    vm.csvItems = [];
    vm.csvHeaders = [];
    
    // 部門DropDown
    vm.bumonDropdown = [];
    angular.forEach(vm.commondata.parentBumon ,function(v,k){
        if(v.bumon_kb != 0)
            vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'str.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_kb +'","'+ v.bumon_nm +'")'});
    });
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_kb, bumon_nm){
        vm.form.bumon_cd = bumon_cd;
        vm.form.bumon_kb = bumon_kb;
        vm.form.bumon_nm = bumon_nm;
    };
    // DatePicker MAX月対応
    vm.getMaxDate = function(){
        var endBaseDate = new Date();
        //endBaseDate.setMonth(endBaseDate.getMonth());
        return moment(new Date(endBaseDate.getFullYear(),endBaseDate.getMonth(),1)).format("YYYY/MM/DD");
    }
    
    // 横td生成用
    vm.dummyItem = function(){
        vm.item = [];
        var i = 0;
        while( i < 32){
            vm.item.push(i)
            i++
        }
    }
    vm.dummyItem();

    // 該当データの日付ごとの曜日を取得
    vm.getWeek = function(day){
        moment.lang('ja', {weekdays: ["日","月","火","水","木","金","土"]});
        var weeks = moment(vm.form.target_date+'/'+vm.zeroPudding(day+1),"YYYY/MM/DD");
        return weeks.format('dddd');
    };
    
    // アイテム判定
    vm.getLength = function(obj) {
        return Object.keys(obj).length;
    };
    // 達成率計算
    vm.makeAchievementRate = function(dtl, no) {
        if(!dtl) return 0;
        var kins = [],i=1,total=0;
        while(i <= no){
            kins.push( dtl['kin'+i] );
            i++;
        }
        if(kins.length > 0){
            total = kins.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        if(total > 10000){
            return Math.floor(total/1000, 1);
        }else{
            return MathRound(total, 1);
        }
    };
    
    // 月間合計金額
    vm.makeMonthTotal = function(dtl) {
        if(!dtl) return 0;
        var kins=[],i=1,total=0;
        while(i <= 31){
            var kin = dtl['kin'+i];
            kins.push( kin );
            i++;
        }
        if(kins.length > 0){
            total = kins.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        if(total > 10000){
            return Math.floor(total/1000, 1);
        }else{
            return Math.floor(total, 1);
        }
    };
    
    // Filter
    vm.kinFilter = function(kin) {
        if(!kin) return 0;
        if(kin > 1000)
            return Math.floor(kin/1000, 1);
        return kin;
    };
    
    // 帳票生成実行
    vm.generateAnalysis = function() {
        $log.debug(vm.form);

        $http({
            url: dev.api + 'api/v1/getstudiotransition',
            method: 'GET',
            params: {form:angular.toJson(vm.form)}
        }).success(function(response) {
            $log.debug(response);
            if(response.datas.length === 1 || !response.datas){
                vm.error = 'データが存在しません';
            }else{
                vm.error = null;
                var list = $filter('groupBy')(response.datas, 'bumon_cd');
                angular.forEach(list, function(v,group){
                    list[group].bumon_nm = v[0].bumon_nm;
                    list[group].bumon_cd = v[0].bumon_cd;
                });
                vm.mainDatas = list;
                $log.debug(vm.mainDatas);
                angular.forEach(response.datas, function(val,i){
                    vm.csvItems.push(val);
                    angular.forEach(val, function(v,k){
                        if(i === 0) vm.csvHeaders.push(k);
                    });
                });
            }
        });
    };
    
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('StaffOperatingStatusController', StaffOperatingStatusController);

  /** @ngInject */
  function StaffOperatingStatusController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('StaffOperatingStatusController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'027');
    vm.commondata = storage.get('commondata');
    
    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.form = {value: []};
    vm.from_date = y + '/04';
    //vm.end_date = y + '/' + m;
    vm.end_date = null;

    // DatePicker MIN月対応
    vm.getMinDate = function(){
        var from = vm.from_date+'/01';
        var fromBaseDate = new Date(from);
        fromBaseDate.setMonth(fromBaseDate.getMonth()+1);
        return moment(new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1)).format("YYYY/MM/DD");
    }
    // DatePicker MAX月対応
    vm.getMaxDate = function(){
        var end = vm.end_date+'/01';
        var endBaseDate = new Date(end);
        endBaseDate.setMonth(endBaseDate.getMonth()-1);
        return moment(new Date(endBaseDate.getFullYear(),endBaseDate.getMonth(),1)).format("YYYY/MM/DD");
    }
    
    
    vm.options = {};
    vm.origin_data = [];

    vm.getStaff = function(){
        $http({
            url: dev.api + 'api/v1/getbumonstaffkado',
            method: 'GET',
        }).success(function(datas) {
            vm.origin_data = datas;
            var list = $filter('groupBy')(datas, 'parent_bumon_cd');
            //vm.items = [{id:'0000', text:'すべて',children:[]}];
            // 部門内でさらに部署ごとにグルーピング
            angular.forEach(list, function(v,k){
                list[k] = $filter('groupBy')(v, 'bumon_cd');
            });
            // 部署内でさらにｱｲｳｴｵごとにグルーピング
            angular.forEach(list, function(v,k){
                angular.forEach(v, function(val,key){
                    list[k][key] = $filter('groupBy')(val, 'syain_km_head');
                });
            });
            
            vm.items = [];
            // dualSelectの仕様に合わせデータを加工
            angular.forEach(list, function(v,parent_bumon_cd){
                var child = [],parent_bumon_nm,i = 0;
                angular.forEach(v ,function(val,bumon_cd){
                    var grandChild = [],bumon_nm,y = 0;
                    angular.forEach(val ,function(itm,head){
                        var lastChild = [];
                        angular.forEach(itm ,function(data){
                            lastChild.push({ id:parent_bumon_cd +':'+ bumon_cd +':'+ head +':'+ data.syain_cd, text:data.syain_nm });
                        });
                        grandChild.push({ id:parent_bumon_cd +':'+ bumon_cd +':'+ head , text:head, children:lastChild});
                        if(y === 0 ) {
                            parent_bumon_nm = itm[y].parent_bumon_nm;
                            bumon_nm = itm[y].bumon_nm;
                        }
                        y++;
                    });
                    child.push({ id:parent_bumon_cd +':'+ bumon_cd , text:bumon_nm, children:grandChild });
                    if(i === 0) 
                    i++;
                });
                vm.items.push({ id:parent_bumon_cd, text:parent_bumon_nm, children:child });
            });
            
            // dualSelectのoption
            vm.options = {
                labelAll: '一覧',
                labelSelected: '選択済みリスト',
                buttonCheckAll: 'すべて選択',
                buttonDeselectAll: 'すべて解除',
                displayProperty: 'text',
                valueProperty: 'id'
            };
        });
    };
    vm.getStaff();
        
    vm.generateAnalysis = function() {
        vm.form.from_date = vm.from_date;
        vm.form.end_date = vm.end_date;
        $log.debug(vm.form);

        $http({
            url: dev.api + 'api/v1/getstaffoperatingstatus',
            method: 'GET',
            params: {values:angular.toJson(vm.form)}
        }).success(function(datas) {
            $log.debug(datas);
            storage.set('printSosData', datas);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $rootScope.openWindow = $window.open('#/sos-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('SosPrintController', SosPrintController);

  /** @ngInject */
  function SosPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('SosPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.mode = 1;
    vm.allItems = [];
    vm.datas = [];
    vm.datasPerPage = 3;
    vm.shimeData = {};
    vm.nowDate = Math.round(+new Date()/1000);

    vm.pageEngneerInit = function(){
        vm.title = 'スタッフ稼動状況';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printSosData');
        var printTargetData = data.datas;
        vm.frmEnd = data.frmEnd;
        vm.shimeData = data.shime_data;
        vm.ym = vm.shimeData.getuji_ym.toString();
        vm.y = vm.ym.substring(0 ,4);
        vm.m = vm.ym.substring(4 ,6);
        
        var geoupItems = $filter('groupBy')(printTargetData, 'parent_bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        angular.forEach(geoupItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].parent_bumon_nm, 'click': 'sosprint.bumonSelect("'+ datas[0].parent_bumon_cd +'","'+ datas[0].parent_bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].parent_bumon_nm;
            }
            var chunk_size = 15;
            var gpItems = $filter('groupBy')(datas, 'bumon_cd');
            //var items = $filter('orderBy')(itms, 'bumon_syokusyu');
            var lastItem = {};
            var gpItmLen = Object.keys(gpItems).length;
            var bumonTmp = [];

            // 明細の数がn以上の場合nページに分ける
            angular.forEach(gpItems, function(dt,grp){
                var dtl = $filter('orderBy')(dt, 'syain_km');
                var itemsArr = dtl.map( function(e,i){
                    return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
                }).filter(function(e){ return e; });
                allTemp.push(itemsArr);
            });
            i++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
        $log.debug(vm.allItems);
 
    };
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        var start = 0;
        var end = vm.datasPerPage;
        if(newPage > 1){
            start = (newPage - 1) * vm.datasPerPage;
            end = start + start;
        }
        var filterd = $filter('filter')(vm.allItems, { 'parent_bumon_cd': vm.defaultFiler });
        vm.datas = filterd.slice(start, end);
        //$log.debug(vm.datas);
    };

    // 部門選択
    vm.bumonSelect = function(group_no,name){
        //console.log('group > ' + group_no);
        //console.log('name > ' + name);
        vm.pagination = {current:1};
        vm.bumonName = name;
        vm.parentBumonName = name;
        vm.defaultFiler = group_no;
       
        var filterd = $filter('filter')(vm.allItems, { 'parent_bumon_cd': group_no });
        //$log.debug(filterd);
        vm.totalCount = filterd.length;
        vm.datas = filterd.slice(0, vm.datasPerPage );
        
    };
    
    vm.pageEngneerInit();

    // 指名率時間
    vm.makeKado_j = function(dtl){
        var j_kei = dtl.giju_j_kei
        var JS_kei = dtl.giju_js_kei
        var res = MathRound(MathRound(JS_kei/j_kei, 3)*100,1);
        return isFinite(res)?res:'***';
    };
    // 指名率件数
    vm.makeKado_k = function(dtl){
        var k_kei = dtl.giju_k_kei
        var kS_kei = dtl.giju_ks_kei
        var res = MathRound(MathRound(kS_kei/k_kei, 3)*100,1);
        return isFinite(res)?res:'***';
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('OaPrintPrintController', OaPrintPrintController);

  /** @ngInject */
  function OaPrintPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('OaPrintPrintController');

    var vm = this;

    vm.printMode = null;
    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.mode = 1;
    vm.allItems = [];
    vm.datas = [];
    vm.datasPerPage = 6;
    vm.shimeData = {};
    vm.nowDate = Math.round(+new Date()/1000);
    
    vm.pageOaPrintCountInit = function(){
        vm.title = '得意先別OAプリント本数';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printOaData');
        var printTargetData = data.datas;
        vm.shimeData = data.shime_data;
        vm.ym = vm.shimeData.getuji_ym.toString();
        vm.y = vm.ym.substring(0 ,4);
        vm.m = vm.ym.substring(4 ,6);

        var geoupItems = $filter('groupBy')(printTargetData, 'toku_cd');
        
        // グルーピングしたデータをさらに分割
        vm.allItems = [];
        var allTemp = [];
        var extendedItems = [];
        //console.log(geoupItems);
        
        // 通常の配列に変換
        var odered = $filter('orderObjectBy')(geoupItems, 'toku_km', true);
        angular.forEach(odered, function(val){
            allTemp.push(val);
        });
        
        // １ページ２件づつのデータに分割(一段上にページ用配列追加）
        var chunk_size = 1;
        var targetItems = allTemp.map( function(e,i){
            return i%chunk_size===0 ? allTemp.slice(i,i+chunk_size) : null;
        }).filter(function(e){ return e; });
        
        var newArr = [];
        angular.forEach(targetItems, function(val, key){
            var inArr = [];
            angular.forEach(val, function(items, k){
                var sort = $filter('orderBy')(items, 'media_cd');
                var mearge = [0,1,2];
                var toku_data = {};
                angular.forEach(items, function(itm, k){
                    var preMearge = [0,1,2];
                    angular.forEach(itm.preData, function(pre, ky){
                        //if(pre.media_cd === '033') preMearge[0] = pre;
                        //if(pre.media_cd === '017') preMearge[1] = pre;
                        //if(pre.media_cd === '9999') preMearge[2] = pre;
                    });
                    //itm.preData = preMearge;
                    if(itm.media_cd === '033') {
                        mearge[0] = itm;
                        toku_data.toku_cd = itm.toku_cd;
                        toku_data.toku_nm = itm.toku_nm
                        toku_data.bumon_cd = itm.bumon_cd
                        toku_data.bumon_nm = itm.bumon_nm
                    }
                    if(itm.media_cd === '017') {
                        mearge[1] = itm;
                        toku_data.toku_cd = itm.toku_cd;
                        toku_data.toku_nm = itm.toku_nm
                        toku_data.bumon_cd = itm.bumon_cd
                        toku_data.bumon_nm = itm.bumon_nm
                    }
                    if(itm.media_cd === '9999') {
                        mearge[2] = itm;
                        toku_data.toku_cd = itm.toku_cd;
                        toku_data.toku_nm = itm.toku_nm
                        toku_data.bumon_cd = itm.bumon_cd
                        toku_data.bumon_nm = itm.bumon_nm
                    }
                });
                inArr.push({item:mearge,toku:toku_data});
            });
            newArr.push(inArr); 
        });
        vm.allItems = newArr;
        
        //$log.debug(allTemp);
        // 最初の部門のページをセット
        vm.totalCount = vm.allItems.length;
        vm.datas = vm.allItems.slice(0, vm.datasPerPage );
        $log.debug(vm.allItems);

    };
    vm.pageOaPrintCountInit();
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        var start = 0;
        var end = vm.datasPerPage;
        if(newPage > 1){
            start = (newPage - 1) * vm.datasPerPage;
            end = start + start;
        }
        //var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': vm.defaultFiler });
        vm.datas = vm.allItems.slice(start, end);
        //$log.debug(vm.datas);
    };

    // 合計計算
    vm.reduceItem = function(kinArr){
        var allTotal = 0;
        if(kinArr.length > 0){
            allTotal = kinArr.reduce(function(pre, curr) {
                if(!pre) pre = 0;
                if(!curr) curr = 0;
                return Number(pre) + Number(curr);
            });
        }
        return allTotal;
    };
    
    // 前年比計算
    vm.prePer = function(kin,prekin){
        if(!kin || !prekin) return 0;
        var ret = MathRound( MathRound( Number(kin)/Number(prekin), 3)*100,1)
        if( !isFinite(ret) ) ret = 0;
        return ret;
    }
    // 前年比計 計算
    vm.prePerKei = function(kinArr, preKinArr){
        var kin = vm.reduceItem(kinArr);
        var preKin = vm.reduceItem(preKinArr);
        return vm.prePer(kin, preKin);
    };
    
    // 基準売上　前年比累計 計算
    vm.prePerKinYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 基準売上　前年比累計 計算
    vm.prePerHonYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'honsu'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 実売上　前年比累計 計算
    vm.prePerHonNbYear = function(kn,pr){
        if(!kn || !pr) return 0;
        var kin = vm.reduceItem(kn);
        
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var preAll = [];
        var target = [];
        for(; i <= endM; i++){
            var column = 'honsu'+ vm.zeroPudding(i);
            target.push(column);
        }
        var allTotal = 0;
        if(pr){
            angular.forEach(pr,function(pre){
                var sumKin = [];
                var preTotal = 0;
                if(pre){
                    angular.forEach(target, function(v){
                        sumKin.push(pre[v]);
                    });
                }
                if(sumKin.length > 0){
                    preTotal = vm.reduceItem(sumKin);
                    //console.log(preTotal)
                }
                preAll.push(preTotal);
            });
        }
        
        allTotal = vm.reduceItem(preAll);
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引率　前年比累計 計算
    vm.prePerKinNbYear = function(kn,pr){
        if(!kn || !pr) return 0;
        var kin = vm.reduceItem(kn);
        
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var preAll = [];
        var target = [];
        for(; i <= endM; i++){
            var column = 'kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var allTotal = 0;
        if(pr){
            angular.forEach(pr,function(pre){
                var sumKin = [];
                var preTotal = 0;
                if(pre){
                    angular.forEach(target, function(v){
                        sumKin.push(pre[v]);
                    });
                }
                if(sumKin.length > 0){
                    preTotal = vm.reduceItem(sumKin);
                }
                preAll.push(preTotal);
            });
        }
        
        allTotal = vm.reduceItem(preAll);
        allTotal = vm.reduceItem(preAll);
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
   
    // 値引き計算
    vm.nebiki = function(kj,ur){
        if(!kj || !ur) return 0;
        var sabun = kj - ur;
        return MathRound(MathRound(sabun/kj, 3)*100,1);
    }
    

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('OaPrintCountController', OaPrintCountController);

  /** @ngInject */
  function OaPrintCountController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('OaPrintCountController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'024');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    
    vm.options = {};
    vm.form = {value: []};
    vm.origin_data = [];

    vm.getBumonToku = function(){
        $http({
            url: dev.api + 'api/v1/getoaprinttoku',
            method: 'GET',
        }).success(function(datas) {
            vm.origin_data = datas;
            vm.filterd = [];
            angular.forEach(datas, function(v,k){
                if(v.parent_bumon_cd === '0200') vm.filterd.push(v);
            });

            var list = $filter('groupBy')(vm.filterd, 'bumon_cd');
            
            // 部門内でさらにｱｲｳｴｵ順にグルーピング
            angular.forEach(list, function(v,k){
                list[k] = $filter('groupBy')(v, 'toku_km_head');
            })
            //console.log(list);
            
            vm.items = [];
            // dualSelectの仕様に合わせデータを加工
            angular.forEach(list, function(v,bumon_cd){
                var child = [],bumon_nm,i = 0;
                angular.forEach(v ,function(val,head){
                    var grandChild = [];
                    angular.forEach(val ,function(data){
                        grandChild.push({ id:bumon_cd +':'+ head + ':' +data.toku_cd, text:data.toku_nm });
                        bumon_nm = data.parent_bumon_nm;
                    });
                    child.push({ id:bumon_cd +':'+ head , text:head, children:grandChild });
                    i++;
                })
                vm.items.push({ id:bumon_cd, text:bumon_nm, children:child });
            });

            // dualSelectのoption
            vm.options = {
                labelAll: '一覧',
                labelSelected: '選択済みリスト',
                buttonCheckAll: 'すべて選択',
                buttonDeselectAll: 'すべて解除',
                displayProperty: 'text',
                valueProperty: 'id'
            };
        });
    };
    vm.getBumonToku();
        
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        var year = vm.commondata.kihon.kaikei_nendo;

        $http({
            url: dev.api + 'api/v1/getmonthlyanaliysisoaprint',
            method: 'GET',
            params: {year:year,values:angular.toJson(vm.form.value)}
        }).success(function(datas) {
            $log.debug(datas);
            storage.set('printOaData', datas);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $rootScope.openWindow = $window.open('#/oa-prt', '_blank','width=1100,height=800,scrollbars=1,location=0');
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MtsPrintController', MtsPrintController);

  /** @ngInject */
  function MtsPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('MtsPrintController');

    var vm = this;

    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.mode = 1;
    vm.allItems = [];
    vm.datas = [];
    vm.datasPerPage = 6;
    vm.shimeData = {};
    vm.nowDate = Math.round(+new Date()/1000);
    
    vm.pageMtsInit = function(){
        vm.title = '部門別売上推移';
        // pagenation 設定
        vm.pagination = {current:1};
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printMtsData');
        var printTargetData = data.datas;
        vm.shimeData = data.shime_data;
        vm.ym = vm.shimeData.getuji_ym.toString();
        vm.y = vm.ym.substring(0 ,4);
        vm.m = vm.ym.substring(4 ,6);
        
        var chunk_size = 3;
        var items = $filter('orderBy')(printTargetData, '-bumon_cd');
        var allTemp = [];
        
        angular.forEach(items, function(val){
            if(val.bumon_kb === '0'){
                vm.parent_bumon_nm = val.bumon_nm;
                vm.parent_bumon_cd = val.bumon_cd;
            }
            if(Object.keys(items).length < 3){
                if(val.bumon_kb !== '0') allTemp.push(val);
            }else{
                allTemp.push(val);
            }
        });
        
        // 明細の数がn以上の場合nページに分ける
        vm.allItems = allTemp.map( function(e,i){
            return i%chunk_size===0 ? allTemp.slice(i,i+chunk_size) : null;
        }).filter(function(e){ return e; });
        // 最初のページをセット
        vm.datas = vm.allItems.slice(0, vm.datasPerPage); 
    };
    vm.pageMtsInit();
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        var start = 0;
        var end = vm.datasPerPage;
        if(newPage > 1){
            start = (newPage - 1) * vm.datasPerPage;
            end = start + start;
        }
        vm.datas = vm.allItems.slice(start, end);
        //$log.debug(vm.datas);
    };
    // 前年比計算
    vm.prePer = function(kin,prekin){
        if(!kin || !prekin) return 0;
        return MathRound(MathRound(kin/prekin, 3)*100,1);
    }
    // 基準売上　前年比累計 計算
    vm.prePerKjYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'kj_ur_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 実売上　前年比累計 計算
    vm.prePerJtYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'jt_ur_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引率　前年比累計 計算
    vm.prePerNbYear = function(kj,ur,pre){
        if(!kj || !ur || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target1 = [];
        var target2 = [];
        var zen_nb = 0;
        for(; i <= endM; i++){
            var column1 = 'kj_ur_kin'+ vm.zeroPudding(i);
            var column2 = 'jt_ur_kin'+ vm.zeroPudding(i);
            target1.push(column1);
            target2.push(column2);
        }
        var sumKin1 = [];
        var sumKin2 = [];
        var kj_ur = 0;
        var jt_ur = 0;
        var sb = 0;
        var pre_sb = 0;
        angular.forEach(target1, function(v){
            sumKin1.push(pre[v]);
        });
        angular.forEach(target2, function(v){
            sumKin2.push(pre[v]);
        });
        if( sumKin1.length > 0 && sumKin2.length > 0){
            kj_ur = sumKin1.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            jt_ur = sumKin2.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            sb = kj - ur;
            pre_sb = kj_ur - jt_ur;
        }

        var res = MathRound( MathRound( (sb/kj)/(pre_sb/kj_ur),3 ) *100,1);
        //console.log(res);
        return isFinite(res)?res:'***';
    }
    // 実際原価　前年比 計算
    vm.prePerGnYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'sg_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引き計算
    vm.nebiki = function(kj,ur){
        if(!kj || !ur) return 0;
        var sabun = kj - ur;
        return MathRound(MathRound(sabun/kj, 3)*100,1);
    }
    

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MonthlyTransitionController', MonthlyTransitionController);

  /** @ngInject */
  function MonthlyTransitionController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MonthlyTransitionController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'026');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    vm.options = {};
    vm.form = {};
    vm.form.parentBmnChk = 0;

    // 部門DropDown
    vm.bumonDropdown = [];
    angular.forEach(vm.commondata.parentBumon ,function(v,k){
        if(v.bumon_kb != 0)
            vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'mts.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_kb +'","'+ v.bumon_nm +'")'});
    });
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_kb, bumon_nm){
        vm.form.bumon_cd = bumon_cd;
        vm.form.bumon_kb = bumon_kb;
        vm.form.bumon_nm = bumon_nm;
    };
    
    // 帳票生成実行
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        var year = vm.commondata.kihon.kaikei_nendo;

        $http({
            url: dev.api + 'api/v1/getmonthlytransition',
            method: 'GET',
            params: {year:year,values:angular.toJson(vm.form)}
        }).success(function(datas) {
            $log.debug(datas);
            if(datas.length === 0 || !datas){
                vm.error = 'データが存在しません'
            }else{
                storage.set('printMtsData', datas);
                if( $rootScope.openWindow ){
                    $rootScope.openWindow.focus();
                    $rootScope.openWindow.close();
                }
                $rootScope.openWindow = $window.open('#/mts-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
            }
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MonReportTokuController', MonReportTokuController);

  /** @ngInject */
  function MonReportTokuController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MonReportTokuController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'022');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    
    vm.options = {};
    vm.form = {value: []};
    vm.origin_data = [];

    vm.getBumonToku = function(){
        $http({
            url: dev.api + 'api/v1/getbumontoku',
            method: 'GET',
        }).success(function(datas) {
            vm.origin_data = datas;
            var list = $filter('groupBy')(datas, 'bumon_cd');
            // 部門内でさらにｱｲｳｴｵ順にグルーピング
            angular.forEach(list, function(v,k){
                list[k] = $filter('groupBy')(v, 'toku_km_head');
            })
            //console.log(list);
            
            vm.items = [];
            // dualSelectの仕様に合わせデータを加工
            angular.forEach(list, function(v,bumon_cd){
                var child = [],bumon_nm,i = 0;
                angular.forEach(v ,function(val,head){
                    var grandChild = [];
                    angular.forEach(val ,function(data){
                        grandChild.push({ id:bumon_cd +':'+ head + ':' +data.toku_cd, text:data.toku_nm });
                    });
                    child.push({ id:bumon_cd +':'+ head , text:head, children:grandChild });
                    if(i === 0) bumon_nm = val[i].bumon_nm;
                    i++;
                })
                vm.items.push({ id:bumon_cd, text:bumon_nm, children:child });
            });

            // dualSelectのoption
            vm.options = {
                labelAll: '一覧',
                labelSelected: '選択済みリスト',
                buttonCheckAll: 'すべて選択',
                buttonDeselectAll: 'すべて解除',
                displayProperty: 'text',
                valueProperty: 'id'
            };
        });
    };
    vm.getBumonToku();
    
    /*
    $scope.$watch(function() { return vm.form.value;},
      function(newVal,oldVal) {
        if(newVal !== oldVal){
            //console.log(vm.form.value);
        }
    }, true);
    */
    
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        var year = vm.commondata.kihon.kaikei_nendo;

        $http({
            url: dev.api + 'api/v1/getmonthlyanaliysistoku',
            method: 'GET',
            params: {year:year,values:angular.toJson(vm.form.value)}
        }).success(function(datas) {
            $log.debug(datas);
            storage.set('printMtokuData', datas);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $rootScope.openWindow = $window.open('#/jt-print/toku', '_blank','width=1100,height=800,scrollbars=1,location=0');
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MonReportTanController', MonReportTanController);

  /** @ngInject */
  function MonReportTanController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MonReportTanController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'021');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    
    vm.options = {};
    vm.form = {value: []};
    vm.origin_data = [];

    vm.getBumonSyain = function(){
        $http({
            url: dev.api + 'api/v1/getbumonsyain',
            method: 'GET',
        }).success(function(datas) {
            vm.origin_data = datas;
            var list = $filter('groupBy')(datas, 'bumon_cd');
            //vm.items = [{id:'0000', text:'すべて',children:[]}];
            vm.items = [];
            // dualSelectの仕様に合わせデータを加工
            angular.forEach(list, function(v,k){
                var child = [],bumon_nm;
                angular.forEach(v ,function(val){
                    child.push({ id:val.syain_cd+':'+val.bumon_cd, text:val.syain_nm});
                    bumon_nm = val.bumon_nm;
                })
                vm.items.push({id:k, text:bumon_nm, children:child});
            });
            // dualSelectのoption
            vm.options = {
                labelAll: '一覧',
                labelSelected: '選択済みリスト',
                buttonCheckAll: 'すべて選択',
                buttonDeselectAll: 'すべて解除',
                displayProperty: 'text',
                valueProperty: 'id'
            };
        });
    };
    vm.getBumonSyain();
        
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        var year = vm.commondata.kihon.kaikei_nendo;

        $http({
            url: dev.api + 'api/v1/getmonthlyanaliysistan',
            method: 'GET',
            params: {year:year,values:angular.toJson(vm.form.value)}
        }).success(function(datas) {
            $log.debug(datas);
            storage.set('printMtanData', datas);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $rootScope.openWindow = $window.open('#/jt-print/tan', '_blank','width=1100,height=800,scrollbars=1,location=0');
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('JtPrintController', JtPrintController);

  /** @ngInject */
  function JtPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('JtPrintcontroller');

    var vm = this;

    vm.printMode = null;
    if( $stateParams.mode ){
        vm.printMode = $stateParams.mode;
    }
    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.mode = 1;
    vm.allItems = [];
    vm.datas = [];
    vm.datasPerPage = 10;
    vm.shimeData = {};
    vm.nowDate = Math.round(+new Date()/1000);

    vm.pageGetuTanInit = function(){
        vm.title = '月別実績(担当者)';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printMtanData');
        var printTargetData = data.datas;
        vm.shimeData = data.shime_data;
        vm.ym = vm.shimeData.getuji_ym.toString();
        vm.y = vm.ym.substring(0 ,4);
        vm.m = vm.ym.substring(4 ,6);
        
        var geoupItems = $filter('groupBy')(printTargetData, 'bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        //console.log(geoupItems);
        angular.forEach(geoupItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'jtprint.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].bumon_nm;
            }
            var chunk_size = 1;
            var items = $filter('orderBy')(datas, 'syain_km');
            // 明細の数がn以上の場合nページに分ける
            var itemsArr = items.map( function(e,i){
                return i%chunk_size===0 ? items.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            // 数の足りていない配列に追加
            /*angular.forEach(itemsArr, function(v,k){
                while (v.length < chunk_size) {
                    v.push({'bumon_cd':group});
                }
                itemsArr[k] = v;
            });
            */
            allTemp.push(itemsArr);
            i++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
        //$log.debug(vm.allItems);
 
    };
    
    vm.pageGetuTokuInit = function(){
        vm.title = '月別実績(得意先)';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printMtokuData');
        var printTargetData = data.datas;
        vm.shimeData = data.shime_data;
        vm.ym = vm.shimeData.getuji_ym.toString();
        vm.y = vm.ym.substring(0 ,4);
        vm.m = vm.ym.substring(4 ,6);
        
        var geoupItems = $filter('groupBy')(printTargetData, 'bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        //console.log(geoupItems);
        angular.forEach(geoupItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].bumon_nm, 'click': 'jtprint.bumonSelect("'+ datas[0].bumon_cd +'","'+ datas[0].bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].bumon_nm;
            }
            var chunk_size = 1;
            var items = $filter('orderBy')(datas, '-toku_km');
            // 明細の数がn以上の場合nページに分ける
            var itemsArr = items.map( function(e,i){
                return i%chunk_size===0 ? items.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            // 数の足りていない配列に追加
            /*angular.forEach(itemsArr, function(v,k){
                while (v.length < chunk_size) {
                    v.push({'bumon_cd':group});
                }
                itemsArr[k] = v;
            });
            */
            allTemp.push(itemsArr);
            i++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
        //$log.debug(vm.allItems);
 
    };
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        var start = 0;
        var end = vm.datasPerPage;
        if(newPage > 1){
            start = (newPage - 1) * vm.datasPerPage;
            end = start + start;
        }
        var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': vm.defaultFiler });
        vm.datas = filterd.slice(start, end);
        //$log.debug(vm.datas);
    };

    // 部門選択
    vm.bumonSelect = function(group_no,name){
        //console.log('group > ' + group_no);
        //console.log('name > ' + name);
        vm.pagination = {current:1};
        vm.bumonName = name;
        vm.defaultFiler = group_no;
       
        var filterd = $filter('filter')(vm.allItems, { 'bumon_cd': group_no });
        //$log.debug(filterd);
        vm.totalCount = filterd.length;
        vm.datas = filterd.slice(0, vm.datasPerPage );
        
    };
    // 前年比計算
    vm.prePer = function(kin,prekin){
        if(!kin || !prekin) return 0;
        return MathRound(MathRound(kin/prekin, 3)*100,1);
    }
    // 基準売上　前年比累計 計算
    vm.prePerKjYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'kj_ur_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 実売上　前年比累計 計算
    vm.prePerJtYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'jt_ur_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引率　前年比累計 計算
    vm.prePerNbYear = function(kj,ur,pre){
        if(!kj || !ur || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target1 = [];
        var target2 = [];
        var zen_nb = 0;
        for(; i <= endM; i++){
            var column1 = 'kj_ur_kin'+ vm.zeroPudding(i);
            var column2 = 'jt_ur_kin'+ vm.zeroPudding(i);
            target1.push(column1);
            target2.push(column2);
        }
        var sumKin1 = [];
        var sumKin2 = [];
        var kj_ur = 0;
        var jt_ur = 0;
        var sb = 0;
        var pre_sb = 0;
        angular.forEach(target1, function(v){
            sumKin1.push(pre[v]);
        });
        angular.forEach(target2, function(v){
            sumKin2.push(pre[v]);
        });
        if( sumKin1.length > 0 && sumKin2.length > 0){
            kj_ur = sumKin1.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            jt_ur = sumKin2.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            sb = kj - ur;
            pre_sb = kj_ur - jt_ur;
        }

        var res = MathRound( MathRound( (sb/kj)/(pre_sb/kj_ur),3 ) *100,1);
        //console.log(res);
        return isFinite(res)?res:'***';
    }
    // 実際原価　前年比 計算
    vm.prePerGnYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'jitu_genka'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引き計算
    vm.nebiki = function(kj,ur){
        if(!kj || !ur) return 0;
        var sabun = kj - ur;
        return MathRound(MathRound(sabun/kj, 3)*100,1);
    }
    
    // 印刷モード切替
    if( vm.printMode === 'tan' ){
        vm.mode = 1;
        vm.pageGetuTanInit();
    }else if( vm.printMode === 'toku' ){
        vm.mode = 2;
        vm.pageGetuTokuInit();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('EngineersSpecifyController', EngineersSpecifyController);

  /** @ngInject */
  function EngineersSpecifyController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('EngineersSpecifyController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(2,'023');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    
    vm.options = {};
    vm.form = {value: []};
    vm.origin_data = [];

    vm.getBumonSyain = function(){
        $http({
            url: dev.api + 'api/v1/getbumonsyainshimei',
            method: 'GET',
        }).success(function(datas) {
            vm.origin_data = datas;
            var list = $filter('groupBy')(datas, 'parent_bumon_cd');
            //vm.items = [{id:'0000', text:'すべて',children:[]}];
            // 部門内でさらに部署ごとにグルーピング
            angular.forEach(list, function(v,k){
                list[k] = $filter('groupBy')(v, 'bumon_cd');
            });
            // 部署内でさらにｱｲｳｴｵごとにグルーピング
            angular.forEach(list, function(v,k){
                angular.forEach(v, function(val,key){
                    list[k][key] = $filter('groupBy')(val, 'syain_km_head');
                });
            });
            
            vm.items = [];
            // dualSelectの仕様に合わせデータを加工
            angular.forEach(list, function(v,parent_bumon_cd){
                var child = [],parent_bumon_nm,i = 0;
                angular.forEach(v ,function(val,bumon_cd){
                    var grandChild = [],bumon_nm,y = 0;
                    angular.forEach(val ,function(itm,head){
                        var lastChild = [];
                        angular.forEach(itm ,function(data){
                            lastChild.push({ id:parent_bumon_cd +':'+ bumon_cd +':'+ head +':'+ data.syain_cd, text:data.syain_nm });
                        });
                        grandChild.push({ id:parent_bumon_cd +':'+ bumon_cd +':'+ head , text:head, children:lastChild});
                        if(y === 0 ) {
                            parent_bumon_nm = itm[y].parent_bumon_nm;
                            bumon_nm = itm[y].bumon_nm;
                        }
                        y++;
                    });
                    child.push({ id:parent_bumon_cd +':'+ bumon_cd , text:bumon_nm, children:grandChild });
                    if(i === 0) 
                    i++;
                });
                vm.items.push({ id:parent_bumon_cd, text:parent_bumon_nm, children:child });
            });
            
            // dualSelectのoption
            vm.options = {
                labelAll: '一覧',
                labelSelected: '選択済みリスト',
                buttonCheckAll: 'すべて選択',
                buttonDeselectAll: 'すべて解除',
                displayProperty: 'text',
                valueProperty: 'id'
            };
        });
    };
    vm.getBumonSyain();
        
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        var year = vm.commondata.kihon.kaikei_nendo;

        $http({
            url: dev.api + 'api/v1/getengineersspecify',
            method: 'GET',
            params: {year:year,values:angular.toJson(vm.form.value)}
        }).success(function(datas) {
            $log.debug(datas);
            storage.set('printEsData', datas);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $rootScope.openWindow = $window.open('#/es-print/en', '_blank','width=1100,height=800,scrollbars=1,location=0');
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('EsPrintController', EsPrintController);

  /** @ngInject */
  function EsPrintController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 実績系帳票
    $log.debug('EsPrintController');

    var vm = this;

    vm.printMode = null;
    if( $stateParams.mode ){
        vm.printMode = $stateParams.mode;
    }
    // ゼロサプレス
    vm.zeroSuppress = function(val) {
        return val.replace(/^0+([0-9]+)/, '$1');
    }
    // ゼロパディング
    vm.zeroPudding = function(val) {
        return ('0' + val).slice(-2)
    }
    vm.title = '';
    vm.mode = 1;
    vm.allItems = [];
    vm.datas = [];
    vm.datasPerPage = 6;
    vm.shimeData = {};
    vm.nowDate = Math.round(+new Date()/1000);

    vm.pageEngneerInit = function(){
        vm.title = 'エンジニア指名状況';
        // pagenation 設定
        vm.pagination = {current:1};
        vm.currentBumonNo = 0;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var data = storage.get('printEsData');
        var printTargetData = data.datas;
        vm.shimeData = data.shime_data;
        vm.ym = vm.shimeData.getuji_ym.toString();
        vm.y = vm.ym.substring(0 ,4);
        vm.m = vm.ym.substring(4 ,6);
        
        var geoupItems = $filter('groupBy')(printTargetData, 'parent_bumon_cd');
        // グルーピングしたデータをさらに分割
        var allTemp = [];
        vm.bumonDropdown = [];
        vm.defaultFiler;
        var i = 0;
        
        angular.forEach(geoupItems, function(datas,group){
            vm.bumonDropdown.push({'text':datas[0].parent_bumon_nm, 'click': 'esprint.bumonSelect("'+ datas[0].parent_bumon_cd +'","'+ datas[0].parent_bumon_nm +'")'});
            if(i === 0) {
                vm.defaultFiler = group;
                vm.bumonName = datas[0].parent_bumon_nm;
            }
            var chunk_size = 3;
            var gpItems = $filter('groupBy')(datas, 'bumon_cd');
            //var items = $filter('orderBy')(itms, 'bumon_syokusyu');
            var y = 0;
            var lastItem = {};
            var gpItmLen = Object.keys(gpItems).length;
            var bumonTmp = [];
            // SQLで分け切れなかった同じ部門の合計値をその部門の最後の部門に移す
            angular.forEach(gpItems, function(dt,grp){
                bumonTmp.push(grp);
                if( (y+1) !== gpItmLen ){
                    for(i in dt){
                        if( dt[i].tanto_cd === '88888888' ) {
                            lastItem = dt[i];
                            dt.splice(i, 1);
                        }
                    }
                }else{
                    // 子部門が２つ以上存在する場合
                    if( lastItem && gpItmLen > 1) {
                        var r = grp.slice(-2);
                        // 親部門じゃない場合
                        if( r !== '00'){
                            gpItems[grp].push(lastItem);
                        }else{
                            //ひとつ前の部門に追加
                            gpItems[bumonTmp[y-1]].push(lastItem);
                        }
                    }
                }
               y++;
            });

            // 明細の数がn以上の場合nページに分ける
            angular.forEach(gpItems, function(dt,grp){
                var dtl = $filter('orderBy')(dt, 'syain_km');
                var itemsArr = dtl.map( function(e,i){
                    return i%chunk_size===0 ? dtl.slice(i,i+chunk_size) : null;
                }).filter(function(e){ return e; });
                //console.log(itemsArr)
                allTemp.push(itemsArr);
            });
            i++;
        });
        // 一段上にシフト(Paginationしやすいように）
        angular.forEach(allTemp, function(val){
            angular.forEach(val, function(v){
                vm.allItems.push(v);
            });
        });
        // 最初の部門のページをセット
        vm.bumonSelect(vm.defaultFiler, vm.bumonName);
        //$log.debug(vm.allItems);
 
    };
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        var start = 0;
        var end = vm.datasPerPage;
        if(newPage > 1){
            start = (newPage - 1) * vm.datasPerPage;
            end = start + start;
        }
        var filterd = $filter('filter')(vm.allItems, { 'parent_bumon_cd': vm.defaultFiler });
        vm.datas = filterd.slice(start, end);
        //$log.debug(vm.datas);
    };

    // 部門選択
    vm.bumonSelect = function(group_no,name){
        //console.log('group > ' + group_no);
        //console.log('name > ' + name);
        vm.pagination = {current:1};
        vm.parentBumonName = name;
        vm.defaultFiler = group_no;
       
        var filterd = $filter('filter')(vm.allItems, { 'parent_bumon_cd': group_no });
        //$log.debug(filterd);
        vm.totalCount = filterd.length;
        vm.datas = filterd.slice(0, vm.datasPerPage );
        
    };
    // 前年比計算
    vm.prePer = function(kin,prekin){
        if(!kin || !prekin) return 0;
        return MathRound(MathRound(kin/prekin, 3)*100,1);
    }
    // 基準売上　前年比累計 計算
    vm.prePerKjYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'kj_ur_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 実売上　前年比累計 計算
    vm.prePerJtYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'jt_ur_kin'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引率　前年比累計 計算
    vm.prePerNbYear = function(kj,ur,pre){
        if(!kj || !ur || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target1 = [];
        var target2 = [];
        var zen_nb = 0;
        for(; i <= endM; i++){
            var column1 = 'kj_ur_kin'+ vm.zeroPudding(i);
            var column2 = 'jt_ur_kin'+ vm.zeroPudding(i);
            target1.push(column1);
            target2.push(column2);
        }
        var sumKin1 = [];
        var sumKin2 = [];
        var kj_ur = 0;
        var jt_ur = 0;
        var sb = 0;
        var pre_sb = 0;
        angular.forEach(target1, function(v){
            sumKin1.push(pre[v]);
        });
        angular.forEach(target2, function(v){
            sumKin2.push(pre[v]);
        });
        if( sumKin1.length > 0 && sumKin2.length > 0){
            kj_ur = sumKin1.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            jt_ur = sumKin2.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            sb = kj - ur;
            pre_sb = kj_ur - jt_ur;
        }

        var res = MathRound( MathRound( (sb/kj)/(pre_sb/kj_ur),3 ) *100,1);
        //console.log(res);
        return isFinite(res)?res:'***';
    }
    // 実際原価　前年比 計算
    vm.prePerGnYear = function(kin,pre){
        if(!kin || !pre) return 0;
        var y = vm.y, m = vm.m, i = 4;
        var endM = vm.zeroSuppress(m)
        var target = [];
        for(; i <= endM; i++){
            var column = 'jitu_genka'+ vm.zeroPudding(i);
            target.push(column);
        }
        var sumKin = [];
        var allTotal = 0;
        angular.forEach(target, function(v){
            sumKin.push(pre[v]);
        });
        if(sumKin.length > 0){
            allTotal = sumKin.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
        }
        //return MathRound(MathRound(kin/allTotal, 3)*100,1);
        var res = MathRound(MathRound(kin/allTotal, 3)*100,1);
        return isFinite(res)?res:'***';
    }
    // 値引き計算
    vm.nebiki = function(kj,ur){
        if(!kj || !ur) return 0;
        var sabun = kj - ur;
        return MathRound(MathRound(sabun/kj, 3)*100,1);
    }
    
    // 印刷モード切替
    if( vm.printMode === 'en' ){
        vm.mode = 1;
        vm.pageEngneerInit();
    }else if( vm.printMode === 'toku' ){
        vm.mode = 2;
        vm.pageGetuTokuInit();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('ZanzaikoActionController', ZanzaikoActionController);

  /** @ngInject */
  function ZanzaikoActionController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('ZanzaikoActionController');

    var vm = this;
    vm.user = storage.get('user');
    // Menu
    $rootScope.panelSelected(4,'032');
    vm.commondata = storage.get('commondata');
    
    // 月次実施済みか、実施月は正しいかチェックして表示
    vm.init = function(){
        vm.zz_date = '';
        vm.errorMassage ='';
        //console.log($stateParams);
        if($stateParams.zz_date){
            vm.zz_date = $stateParams.zz_date;
        }
    };
    vm.init();
    
    
    // 残在庫調整実行
    vm.zanzaikoAction = function(mode){
        var zz_date = vm.zz_date;
        if(!zz_date) return;
        var check = moment(zz_date+'/01','YYYY/MM/DD').isValid();
        if(check){
            vm.errorMassage = '';
            $http({
                url: dev.api + 'api/v1/zanzaikoaction',
                method: 'POST',
                data: {'mode': mode, zz_date: zz_date}
            }).success(function(datas) {
                var massage = '残在庫調整処理をバックグランドで実行しています';
                if(Number(mode) === 2) massage = '残在庫調整処理が終了しました';
                toastr.info(massage, 'Info');
                vm.hideModal();
            });
        }else{
            vm.errorMassage = '正しい年月を入力してください。';
        }
    };
    
    // 確認modal
    vm.modal = $modal({
        templateUrl:'app/zanzaiko-action/modal.html',
        scope: $scope,
        show:false
    });
    vm.openModal = function(){
        vm.modal.$promise.then(vm.modal.show);
    };
    vm.hideModal = function(){
        vm.modal.$promise.then(vm.modal.hide);
    };
    vm.mainActionModal = function(){
        vm.openModal();
    }
    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('UserController', UserController);

  /** @ngInject */
  function UserController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('UserController');

    var vm = this;
    vm.user = storage.get('user');
    // Menu
    $rootScope.panelSelected(6,'061');

    // 個人情報データ取得
    vm.getUserData = function (tan_cd){
        $http({
            url: dev.api + 'api/v1/userall',
            method: "GET",
            params: {tan_cd: vm.user.tan_cd}
        }).success(function(data) {
            var user = data;
            vm.form.syain_cd = user.syain_cd;
            vm.form.syain_km = user.syain_km;
            vm.form.syain_nm = user.syain_nm;
            vm.form.sex_cd = user.sex_cd;
            if(user.born_day_time){
                vm.form.born_day = new Date(user.born_day_time*1000);
            }
            vm.form.yubin_no = user.yubin_no;
            vm.form.adrs1 = user.adrs1;
            vm.form.adrs2 = user.adrs2;
            vm.form.tel_no = user.tel_no;
            vm.yakusyoku_nm = user.yakusyoku_nm;
            vm.bumon_nm = user.bumon_nm;
            
            vm.pwForm.tan_cd = vm.user.tan_cd;
        });
    };
    vm.formInit = function(){
        vm.form = {};
        vm.pwForm = {};
        vm.pwError = false;
        vm.getUserData();
    }
    vm.formInit();
    // 全角カナに半角カナFilter適用
    vm.changeZen2Cana = function(){
        vm.form.syain_km = $filter('formatZen2Han')(vm.form.syain_km);
    }
    // "^[a-zA-Z0-9!-/:-@¥[-`{-~]+$"
    // パスワード正規表現
    $scope.$watch(function() { return vm.pwForm.newPassword;},
        function(newVal,oldVal) {
            if(newVal !== oldVal){
                if( vm.pwForm.newPassword ){
                    if( !vm.pwForm.newPassword.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/) ){
                        vm.pwError = true;
                    }else{
                        vm.pwError = false;
                    }
                }
            }
    }, true);
    $scope.$watch(function() { return vm.pwForm.newPasswordConform;},
        function(newVal,oldVal) {
            if(newVal !== oldVal){
                if( vm.pwForm.newPasswordConform ){
                    if( !vm.pwForm.newPasswordConform.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/) ){
                        vm.pwError = true;
                    }else{
                        if( vm.pwForm.newPasswordConform.length < 5){
                            vm.pwLenError = true;
                        }else{
                            vm.pwLenError = false;
                        }
                        vm.pwError = false;
                    }
                }
            }
    }, true);
    
    // 個人情報更新
    vm.updateSubmit = function(){
        if( vm.form.born_day && is('Date', vm.form.born_day) ){
            vm.form.born_day = moment(vm.form.born_day).format('YYYY/MM/DD');
        }
        $http({
            url: dev.api + 'api/v1/userupdate',
            method: 'POST',
            params: {'form': vm.form}
        }).success(function(datas) {
            toastr.info('個人設定を更新しました。', 'Info');
            vm.formInit();
            storage.set('user', datas)
        });
    };
    
    // PW更新
    vm.userModal = $modal({
        templateUrl:'app/user/modal.html',
        scope: $scope,
        show:false
    });
    vm.openUserModal = function(){
        vm.userModal.$promise.then(vm.userModal.show);
    };
    vm.hideUserModal = function(){
        vm.userModal.$promise.then(vm.userModal.hide);
    };
    vm.updatePwSubmit = function(){
        
        $http({
            url: dev.api + 'api/v1/userpwupdate',
            method: 'POST',
            params: {'form': vm.pwForm}
        }).success(function(datas) {
            toastr.info('パスワードを更新しました。', 'Info');
            vm.formInit();
            vm.hideUserModal();
        });
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('UrikakeController', UrikakeController);

  /** @ngInject */
  function UrikakeController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('UrikakeController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'017');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    vm.options = {};
    vm.form = {};

    // 部門DropDown
    vm.bumonDropdown = [];
    angular.forEach(vm.commondata.parentBumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'urk.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        vm.form.bumon_cd = bumon_cd;
        vm.bumon_nm = bumon_nm;
    };
    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };
    // クリア
    vm.clear = function(){
        vm.form = {};
        vm.toku_nm = '';
        vm.bumon_nm = '';
        $scope.$broadcast('angucomplete-alt:clearInput');
    }
    // 帳票生成実行
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        $http({
            url: dev.api + 'api/v1/urikakegen',
            method: 'GET',
            params: {form:angular.toJson(vm.form)}
        }).success(function(datas) {
            $log.debug(datas);
            if(datas.length === 0 || !datas){
                vm.error = 'データが存在しません'
            }else{
                storage.set('printUrkData', datas);
                if( $rootScope.openWindow ){
                    $rootScope.openWindow.focus();
                    $rootScope.openWindow.close();
                }
                $rootScope.openWindow = $window.open('#/uriake-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
            }
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('UrPrintController', UrPrintController);

  /** @ngInject */
  function UrPrintController($log, $timeout, $http, $auth, $filter, $rootScope, toExcel, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    // 見積もりの印刷
    // 仕様が微妙なので、別途分けた
    $log.debug('UrPrintController');

    var vm = this;

    vm.printMode = null;
    if( $stateParams.mode ){
        vm.printMode = $stateParams.mode;
    }

    // ページ初期化
    vm.datasPerPage = 1;
    vm.uriage_origin = [];
    
    vm.subInit = function(){
        vm.title = '作業明細';
    }
    vm.orderByMin = function(arr) {
        return $filter('orderBy')(arr, '-sg_day_time');
    }

    vm.pageEstimateInit = function(editData){
        // pagenation 設定
        vm.datasPerPage = 1;
        vm.chunk_size = 10;
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        vm.zei_ritu = vm.commondata.taxrate;
        var printTargetData = storage.get('uriagePrintTargetData');
        vm.uriage_origin = angular.copy(printTargetData);
        
        //vm.uriage = printTargetData.uriage;
        vm.order = printTargetData.order;
        var uriageDtl = [];
        if( !editData ){
            uriageDtl = $filter('orderBy')(printTargetData.uriageDtl, 'sg_day_time');
            vm.subInit();
            if( !vm.order.toku_tanto_nm ){
                vm.keisho = '御中';
            }else{
                vm.keisho = '様';
            }
            vm.toku_nm = vm.order.toku_nm;
            vm.toku_tanto_nm = vm.order.toku_tanto_nm;
            vm.toku_bumon_nm = vm.order.toku_bumon_nm;
            vm.hin_nm = vm.order.hin_nm;
            vm.ju_no = vm.order.ju_no;
            vm.ju_day = vm.order.ju_day;
            vm.ju_day_time = vm.order.ju_day_time;
            vm.gyomu_nm = vm.order.gyomu_nm;
            vm.gyomu_kb = vm.order.gyomu_kb;
            
        }else{
            uriageDtl = editData;
            
            // 合計反映
            var kj_ur_kinArr = [];
            angular.forEach(uriageDtl,function(v,k){
                kj_ur_kinArr.push(v.kin);
            });
            var kj_ur_kin = kj_ur_kinArr.reduce(function(pre, curr) {
                return Number(pre) + Number(curr);
            });
            // 小計
            angular.forEach(uriageDtl,function(v,k){
                uriageDtl[k].form_editForm.kj_ur_kin = kj_ur_kin;
                uriageDtl[k].form_editForm.zei_kin = Math.floor( kj_ur_kin*vm.zei_ritu );
            });
            // 値引き後
            angular.forEach(uriageDtl,function(v,k){
                var kin = Number( uriageDtl[k].form_editForm.kj_ur_kin ) - Number( uriageDtl[k].form_editForm.nebiki_kin );
                uriageDtl[k].form_editForm.jt_ur_kin = kin;
                uriageDtl[k].form_editForm.zei_kin = Math.floor( kin*vm.zei_ritu );
            });
        }
        
        // 伝票毎合計金額
        vm.sumKinGrp = function(itm){
            var kinArr = []
            angular.forEach(itm,function(v){
                kinArr.push(Number(v.kin));
            });
            return kinArr.reduce(function(pre, curr) {
                return pre + curr;
            });
        };
        
        // 作業伝票毎の伝票合計金額
        vm.uriageDtlCount = $filter('groupBy')(uriageDtl, 'sg_no');
        angular.forEach(vm.uriageDtlCount, function(item, sg_no){
            var kin = vm.sumKinGrp(item);
            angular.forEach(uriageDtl, function(v, k){
                if( v.sg_no === sg_no ){
                    uriageDtl[k].den_kei = kin;
                }
            });
        });
        
        
        
        vm.uriageDtl = uriageDtl;
        //console.log(uriageDtl);
        vm.kihon = vm.commondata.kihon;
        vm.nowDate = Math.round(+new Date()/1000);
        
        
        vm.urDtl = [];
        var chunk_size = vm.chunk_size;
        // 明細の数がn以上の場合nページに分ける
        if( uriageDtl.length > chunk_size ){
            var uriageDtlArr = uriageDtl.map( function(e,i){
                return i%chunk_size===0 ? uriageDtl.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            // 数の足りていない配列に追加
            /*angular.forEach(uriageDtlArr, function(v,k){
                while (v.length < chunk_size) {
                    v.push({});
                }
                uriageDtlArr[k] = v;
            });
            */
            vm.urDtl = uriageDtlArr;
        }else{
            // 数の足りていない配列に追加
            /*
            while (uriageDtl.length < chunk_size) {
                uriageDtl.push({});
            }
            */
            //console.log(uriageDtl);
            vm.urDtl.push(uriageDtl);
        }
        vm.totalDatas = vm.urDtl.length;
        

        $log.debug(vm.urDtl);
        // 作業分類ごとの解析
        vm.sg_bunrui_type = [{name:'① スタジオ・その他',sum_cd:1},{name:'② 人件費',sum_cd:2},{name:'③ 実質請求(テープ代他)',sum_cd:3}];
        var allItems = $filter('groupBy')(uriageDtl, 'sg_bunrui_sum_cd');
        var bunrui = [];
        angular.forEach(allItems, function(val,key){
            var bun = {};
            var kin = [];
            var total = 0;
            angular.forEach(val, function(v){
                kin.push(v.kin);
           });
           total = kin.reduce(function(pre, curr) {
               return Number( pre ) + Number( curr );
           });
           bun.sum_cd = key;
           bun.total = total;
           bunrui.push(bun)
        });
        var allTotal = 0;
        angular.forEach(bunrui, function(val){
            var kin = [];
            angular.forEach(bunrui, function(v){
                kin.push(v.total);
            });
            allTotal = kin.reduce(function(pre, curr) {
                return Number( pre ) + Number( curr );
            });
            //console.log(allTotal);
            angular.forEach(vm.sg_bunrui_type, function(v,k){
                if(Number(val.sum_cd) === Number(v.sum_cd)){
                    vm.sg_bunrui_type[k].total = val.total;
                    vm.sg_bunrui_type[k].allTotal = allTotal;
                    vm.sg_bunrui_type[k].per = MathRound(allTotal/val.total,3);
                }
            });
            
        });
        //console.log(vm.sg_bunrui_type);
        // 業務区分名割り当て
        vm.setGyoumuName = function(){
            angular.forEach(vm.commondata.gyomu,function(v,k){
                if(vm.gyomu_kb === v.gyomu_kb){
                    vm.gyomu_nm = v.gyomu_nm;
                }
            });
        }
        vm.setGyoumuName();
    };
    
    // 編集モード
    vm.printEdit = false;
    vm.editUriage = function(){
        
        vm.ju_day = new Date(vm.ju_day_time*1000);
        angular.forEach(vm.urDtl,function(value,key){
            angular.forEach(value,function(v,k){
                vm.urDtl[key][k].sg_day = new Date(v.sg_day_time*1000);
            });
        });
        angular.forEach(vm.urDtl,function(value,key){
            angular.forEach(value,function(v,k){
                if(v.time_fl){
                    vm.urDtl[key][k].stt_tm = v.stt_tm_str;
                    vm.urDtl[key][k].end_tm = v.end_tm_str;
                }
                
            });
        });
        
        // 部門
        vm.bumonDropdown = [{'text':'－－', 'click': 'urprint.bumonSelect()'}];
        angular.forEach(vm.commondata.sgytbumon ,function(v,k){
            vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'urprint.bumonSelect(prKey,sgNo,idx,"'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
        });
        // 部門選択
        vm.bumonSelect = function(prKey,sgNo,idx,bumon_cd, bumon_nm){
            if(bumon_cd && bumon_nm){
                angular.forEach(vm.urDtl[prKey], function(v,k){
                    if(v.sg_no === sgNo){
                        vm.urDtl[prKey][k].sg_bmn_cd = bumon_cd;
                        vm.urDtl[prKey][k].sg_bmn_nm = bumon_nm;
                    }
                });
            }else{
                angular.forEach(vm.urDtl[prKey], function(v,k){
                    if(v.sg_no === sgNo){
                        vm.urDtl[prKey][k].sg_bmn_cd = '';
                        vm.urDtl[prKey][k].sg_bmn_nm = '';
                    }
                });
            }
        };
        
        // 業務区分
        vm.gyomuDropdown = [{'text':'－－', 'click': 'urprint.kubunSelect()'}];
        angular.forEach(vm.commondata.gyomu ,function(v,k){
            vm.gyomuDropdown.push({'text':v.gyomu_kb + ' : '+ v.gyomu_nm, 'click': 'urprint.kubunSelect("'+ v.gyomu_kb +'","'+ v.gyomu_nm +'")'});
        });
        // 業務区分選択
        vm.kubunSelect = function(gyomu_kb, gyomu_nm){
            if(gyomu_kb && gyomu_nm){
                vm.gyomu_nm = gyomu_nm;
                vm.gyomu_kb = gyomu_kb;
            }else{
                vm.gyomu_nm = '';
                vm.gyomu_kb = '';
            }
        };
        
        // 単価/単位計算
        vm.tankaChange = function(prKey,sgNo,idx){
            //console.log('tankaChange : ' + sgNo);
            angular.forEach(vm.urDtl[prKey], function(v,k){
                if(sgNo === v.sg_no){
                    //console.log(v);
                    if( ( parseFloat(v.suryo_1) !== 0 && !v.suryo_2 ) || ( parseFloat(v.suryo_1) !== 0 && parseFloat(v.suryo_2) === 0) ){
                        //console.log('target 1');
                        vm.urDtl[prKey][k].kin = v.suryo_1*v.tanka;
                    }else if( (parseFloat(v.suryo_1) !== 0 && v.suryo_2) || (parseFloat(v.suryo_1) !== 0 && parseFloat(v.suryo_2) !== 0) ){
                        //console.log('target 2');
                        vm.urDtl[prKey][k].kin = (v.suryo_1*v.suryo_2)*v.tanka;
                    }else if( (parseFloat(v.suryo_1) === 0 && v.suryo_2) || ( parseFloat(v.suryo_1) === 0 && parseFloat(v.suryo_2) !== 0) ){
                        //console.log('target 3');
                        vm.urDtl[prKey][k].kin = v.suryo_2*v.tanka;
                    }
                }
            });
            vm.chengeSumKin(prKey,sgNo,idx);
        };
        // 伝票毎合計計算
        vm.chengeSumKin = function(prKey,sgNo,idx){
            var base = angular.copy(vm.uriageDtl);
            var filtered = $filter('filter')(base, {'sg_no': sgNo});
            
            var kinArr = []
            angular.forEach(filtered,function(v){
                kinArr.push(v.kin)
            });
            // 合計
            var kei = kinArr.reduce(function(pre, curr) {
                return pre + curr;
            });
            // 明細毎に作業伝票合計値をつける
            angular.forEach(vm.urDtl[prKey],function(v,k){
                if(sgNo === v.sg_no){
                    vm.urDtl[prKey][k].den_kei = kei;
                }
            });
            // 合計反映
            var kj_ur_kinArr = [];
            angular.forEach(vm.urDtl,function(value,key){
                angular.forEach(value,function(v,k){
                    kj_ur_kinArr.push(v.kin);
                });
            });
            var kj_ur_kin = kj_ur_kinArr.reduce(function(pre, curr) {
                return pre + curr;
            });
            //console.log(kj_ur_kin);
            // 小計
            var urDtl=[];
            angular.forEach(vm.urDtl,function(value,key){
                angular.forEach(value,function(v,k){
                    vm.urDtl[key][k].form_editForm.kj_ur_kin = kj_ur_kin;
                    vm.urDtl[key][k].form_editForm.zei_kin = Math.floor( kj_ur_kin*vm.zei_ritu );
                    urDtl.push(vm.urDtl[key][k]);
                });
            });
            // カテゴリ毎合計値再計算
            var allItems = $filter('groupBy')(urDtl, 'sg_bunrui_sum_cd');
            var bunrui = [];
            angular.forEach(allItems, function(val,key){
                var bun = {};
                var kin = [];
                var total = 0;
                angular.forEach(val, function(v){
                    kin.push(v.kin);
               });
               total = kin.reduce(function(pre, curr) {
                   return pre + curr;
               });
               bun.sum_cd = key;
               bun.total = total;
               bunrui.push(bun)
            });
            var allTotal = 0;
            angular.forEach(bunrui, function(val){
                var kin = [];
                angular.forEach(bunrui, function(v){
                    kin.push(v.total);
                });
                allTotal = kin.reduce(function(pre, curr) {
                    return pre + curr;
                });
                //console.log(allTotal);
                angular.forEach(vm.sg_bunrui_type, function(v,k){
                    if(Number(val.sum_cd) === Number(v.sum_cd)){
                        vm.sg_bunrui_type[k].total = val.total;
                        vm.sg_bunrui_type[k].allTotal = allTotal;
                        vm.sg_bunrui_type[k].per = MathRound(allTotal/val.total,3);
                    }
                });
                
            });
            vm.nebikiChange(prKey,sgNo,idx);
        };
        
        // 値引き
        vm.nebikiChange = function(prKey,sgNo,idx){
            var urDtl=[];
            angular.forEach(vm.urDtl,function(value,key){
                angular.forEach(value,function(v,k){
                    var kin = vm.urDtl[key][k].form_editForm.kj_ur_kin - vm.urDtl[key][k].form_editForm.nebiki_kin;
                    vm.urDtl[key][k].form_editForm.jt_ur_kin = kin;
                    vm.urDtl[key][k].form_editForm.zei_kin = Math.floor( kin*vm.zei_ritu );
                });
            });
        }
        
        // 開始時間
        vm.sttTmChange = function(prKey,sgNo,idx){
            angular.forEach(vm.urDtl[prKey],function(v,k){
                if(sgNo === v.sg_no && k === idx){
                    var rt = $rootScope.fromToConvH(v.stt_tm, v.end_tm);
                    $log.debug(rt);
                    if(rt.time < -0.1){
                        toastr.warning('時間入力が間違っています', 'Warning');
                    }else{
                        vm.urDtl[prKey][k].suryo_1 = rt.time;
                        vm.urDtl[prKey][k].stt_tm = rt.fromStr;
                        vm.urDtl[prKey][k].stt_tm_str = rt.fromStr.slice(0,2)+':'+rt.fromStr.slice(2,4);
                        //vm.urDtl[prKey][k].end_tm_str = v.end_tm;
                        //vm.urDtl[prKey][k].end_tm = rt.toStr;
                        vm.tankaChange(prKey,sgNo,idx);
                        vm.chengeSumKin(prKey,sgNo,idx);
                    }
                }
            });
        }
        // 終了時間
        vm.endTmChange = function(prKey,sgNo,idx){
            angular.forEach(vm.urDtl[prKey],function(v,k){
                if(sgNo === v.sg_no && k === idx){
                    var rt = $rootScope.fromToConvH(v.stt_tm, v.end_tm);
                    $log.debug(rt);
                    if(rt.time < -0.1){
                        toastr.warning('時間入力が間違っています', 'Warning');
                    }else{
                        //console.log('v.end_tm : '+v.end_tm);
                        //console.log('rt.toStr : '+rt.toStr);
                        vm.urDtl[prKey][k].suryo_1 = rt.time;
                        vm.urDtl[prKey][k].end_tm = rt.toStr;
                        vm.urDtl[prKey][k].end_tm_str = rt.toStr.slice(0,2)+':'+rt.toStr.slice(2,4);
                        //vm.urDtl[prKey][k].stt_tm_str = v.stt_tm;
                        //vm.urDtl[prKey][k].end_tm = rt.fromStr;
                        vm.tankaChange(prKey,sgNo,idx);
                        vm.chengeSumKin(prKey,sgNo,idx);
                    }
                }
            });
        }
        
        // 数量変更
        vm.suryo1Change = function(prKey,sgNo,idx){
            vm.tankaChange(prKey,sgNo,idx);
            vm.chengeSumKin(prKey,sgNo,idx);
        }
        // 数量変更
        vm.suryo2Change = function(prKey,sgNo,idx){
            vm.tankaChange(prKey,sgNo,idx);
            vm.chengeSumKin(prKey,sgNo,idx);
        }
        
        // Excel Export
        vm.exportToExcel = function(tableId){
            var exportHref = toExcel.tableToExcel(tableId,'sheet name');
            $timeout(function(){
                location.href = exportHref;
            },100);
        }
        
        vm.printEdit = true;
    }
    
    // 編集モード切替
    vm.execUriage = function(){
        // 時間変更あった場合にカレンダ用に変換しておく
        vm.ju_day_time = moment(new Date(vm.ju_day)).unix();
        vm.ju_day = moment(new Date(vm.ju_day)).format('YYYY/MM/DD');
        angular.forEach(vm.urDtl,function(value,key){
            angular.forEach(value,function(v,k){
                vm.urDtl[key][k].sg_day_time = moment(new Date(v.sg_day)).unix();
                vm.urDtl[key][k].sg_day = moment(new Date(v.sg_day)).format('YYYY/MM/DD');
            });
        });
        vm.printEdit = false;
        var items = angular.copy(vm.urDtl);
        var newItems = [];
        angular.forEach(items, function(val, key){
            angular.forEach(val, function(v, k){
                newItems.push(v);
            });
        });
        vm.pageEstimateInit(newItems);
    }
    // 編集リセット
    vm.editReset = function(){
        vm.pageEstimateInit(null);
        vm.printEdit = false;
    }
    
    // 業務区分名
    vm.getGyomuName = function(cd){
        var name;
        angular.forEach(vm.commondata.gyomu, function(v,k){
            if(v.gyomu_kb === cd ){
                name = v.gyomu_nm;
            }
        });
        return name;
    };
    
    // 伝票毎合計金額
    vm.sumKin = function(itm){
        var kinArr = []
        angular.forEach(itm,function(v){
            kinArr.push(Number(v.kin));
        });
        return kinArr.reduce(function(pre, curr) {
            return pre + curr;
        });
    };
    // 小計
    vm.sumSubTotal = function(itm){
        var kinArr = [];
        //console.log(itm);
        angular.forEach(itm,function(val){
            angular.forEach(val,function(v){
                //kinArr.push(v.kin)
            });
        });
        return kinArr.reduce(function(pre, curr) {
            return pre + curr;
        });
    };
    
    // 行Noを新しくする
    vm.gyoNoReNo = function(items){
        angular.forEach(items, function(val, key){
            items[key].gyo_no = key+1;
        });
        return items;
    }

    // Table 親Row削除
    vm.parentRowDelete = function(prKey, sgNo){
        var base = angular.copy(vm.urDtl[prKey]);
        var filtered = $filter('filter')(base, {'sg_no': '!'+sgNo});
        vm.urDtl[prKey] = filtered;
        if( vm.urDtl[prKey].length === 0 ){
            vm.urDtl.splice(prKey , 1);
            vm.totalDatas = vm.urDtl.length;
        }
        var items = angular.copy(vm.urDtl);
        var newItems = [];
        angular.forEach(items, function(val, key){
            angular.forEach(val, function(v, k){
                newItems.push(v);
            });
        });
        vm.pageEstimateInit(vm.gyoNoReNo(newItems));
    };
    // Table 子Row削除
    vm.rowDelete = function(prKey, sgNo, gyoNo){
        var base = angular.copy(vm.urDtl[prKey]);
        var index;
        angular.forEach(base, function(v, k){
            if( v.sg_no === sgNo && v.gyo_no === gyoNo ) index = k;
        });
        base.splice(index , 1);
        vm.urDtl[prKey] = base;
        if( vm.urDtl[prKey].length === 0 ){
            vm.urDtl.splice(prKey , 1);
            vm.totalDatas = vm.urDtl.length;
        }
        var items = angular.copy(vm.urDtl);
        var newItems = [];
        angular.forEach(items, function(val, key){
            angular.forEach(val, function(v, k){
                newItems.push(v);
            });
        });
        vm.pageEstimateInit(vm.gyoNoReNo(newItems));
    };
    // Row 追加 
    vm.addRow = function(prKey, sgNo){
        var base = angular.copy(vm.urDtl[prKey]);
        var filtered = $filter('filter')(base, {'sg_no': sgNo});
        var lastItem = filtered[filtered.length-1];
        var addRowItem = {};
        
        angular.forEach(lastItem, function(v, k){
            if( k === 'form_editForm' || k === 'sg_no' || k === 'gyo_no' || k === 'gr_arr_no'
                || k === 'nh_no' || k === 'sg_day' || k === 'sg_day_time' || k === 'stt_tm'
                || k === 'stt_tm_str' || k === 'end_tm' || k === 'end_tm_str' ){
                addRowItem[k] = v;
            }else{
                addRowItem[k] = '';
            }
        });
        base.push(addRowItem);
        base = $filter('orderBy')(base, 'gyo_no');
        //console.log(base);
        vm.urDtl[prKey] = base;
        var items = angular.copy(vm.urDtl);
        var newItems = [];
        angular.forEach(items, function(val, key){
            angular.forEach(val, function(v, k){
                newItems.push(v);
            });
        });
        vm.pageEstimateInit(vm.gyoNoReNo(newItems));
    };
    
    // Table Row 複写
    vm.rowCopy = function(prKey, sgNo, gyoNo){
        var base = angular.copy(vm.urDtl[prKey]);
        var index;
        angular.forEach(base, function(v, k){
            if( v.sg_no === sgNo && v.gyo_no === gyoNo ) index = k;
        });
        var newItems = angular.copy(base[index]);
        base.splice(index+1, 0, newItems);
        
        vm.urDtl[prKey] = angular.copy(base);
        var items = angular.copy(vm.urDtl);
        var newItems = [];
        angular.forEach(items, function(val, key){
            angular.forEach(val, function(v, k){
                newItems.push(v);
            });
        });
        vm.pageEstimateInit(vm.gyoNoReNo(newItems));
    };
    
    
    // 印刷モード切替
    if( vm.printMode === 'estimate' ){
        vm.pageEstimateInit();
    }else if( vm.printMode === 'sgyt' ){
        vm.pageSgYtInit();
    }

    vm.goPrint = function(){
        $window.print();
    };

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.totalDatas = vm.invoiceData.length;
        vm.datas = vm.invoiceData.slice(pageNumber-1, (pageNumber-1) + vm.datasPerPage );
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('TokuisakiMotoController', TokuisakiMotoController);

  /** @ngInject */
  function TokuisakiMotoController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('TokuisakiMotoController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'014');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    vm.options = {};
    vm.form = {};

    // 部門DropDown
    vm.bumonDropdown = [];
    angular.forEach(vm.commondata.parentBumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'tkm.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        vm.form.bumon_cd = bumon_cd;
        vm.bumon_nm = bumon_nm;
    };
    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };
    
    // クリア
    vm.clear = function(){
        vm.form = {};
        vm.toku_nm = '';
        vm.bumon_nm = '';
        $scope.$broadcast('angucomplete-alt:clearInput');
    }
    
    // 帳票生成実行
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        $http({
            url: dev.api + 'api/v1/tokumotogen',
            method: 'GET',
            params: {form:angular.toJson(vm.form)}
        }).success(function(datas) {
            $log.debug(datas);
            if(datas.length === 0 || !datas){
                vm.error = 'データが存在しません'
            }else{
                storage.set('printTkmtData', datas);
                if( $rootScope.openWindow ){
                    $rootScope.openWindow.focus();
                    $rootScope.openWindow.close();
                }
                $rootScope.openWindow = $window.open('#/tkmt-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
            }
            //vm.form = {value: []};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('PrintController', PrintController);

  /** @ngInject */
  function PrintController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('PrintController');

    var vm = this;

    vm.printMode = null;
    if( $stateParams.mode ){
        vm.printMode = $stateParams.mode;
    }

    // ページ初期化
    vm.datasPerPage = 1;
    vm.pageInvoiceInit = function(){
        // pagenation 設定
        vm.datasPerPage;

        var printTargetData = storage.get('printTargetData');
        var invoiceData = printTargetData.invoice;
        vm.invoiceData = invoiceData; 
        vm.typeCheck = printTargetData.typeCheck;
        vm.kozaData = printTargetData.koza;
        vm.kihon = printTargetData.kihon;
        vm.totalDatas = vm.invoiceData.length;

        vm.datas = vm.invoiceData.slice(0, vm.datasPerPage);

        $log.debug(vm.datas);
        vm.pagination = {current:1};

        vm.inviceMode = false;
        vm.inviceDtlMode = false;
        vm.nhinMode = false;
        angular.forEach(vm.typeCheck, function(type){
            if(type === '1')vm.inviceMode = true;
            if(type === '2')vm.inviceDtlMode = true;
            if(type === '3')vm.nhinMode = true;
        });

        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        /*
         * ★★★SC請求書について
         * まず左上枠、左上銀行、右上枠（Noと件数表記含）
         * 左下枠、左下銀行、右下枠（Noと件数表記含）と分けるとします。
         * 左上枠そのまま、左下銀行は左へ10mm、上へ5mm
         * 右上枠は値引き額と差引き金額の欄はいらず、差引金額の金額をご利用金額に表記させて欲しい。
         * そして消費税とご請求で基本的には３つのみ。
         * （AOI Proだけ特別値引きがはいる。　段は今の6段から5段へ）
         * 枠の移動は1段省いた10mm分を件数表記の所を10mm上へ
         * 左下枠は30mm下、左下銀行は30mm下、10mm左
         * 右下枠は右上とどうようの表記段組みにし、30mm下（但し1段10mm省くので実質20mm下）
         */
    };

    // 作業予定プリント
    vm.pageSgYtInit = function(){
        // 使いましデータ取得
        vm.commondata = storage.get('commondata');
        var printTargetData = storage.get('printTargetData');
        $log.debug(printTargetData);
        $log.debug(vm.commondata);
        vm.sgyt = printTargetData.sgyt;
        vm.order = printTargetData.order;
        vm.memo = printTargetData.memo;
        var sgytDtl = printTargetData.sgytDtl;
        vm.kihon = vm.commondata.kihon;


        var chunk_size = 20;
        vm.sgytDtl = [];
        // 明細の数が20以上の場合nページに分ける
        if( sgytDtl.length > chunk_size ){
            var sgytDtlArr = sgytDtl.map( function(e,i){
                return i%chunk_size===0 ? sgytDtl.slice(i,i+chunk_size) : null;
            }).filter(function(e){ return e; });
            // 数の足りていない配列に追加
            angular.forEach(sgytDtlArr, function(v,k){
                while (v.length < chunk_size) {
                    v.push({});
                }
                sgytDtlArr[k] = v;
            });
            vm.sgytDtl = sgytDtlArr;
        }else{
            // 数の足りていない配列に追加
            while (sgytDtl.length < chunk_size) {
                sgytDtl.push({});
            }
            //console.log(sgytDtl);
            vm.sgytDtl.push(sgytDtl);
        }
    };

    // 印刷モード切替
    if( vm.printMode === 'invoice' ){
        vm.pageInvoiceInit();
    }else if( vm.printMode === 'sgyt' ){
        vm.pageSgYtInit();
    }

    vm.goPrint = function(){
        $window.print();
    };

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.totalDatas = vm.invoiceData.length;
        vm.datas = vm.invoiceData.slice(pageNumber-1, (pageNumber-1) + vm.datasPerPage );
    }
    
    // 納品書・納品書控え切り替え
    vm.initMode = function(mode) {
        if(mode === 1) vm.nhMode1 = true;
        if(mode === 2) vm.nhMode2 = true;
        if(mode === 3) vm.nhMode3 = true;
    }
    
    // 差引き金額(ご利用金額)
    vm.setSasyhikiKin = function(item){
        var kin = item.kijun_kn;
        if( item.nebiki_kn > 0 || item.tokubiki_kn > 0){
            kin = kin -(item.nebiki_kn+item.tokubiki_kn)
        }
        return kin;
    }
    
    /* PDFにする画像加工が思ったより大変なので普通のHTMLプリントに変更
     * 未使用
    vm.printPDF = function(){
        var element = angular.element('#print-area');
        //console.log(element);
        var pdf = new jsPDF('p','px','letter');
        //console.log(element, 'height', element[0].offsetHeight);
        var specialElementHandlers = {
            '#print-area': function(element, renderer){
                return true;
            }
        };
        //angular.forEach(element, function(value, key) {
            pdf.fromHTML(element[0],10, 10, {
                'elementHandlers': specialElementHandlers
            });
        //});
        pdf.save('test.pdf');
        //pdf.addHTML(element, 50, 50, {
        //pdf.fromHTML(element, 15, 15, {
            //'pagesplit':true,
            //'height': element.offsetHeight,
          //  'elementHandlers': specialElementHandlers
        //},function(dispose) {
        //    pdf.save('test.pdf');
        //});
    };
    */

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('PaymentController', PaymentController);

  /** @ngInject */
  function PaymentController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('PaymentController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'013');

    // Tooltip
    vm.editTooltipText1 = {'title': '-新規登録-<br />この得意先の未入金一覧から入金の新規登録を行います'};
    //vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};

    // モード切替
    vm.mode = 'data';
    if($stateParams.mode !== 'data'){
        vm.mode = $stateParams.mode;
    }

    /*
     * 発行済み請求書・納品書を検索・プレビュー（印刷）するモード
     * 未発行請求書を発行するモード
     */

    // 検索フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.toku_nm = '';
        vm.form.toku_cd = null;
        vm.mode = 1;
        vm.detai = {};
        vm.detailForm = {};

        // 1年前の1/1を基準とする
        var fromBaseDate = new Date();
        fromBaseDate.setYear(fromBaseDate.getFullYear()-1);
        vm.form.nkDateFrom = new Date(fromBaseDate.getFullYear(), 1-1,1);
        vm.form.nkDateTo = null;
        vm.form.skDateFrom = null;
        vm.form.skDateTo = null;

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        getResultsPage(1);
        vm.pagination = {current:1};

    };
    vm.formInit();

    // 使いまわしデータ取得
    vm.commondata = storage.get('commondata');
    // 入金種別
    vm.nktype = [
        {'nk_sb_nm':'振込み','nk_sb':1},
        {'nk_sb_nm':'手形','nk_sb':2},
        {'nk_sb_nm':'その他','nk_sb':3}
    ];

    // 入金種別Dropdown
    vm.nkTypeDropdown = [];
    angular.forEach(vm.nktype ,function(v){
        vm.nkTypeDropdown.push({'text':v.nk_sb_nm, 'click': 'payment.nkTypeSelect("'+ v.nk_sb +'","'+ v.nk_sb_nm +'")'});
    });
    // 入金種別選択
    vm.nkTypeSelect = function(nk_sb, nk_sb_nm){
        vm.nk_sb_nm = nk_sb_nm;
        vm.form.nk_sb = nk_sb;
    };

    // 入金種別選択名称取得
    vm.SetSeikyuTaniNm = function(nk_sb){
        var name;
        angular.forEach(vm.nktype ,function(v){
            if(Number(v.nk_sb) === Number(nk_sb)) name = v.nk_sb_nm;
        });
        return name;
    }

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.nkDateFrom && is('Date', vm.form.nkDateFrom) ){
                vm.form.nkDateFrom = moment(vm.form.nkDateFrom).format('YYYY/MM/DD');
            }
            if( vm.form.nkDateTo && is('Date', vm.form.nkDateTo) ){
                vm.form.nkDateTo = moment(vm.form.nkDateTo).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/payment',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    /***************************************************** 新規・編集 Modal *********************************************/

    // 入金明細確認Modal
    vm.detailModal = $modal({
        templateUrl:'app/payment/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    // 詳細取得実行
    vm.addPaymentDetail = function(mode, item){
        vm.detailForm = {};
        vm.tokuDtl = {};
        vm.detail = {};
        vm.skUrDetail = {};
        vm.uriageDtl = [];
        vm.mode = mode;
        if(mode === 1){
            if(item){
                // 新規得意先指定モード
                vm.getUrDtlData(item.toku_cd);
                vm.detailForm.toku_cd = item.toku_cd;
            }else{
                // 新規得意先選択モード
                vm.detailForm.nk_bmn_cd = null;
                vm.detailForm.toku_cd = null;
                vm.detailForm.bank_cd = null;
                vm.detailForm.nk_tan_cd = null;
                vm.detailForm.tekiyo = null;
                vm.detailForm.nk_sb = null;
                vm.openDetailModal();
            }
        }else{
            // 編集モード
            vm.getPaymentDtlData(item.nk_no);
            vm.tokuDtl = item;
            // form
            if(item.nk_day_time > 0){
               vm.detailForm.nk_day = new Date(item.nk_day_time*1000);
            }
            vm.detailForm.nk_no = item.nk_no;
            vm.detailForm.nk_bmn_cd = item.nk_bmn_cd;
            vm.detailForm.toku_cd = item.toku_cd;
            vm.detailForm.nk_koza_cd = item.nk_koza_cd;
            vm.detailForm.nk_tan_cd = item.nk_tan_cd;
            vm.detailForm.tekiyo = item.tekiyo;
            vm.detailForm.nk_sb = item.nk_sb;

            vm.detail.nk_sb_nm = item.nk_sb_nm;
            vm.detail.bank_fl_nm = item.bank_fl_nm;
            vm.detail.nk_bmn_nm = item.nk_bmn_nm;
            vm.detail.nk_tan_nm = item.nk_tan_nm;

            // 入金種別
            var nk_sb_nm;
            angular.forEach(vm.nktype ,function(v){
                if(Number(vm.tokuDtl.nk_sb) === Number(v.nk_sb)) nk_sb_nm = v.nk_sb_nm;
            });
            vm.detail.nk_sb_nm = nk_sb_nm;


        }

    };

    // Modal 入金種別Dropdown
    vm.modalNkTypeDropdown = [];
    angular.forEach(vm.nktype ,function(v){
        vm.modalNkTypeDropdown.push({'text':v.nk_sb_nm, 'click': 'payment.modalNkTypeSelect("'+ v.nk_sb +'","'+ v.nk_sb_nm +'")'});
    });
    // Modal 入金種別選択
    vm.modalNkTypeSelect = function(nk_sb, nk_sb_nm){
        vm.detail.nk_sb_nm = nk_sb_nm;
        vm.detailForm.nk_sb = nk_sb;
    };
    // 得意先検索実行
    vm.modakTokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisakicodename',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };
    // Modal 得意先選択
    vm.modalTokuisakiSelected = function(selected) {
        if (selected) {
            vm.detailForm = {};
            vm.detailForm.toku_cd = selected.originalObject.toku_cd;
            vm.getUrDtlData(vm.detailForm.toku_cd, true);
        }
    };

    // 入金口座DropDown生成
    vm.makeNkKozaDropdown = function(){
        // Modal 入金口座Dropdown
        vm.modalNkKozaDropdown = [];
        angular.forEach(vm.nkKoza ,function(v){
            vm.modalNkKozaDropdown.push({'text':v.bank_fl_nm, 'click': 'payment.modalNkKozaSelect("'+ v.koza_cd +'","'+ v.bank_fl_nm +'")'});
        });
    }
    // Modal 入金口座選択
    vm.modalNkKozaSelect = function(koza_cd, bank_fl_nm){
        vm.detail.bank_fl_nm = bank_fl_nm;
        vm.detailForm.nk_koza_cd = koza_cd;
    };
    // 入金部門DropDown生成
    vm.makeNkBumonDropdown = function(){
        // Modal 入金部門Dropdown
        vm.modalNkBumonDropdown = [];
        angular.forEach(vm.nkBumon ,function(v){
            vm.modalNkBumonDropdown.push({'text':v.bumon_nm, 'click': 'payment.modalNkBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
        });
    }
    // Modal 入金部門選択
    vm.modalNkBumonSelect = function(bumon_cd, bumon_nm){
        vm.detail.nk_bmn_nm = bumon_nm;
        vm.detailForm.nk_bmn_cd = bumon_cd;
        vm.getNkTanto(bumon_cd);
    };
    // 入金担当取得
    vm.modalNkTantoDropdown = [];
    vm.getNkTanto = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.modalNkTantoDropdown = [];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.modalNkTantoDropdown.push({'text':v.syain_nm, 'click': 'payment.modakNkTantoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 入金担当選択
    vm.modakNkTantoSelect = function(syain_cd, syain_nm){
        vm.detailForm.nk_tan_cd = syain_cd;
        vm.detail.nk_tan_nm = syain_nm;
    };
    // 入金明細データ取得
    vm.getPaymentDtlData = function(nk_no){
        $http({
            url: dev.api + 'api/v1/paymentdetail',
            method: 'GET',
            params: { nk_no : nk_no }
        }).success(function(data) {
            $log.debug(data);
            vm.skUrDetail = data.uriageDtl;
            vm.nkKoza = data.koza;
            vm.nkBumon = data.nkBumon;
            vm.openDetailModal();
            vm.makeNkKozaDropdown();
            vm.makeNkBumonDropdown();

            // 各合計額
            vm.nkSum = vm.paymentNkSum();
            vm.tsSum = vm.paymentTsSum();
            vm.ztSum = vm.paymentZtSum();
            vm.npSum = vm.notPaymentSum();

        });
    };
    // 未入金売上明細データ取得(新規モード)
    vm.getUrDtlData = function(toku_cd, modal){
        $http({
            url: dev.api + 'api/v1/notpaymentdetail',
            method: 'GET',
            params: { toku_cd : toku_cd }
        }).success(function(data) {
            $log.debug(data);
            vm.skUrDetail = data.uriageDtl;
            vm.nkKoza = data.koza;
            vm.tokuDtl = data.tokuDtl;
            vm.nkKoza = data.koza;
            vm.nkBumon = data.nkBumon;

            vm.makeNkKozaDropdown();
            vm.makeNkBumonDropdown();
            // modalが出ていない場合
            if(!modal) vm.openDetailModal();
        });
    };
    // 入金合計
    vm.paymentNkSum = function(){
        return Object.keys(vm.skUrDetail).map(function(k){
            return +vm.skUrDetail[k].nk_kn;
        }).reduce(function(a,b){ return a + b },0);
    };
    // 手数料合計
    vm.paymentTsSum = function(){
        return Object.keys(vm.skUrDetail).map(function(k){
            return +vm.skUrDetail[k].tesu_kn;
        }).reduce(function(a,b){ return a + b },0);
    };
    // 雑損他合計
    vm.paymentZtSum = function(){
        return Object.keys(vm.skUrDetail).map(function(k){
            return +vm.skUrDetail[k].son_kn;
        }).reduce(function(a,b){ return a + b },0);
    };
    // 未入金金額計算
    vm.notPaymentDtlSum = function(item){
        return (item.jt_ur_kin + item.zei_kin) - (item.nk_kn + item.tesu_kn + item.son_kn);
    };
    // 未入金合計金額計算
    vm.notPaymentSum = function(){
        return Object.keys(vm.skUrDetail).map(function(k){
            return +vm.notPaymentDtlSum(vm.skUrDetail[k]);
        }).reduce(function(a,b){ return a + b },0);
    };
    // 各合計額計算実施
    $scope.$watch(function() { return vm.skUrDetail;},
        function(newVal,oldVal) {
            if(newVal !== oldVal){
                vm.nkSum = vm.paymentNkSum();
                vm.tsSum = vm.paymentTsSum();
                vm.ztSum = vm.paymentZtSum();
                vm.npSum = vm.notPaymentSum();
            }
    }, true);

    // 入金登録実行
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.paymentSubmit = function(method, detail){
        
        if( vm.detailForm.nk_day && is('Date', vm.detailForm.nk_day) ){
            vm.detailForm.nk_day = moment(vm.detailForm.nk_day).format('YYYY/MM/DD');
        }

        // 合計額再計算
        vm.detailForm.tesu_kei = vm.paymentTsSum();
        vm.detailForm.son_kei = vm.paymentZtSum();
        vm.detailForm.nk_kei = vm.paymentNkSum() + vm.detailForm.tesu_kei + vm.detailForm.son_kei;

        $log.debug('手数料合計:'+vm.detailForm.tesu_kei);
        $log.debug('雑損合計:'+vm.detailForm.son_kei);
        $log.debug('入金合計:'+vm.detailForm.nk_kei);

        var detailItem = [];
        if( detail.length > 0 ){
            angular.forEach(detail, function(v, k){
                if( Number(v.nk_kn) !== 0 ){
                    var itm = {
                            'nh_no' : v.nh_no,
                            'nk_kn' : v.nk_kn,
                            'tesu_kn' : v.tesu_kn,
                            'son_kn' : v.son_kn,
                    }
                    detailItem.push(itm);
                }
            });
        }
        
        var form = {'detailForm': vm.detailForm, 'detailItem': detailItem};
        var subUrl = '';
        var submitOk = true;
        if(method === 'DELETE') {
            form = vm.detailForm.nk_no;
            subUrl = '/delete';
        }else{
            if( detailItem.length === 0 ){
                submitOk = false;
            }
        }
        if(method === 'PUT') subUrl = '/put';

        $log.debug(form);

        if(submitOk){
            $http({
                url: dev.api + 'api/v1/payment'+ subUrl,
                method: method,
                params: { form : form }
            }).success(function(data) {
                $log.debug(data);
                var mess = message[method] + 'が完了しました。';
                toastr.info(mess, 'Info');
                vm.hideSelectModal();
                getResultsPage(1);
            });
        }else{
            toastr.error('最低1件は入金額をセットしてください', 'Error');
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('NyukinYoteiController', NyukinYoteiController);

  /** @ngInject */
  function NyukinYoteiController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('NyukinYoteiController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'015');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    vm.options = {};
    vm.form = {};
    vm.dateError = false;
    
    
    // 種類
    vm.form.nkyt = '1';

    // 部門DropDown
    vm.bumonDropdown = [];
    angular.forEach(vm.commondata.parentBumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'nky.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
        }else{
            vm.form.bumon_cd = '';
            vm.bumon_nm = '';
        }
    };
    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };
    // クリア
    vm.clear = function(){
        vm.form = {};
        vm.form.nkyt = '1';
        vm.bumon_nm = '';
        $scope.$broadcast('angucomplete-alt:clearInput');
    }

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };
    
    // 帳票生成実行
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        vm.dateError = false;
        var toDay;
        if(vm.form.untilDate){
            toDay = moment(new Date(vm.form.untilDate)).unix();
        }
        if(!toDay) toDay = moment().unix();
        var checkDay = moment(new Date(vm.form.fromDate)).add(3,'months').unix();
        if( toDay > checkDay ){
            vm.dateError = true;
        }
        //console.log(moment.unix(toDay).format('YYYY-MM-DD'));
        //console.log(moment.unix(checkDay).format('YYYY-MM-DD'));
        
        if(!vm.dateError){
            $http({
                url: dev.api + 'api/v1/nyukinyoteigen',
                method: 'GET',
                params: {form:angular.toJson(vm.form)}
            }).success(function(datas) {
                $log.debug(datas);
                if(datas.length === 0 || !datas){
                    vm.error = 'データが存在しません'
                }else{
                    storage.set('printNkytData', datas);
                    vm.dateError = false;
                    if( $rootScope.openWindow ){
                        $rootScope.openWindow.focus();
                        $rootScope.openWindow.close();
                    }
                    $rootScope.openWindow = $window.open('#/nkyt-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                }
                //vm.form = {value: []};
            });
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MonthlyActionController', MonthlyActionController);

  /** @ngInject */
  function MonthlyActionController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MonthlyActionController');

    var vm = this;
    vm.user = storage.get('user');
    // Menu
    $rootScope.panelSelected(4,'031');
    vm.commondata = storage.get('commondata');
    // 月次情報はcommondataからでは無くログイン時差を考えて最新を取得
    vm.kaiKihon = {};
    vm.monthlyDateCheck = false;
    vm.monthlyDateLastCheck = false;
    vm.ShowAll = false;
    // 月次実施済みか、実施月は正しいかチェックして表示
    vm.init = function(){
        vm.kaiKihon = {};
        vm.monthlyDateCheck = false;
        vm.monthlyDateLastCheck = false;
        vm.ShowAll = false;
        $http({
            url: dev.api + 'api/v1/getkaikihon',
            method: 'GET'
        }).success(function(datas) {
            vm.kaiKihon = datas;
            var ym = vm.kaiKihon.getuji_ym.toString();

            // 現在日時
            vm.now = moment().unix();
            // 最終月次実施月末
            vm.last = moment(ym, 'YYYYMMDD').endOf('month').unix();
            // 次回実施予定月末
            vm.nowLast = moment(ym, 'YYYYMMDD').add({months:1}).endOf('month').unix();
            vm.nowLastFirst = moment(ym, 'YYYYMMDD').add({months:2}).startOf('month').unix();
            // 現在よりも最終実施日が大きい場合(次のチェックがあるので基本的にはありえない)
            if(vm.now < vm.last){
                vm.monthlyDateCheck = true;
            }
            // 現在よりも次の実施月末が大きい場合
            if(vm.now < vm.nowLast){
                vm.monthlyDateLastCheck = true;
            }
            vm.lastY = ym.substring(0 ,4);
            vm.lastM = ym.substring(4 ,6);
            vm.gettsujiYm = ym;
        });
        vm.ShowAll = true;
    };
    vm.init();
    /*
     * 月次処理 STEP1
     * 1.月次締年月と月次仮締年月との整合性チェック
     *  月次締年月と月次仮締年月が違う場合はエラーとします。
     * 2.データ整合性チェック処理実行
     *  以下チェックを行います。 
     *    (1).作業報告情報の作業日が月次対象月で、作業報告承認が済でないデータの存在チェック
     *    (2).作業売上情報の作業日が月次対象月で、作業売上承認が済でないデータの存在チェック
     *    (3).経費情報で計上日が月次対象月で、経理承認が済でないデータの存在チェック
     *    (4).同一受注で複数売上計上（入力）されている中に、売上承認されているデータとされていないデータの存在チェック
     *    (5).同一受注で複数の作業売上の中に、売上入力されていないデータの存在チェック
     *    (6).受注関連付けされていない作業伝票の存在チェック（作業報告）
     *    (7).受注関連付けされていない作業伝票の存在チェック（作業売上）
     *    (8～10)は奉行関連(z-if)なので廃止
     *    (11).売上情報の売上計上日が月次対象月で、売上承認が済でないデータの存在チェック
     *
     *  原価は奉行絡みなので　原価配賦処理は行わない
     *  
     * 1.月次締年月と月次仮締年月との整合性チェック
     *   月次締年月と月次仮締年月が同じ場合はエラー。
     *   月次締年月と原価配賦処理完了年月が同じ場合はエラー。 ⇒ 無視
     * 2.在庫残高更新処理を行います。 ⇒ 無視
     * 3.売掛金残高更新処理を行います。
     * 4.買掛金残高更新処理を行います。
     * 5.入金確定処理を行います。
     * 6.請求締切処理を行います。
     * 7.月次帳票系データ作成処理を行います。
     * 8.基本情報マスターの「月次締年月」の更新を行います。
     */
    
    //console.log(vm.commondata);
    
    // 月次処理実行
    vm.monthlyActionDateCheck = false;
    vm.monthlyMainCheck = false;
    vm.errorPrint = false;
    vm.monthlyAction = function(){
        $http({
            url: dev.api + 'api/v1/monthlyaction',
            method: 'GET'
        }).success(function(datas) {
            //toastr.info('月次処理が完了しました', 'Info');
            //console.log(datas);
            if(Object.keys(datas).length > 0){
                var printTarget = [];
                angular.forEach(datas, function(data, name){
                    if(!data.check){
                        printTarget.push({name:name,data:data.data});
                    }
                });
                if( printTarget.length > 0 ){
                    storage.set('mPrintData', printTarget);
                    if( $rootScope.openWindow ){
                        $rootScope.openWindow.focus();
                        $rootScope.openWindow.close();
                    }
                    vm.errorPrint = true;
                    $rootScope.openWindow = $window.open('#/m-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                }else{
                    vm.monthlyMainCheck = true;
                }
            }else{
                vm.monthlyMainCheck = true;
                vm.monthlyActionDateCheck = true;
            }
        });
    };
    
    // 月次確認modal
    vm.modal = $modal({
        templateUrl:'app/monthly-action/modal.html',
        scope: $scope,
        show:false
    });
    vm.openModal = function(){
        vm.modal.$promise.then(vm.modal.show);
    };
    vm.hideModal = function(){
        vm.modal.$promise.then(vm.modal.hide);
    };
    vm.monthlyMainActionModal = function(){
        vm.openModal();
    }
    // 残在庫処理modal
    vm.modal2 = $modal({
        templateUrl:'app/monthly-action/modal2.html',
        scope: $scope,
        show:false
    });
    vm.openModal2 = function(){
        vm.modal2.$promise.then(vm.modal2.show);
    };
    vm.hideModal2 = function(){
        vm.modal2.$promise.then(vm.modal2.hide);
    };
    vm.zanZaikoActionModal = function(){
        vm.openModal2();
    }
    // 月次メイン処理実行
    vm.monthlyMainAction = function(){
        $http({
            url: dev.api + 'api/v1/monthlymainaction',
            method: 'GET'
        }).success(function(datas) {
            //console.log(datas);
            if(datas.set){
                vm.hideModal();
                toastr.info('月次処理が完了しました', 'Info');
                vm.zanZaikoActionModal();
                vm.init();
            }else{
                toastr.warning('月次処理が失敗しました。管理者にお問い合わせください', 'Warning');
            }
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MonthlyStaffController', MonthlyStaffController);

  /** @ngInject */
  function MonthlyStaffController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MonthlyStaffController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(4,'033');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    
    vm.init = function(){
        var y = ym.substring(0 ,4);
        var m = ym.substring(4 ,6);
        vm.from_date = new Date(y,m,1);
    }
    vm.init();
    
    // 帳票生成実行
    vm.generateAnalysis = function() {
        
        if( vm.from_date ){
            var from_date = moment(new Date(vm.from_date));
            if( !from_date.isValid() ) {
                from_date = moment(new Date(vm.from_date+'/01'));
            }
            if( from_date.isValid() ){
                
                var from_date = moment(from_date).format('YYYYMM');
                $http({
                    url: dev.api + 'api/v1/monthlystaffgenarate',
                    method: 'POST',
                    params: {from_date:from_date}
                }).success(function(datas) {
                    $log.debug(datas);
                    if( !datas.set ){
                        vm.error = '生成できませんでした'
                    }else{
                        toastr.info('スタッフ稼働状況の集計が完了しました。', 'Info');
                        vm.init();
                    }
                });
            }else{
                toastr.warn('日付が不正です', 'Warn');
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MklistController', MklistController);

  /** @ngInject */
  function MklistController($log, $timeout, $filter, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MklistController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'016');
    vm.commondata = storage.get('commondata');
    
    var ym = vm.commondata.kihon.getuji_ym.toString();
    var y = ym.substring(0 ,4);
    var m = ym.substring(4 ,6);
    
    vm.from_date = y + '/04';
    vm.end_date = y + '/' + m;
    vm.options = {};
    vm.form = {};
    vm.dateError = false;
    
    vm.form.toDate = new Date();
    
    
    // ソート種類
    vm.form.sort = '1';

    // 部門DropDown
    vm.bumonDropdown = [];
    angular.forEach(vm.commondata.parentBumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'mklist.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
        }else{
            vm.form.bumon_cd = '';
            vm.bumon_nm = '';
        }
    };
    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };
    // クリア
    vm.clear = function(){
        vm.form.bumon_cd = '';
        vm.form.toku_cd = '';
        vm.toku_nm = '';
        $scope.$broadcast('angucomplete-alt:clearInput');
    }

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };
    
    // 帳票生成実行
    vm.generateAnalysis = function() {
        $log.debug(vm.form);
        vm.dateError = false;
        if( vm.form.toDate ){
            vm.form.toDate = moment(new Date(vm.form.toDate)).format('YYYY/MM/DD');
            $http({
                url: dev.api + 'api/v1/mklistgen',
                method: 'GET',
                params: {form:angular.toJson(vm.form)}
            }).success(function(datas) {
                $log.debug(datas);
                if(datas.length === 0 || !datas){
                    vm.error = 'データが存在しません'
                }else{
                    storage.set('printMklistData', datas);
                    vm.dateError = false;
                    if( $rootScope.openWindow ){
                        $rootScope.openWindow.focus();
                        $rootScope.openWindow.close();
                    }
                    $rootScope.openWindow = $window.open('#/mklist-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
                }
                //vm.form = {value: []};
            });
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MenuController', MenuController);

  /** @ngInject */
  function MenuController($log, $scope, $timeout, $http, $auth, $rootScope, $state, $q, dev, storage) {

    $log.debug('MenuController');

    var vm = this;
    vm.user = storage.get('user');

    vm.admin_menu =
        [{//0
           'name': '一般業務' , 'icon' : 'glyphicon-th', 'hidden':0, 'items': [
              {'id':'001', 'name':'受注一覧 ',      'link':'app.business-orders'},
              {'id':'002', 'name':'作業予定一覧',  'link':'app.business-planning({juno:"000"})'},
              {'id':'003', 'name':'作業報告一覧',  'link':'app.business-report({juno:"000",sgno:"000"})'},
              {'id':'004', 'name':'作業売上一覧',  'link':'app.business-earnings({juno:"000"})'},
              //{'name':'作業売上承認','link':'app.business({mode:work-sales-approval})'},
              //{'name':'作品完了入力','link':'app.business({mode:completion})'},
              {'id':'005', 'name':'売上一覧',  'link':'app.business-workearnings({juno:"000"})'},
              {'id':'006', 'name':'経費一覧',  'link':'app.business-expenses'}
              //{'name':'売上承認',  'link':'app.business({mode:sales-approval})'}
          ]
        },{//1
            'name': '請求・納品' , 'icon' : 'glyphicon-yen', 'hidden':0, 'items' : [
                {'id':'011', 'name':'請求書・納品書印刷/値引','link':'app.invoice-data'},
                {'id':'012', 'name':'請求書・納品書生成','link':'app.invoice-add'},
                {'id':'013', 'name':'入金処理','link':'app.payment'},
                {'id':'014', 'name':'得意先元帳','link':'app.tokumoto'},
                {'id':'015', 'name':'入金予定表','link':'app.nkyt'},
                {'id':'016', 'name':'未回収一覧','link':'app.mklist'},
                {'id':'017', 'name':'売掛金一覧','link':'app.urikake'},
            ]
        },{//2
            'name': '帳票' , 'icon' : 'glyphicon-list-alt', 'hidden':0, 'items' : [
                {'id':'021', 'name':'月別実績(担当者)','link':'app.monthly-rep-tan'},
                {'id':'022', 'name':'月別実績(得意先)','link':'app.monthly-rep-toku'},
                {'id':'023', 'name':'エンジニア指名状況','link':'app.engineers'},
                {'id':'024', 'name':'得意先別OAプリント本数','link':'app.oa-print'},
                {'id':'025', 'name':'各部屋別作業時間推移・作業金額','link':'app.studio-transition'},
                {'id':'026', 'name':'部門別売上推移','link':'app.monthly-transition'},
                {'id':'027', 'name':'スタッフ稼働状況','link':'app.op-stasus'},
                {'id':'028', 'name':'技術員作業明細','link':'app.work-spec'},
            ]
        },{//3
            'name': '在庫管理' , 'icon' : 'glyphicon-cd', 'hidden':0, 'items' : [
                 {'id':'081', 'name':'仕入入力','link':'app.inventory-controll'},
                 {'id':'082', 'name':'振替入力','link':'app.inventory-transfer'},
                 {'id':'083', 'name':'在庫一覧表','link':'app.inventory-list'},
                 {'id':'084', 'name':'スタジオ別出庫集計表','link':'app.inventory-studio'},
                 {'id':'085', 'name':'商品別出庫集計','link':'app.inventory-sgitem'},
                 {'id':'086', 'name':'出庫一覧表','link':'app.inventory-issue'}
             ]
        },{//4
            'name': '月次' , 'icon' : 'glyphicon-time', 'hidden':0, 'items' : [
                {'id':'031', 'name':'月次実行','link':'app.monthly-action'},
                {'id':'032', 'name':'残在庫調整実行','link':'app.zanzaiko-action({zz_date:""})'},
                {'id':'033', 'name':'スタッフ稼働状況集計','link':'app.monthly-staff'}
            ]
        },{//5
            'name': 'マスタ管理' , 'icon' : 'glyphicon-oil', 'hidden':0, 'items' : [
                {'id':'041', 'name':'基本情報','link':'app.basic'},
                {'id':'042', 'name':'社員マスタ','link':'app.syain'},
                {'id':'043', 'name':'外部関係者マスタ','link':'app.gaibu'},
                {'id':'044', 'name':'得意先マスタ','link':'app.toku'},
                {'id':'045', 'name':'スタジオマスタ','link':'app.studio'},
                {'id':'046', 'name':'作業項目マスタ','link':'app.sgitem'},
                {'id':'047', 'name':'作業分類マスタ','link':'app.bunrui'},
                {'id':'048', 'name':'作業形態マスタ','link':'app.sgkeitai'},
                {'id':'049', 'name':'部門マスタ','link':'app.bumon'},
                {'id':'050', 'name':'メディアマスタ','link':'app.media'},
                {'id':'051', 'name':'コードマスタ','link':'app.code'},
                {'id':'052', 'name':'経費分類マスタ','link':'app.keihi-bunrui'},
                {'id':'053', 'name':'経費科目マスタ','link':'app.keihi-kamoku'},
                {'id':'054', 'name':'勘定科目マスタ','link':'app.kanjyo-kamoku'},
                {'id':'055', 'name':'補助科目マスタ','link':'app.hojyo-kamoku'},
                {'id':'056', 'name':'取引先マスタ','link':'app.torihiki'},
            ]
        },{//6 マスタの増加を考え子設定の番号はObjキーに対してここから1つずれる
            'name': '設定' , 'icon' : 'glyphicon-cog', 'hidden':0, 'items' : [
                {'id':'061', 'name':'個人設定','link':'app.user'}
                //{'id':'052', 'name':'その他','link':'business.other'}
            ]
        },{//7
            'name': 'TOP' , 'icon' : 'glyphicon-home', 'hiden':0, 'items' : [
               {'id':'071', 'name':'ダッシュボード','link':'app.dashboard'},
           ]
       }];

    // 権限によって表示するメニュー内容を切り替える
    if( vm.user.sys_admin_fl === '2' || vm.user.sys_admin_fl === '3'){
        //vm.admin_menu.splice(4, 2);
        angular.forEach(vm.admin_menu, function(v,k){
            if(k > 4 && k < 6 )vm.admin_menu[k].hidden = 1;
        });
    }else if( vm.user.sys_admin_fl === '4' || vm.user.sys_admin_fl === '5'){
        //vm.admin_menu.splice(1,5);
        angular.forEach(vm.admin_menu, function(v,k){
            if(k > 0 && k < 6 )vm.admin_menu[k].hidden = 1;
        });
    }else if( vm.user.sys_admin_fl === '6'){
        //vm.admin_menu.splice(0,6);
        angular.forEach(vm.admin_menu, function(v,k){
            if(k < 6 )vm.admin_menu[k].hidden = 1;
        });
    }
    //$log.debug(vm.admin_menu);
    vm.standard_menu = [];

    //menu panel設定
    $rootScope.panels = {};
    $rootScope.panels.activePanel = null;
    $rootScope.panels.activePanelLink = null;
    $rootScope.panelSelected = function(index, id){
        //console.log('panelSelected id:' + id);
        //console.log('panelSelected index:' + index);

        $rootScope.panels.activePanel = index;
        $rootScope.panels.activePanelLink = id;
    };

    vm.meisaiChk = function(id){
        if( id !== '028' ){
            return true;
        }else{
            if( vm.user.sys_admin_fl === '1' ){
                return true;
            }else{
                return false;
            }
        }
    }
    vm.getujiChk = function(index){
        if( Number(index) !== 4 ){
            return true;
        }else{
            if( vm.user.sys_admin_fl === '1' ){
                return true;
            }else{
                return false;
            }
        }
    }
    /*$rootScope.activePanel = function(pIndex, idx){
        //console.log(pIndex + ':::' +$rootScope.panels.activePanel);

        if( $rootScope.panels.activePanelLink == idx && $rootScope.panels.activePanel == pIndex){
            return true;
        }
        return false;
    };
    */

  }
})();
(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('TorihikiController', TorihikiController);

  /** @ngInject */
  function TorihikiController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('TorihikiController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'056');

    // Tooltip
    vm.editTooltipText1 = {'title': '-新規登録-<br />この取引先を複写して新規登録します'};
    //vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};
    // 検索フォーム初期化
    vm.formInit = function(){
        // 使いまわしデータ取得
        vm.commondata = storage.get('commondata');
        // From初期化
        vm.form = {};
        vm.toku_nm = '';
        vm.toku_km = '';
        vm.tan_nm= '';
        vm.bumon_nm= '';
        vm.toku_kb_nm= '';
        vm.mode = 1;
        vm.detai = {};
        vm.detailForm = {};

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 25;
        getResultsPage(1);
        vm.pagination = {current:1};
        
        // 付随データ取得
        $http({
            url: dev.api + 'api/v1/gettorikankei',
            method: 'GET'
        }).success(function(datas) {
            vm.kubun = datas.kubun;
            // 区分Dropdown
            vm.kubunDropdown = [{'text':'－－', 'click': 'thk.kubunSelect()'}];
            angular.forEach(vm.kubun ,function(v){
                vm.kubunDropdown.push({'text':v.tori_kb_nm, 'click': 'thk.kubunSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
            });
            // 区分選択
            vm.kubunSelect = function(tori_kb, tori_kb_nm){
                if(tori_kb && tori_kb_nm){
                    vm.form.tori_kb = tori_kb;
                    vm.tori_kb_nm = tori_kb_nm;
                }else{
                    vm.form.tori_kb = '';
                    vm.tori_kb_nm = '';
                }
            };
        });
        
    };
    vm.formInit();
 
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/torihikisaki',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    /***************************************************** 新規・編集 Modal *********************************************/

    // 詳細Modal
    vm.detailModal = $modal({
        templateUrl:'app/masta-torihiki/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    // 詳細取得実行
    vm.setTokuDetail = function(mode, item){
        //console.log(item);
        //console.log(mode);
        vm.detailForm = {};
        vm.tokuDtl = {};
        vm.detail = {};
        vm.mode = mode;
        if(!item && mode === 1){
            // 新規取引先選択モード
            vm.detailForm.tori_kb = null;
            vm.detailForm.tori_kb_nm = null;
            vm.detailForm.tori_nm = null;
            vm.detailForm.tori_rm = null;
            vm.detailForm.tori_km = null;
            vm.detailForm.tori_busyo = null;
            vm.detailForm.tori_tanto = null;
            vm.detailForm.keisyo = null;
            vm.detailForm.yubin_no = null;
            vm.detailForm.adrs1 = null;
            vm.detailForm.adrs2 = null;
            vm.detailForm.tel_no = null;
            vm.detailForm.fax_no = null;
            vm.detailForm.email = null;
            vm.detailForm.siharai_cd = null;
        }else{
            if(mode === 1){// 新規複写モード
                vm.detailForm.toku_cd = null;
            }else{
                vm.detailForm.tori_cd = item.tori_cd;
            }
            vm.detailForm.tori_kb = item.tori_kb;
            vm.detailForm.tori_kb_nm = item.tori_kb_nm;
            vm.detailForm.tori_nm = item.tori_nm;
            vm.detailForm.tori_rm = item.tori_rm;
            vm.detailForm.tori_km = item.tori_km;
            vm.detailForm.tori_busyo = item.tori_busyo;
            vm.detailForm.tori_tanto = item.tori_tanto;
            vm.detailForm.keisyo = item.keisyo;
            vm.detailForm.yubin_no = item.yubin_no;
            vm.detailForm.adrs1 = item.adrs1;
            vm.detailForm.adrs2 = item.adrs2;
            vm.detailForm.tel_no = item.tel_no;
            vm.detailForm.fax_no = item.fax_no;
            vm.detailForm.email = item.email;
            vm.detailForm.siharai_cd = item.siharai_cd;
        }
        // 区分Dropdown
        vm.modalTorihikisakiKbnDropdown = [];
        angular.forEach(vm.kubun ,function(v){
            vm.modalTorihikisakiKbnDropdown.push({'text':v.tori_kb_nm, 'click': 'thk.modalKubunSelect("'+ v.tori_kb +'","'+ v.tori_kb_nm +'")'});
        });
        // 区分選択
        vm.modalKubunSelect = function(tori_kb, tori_kb_nm){
            vm.detailForm.tori_kb = tori_kb;
            vm.detailForm.tori_kb_nm = tori_kb_nm;
        };
        
        vm.openDetailModal();
    };
    
    // 取引先登録実行
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.torihikisakiSubmit = function(method){

        var form;
        if(vm.detailForm && method !== 'DELETE'){
            angular.forEach(vm.detailForm, function(v,k){
               if(!v || v == null) delete vm.detailForm[k];
               if( angular.isArray(v) ){
                   if(v.length === 0) delete vm.detailForm[k];
               }
            });
            form = vm.detailForm;
        }
        var subUrl = '';
        if(method === 'DELETE') {
            form = vm.detailForm.tori_cd;
            subUrl = '/delete';
        }
        if(method === 'PUT') subUrl = '/put';

        $log.debug(form);
        $http({
            url: dev.api + 'api/v1/torihikisaki'+ subUrl,
            method: method,
            params: { form : form }
        }).success(function(data) {
            $log.debug(data);
            var mess = message[method] + 'が完了しました。';
            toastr.info(mess, 'Info');
            vm.hideSelectModal();
            getResultsPage(1);
            vm.pagination = { current: 1};
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('SyainController', SyainController);

  /** @ngInject */
  function SyainController($log, $filter, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('SyainController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'042');

    // Tooltip
    //vm.editTooltipText1 = {'title': '-新規登録-<br />この得意先の未入金一覧から入金の新規登録を行います'};
    //vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    // Tooltip
    vm.editTooltip1 = {'title': 'ダブルクリックすると編集画面が開きます'};
    
    // 検索フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.form.syain_km = null;
        vm.form.taisyoku_fl = '00';
        vm.taisyoku_nm = '問わず';
        vm.form.hiddenChk = 'yes';

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        getResultsPage(1);
        vm.pagination = {current:1};
        // 検索用データ取得
        getSearchConditions();
        
    };
    vm.formInit();
    // 社員検索・登録用サブデータ取得
    function getSearchConditions(){
        $http({
            url: dev.api + 'api/v1/syainsc',
            method: 'GET',
        }).success(function(datas) {
            vm.bumon = datas.bumon;
            vm.yakusyoku = datas.yakusyoku;
            
            // 受注部門
            vm.bumonDropdown = [{'text':'－－', 'click': 'syain.bumonSelect("","")'}];
            angular.forEach(vm.bumon ,function(v,k){
                vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'syain.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            
            // Modal 部門Dropdown
            vm.modalBumonDropdown = [];
            angular.forEach(vm.bumon ,function(v){
                vm.modalBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'syain.modalBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            
            // Modal 役職Dropdown
            vm.modalYakusyokuDropdown = [];
            angular.forEach(vm.yakusyoku ,function(v){
                vm.modalYakusyokuDropdown.push({'text':v.yakusyoku_nm, 'click': 'syain.modalYakusyokuSelect("'+ v.yakusyoku_cd +'","'+ v.yakusyoku_nm +'")'});
            });
        });
    }
    // 全角カナに半角カナFilter適用
    vm.changeZen2Cana = function(mode){
        if(mode === 'form'){
            vm.form.syain_km = $filter('formatZen2Han')(vm.form.syain_km);
        }else if(mode === 'detailForm'){
            vm.detailForm.syain_km = $filter('formatZen2Han')(vm.detailForm.syain_km);
        }
    }
   
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        vm.form.bumon_cd = null;
        vm.bumon_nm = null;
        if(bumon_cd && bumon_nm){
            vm.form.bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;    
        }
    };
    
    // 退職
    vm.taisyoku = [
        {'taisyoku_nm':'問わず','taisyoku_fl':'00'},
        {'taisyoku_nm':'退職','taisyoku_fl':'01'},
        {'taisyoku_nm':'在職','taisyoku_fl':'02'}
    ];
    // 退職Dropdown
    vm.taisyokuDropdown = [];
    angular.forEach(vm.taisyoku ,function(v){
        vm.taisyokuDropdown.push({'text':v.taisyoku_nm, 'click': 'syain.taisyokuSelect("'+ v.taisyoku_fl +'","'+ v.taisyoku_nm +'")'});
    });
    // 退職選択
    vm.taisyokuSelect = function(taisyoku_fl, taisyoku_nm){
        vm.taisyoku_nm = taisyoku_nm;
        vm.form.taisyoku_fl = taisyoku_fl;
    };

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/syain',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }
    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    /***************************************************** 新規・編集 Modal *********************************************/

    /* 
     * 権限付与
     * sys_admin_fl
     * 
       * 1 : Admin すべて操作可能
       * 2 : 一般社員1　一般業務/請求・納品/帳票 各承認
       * 3 : 一般社員2　一般業務/請求・納品/帳票
       * 4 : 一般社員3　一般業務のみ
       * 5 : 一般社員4　一般業務閲覧/印刷のみ
       * 6 : 権限剥奪(ログインのみ個人設定以外何も出来ない)
     */
    
    
    // 入金明細確認Modal
    vm.detailModal = $modal({
        templateUrl:'app/masta-syain/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    // 詳細取得実行
    vm.addSyainDetail = function(mode, item){
        vm.hideSelectModal();
        vm.detailForm = {};
        vm.detail= {};
        vm.mode = mode;
        vm.pwError = false;
        vm.idError = false;
        if(mode === 1){
            // 誕生日の初期値（現在から20年前の1/1~)
            var baseDate = new Date();
            baseDate.setYear(baseDate.getFullYear()-20);
            vm.detailForm.born_day = new Date(baseDate.getFullYear(), 1-1,1);
            vm.passwordMessage = '半角英数記号';
        }else{
            vm.passwordMessage = '新しいPW ： 変更ない場合は空白';
            // 編集モード
            if(item.born_day_time){
               vm.detailForm.born_day = new Date(item.born_day_time*1000);
            }
            if(item.nyusya_day_time){
                vm.detailForm.nyusya_day = new Date(item.nyusya_day_time*1000);
             }
            if(item.taisyoku_day_time > 0){
                vm.detailForm.taisyoku_day = new Date(item.taisyoku_day_time*1000);
             }
            vm.detailForm.syain_cd = item.syain_cd;
            vm.detailForm.syain_km = item.syain_km;
            vm.detailForm.syain_nm = item.syain_nm;
            vm.detailForm.bumon_cd = item.bumon_cd;
            vm.detailForm.sex_cd = item.sex_cd;
            vm.detailForm.yubin_no = item.yubin_no;
            vm.detailForm.adrs1 = item.adrs1;
            vm.detailForm.adrs2 = item.adrs2;
            vm.detailForm.tel_no = item.tel_no;
            vm.detailForm.yakusyoku_cd = item.yakusyoku_cd;
            vm.detailForm.hidden_flg = item.hidden_flg;
            vm.detailForm.base_salary = item.base_salary;
            // 今までは0/1のみだったので古い権限を持っている場合はADMINを充てる
            if( item.sys_admin_fl === 0) item.sys_admin_fl = 1;
            vm.detailForm.sys_admin_fl = item.sys_admin_fl;
            
            vm.detailForm.user_id = item.user_id;
            
            var brakep = false;
            angular.forEach(vm.commondata.authLevel, function(v){
                if(!brakep && Number(v.sys_admin_fl) === Number(item.sys_admin_fl)){
                    brakep = true;
                    //console.log(v.sys_admin_nm);
                    vm.detail.sys_admin_nm = v.sys_admin_nm;
                }
            });
            //console.log(vm.detailForm);
            
            vm.detail.bumon_nm = item.bumon_nm;
            vm.detail.yakusyoku_nm = item.yakusyoku_nm;
            //console.log(vm.detailForm);
        }
        vm.openDetailModal();
        
        // pwチェック
        $scope.$watch(function() { return vm.detailForm.password;},
            function(newVal,oldVal) {
                if(newVal !== oldVal && newVal){
                    if( !vm.detailForm.password.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/) ){
                        vm.pwError = true;
                    }else{
                        if( vm.detailForm.password.length < 5){
                            vm.pwLenError = true;
                        }else{
                            vm.pwLenError = false;
                        }
                        vm.pwError = false;
                    }
                }else{
                    vm.pwError = false;
                    vm.pwLenError = false;
                }
        }, true);
        // idチェック
        $scope.$watch(function() { return vm.detailForm.user_id;},
            function(newVal,oldVal) {
                if(newVal !== oldVal && newVal){
                    //console.log('id check :' + newVal);
                    if( vm.detailForm.user_id.match(/[^A-Za-z0-9]+/) ){
                        vm.idError = true;
                    }else{
                        vm.idError = false;
                    }
                }else{
                    vm.idError = false;
                }
        }, true);
    };

   
    // Modal 部門選択
    vm.modalBumonSelect = function(bumon_cd, bumon_nm){
        vm.detailForm.bumon_cd = bumon_cd;
        vm.detail.bumon_nm = bumon_nm;    
    };

    // Modal 役職選択
    vm.modalYakusyokuSelect = function(yakusyoku_cd, yakusyoku_nm){
        vm.detail.yakusyoku_nm = yakusyoku_nm;
        vm.detailForm.yakusyoku_cd = yakusyoku_cd;
    };

    // 管理権限レベル Dropdown
    vm.authorityLevelsDropdown = [];
    angular.forEach(vm.commondata.authLevel ,function(v){
        vm.authorityLevelsDropdown.push({'text':v.sys_admin_nm, 'click': 'syain.modalAuthSelect("'+ v.sys_admin_fl +'","'+ v.sys_admin_nm +'")'});
    });
    // 管理権限レベル選択
    vm.modalAuthSelect = function(sys_admin_fl, sys_admin_nm){
        vm.detail.sys_admin_nm = sys_admin_nm;
        vm.detailForm.sys_admin_fl = sys_admin_fl;
    };

    // 登録実行
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.paymentSubmit = function(method, detail){

        if( vm.detailForm.born_day && is('Date', vm.detailForm.born_day) ){
            vm.detailForm.born_day = moment(vm.detailForm.born_day).format('YYYY/MM/DD');
        }
        if( vm.detailForm.nyusya_day && is('Date', vm.detailForm.nyusya_day) ){
            vm.detailForm.nyusya_day = moment(vm.detailForm.nyusya_day).format('YYYY/MM/DD');
        }
        if( vm.detailForm.taisyoku_day && is('Date', vm.detailForm.taisyoku_day) ){
            vm.detailForm.taisyoku_day = moment(vm.detailForm.taisyoku_day).format('YYYY/MM/DD');
        }
        var subUrl = '';
        if(method === 'DELETE') {
            subUrl = '/delete';
        }
        if(method === 'PUT') subUrl = '/put';

        $log.debug(vm.detailForm);
        $http({
            url: dev.api + 'api/v1/syain'+ subUrl,
            method: method,
            params: { form : angular.toJson(vm.detailForm) }
        }).success(function(data) {
            $log.debug(data);
            var mess = message[method] + 'が完了しました。';
            toastr.info(mess, 'Info');
            vm.hideSelectModal();
            vm.formInit();
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('TokuController', TokuController);

  /** @ngInject */
  function TokuController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('TokuController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'044');

    // Tooltip
    vm.editTooltipText1 = {'title': '-新規登録-<br />この得意先を複写して新規登録します'};
    //vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};
    // 検索フォーム初期化
    vm.formInit = function(){
        // 使いまわしデータ取得
        vm.commondata = storage.get('commondata');
        // From初期化
        vm.form = {};
        vm.toku_nm = '';
        vm.toku_km = '';
        vm.tan_nm= '';
        vm.bumon_nm= '';
        vm.toku_kb_nm= '';
        vm.mode = 1;
        vm.detai = {};
        vm.detailForm = {};

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 25;
        getResultsPage(1);
        vm.pagination = {current:1};
        
        // 付随データ取得
        $http({
            url: dev.api + 'api/v1/gettokukankei',
            method: 'GET'
        }).success(function(datas) {
            vm.bumon = datas.bumon;
            vm.kubun = datas.kubun;
            vm.nk_keitai = datas.nk_keitai;
            vm.hakko_kubun = datas.hakko_kubun;
            vm.sk_tani = datas.sk_tani;
            vm.formItemInit();
        });
        
    };
    vm.formInit();
    
    vm.formItemInit = function(){
        // 部門Dropdown
        vm.bumonDropdown = [];
        angular.forEach(vm.bumon ,function(v){
            vm.bumonDropdown.push({'text':v.bumon_nm, 'click': 'tk.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
        });
       // 区分Dropdown
        vm.kubunDropdown = [];
        angular.forEach(vm.kubun ,function(v){
            vm.kubunDropdown.push({'text':v.toku_kb_nm, 'click': 'tk.kubunSelect("'+ v.toku_kb +'","'+ v.toku_kb_nm +'")'});
        });
        
        // 区分選択
        vm.kubunSelect = function(toku_kb, toku_kb_nm){
            vm.form.toku_kb = toku_kb;
            vm.toku_kb_nm = toku_kb_nm;
        };
        // 受注部門選択
        vm.bumonSelect = function(bumon_cd, bumon_nm){
            vm.form.bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd,1);
        };
        //営業選択
        vm.eigyoSelect = function(syain_cd, syain_nm){
            vm.form.tan_cd = syain_cd;
            vm.tan_nm = syain_nm;
        };
        // 担当営業取得
        vm.eigyoDropdown = [];
        vm.getTantoEigyo = function(bumon_cd, mode){
            $http({
                url: dev.api + 'api/v1/geteigyo',
                method: "GET",
                params: {'cd': bumon_cd}
            }).success(function(data, status, headers, config) {
                vm.eigyoDropdown = [];
                vm.modalEigyoDropdown = [];
                if(data){
                    angular.forEach(data ,function(v,k){
                        if(mode === 1){
                            vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'tk.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                        }else{
                            vm.modalEigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'tk.modalEigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                        }
                    });
                }
            });
        };
    };
    
 
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/toku',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    /***************************************************** 新規・編集 Modal *********************************************/

    // 詳細Modal
    vm.detailModal = $modal({
        templateUrl:'app/masta-toku/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    // 詳細取得実行
    vm.setTokuDetail = function(mode, item){
        //console.log(item);
        //console.log(mode);
        vm.detailForm = {};
        vm.tokuDtl = {};
        vm.detail = {};
        vm.skUrDetail = {};
        vm.uriageDtl = [];
        vm.detailForm.nebiki = [];
        vm.detail.nebiki_origin = [];
        vm.mode = mode;
        if(!item && mode === 1){
            // 新規得意先選択モード
            vm.detailForm.toku_kb = null;
            vm.detailForm.bumon_cd = null;
            vm.detailForm.tan_cd = null;
            vm.detailForm.toku_nm = null;
            vm.detailForm.toku_rm = null;
            vm.detailForm.toku_km = null;
            vm.detailForm.toku_busyo = null;
            vm.detailForm.toku_tanto = null;
            vm.detailForm.keisyo = null;
            vm.detailForm.yubin_no = null;
            vm.detailForm.adrs1 = null;
            vm.detailForm.adrs2 = null;
            vm.detailForm.tel_no = null;
            vm.detailForm.fax_no = null;
            vm.detailForm.email = null;
            vm.detailForm.kessan_mm = null;
            vm.detailForm.sime_dd = null;
            vm.detailForm.nohin_hakko_kb = null;
            vm.detailForm.sk_sime_dd = null;
            vm.detailForm.sk_tani = null;
            vm.detailForm.nk_sight = null;
            vm.detailForm.nk_dd = null;
            vm.detailForm.nk_ketai1 = null;
            vm.detailForm.genkai_kin1 = null;
            vm.detailForm.nk_ketai2 = null;
            vm.detailForm.genkai_kin2 = null;
            vm.detailForm.nk_ketai3 = null;
            vm.detailForm.genkai_kin3 = null;
            vm.detailForm.over_nk_keitai = null;
            vm.detailForm.kakeritu = null;
            vm.detailForm.nebiki_fl = '0';
        }else{
            if(mode === 1){// 新規複写モード
                vm.detailForm.toku_cd = null;
            }else{
                vm.detailForm.toku_cd = item.toku_cd;
            }
            // 得意先変更用
            vm.cd_editing = false;
            vm.changeForm = {};
            
            vm.detailForm.toku_kb = item.toku_kb;
            vm.detailForm.bumon_cd = item.bumon_cd;
            vm.detailForm.tan_cd = item.tan_cd;
            vm.detailForm.toku_nm = item.toku_nm;
            vm.detailForm.toku_rm = item.toku_rm;
            vm.detailForm.toku_km = item.toku_km;
            vm.detailForm.toku_busyo = item.toku_busyo;
            vm.detailForm.toku_tanto = item.toku_tanto;
            vm.detailForm.keisyo = item.keisyo;
            vm.detailForm.yubin_no = item.yubin_no;
            vm.detailForm.adrs1 = item.adrs1;
            vm.detailForm.adrs2 = item.adrs2;
            vm.detailForm.tel_no = item.tel_no;
            vm.detailForm.fax_no = item.fax_no;
            vm.detailForm.email = item.email;
            vm.detailForm.kessan_mm = item.kessan_mm;
            vm.detailForm.sime_dd = item.sime_dd;
            vm.detailForm.nohin_hakko_kb = item.nohin_hakko_kb;
            vm.detailForm.sk_sime_dd = item.sk_sime_dd;
            vm.detailForm.sk_tani = item.sk_tani;
            vm.detailForm.nk_sight = item.nk_sight;
            vm.detailForm.nk_dd = item.nk_dd;
            vm.detailForm.nk_ketai1 = item.nk_ketai1;
            vm.detailForm.genkai_kin1 = item.genkai_kin1;
            vm.detailForm.nk_ketai2 = item.nk_ketai2;
            vm.detailForm.genkai_kin2 = item.genkai_kin2;
            vm.detailForm.nk_ketai3 = item.nk_ketai3;
            vm.detailForm.genkai_kin3 = item.genkai_kin3;
            vm.detailForm.over_nk_keitai = item.over_nk_keitai;
            vm.detailForm.kakeritu = item.kakeritu_per;
            vm.detailForm.nebiki_fl = item.nebiki_fl;
            
            vm.detail.toku_kb_nm = item.toku_kb_nm;
            vm.detail.bumon_nm = item.bumon_nm;
            vm.detail.tan_nm = item.tan_nm;
            vm.detail.sk_tani_nm = item.sk_tani_nm;
            vm.detail.nk_ketai1_nm = item.nk_ketai1_nm;
            vm.detail.nk_ketai2_nm = item.nk_ketai2_nm;
            vm.detail.nk_ketai3_nm = item.nk_ketai3_nm;
            vm.detail.over_nk_keitai_nm = item.over_nk_keitai_nm;
            vm.detail.nohin_hakko_kb_nm = item.nohin_hakko_kb_nm;
            
            if(vm.detailForm.nebiki_fl === '1'){
                vm.getNebikiData(item.toku_cd);
            }
            if(vm.detailForm.tan_cd){
                vm.getTantoEigyo(vm.detailForm.bumon_cd,2);
            }
        }
        //営業選択
        vm.modalEigyoSelect = function(syain_cd, syain_nm){
            vm.detailForm.tan_cd = syain_cd;
            vm.detail.tan_nm = syain_nm;
        };
        
        // Modal得意先区分 Dropdown
        vm.modalBumonDropdown = [];
        angular.forEach(vm.bumon ,function(v){
            vm.modalBumonDropdown.push({'text':v.bumon_nm, 'click': 'tk.modalBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
        });
        // 部門選択
        vm.modalBumonSelect = function(bumon_cd, bumon_nm){
            vm.detailForm.bumon_cd = bumon_cd;
            vm.detail.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        };
        // 区分Dropdown
        vm.modalKubunDropdown = [];
        angular.forEach(vm.kubun ,function(v){
            vm.modalKubunDropdown.push({'text':v.toku_kb_nm, 'click': 'tk.modalKubunSelect("'+ v.toku_kb +'","'+ v.toku_kb_nm +'")'});
        });
        // 区分選択
        vm.modalKubunSelect = function(toku_kb, toku_kb_nm){
            vm.detailForm.toku_kb = toku_kb;
            vm.detail.toku_kb_nm = toku_kb_nm;
        };
        
        // 請求単位Dropdown
        vm.modalSkTaniDropdown = [];
        angular.forEach(vm.sk_tani ,function(v){
            vm.modalSkTaniDropdown.push({'text':v.sk_tani_nm, 'click': 'tk.modalSkTaniSelect("'+ v.sk_tani +'","'+ v.sk_tani_nm +'")'});
        });
        // 請求単位
        vm.modalSkTaniSelect = function(sk_tani, sk_tani_nm){
            vm.detailForm.sk_tani = sk_tani;
            vm.detail.sk_tani_nm = sk_tani_nm;
        };
        
        // 発行区分Dropdown
        vm.modalHkKubunDropdown = [];
        angular.forEach(vm.hakko_kubun ,function(v){
            vm.modalHkKubunDropdown.push({'text':v.hakko_kubun_nm, 'click': 'tk.modalHkKubunSelect("'+ v.hakko_kubun +'","'+ v.hakko_kubun_nm +'")'});
        });
        // 発行区分選択
        vm.modalHkKubunSelect = function(hakko_kubun, hakko_kubun_nm){
            vm.detailForm.nohin_hakko_kb = hakko_kubun;
            vm.detail.nohin_hakko_kb_nm = hakko_kubun_nm;
        };
        
        // 入金形態Dropdown
        vm.modalNkKeitai1Dropdown = [];
        vm.modalNkKeitai2Dropdown = [];
        vm.modalNkKeitai3Dropdown = [];
        vm.modalOverNkKeitaiDropdown = [];
        angular.forEach(vm.nk_keitai ,function(v){
            vm.modalNkKeitai1Dropdown.push({'text':v.nk_keitai_nm, 'click': 'tk.modalNkKeitaiSelect(1,"'+ v.nk_keitai +'","'+ v.nk_keitai_nm +'")'});
            vm.modalNkKeitai2Dropdown.push({'text':v.nk_keitai_nm, 'click': 'tk.modalNkKeitaiSelect(2,"'+ v.nk_keitai +'","'+ v.nk_keitai_nm +'")'});
            vm.modalNkKeitai3Dropdown.push({'text':v.nk_keitai_nm, 'click': 'tk.modalNkKeitaiSelect(3,"'+ v.nk_keitai +'","'+ v.nk_keitai_nm +'")'});
            vm.modalOverNkKeitaiDropdown.push({'text':v.nk_keitai_nm, 'click': 'tk.modalNkKeitaiSelect(4,"'+ v.nk_keitai +'","'+ v.nk_keitai_nm +'")'});
        });
        // 入金形態選択
        vm.modalNkKeitaiSelect = function(mode,nk_keitai, nk_keitai_nm){
            switch(mode){
                case 1:
                case '1':
                    vm.detailForm.nk_ketai1 = nk_keitai;
                    vm.detail.nk_ketai1_nm = nk_keitai_nm;
                    break;
                case 2:
                case '2':
                    vm.detailForm.nk_ketai2 = nk_keitai;
                    vm.detail.nk_ketai2_nm = nk_keitai_nm;
                    break;
                case 3:
                case '3':
                    vm.detailForm.nk_ketai3 = nk_keitai;
                    vm.detail.nk_ketai3_nm = nk_keitai_nm;
                    break;
                case 4:
                case '4':
                    vm.detailForm.over_nk_keitai = nk_keitai;
                    vm.detail.over_nk_keitai_nm = nk_keitai_nm;
                    break;
                default:
                    break;
            }
        };
        
        // 特別値引Dropdown
        vm.modalHkKubunDropdown = [];
        angular.forEach(vm.hakko_kubun ,function(v){
            vm.modalHkKubunDropdown.push({'text':v.hakko_kubun_nm, 'click': 'tk.modalHkKubunSelect("'+ v.hakko_kubun +'","'+ v.hakko_kubun_nm +'")'});
        });
        // 発行区分選択
        vm.modalHkKubunSelect = function(hakko_kubun, hakko_kubun_nm){
            vm.detailForm.nohin_hakko_kb = hakko_kubun;
            vm.detail.nohin_hakko_kb_nm = hakko_kubun_nm;
        };
        
        // 得意先CD変更
        vm.changeFormUrl = dev.api + 'api/v1/chktokucd'; // 得意先CDチェックURL
        vm.cd_doneEditing = function(){
            //console.log(vm.changeForm.chg_toku_cd);
            var param = {
                    'toku_cd' : vm.detailForm.toku_cd,
                    'chg_toku_cd' : vm.changeForm.chg_toku_cd
            }
            $http({
                url: dev.api + 'api/v1/updatetokucd',
                method: "POST",
                params: {'form': param}
            }).success(function(res) {
                vm.detailForm.toku_cd = vm.changeForm.chg_toku_cd;
                vm.changeForm = {};
                vm.cd_editing = false;
            });
        }
        
        vm.openDetailModal();
    };
    // 値引きデータ取得
    vm.getNebikiData = function(toku_cd){
        //console.log(toku_cd);
        $http({
            url: dev.api + 'api/v1/gettokunebiki',
            method: "GET",
            params: {'toku_cd': toku_cd}
        }).success(function(data) {
            vm.detailForm.nebiki = data;
            vm.detail.nebiki_origin = data;
        });
    };
    
    // 特別値引有効無効
    vm.modalChangeNebiki = function(flg){
        if(flg === '1'){
            if( vm.detail.nebiki_origin.length > 0 ){
                vm.detailForm.nebiki = [];
                vm.detailForm.nebiki = angular.copy(vm.detail.nebiki_origin);
            }else{
                vm.detailForm.nebiki.push({seq_no:'',uriage_ijyo:'',uriage_ika:'',nebiki_ritu:''});
            }
        }else{
            vm.detailForm.nebiki = [];
        }
    };
    // 特別値引1行削除
    vm.nebikiDelete = function($index){
        vm.detailForm.nebiki.splice($index,1);
    };
    // 特別値引1行追加
    vm.nebikiExtend = function($index){
        if( vm.detailForm.nebiki.length < 3){
            vm.detailForm.nebiki.push({seq_no:'',uriage_ijyo:'',uriage_ika:'',nebiki_ritu:''});
        }
    };
    
    // 得意先登録実行
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.tokuSubmit = function(method){

        var form;
        if(vm.detailForm && method !== 'DELETE'){
            angular.forEach(vm.detailForm, function(v,k){
               if(!v || v == null) delete vm.detailForm[k];
               if( angular.isArray(v) ){
                   if(v.length === 0) delete vm.detailForm[k];
               }
            });
            form = vm.detailForm;
        }
        var subUrl = '';
        if(method === 'DELETE') {
            form = vm.detailForm.toku_cd;
            subUrl = '/delete';
        }
        if(method === 'PUT') subUrl = '/put';

        $log.debug(form);
        $http({
            url: dev.api + 'api/v1/toku'+ subUrl,
            method: method,
            params: { form : form }
        }).success(function(data) {
            $log.debug(data);
            var mess = message[method] + 'が完了しました。';
            toastr.info(mess, 'Info');
            vm.hideSelectModal();
            getResultsPage(1);
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('StudioController', StudioController);

  /** @ngInject */
  function StudioController($log, $filter, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('StudioController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'045');

    // スタジオデータ取得
    vm.studio = {};
    vm.getStudioData = function (){
        $http({
            url: dev.api + 'api/v1/studioall',
            method: "GET",
        }).success(function(data) {
            vm.studio = data.studio;
            vm.studio_origin = angular.copy(data.studio);
            // 部門
            vm.bumonDropdown = [];
            angular.forEach(data.bumon ,function(v,k){
                vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'std.selectItem(key,"'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
        });
    };

    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.getStudioData();
    };
    vm.formInit();

    // 追加
    vm.studioExtend = function(){
        vm.studio.push({studio_cd:'', studio_nm:'', studio_rm:'',bumon_cd:'',bumon_nm:'', delete_flg:'0'});
    };
    // 削除
    vm.studioDelete = function($index){
        if(vm.studio.length > 0) {
            if(!vm.studio[$index].studio_cd){
                vm.studio.splice($index,1);
            }else{
                var dummy = angular.copy(vm.studio);
                dummy.splice($index,1);
                if( vm.duplicateCheckCd(vm.studio[$index].studio_cd,dummy) ){
                    vm.studio.splice($index,1);
                }else{
                    vm.studio[$index].delete_flg = '1';
                }
                
            }
        }
    };
    // リセット
    vm.studioReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.studio = angular.copy(vm.studio_origin);
    };
    // 各DropdownSelect
    vm.selectItem = function(index, cd, name){
        vm.studio[index].bumon_cd = cd;
        vm.studio[index].bumon_nm = name;
    };
   
    // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var duplicate=false;
        angular.forEach(data,function(v,i){
            var itm = angular.copy(data);
            itm.splice(i,1);
            for(var y in itm){
                if(!duplicate && v.studio_cd === itm[y].studio_cd){
                    duplicate = true;
                }
            }
        });
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code,arr){
        var duplicate=false;
        angular.forEach(arr, function(v,i){
            if(!duplicate && code === v.studio_cd){
                duplicate = true;
            }
        });
        return duplicate;
    }
    // 基本情報更新
    vm.studioSubmit = function(studio){
        vm.formError = false;
        angular.forEach(studio,function(v,i){
            if(!v.studio_cd) vm.formError = true;
        });
        if(!vm.formError){
            if(!vm.duplicateCheck(studio)){
                $http({
                    url: dev.api + 'api/v1/studioupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(studio)}
                }).success(function(datas) {
                    toastr.info('スタジオ情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }else{
                vm.duplicateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('SgKeitaiController', SgKeitaiController);

  /** @ngInject */
  function SgKeitaiController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('SgKeitaiController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'048');
    $scope.controllerAliasName = 'sgk';
    vm.commondata = storage.get('commondata');

    // メディアデータ取得
   
    vm.getsgkeitaiData = function (){
        $http({
            url: dev.api + 'api/v1/sgkeitaiall',
            method: "GET",
        }).success(function(data) {
            vm.sgKeitai = data.sgKeitai;
            vm.sgKeitaiItem = data.sgKeitaiItem;
            //vm.sgPtn = data.sgPtn;
            vm.bumon = data.bumon;
            vm.sgBunruiItem = data.sgBunruiItem;
            
            // 部門Dropdown
            vm.bumonDropdown = [{'text':'すべて', 'click': 'sgk.bumonSelect()'}];
            vm.itmBumonDropdown = [];
            angular.forEach(vm.bumon ,function(v){
                vm.bumonDropdown.push({'text':v.bumon_nm, 'click': 'sgk.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.itmBumonDropdown.push({'text':v.bumon_nm, 'click': 'sgk.sgItemBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            
            // 部門Dropdown
            vm.sgItemBunruiDropdown = [{'text':'すべて', 'click': 'sgk.sgItemBunruiSelect(key)'}];
            vm.sgPtnSgItemBunruiDropdown = [];
            angular.forEach(vm.sgBunruiItem ,function(v){
                vm.sgItemBunruiDropdown.push({'text':v.sg_bunrui_nm, 'click': 'sgk.sgItemBunruiSelect(key,"'+ v.sg_bunrui_cd +'","'+ v.sg_bunrui_nm +'")'});
                vm.sgPtnSgItemBunruiDropdown.push({'text':v.sg_bunrui_nm, 'click': 'sgk.sgPtnSgItemBunruiSelect(key,"'+ v.sg_bunrui_cd +'","'+ v.sg_bunrui_nm +'")'});
            });
        });
    };
    
    // フォーム初期化
    vm.formInit = function(flg){
        vm.ptn = {};
        vm.showPtn = false;
        vm.editScope = {};
        vm.copyMode = false;
        vm.sgkeitai = {};
        vm.searchFilter = {};
        vm.sgKeitaiItemForm = [];
        vm.sgKeitaiItemForm_origin = [];
        vm.searchFilter.sg_keitai_cd = '99999';
        vm.searchFilter.sg_keitai_nm = '';
        vm.sgKeitaiForm = {};
        vm.activeRow = null;
        vm.formError = false;
        vm.duplicateError = false;
        if(flg) vm.getsgkeitaiData();
    };
    vm.formInit(true);
    
    // RowColor
    vm.setActiveRow = function($index){
        vm.activeRow = $index;
    };
    // 検索表示/非表示
    vm.setShowSearch = function(){
        vm.formInit(false);
        if(vm.showPtn) vm.showPtn = false;
        return vm.showSearch = !vm.showSearch;
    }
    // 検索・部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.searchFilter.bumon_cd = bumon_cd;
            vm.searchFilter.bumon_nm = bumon_nm;
        }else{
            vm.searchFilter.bumon_cd = '';
            vm.searchFilter.bumon_nm = '';
        }
    };
    // 検索・部門選択
    vm.sgKeitaiSelect = function(item){
        vm.searchFilter.sg_keitai_cd = item.sg_keitai_cd;
        vm.searchFilter.sg_keitai_nm = item.sg_keitai_nm;
        vm.sgKeitaiForm = angular.copy(item);
        vm.sgKeitaiForm_origin = angular.copy(item);
        // 作業項目Filter
        vm.sgKeitaiItemForm = $filter('filter')(vm.sgKeitaiItem, {sg_keitai_cd: item.sg_keitai_cd});
        vm.sgKeitaiItemForm_origin = angular.copy(vm.sgKeitaiItemForm);
    };
    // 作業形態Form ・受注部門選択
    vm.sgItemBumonSelect = function(bumon_cd, bumon_nm){
        vm.sgKeitaiForm.bumon_cd = bumon_cd;
        vm.sgKeitaiForm.bumon_nm = bumon_nm;
    };
    // 作業項目追加
    vm.sgkeitaiItemExtend = function(){
        var dsp_seq_no = 0;
        if( vm.sgKeitaiItemForm.length > 0){
            var tmp = [];
            angular.forEach(vm.sgKeitaiItemForm, function(v){
                tmp.push(v.dsp_seq_no);
            })
            dsp_seq_no = Math.max.apply(null, tmp);
        }
        vm.sgKeitaiItemForm.push({sg_keitai_cd:'', dsp_seq_no:dsp_seq_no+1, sg_bunrui_cd:'', sg_bunrui_nm:'', dsp_nm:'', sg_item_cd:'', delete_flg:'0'});
    };
    // 作業項目削除
    vm.sgkeitaiItemDelete = function($index){
        if(vm.sgKeitaiItemForm.length > 0) {
            vm.sgKeitaiItemForm[$index].delete_flg = '1';
        }
    };
    // リセット
    vm.sgkeitaiItemReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.sgKeitaiItemForm = angular.copy(vm.sgKeitaiItemForm_origin);
    };
    // コピーモード判定&重複チェック
    $scope.$watch(function() { return vm.sgKeitaiForm.sg_keitai_cd;},
        function(newVal,oldVal) {
            // 編集の場合
            if(vm.sgKeitaiForm_origin){
                if(newVal !== oldVal && Object.keys(vm.sgKeitaiForm_origin).length > 0){
                    if(vm.sgKeitaiForm_origin.sg_keitai_cd !== newVal){
                        vm.copyMode = true;
                        if(newVal) {
                            vm.duplicateError = false;
                            if(vm.duplicateCheckCd(vm.sgKeitaiForm.sg_keitai_cd, vm.sgKeitai)){
                                vm.duplicateError = true;
                                vm.sgKeitaiForm.sg_keitai_cd = '';
                            }
                        }
                    }else{
                        vm.copyMode = false;
                    }
                    if(vm.showPtn){
                        vm.ptnFormInit(true);
                    }
                }
            }else{
                // 新規の場合は重複チェック
                if(newVal) {
                    vm.duplicateError = false;
                    if(vm.duplicateCheckCd(vm.sgKeitaiForm.sg_keitai_cd, vm.sgKeitai)){
                        vm.duplicateError = true;
                        vm.sgKeitaiForm.sg_keitai_cd = '';
                    }
                }
            }
    }, true);
    // コピーモードで、すでに登録済みのsg_keitai_cd がある場合のチェック
    vm.duplicateCheckCd = function(code,arr){
        var duplicate=false;
        angular.forEach(arr, function(v,i){
            if(!duplicate && code === v.sg_keitai_cd){
                duplicate = true;
            }
        });
        return duplicate;
    }
    // 作業分類名選択
    vm.sgItemBunruiSelect = function($index, sg_bunrui_cd,sg_bunrui_nm){
        if(sg_bunrui_cd && sg_bunrui_nm){
            vm.sgKeitaiItemForm[$index].sg_bunrui_cd = sg_bunrui_cd;
            vm.sgKeitaiItemForm[$index].sg_bunrui_nm = sg_bunrui_nm;
        }else{
            vm.sgKeitaiItemForm[$index].sg_bunrui_cd = '';
            vm.sgKeitaiItemForm[$index].sg_bunrui_nm = '';
        }
    };
    
    // 作業形態情報更新
    vm.sgkeitaiSubmit = function(){
        $log.debug(vm.sgKeitaiForm);
        $log.debug(vm.sgKeitaiItemForm);
        vm.formDupError = false;
        vm.formError = false;
        if(!vm.sgKeitaiForm.sg_keitai_cd) vm.formError = true;
        if(!vm.formError){
            var tmp = [];
            angular.forEach(vm.sgKeitaiItemForm, function(v){
                if(v.dsp_seq_no) tmp.push(Number(v.dsp_seq_no));
            })
            var duplicate = tmp.filter(function (x, i, self) {
                return self.indexOf(x) !== self.lastIndexOf(x);
            });
            // 表示順に重複/不足があったらエラー
            if( duplicate.length > 0 || (tmp.length !== vm.sgKeitaiItemForm.length) ){
                vm.formDupError = true;
            }else{
                var form = {sgKeitai: vm.sgKeitaiForm,sgKeitaiItem:vm.sgKeitaiItemForm};
                $http({
                    url: dev.api + 'api/v1/sgkeitaiupdate',
                    method: 'POST',
                    params: {'form': form}
                }).success(function(datas) {
                    toastr.info('作業形態情報を更新しました。', 'Info');
                    vm.formInit(true);
                });
            }
        }
    };
    // 作業形態情報削除
    vm.sgKeitaiDelete = function(){
        if( vm.sgKeitaiForm.sg_keitai_cd ){
            $http({
                url: dev.api + 'api/v1/sgkeitaidelete',
                method: 'POST',
                params: {sg_keitai_cd:vm.sgKeitaiForm.sg_keitai_cd}
            }).success(function(datas) {
                toastr.error('作業形態情報を削除しました。');
                vm.formInit(true);
            });
        }
    };
    
    
    /**************************************** 作業パターン ***************************************************/

    // 作業パターンフォーム初期化
    vm.ptnFormInit = function(flg){
        vm.templateUrl = 'app/masta-sgkeitai/sgptn.html';
        vm.showPtn = true;
        vm.sgPtnSearch = {};
        vm.sgPtnItem = [];
        vm.sgPtnItem_origin = [];
        vm.sgPtnForm = {};
        vm.sgItemFilterd = [];
        vm.sgItemFilterd_origin = [];
        vm.sgPtnFilterd = [];
        vm.sgPtnItemForm = [];
        vm.sgPtnCopyMode = false;
        vm.sgPtnSearchFilter = {};
        vm.sgPtnDuplicateError = false;
        vm.sgItem = vm.commondata.sgItemKit.sgItem;
        vm.sgPtnInited = false;
        //console.log(vm.sgItem);
        if(flg) vm.getSgPtnItem();
        
        //vm.sgPtnFilterd = $filter('filter')(vm.sgPtn, {sg_keitai_cd: vm.sgKeitaiForm.sg_keitai_cd});
        
        // 重複チェック
        vm.sgPtnDuplicateCheckCd = function(code,arr){
            var duplicate=false;
            angular.forEach(arr, function(v,i){
                if(!duplicate && code === v.sg_ptn_cd){
                    duplicate = true;
                }
            });
            return duplicate;
        }
        // コピーモード判定&重複チェック
        $scope.$watch(function() { return vm.sgPtnForm.sg_ptn_cd;},
            function(newVal,oldVal) {
                // 編集の場合
                if(vm.sgPtnForm_origin){
                    if(newVal !== oldVal && Object.keys(vm.sgPtnForm_origin).length > 0){
                        if(vm.sgPtnForm_origin.sg_ptn_cd !== newVal){
                            if(newVal) {
                                vm.sgPtnDuplicateError = false;
                                if(vm.sgPtnDuplicateCheckCd(vm.sgPtnForm.sg_ptn_cd, vm.sgPtn)){
                                    vm.sgPtnDuplicateError = true;
                                    vm.sgPtnForm.sg_ptn_cd = '';
                                }
                            }
                        }else{
                            vm.sgPtncopyMode = false;
                        }
                    }
                }else{
                    // 新規の場合は重複チェック
                    if(newVal) {
                        vm.sgPtnDuplicateError = false;
                        if(vm.sgPtnDuplicateCheckCd(vm.sgPtnForm.sg_ptn_cd, vm.sgPtn)){
                            vm.sgPtnDuplicateError = true;
                            vm.sgPtnForm.sg_ptn_cd = '';
                        }
                    }
                }
        }, true);
        
    };
    
    // 作業パターンアイテム情報取得
    vm.getSgPtnItem = function(){
        if( vm.sgKeitaiForm.sg_keitai_cd ){
            $http({
                url: dev.api + 'api/v1/getsgptnitem',
                method: 'GET',
                params: {sg_keitai_cd:vm.sgKeitaiForm.sg_keitai_cd}
            }).success(function(datas) {
                vm.sgPtnItem = datas.sgPtnItem;
                vm.sgPtn = datas.sgPtn;
                vm.sgPtnItem_origin = angular.copy(datas);
            });
        }
    };
    // RowColor
    vm.sgPtnSetActiveRow = function($index){
        vm.sgPtnActiveRow = $index;
    };
    
    // 自身の作業パターンアイテム
    vm.ptnMatchSgItem = function(sgPtnItem,sgPtnForm,sg_bunrui_cd){
        var ptnItemSgItemCds = [];
        var sgPtnItemFilteredCds = [];
        var sgPtnItemForm = [];
        var sgPtnItemFiltered = [];
        // パターンアイテムから該当sg_item_cdを抽出
        angular.forEach(sgPtnItem, function(v){
            if( v.sg_keitai_cd === sgPtnForm.sg_keitai_cd && v.sg_ptn_cd === sgPtnForm.sg_ptn_cd
                    && v.sg_bunrui_cd === sg_bunrui_cd){
                ptnItemSgItemCds.push(v.sg_item_cd);
            }
        });
        // 未選択アイテム(真ん中リスト)
        angular.forEach(vm.sgItem, function(v){
            if( v.sg_bunrui_cd === sg_bunrui_cd){
                sgPtnItemFilteredCds.push(v.sg_item_cd);
            }
        });
        // 該当パターンアイテムを抽出
        angular.forEach(ptnItemSgItemCds, function(cd){
            angular.forEach(vm.sgItem, function(sg){
                if(cd === sg.sg_item_cd){
                    sgPtnItemForm.push(sg)
                }
            });
        });
        // 重複の無いように未選択アイテム(真ん中リスト)を整形
        var cds = [];
        angular.forEach(ptnItemSgItemCds, function(cd,i){
            angular.forEach(sgPtnItemFilteredCds, function(cd2,y){
                if(cd === cd2){
                    sgPtnItemFilteredCds.splice(y,1);
                }
            });
        });
        // 該当部門の作業アイテム
        angular.forEach(sgPtnItemFilteredCds, function(cd){
            angular.forEach(vm.sgItem, function(sg){
                if(cd === sg.sg_item_cd){
                    sgPtnItemFiltered.push(sg)
                }
            });
        });
        return {'ptnItemSgItemCds':ptnItemSgItemCds,'sgPtnItemForm':sgPtnItemForm,'sgPtnItemFiltered':sgPtnItemFiltered};
    };
   
    // 作業アイテム選択
    vm.sgPtnSgItemSelect = function(item,$index){
        vm.sgPtnItemForm.push(item);
        vm.sgItemFilterd.splice($index,1);
    };
    // 作業アイテム排除
    vm.sgPtnSgItemDeselect = function(item,$index){
        vm.sgItemFilterd.push(item);
        vm.sgPtnItemForm.splice($index,1);
    };
    
    // 作業アイテム絞りこみ
    vm.selectedBunruiIndex = '99999';
    vm.sgPtnSgItemBunruiSelect = function($index, sg_bunrui_cd,sg_bunrui_nm){
        vm.selectedBunruiIndex = $index;
        vm.sgPtnForm.sg_bunrui_cd = sg_bunrui_cd;
        vm.sgPtnForm.sg_bunrui_nm = sg_bunrui_nm;
        vm.sgPtnItemForm = [];
        vm.sgItemFilterd = [];
        //console.log(vm.sgPtnForm);
        // 更新用のアイテムを絞り込む
        var itm = vm.ptnMatchSgItem(vm.sgPtnItem,vm.sgPtnForm,sg_bunrui_cd);
        vm.sgPtnItemForm = itm.sgPtnItemForm;
        //$filter('filter')(itm.sgPtnItemFiltered, {sg_bunrui_cd: sg_bunrui_cd});
        vm.sgItemFilterd = itm.sgPtnItemFiltered;
    };

    // 新規 パターン登録
    vm.sgPtnNew = function(){
        vm.sgPtnForm.sg_keitai_cd = vm.sgKeitaiForm.sg_keitai_cd;
        vm.sgPtnForm.sg_ptn_cd = '';
        vm.sgPtnForm.sg_ptn_nm = '';
        vm.sgPtnItemForm = [];
        vm.sgItemFilterd = [];
        vm.sgPtnActiveRow = null;
        vm.sgPtnInited = true;
    };
    
    // 検索・作業パターン選択
    vm.sgPtnSelect = function(item){
        vm.sgPtnForm = angular.copy(item);
        vm.sgPtnForm_origin = angular.copy(item);
        vm.sgPtnItemForm = [];
        vm.sgItemFilterd = [];
        vm.sgPtnInited = true;
    };
    
    // パターンFormリセット
    vm.sgPtnItemFormReset = function(){
        vm.sgPtnSgItemBunruiSelect(vm.selectedBunruiIndex, vm.sgPtnForm.sg_bunrui_cd,vm.sgPtnForm.sg_bunrui_nm);
    };
    
    // 作業パターン情報更新
    vm.sgPtnSubmit = function(){
        $log.debug(vm.sgPtnForm);
        $log.debug(vm.sgPtnItemForm);
        vm.sgPtnFormError = false;
        vm.sgPtnForm.sg_keitai_cd = vm.sgKeitaiForm.sg_keitai_cd;
        if(!vm.sgPtnForm.sg_ptn_cd) vm.sgPtnFormError = true;
        if(!vm.sgPtnFormError){
            var form = { sgPtn:vm.sgPtnForm, sgPtnItem:vm.sgPtnItemForm };
            $http({
                url: dev.api + 'api/v1/sgptnupdate',
                method: 'POST',
                params: {'form': form}
            }).success(function(datas) {
                toastr.info('作業パターン情報を更新しました。', 'Info');
                vm.ptnFormInit(true);
            });
        }
    };
    
    // 作業パターン情報削除
    vm.sgPtnDelete = function(){
        $log.debug(vm.sgPtnForm);
        vm.sgPtnFormError = false;
        vm.sgPtnForm.sg_keitai_cd = vm.sgKeitaiForm.sg_keitai_cd;
        var form = { sgPtn:vm.sgPtnForm };
        // 元のデータに存在が確認できるもののみ削除
        var check = [];
        check = vm.sgPtn.filter(function(item,i){ if(item.sg_ptn_cd === vm.sgPtnForm.sg_ptn_cd ) return i; });
        if( check.length > 0 ){
            $http({
                url: dev.api + 'api/v1/sgptndelete',
                method: 'POST',
                params: {form: form}
            }).success(function(datas) {
                toastr.error('作業パターン情報を削除しました。');
                vm.ptnFormInit(true);
            });
        }
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('SgItemController', SgItemController);

  /** @ngInject */
  function SgItemController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('SgItemController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'046');
    $scope.controllerAliasName = 'sgi';

    // Tooltip
    vm.editTooltipText1 = {'title': '-新規登録-<br />この作業項目を複写して新規登録します'};
    //vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};
    // 検索フォーム初期化
    vm.formInit = function(){
        // 使いまわしデータ取得
        vm.commondata = storage.get('commondata');
        // From初期化
        vm.form = {};
        vm.detailForm = {};
        vm.detail = {};
        vm.bumon_nm = '';
        vm.sg_bunrui_nm = '';
        vm.mode = 1;
        

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 25;
        getResultsPage(1);
        vm.pagination = {current:1};
        
        // 付随データ取得
        $http({
            url: dev.api + 'api/v1/getsgitemopt',
            method: 'GET'
        }).success(function(datas) {
            vm.bumon = datas.bumon;
            vm.sgBunrui = datas.sgBunrui;
            vm.media = datas.media;
            vm.studio = datas.studio;
            vm.suryoKubun = datas.suryoKubun;
            vm.zaikoBumon = datas.zaikoBumon;
            vm.genkaSum = datas.genkaSum;
            vm.formItemInit();
        });
        
    };
    vm.formInit();
    
    vm.formItemInit = function(){
        // 部門Dropdown
        vm.bumonDropdown = [{'text':'－－', 'click': 'sgi.bumonSelect()'}];
        vm.modalBumonDropdown = [];
        angular.forEach(vm.bumon ,function(v){
            vm.bumonDropdown.push({'text':v.bumon_cd+':'+v.bumon_nm, 'click': 'sgi.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            vm.modalBumonDropdown.push({'text':v.bumon_cd+':'+v.bumon_nm, 'click': 'sgi.modalBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
        });
        // 部門Dropdown
        vm.modalZaikoBumonDropdown = [];
        angular.forEach(vm.zaikoBumon ,function(v){
            vm.modalZaikoBumonDropdown.push({'text':v.bumon_cd+':'+v.bumon_nm, 'click': 'sgi.modalZaikoBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
        });
        // ModalスタジオDropdown
        vm.modalStudioDropdown = [];
        angular.forEach(vm.studio ,function(v){
            vm.modalStudioDropdown.push({'text':v.studio_cd+':'+v.studio_nm, 'click': 'sgi.modalStudioSelect("'+ v.studio_cd +'","'+ v.studio_nm +'")'});
        });
        // ModalメディアDropdown
        vm.modalMediaDropdown = [];
        angular.forEach(vm.media ,function(v){
            vm.modalMediaDropdown.push({'text':v.media_cd+':'+v.media_nm, 'click': 'sgi.modalMediaSelect("'+ v.media_cd +'","'+ v.media_nm +'")'});
        });
        // Modal原価集計Dropdown
        vm.modalGenkaSumDropdown = [];
        angular.forEach(vm.genkaSum ,function(v){
            vm.modalGenkaSumDropdown.push({'text':v.genka_sum_cd+':'+v.genka_sum_nm, 'click': 'sgi.modalGenkaSumSelect("'+ v.genka_sum_cd +'","'+ v.genka_sum_nm +'")'});
        });
        // 分類Dropdown
        vm.sgBunruiDropdown = [{'text':'－－', 'click': 'sgi.sgBunruiSelect()'}];
        vm.modalSgBunruiDropdown = [];
        angular.forEach(vm.sgBunrui ,function(v){
            vm.sgBunruiDropdown.push({'text':v.sg_bunrui_cd+':'+v.sg_bunrui_nm, 'click': 'sgi.sgBunruiSelect("'+ v.sg_bunrui_cd +'","'+ v.sg_bunrui_nm +'")'});
            vm.modalSgBunruiDropdown.push({'text':v.sg_bunrui_cd+':'+v.sg_bunrui_nm, 'click': 'sgi.modalSgBunruiSelect("'+ v.sg_bunrui_cd +'","'+ v.sg_bunrui_nm +'")'});
        });
        // 数量区分Dropdown
        vm.modalSgKubun1_Dropdown = [];
        vm.modalSgKubun2_Dropdown = [];
        angular.forEach(vm.suryoKubun ,function(v){
            vm.modalSgKubun1_Dropdown.push({'text':v.suryo_kbn_nm, 'click': 'sgi.modalSgKubun1_Select("'+ v.suryo_kbn +'","'+ v.suryo_kbn_nm +'")'});
            vm.modalSgKubun2_Dropdown.push({'text':v.suryo_kbn_nm, 'click': 'sgi.modalSgKubun2_Select("'+ v.suryo_kbn +'","'+ v.suryo_kbn_nm +'")'});
        });
        // 部門選択
        vm.bumonSelect = function(bumon_cd, bumon_nm){
            if(bumon_cd && bumon_nm){
                vm.form.bumon_cd = bumon_cd;
                vm.bumon_nm = bumon_nm;
            }else{
                vm.form.bumon_cd = '';
                vm.bumon_nm = '';
            }
        };
        
        vm.yesNo = [{text:'有',value:'1'},{text:'無',value:'0'}];
        vm.target = [{text:'対象',value:'1'},{text:'対象外',value:'0'}];
        // する/しない[
        vm.modalTimeFlDropdown = [];
        vm.modalGenkaFlDropdown = [];
        vm.modalOverFlDropdown = [];
        vm.modalZaikoFlDropdown = [];
        angular.forEach(vm.yesNo ,function(v){
            vm.modalTimeFlDropdown.push({'text':v.text, 'click': 'sgi.modalFlSelect(1,"'+ v.value +'","'+ v.text +'")'});
            vm.modalGenkaFlDropdown.push({'text':v.text, 'click': 'sgi.modalFlSelect(2,"'+ v.value +'","'+ v.text +'")'});
            vm.modalOverFlDropdown.push({'text':v.text, 'click': 'sgi.modalFlSelect(3,"'+ v.value +'","'+ v.text +'")'});
            vm.modalZaikoFlDropdown.push({'text':v.text, 'click': 'sgi.modalFlSelect(4,"'+ v.value +'","'+ v.text +'")'});
        });
        // 対象/未対象
        vm.modalSkflDropdown = [];
        vm.modalOaPrtFlDropdown = [];
        angular.forEach(vm.target ,function(v){
            vm.modalSkflDropdown.push({'text':v.text, 'click': 'sgi.modalFlSelect(5,"'+ v.value +'","'+ v.text +'")'});
            vm.modalOaPrtFlDropdown.push({'text':v.text, 'click': 'sgi.modalFlSelect(6,"'+ v.value +'","'+ v.text +'")'});
        });
        vm.modalFlSelect = function(mode,flg,name){
            switch(mode){
                case 1:
                case '1':
                    vm.detailForm.time_fl = flg;
                    vm.detailForm.time_fl_nm = name;
                    break;
                case 2:
                case '2':
                    vm.detailForm.genka_fl = flg;
                    vm.detailForm.genka_fl_nm = name;
                    break;
                case 3:
                case '3':
                    vm.detailForm.over_fl = flg;
                    vm.detailForm.over_fl_nm = name;
                    break;
                case 4:
                case '4':
                    vm.detailForm.zaiko_kb = flg;
                    vm.detailForm.zaiko_kb_nm = name;
                    break;
                case 5:
                case '5':
                    vm.detailForm.sk_fl = flg;
                    vm.detailForm.sk_fl_nm = name;
                    break;
                case 6:
                case '6':
                    vm.detailForm.oa_prt_fl = flg;
                    vm.detailForm.oa_prt_fl_nm = name;
                    break;
            }
        }
        
        // Modal部門選択
        vm.modalBumonSelect = function(bumon_cd, bumon_nm){
            vm.detailForm.bumon_cd = bumon_cd;
            vm.detailForm.bumon_nm = bumon_nm;
        };
        // Modal部門選択
        vm.modalZaikoBumonSelect = function(bumon_cd, bumon_nm){
            vm.detailForm.zk_bumon_cd = bumon_cd;
            vm.detailForm.zk_bumon_nm = bumon_nm;
        };
        // 分類選択
        vm.sgBunruiSelect = function(sg_bunrui_cd, sg_bunrui_nm){
            if(sg_bunrui_cd && sg_bunrui_nm){
                vm.form.sg_bunrui_cd = sg_bunrui_cd;
                vm.sg_bunrui_nm = sg_bunrui_nm;
            }else{
                vm.form.sg_bunrui_cd = '';
                vm.sg_bunrui_nm = '';
            }
        };
        // Modal分類選択
        vm.modalSgBunruiSelect = function(sg_bunrui_cd, sg_bunrui_nm){
            vm.detailForm.sg_bunrui_cd = sg_bunrui_cd;
            vm.detailForm.sg_bunrui_nm = sg_bunrui_nm;
        };
        // Modal数量区分選択
        vm.modalSgKubun1_Select = function(suryo_kbn, suryo_kbn_nm){
            vm.detailForm.suryo_kbn_1 = suryo_kbn;
            vm.detailForm.suryo_kbn_1_nm = suryo_kbn_nm;
        };
        // Modal数量区分選択
        vm.modalSgKubun2_Select = function(suryo_kbn, suryo_kbn_nm){
            vm.detailForm.suryo_kbn_2 = suryo_kbn;
            vm.detailForm.suryo_kbn_2_nm = suryo_kbn_nm;
        };
        // Modalメディア
        vm.modalMediaSelect = function(media_cd, media_nm){
            vm.detailForm.media_cd = media_cd;
            vm.detailForm.media_nm = media_nm;
        }
        // Modalメディア
        vm.modalStudioSelect = function(studio_cd, studio_nm){
            vm.detailForm.studio_cd = studio_cd;
            vm.detailForm.studio_nm = studio_nm;
        }
        // 原価集計
        vm.modalGenkaSumSelect = function(genka_sum_cd, genka_sum_nm){
            vm.detailForm.genka_sum_cd = genka_sum_cd;
            vm.detailForm.genka_sum_nm = genka_sum_nm;
        }
    };
    
 
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/sgitemmasta',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    /***************************************************** 新規・編集 Modal *********************************************/

    // 詳細Modal
    vm.detailModal = $modal({
        templateUrl:'app/masta-sgitem/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    // 詳細取得実行
    vm.setSgItemDetail = function(mode, item){
        //console.log(item);
        //console.log(mode);
        vm.detailForm = {};
        vm.tokuDtl = {};
        vm.detail = {};
        vm.detailForm.sgTanka = [];
        vm.detail.sgTanka_origin = [];
        vm.mode = mode;
        
        if(!item && mode === 1){
            // 新規得意先選択モード
            vm.detailForm.sg_item_cd        = null;
            vm.detailForm.sg_bunrui_cd      = null;
            vm.detailForm.sg_bunrui_nm      = null;
            vm.detailForm.bumon_cd          = null;
            vm.detailForm.bumon_nm          = null;
            vm.detailForm.sg_item_nms       = null;
            vm.detailForm.sg_item_nm        = null;
            vm.detailForm.suryo_kbn_1       = '0';
            vm.detailForm.suryo_kbn_1_nm    = null;
            vm.detailForm.tani_1            = null;
            vm.detailForm.suryo_kbn_2       = '0';
            vm.detailForm.suryo_kbn_2_nm    = null;
            vm.detailForm.tani_2            = null;
            vm.detailForm.studio_cd         = null;
            vm.detailForm.studio_nm         = null;
            vm.detailForm.time_fl           = '0';
            vm.detailForm.time_fl_nm        = null;
            vm.detailForm.genka_fl          = '0';
            vm.detailForm.genka_fl_nm       = null;
            vm.detailForm.over_fl           = '0';
            vm.detailForm.over_fl_nm        = null;
            vm.detailForm.ov_sg_item_cd     = null;
            vm.detailForm.ov_sg_item_nms    = null;
            vm.detailForm.ov_suryo          = null;
            vm.detailForm.media_cd          = null;
            vm.detailForm.media_nm          = null;
            vm.detailForm.zaiko_kb          = '0';
            vm.detailForm.zaiko_kb_nm       = null;
            vm.detailForm.zk_bumon_cd       = null;
            vm.detailForm.zk_bumon_nm       = null;
            vm.detailForm.siire_tanka       = '0';
            vm.detailForm.zaiko_tanka       = '0';
            vm.detailForm.base_tanka        = '0';
            vm.detailForm.genka_sum_cd      = null;
            vm.detailForm.sk_fl             = '0';
            vm.detailForm.sk_fl_nm          = null;
            vm.detailForm.oa_prt_fl         = '0';
            vm.detailForm.oa_prt_fl_nm      = null;
        }else{
            if(mode === 1){// 新規複写モード
                vm.detailForm.sg_item_cd = null;
            }else{
                vm.detailForm.sg_item_cd = item.sg_item_cd;
            }
            vm.detailForm.sg_bunrui_cd  = item.sg_bunrui_cd;
            vm.detailForm.sg_bunrui_nm  = item.sg_bunrui_nm;
            vm.detailForm.bumon_cd      = item.bumon_cd;
            vm.detailForm.bumon_nm      = item.bumon_nm;
            vm.detailForm.sg_item_nms   = item.sg_item_nms;
            vm.detailForm.sg_item_nm    = item.sg_item_nm;
            vm.detailForm.suryo_kbn_1   = item.suryo_kbn_1;
            vm.detailForm.suryo_kbn_1_nm = item.suryo_kbn_1_nm;
            vm.detailForm.tani_1        = item.tani_1;
            vm.detailForm.suryo_kbn_2   = item.suryo_kbn_2;
            vm.detailForm.suryo_kbn_2_nm = item.suryo_kbn_2_nm;
            vm.detailForm.tani_2        = item.tani_2;
            vm.detailForm.studio_cd     = item.studio_cd;
            vm.detailForm.studio_nm     = item.studio_nm;
            vm.detailForm.time_fl       = item.time_fl;
            vm.detailForm.time_fl_nm    = item.time_fl_nm;
            vm.detailForm.genka_fl      = item.genka_fl;
            vm.detailForm.genka_fl_nm   = item.genka_fl_nm;
            vm.detailForm.over_fl       = item.over_fl;
            vm.detailForm.over_fl_nm    = item.over_fl_nm;
            vm.detailForm.ov_sg_item_cd = item.ov_sg_item_cd;
            vm.detailForm.ov_sg_item_nms = item.ov_sg_item_nms;
            vm.detailForm.ov_suryo      = item.ov_suryo;
            vm.detailForm.media_cd      = item.media_cd;
            vm.detailForm.media_nm      = item.media_nm;
            vm.detailForm.zaiko_kb      = item.zaiko_kb;
            vm.detailForm.zaiko_kb_nm   = item.zaiko_kb_nm;
            vm.detailForm.zk_bumon_cd   = item.zk_bumon_cd;
            vm.detailForm.zk_bumon_nm   = item.zk_bumon_nm;
            vm.detailForm.siire_tanka   = item.siire_tanka;
            vm.detailForm.zaiko_tanka   = item.zaiko_tanka;
            vm.detailForm.base_tanka    = item.base_tanka;
            vm.detailForm.genka_sum_cd  = item.genka_sum_cd;
            vm.detailForm.genka_sum_nm  = item.genka_sum_nm;
            vm.detailForm.sk_fl         = item.sk_fl;
            vm.detailForm.sk_fl_nm      = item.sk_fl_nm;
            vm.detailForm.oa_prt_fl     = item.oa_prt_fl;
            vm.detailForm.oa_prt_fl_nm  = item.oa_prt_fl_nm;
            
            // 個別単価設定のある場合
            if(Number(item.tanka_cnt) > 0){
                vm.getSgTankaData(item.sg_item_cd);
            }
           
        }
        vm.openDetailModal();
    };
    // 個別単価データ取得
    vm.getSgTankaData = function(sg_item_cd){
        //console.log(sg_item_cd);
        $http({
            url: dev.api + 'api/v1/gesgtanka',
            method: "GET",
            params: {'sg_item_cd': sg_item_cd}
        }).success(function(data) {
            vm.detailForm.sgTanka = data;
            vm.detail.sgTanka_origin = data;
        });
    };
    
    // 得意先別単価削除
    vm.sgTankaDelete = function($index){
        vm.detailForm.sgTanka.splice($index,1);
    };
    // 得意先別単価追加
    vm.sgTankaExtend = function(sg_item_cd){
        //console.log('sgTankaExtend');
        vm.detailForm.sgTanka.push({sg_item_cd:sg_item_cd, toku_cd:'',toku_nm:'',toku_tanka:''});
    };
    
    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: "GET",
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };
    
    
    // 得意先登録実行
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.sgItemSubmit = function(method){

        var form;
        if(vm.detailForm && method !== 'DELETE'){
            angular.forEach(vm.detailForm, function(v,k){
               if(!v || v == null) delete vm.detailForm[k];
               if( angular.isArray(v) ){
                   if(v.length === 0) delete vm.detailForm[k];
               }
            });
            form = vm.detailForm;
        }
        var subUrl = '';
        if(method === 'DELETE') {
            form = vm.detailForm.sg_item_cd;
            subUrl = '/delete';
        }
        if(method === 'PUT') subUrl = '/put';

        $log.debug(form);
        $http({
            url: dev.api + 'api/v1/sgitemmasta'+ subUrl,
            method: method,
            params: { form : form }
        }).success(function(data) {
            $log.debug(data);
            var mess = message[method] + 'が完了しました。';
            toastr.info(mess, 'Info');
            vm.hideSelectModal();
            getResultsPage(1);
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MediaController', MediaController);

  /** @ngInject */
  function MediaController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('MediaController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'050');


    // メディアデータ取得
    vm.media = {};
    vm.getMediaData = function (){
        $http({
            url: dev.api + 'api/v1/mediaall',
            method: "GET",
        }).success(function(data) {
            vm.media = data;
            vm.media_origin = angular.copy(data);
        });
    };

    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.getMediaData();
    };
    vm.formInit();

    // 追加
    vm.mediaExtend = function(){
        vm.media.push({media_cd:'', media_nm:'', delete_flg:'0'});
    };
    // 削除
    vm.mediaDelete = function($index){
        if(vm.media.length > 0) {
            if(!vm.media[$index].media_cd){
                vm.media.splice($index,1);
            }else{
                var dummy = angular.copy(vm.media);
                dummy.splice($index,1);
                if( vm.duplicateCheckCd(vm.media[$index].media_cd,dummy) ){
                    vm.media.splice($index,1);
                }else{
                    vm.media[$index].delete_flg = '1';
                }
            }
        }
    };
    // リセット
    vm.mediaReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.media = angular.copy(vm.media_origin);
    };
   
 // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var duplicate=false;
        angular.forEach(data,function(v,i){
            var itm = angular.copy(data);
            itm.splice(i,1);
            for(var y in itm){
                if(!duplicate && v.media_cd === itm[y].media_cd){
                    duplicate = true;
                }
            }
        });
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code,arr){
        var duplicate=false;
        angular.forEach(arr, function(v,i){
            if(!duplicate && code === v.media_cd){
                duplicate = true;
            }
        });
        return duplicate;
    }
    // メディア情報更新
    vm.mediaSubmit = function(media){
        vm.formError = false;
        angular.forEach(media,function(v,i){
            if(!v.media_cd) vm.formError = true;
        });
        if(!vm.formError){
            if(!vm.duplicateCheck(media)){
                $http({
                    url: dev.api + 'api/v1/mediaupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(media)}
                }).success(function(datas) {
                    toastr.info('メディア情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }else{
                vm.duplicateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('KeihiKamokuController', KeihiKamokuController);

  /** @ngInject */
  function KeihiKamokuController($log, $timeout, $http, $auth, $filter,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('KeihiKamokuController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'053');
    vm.controllerAliasName = 'kkm';
    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = [];
        vm.form = {};
        vm.editScope = {};
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        vm.pagination = {
            current: 1
        };
        getResultsPage(1);
    };
    vm.formInit();
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.datas = [];
        var search = null;
        search = vm.form;
        angular.forEach(search,function(v,k){
           if(!v) delete search[k];//不要なparamは削除
        });
        $http({
            url: dev.api + 'api/v1/keihikamoku',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.datas_origin = angular.copy(vm.datas);
            vm.totalDatas = datas.total;
            vm.lastPage = datas.last_page;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
            vm.itemDetail = [];
        });
    }
    
    /****************************************************** Edit Area ************************************************/
    // Scopeに注意

    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/masta-keihi-kamoku/kkmedit.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    // ModalClose
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };
    $scope.$on('modal.hide',function(){
        //console.log('modal.hide');
        toastr.clear();
    });
    // Edit Disabled
    vm.isFromDisabled = false;

    // EditMode init
    vm.editForm = {};
    vm.editModeInit = function(item){
        vm.isFromDetailError = false;
        
        // Table Row追加
        vm.editScope.tableExtend = function(){
            var detail = {
                    kh_bunrui_cd:'',
                    kmk_cd:'',
                    hojyo_kmk_cd:'',
                    dsp_nm:'',
            };
            var base = angular.copy(vm.editForm.detail);
            base.push(detail);
            vm.editForm.detail = base;
        };
        // Table Row 複写
        vm.editScope.tableRowCopy = function($index){
            //console.log($index);
            var base = angular.copy(vm.editForm.detail);
            var detail = angular.copy(base[$index]);
            base.splice($index+1, 0, detail);
            vm.editForm.detail = base;
            $log.debug(vm.editForm.detail);
        };
        // Table Row削除
        vm.editScope.tableCellDelete = function($index){
            //console.log($index);
            var base = angular.copy(vm.editForm.detail);
            base.splice($index , 1);
            vm.editForm.detail = base;
            $log.debug(vm.editForm.detail);
        };
        if( !item.detail)return false;

        vm.editForm = {};
        vm.editForm.detail = [];
        $log.debug(item);
        vm.editForm = item;
        vm.isFromDisabled = false;

        // 画面Open
        vm.openEdit();
    };
    
    // formSubmit
    vm.editScope.formSubmit = function(method){
        $log.debug(vm.editForm);

        var completeMessage = 'が完了しました';
        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.kh_bunrui_cd){
                return false;
            }
            completeMessage = '更新'+completeMessage;
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.kh_bunrui_cd){
                return false;
            }
            vm.editForm = angular.toJson({kh_bunrui_cd:vm.editForm.kh_bunrui_cd});
            completeMessage = '削除'+completeMessage;
        }

        $http({
            url: dev.api + 'api/v1/keihikamoku' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            vm.pagination = {current: 1};
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.info(completeMessage, 'Info');
        });
    };

    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        vm.hideEdit();
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('KeihiBunruiController', KeihiBunruiController);

  /** @ngInject */
  function KeihiBunruiController($log, $timeout, $http, $auth, $filter,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('KeihiBunruiController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'052');
    vm.controllerAliasName = 'kbun';
    
    // スタジオデータ取得
    vm.bunrui = {};
    vm.getkBunruiData = function (){
        $http({
            url: dev.api + 'api/v1/khbunrui',
            method: "GET",
        }).success(function(data) {
            vm.data = data.bunrui.slice( 50, 90) ;
            vm.data_origin = angular.copy(data.bunrui);
            // 交通費
            vm.kotuhiDropdown = [];
            angular.forEach(data.kotuhi ,function(v,k){
                vm.kotuhiDropdown.push({'text':v.kotuhi_fl + ' : '+ v.kotuhi_fl_nm, 'click': 'kbun.selectItem(key,"'+ v.kotuhi_fl +'","'+ v.kotuhi_fl_nm +'")'});
            });
            // 経費区分
            vm.keihiKbnDropdown = [];
            angular.forEach(data.kbn ,function(v,k){
                vm.keihiKbnDropdown.push({'text':v.kmk_kbn + ' : '+ v.kmk_kbn_nm, 'click': 'kbun.selectKbnItem(key,"'+ v.kmk_kbn +'","'+ v.kmk_kbn_nm +'")'});
            });
        });
    };

    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = [];
        vm.form = {};
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        vm.pagination = {
            current: 1
        };
        vm.bunruiCds = [];
        $http({
            url: dev.api + 'api/v1/khbunruioptions',
            method: "GET",
        }).success(function(data) {
            // 交通費
            vm.kotuhiDropdown = [];
            angular.forEach(data.kotuhi ,function(v,k){
                vm.kotuhiDropdown.push({'text':v.kotuhi_fl + ' : '+ v.kotuhi_fl_nm, 'click': 'kbun.selectItem(key,"'+ v.kotuhi_fl +'","'+ v.kotuhi_fl_nm +'")'});
            });
            // 経費区分
            vm.keihiKbnDropdown = [];
            angular.forEach(data.kbn ,function(v,k){
                vm.keihiKbnDropdown.push({'text':v.kmk_kbn + ' : '+ v.kmk_kbn_nm, 'click': 'kbun.selectKbnItem(key,"'+ v.kmk_kbn +'","'+ v.kmk_kbn_nm +'")'});
            });
            // 分類CD一覧
            vm.bunruiCds = data.bunruiCds;
        });
        getResultsPage(1);
    };
    vm.formInit();
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.datas = [];
        var search = null;
        search = vm.form;
        angular.forEach(search,function(v,k){
           if(!v) delete search[k];//不要なparamは削除
        });
        $http({
            url: dev.api + 'api/v1/khbunrui',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.datas_origin = angular.copy(vm.datas);
            vm.totalDatas = datas.total;
            vm.lastPage = datas.last_page;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
            vm.itemDetail = [];
        });
    }
    
    // 追加
    vm.itemExtend = function(){
        vm.datas.push({kh_bunrui_cd:'', kh_bunrui_nm:'', kotuhi_fl:'0',kmk_cd:'',kmk_nm:'',hojyo_kmk_cd:'',hojyo_kmk_nm:'', delete_flg:'0', new_flg:'1'});
    };
    // 削除
    vm.itemDelete = function($index){
        if(vm.datas.length > 0) {
            if(!vm.datas[$index].kh_bunrui_cd){
                vm.datas.splice($index,1);
            }else{
                if( vm.duplicateCheckCd(vm.datas[$index].kh_bunrui_cd,vm.datas) ){
                    //console.log('duplicate delete');
                    vm.datas.splice($index,1);
                }else{
                    //console.log('delete');
                    vm.datas[$index].delete_flg = '1';
                }
                
            }
        }
    };
    // リセット
    vm.itemReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = angular.copy(vm.datas_origin);
    };
    // DropdownSelect
    vm.selectItem = function(index, cd, name){
        vm.datas[index].kotuhi_fl = cd;
        vm.datas[index].kotuhi_fl_nm = name;
    };
    // DropdownSelect
    vm.selectKbnItem = function(index, cd, name){
        vm.datas[index].kmk_kbn = cd;
        vm.datas[index].kmk_kbn_nm = name;
    };
   
    // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var bunruiCds = angular.copy(vm.bunruiCds);
        var duplicate=false;
        vm.duplicateError = duplicate;
        angular.forEach(data,function(v,i){
            if( Number(v.new_flg) === 1 )
                bunruiCds.push({kh_bunrui_cd:v.kh_bunrui_cd})
        });
        var geoupItems = $filter('groupBy')(bunruiCds, 'kh_bunrui_cd');
        vm.duplicateItem = [];
        angular.forEach(geoupItems,function(v,i){
            if( v.length > 1 ){
                duplicate = true;
                vm.duplicateItem.push(v[0]);
            }
        });
        vm.duplicateError = duplicate;
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code, data){
        var bunruiCds = angular.copy(vm.bunruiCds);
        var duplicate=false;
        angular.forEach(data,function(v,i){
            if( Number(v.new_flg) === 1 )
                bunruiCds.push({kh_bunrui_cd:v.kh_bunrui_cd})
        });
        var geoupItems = $filter('groupBy')(bunruiCds, 'kh_bunrui_cd');
        vm.duplicateItem = [];
        angular.forEach(geoupItems,function(v,key){
            if( code === key && v.length > 1 ){
                duplicate = true;
            }
        });
        return duplicate;
    }
    // 情報更新
    vm.itemSubmit = function(bunrui){
        vm.formError = false;
        angular.forEach(bunrui,function(v,i){
            if(!v.kh_bunrui_cd) vm.formError = true;
        });
        if(!vm.formError){
            if(!vm.duplicateCheck(bunrui)){
                //console.log('submit');
                $http({
                    url: dev.api + 'api/v1/khbunruiupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(bunrui)}
                }).success(function(datas) {
                    toastr.info('経費分類情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('KanjyoKamokuController', KanjyoKamokuController);

  /** @ngInject */
  function KanjyoKamokuController($log, $timeout, $http, $auth, $filter,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('KanjyoKamokuController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'054');
    vm.controllerAliasName = 'kkmk';
    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = [];
        vm.form = {};
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        vm.pagination = {
            current: 1
        };
        vm.kmkCds = [];
        $http({
            url: dev.api + 'api/v1/kanjyokanokuall',
            method: "GET",
        }).success(function(data) {
            // KMKCD一覧
            vm.kmkCds = data.kmkCds;
        });
        getResultsPage(1);
    };
    vm.formInit();
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.datas = [];
        var search = null;
        search = vm.form;
        angular.forEach(search,function(v,k){
           if(!v) delete search[k];//不要なparamは削除
        });
        $http({
            url: dev.api + 'api/v1/kanjyokamoku',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.datas_origin = angular.copy(vm.datas);
            vm.totalDatas = datas.total;
            vm.lastPage = datas.last_page;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
            vm.itemDetail = [];
        });
    }
    
    // 追加
    vm.itemExtend = function(){
        vm.datas.push({kmk_cd:'', kmk_nm:'', delete_flg:'0', new_flg:'1'});
    };
    // 削除
    vm.itemDelete = function($index){
        if(vm.datas.length > 0) {
            if(!vm.datas[$index].kmk_cd){
                vm.datas.splice($index,1);
            }else{
                if( vm.duplicateCheckCd(vm.datas[$index].kmk_cd,vm.datas) ){
                    //console.log('duplicate delete');
                    vm.datas.splice($index,1);
                }else{
                    //console.log('delete');
                    vm.datas[$index].delete_flg = '1';
                }
                
            }
        }
    };
    // リセット
    vm.itemReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = angular.copy(vm.datas_origin);
    };
   
    // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var kmkCds = angular.copy(vm.kmkCds);
        var duplicate=false;
        vm.duplicateError = duplicate;
        angular.forEach(data,function(v,i){
            if( Number(v.new_flg) === 1 )
                kmkCds.push({kmk_cd:v.kmk_cd});
        });
        var geoupItems = $filter('groupBy')(kmkCds, 'kmk_cd');
        vm.duplicateItem = [];
        angular.forEach(geoupItems,function(v,i){
            if( v.length > 1 ){
                duplicate = true;
                vm.duplicateItem.push(v[0]);
            }
        });
        vm.duplicateError = duplicate;
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code, data){
        var kmkCds = angular.copy(vm.kmkCds);
        var duplicate=false;
        angular.forEach(data,function(v,i){
            if( Number(v.new_flg) === 1 )
                kmkCds.push({kmk_cd:v.kmk_cd});
        });
        var geoupItems = $filter('groupBy')(kmkCds, 'kmk_cd');
        vm.duplicateItem = [];
        angular.forEach(geoupItems,function(v,key){
            if( code === key && v.length > 1 ){
                duplicate = true;
            }
        });
        return duplicate;
    }
    // 情報更新
    vm.itemSubmit = function(item){
        vm.formError = false;
        angular.forEach(item,function(v,i){
            if(!v.kmk_cd) vm.formError = true;
        });
        if(!vm.formError){
            if(!vm.duplicateCheck(item)){
                //console.log('submit');
                $http({
                    url: dev.api + 'api/v1/kanjyokamokuupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(item)}
                }).success(function(datas) {
                    toastr.info('勘定科目情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('GaibuController', GaibuController);

  /** @ngInject */
  function GaibuController($log, $filter, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('GaibuController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'043');

    // Tooltip
    //vm.editTooltipText1 = {'title': '-新規登録-<br />この得意先の未入金一覧から入金の新規登録を行います'};
    //vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    // Tooltip
    vm.editTooltip1 = {'title': 'ダブルクリックすると編集画面が開きます'};
    
    // 検索フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.form.simei_km = null;

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        getResultsPage(1);
        vm.pagination = {current:1};
        // 検索用データ取得
        getSearchConditions();
        
    };
    vm.formInit();
    // 社員検索・登録用サブデータ取得
    function getSearchConditions(){
        $http({
            url: dev.api + 'api/v1/gaibusc',
            method: 'GET',
        }).success(function(datas) {
            vm.bumon = datas.bumon;
            vm.gyosyu = datas.gyosyu;
            
            // 部門
            vm.bumonDropdown = [{'text':'－－', 'click': 'ga.bumonSelect("","")'}];
            angular.forEach(vm.bumon ,function(v,k){
                vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'ga.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            
            // Modal 部門Dropdown
            vm.modalBumonDropdown = [];
            angular.forEach(vm.bumon ,function(v){
                vm.modalBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'ga.modalBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            
            // 業種
            vm.gyoDropdown = [{'text':'－－', 'click': 'ga.gyoSelect("","")'}];
            angular.forEach(vm.gyosyu ,function(v,k){
                vm.gyoDropdown.push({'text':v.gyosyu_kb + ' : '+ v.gyosyu_nm, 'click': 'ga.gyoSelect("'+ v.gyosyu_kb +'","'+ v.gyosyu_nm +'")'});
            });
            
            // Modal 業種Dropdown
            vm.modalGyoDropdown = [];
            angular.forEach(vm.gyosyu ,function(v){
                vm.modalGyoDropdown.push({'text':v.gyosyu_kb + ' : '+ v.gyosyu_nm, 'click': 'ga.modalGyoSelect("'+ v.gyosyu_kb +'","'+ v.gyosyu_nm +'")'});
            });
            
        });
    }
    // 全角カナに半角カナFilter適用
    vm.changeZen2Cana = function(mode){
        if(mode === 'form'){
            vm.form.simei_km = $filter('formatZen2Han')(vm.form.simei_km);
        }else if(mode === 'detailForm'){
            vm.detailForm.simei_km = $filter('formatZen2Han')(vm.detailForm.simei_km);
        }
    }
    // 業種名
    vm.getGyoName = function(gyosyu_kb){
        var name,breakFlg=false;
        angular.forEach(vm.gyosyu,function(itm){
            if(!breakFlg && itm.gyosyu_kb === gyosyu_kb) 
                name = itm.gyosyu_nm
        });
        return name;
    }
    
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        vm.form.bumon_cd = null;
        vm.bumon_nm = null;
        if(bumon_cd && bumon_nm){
            vm.form.bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
        }
    };
    // 業種選択
    vm.gyoSelect = function(gyosyu_kb, gyosyu_nm){
        vm.form.gyosyu_kb = null;
        vm.gyosyu_nm = null;
        if(gyosyu_kb && gyosyu_nm){
            vm.form.gyosyu_kb = gyosyu_kb;
            vm.gyosyu_nm = gyosyu_nm;
        }
    };
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/gaibu',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }
    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    /***************************************************** 新規・編集 Modal *********************************************/

    // 詳細Modal
    vm.detailModal = $modal({
        templateUrl:'app/masta-gaibu/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    // 詳細取得実行
    vm.addGaibuDetail = function(mode, item){
        vm.hideSelectModal();
        vm.detailForm = {};
        vm.detail= {};
        vm.mode = mode;
        vm.idError = false;
        if(mode === 1){
            // 誕生日の初期値（現在から20年前の1/1~)
            var baseDate = new Date();
            baseDate.setYear(baseDate.getFullYear()-20);
            vm.detailForm.born_day = new Date(baseDate.getFullYear(), 1-1,1);
        }else{
            // 編集モード
            if(item.born_day_time){
               vm.detailForm.born_day = new Date(item.born_day_time*1000);
            }
            vm.detailForm.gaibu_cd = item.gaibu_cd;
            vm.detailForm.gyosyu_kb = item.gyosyu_kb;
            vm.detailForm.bumon_cd = item.bumon_cd;
            vm.detailForm.simei = item.simei;
            vm.detailForm.simei_km = item.simei_km;
            vm.detailForm.yubin_no = item.yubin_no;
            vm.detailForm.adrs1 = item.adrs1;
            vm.detailForm.adrs2 = item.adrs2;
            vm.detailForm.tel_no = item.tel_no;
            vm.detailForm.fax_no = item.fax_no;
            vm.detailForm.keitai_no = item.keitai_no;
            vm.detailForm.email = item.email;
            
            vm.detailForm.kai_name = item.kai_name;
            vm.detailForm.kai_yubin_no = item.kai_yubin_no;
            vm.detailForm.kai_adrs1 = item.kai_adrs1;
            vm.detailForm.kai_adrs2 = item.kai_adrs2;
            vm.detailForm.kai_tel_no = item.kai_tel_no;
            vm.detailForm.kai_fax_no = item.kai_fax_no;
            
            //console.log(vm.detailForm);
            
            vm.detail.bumon_nm = item.bumon_nm;
        }
        vm.openDetailModal();
    };

   
    // Modal 部門選択
    vm.modalBumonSelect = function(bumon_cd, bumon_nm){
        vm.detailForm.bumon_cd = bumon_cd;
        vm.detail.bumon_nm = bumon_nm;
    };

    // Modal 業務選択
    vm.modalGyoSelect = function(gyosyu_kb, gyosyu_nm){
        vm.detail.gyosyu_nm = gyosyu_nm;
        vm.detailForm.gyosyu_kb = gyosyu_kb;
    };

    // 登録実行
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.addSubmit = function(method, detail){

        if( vm.detailForm.born_day && is('Date', vm.detailForm.born_day) ){
            vm.detailForm.born_day = moment(vm.detailForm.born_day).format('YYYY/MM/DD');
        }
        var subUrl = '';
        if(method === 'DELETE') {
            subUrl = '/delete';
        }
        if(method === 'PUT') subUrl = '/put';

        $log.debug(vm.detailForm);
        $http({
            url: dev.api + 'api/v1/gaibu'+ subUrl,
            method: method,
            params: { form : angular.toJson(vm.detailForm) }
        }).success(function(data) {
            $log.debug(data);
            var mess = message[method] + 'が完了しました。';
            toastr.info(mess, 'Info');
            vm.hideSelectModal();
            vm.formInit();
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('HojyoKamokuController', HojyoKamokuController);

  /** @ngInject */
  function HojyoKamokuController($log, $timeout, $http, $auth, $filter,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('HojyoKamokuController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'055');
    vm.controllerAliasName = 'hkm';
    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = [];
        vm.form = {};
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        vm.pagination = {
            current: 1
        };
        vm.kmkCds = [];
        $http({
            url: dev.api + 'api/v1/hojyokanokuall',
            method: "GET",
        }).success(function(data) {
            // KMKCD一覧
            angular.forEach(data.kmkCds,function(v,i){
                vm.kmkCds.push( v.kmk_cd+':'+v.hojyo_cd );
            });
        });
        getResultsPage(1);
    };
    vm.formInit();
    
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        vm.datas = [];
        var search = null;
        search = vm.form;
        angular.forEach(search,function(v,k){
           if(!v) delete search[k];//不要なparamは削除
        });
        $http({
            url: dev.api + 'api/v1/hojyokamoku',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.datas_origin = angular.copy(vm.datas);
            vm.totalDatas = datas.total;
            vm.lastPage = datas.last_page;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
            vm.itemDetail = [];
        });
    }
    
    // 追加
    vm.itemExtend = function(){
        vm.datas.push({kmk_cd:'', kmk_nm:'', hojyo_cd:'', hj_kmk_nm:'', delete_flg:'0', new_flg:'1'});
    };
    // 削除
    vm.itemDelete = function($index){
        if(vm.datas.length > 0) {
            if(!vm.datas[$index].kmk_cd && !vm.datas[$index].hojyo_cd){
                vm.datas.splice($index,1);
            }else{
                var code = {kmk_cd:vm.datas[$index].kmk_cd,hojyo_cd:vm.datas[$index].hojyo_cd};
                if( vm.duplicateCheckCd(code,vm.datas) ){
                    //console.log('duplicate delete');
                    vm.datas.splice($index,1);
                }else{
                    //console.log('delete');
                    vm.datas[$index].delete_flg = '1';
                }
                
            }
        }
    };
    // リセット
    vm.itemReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.datas = angular.copy(vm.datas_origin);
    };
   
    // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var kmkCds = angular.copy(vm.kmkCds);
        var duplicate=false;
        vm.duplicateError = duplicate;
        angular.forEach(data,function(v,i){
            if( Number(v.new_flg) === 1 )
                kmkCds.push( v.kmk_cd+':'+v.hojyo_cd );
        });
        var duplicateItem = kmkCds.filter(function (x, i, self) {
            return self.indexOf(x) === i && i !== self.lastIndexOf(x);
        });
        vm.duplicateItem = [];
        if( duplicateItem.length > 0 ) {
            angular.forEach(duplicateItem,function(v,i){
                var obj = v.split(':');
                vm.duplicateItem.push({kmk_cd:obj[0],hojyo_cd:obj[1]});
            });
            duplicate=true;
        }
        vm.duplicateError = duplicate;
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code, data){
        var kmkCds = angular.copy(vm.kmkCds);
        var duplicate=false;
        vm.duplicateError = duplicate;
        angular.forEach(data,function(v,i){
            if( Number(v.new_flg) === 1 )
                kmkCds.push( v.kmk_cd+':'+v.hojyo_cd );
        });
        var duplicateItem = kmkCds.filter(function (x, i, self) {
            return self.indexOf(x) === i && i !== self.lastIndexOf(x);
        });
        vm.duplicateItem = [];
        if( duplicateItem.length > 0 ) {
            angular.forEach(duplicateItem,function(v,i){
                var obj = v.split(':');
                var kmk_cd = obj[0];
                var hojyo_cd = obj[1];
                if( ( code.kmk_cd === kmk_cd && code.hojyo_cd === hojyo_cd ) ){
                    duplicate = true;
                }
            });
        }
        return duplicate;
    }
    // 情報更新
    vm.itemSubmit = function(item){
        //console.log('itemSubmit');
        vm.formError = false;
        angular.forEach(item,function(v,i){
            if(!v.kmk_cd || !v.hojyo_cd) vm.formError = true;
        });
        if(!vm.formError){
            //console.log('formError ok');
            if(!vm.duplicateCheck(item)){
                //console.log('submit');
                $http({
                    url: dev.api + 'api/v1/hojyokamokuupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(item)}
                }).success(function(datas) {
                    toastr.info('補助科目情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('CodeValController', CodeValController);

  /** @ngInject */
  function CodeValController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('CodeValController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'051');
    $scope.controllerAliasName = 'cd';
    vm.commondata = storage.get('commondata');

    // CODEデータ取得
    vm.getCodeData = function (){
        $http({
            url: dev.api + 'api/v1/codeall',
            method: "GET",
        }).success(function(data) {
            vm.code_origin = data.code;
            vm.codeVal_origin = data.codeVal;
            vm.filterSelect(null);
        });
    };
    
    // フォーム初期化
    vm.formInit = function(flg){
        vm.searchFilter = {};
        vm.code = [];
        vm.codeVal = [];
        vm.codeVal_origin = [];
        vm.codeValForm_origin = [];
        vm.activeRow = null;
        vm.formError = false;
        vm.formDupError = false;
        vm.duplicateError = false;
        vm.ins_fl = 1;
        vm.chg_fl = 1;
        vm.del_fl = 1;
        vm.searchFilter.id_val = 0;
        if(flg) vm.getCodeData();
    };
    vm.formInit(true);
    
    // RowColor
    vm.setActiveRow = function($index){
        vm.activeRow = $index;
    };
    // FilterChange
    vm.filterSelect = function(mode){
        var id_val;
        switch(mode){
            case 1:
                id_val = 'CD';
                break;
            case 2:
                id_val = 'KB';
                break;
            case 3:
                id_val = 'FL';
                break;
            default:
                id_val = '';
                break;
        }
        vm.code = $filter('filter')(vm.code_origin, {code_id: id_val });
        
    };
    // ゼロパディングソート
    vm.sorter = function(arr){
        arr.sort(function(a, b){
            return parseInt(a.code_vl) > parseInt(b.code_vl);
        });
        return arr;
    };
    
    
    // CODE選択
    vm.codeSelect = function(item){
        vm.ins_fl = Number(item.ins_fl);
        vm.chg_fl = Number(item.chg_fl);
        vm.del_fl = Number(item.del_fl);
        vm.code_id = item.code_id;
        var filterd = $filter('filter')(vm.codeVal_origin, {code_id: item.code_id });
        vm.codeVal = vm.sorter(filterd);
        vm.codeValForm_origin = angular.copy(vm.codeVal);
    };
    
    // 追加
    vm.codeValExtend = function(){
        vm.codeVal.push({code_id:vm.code_id, code_vl:'',origin_code_vl:'', vl_nm:'', vl_rm:'', delete_flg:'0'});
    };
    // 削除
    vm.codeValDelete = function($index){
        if(vm.codeVal.length > 0) {
            vm.codeVal[$index].delete_flg = '1';
        }
    };
    // リセット
    vm.codeValReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.formDupError = false;
        vm.codeVal = angular.copy(vm.codeValForm_origin);
    };
    
    // 重複チェック
    vm.duplicateCheckCd = function(code,arr){
        var duplicate=false;
        angular.forEach(arr, function(v,i){
            if(!duplicate && code === v.code_vl){
                duplicate = true;
            }
        });
        return duplicate;
    }
    
    // 更新
    vm.codeValSubmit = function(){
        $log.debug(vm.codeVal);
        vm.formDupError = false;
        vm.formError = false;
        var tmp = [];
        angular.forEach(vm.codeVal, function(v){
            if(v.code_vl) tmp.push(v.code_vl);
        })
        var duplicate = tmp.filter(function (x, i, self) {
            return self.indexOf(x) !== self.lastIndexOf(x);
        });
        
        // 表示順に重複/不足があったらエラー
        if( duplicate.length > 0 || (tmp.length !== vm.codeVal.length) ){
            vm.formDupError = true;
        }else{
            var form = {codeVal: vm.codeVal};
            $http({
                url: dev.api + 'api/v1/codevalupdate',
                method: 'POST',
                params: {'form': form}
            }).success(function(datas) {
                toastr.info('コード情報を更新しました。', 'Info');
                vm.formInit(true);
            });
        }
    };
  
  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('BunruiController', BunruiController);

  /** @ngInject */
  function BunruiController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('BunruiController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'047');


    // 作業分類データ取得
    vm.bunrui = {};
    vm.getBunruiData = function (){
        $http({
            url: dev.api + 'api/v1/bunruiall',
            method: "GET",
        }).success(function(data) {
            vm.bunrui = data.bunrui;
            vm.bunrui_origin = angular.copy(data.bunrui);
            
            // 作業明細集計コード
            vm.sumCdDropdown = [];
            angular.forEach(data.bunrui_sum_cd ,function(v,k){
                vm.sumCdDropdown.push({'text':v.sg_bunrui_sum_cd + ' : '+ v.sg_bunrui_sum_cd_nm, 'click': 'bnr.selectItem(key,"'+ v.sg_bunrui_sum_cd +'","'+ v.sg_bunrui_sum_cd_nm +'")'});
            });
        });
    };

    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.getBunruiData();
    };
    vm.formInit();

    // 追加
    vm.bunruiExtend = function(){
        vm.bunrui.push({sg_bunrui_cd:'', sg_bunrui_nm:'',sg_bunrui_sum_cd:'', delete_flg:'0'});
    };
    // 削除
    vm.bunruiDelete = function($index){
        if(vm.bunrui.length > 0) {
            if(!vm.bunrui[$index].sg_bunrui_cd){
                vm.bunrui.splice($index,1);
            }else{
                var dummy = angular.copy(vm.bunrui);
                dummy.splice($index,1);
                if( vm.duplicateCheckCd(vm.bunrui[$index].sg_bunrui_cd,dummy) ){
                    vm.bunrui.splice($index,1);
                }else{
                    vm.bunrui[$index].delete_flg = '1';
                }
            }
        }
    };
    // リセット
    vm.bunruiReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.bunrui = angular.copy(vm.bunrui_origin);
    };
   
    // DropdownSelect
    vm.selectItem = function(index, cd, name){
        vm.bunrui[index].sg_bunrui_sum_cd = cd;
        vm.bunrui[index].sg_bunrui_sum_cd_nm = name;
    };
    
    // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var duplicate=false;
        angular.forEach(data,function(v,i){
            var itm = angular.copy(data);
            itm.splice(i,1);
            for(var y in itm){
                if(!duplicate && v.sg_bunrui_cd === itm[y].sg_bunrui_cd){
                    duplicate = true;
                }
            }
        });
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code,arr){
        var duplicate=false;
        angular.forEach(arr, function(v,i){
            if(!duplicate && code === v.sg_bunrui_cd){
                duplicate = true;
            }
        });
        return duplicate;
    }
    
    // メディア情報更新
    vm.bunruiSubmit = function(bunrui){
        vm.formError = false;
        vm.duplicateError = false;
        angular.forEach(bunrui,function(v,i){
            if(!v.sg_bunrui_cd) vm.formError = true;
        });
        if(!vm.formError){
            if(!vm.duplicateCheck(bunrui)){
                $http({
                    url: dev.api + 'api/v1/bunruiupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(bunrui)}
                }).success(function(datas) {
                    toastr.info('メディア情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }else{
                vm.duplicateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('BumonController', BumonController);

  /** @ngInject */
  function BumonController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('BumonController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'049');

    // Tooltip
    vm.editTooltipText1 = {'title': '-請求値引-<br />請求値引を行います'};
    vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};

    // モード切替
    vm.mode = 'data';
    if($stateParams.mode !== 'data'){
        vm.mode = $stateParams.mode;
    }

    // 部門データ取得
    vm.bumon = {};
    vm.getBumondata = function (){
        $http({
            url: dev.api + 'api/v1/bumonall',
            method: "GET",
        }).success(function(data) {
            vm.bumon = data.bumon;
            vm.bumon_origin = angular.copy(data.bumon);
            // 職種
            vm.syokusyuDropdown = [];
            angular.forEach(data.syokusyu ,function(v,k){
                vm.syokusyuDropdown.push({'text':v.bumon_syokusyu + ' : '+ v.bumon_syokusyu_nm, 'click': 'bmn.selectItem(1,key,"'+ v.bumon_syokusyu +'","'+ v.bumon_syokusyu_nm +'")'});
            });
            // 技術
            vm.tecBumonKbDropdown = [];
            angular.forEach(data.tec_bumon_kb ,function(v,k){
                vm.tecBumonKbDropdown.push({'text':v.tec_bumon_kb + ' : '+ v.tec_bumon_kb_nm, 'click': 'bmn.selectItem(2,key,"'+ v.tec_bumon_kb +'","'+ v.tec_bumon_kb_nm +'")'});
            });
            // 部署
            vm.bumonKbDropdown = [];
            angular.forEach(data.bumon_kb ,function(v,k){
                vm.bumonKbDropdown.push({'text':v.bumon_kb + ' : '+ v.bumon_kb_nm, 'click': 'bmn.selectItem(3,key,"'+ v.bumon_kb +'","'+ v.bumon_kb_nm +'")'});
            });
        });
    };

    
    // フォーム初期化
    vm.formInit = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.getBumondata();
    };
    vm.formInit();

    // 追加
    vm.bumonExtend = function(){
        vm.bumon.push({bumon_cd:'', bumon_nm:'', bumon_rm:'', bumon_syokusyu:'', bumon_syokusyu_nm:'', tec_bumon_kb:'', tec_bumon_kb_nm:'', bumon_kb:'', bumon_kb_nm:'', delete_flg:'0'});
    };
    // 削除
    vm.bumonDelete = function($index){
        if(vm.bumon.length > 0) {
            if(!vm.bumon[$index].bumon_cd){
                vm.bumon.splice($index,1);
            }else{
                var dummy = angular.copy(vm.bumon);
                dummy.splice($index,1);
                if( vm.duplicateCheckCd(vm.bumon[$index].bumon_cd,dummy) ){
                    vm.bumon.splice($index,1);
                }else{
                    vm.bumon[$index].delete_flg = '1';
                }
            }
        }
    };
    // リセット
    vm.bumonReset = function(){
        vm.formError = false;
        vm.duplicateError = false;
        vm.bumon = angular.copy(vm.bumon_origin);
    };
    // 各DropdownSelect
    vm.selectItem = function(mode, index, cd, name){
        if(mode === 1) {
            vm.bumon[index].bumon_syokusyu = cd;
            vm.bumon[index].bumon_syokusyu_nm = name;
        }
        if(mode === 2) {
            vm.bumon[index].tec_bumon_kb = cd;
            vm.bumon[index].tec_bumon_kb_nm = name;
        }
        if(mode === 3) {
            vm.bumon[index].bumon_kb = cd;
            vm.bumon[index].bumon_kb_nm = name;
        }
    };
   
    // 重複cdチェック全体
    vm.duplicateCheck = function(data){
        var duplicate=false;
        angular.forEach(data,function(v,i){
            var itm = angular.copy(data);
            itm.splice(i,1);
            for(var y in itm){
                if(!duplicate && v.bumon_cd === itm[y].bumon_cd){
                    duplicate = true;
                }
            }
        });
        return duplicate;
    }
    // 重複cdチェックcd指定
    vm.duplicateCheckCd = function(code,arr){
        var duplicate=false;
        angular.forEach(arr, function(v,i){
            if(!duplicate && code === v.bumon_cd){
                duplicate = true;
            }
        });
        return duplicate;
    }
    
    // 基本情報更新
    vm.bumonSubmit = function(bumon){
        vm.formError = false;
        angular.forEach(bumon,function(v,i){
            if(!v.bumon_cd) vm.formError = true;
        });
        if(!vm.formError){
            if(!vm.duplicateCheck(bumon)){
                $http({
                    url: dev.api + 'api/v1/bumonupdate',
                    method: 'POST',
                    params: {'form': angular.toJson(bumon)}
                }).success(function(datas) {
                    toastr.info('部門情報を更新しました。', 'Info');
                    vm.formInit();
                });
            }else{
                vm.duplicateError = true;
            }
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($log, $timeout, storage, $state, $http, $rootScope, toastr, $auth, dev) {

      // 念のためログアウト処理をしておく
      $auth.logout();
      storage.clearAll();
      
      var vm = this;

      vm.loginError = false;
      vm.loginErrorText;

      // ログイン処理開始
      vm.login = function() {

          $log.debug('login');
          //$log.debug($auth);

          var credentials = {
              user_id: vm.user_id,
              password: vm.password
          };
          $log.debug(credentials);

          // ログイン
          $auth.login(credentials)
          .then(function() {
              $log.debug('loged in');

              // ユーザデータ取得
              $http.get(dev.api + 'api/v1/authenticate/user')
                  .success(function(response){
                      var user = angular.fromJson(response.user);
                      $log.debug('login OK ');
                      // LocalStorageにユーザデータを保存
                      storage.set('user', user);
                      $rootScope.currentUser = response.user;
                      $state.go('app.dashboard');
                  })
                  .error(function(e){
                      vm.loginError = true;
                      $auth.logout();
                      //$log.error(angular.fromJson(e));
              });
          },function(e){
              toastr.warning('IDかパスワードが違うためログイン出来ません', 'Warning');
              $log.debug(angular.fromJson(e));
          });
      };

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('BasicController', BasicController);

  /** @ngInject */
  function BasicController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('BasicController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(5,'041');

    // Tooltip
    vm.editTooltipText1 = {'title': '-請求値引-<br />請求値引を行います'};
    vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};

    // モード切替
    vm.mode = 'data';
    if($stateParams.mode !== 'data'){
        vm.mode = $stateParams.mode;
    }
    // 使いまわしデータ取得
    vm.common = {};
    vm.getCommondata = function (){
        $http({
            url: dev.api + 'api/v1/commondata',
            method: "GET",
        }).success(function(data) {
            vm.common = data;
            vm.kihon = vm.common.kihon;
            vm.form.kaisya_nm = vm.kihon.kaisya_nm;
            vm.form.yubin_no = vm.kihon.yubin_no;
            vm.form.adrs = vm.kihon.adrs;
            vm.form.tel_info = vm.kihon.tel_info;
            vm.form.tel_no = vm.kihon.tel_no;
            vm.form.fax_no = vm.kihon.fax_no;
            vm.form.sime_dd = vm.kihon.sime_dd;
            vm.form.site_mm = vm.kihon.site_mm;
            vm.form.sh_dd = vm.kihon.sh_dd;
            vm.form.kaikei_nendo = vm.kihon.kaikei_nendo;
            vm.form.hasu_kb = vm.kihon.hasu_kb;
            vm.form.getuji_ym_kari = vm.kihon.getuji_ym_kari;
            vm.form.getuji_ym = vm.kihon.getuji_ym;
            vm.form.genka_ym = vm.kihon.genka_ym;
            vm.form.kessan_mm = vm.kihon.kessan_mm;
            //vm.form.getuji_ym_kari = vm.kihon.getuji_ym_kari_time;
            //vm.form.getuji_ym = vm.kihon.getuji_ym_time;
            //vm.form.genka_ym = vm.kihon.genka_ym_time;
            vm.form.corp_no = vm.kihon.corp_no;
            vm.form.z_kj_uriage = vm.kihon.z_kj_uriage;
            vm.form.z_kj_nyukin = vm.kihon.z_kj_nyukin;
            vm.form.z_kj_shiire = vm.kihon.z_kj_shiire;
            
            vm.form.base_rate_over_1 = vm.kihon.base_rate_over_1;
            vm.form.base_rate_over_2 = vm.kihon.base_rate_over_2;
            vm.form.base_rate_over_3 = vm.kihon.base_rate_over_3;
            vm.form.base_rate_over_4 = vm.kihon.base_rate_over_4;
        });
    };
    // 口座データ取得
    vm.koza = {};
    vm.getKozadata = function (){
        $http({
            url: dev.api + 'api/v1/kozaall',
            method: "GET",
        }).success(function(data) {
            vm.koza = data;
            vm.koza_origin = data;
        });
    };
    // 税率データ取得
    vm.zei = {};
    vm.getZeidata = function (){
        $http({
            url: dev.api + 'api/v1/zeiall',
            method: "GET",
        }).success(function(data) {
            angular.forEach(data,function(v,k){
                if(v.start_day_time) data[k].start_day = new Date(v.start_day_time*1000);
                if(v.end_day_time){
                    data[k].end_day = new Date(v.end_day_time*1000);
                }else{
                    data[k].end_day = null;
                }
            });
            vm.zei = data;
            vm.zei_origin = data;
        });
    };
    
    // 検索フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        
        vm.getCommondata();
        vm.getKozadata();
        vm.getZeidata();
    };
    vm.formInit();

    //　預金種別
    vm.yokinSbDropdown = [{yokin_sb:'1',name:'普通'},{yokin_sb:'2',name:'当座'}];
    // 口座追加
    vm.kozaExtend = function(){
        vm.koza.push({});
    };
    // 口座削除
    vm.kozaDelete = function($index){
        if(vm.koza.length > 0) vm.koza.splice($index,1);
    };
    // 口座リセット
    vm.kozaReset = function(){
        vm.koza = angular.copy(vm.koza_origin);
    };
    // 税情報追加
    vm.zeiExtend = function(){
        vm.zei.push({});
    };
    // 税情報削除
    vm.zeiDelete = function($index){
        if(vm.zei.length > 0) vm.zei.splice($index,1);
    };
    // 税情報リセット
    vm.zeiReset = function(){
        vm.zei = angular.copy(vm.zei_origin);
    };
    
    // 基本情報更新
    vm.basicSubmit = function(){
        $http({
            url: dev.api + 'api/v1/kihonupdate',
            method: 'POST',
            params: {'form': vm.form}
        }).success(function(datas) {
            toastr.info('基本情報を更新しました。', 'Info');
            vm.form ={};
            vm.getCommondata();
        });
    };
    // 口座情報更新
    vm.kozaSubmit = function(form){
        //console.log(form);
        $http({
            url: dev.api + 'api/v1/kozaupdate',
            method: 'POST',
            params: {'form': angular.toJson(form)}
        }).success(function(datas) {
            toastr.info('口座情報を更新しました。', 'Info');
            vm.getKozadata();
        });
    };
    //　税情報更新
    vm.zeiSubmit = function(form){
        angular.forEach(form, function(v,k){
            if( v.start_day && is('Date', v.start_day) ){
                form[k].start_day = moment(v.start_day).format('YYYY/MM/DD');
            }
            if( v.end_day && is('Date', v.end_day) ){
                form[k].end_day = moment(v.end_day).format('YYYY/MM/DD');
            }
        });
        
        $http({
            url: dev.api + 'api/v1/zeiupdate',
            method: 'POST',
            params: {'form': angular.toJson(form)}
        }).success(function(datas) {
            toastr.info('税率情報を更新しました。', 'Info');
            vm.getZeidata();
        });
    }
    // 印刷対象タイプ
    vm.hasukbn = [
        {'name':'切捨て','hasu_kb':'1','checked':false},
        {'name':'切り上げ','hasu_kb':'2','checked':false},
        {'name':'四捨五入','hasu_kb':'3','checked':false}
    ];

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InvoicedataController', InvoicedataController);

  /** @ngInject */
  function InvoicedataController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('InvoicedataController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'011');

    // Tooltip
    vm.editTooltipText1 = {'title': '-請求値引-<br />請求値引を行います'};
    vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};

    // モード切替
    vm.mode = 'data';
    if($stateParams.mode !== 'data'){
        vm.mode = $stateParams.mode;
    }

    /*
     * 発行済み請求書・納品書を検索・プレビュー（印刷）するモード
     * 未発行請求書を発行するモード
     */

    // 検索フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.toku_nm = '';
        vm.form.toku_cd = null;
        vm.sime_dd_nm = null;
        vm.printType = '1';
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        vm.detailForm = {};

        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        //vm.form.untilDate = new Date();

        vm.itemAllChecked = 0;
        vm.typeCheckErr = true;

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        getResultsPage(1);
        vm.pagination = {current:1};
        getSimeDD();

    };
    vm.formInit();

    // 使いまわしデータ取得
    vm.commondata = storage.get('commondata');

    // 閉め日情報取得
    function getSimeDD(){
        $http({
            url: dev.api + 'api/v1/simedd',
            method: 'GET',
        }).success(function(datas) {
            // 受注部門
            vm.simeddDropdown = [];
            angular.forEach(datas ,function(v){
                vm.simeddDropdown.push({'text':v.sime_dd_nm, 'click': 'invoicedata.simeddSelect("'+ v.sime_dd +'","'+ v.sime_dd_nm +'")'});
            });
        });
    }
    vm.simeddSelect = function(sime_dd, sime_dd_nm){
        vm.sime_dd_nm = sime_dd_nm;
        vm.form.sime_dd = sime_dd;
    };

    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 請求単位名称取得
    vm.SetSeikyuTaniNm = function(sk_tani){
        var name;
        angular.forEach(vm.commondata.seikyuTani ,function(v){
            if(v.sk_tani === sk_tani) name = v.sk_nm;
        });
        return name;
    }


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            if( vm.form.fromHkDate && is('Date', vm.form.fromHkDate) ){
                vm.form.fromHkDate = moment(vm.form.fromHkDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilHkDate && is('Date', vm.form.untilSkDate) ){
                vm.form.untilHkDate = moment(vm.form.untilHkDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/invoicedata',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    // アイテム選択
    vm.allChecked = function(itemAllChecked){
        var res = !itemAllChecked;
        vm.itemAllChecked = res;
        angular.forEach(vm.datas,function(v,k){
            v.checked = res;
            vm.datas[k] = v;
        });
    };

    // 印刷対象タイプ
    vm.typeCheck = [
        {'name':'請求書','type':'1','checked':false},
        {'name':'請求明細','type':'2','checked':false},
        {'name':'納品書','type':'3','checked':false}
    ];
    // 印刷対象タイプValidation
    $scope.$watch(function() { return vm.typeCheck;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            var checks = [];
            vm.typeCheckErr = true;
            angular.forEach(vm.typeCheck, function(item) {
                if (item.checked) checks.push(item.sk_no);
            });
            if(checks.length > 0){
                vm.typeCheckErr = false;
            }
        }
    }, true);

    // 印刷タイプ選択Modal
    vm.selectModal = $modal({
        templateUrl:'app/invoice-data/select-modal.html',
        scope: $scope,
        show:false
    });
    vm.openSelectModal = function(){
        vm.selectModal.$promise.then(vm.selectModal.show);
    };
    vm.hideSelectModal = function(){
        vm.selectModal.$promise.then(vm.selectModal.hide);
    };
    vm.invoiceGenerateCheck = function(){
        vm.generateCheckErr = false;
        vm.openSelectModal();
    };

    // 発行実行
    vm.generateCheckErr = false;
    vm.invoiceGenerate = function(){
        var checks = [];
        vm.generateCheckErr = false;
        angular.forEach(vm.datas, function(item) {
            if (item.checked) checks.push(item.sk_no);
        });
        if(checks.length > 0){
            vm.getInvoiceData(checks);
        }else{
            vm.generateCheckErr = true;
        }
    };
    // 対象データ取得
    vm.getInvoiceData = function(checks){
        if(!checks) return false;
        //console.log(checks);
        $http({
            url: dev.api + 'api/v1/invoiceprint',
            method: 'GET',
            params: { checks : angular.toJson(checks) }
        }).success(function(data) {

            var typeCheck = [];
            vm.generateCheckErr = false;
            angular.forEach(vm.typeCheck, function(item,k) {
                if (item.checked) typeCheck.push(item.type);
            });
            data.typeCheck = typeCheck;
            $log.debug(data);
            storage.set('printTargetData', data);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $rootScope.openWindow = $window.open('#/print/invoice', '_blank','width=830,height=800,scrollbars=1,location=0');
        });
    };

    // 売上明細確認Modal
    vm.detailModal = $modal({
        templateUrl:'app/invoice-data/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    vm.getUriageDtl = function(item){
        vm.detail = {};
        vm.detail.uriageDtl = [];
        //console.log(item);
        vm.getUrDtlData(item.sk_no);
    };
    // 売上明細データ取得
    vm.getUrDtlData = function(sk_no){
        $http({
            url: dev.api + 'api/v1/invoiceskdetail',
            method: 'GET',
            params: { sk_no : sk_no }
        }).success(function(data) {
            $log.debug(data);
            vm.openDetailModal();
            vm.detail.uriage = data.seikyu;
            vm.detail.uriageDtl = data.seikyuDtl;
            vm.detailForm = {};
            vm.detailForm.sk_no = data.seikyu.sk_no;
            vm.sk_check = data.seikyu.sk_check;

            vm.detailForm.kijun_kn = data.seikyu.kijun_kn;
            vm.detailForm.nebiki_kn = data.seikyu.nebiki_kn;
            vm.detailForm.tokubiki_kn = data.seikyu.tokubiki_kn;
            vm.detailForm.hiki_kn = data.seikyu.hiki_kn;
            vm.detailForm.tokubiki_ritu = MathRound( ( vm.detailForm.tokubiki_kn / vm.detailForm.hiki_kn )*100, 1);
            vm.detailForm.zei_kn = data.seikyu.zei_kn;
            vm.detailForm.sk_kn = data.seikyu.sk_kn;
        });
    };

    // 売上計算
    vm.uriageCalculation = function(){
        /*
         * kijun_kn 利用金額
         * nebiki_kn 値引
         * tokubiki_kn 特引
         * tokubiki_ritu 特引率
         * hiki_kn 差引(税抜)
         * zei_kn 消費税
         * sk_kn 請求
         */
        var hiki_kn = vm.detail.uriage.kijun_kn - vm.detail.uriage.nebiki_kn;
        if( vm.detailForm.tokubiki_kn > 0){
            vm.detailForm.hiki_kn = hiki_kn - vm.detailForm.tokubiki_kn;
        }else{
            vm.detailForm.hiki_kn = vm.detail.uriage.kijun_kn - vm.detail.uriage.nebiki_kn;
        }
        vm.detailForm.zei_kn = Math.floor(vm.detailForm.hiki_kn * vm.commondata.taxrate);
        vm.detailForm.sk_kn = Math.floor(Number(vm.detailForm.hiki_kn) + Number(vm.detailForm.zei_kn));
        vm.detailForm.tokubiki_ritu = MathRound( ( vm.detailForm.tokubiki_kn / hiki_kn )*100, 1);
    };

    // 売上計算実行
    $scope.$watch(function() { return vm.detailForm.tokubiki_kn;},
        function(newVal,oldVal) {
            if(newVal !== oldVal){
                vm.uriageCalculation();
            }
    }, true);

    // 請求割引実行
    vm.tokubikiSubmit = function(){
        $http({
            url: dev.api + 'api/v1/invoicdiscount',
            method: 'POST',
            params: { form : vm.detailForm }
        }).success(function(data) {
            $log.debug(data);
            toastr.info('請求値引きが完了しました。', 'Info');
            vm.getUrDtlData(vm.detailForm.sk_no);
            getResultsPage(1);
        });
    };

    // 請求削除
    vm.seikyuDelete = function(sk_no){
        $http({
            url: dev.api + 'api/v1/invoiceskdel',
            method: 'POST',
            params: { sk_no : sk_no }
        }).success(function(data) {
            $log.debug(data);
            var message = '請求No.'+sk_no+'の削除が完了しました。';
            toastr.info(message, 'Info');
            getResultsPage(1);
            vm.hideSelectModal();
        });
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('InvoiceaddController', InvoiceaddController);

  /** @ngInject */
  function InvoiceaddController($log, $timeout, $http, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr, $window) {

    $log.debug('InvoiceaddController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(1,'012');

    // モード切替
    vm.mode = 'data';
    if($stateParams.mode !== 'data'){
        vm.mode = $stateParams.mode;
    }

    /*
     * 発行済み請求書・納品書を検索・プレビュー（印刷）するモード
     * 未発行請求書を発行するモード
     */

    // 検索フォーム初期化
    vm.genCnt = 0;
    vm.genEnd = false;
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.toku_nm = '';
        vm.form.toku_cd = null;
        vm.sime_dd_nm = null;
        vm.form.sk_sime_dd = null;
        vm.form.any_time_check = 0;
        vm.form.re_genarate = 0;
        var from = new Date();
        vm.form.fromDate = new Date(from.setDate(1));

        //vm.itemAllChecked = 1;
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        //getResultsPage(1);
        vm.pagination = {current:1};
        getSimeDD();

    };
    vm.formInit();

    // 使いまわしデータ取得
    vm.commondata = storage.get('commondata');
    
    // 請求単位名称
    vm.getSeikyuTaniName = function(sk_tani){
        var ret;
        angular.forEach(vm.commondata.seikyuTani,function(v){
            if(v.sk_tani === sk_tani) ret = v.sk_nm;
        });
        return ret;
    }
    
    // 閉め日情報取得
    function getSimeDD(){
        $http({
            url: dev.api + 'api/v1/simedd',
            method: 'GET',
        }).success(function(datas) {
            // 受注部門
            vm.simeddDropdown = [];
            angular.forEach(datas ,function(v){
                vm.simeddDropdown.push({'text':v.sime_dd_nm, 'click': 'invoiceadd.simeddSelect("'+ v.sime_dd +'","'+ v.sime_dd_nm +'")'});
            });
        });
    }
    // 閉め日選択
    vm.simeddSelect = function(sime_dd, sime_dd_nm){
        vm.sime_dd_nm = sime_dd_nm;
        vm.form.sk_sime_dd = sime_dd;
    };

    // 随時選択
    vm.changeFree = function(freeCheck){
        if(freeCheck) vm.form.skDate2 = null;
    };

    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        //getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
        if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
            vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
        }
        if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
            vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
        }
        search = vm.form;
        angular.forEach(search,function(v,k){
           if(!v) delete search[k];//不要なparamは削除
        });
        $http({
            url: dev.api + 'api/v1/invoicesearch',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            angular.forEach(datas.data, function(v, k){
                v.checked = true;
                vm.datas[k] = v;
            });
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // アイテム選択
    vm.allChecked = function(itemAllChecked){
        var res = !itemAllChecked;
        vm.itemAllChecked = res;
        angular.forEach(vm.datas,function(v,k){
            v.checked = res;
            vm.datas[k] = v;
        });
    };


    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    // 請求単位チェック
    vm.checkSkTani = function(item, checked){
        // 同じ受注番号で請求単位が作品単位となっているものを選択
        if(Number(item.sk_tani) === 2){
            angular.forEach(vm.datas, function(v,k){
                if( item.nh_no !== v.nh_no && item.ju_no === v.ju_no){
                    //console.log(v.sk_tani);
                    if(Number(v.sk_tani) === 2){
                        v.checked = checked;
                        vm.datas[k] = v;
                    }
                }
            });
        }
    };

    //　請求書再発行
    vm.invoiceReGenerate=function(){
        vm.form.re_genarate = 1;
        vm.invoiceGenerate();
    }
    
    // 請求書発行
    vm.invoiceGenerate = function(){
        var conditions = null;
        if(vm.form){
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            conditions = vm.form;
            angular.forEach(conditions,function(v,k){
               if(!v) delete conditions[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/invoicegenerate',
            method: 'POST',
            params: { conditions : conditions }
        }).success(function(cnt) {
            // form 初期化
            vm.formInit();
            vm.genCnt = cnt;
            vm.genEnd = true;
        });
    }
    
    /*
    // 請求書生成実行
    vm.generateCheckErr = false;
    vm.invoiceGenerateCheck = function(){
        var checks = [];
        vm.generateCheckErr = false;
        angular.forEach(vm.datas, function(item) {
            if (item.checked) checks.push({nh_no:item.nh_no,ju_no:item.ju_no});
        });
        if(checks.length > 0){
            vm.setInvoiceData(checks);
        }else{
            vm.generateCheckErr = true;
        }
    };
    
    
    // 対象データから請求書を生成
    vm.setInvoiceData = function(checks){
        if(!checks) return false;
        //console.log(checks);
        $http({
            url: dev.api + 'api/v1/invoicgenerate',
            method: 'POST',
            params: { checks : angular.toJson(checks)}
        }).success(function(data) {
            $log.debug(data);
            toastr.info('請求書・納品書の生成が完了しました。', 'Info');
            getResultsPage(1);
        });
    };

    // 売上明細確認Modal
    vm.detailModal = $modal({
        templateUrl:'app/invoice-add/detail-modal.html',
        scope: $scope,
        show:false
    });
    vm.openDetailModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.show);
    };
    vm.hideSelectModal = function(){
        vm.detailModal.$promise.then(vm.detailModal.hide);
    };
    vm.getUriageDtl = function(item){
        vm.detail = {};
        vm.detail.uriageDtl = [];
        vm.detail.uriage = item;

        vm.getUrDtlData(item.nh_no);
    };
    // 売上明細データ取得
    vm.getUrDtlData = function(nh_no){
        $http({
            url: dev.api + 'api/v1/invoiceurdtl',
            method: 'GET',
            params: { nh_no : nh_no }
        }).success(function(data) {
            $log.debug(data);
            vm.openDetailModal();
            vm.detail.uriageDtl = data.detail;
        });
    };
     */

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  /** @ngInject */
  function DashboardController($log, $timeout, $http, $auth, $rootScope, $state, $q, dev, storage) {

    $log.debug('DashboardController');

    var vm = this;
    // Menu
    $rootScope.panelSelected(7,'071');

    // 使いまわしデータを取得しておく
    $rootScope.getJuchuBumon = function(){
        $http({
            url: dev.api + 'api/v1/commondata',
            method: "GET",
        }).success(function(data) {
            storage.remove('commondata');
            storage.set('commondata', data);
        });
    };
    $rootScope.getJuchuBumon();
    
    vm.debug = true;
    vm.user = storage.get('user');
    vm.isAdmin = storage.get('isAdmin');
    if( (Number(vm.user.sys_admin_fl) === 1 && !vm.isAdmin) || vm.isAdmin){
        vm.isAdmin = true;
        storage.set('isAdmin', true);
    }
    
    vm.debugAuthChange = function(no){
        vm.user.sys_admin_fl = no;
        storage.set('user', vm.user);
        $state.go($state.current, {}, {reload: true});
    }
    
    // 古いlocalStorageを削除
    storage.remove('uriagePrintTargetData');
    storage.remove('uriagePrintTargetData');
    storage.remove('printTargetData');
    storage.remove('printSosData');
    storage.remove('printOaData');
    storage.remove('printMtsData');
    storage.remove('printMtokuData');
    storage.remove('printMtanData');
    storage.remove('printEsData');
    storage.remove('printIvlData');
    storage.remove('printIvsData');
    
    
    // 売上承認要求一覧を表示
    // フォーム初期化
    vm.formInit = function(){
        vm.totalKin = 0;
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 15;
        getResultsPage(1);
        vm.pagination = {current:1};
    };
    if( Number(vm.user.sys_admin_fl) === 1 | Number(vm.user.sys_admin_fl) === 2){
        vm.formInit();
    }
    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = {sn_fl:'01'};
        $http({
            url: dev.api + 'api/v1/workearnings',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalKin = datas.totalKin;
            vm.totalDatas = datas.total;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }
    

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('WkearnController', WkearnController);

  /** @ngInject */
  function WkearnController($log, $timeout, $window, $http, $filter, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr) {

    $log.debug('WkearnController');
    $scope.controllerAliasName = 'wkearn';
    
    var vm = this;
    vm.user = storage.get('user');
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    // 承認可能
    vm.approvalUser = false;
    if( vm.user.sys_admin_fl === '1' || vm.user.sys_admin_fl === '2' ){
        vm.approvalUser = true;
    }
    //console.log('isEditDisabled : ' + vm.isEditDisabled);
    // Menu
    $rootScope.panelSelected(0,'005');

    // Tooltip
    vm.editTooltipText1 = {'title': '-売上編集-<br />売上の編集と承認を行います'};
    vm.editTooltipText2 = {'title': '-売上閲覧-<br />売上の確認を行います'};

    // 他処理から引継ぎの場合
    vm.lead_ju_no = null;
    if( $stateParams.juno !== '000' && $stateParams.juno.length > 3 ){
        vm.lead_ju_no = $stateParams.juno;
        $timeout(function(){
            vm.editModeInit(1, $stateParams.juno);
        },1000);
    }
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');

    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        //vm.form.sn_fl_1 = '0';
        vm.bumon_nm = '';// 受注部門名
        vm.ju_tanto_nm = '';// 担当営業名
        vm.sg_bumon_nm = ''; // 作業予定部門名
        vm.simei_gj_nm_1 = '';// 作業予定担当者名
        vm.studio_nm = ''; //スタジオ名
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        vm.form.sg_bumon_cd = '';

        //vm.form.sg_no = '15205607';
        vm.form.sn_fl = '00';
        vm.sn_fl_nm = '問わず';
        vm.form.sk_fl = '00';
        vm.sk_fl_nm = '問わず';
        //vm.form.pr_fl = '02';
        vm.totalKin = 0;
        
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        
        vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        
        if( vm.user.tan_cd !== '9999' && vm.user.tan_cd !== '9998' ){
            var stChk = false;
            // 部門選択初期値
            angular.forEach(vm.commondata.bumon ,function(v,k){
                if(!stChk && vm.user.bumon_cd == v.bumon_cd){
                    vm.bumonSelect(v.bumon_cd, v.bumon_nm);
                    stChk = true;
                }
            });
            // 担当営業初期値
            if(stChk) vm.eigyoSelect(vm.user.tan_cd,　vm.user.syain_nm);
        }
        
        if( !vm.lead_ju_no ){
            if( $stateParams.param ){
                if($stateParams.param.mode === 'approval'){
                    // 承認要求一覧
                    vm.form.fromDate = null;
                    vm.form.untilDate = null;
                    vm.form.sn_fl = '01';
                    vm.sn_fl_nm = '要承認';
                }
            }
            $timeout(function() {
                getResultsPage(1);
            }, 1500);
        }
        vm.pagination = {current:1};

    };
    vm.clearDates = function() {
        vm.selectedDate = null;
    };


    // 請求単位名称
    vm.getSeikyuTaniName = function(sk_tani){
        var ret;
        angular.forEach(vm.commondata.seikyuTani,function(v){
            if(v.sk_tani === sk_tani) ret = v.sk_nm;
        });
        return ret;
    }
    // 受注部門
    vm.bumonDropdown = [{'text':'－－', 'click': 'wkearn.bumonSelect()'}];
    angular.forEach(vm.commondata.bumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'wkearn.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 作業部門
    vm.sgBumonDropdown = [{'text':'－－', 'click': 'wkearn.sgBumonSelect()'}];
    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
        vm.sgBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'wkearn.sgBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.ju_bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        }else{
            vm.form.ju_bumon_cd = '';
            vm.bumon_nm = '';
        }
    };
    // 作業部門選択
    vm.sgBumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.sg_bumon_cd = bumon_cd;
            vm.sg_bumon_nm = bumon_nm;
        }else{
            vm.form.sg_bumon_cd = '';
            vm.sg_bumon_nm = '';
        }
    };

    // 担当営業取得
    vm.eigyoDropdown = [];
    vm.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data, status, headers, config) {
            vm.eigyoDropdown = [{'text':'－－', 'click': 'wkearn.eigyoSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'wkearn.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 担当営業選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ju_tanto_cd = syain_cd;
            vm.ju_tanto_nm = syain_nm;
        }else{
            vm.form.ju_tanto_cd = '';
            vm.ju_tanto_nm = '';
        }
    };


    // プリント状態
    //vm.prflStatus = [{id:'00', name:'プリントのみ'}, {id:'01', name:'プリント以外'},{id:'02', name:'問わず'}];

    // 承認状態
    vm.snflStatus = [{id:'00', name:'問わず'},{id:'01', name:'要承認'},{id:'02', name:'承認済み'}, {id:'03', name:'未承認'}];
    vm.snflStatusDropdown = [];
    angular.forEach(vm.snflStatus ,function(v,k){
        vm.snflStatusDropdown.push({'text':v.name, 'click': 'wkearn.snflStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 承認状態選択
    vm.snflStatusSelect = function(id, name){
        vm.form.sn_fl = id;
        vm.sn_fl_nm = name;
    };
    // 請求状態
    vm.skflStatus = [{id:'00', name:'問わず'}, {id:'01', name:'請求済'},{id:'02', name:'未請求'}];
    vm.skflStatusDropdown = [];
    angular.forEach(vm.skflStatus ,function(v,k){
        vm.skflStatusDropdown.push({'text':v.name, 'click': 'wkearn.skflStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 請求状態選択
    vm.skflStatusSelect = function(id, name){
        vm.form.sk_fl = id;
        vm.sk_fl_nm = name;
    };


    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            if( vm.form.fromSkDate && is('Date', vm.form.fromSkDate) ){
                vm.form.fromSkDate = moment(vm.form.fromSkDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilSkDate && is('Date', vm.form.untilSkDate) ){
                vm.form.untilSkDate = moment(vm.form.untilSkDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/workearnings',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = [];
            vm.totalKin = 0;
            vm.currentpage = '';
            vm.totalDatas = '';
            if(vm.form.sg_bumon_cd && !vm.form.ju_bumon_cd){
                angular.forEach(datas.data, function(v){
                    if( angular.isDefined(v.detail) ){
                        vm.datas.push(v);
                    }
                });
            }else{
                vm.datas = datas.data;
            }
            
            vm.totalKin = datas.totalKin;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    // Error Message
    vm.errorModal = $modal({
        templateUrl:'app/business-workearnings/error.html',
        scope: $scope,
        show:false
    });
    vm.openError = function(){
        vm.errorModal.$promise.then(vm.errorModal.show);
    };
    vm.hideError = function(){
        vm.errorModal.$promise.then(vm.errorModal.hide);
    };
    
    vm.formInit();
    
    /****************************************************** Edit Area ************************************************/
    // Scopeに注意
    /*
     * 受注No(ju_no)を持って遷移してきた場合は
     * 新規売上登録画面を表示させる
     */

    // Formの無効化(disabled)
    vm.isFromDisabled = false;

    vm.editTemplateUrl = 'app/business-workearnings/uriageedit.html';
    // テンプレート切り替え
    //if(vm.lead_ju_no){
    //    vm.editTemplateUrl = 'app/business-workearnings/uriagenew.html';
    //}

    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:vm.editTemplateUrl,
        scope: $scope,
        show:false
    });
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };

    // EditMode init
    vm.sgKeitaiReadSleep = false;
    vm.editForm = {};
    vm.editForm.sgurDtl = {};
    vm.editForm.sgurMemo = {};
    vm.editScope = {};
    vm.editMode = 1;
    vm.completeScope = {};
    vm.editScope.uriageDtl = [];
    vm.dummyUriageDtl = [];
    vm.sgDtlSelectMode = false;
    vm.approvalEditCheck = true;
    vm.editModeInit = function(mode, ju_no, nh_no ){

        vm.editScope.editMode = mode;
        vm.isFromDisabled = false;
        vm.isAddDisabled = false;
        vm.isFormKinAddErr = false;
        vm.approvalEditCheck = true;
        // 新規登録
        if(mode === 1 && ju_no && !nh_no){
            vm.editMode = mode;
            // From初期化
            vm.editScope.item = {};
            vm.editForm = {};
            vm.sgKeitaiReadSleep = true;
            vm.sgDtlSelectMode = false;
            vm.approvalEditCheck = true;

            // 作業売上データ取得
            $http({
                    url: dev.api + 'api/v1/completedetail',
                    method: 'GET',
                    params: {ju_no:ju_no}
            }).success(function(data) {
                if(data.order){
                    $log.debug(data);
                    var uriage = data.detail;
                    var order = data.order;
                    var uriageDtl = [];
                    vm.completeData = data;

                    // 作業予定
                    vm.editForm.ju_no = order.ju_no;                 // 受注No.
                    vm.editForm.nh_no = '';                          // 納品No.

                    vm.editForm.ur_day = new Date();                 // 売上計上日 Default Now

                    vm.editForm.toku_cd = order.toku_cd;             // 得意先CD
                    vm.editForm.toku_nm = order.toku_nm;             // 得意先名
                    vm.editForm.toku_busyo = order.toku_bumon_nm;    // 得意先部署名
                    vm.editForm.toku_tanto = order.toku_tanto_nm;    // 得意先担当者名
                    vm.editForm.keisyo = order.keisyo;               // 得意先敬称
                    vm.editForm.sakuhin_nm = order.hin_nm;           // 作品名

                    var kj_ur_kin=0,jt_ur_kin=0,nebiki_kin=0,zei_kin=0,nebiki_ritu=0;
                    angular.forEach(uriage, function(val,key){
                        angular.forEach(val.sgurDtl, function(v,k){
                            kj_ur_kin = kj_ur_kin + v.kin;
                            // 売上明細作成
                            var data = {
                                    'nh_no':'',
                                    'gyo_no':'',
                                    'sg_no':v.sg_no,
                                    'sg_gyo_no':v.gyo_no,
                                    'sg_day':val.sgur.sg_day,
                                    'sg_day_time':val.sgur.sg_day_time,
                                    'sg_bmn_cd':val.sgur.sg_bmn_cd,
                                    'studio_cd':val.sgur.studio_cd,
                                    'sg_bunrui_cd':v.sg_bunrui_cd,
                                    'sg_item_cd':v.sg_item_cd,
                                    'sg_item_nms':v.sg_item_nms,
                                    'stt_tm':v.stt_tm,
                                    'stt_tm_str':v.stt_tm,
                                    'end_tm':v.end_tm,
                                    'end_tm_str':v.end_tm,
                                    'media_cd_1':v.media_cd_1,
                                    'media_cd_2':v.media_cd_2,
                                    'suryo_1':v.suryo_1,
                                    'tani_1':v.tani_1,
                                    'suryo_2':v.suryo_2,
                                    'tani_2':v.tani_2,
                                    'tanka':v.tanka,
                                    'kin':v.kin,
                                    'jt_ur_kin':'',
                                    'oa_prt_fl':v.oa_prt_fl,
                                    'ur_checked': 1,
                                    'sg_checked': 1,
                                    'gr_arr_no': 0,
                                    'form_jt_ur_kin':0
                                };
                                uriageDtl.push(data);
                        });
                    });
                    //$log.debug(uriageDtl);
                    vm.editForm.kj_ur_kin = kj_ur_kin;              // 基準売上
                    vm.editForm.jt_ur_kin = kj_ur_kin;              // 実売上
                    vm.editForm.nebiki_kin = nebiki_kin;            // 値引き
                    vm.editForm.zei_kin = Math.floor(kj_ur_kin * vm.commondata.taxrate);// 消費税
                    vm.editForm.nebiki_ritu = nebiki_ritu;          // 値引き率
                    vm.editForm.nebiki_riyu = '';                   // 値引き理由

                    vm.editScope.goukei = Number(vm.editForm.jt_ur_kin) + Number(vm.editForm.zei_kin);

                    vm.editForm.biko_1 = '';               // 備考1
                    vm.editForm.biko_2 = '';               // 備考2
                    vm.editForm.biko_3 = '';               // 備考3

                    vm.editForm.sk_no = '';                 // 請求No.
                    vm.editForm.sk_day = new Date();// 請求日 Default Now

                    vm.editForm.nh_print_fl = 0;            // プリントFLG
                    vm.editForm.sk_dtl_print_fl = 0;        // 詳細プリントFLG

                    vm.editForm.sk_jt_kb = '1';             // 実売区分
                    vm.editForm.nk_end_fl = 0;              // 入金完了FLG

                    vm.editForm.z_if_fl = 0;                //
                    vm.editForm.z_den_no = '';              // ？伝票No.
                    vm.editForm.z_den_ts_no = '';           // ?伝票
                    vm.editForm.sk_tani = order.sk_tani;    // 請求単位

                    /* 
                     * 明細グループごとにPaging
                     * 新規の場合は初期は1ページのみ
                     */
                    //console.log(vm.editScope.uriageDtl)
                    vm.editScope.uriageDtlTotal = 1;
                    vm.editScope.pagination = {current:1};

                    // DataPicker
                    vm.editScope.selectedDate = new Date();
                    vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

                    // 作業詳細データにチェックフラグを追加
                    angular.forEach(vm.completeData.detail, function(comVal,comKey){
                        angular.forEach(uriageDtl, function(uriVal,uriKey){
                            // 親チェック
                            if(comVal.sgur.sg_no === uriVal.sg_no){
                                vm.completeData.detail[comKey].sgur.checked = 1;
                                // 子チェック
                                angular.forEach(comVal.sgurDtl, function(v,k){
                                    if(v.sg_item_cd === uriVal.sg_item_cd){
                                        vm.completeData.detail[comKey].sgurDtl[k].checked = 1;
                                    }
                                    // 配列初期値
                                    vm.completeData.detail[comKey].sgurDtl[k].gr_arr_no = 0;
                                });
                            }
                        });
                    });
                    // 親フォーム値(初期値)を詳細に追加
                    angular.forEach(uriageDtl, function(v,k){
                        uriageDtl[k].form_editForm = angular.copy(vm.editForm);
                    });
                    vm.editScope.dummyUriageDtl = uriageDtl;
                    vm.editScope.uriageDtl.push(uriageDtl);

                    
                    //console.log(vm.editForm);
                    
                    vm.editInit();
                }
            });

        // 編集モード
        }else if(mode === 2 && ju_no && nh_no){
            vm.editScope.uriageDtl = [];
            vm.dummyUriageDtl = [];
            vm.editMode = mode;
            vm.editScope.item = {};
            vm.editForm = {};
            vm.editScope.item.bumon_nm = '';        // 受注部門名
            vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
            vm.editScope.item.sg_bmn_nm = '';    // 作業予定部門名
            //vm.editScope.item.simei_gj_nm_1 = '';   // 作業予定担当者名
            //vm.editScope.item.studio_nm = '';     // スタジオ名
            vm.editForm.sg_time = '';
            vm.sgKeitaiReadSleep = true;
            vm.sgDtlSelectMode = false;
            vm.uriagePrint = true;//常に許可
            vm.originData = [];

            $http({
                url: dev.api + 'api/v1/wkearningsdetail',
                method: 'GET',
                params: {ju_no:ju_no,nh_no:nh_no}
            }).success(function(data) {
                if(data.uriage){
                    $log.debug(data);
                    var uriage = data.uriage;
                    var order = data.order;
                    var uriageDtl = data.uriageDtl;
                    vm.originData = data;
                    
                    // 承認済みの場合は編集不可
                    if(Number(uriage.sn_fl_1) === 2 || uriage.sn_fl_2 > 0){
                        toastr.info('承認済みのため、編集できません', 'Info');
                        vm.uriagePrint = true;
                        vm.isFromDisabled = true;
                    }

                    // 作業予定
                    vm.editForm.ju_no = uriage.ju_no;                 // 受注No.
                    vm.editForm.nh_no = uriage.nh_no;                 // 納品No.
                    if(uriage.ur_day_time > 0){
                        vm.editForm.ur_day = new Date(uriage.ur_day_time*1000);// 売上計上日
                    }
                    vm.editForm.toku_cd = uriage.toku_cd;             // 得意先CD
                    vm.editForm.toku_nm = order.toku_nm;             // 得意先名
                    vm.editForm.toku_busyo = uriage.toku_busyo;       // 得意先部署名
                    vm.editForm.toku_tanto = uriage.toku_tanto;       // 得意先担当者名
                    vm.editForm.keisyo = uriage.keisyo;               // 得意先敬称
                    vm.editForm.sakuhin_nm = uriage.sakuhin_nm;       // 作品名

                    vm.editForm.kj_ur_kin = uriage.kj_ur_kin;         // 基準売上
                    vm.editForm.jt_ur_kin = uriage.jt_ur_kin;         // 実売上
                    vm.editForm.nebiki_kin = uriage.nebiki_kin;       // 値引き
                    vm.editForm.zei_kin = uriage.zei_kin;             // 消費税
                    vm.editForm.nebiki_ritu = uriage.nebiki_ritu;     // 値引き率
                    vm.editForm.nebiki_riyu = uriage.nebiki_riyu;     // 値引き理由

                    vm.editScope.goukei = Number(vm.editForm.jt_ur_kin) + Number(vm.editForm.zei_kin);

                    vm.editForm.biko_1 = uriage.biko_1;               // 備考1
                    vm.editForm.biko_2 = uriage.biko_2;               // 備考2
                    vm.editForm.biko_3 = uriage.biko_3;               // 備考3

                    vm.editForm.sk_no = uriage.sk_no;                 // 請求No.
                    if(uriage.sk_day_time > 0){
                        vm.editForm.sk_day = new Date(uriage.sk_day_time*1000);// 請求日(予定)
                    }
                    vm.editForm.sn_fl_1 = Number(uriage.sn_fl_1);     // 承認FLG1
                    vm.editForm.sn_fl_2 = Number(uriage.sn_fl_2);     // 承認FLG2
                    vm.editForm.sn_end_fl = Number(uriage.sn_end_fl); // 承認完了FLG

                    vm.editForm.nebiki_fl = Number(uriage.nebiki_fl); // 値引きFLG

                    vm.editForm.nh_print_fl = Number(uriage.nh_print_fl);// プリントFLG
                    vm.editForm.sk_dtl_print_fl = Number(uriage.sk_dtl_print_fl);// 詳細プリントFLG

                    vm.editForm.sk_jt_kb = Number(uriage.sk_jt_kb);   // 実売区分

                    if(uriage.nk_yt_day_time > 0){
                        vm.editForm.nk_yt_day = new Date(uriage.nk_yt_day_time*1000);// 入金予定
                    }
                    vm.editForm.nk_end_fl = Number(uriage.nk_end_fl);   // 入金完了FLG

                    // zがつくものは奉行(財務)関連なので無視
                    vm.editForm.z_if_fl = Number(uriage.z_if_fl);       //
                    vm.editForm.z_den_no = uriage.z_den_no;             // ？伝票No.
                    vm.editForm.z_den_ts_no = uriage.z_den_ts_no;       // ?伝票
                    vm.editForm.sk_tani = uriage.sk_tani;               // 請求単位

                    // 配列keyを付与
                    angular.forEach(uriageDtl, function(v,k){
                        uriageDtl[k].gr_arr_no = 0;
                    });
                    
                    vm.editScope.uriageDtlTotal = 1;
                    vm.editScope.pagination = {current:1};
                    // 親フォーム値(初期値)を詳細に追加
                    angular.forEach(uriageDtl, function(v,k){
                        uriageDtl[k].form_editForm = angular.copy(vm.editForm);
                    });
                    vm.editScope.dummyUriageDtl = uriageDtl;
                    vm.editScope.uriageDtl.push(uriageDtl);


                    // 作業状態
                    //vm.editScope.sgjtDisplay(sgur.sg_jt_kb);
                    // PrintShow
                    //vm.editScope.printShow = false;
                    // DataPicker
                    vm.editScope.selectedDate = new Date();
                    vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

                    // 作業売上データ取得
                    $http({
                        url: dev.api + 'api/v1/completedetail',
                        method: 'GET',
                        params: {ju_no:ju_no}
                    }).success(function(ret) {
                        vm.completeData = ret;

                        // 売上データに反映されているものはすべてチェックして表示
                        angular.forEach(vm.completeData.detail, function(comVal,comKey){
                            angular.forEach(uriageDtl, function(uriVal,uriKey){
                                // 親チェック
                                if(comVal.sgur.sg_no === uriVal.sg_no){

                                    // checkbox チェック
                                    vm.completeData.detail[comKey].sgur.checked = 1;

                                    // 子チェック
                                    angular.forEach(comVal.sgurDtl, function(v,k){
                                        if(uriVal.ur_checked && v.sg_item_cd === uriVal.sg_item_cd){
                                            vm.completeData.detail[comKey].sgurDtl[k].checked = 1;
                                            vm.completeData.detail[comKey].sgurDtl[k].gr_arr_no = 0;
                                            //console.log('cheked : ' + v.gyo_no);
                                        }else{
                                            if(!uriVal.ur_checked && v.sg_item_cd === uriVal.sg_item_cd){
                                                vm.completeData.detail[comKey].sgurDtl[k].sliced_checked = 1;
                                            }
                                        }
                                        // 配列初期値
                                        //vm.completeData.detail[comKey].sgurDtl[k].gr_arr_no = 0;
                                    });
                                }
                            });
                        });
                        // 承認済みの場合は編集用データの初期化は不要
                        if(!vm.isFromDisabled){
                            vm.editInit();
                        }else{
                            vm.filteredDtl = vm.editScope.uriageDtl[0];
                        }
                        $log.debug(vm.completeData);
                        
                        if(vm.approvalUser){
                            $timeout(function(){
                                $scope.$watch(function() { return vm.editForm;}, function(newVal,oldVal) {
                                    if( (newVal.ju_no === oldVal.ju_no) && (newVal !== oldVal) ){
                                        vm.approvalEditCheck = false;
                                    }
                                }, true);
                            },1500);
                        }
                        
                    });
                }
            });
        }

        // 画面Open
        vm.openEdit();
    };
    
    // 印刷確認Modal
    vm.printModal = $modal({
        templateUrl:'app/business-workearnings/print.html',
        scope: $scope,
        show:false
    });
    vm.openPrint = function(){
        vm.printModal.$promise.then(vm.printModal.show);
    };
    vm.hidePrint = function(){
        vm.printModal.$promise.then(vm.printModal.hide);
    };
    // 見積もり印刷
    vm.addEstimate = function(){
        $log.debug(vm.originData);
        storage.set('uriagePrintTargetData', vm.originData);
        //storage.set('uriagePrintTargetData', vm.completeData);
        if( $rootScope.openWindow ){
            $rootScope.openWindow.focus();
            $rootScope.openWindow.close();
        }
        $rootScope.openWindow = $window.open('#/ur-print/estimate', '_blank','width=1100,height=800,scrollbars=1,location=0');
    }
    
    // 得意先検索実行
    vm.editScope.tokuisakiApiSearch = function(cd) {
        return $http({
            url: dev.api + 'api/v1/tokuisakicode',
            method: 'GET',
            params: {cd:cd}
        });
    };
    // 得意先の選択
    vm.editScope.tokuisakiSelected = function(selected) {
        if (selected) {
            //console.log(selected);
            vm.editForm.toku_cd = selected.originalObject.toku_cd;
            vm.editForm.toku_nm = selected.originalObject.name;
        }
    };

    // 請求単位Dropdown
    vm.editScope.seikyuTaniDropdown = [];
    var skTani = vm.commondata.seikyuTani;
    skTani.some(function(v, i){
        if (v.sk_tani === '1') skTani.splice(i,1);
    });
    angular.forEach(skTani ,function(v,k){
        vm.editScope.seikyuTaniDropdown.push({'name':v.sk_nm, 'id':v.sk_tani});
    });

    // Total金額
    vm.getTotalKin = function(item){
        var total = 0;
        angular.forEach(item, function(itm){
            if(itm.ur_checked) total += itm.kin;
        });
        return total;
    };
    // 作業売上 Total金額
    vm.getSgTotalKin = function(item){
        var total = 0;
        angular.forEach(item, function(itm){
            total += itm.sgur.sg_kin;
        });
        return total;
    };
    // メディア取得
    vm.getMediaName = function(cd){
        var name;
        angular.forEach(vm.commondata.media, function(v,k){
            if(v.media_cd === cd ){
                name = v.media_nm;
            }
        });
        return name;
    };

    // 売上計算
    vm.uriageCalculation = function(){
        vm.editForm.nebiki_kin = vm.editForm.kj_ur_kin - vm.editForm.jt_ur_kin;
        vm.editForm.zei_kin = Math.floor(vm.editForm.jt_ur_kin * vm.commondata.taxrate);
        vm.editScope.goukei = Number(vm.editForm.jt_ur_kin) + Number(vm.editForm.zei_kin);
        vm.editForm.nebiki_ritu = MathRound(100 - (MathRound( (vm.editForm.jt_ur_kin / vm.editForm.kj_ur_kin)*100, 2)),1);
    };

    
    // 売上計算実行
    $scope.$watch(function() { return vm.editForm.jt_ur_kin;},
        function(newVal,oldVal) {
            //console.log('jisshitu uriage');
            if(newVal !== oldVal){
                if( angular.isNumber(vm.editForm.jt_ur_kin) && vm.editForm.jt_ur_kin != 0){
                    // 売上明細の中に実売上金額を挿入
                    var index = vm.editScope.pagination.current-1;
                    angular.forEach(vm.editScope.uriageDtl[index], function(v,k){
                        v.form_jt_ur_kin = vm.editForm.jt_ur_kin;
                        v.form_editForm.jt_ur_kin = vm.editForm.jt_ur_kin;
                        //console.log(v.form_editForm);
                    });
                    // 一度も表示させていないページがあったらエラー(この計算実行時に判別できる）
                    if(vm.editScope.uriageDtl.length === vm.editScope.pagination.current){
                        vm.isFormKinAddErr = false;
                    }
                    //console.log(vm.editScope.uriageDtl);
                    vm.uriageCalculation();
                }
            }
    }, true);
    
    // 各ページのフォーム値を保存
    vm.formEditChange = function(newVal){
        //console.log('current : ' + vm.editScope.pagination.current);
        var index = vm.editScope.pagination.current-1;
        angular.forEach(vm.editScope.uriageDtl[index], function(v){
            //console.log('index :'+ index  +', toku_busyo : '+newVal.toku_busyo);
            v.form_editForm = newVal;
        });
    }
    
    
    // 実売り上げ計算(任意)
    vm.uriageAnyCalculation = function(jt_ur_kin){
        /*if(is('Number',vm.editForm.jt_ur_kin) && vm.editForm.jt_ur_kin > 0){
            vm.uriageCalculation();
        }
        */
    };

    /****** 明細選択処理系 編集 *****/

    vm.editInit = function(){
        //　初期売上明反映
        vm.filteredDtl = vm.editScope.uriageDtl[0];
        vm.completeScope = {};
        
        $scope.$watch(function() { return vm.editForm;},
            function(newVal,oldVal) {
                //console.log('editForm change');
                if(newVal !== oldVal){
                    if(vm.editScope.pagination){
                        vm.formEditChange(angular.copy(newVal));
                    }
                }
        }, true);
        
        // 親チェック
        vm.completeScope.parentChkChange = function(checked, index, sg_no){

            // 反映前データのフラグを反映
            /*angular.forEach(vm.editScope.dummyUriageDtl, function(val,key){
                if(val.sg_no === sg_no){
                    vm.editScope.dummyUriageDtl[key].ur_checked = checked;
                    vm.editScope.dummyUriageDtl[key].sg_checked = checked;
                }
            });*/
            // ぶら下がる子データをチェック
            angular.forEach(vm.completeData.detail, function(v,k){
                if(k === index ){
                    angular.forEach(v.sgurDtl, function(itm,ky){
                        vm.completeScope.childChkChange(checked, itm.gyo_no, itm.sg_no, itm.sg_item_cd, itm.gr_arr_no, k, ky);
                    });
                }
            });
            /*
            // 作業売上データにフラグを反映
            angular.forEach(vm.completeData.detail[index].sgurDtl, function(v,k){
                vm.completeData.detail[index].sgurDtl[k].checked = checked;
            });
            */
        };

        // 明細次のページ/前のページ
        vm.editScope.pageChanged = function(newPage) {
            //if(newPage > 0)
            //console.log(newPage);
            vm.filteredDtl = vm.editScope.uriageDtl[newPage-1];
            
            //console.log(vm.filteredDtl[0].form_editForm);
            vm.editForm = vm.filteredDtl[0].form_editForm;
            vm.uriageKinKeiasn(vm.filteredDtl);
            vm.editScope.pagination.current = newPage;
        };
        
        // 子チェック
        vm.completeScope.childChkChange = function(checked, gyo_no, sg_no, sg_item_cd, gr_arr_no, parentIndex, index){
            //console.log(gr_arr_no);
            // 現在の分割件(配列)数を計算
            var arrLen = vm.editScope.uriageDtl.length;
            if( arrLen > 0){
                gr_arr_no = gr_arr_no + (arrLen-1);
            }
            //console.log(gr_arr_no);
            // 選択明細
            angular.forEach(vm.editScope.dummyUriageDtl, function(v,k){
                if(v.sg_no === sg_no && v.sg_item_cd === sg_item_cd && v.sg_gyo_no === gyo_no){
                    vm.editScope.dummyUriageDtl[k].ur_checked = checked;
                    if(!checked){
                        //console.log('not checked');
                        vm.editScope.dummyUriageDtl[k].gr_arr_no = gr_arr_no+1;
                        vm.editScope.dummyUriageDtl[k].ur_checked = 1;
                    }else{
                        var arr = 0;
                        if(gr_arr_no > 0) arr-1; 
                        vm.editScope.dummyUriageDtl[k].gr_arr_no = arr;
                    }
                }
            });
            var cheker = function(target){
                var NoArr = [];
                angular.forEach(target, function(v){
                    NoArr.push(v.gr_arr_no);
                });
                return NoArr.reduce(function(preVal, currVal, index, arr){
                    //console.log(preVal * currVal);
                    return !((preVal * currVal) === 0) ;
              });
            }
            vm.isAddDisabled = false;
            if( cheker(vm.editScope.dummyUriageDtl) ){
                vm.openError();
                vm.errorMessage = '少なくともひとつ以上の明細は残してください。';
                vm.isAddDisabled = true;
            }
            
            //console.log(vm.editScope.dummyUriageDtl);
            angular.forEach(vm.editScope.dummyUriageDtl, function(v){
                //if(v.sg_gyo_no){
                  //  vm.openError
                //}
                    //console.log('sg_gyo_no: ' + v.sg_gyo_no + ', gr_arr_no:' + v.gr_arr_no + ', ur_checked: ' + v.ur_checked);
                //});
            });
            
            // 元明細（選択用)
            if(!checked){
                vm.completeData.detail[parentIndex].sgurDtl[index].gr_arr_no = gr_arr_no+1;
            }else{
                var arr = 0;
                if(gr_arr_no > 0) arr = gr_arr_no-1; 
                vm.completeData.detail[parentIndex].sgurDtl[index].gr_arr_no = arr;
            }
            vm.completeData.detail[parentIndex].sgurDtl[index].checked = checked;
        };
        // 子選択チェック
        vm.completeData.desabledCheck = function(item){
            var blakable = false;
            angular.forEach(item, function(v,k){
                if(!blakable) 
                    if(!v.checked) blakable = true;
            });
            return blakable;
        };
        
        // 明細チェック反映
        vm.editScope.dtlReflection = function(){
            //$log.debug(vm.editScope.dummyUriageDtl);
            //vm.editScope.uriageDtl = vm.editScope.dummyUriageDtl;
            // 選択済み明細と未選択明細を分ける
            vm.editScope.uriageDtl = [];
            var filtered = $filter('orderBy')($filter('groupBy')(vm.editScope.dummyUriageDtl,'gr_arr_no'),'-gr_arr_no');
            //console.log(filtered);
            angular.forEach(filtered, function(v){
                vm.editScope.uriageDtl.push(v);
            });
            //console.log(vm.editScope.uriageDtl);
            // 明細選択後の実態を反映
            vm.filteredDtl = vm.editScope.uriageDtl[0];
            
            // 売上トータル
            vm.editScope.uriageDtlTotal = vm.editScope.uriageDtl.length;
            vm.sgDtlSelectMode = false;
            
            // 明細反映後合計料金計算実行
            vm.uriageKinKeiasn(vm.filteredDtl);
            
            // 増えたデータ画面に未アクセスの場合submitをとめる
            if(vm.editScope.uriageDtlTotal > 1)
                vm.isFormKinAddErr = true;
            
            // 一度選択したものは操作不可とする
            angular.forEach(vm.completeData.detail, function(v,k){
                angular.forEach(v.sgurDtl, function(val,key){
                    vm.completeData.detail[k].sgur.disabled = !val.checked;
                    vm.completeData.detail[k].sgurDtl[key].disabled = !val.checked;
                });
            });
        };
    };
    
    // チェック後、ページング後金額計算
    vm.uriageKinKeiasn = function(uriageDtl){
        // 基準売上再計算
        vm.editForm.kj_ur_kin = vm.getTotalKin(uriageDtl);
        if(vm.editForm.jt_ur_kin > vm.editForm.kj_ur_kin){
            vm.editForm.jt_ur_kin = vm.editForm.kj_ur_kin;
            vm.editForm.nebiki_kin = 0;
        }
        vm.uriageCalculation();
    }

    // 売上計上日月内チェック
    vm.urDateCheck = function(dtl){
        var urDayArr = [];
        angular.forEach(dtl, function(v,k){
            urDayArr.push(moment(new Date(v[0].form_editForm.ur_day)).format('YYYYM'));
        });
        return urDayArr.reduce(function(preVal, currVal){
            return (preVal === currVal)?currVal:0;
        });
    }
    /********************/

    // 削除確認Modal
    vm.deleteCheckModal = $modal({
        templateUrl: 'app/business-workearnings/delcheck.html',
        scope: $scope,
        show:false
    });
    vm.openDelCheck = function(){
        vm.deleteCheckModal.$promise.then(vm.deleteCheckModal.show);
    };
    vm.hideDelcheck = function(){
        vm.deleteCheckModal.$promise.then(vm.deleteCheckModal.hide);
    };
    // 売上削除チェック
    vm.delCheck = {};
    vm.editScope.uriageDelete = function(){
        $http({
            url: dev.api + 'api/v1/workearningdeletecheck',
            method: 'GET',
            params: {ju_no:vm.editForm.ju_no}
        }).success(function(ret) {
            //console.log(ret);
            vm.delCheck.type = 3;
            if(ret.length > 0 ){
                var cnt = 0;
                var data = [];
                angular.forEach(ret, function(v){
                    if(v.sn_fl_1 == 2 || v.sn_fl_2 > 0 ){
                        cnt++;
                    }
                    data.push(v.nh_no);
                });
                if( cnt > 0 ) {
                    vm.delCheck.type = 2;
                }else{
                    vm.delCheck.type = 1;
                }
                vm.delCheck.data = data;
            }
            vm.openDelCheck();
        });
    };
    
    // formSubmit
    vm.editScope.uriageSubmit = function(method){
        // 計上日チェック(すべて月内であれば0以上が返ってくる）
        if( vm.urDateCheck(vm.editScope.uriageDtl) > 0){
            // 日付Fromat整形
            angular.forEach(vm.editScope.uriageDtl,function(v,key){
                angular.forEach(v,function(val){
                    if( val.form_editForm.nk_yt_day && is('Date', val.form_editForm.nk_yt_day) ){
                        val.form_editForm.nk_yt_day = moment(val.form_editForm.nk_yt_day).format('YYYY/MM/DD');
                    }
                    if( val.form_editForm.sk_day && is('Date', val.form_editForm.sk_day) ){
                        val.form_editForm.sk_day = moment(val.form_editForm.sk_day).format('YYYY/MM/DD');
                    }
                    if( val.form_editForm.ur_day && is('Date', val.form_editForm.ur_day) ){
                        val.form_editForm.ur_day = moment(val.form_editForm.ur_day).format('YYYY/MM/DD');
                    }
                    if(key !== 0 && method === 'PUT'){
                        delete val.form_editForm.nh_no;// 分割された先のデータからnh_noを排除
                    }
                });
            });
            
            //$log.debug(vm.editForm);
            $log.debug(vm.editScope.uriageDtl);
            var form = {'urData':vm.editScope.uriageDtl};
            var completeMessage = 'が完了しました';
            var subUrl = '';// POSTで切り分けてもいいかも
            if(method === 'PUT') {
                subUrl = '/put';
                if(!vm.editForm.nh_no){
                    return false;
                }
                completeMessage = '更新'+completeMessage;
            }else if(method === 'DELETE') {
                subUrl = '/delete';
                if(!vm.editForm.nh_no){
                    return false;
                }
                if( vm.editForm.sk_no ){
                    // 請求発行済み
                    toastr.error('請求書発行済みです。削除出来ません');
                    return false;
                }
                form = {nh_no:vm.editForm.nh_no,ju_no:vm.editForm.ju_no};
                completeMessage = '削除'+completeMessage;
                vm.delCheck = {};
                vm.hideDelcheck();
            }else{
                completeMessage = '登録'+completeMessage;
            }
           
            /*
             * $httpの送信を
             * params : value とするとurlqueryがPOSTでも付いてしまう
             * data : value とすると通常の送信(queryなし）で送信できる
             * 盲点だった
             */
            if(method === 'PUT' || method === 'POST') {
                $http({
                    url: dev.api + 'api/v1/workearnings' + subUrl,
                    method: method,
                    data: { form : form }
                }).success(function(data) {
                    // 登録完了
                    $log.debug(data);
                    // formクリア
                    if(method === 'POST'){
                        vm.lead_ju_no = null;
                        vm.hideEdit();
                        $state.go($state.current, {juno:'000'}, {reload: true});
                    }else{
                        getResultsPage(1);//一覧更新
                        vm.hideEdit();
                    }
                    toastr.success(completeMessage, 'Success');
                });
            }else{
                $http({
                    url: dev.api + 'api/v1/workearnings' + subUrl,
                    method: method,
                    params: { form : form }
                }).success(function(data) {
                    // 登録完了
                    $log.debug(data);
                    // formクリア
                    if(method === 'POST'){
                        vm.lead_ju_no = null;
                        vm.hideEdit();
                        $state.go($state.current, {juno:'000'}, {reload: true});
                    }else{
                        getResultsPage(1);//一覧更新
                        vm.hideEdit();
                    }
                    toastr.success(completeMessage, 'Success');
                });
            }
        }else{
            // 計上日が月内にまとまっていなかった場合、エラーとする
            vm.openError();
            vm.errorMessage = '明細の売上計上日は同月内になるように調整してください。月を分ける場合は作業売上で受注No変更を行ってください。';
        }
    };

    // formSubmit 承認
    vm.editScope.wkApprovalSubmit = function(mode){
        $log.debug(vm.editForm);

        var params = {ju_no:vm.editForm.ju_no,nh_no:vm.editForm.nh_no};
        var url = dev.api + 'api/v1/workearningapproval';
        var message = '承認しました';
        if(mode === 'request'){
            url = dev.api + 'api/v1/workearningapprovalrequest';
            message = '承認要求しました';
        }
        
        $http({
            url: url,
            method: 'POST',
            params: { form : params }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.success(message, 'Success');
        });
    };
    
    // formSubmit 承認取り消し
    vm.editScope.unApprovalSubmit = function(){
        $log.debug(vm.editForm);
        
        if( vm.editForm.sk_no ){
            // 請求発行済み
            toastr.error('請求書発行済みです。承認取消出来ません');
            return false;
        }
        var params = {ju_no:vm.editForm.ju_no,nh_no:vm.editForm.nh_no};
        var url = dev.api + 'api/v1/workearninganapproval';
        var message = '承認取消しました';
        
        $http({
            url: url,
            method: 'POST',
            params: { form : params }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.success(message, 'Success');
        });
    };

    
    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        if(mode === 1){
            $state.go($state.current, {juno:'000'}, {reload: true});
        }else{
            vm.hideEdit();
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('ReportController', ReportController);

  /** @ngInject */
  function ReportController($log, $timeout, $http, $auth, $filter, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr) {

    $log.debug('ReportController');
    $scope.controllerAliasName = 'report';
    /*
     * 作業報告TBからのデータの変数/項目名が
     * 本来は sghkとすべきところを sghtとしてしまっているので注意
     */

    var vm = this;
    vm.user = storage.get('user');
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    // 承認可能
    vm.approvalUser = false;
    if( vm.user.sys_admin_fl === '1' || vm.user.sys_admin_fl === '2' ){
        vm.approvalUser = true;
    }
    //console.log('isEditDisabled : ' + vm.isEditDisabled);
    // Menu
    $rootScope.panelSelected(0,'003');


    // Tooltip
    vm.editTooltipText1 = {'title': '-作業報告編集-<br />作業報告の編集と承認を行います'};
    vm.editTooltipText2 = {'title': '-作業報告閲覧-<br />作業報告の確認を行います'};
    vm.editTooltipText3 = {'title': '作業項目検索<br />チェックONでスペース検索、チェックOFFで直接ID検索です'};

    // 他処理から引継ぎの場合
    vm.lead_ju_no = null;
    if( ($stateParams.juno !== '000' && $stateParams.juno.length > 3 ) &&
            $stateParams.sgno !== '000' && $stateParams.sgno.length > 3 ){
        vm.lead_ju_no = $stateParams.juno;
        vm.lead_sg_no = $stateParams.sgno;
        $timeout(function(){
            vm.editModeInit(1, $stateParams.juno,$stateParams.sgno);
        },1000);
    }

    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        //vm.form.sn_fl_1 = '0';
        vm.bumon_nm = '';// 受注部門名
        vm.ju_tanto_nm = '';// 担当営業名
        vm.sg_bmn_nm = ''; // 作業予定部門名
        vm.simei_gj_nm_1 = '';// 作業予定担当者名
        vm.studio_nm = ''; //スタジオ名
        vm.form.sn_fl = '00';// 承認状態
        vm.sn_fl_nm = '問わず';
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);

        vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        
        if( vm.user.tan_cd !== '9999' && vm.user.tan_cd !== '9998' ){
            var stChk = false;
            // 部門選択初期値
            angular.forEach(vm.commondata.bumon ,function(v,k){
                if(!stChk && vm.user.bumon_cd == v.bumon_cd){
                    vm.bumonSelect(v.bumon_cd, v.bumon_nm);
                    stChk = true;
                }
            });
            // 担当営業初期値
            if(stChk) vm.eigyoSelect(vm.user.tan_cd,　vm.user.syain_nm);
        }
        
        if(!vm.lead_ju_no || !vm.lead_sg_no){
            // 受注指定検索
            if( $stateParams.param ){
                vm.form.fromDate = null;
                vm.form.untilDate = null;
                vm.form.ju_noFrom = $stateParams.param.ju_no;
                vm.form.ju_noTo = $stateParams.param.ju_no;
            }
            $timeout(function() {
                getResultsPage(1);
            }, 1500);
        }
        vm.pagination = {
            current: 1
        };

    };
    
    vm.clearDates = function() {
        vm.selectedDate = null;
    };




    // 受注部門
    vm.bumonDropdown = [{'text':'－－', 'click': 'report.bumonSelect()'}];
    angular.forEach(vm.commondata.bumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'report.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 作業部門
    vm.sghtDropdown = [{'text':'－－', 'click': 'report.sghtSelect()'}];
    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
        vm.sghtDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'report.sghtSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    //$log.debug(vm.sghtDropdown);
    // Studio
    vm.studioDropdown = [{'text':'－－', 'click': 'report.studioSelect()'}];
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.studioDropdown.push({'text':v.studio_cd + ' : '+ v.studio_nm, 'click': 'report.studioSelect("'+ v.studio_cd +'","'+ v.studio_nm +'")'});
    });

    // スタジオ表示用
    vm.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };
    // Studio選択
    vm.studioSelect = function(studio_cd, studio_nm){
        if(studio_cd && studio_nm){
            vm.form.studio_cd = studio_cd;
            vm.studio_nm = studio_nm;
        }else{
            vm.form.studio_cd = '';
            vm.studio_nm = '';
        }
    };

    // 作業部門選択
    vm.sghtSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.sg_bmn_nm = bumon_nm;
            vm.form.sg_bmn_cd = bumon_cd;
            vm.getsghtsyain(bumon_cd);
        }else{
            vm.sg_bmn_nm = '';
            vm.form.sg_bmn_cd = '';
        }
    };

    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.ju_bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        }else{
            vm.form.ju_bumon_cd = '';
            vm.bumon_nm = '';
        }
    };

    // 担当営業取得
    vm.eigyoDropdown = [];
    vm.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data, status, headers, config) {
            vm.eigyoDropdown = [{'text':'－－', 'click': 'report.eigyoSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'report.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 担当営業選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ju_tanto_cd = syain_cd;
            vm.ju_tanto_nm = syain_nm;
        }else{
            vm.form.ju_tanto_cd = '';
            vm.ju_tanto_nm = '';
        }
    };

    // 作業予定担当取得
    vm.sghtsyaDropdown = [];
    vm.getsghtsyain = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.sghtsyaDropdown = [{'text':'－－', 'click': 'report.sghtSyaSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.sghtsyaDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'report.sghtSyaSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 作業予定担当選択
    vm.sghtSyaSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.gj_cd_1 = syain_cd;
            vm.gj_nm_1 = syain_nm;
        }else{
            vm.form.gj_cd_1 = '';
            vm.gj_nm_1 = '';
        }
    };

    // 承認状態
    vm.snflStatus = [{id:'00', name:'問わず'},{id:'01', name:'承認済み'}, {id:'02', name:'未承認'}];
    vm.snflStatusDropdown = [];
    angular.forEach(vm.snflStatus ,function(v,k){
        vm.snflStatusDropdown.push({'text':v.name, 'click': 'report.snflStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 承認状態選択
    vm.snflStatusSelect = function(id, name){
        vm.form.sn_fl = id;
        vm.sn_fl_nm = name;
    };


    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/report',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };
    
    vm.formInit();

    /****************************************************** Edit Area ************************************************/
    // Scopeに注意
    /*
     * 受注No(ju_no)を持って遷移してきた場合は
     * 新規作業予定登録画面を表示させる
     * （受注情報を取得）
     * 編集の場合は作業予定No.(sg_no）から情報を取得
     */

    // Formの無効化(disabled)
    vm.isFromDisabled = false;

    // 編集詳細テンプレート
    // 作業形態を変更する場合にnew/editを入れ替えることでng-initを再度行う
    vm.templateInit = function(){
        vm.templateUrl_1 = null;
        vm.templateUrl_2 = null;
        vm.templateUrl_1 = 'app/business-report/editmode.html';
        vm.templateUrl_2 = 'app/business-report/newmode.html';
    }
    
    vm.templateInit();
    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/business-report/reportedit.html',
        scope: $scope,
        show:false
    });
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };

    // EditMode init
    vm.sgKeitaiReadSleep = false;
    vm.editForm = {};
    vm.editForm.sghtDtl = {};
    vm.editForm.sghtMemo = {};
    vm.editScope = {};
    vm.editModeInit = function(mode, ju_no, sg_no){
        vm.editScope.editMode = mode;
        vm.editScope.sgkyItems = {};
        vm.isFromDisabled = false;
        vm.approvalEditCheck = true;
        vm.templateInit();
        // 新規登録
        if(mode === 1 && ju_no && sg_no){
            // From初期化
            vm.editScope.item = {};
            vm.editForm = {};
            vm.editScope.item.bumon_nm = '';        // 受注部門名
            vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
            vm.editScope.item.sg_bmn_nm = '';    // 作業予定部門名
            //vm.editScope.item.simei_gj_nm_1 = '';   // 作業予定担当者名
            //vm.editScope.item.studio_nm = '';     // スタジオ名
            vm.editForm.sg_time = '';
            vm.sgKeitaiReadSleep = true;
            vm.editScope.sgkyItems = {};

            // 作業予定を取得して、フィールド名を変更
            $http({
                url: dev.api + 'api/v1/planningdetail',
                method: 'GET',
                params: {ju_no:ju_no,sg_no:sg_no}
            }).success(function(data) {
                if(data.sgyt){
                    $log.debug(data);
                    var sght = data.sgyt; // sgyt ⇒ sght
                    var order = data.order;
                    var sghtDtl = data.sgytDtl;// sgyt ⇒ sght

                    vm.order = order;
                    // 承認済みの場合は編集不可
                    if(sght.sn_fl_1 > 0){
                        toastr.info('承認済みのため、編集できません', 'Info');
                        vm.isFromDisabled = true;
                    }

                    // 作業予定
                    vm.editForm.ju_no = sght.ju_no;                 // 受注No.
                    vm.editForm.sg_no = sght.sg_no;                 // 作業No.
                    vm.editForm.sg_jt_kb = sght.sg_jt_kb;           // 作業状態
                    vm.editForm.gj_kb_1 = sght.gj_kb_1;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_2 = sght.gj_kb_2;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_3 = sght.gj_kb_3;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_4 = sght.gj_kb_4;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.sg_hk_fl = Number(sght.sg_hk_fl);   // 作業報告FLG(Default:0)
                    vm.editForm.print_fl = Number(sght.print_fl);   // プリントFLG(Default:0)
                    vm.editForm.sg_bmn_cd = sght.sg_yt_bmn_cd;      // 作業部門
                    vm.editForm.gyomu_kb = sght.gyomu_kb;           // 業務区分
                    vm.editForm.sg_keitai_cd = sght.sg_keitai_cd;   // 作業形態
                    vm.editForm.studio_cd = sght.studio_cd;         // 作業予定スタジオ
                    vm.editForm.sg_day = null;
                    if(sght.sg_yt_day_time > 0){
                        vm.editForm.sg_day = new Date(sght.sg_yt_day_time*1000);// 作業日
                    }
                    vm.editForm.sg_tm_fm = sght.sg_yt_tm_fm_str;  // 作業予定時間FROM
                    vm.editForm.sg_tm_to = sght.sg_yt_tm_to_str;  // 作業予定時間TO
                    vm.setsghtTime();//時間整形
                    vm.editForm.sg_time = sght.sg_yt_time;        // 作業予定時間 => 作業時間
                    vm.editForm.simei_gj_cd_1 = sght.simei_gj_cd_1;  // 指名技術員１
                    vm.editForm.simei_gj_cd_2 = sght.simei_gj_cd_2;  // 指名技術員２
                    //vm.editScope.item.simei_gj_nm_1 = sght.simei_gj_nm_1;  // 指名技術員１
                    //vm.editScope.item.simei_gj_nm_2 = sght.simei_gj_nm_2;  // 指名技術員２
                    //vm.editForm.cancel_day = null;                   // キャンセル日
                    //if(sght.cancel_day_time > 0){
                    //    vm.editForm.cancel_day = new Date(sght.cancel_day_time*1000);
                    //}
                    vm.editForm.gj_cd_1 = sght.gj_cd_1;              // 作業技術員１
                    vm.editForm.gj_tm_fm_1 = sght.gj_tm_fm_1_str;    // 作業時間FROM１
                    vm.editForm.gj_tm_to_1 = sght.gj_tm_to_1_str;    // 作業時間TO１
                    vm.setGjTime1();// 時間整形
                    vm.editForm.gj_time_mae_1 = sght.gj_time_mae_1;  // 作業時間前１
                    vm.editForm.gj_time_ato_1 = sght.gj_time_ato_1;  // 作業時間後１
                    vm.editForm.gj_time_1 = sght.gj_time_1;          // 作業時間１

                    vm.editForm.gj_cd_2 = sght.gj_cd_2;              // 作業技術員２
                    vm.editForm.gj_tm_fm_2 = sght.gj_tm_fm_2_str;    // 作業時間FROM２
                    vm.editForm.gj_tm_to_2 = sght.gj_tm_to_2_str;    // 作業時間TO２
                    vm.setGjTime2();//時間整形
                    vm.editForm.gj_time_2 = sght.gj_time_2;          // 作業時間２
                    vm.editForm.gj_time_mae_2 = sght.gj_time_mae_2;  // 作業時間前２
                    vm.editForm.gj_time_ato_2 = sght.gj_time_ato_2;  // 作業時間後２
                    vm.editForm.gj_cd_3 = sght.gj_cd_3;              // 作業技術員３
                    vm.editForm.gj_tm_fm_3 = sght.gj_tm_fm_3_str;    // 作業時間FROM３
                    vm.editForm.gj_tm_to_3 = sght.gj_tm_to_3_str;    // 作業時間TO３
                    vm.setGjTime3();//時間整形
                    vm.editForm.gj_time_3 = sght.gj_time_3;         // 作業時間３
                    vm.editForm.gj_time_mae_3 = sght.gj_time_mae_3; // 作業時間前３
                    vm.editForm.gj_time_ato_3 = sght.gj_time_ato_3; // 作業時間後３
                    vm.editForm.gj_cd_4 = sght.gj_cd_4;             // 作業技術員４
                    vm.editForm.gj_tm_fm_4 = sght.gj_tm_fm_4_str;   // 作業時間FROM４
                    vm.editForm.gj_tm_to_4 = sght.gj_tm_to_4_str;   // 作業時間TO４
                    vm.setGjTime4();//時間整形
                    vm.editForm.gj_time_4 = sght.gj_time_4;         // 作業時間４
                    vm.editForm.gj_time_mae_4 = sght.gj_time_mae_4; // 作業時間前４
                    vm.editForm.gj_time_ato_4 = sght.gj_time_ato_4; // 作業時間後４
                    vm.editForm.print_nh_dt = null;                 // プリント納品日
                    if(sght.print_nh_dt_time > 0){
                        vm.editForm.print_nh_dt = new Date(sght.print_nh_dt_time*1000);
                    }
                    vm.editForm.nh_kb = sght.nh_kb;                 // プリント納品区分
                    vm.editForm.nh_hosoku = sght.nh_hosoku;         // プリント納品補足
                    vm.editForm.genban_kb = sght.genban_kb;         // プリント原版区分

                    // 予定から引継ぎの場合で、作業項目未登録の場合は新しく登録できるような形を取る
                    if( sghtDtl.length > 0 ){
                        vm.editScope.sgkyItems = sghtDtl;
                    }else{
                        vm.editScope.getSgkeitaiitem(vm.editForm.sg_keitai_cd);
                        vm.templateUrl_1 = null;
                        $timeout(function(){
                            vm.templateUrl_1 = 'app/business-report/editmode.html';
                        },500);
                    }
                    
                    vm.editForm.sghtMemo = data.memo;

                    // 作業状態
                    vm.editScope.sgjtDisplay(sght.sg_jt_kb);
                    // PrintShow
                    //vm.editScope.printShow = false;
                    // DataPicker
                    vm.editScope.selectedDate = new Date();
                    vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

                    // 受注情報
                    // Form情報
                    vm.editForm.ju_no = sght.ju_no;             // 受注No.
                    vm.editForm.ju_tan_cd = order.ju_tanto_cd; // 担当営業CD
                    vm.editForm.ju_bmn_cd = order.ju_bumon_cd; // 担当営業CD
                    vm.editForm.toku_cd = order.toku_cd;         // 得意先CD
                    vm.editForm.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名

                    // 表示項目
                    vm.editScope.item.hin_nm = order.hin_nm; // 作品名
                    vm.editForm.sakuhin_nm = order.hin_nm; // 作品名(作業報告登録用)
                    vm.editScope.item.ju_tanto_nm = order.ju_tanto_nm; // 担当営業名
                    vm.editScope.item.ju_bumon_nm = order.ju_bumon_nm; // 受注部門名
                    vm.editScope.item.toku_bumon_nm = order.toku_bumon_nm; // 得意先部門名
                    vm.editScope.item.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名

                    $log.debug(vm.editForm);
                    
                    $timeout(function(){

                        $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                            url: dev.api + 'api/v1/tokuisakidata',
                            method: 'GET',
                            params: {cd:order.toku_cd}
                        }).success(function(tokuData) {
                            if(tokuData){
                                vm.editScope.item.toku_nm = tokuData.toku_nm;
                                vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;

                                // Printチェック
                                vm.sghtBmnCheck(sght.sg_yt_bmn_cd);
                                vm.sgKeitaiReadSleep = false;
                                
                                $timeout(function(){
                                    vm.changeGjKtPat1(0);
                                    vm.changeGjKtPat2(0);
                                    vm.changeGjKtPat3(0);
                                    vm.changeGjKtPat4(0);
                                },2000);
                                
                            }
                        });
                    },500);

                }
            });

        // 編集モード
        }else if(mode === 2 && ju_no && sg_no){
            vm.editScope.item = {};
            vm.editForm = {};
            vm.editScope.item.bumon_nm = '';        // 受注部門名
            vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
            vm.editScope.item.sg_bmn_nm = '';    // 作業予定部門名
            //vm.editScope.item.simei_gj_nm_1 = '';   // 作業予定担当者名
            //vm.editScope.item.studio_nm = '';     // スタジオ名
            vm.editForm.sg_time = '';
            vm.sgKeitaiReadSleep = true;
            vm.approvalEditCheck = true;
            vm.editScope.sgkyItems = {};

            $http({
                url: dev.api + 'api/v1/reportdetail',
                method: 'GET',
                params: {ju_no:ju_no,sg_no:sg_no}
            }).success(function(data) {
                if(data.sght){
                    $log.debug(data);
                    var sght = data.sght;
                    var order = data.order;
                    var sghtDtl = data.sghtDtl;
                    vm.order = order;
                    vm.sg_ur_snEndCnt = data.sg_ur_snEndCnt;
                    // 承認済みの場合は編集不可
                    if(sght.sn_fl_1 > 0){
                        toastr.info('承認済みのため、編集できません', 'Info');
                        vm.isFromDisabled = true;
                    }

                    // 作業予定
                    vm.editForm.ju_no = sght.ju_no;                 // 受注No.
                    vm.editForm.sg_no = sght.sg_no;                 // 作業No.
                    vm.editForm.sg_jt_kb = sght.sg_jt_kb;           // 作業状態
                    vm.editForm.gj_kb_1 = sght.gj_kb_1;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_2 = sght.gj_kb_2;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_3 = sght.gj_kb_3;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_4 = sght.gj_kb_4;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.sg_hk_fl = Number(sght.sg_hk_fl);   // 作業報告FLG(Default:0)
                    vm.editForm.print_fl = Number(sght.print_fl);   // プリントFLG(Default:0)
                    vm.editForm.sg_bmn_cd = sght.sg_bmn_cd;         // 作業部門
                    vm.editForm.gyomu_kb = sght.gyomu_kb;           // 業務区分
                    vm.editForm.sg_keitai_cd = sght.sg_keitai_cd;   // 作業形態
                    vm.editForm.studio_cd = sght.studio_cd;         // 作業予定スタジオ
                    vm.editForm.sg_day = null;
                    if(sght.sg_day_time > 0){
                        vm.editForm.sg_day = new Date(sght.sg_day_time*1000);// 作業日
                    }
                    // 作業報告承認時に作業売上に指名技術委員情報を引き継ぐ
                    vm.editForm.simei_gj_cd_1 = sght.simei_gj_cd_1;  // 指名技術員１
                    vm.editForm.simei_gj_cd_2 = sght.simei_gj_cd_2;  // 指名技術員２
                    
                    vm.editForm.sg_tm_fm = sght.sg_tm_fm_str;  // 作業予定時間FROM
                    vm.editForm.sg_tm_to = sght.sg_tm_to_str;  // 作業予定時間TO
                    vm.setsghtTime();//時間整形
                    vm.editForm.sg_time = sght.sg_time;        // 作業予定時間
                    vm.editForm.gj_cd_1 = sght.gj_cd_1;              // 作業技術員１
                    vm.editForm.gj_tm_fm_1 = sght.gj_tm_fm_1_str;    // 作業時間FROM１
                    vm.editForm.gj_tm_to_1 = sght.gj_tm_to_1_str;    // 作業時間TO１
                    vm.setGjTime1();                                 //時間整形
                    vm.editForm.gj_time_mae_1 = sght.gj_time_mae_1;  // 作業時間前１
                    vm.editForm.gj_time_ato_1 = sght.gj_time_ato_1;  // 作業時間後１
                    vm.editForm.gj_time_1 = sght.gj_time_1;          // 作業時間１

                    vm.editForm.gj_cd_2 = sght.gj_cd_2;              // 作業技術員２
                    vm.editForm.gj_tm_fm_2 = sght.gj_tm_fm_2_str;    // 作業時間FROM２
                    vm.editForm.gj_tm_to_2 = sght.gj_tm_to_2_str;    // 作業時間TO２
                    vm.setGjTime2();//時間整形
                    vm.editForm.gj_time_2 = sght.gj_time_2;          // 作業時間２
                    vm.editForm.gj_time_mae_2 = sght.gj_time_mae_2;  // 作業時間前２
                    vm.editForm.gj_time_ato_2 = sght.gj_time_ato_2;  // 作業時間後２
                    vm.editForm.gj_cd_3 = sght.gj_cd_3;              // 作業技術員３
                    vm.editForm.gj_tm_fm_3 = sght.gj_tm_fm_3_str;    // 作業時間FROM３
                    vm.editForm.gj_tm_to_3 = sght.gj_tm_to_3_str;    // 作業時間TO３
                    vm.setGjTime3();//時間整形
                    vm.editForm.gj_time_3 = sght.gj_time_3;         // 作業時間３
                    vm.editForm.gj_time_mae_3 = sght.gj_time_mae_3; // 作業時間前３
                    vm.editForm.gj_time_ato_3 = sght.gj_time_ato_3; // 作業時間後３
                    vm.editForm.gj_cd_4 = sght.gj_cd_4;             // 作業技術員４
                    vm.editForm.gj_tm_fm_4 = sght.gj_tm_fm_4_str;   // 作業時間FROM４
                    vm.editForm.gj_tm_to_4 = sght.gj_tm_to_4_str;   // 作業時間TO４
                    vm.setGjTime4();//時間整形
                    vm.editForm.gj_time_4 = sght.gj_time_4;         // 作業時間４
                    vm.editForm.gj_time_mae_4 = sght.gj_time_mae_4; // 作業時間前４
                    vm.editForm.gj_time_ato_4 = sght.gj_time_ato_4; // 作業時間後４
                    vm.editForm.print_nh_dt = null;                 // プリント納品日
                    if(sght.print_nh_dt_time > 0){
                        vm.editForm.print_nh_dt = new Date(sght.print_nh_dt_time*1000);
                    }
                    vm.editForm.nh_kb = sght.nh_kb;                 // プリント納品区分
                    vm.editForm.nh_hosoku = sght.nh_hosoku;         // プリント納品補足
                    vm.editForm.genban_kb = sght.genban_kb;         // プリント原版区分

                    vm.editScope.sgkyItems = sghtDtl;
                    vm.editForm.sghtMemo = data.memo;

                    // 作業状態
                    vm.editScope.sgjtDisplay(sght.sg_jt_kb);
                    // PrintShow
                    //vm.editScope.printShow = false;
                    // DataPicker
                    vm.editScope.selectedDate = new Date();
                    vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

                    // 受注情報
                    // Form情報
                    vm.editForm.ju_no = sght.ju_no;             // 受注No.
                    vm.editForm.ju_tanto_cd = order.ju_tanto_cd; // 担当営業CD
                    vm.editForm.toku_cd = order.toku_cd;         // 得意先CD
                    vm.editForm.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名

                    // 表示項目
                    vm.editScope.item.hin_nm = order.hin_nm; // 作品名
                    vm.editScope.item.ju_tanto_nm = order.ju_tanto_nm; // 担当営業名
                    vm.editScope.item.ju_bumon_nm = order.ju_bumon_nm; // 受注部門名
                    vm.editScope.item.toku_bumon_nm = order.toku_bumon_nm; // 得意先部門名
                    vm.editScope.item.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名

                    $timeout(function(){

                        $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                            url: dev.api + 'api/v1/tokuisakidata',
                            method: 'GET',
                            params: {cd:order.toku_cd}
                        }).success(function(tokuData) {
                            if(tokuData){
                                vm.editScope.item.toku_nm = tokuData.toku_nm;
                                vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;

                                // Printチェック
                                vm.sghtBmnCheck(sght.sg_bmn_cd);
                                vm.sgKeitaiReadSleep = false;
                                
                                $timeout(function(){
                                    vm.changeGjKtPat1(0);
                                    vm.changeGjKtPat2(0);
                                    vm.changeGjKtPat3(0);
                                    vm.changeGjKtPat4(0);
                                },1000);
                                
                            }
                        });
                    },500);

                    if(vm.approvalUser){
                        $timeout(function(){
                            $scope.$watch(function() { return vm.editForm;}, function(newVal,oldVal) {
                                if( (newVal.ju_no === oldVal.ju_no) && (newVal !== oldVal) ){
                                    vm.approvalEditCheck = false;
                                }
                            }, true);
                        },1500);
                    }
                    
                }
            });
        }

        // 画面Open
        vm.openEdit();
    };

    // 作業時間計算実行( 作業詳細用 )
    vm.setSghtColumnTime = function($index){
        if(vm.editForm.sghtDtl[$index].stt_tm && vm.editForm.sghtDtl[$index].end_tm){
            if(vm.editForm.sghtDtl[$index].stt_tm.length > 3 && vm.editForm.sghtDtl[$index].end_tm.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.sghtDtl[$index].stt_tm, vm.editForm.sghtDtl[$index].end_tm);
                $log.debug(rt);
                if(rt.time < -0.1){
                    toastr.warning('作業時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.sghtDtl[$index].suryo_1 = rt.time;
                    vm.editForm.sghtDtl[$index].stt_tm = rt.fromStr;
                    vm.editForm.sghtDtl[$index].end_tm = rt.toStr;
                    //vm.editScope.item. = rt.time + 'H';
                }
            }
        }
    };
    // 作業時間計算実行
    vm.setsghtTime = function(){
        if(vm.editForm.sg_tm_fm && vm.editForm.sg_tm_to){
            if(vm.editForm.sg_tm_fm.length > 3 && vm.editForm.sg_tm_to.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.sg_tm_fm, vm.editForm.sg_tm_to);
                //$log.debug(rt);
                if(rt.time < -0.1){
                    vm.editScope.sghtError = true;
                }else{
                    vm.editForm.sg_time = rt.time;
                    vm.editForm.sg_tm_fm = rt.fromStr;
                    vm.editForm.sg_tm_to = rt.toStr;
                    vm.editScope.sg_time = rt.time + 'H';
                    vm.editScope.sghtError = false;
                }
            }
        }
    };
    // 作業技術員１ 作業時間計算実行
    vm.setGjTime1 = function(){
        if(vm.editForm.gj_tm_fm_1 && vm.editForm.gj_tm_to_1){
            if(vm.editForm.gj_tm_fm_1.length > 3 && vm.editForm.gj_tm_to_1.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_1, vm.editForm.gj_tm_to_1);
                if(rt.time < -0.1){
                    toastr.warning('作業技術員１:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_1 = rt.time;
                    vm.editForm.gj_tm_fm_1 = rt.fromStr;
                    vm.editForm.gj_tm_to_1 = rt.toStr;
                    vm.editScope.gj_time_1 = rt.time + 'H';
                    vm.editScope.gjTime1Error = false;
                }
            }
        }
    };

    // 作業技術員２ 作業時間計算実行
    vm.setGjTime2 = function(){
        if(vm.editForm.gj_tm_fm_2 && vm.editForm.gj_tm_to_2){
            if(vm.editForm.gj_tm_fm_2.length > 3 && vm.editForm.gj_tm_to_2.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_2, vm.editForm.gj_tm_to_2);
                if(rt.time < -0.1){
                    toastr.warning('作業技術員２:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_2 = rt.time;
                    vm.editForm.gj_tm_fm_2 = rt.fromStr;
                    vm.editForm.gj_tm_to_2 = rt.toStr;
                    vm.editScope.gj_time_2 = rt.time + 'H';
                    vm.editScope.gjTime2Error = false;
                }
            }
        }
    };

    // 作業技術員３ 作業時間計算実行
    vm.setGjTime3 = function(){
        if(vm.editForm.gj_tm_fm_3 && vm.editForm.gj_tm_to_3){
            if(vm.editForm.gj_tm_fm_3.length > 3 && vm.editForm.gj_tm_to_3.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_3, vm.editForm.gj_tm_to_3);
                if(rt.time < -0.1){
                    toastr.warning('作業技術員３:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_3 = rt.time;
                    vm.editForm.gj_tm_fm_3 = rt.fromStr;
                    vm.editForm.gj_tm_to_3 = rt.toStr;
                    vm.editScope.gj_time_3 = rt.time + 'H';
                    vm.editScope.gjTime3Error = false;
                }
            }
        }
    };

    // 外部技術員 作業時間計算実行
    vm.setGjTime4 = function(){
        if(vm.editForm.gj_tm_fm_4 && vm.editForm.gj_tm_to_4){
            if(vm.editForm.gj_tm_fm_4.length > 3 && vm.editForm.gj_tm_to_4.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_4, vm.editForm.gj_tm_to_4);
                if(rt.time < -0.1){
                    toastr.warning('外部技術員:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_4 = rt.time;
                    vm.editForm.gj_tm_fm_4 = rt.fromStr;
                    vm.editForm.gj_tm_to_4 = rt.toStr;
                    vm.editScope.gj_time_4 = rt.time + 'H';
                    vm.editScope.gjTime4Error = false;
                }
            }
        }
    };



    // 作業部門 普通のDropdown
    vm.editScope.sghtDropdown = [{'name':'－－', 'id':null}];
    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
        vm.editScope.sghtDropdown.push({'name':v.bumon_nm, 'id':v.bumon_cd});
    });

    // 業務区分 普通のDropdown
    vm.editScope.gyomuDropdown = [{'name':'－－', 'id':null}];
    angular.forEach(vm.commondata.gyomu ,function(v,k){
        vm.editScope.gyomuDropdown.push({'name':v.gyomu_nm, 'id':v.gyomu_kb});
    });

    // メディア 普通のDropdown
    vm.editScope.mediaDropdown = [{'name':'－－', 'id':null}];
    angular.forEach(vm.commondata.media ,function(v,k){
        vm.editScope.mediaDropdown.push({'name':v.media_nm, 'id':v.media_cd});
    });

    // 作業予定スタジオ 普通のDropdown
    vm.editScope.studioDropdown = [{'name':'－－', 'id':null}];
    /*
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.editScope.studioDropdown.push({'name':v.studio_nm, 'id':v.studio_cd});
    });
    */

    // 業務区分表示用
    vm.editScope.getGyomuName = function(cd){
        var name;
        angular.forEach(vm.commondata.gyomu, function(v,k){
            if(v.gyomu_kb === cd ){
                name = v.gyomu_nm;
            }
        });
        return name;
    };
    // スタジオ表示用
    vm.editScope.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };

    /*
     * プリント有り
     * MA:0310 ビデオ:0320 旧テレシネ:0321 プロセス:0330 DVD:0331 テレシネ：0333
     * プリント無し
     * オーディオ技術:0120 マルチメディア:0130 デジタルイメージ：0334 開発部技術:0850
     *
     */
    vm.bumonPrintCd = ['0310','0320','0321','0330','0331','0333'];
    vm.sghtBmnCheck = function(bumon_cd){
        vm.editScope.printShow = false;
        var breaks = false;
        angular.forEach(vm.bumonPrintCd, function(v, k) {
            breaks = v == bumon_cd;
            if(breaks){
                vm.editScope.printShow = true;
            }
        });
    };

    vm.changeSgBmnCd = function(){
        vm.editForm.sg_keitai_cd = '';
        vm.editForm.gyomu_kb = '';
    }
    
    // 作業予定部門選択 ⇒ 作業形態取得 プリント有無
    $scope.$watch(function() { return vm.editForm.sg_bmn_cd;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            vm.editScope.getSgkt(newVal);
            vm.sghtBmnCheck(newVal);
        }
    }, true);

    // 作業形態取得
    vm.editScope.sgktDropdown = [{'name':'－－', 'id':null}];
    vm.editScope.sgktSyaDropdown1 = [];
    vm.editScope.sgktSyaDropdown2 = [];
    vm.editScope.gjktSyaDropdown1 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdown2 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdown3 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdown4 = [{'name':'－－', 'gj_cd':null}];
    //vm.editScope.gjktGaibuDropdown = [{'name':'－－', 'id':null}];
    vm.editScope.gjktSyaDropdownItems = [];
    vm.editScope.gjPatternDropdown = [{'gj_kb':'1', 'text': '技術員1'},{'gj_kb':'2', 'text': '技術員2'},{'gj_kb':'3', 'text': '技術員3'},{'gj_kb':'4', 'text': '外部技術員'}];
    vm.editScope.getSgkt = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/sgktsya',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.editScope.sgktDropdown = [{'name':'－－', 'id':null}];
            vm.editScope.sgktSyaDropdown1 = [];
            vm.editScope.sgktSyaDropdown2 = [];
            vm.editScope.gjktSyaDropdown1 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.gjktSyaDropdown2 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.gjktSyaDropdown3 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.gjktSyaDropdown4 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.studioDropdown = [];
            vm.editScope.gjktSyaDropdownItems = [];
            if(data.sgkt){
                // 作業形態
                angular.forEach(data.sgkt ,function(v,k){
                    vm.editScope.sgktDropdown.push({'name':v.sg_keitai_nm, 'id':v.sg_keitai_cd});
                });
            }
            if(data.syain){
                // 指名作業員 作業技術員
                angular.forEach(data.syain ,function(v,k){
                    //vm.editScope.sgktSyaDropdown.push({'name':v.syain_nm, 'id':v.syain_cd});
                    //vm.editScope.sgktSyaDropdown1.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'report.editScope.sgktSyaSelect1("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                    //vm.editScope.sgktSyaDropdown2.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'report.editScope.sgktSyaSelect2("'+ v.syain_cd +'","'+ v.syain_nm +'")'});

                    //
                    vm.editScope.gjktSyaDropdown1.push({'name':v.syain_cd+' : '+v.syain_nm, 'gj_cd':v.syain_cd});
                    vm.editScope.gjktSyaDropdown2.push({'name':v.syain_cd+' : '+v.syain_nm, 'gj_cd':v.syain_cd});
                    vm.editScope.gjktSyaDropdown3.push({'name':v.syain_cd+' : '+v.syain_nm, 'gj_cd':v.syain_cd});
                });
            }
            if(data.gaibu){
                // 作業技術員(外部)
                angular.forEach(data.gaibu ,function(v,k){
                    vm.editScope.gjktSyaDropdown4.push({'name':v.gaibu_cd+' : '+v.simei, 'gj_cd':v.gaibu_cd});
                });
            }
            /*
             * 技術員選択処理の変更
             * 技術員1に技術員2が来たりなど柔軟性を持たせる修正
             * 2016/09/20
             */
            var itm1 = angular.copy(vm.editScope.gjktSyaDropdown1);
            var itm2 = angular.copy(vm.editScope.gjktSyaDropdown2);
            var itm3 = angular.copy(vm.editScope.gjktSyaDropdown3);
            var itm4 = angular.copy(vm.editScope.gjktSyaDropdown4);
            vm.editScope.gjktSyaDropdownItems = [
                            { kb : '1', 'item':itm1},
                            { kb : '2', 'item':itm2},
                            { kb : '3', 'item':itm3},
                            { kb : '4', 'item':itm4}
            ];
            if(data.studio){
                // 作業技術員(外部)
                angular.forEach(data.studio ,function(v,k){
                    vm.editScope.studioDropdown.push({'name':v.studio_cd+' : '+v.studio_nm, 'id':v.studio_cd});
                });
            }
        });
    };

    /*
     * 技術員選択処理の変更
     * 技術員1に技術員2が来たりなど柔軟性を持たせる修正
     * 2016/09/20
     */
    vm.changeGjKtPat1 = function(change){
        if(vm.editForm.gj_kb_1){
            if(change) vm.editForm.gj_cd_1 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_1});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown1 = ret[0].item;
        }
    };
    vm.changeGjKtPat2 = function(change){
        if(vm.editForm.gj_kb_2){
            if(change) vm.editForm.gj_cd_2 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_2});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown2 = ret[0].item;
        }
    };
    vm.changeGjKtPat3 = function(change){
        if(vm.editForm.gj_kb_3){
            if(change) vm.editForm.gj_cd_3 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_3});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown3 = ret[0].item;
        }
    };
    vm.changeGjKtPat4 = function(change){
        if(vm.editForm.gj_kb_4){
            if(change) vm.editForm.gj_cd_4 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_4});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown4 = ret[0].item;
        }
    };
    
    // 指名作業員１選択
    vm.editScope.sgktSyaSelect1 = function(syain_cd, syain_nm){
        vm.editForm.simei_gj_cd_1 = syain_cd;
        vm.editScope.item.simei_gj_nm_1 = syain_nm;
    };
    // 指名作業員２選択
    vm.editScope.sgktSyaSelect2 = function(syain_cd, syain_nm){
        vm.editForm.simei_gj_cd_2 = syain_cd;
        vm.editScope.item.simei_gj_nm_2 = syain_nm;
    };

    // 作業状態
    vm.editScope.sgjtDropdown = [];
    vm.editScope.sgjtDropdown.push({'text':'通常', 'click': 'report.editScope.sgjtSelect(0,"通常")'});
    vm.editScope.sgjtDropdown.push({'text':'キャンセル', 'click': 'report.editScope.sgjtSelect(1,"キャンセル")'});

    vm.editScope.sgjtSelect = function(sg_jt_kb, sg_jt_nm){
        vm.editScope.item.sg_jt_nm = sg_jt_nm;
        vm.editForm.sg_jt_kb = sg_jt_kb;
    };
 // 作業状態 Display
    vm.editScope.sgjtDisplay = function(sg_jt_kb){
        var txt;
        if(Number(sg_jt_kb) === 0) txt = '通常';
        if(Number(sg_jt_kb) === 1) txt = 'キャンセル';
        vm.editScope.item.sg_jt_nm = txt;
    };

    // 技術作業員区分
    vm.editScope.gjkbDropdown =[ {'name':'技術員１', 'gj_kb':'1'},{'name':'技術員２', 'gj_kb':'2'},{'name':'技術員３', 'gj_kb':'3'},{'name':'外部技術員', 'gj_kb':'4'}];

    // プリント
    vm.editScope.printStatus1 = [ {id : '1' ,name: 'AM便'}, {id : '2' ,name: 'PM便'}, {id : '3' ,name: 'カウンター止め'}, {id : '4' ,name: '持ち帰り'}, {id : '5' ,name: 'バイク便'}];
    vm.editScope.printStatus2 = [ {id : '1' ,name: '当社補完'}, {id : '2' ,name: '担当者へ'}, {id : '3' ,name: '同時返却'}];
    // プリント詳細
    vm.editScope.printStatus3 = [ {id : '1' ,name: '共通コード'}, {id : '2' ,name: 'DBCMコード'}, {id : '3' ,name: '10桁CMコード'}, {id : '4' ,name: '原版No.'}];
    // プリント時間単位
    vm.editScope.printUnit = [ {id : '1' ,name: '秒'}, {id : '2' ,name: '分'}, {id : '3' ,name: '時'}];


    // 作業形態選択 ⇒ 作業項目取得 ⇒ HTML反映
    $scope.$watch(function() { return vm.editForm.sg_keitai_cd;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            if(!vm.sgKeitaiReadSleep){
                if(oldVal){
                    vm.editScope.getSgkeitaiitem(newVal);
                    // 作業形態再設定時は作業詳細テンプレートをnewに変更
                    vm.templateUrl_1 = null;
                    $timeout(function(){
                        vm.templateUrl_1 = 'app/business-report/editmode.html';
                    },500);
                    //console.log('change template');
                    //vm.templateInit();
                }else{
                    vm.editScope.getSgkeitaiitem(newVal);
                }
            }
        }
    }, true);

    // 作業項目取得
    vm.editScope.getSgkeitaiitem = function(str){
        return $http({
            url: dev.api + 'api/v1/sgkeitaiitem',
            method: 'GET',
            params: {cd:str}
        }).success(function(data) {
            if(data){
                $log.debug(data);
                vm.editScope.sgkyItems = data;
            }
        });
    };

    /************************************************** 作業項目Detail **********************************************/

    // Table Row追加
    vm.editScope.tableExtend = function(){
        var items = [];
        vm.editScope.sgkyItems.push(items);

    };
    // Table Row 複写
    vm.editScope.tableRowCopy = function($index){
        var sgkyItems = angular.copy(vm.editScope.sgkyItems[$index]);
        var sghtDtlArr = angular.copy(vm.editForm.sghtDtl);
        var sghtDtl = angular.copy(vm.editForm.sghtDtl[$index]);
        vm.editScope.sgkyItems.splice($index+1, 0, sgkyItems);

        // html内でindexを充てたのでobjになっている。一旦arrayに変換
        var newItemsArr = $.map(sghtDtlArr, function(value, index) {
            return [value];
        });
        newItemsArr.splice($index+1, 0, sghtDtl);
        
        //console.log(newItemsArr);
        
        // 再びobjに戻す
        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
            o[i] = v; return o;
        }, {});
        
        //console.log(newItemsObj);
        angular.forEach(sghtDtl, function(v, k){
            vm.editScope.sgkyItems[$index+1][k] = v;
        });
        vm.editForm.sghtDtl = newItemsObj;
        //$log.debug(vm.editScope.sgkyItems);
        //$log.debug(vm.editForm.sghtDtl);
    };
    // Table Row削除
    vm.editScope.tableCellDelete = function($index){
        vm.editScope.sgkyItems.splice($index , 1);
        // html内でindexを充てたのでobjになっている。一旦arrayに変換
        var newItemsArr = $.map(vm.editForm.sghtDtl, function(value, index) {
            return [value];
        });
        newItemsArr.splice($index , 1);
        // 再びobjに戻す
        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
            o[i] = v; return o;
        }, {});
        vm.editForm.sghtDtl = newItemsObj;

        $log.debug(vm.editScope.sgkyItems);
        $log.debug(vm.editForm.sghtDtl);
    };


    // 作業項目検索
    vm.editScope.sgItemApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/sgitem',
            method: "GET",
            params: {q:str}
        });
    };
    // 作業項目選択
    vm.editScope.sgItemSelected = function(selected) {
        var index = this.$parent.$index;// obj index
        if (selected) {
            //var res = selected.title.split(':');
            //vm.editForm.toku_cd = res[0];
            //vm.editScope.item.toku_nm = res[1];
            $http({
                url: dev.api + 'api/v1/sgitemdata',
                method: "GET",
                params: {cd:selected.originalObject.sg_item_cd}
            }).success(function(data) {
                if(data){
                    vm.editScope.sgkyItems[index].sg_item_nm = data.sg_item_nm;
                    vm.editScope.sgkyItems[index].tani_1 = data.tani_1;
                    vm.editScope.sgkyItems[index].tani_2 = data.tani_2;
                    vm.editScope.sgkyItems[index].time_fl = data.time_fl;
                    vm.editScope.sgkyItems[index].genka_fl = data.genka_fl;
                    vm.editForm.sghtDtl[index].sg_item_cd = data.sg_item_cd;
                    vm.editForm.sghtDtl[index].sg_bunrui_cd = data.sg_bunrui_cd;
                    vm.editForm.sghtDtl[index].time_fl = data.time_fl;
                    vm.editForm.sghtDtl[index].genka_fl = data.genka_fl;
                }
            });
        }
    };
    // 作業項目選択 Modalバージョン
    vm.editScope.sgItemModalSelected = function(sgItemCd,index) {
        //var index = this.$parent.$index;// obj index
        $http({
            url: dev.api + 'api/v1/sgitemdata',
            method: "GET",
            params: {cd:sgItemCd}
        }).success(function(data) {
            if(data){
                vm.editScope.sgkyItems[index].sg_item_nm = data.sg_item_nm;
                vm.editScope.sgkyItems[index].tani_1 = data.tani_1;
                vm.editScope.sgkyItems[index].tani_2 = data.tani_2;
                vm.editScope.sgkyItems[index].time_fl = data.time_fl;
                vm.editScope.sgkyItems[index].genka_fl = data.genka_fl;
                vm.editForm.sghtDtl[index].sg_item_cd = data.sg_item_cd;
                vm.editForm.sghtDtl[index].sg_bunrui_cd = data.sg_bunrui_cd;
                vm.editForm.sghtDtl[index].time_fl = data.time_fl;
                vm.editForm.sghtDtl[index].genka_fl = data.genka_fl;
            }
        });
    };

    //　数量の変更
    vm.changeSuryo = function($index){
        
        var sg_items = vm.commondata.sgItemKit.sgItem;
        var target_item_cd = vm.editForm.sghtDtl[$index].sg_item_cd;
        var arrTmp = $filter('filter')(sg_items, {sg_item_cd: target_item_cd});
        var sg_item = arrTmp[0];
        var ov_sg_item = {};
        var ov_sr = 0;
        var ov_goukei = 0;
        var tanka = vm.editForm.sghtDtl[$index].tanka;
        var suryo_2_flg = false;
        if( vm.editForm.sghtDtl[$index].suryo_1 ){
            var suryo = vm.editForm.sghtDtl[$index].suryo_1;
            if(vm.editForm.sghtDtl[$index].suryo_2 > 0){
                suryo = vm.editForm.sghtDtl[$index].suryo_2 * suryo;
                suryo_2_flg = true;
            }
            // ロックアウト対応
            if( Number(sg_item.over_fl) === 1 ){
                if( suryo > sg_item.ov_suryo ){
                    ov_sr = suryo - sg_item.ov_suryo;
                    suryo = sg_item.ov_suryo;
                    ov_sg_item = $filter('filter')(sg_items, {sg_item_cd: sg_item.ov_sg_item_cd});
                    ov_goukei = ov_sg_item[0].base_tanka * ov_sr;
                    //$log.debug(vm.editScope.sgkyItems);
                    //$log.debug(vm.editForm.sghtDtl);
                    var stt_tm = vm.editForm.sghtDtl[$index].stt_tm;
                    var end_tm = vm.editForm.sghtDtl[$index].end_tm;
                    var kitei = sg_item.ov_suryo;
                    var timeItems = {};
                    if(stt_tm && end_tm){
                        timeItems = $rootScope.getSttAndEndTm(stt_tm, end_tm, kitei, ov_sr);
                        vm.editForm.sghtDtl[$index].end_tm = timeItems.newEnd_tm;
                    }
                    var suryo_1 = 0;
                    var suryo_2 = null;
                    if( Number(ov_sg_item[0].suryo_kbn_1) === 1 ){
                        suryo_1 = 1;
                        suryo_2 = ov_sr;
                    }else if( Number(ov_sg_item[0].suryo_kbn_1) === 2 ){
                        suryo_1 = ov_sr;
                    }
                    
                    var sgkyItems = {};
                    var sgkyItemsTmp = angular.copy(vm.editScope.sgkyItems[$index]);
                    // 新しい行を作る
                    angular.forEach(sgkyItemsTmp, function(v,k){
                        angular.forEach(ov_sg_item[0], function(va,ke){
                            if(k === ke) sgkyItems[k] = va;
                        });
                    });
                    sgkyItems.gyo_no = sgkyItemsTmp.gyo_no + 1;
                    sgkyItems.suryo_1 = suryo_1;
                    sgkyItems.suryo_2 = suryo_2;
                    sgkyItems.tanka = ov_sg_item[0].base_tanka;
                    sgkyItems.kin = ov_goukei;
                    sgkyItems.sg_bunrui_cd = ov_sg_item[0].sg_bunrui_cd;
                    sgkyItems.sg_item_cd = ov_sg_item[0].sg_item_cd;
                    sgkyItems.sg_item_nm = ov_sg_item[0].sg_item_nm;
                    sgkyItems.tani_1 = ov_sg_item[0].tani_1;
                    sgkyItems.tani_2 = ov_sg_item[0].tani_2;
                    sgkyItems.time_fl = ov_sg_item[0].time_fl;
                    sgkyItems.genka_fl = ov_sg_item[0].genka_fl;
                    sgkyItems.stt_tm = (timeItems)?timeItems.newEnd_tm:null;
                    sgkyItems.end_tm = (timeItems)?timeItems.overEnd:null;
                    
                    var sghtDtl = {};
                    var sghtDtlTmp = angular.copy(vm.editForm.sghtDtl[$index]);
                    sghtDtl.gyo_no = sghtDtlTmp.gyo_no + 1;
                    sghtDtl.sg_bunrui_cd = ov_sg_item[0].sg_bunrui_cd;
                    sghtDtl.sg_item_cd = ov_sg_item[0].sg_item_cd;
                    sghtDtl.sg_item_nm = ov_sg_item[0].sg_item_nm;
                    sghtDtl.suryo_1 = suryo_1;
                    sghtDtl.suryo_2 = suryo_2;
                    sghtDtl.tani_1 = ov_sg_item[0].tani_1;
                    sghtDtl.tani_2 = ov_sg_item[0].tani_2;
                    sghtDtl.time_fl = ov_sg_item[0].time_fl;
                    sghtDtl.genka_fl = ov_sg_item[0].genka_fl;
                    sghtDtl.tanka = ov_sg_item[0].base_tanka;
                    sghtDtl.kin = ov_goukei;
                    sghtDtl.stt_tm = (timeItems)?timeItems.newEnd_tm:null;
                    sghtDtl.end_tm = (timeItems)?timeItems.overEnd:null;
                    
                    vm.editScope.sgkyItems.splice($index+1, 0, sgkyItems);
                    // html内でindexを充てたのでobjになっている。一旦arrayに変換
                    var newItemsArr = $.map(vm.editForm.sghtDtl, function(value, index) {
                        return [value];
                    });
                    newItemsArr.splice($index+1, 0, sghtDtl);
                    // 再びobjに戻す
                    var newItemsObj = newItemsArr.reduce(function(o, v, i) {
                        o[i] = v; return o;
                    }, {});
                    vm.editForm.sghtDtl = newItemsObj;
                    if(suryo_2_flg){
                        vm.editForm.sghtDtl[$index].suryo_2 = (ov_sg_item[0].tani_2)?1:suryo;
                    }else{
                        vm.editForm.sghtDtl[$index].suryo_1 = (ov_sg_item[0].tani_2)?1:suryo;
                        vm.editForm.sghtDtl[$index].suryo_2 = (ov_sg_item[0].tani_2)?suryo:null;
                    }
                    
                    
                }
            }
        }
    };

    /************************************************** /作業項目Detail **********************************************/


    // formSubmit
    vm.editScope.reportSubmit = function(method){
        $log.debug(vm.editForm);
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.sg_day && is('Date', vm.editForm.sg_day) ){
            vm.editForm.sg_day = moment(vm.editForm.sg_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.print_nh_dt && is('Date', vm.editForm.print_nh_dt) ){
            vm.editForm.print_nh_dt = moment(vm.editForm.print_nh_dt).format('YYYY/MM/DD HH:mm');
        }

        var completeMessage = 'が完了しました';
        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.sg_no){
                return false;
            }
            completeMessage = '更新'+completeMessage;
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.sg_no){
                return false;
            }
            vm.editForm = {sg_no:vm.editForm.sg_no,ju_no:vm.editForm.ju_no};
            completeMessage = '削除'+completeMessage;
        }else{
            completeMessage = '登録'+completeMessage;
        }
        

        $http({
            url: dev.api + 'api/v1/report' + subUrl,
            method: method,
            //method: 'POST',
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            // formクリア
            vm.editForm = {};
            if(method === 'POST'){
                vm.lead_ju_no = null;
                vm.lead_sg_no = null;
                //vm.editScope.cancel(1);
                vm.hideEdit();
                $state.go($state.current, {juno:'000',sgno:'000'}, {reload: true});

            }else{
                getResultsPage(1);//一覧更新
                vm.hideEdit();
            }
            toastr.info(completeMessage, 'Info');
        });
    };

    // formSubmit 承認
    vm.editScope.approvalSubmit = function(){
        $log.debug(vm.editForm);
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.sg_day && is('Date', vm.editForm.sg_day) ){
            vm.editForm.sg_day = moment(vm.editForm.sg_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.print_nh_dt && is('Date', vm.editForm.print_nh_dt) ){
            vm.editForm.print_nh_dt = moment(vm.editForm.print_nh_dt).format('YYYY/MM/DD HH:mm');
        }
        $http({
            url: dev.api + 'api/v1/reportapproval',
            method: 'POST',
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.info('承認しました', 'Info');
        });
    };
    
    // formSubmit 承認取り消し
    vm.editScope.approvalResetSubmit = function(){
        $log.debug(vm.editForm);
        $log.debug(vm.order);
        $log.debug(vm.sg_ur_snEndCnt);
        
        if( Number(vm.order.fin_fl) === 1 ){
            // 作品完了済み
            toastr.error('作品完了済みです。承認取消出来ません');
        }else if( vm.sg_ur_snEndCnt > 0 ){
            // 作業売上承認済み
            toastr.error('作業売上承認済みです。承認取消出来ません');
        }else{
            $http({
                url: dev.api + 'api/v1/reportunapproval',
                method: 'POST',
                params: {ju_no:vm.order.ju_no,sg_no:vm.editForm.sg_no}
            }).success(function(data) {
                // 登録完了
                $log.debug(data);
                getResultsPage(1);//一覧更新
                vm.hideEdit();
                toastr.info('承認取消しました', 'Info');
            });
        }
    };


    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        if(mode !== 2){
            $state.go($state.current, {juno:'000',sgno:'000'}, {reload: true});
        }else{
            vm.hideEdit();
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('PlanningController', PlanningController);

  /** @ngInject */
  function PlanningController($log, $window, $timeout, $http, $filter, $auth, $rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr) {

    $log.debug('PlanningController');

    var vm = this;
    $scope.controllerAliasName = 'planning';
    
    vm.user = storage.get('user');
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    //console.log('isEditDisabled : ' + vm.isEditDisabled);
    
    // Menu
    $rootScope.panelSelected(0,'002');

    // 他処理から引継ぎの場合
    vm.lead_ju_no = null;
    if($stateParams.juno !== '000' && $stateParams.juno.length > 3){
        vm.lead_ju_no = $stateParams.juno;
        $timeout(function(){
            vm.editModeInit(1, $stateParams.juno);
        },1000);
    }

    // Tooltip
    vm.editTooltipText1 = {'title': '-予定編集-<br />作業予定の編集を行います'};
    vm.editTooltipText2 = {'title': '-作業報告-<br />作業報告の新規登録を行います'};
    vm.editTooltipText3 = {'title': '作業項目検索<br />チェックONでスペース検索、チェックOFFで直接ID検索です'};

    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    
    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.form.sg_jt_kb = '00';
        vm.sg_jt_kb_nm = '問わず';
        vm.form.sg_hk_fl = '00';
        vm.sg_hk_fl_nm = '問わず';
        vm.bumon_nm = '';// 受注部門名
        vm.ju_tanto_nm = '';// 担当営業名
        vm.sg_yt_bmn_nm = ''; // 作業予定部門名
        vm.simei_gj_nm_1 = '';// 作業予定担当者名
        vm.studio_nm = ''; //スタジオ名
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);

        //vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        
        if( vm.user.tan_cd !== '9999' && vm.user.tan_cd !== '9998' ){
            var stChk = false;
            // 部門選択初期値
            angular.forEach(vm.commondata.bumon ,function(v,k){
                if(!stChk && vm.user.bumon_cd == v.bumon_cd){
                    vm.bumonSelect(v.bumon_cd, v.bumon_nm);
                    stChk = true;
                }
            });
            // 担当営業初期値
            if(stChk) vm.eigyoSelect(vm.user.tan_cd,　vm.user.syain_nm);
        }
        
        if(!vm.lead_ju_no){
            // 受注指定検索
            if( $stateParams.param ){
                vm.form.fromDate = null;
                vm.form.untilDate = null;
                vm.form.ju_noFrom = $stateParams.param.ju_no;
                vm.form.ju_noTo = $stateParams.param.ju_no;
            }
            $timeout(function() {
                getResultsPage(1);
            }, 1500);
        }
        vm.pagination = {
            current: 1
        };
        
    };
    
    vm.clearDates = function() {
        vm.selectedDate = null;
    };

    // 受注部門
    vm.bumonDropdown = [{'text':'－－', 'click': 'planning.bumonSelect()'}];
    angular.forEach(vm.commondata.bumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'planning.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 作業予定部門
    vm.sgytDropdown = [{'text':'－－', 'click': 'planning.sgytSelect()'}];
    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
        vm.sgytDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'planning.sgytSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // Studio
    vm.studioDropdown = [{'text':'－－', 'click': 'planning.studioSelect()'}];
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.studioDropdown.push({'text':v.studio_cd + ' : '+ v.studio_nm, 'click': 'planning.studioSelect("'+ v.studio_cd +'","'+ v.studio_nm +'")'});
    });

    // スタジオ表示用
    vm.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };
    // Studio選択
    vm.studioSelect = function(studio_cd, studio_nm){
        if(studio_cd && studio_nm){
            vm.form.studio_cd = studio_cd;
            vm.studio_nm = studio_nm;
        }else{
            vm.form.studio_cd = '';
            vm.studio_nm = '';
        }
    };

    // 作業予定部門選択
    vm.sgytSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.sg_yt_bmn_nm = bumon_nm;
            vm.form.sg_yt_bmn_cd = bumon_cd;
            vm.getSgytsyain(bumon_cd);
        }else{
            vm.sg_yt_bmn_nm = '';
            vm.form.sg_yt_bmn_cd = '';
        }
    };
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.ju_bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        }else{
            vm.form.ins_bmn_cd = '';
            vm.bumon_nm = '';
        }
    };
    // 担当営業取得
    vm.eigyoDropdown = [];
    vm.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data, status, headers, config) {
            vm.eigyoDropdown = [{'text':'－－', 'click': 'planning.eigyoSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'planning.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 担当営業選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ju_tanto_cd = syain_cd;
            vm.ju_tanto_nm = syain_nm;    
        }else{
            vm.form.ju_tanto_cd = '';
            vm.ju_tanto_nm = '';
        }
        
    };

    // 作業予定担当取得
    vm.sgytsyaDropdown = [];
    vm.getSgytsyain = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data, status, headers, config) {
            vm.sgytsyaDropdown = [{'text':'－－', 'click': 'planning.sgytSyaSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.sgytsyaDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'planning.sgytSyaSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 作業予定担当選択
    vm.sgytSyaSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.simei_gj_cd_1 = syain_cd;
            vm.simei_gj_nm_1 = syain_nm;
        }else{
            vm.form.simei_gj_cd_1 = '';
            vm.simei_gj_nm_1 = '';
        }
    };

    // 作業状態
    vm.sgjtStatus = [{id:'00', name:'問わず'},{id:'01', name:'通常'}, {id:'02', name:'キャンセル'}];
    vm.sgjtStatusDropdown = [];
    angular.forEach(vm.sgjtStatus ,function(v,k){
        vm.sgjtStatusDropdown.push({'text':v.name, 'click': 'planning.sgjtStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 作品完了選択
    vm.sgjtStatusSelect = function(id, name){
        vm.form.sg_jt_kb = id;
        vm.sg_jt_kb_nm = name;
    };
    // 報告
    vm.sghkStatus = [{id:'00', name:'問わず'},{id:'01', name:'未報告'}, {id:'02', name:'報告済'}];
    vm.sghkStatusDropdown = [];
    angular.forEach(vm.sghkStatus ,function(v,k){
        vm.sghkStatusDropdown.push({'text':v.name, 'click': 'planning.sghkStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 報告選択
    vm.sghkStatusSelect = function(id, name){
        vm.form.sg_hk_fl = id;
        vm.sg_hk_fl_nm = name;
    };

    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/planning',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas, status, headers, config) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str,bumon_cd:vm.user.bumon_cd}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };
    
    vm.formInit();

    /****************************************************** Edit Area ************************************************/
    // Scopeに注意
    /*
     * 受注No(ju_no)を持って遷移してきた場合は
     * 新規作業予定登録画面を表示させる
     * （受注情報を取得）
     * 編集の場合は作業予定No.(sg_no）から情報を取得
     */

    // Formの無効化(disabled)
    vm.isFromDisabled = false;

    // 編集詳細テンプレート
    // 作業形態を変更する場合にnew/editを入れ替えることでng-initを再度行う
    vm.templateInit = function(){
        vm.templateUrl_1 = null;
        vm.templateUrl_2 = null;
        vm.templateUrl_1 = 'app/business-planning/editmode.html';
        vm.templateUrl_2 = 'app/business-planning/newmode.html';
    }
    vm.templateInit();
    
    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/business-planning/planningedit.html',
        scope: $scope,
        show:false
    });
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };

    // EditMode init
    vm.sgKeitaiReadSleep = false;
    vm.editForm = {};
    vm.editForm.sgytDtl = {};
    vm.editForm.sgytMemo = {};
    vm.editScope = {};
    vm.editModeInit = function(mode, ju_no, sg_no){
        vm.templateInit();
        vm.editScope.editMode = mode;
        vm.isFromDisabled = false;
        // 新規登録
        if(mode === 1 && ju_no && !sg_no){
            // From初期化
            vm.editScope.item = {};
            vm.editScope.item.bumon_nm = '';        // 受注部門名
            vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
            vm.editScope.item.sg_yt_bmn_nm = '';    // 作業予定部門名
            vm.editScope.item.simei_gj_nm_1 = '';   // 作業予定担当者名
            //vm.editScope.item.studio_nm = '';     // スタジオ名

            // 作業予定
            vm.editForm = {};
            vm.editForm.sg_jt_kb = '0';     // 作業状態
            vm.editForm.gj_kb_1 = '1';      // 技術員区分(1～3+[4外部]とする-固定）
            vm.editForm.gj_kb_2 = '2';      // 技術員区分(1～3+[4外部]とする-固定）
            vm.editForm.gj_kb_3 = '3';      // 技術員区分(1～3+[4外部]とする-固定）
            vm.editForm.gj_kb_4 = '4';      // 技術員区分(1～3+[4外部]とする-固定）
            vm.editForm.sg_hk_fl = 0;       // 作業報告FLG(Default:0)
            vm.editForm.print_fl = 0;       // プリントFLG(Default:0)

            /** デフォルト値が必要な場合は以下をコメントアウトして利用 **/
            //vm.editForm.sg_yt_bmn_cd = '';  // 作業予定部門
            //vm.editForm.gyomu_kb = '';      // 業務区分
            //vm.editForm.sg_keitai_cd = '';  // 作業形態
            //vm.editForm.studio_cd = '';     // 作業予定スタジオ
            //vm.editForm.sg_yt_day = '';     // 作業予定日
            //vm.editForm.sg_yt_tm_fm = '';   // 作業予定時間FROM
            //vm.editForm.sg_yt_tm_to = '';   // 作業予定時間TO
            //vm.editForm.sg_yt_time = '';    // 作業予定時間
            //vm.editForm.simei_gj_cd_1 = ''; // 指名技術員１
            //vm.editForm.simei_gj_cd_2 = ''; // 指名技術員２
            //vm.editForm.cancel_day = '';    // キャンセル日
            //vm.editForm.gj_cd_1 = '';       // 作業予定技術員１
            //vm.editForm.gj_tm_fm_1 = '';    // 作業予定時間FROM１
            //vm.editForm.gj_tm_to_1 = '';    // 作業予定時間TO１
            //vm.editForm.gj_time_1 = '';     // 作業予定時間１
            //vm.editForm.gj_time_mae_1 = ''; // 作業予定時間前１
            //vm.editForm.gj_time_ato_1 = ''; // 作業予定時間後１
            //vm.editForm.gj_cd_2 = '';       // 作業予定技術員２
            //vm.editForm.gj_tm_fm_2 = '';    // 作業予定時間FROM２
            //vm.editForm.gj_tm_to_2 = '';    // 作業予定時間TO２
            //vm.editForm.gj_time_2 = '';     // 作業予定時間２
            //vm.editForm.gj_time_mae_2 = ''; // 作業予定時間前２
            //vm.editForm.gj_time_ato_2 = ''; // 作業予定時間後２
            //vm.editForm.gj_cd_3 = '';       // 作業予定技術員３
            //vm.editForm.gj_tm_fm_3 = '';    // 作業予定時間FROM３
            //vm.editForm.gj_tm_to_3 = '';    // 作業予定時間TO３
            //vm.editForm.gj_time_3 = '';     // 作業予定時間３
            //vm.editForm.gj_time_mae_3 = ''; // 作業予定時間前３
            //vm.editForm.gj_time_ato_3 = ''; // 作業予定時間後３
            //vm.editForm.gj_cd_4 = '';       // 作業予定技術員４
            //vm.editForm.gj_tm_fm_4 = '';    // 作業予定時間FROM４
            //vm.editForm.gj_tm_to_4 = '';    // 作業予定時間TO４
            //vm.editForm.gj_time_4 = '';     // 作業予定時間４
            //vm.editForm.gj_time_mae_4 = ''; // 作業予定時間前４
            //vm.editForm.gj_time_ato_4 = ''; // 作業予定時間後４
            //vm.editForm.print_nh_dt = '';   // プリント納品日
            //vm.editForm.nh_kb = '';         // プリント納品区分
            //vm.editForm.nh_hosoku = '';     // プリント納品補足
            //vm.editForm.genban_kb = '';     // プリント原版区分

            // 作業予定詳細
            vm.editForm.sgytDtl = [];
            vm.editForm.sgytMemo = '';

            // PrintShow
            vm.editScope.printShow = false;
            // DataPicker
            vm.editScope.selectedDate = new Date();
            vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

            // 受注情報を取得
            $http({
                url: dev.api + 'api/v1/orderdetail',
                method: 'GET',
                params: {ju_no:ju_no}
            }).success(function(data) {
                if(data){
                    $log.debug(data);

                    // Form情報
                    vm.editForm.ju_no = data.ju_no;             // 受注No.
                    vm.editForm.ju_tanto_cd = data.ju_tanto_cd; // 担当営業CD
                    vm.editForm.toku_cd = data.toku_cd;         // 得意先CD
                    vm.editForm.toku_tanto_nm = data.toku_tanto_nm; // 得意先担当名
                    vm.editScope.bumon_kb = data.bumon_kb;   // 作業予定部門区分
                    
                    // 表示項目
                    vm.editScope.item.hin_nm = data.hin_nm; // 作品名
                    vm.editScope.item.ju_tanto_nm = data.ju_tanto_nm; // 担当営業名
                    vm.editScope.item.ju_bumon_nm = data.ju_bumon_nm; // 受注部門名

                    // 作業予定部門 普通のDropdown
                    vm.editScope.sgytDropdown = [{'name':'－－', 'id': null}];
                    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
                        if(vm.editScope.bumon_kb === v.bumon_kb)
                            //vm.editScope.sgytDropdown.push({'name':v.bumon_nm, 'id':v.bumon_cd});
                            vm.editScope.sgytDropdown.push({'name':v.bumon_cd+' '+v.bumon_nm, 'id':v.bumon_cd});
                    });
                    
                    $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                        url: dev.api + 'api/v1/tokuisakidata',
                        method: 'GET',
                        params: {cd:data.toku_cd}
                    }).success(function(tokuData) {
                        if(tokuData){
                            vm.editScope.item.toku_nm = tokuData.toku_nm;
                            vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;
                        }
                    });

                }
            });

        // 編集モード
        }else if(mode === 2 && ju_no && sg_no){
            vm.editScope.item = {};
            vm.editForm = {};
            vm.editScope.item.bumon_nm = '';        // 受注部門名
            vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
            vm.editScope.item.sg_yt_bmn_nm = '';    // 作業予定部門名
            vm.editScope.item.simei_gj_nm_1 = '';   // 作業予定担当者名
            //vm.editScope.item.studio_nm = '';     // スタジオ名
            vm.editForm.sg_yt_time = '';
            vm.sgKeitaiReadSleep = true;

            $http({
                url: dev.api + 'api/v1/planningdetail',
                method: 'GET',
                params: {ju_no:ju_no,sg_no:sg_no}
            }).success(function(data) {
                if(data.sgyt){
                    $log.debug(data);
                    /*
                     * 作業報告flgと
                     * 承認flgがあり(承認flgは1と2と3）
                     * それぞれ組み合わせで状態が異なるので注意
                     * ただし、今回のリファクタリングで承認2は廃止とする
                     */
                    vm.print_data = data;
                    var sgyt = data.sgyt;
                    var order = data.order;
                    var sgytDtl = data.sgytDtl;

                    // 作業予定
                    vm.editForm.ju_no = sgyt.ju_no;                 // 受注No.
                    vm.editForm.sg_no = sgyt.sg_no;                 // 作業予定No.
                    vm.editForm.sg_jt_kb = sgyt.sg_jt_kb;           // 作業状態
                    vm.editForm.gj_kb_1 = sgyt.gj_kb_1;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_2 = sgyt.gj_kb_2;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_3 = sgyt.gj_kb_3;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.gj_kb_4 = sgyt.gj_kb_4;             // 技術員区分(1～3+[4外部]とする-固定）
                    vm.editForm.sg_hk_fl = Number(sgyt.sg_hk_fl);   // 作業報告FLG(Default:0)
                    // 報告済みの場合は編集不可
                    if(vm.editForm.sg_hk_fl > 0){
                        toastr.info('作業報告済みのため、編集できません', 'Info');
                        vm.isFromDisabled = true;
                    }
                    // 作品完了済みの場合は編集不可
                    if(order.fin_fl > 0){
                        toastr.info('作品は完了しているため、編集できません', 'Info');
                        vm.isFromDisabled = true;
                    }
                    vm.editForm.print_fl = Number(sgyt.print_fl);   // プリントFLG(Default:0)
                    vm.editForm.sg_yt_bmn_cd = sgyt.sg_yt_bmn_cd;   // 作業予定部門
                    vm.editForm.gyomu_kb = sgyt.gyomu_kb;           // 業務区分
                    vm.editForm.sg_keitai_cd = sgyt.sg_keitai_cd;   // 作業形態
                    vm.editForm.studio_cd = sgyt.studio_cd;         // 作業予定スタジオ
                    vm.editForm.sg_yt_day = null;
                    if(sgyt.sg_yt_day_time > 0){
                        vm.editForm.sg_yt_day = new Date(sgyt.sg_yt_day_time*1000);// 作業予定日
                    }
                    vm.editForm.sg_yt_tm_fm = sgyt.sg_yt_tm_fm_str;  // 作業予定時間FROM
                    vm.editForm.sg_yt_tm_to = sgyt.sg_yt_tm_to_str;  // 作業予定時間TO
                    vm.setSgytTime();//時間整形
                    vm.editForm.sg_yt_time = sgyt.sg_yt_time;        // 作業予定時間
                    vm.editForm.simei_gj_cd_1 = sgyt.simei_gj_cd_1;  // 指名技術員１
                    vm.editForm.simei_gj_cd_2 = sgyt.simei_gj_cd_2;  // 指名技術員２
                    vm.editScope.item.simei_gj_nm_1 = sgyt.simei_gj_nm_1;  // 指名技術員１
                    vm.editScope.item.simei_gj_nm_2 = sgyt.simei_gj_nm_2;  // 指名技術員２
                    vm.editForm.cancel_day = null;                   // キャンセル日
                    if(sgyt.cancel_day_time > 0){
                        vm.editForm.cancel_day = new Date(sgyt.cancel_day_time*1000);
                    }
                    vm.editForm.gj_cd_1 = sgyt.gj_cd_1;              // 作業予定技術員１
                    vm.editForm.gj_tm_fm_1 = sgyt.gj_tm_fm_1_str;    // 作業予定時間FROM１
                    vm.editForm.gj_tm_to_1 = sgyt.gj_tm_to_1_str;    // 作業予定時間TO１
                    vm.setGjTime1();//時間整形
                    vm.editForm.gj_time_1 = sgyt.gj_time_1;          // 作業予定時間１
                    vm.editForm.gj_time_mae_1 = sgyt.gj_time_mae_1;  // 作業予定時間前１
                    vm.editForm.gj_time_ato_1 = sgyt.gj_time_ato_1;  // 作業予定時間後１
                    vm.editForm.gj_cd_2 = sgyt.gj_cd_2;              // 作業予定技術員２
                    vm.editForm.gj_tm_fm_2 = sgyt.gj_tm_fm_2_str;    // 作業予定時間FROM２
                    vm.editForm.gj_tm_to_2 = sgyt.gj_tm_to_2_str;    // 作業予定時間TO２
                    vm.setGjTime2();//時間整形
                    vm.editForm.gj_time_2 = sgyt.gj_time_2;          // 作業予定時間２
                    vm.editForm.gj_time_mae_2 = sgyt.gj_time_mae_2;  // 作業予定時間前２
                    vm.editForm.gj_time_ato_2 = sgyt.gj_time_ato_2;  // 作業予定時間後２
                    vm.editForm.gj_cd_3 = sgyt.gj_cd_3;              // 作業予定技術員３
                    vm.editForm.gj_tm_fm_3 = sgyt.gj_tm_fm_3_str;    // 作業予定時間FROM３
                    vm.editForm.gj_tm_to_3 = sgyt.gj_tm_to_3_str;    // 作業予定時間TO３
                    vm.setGjTime3();//時間整形
                    vm.editForm.gj_time_3 = sgyt.gj_time_3;         // 作業予定時間３
                    vm.editForm.gj_time_mae_3 = sgyt.gj_time_mae_3; // 作業予定時間前３
                    vm.editForm.gj_time_ato_3 = sgyt.gj_time_ato_3; // 作業予定時間後３
                    vm.editForm.gj_cd_4 = sgyt.gj_cd_4;             // 作業予定技術員４
                    vm.editForm.gj_tm_fm_4 = sgyt.gj_tm_fm_4_str;   // 作業予定時間FROM４
                    vm.editForm.gj_tm_to_4 = sgyt.gj_tm_to_4_str;   // 作業予定時間TO４
                    vm.setGjTime4();//時間整形
                    vm.editForm.gj_time_4 = sgyt.gj_time_4;         // 作業予定時間４
                    vm.editForm.gj_time_mae_4 = sgyt.gj_time_mae_4; // 作業予定時間前４
                    vm.editForm.gj_time_ato_4 = sgyt.gj_time_ato_4; // 作業予定時間後４
                    vm.editForm.print_nh_dt = null;                 // プリント納品日
                    if(sgyt.print_nh_dt_time > 0){
                        vm.editForm.print_nh_dt = new Date(sgyt.print_nh_dt_time*1000);
                    }

                    vm.editForm.nh_kb = sgyt.nh_kb;                 // プリント納品区分
                    vm.editForm.nh_hosoku = sgyt.nh_hosoku;         // プリント納品補足
                    vm.editForm.genban_kb = sgyt.genban_kb;         // プリント原版区分

                    vm.editScope.sgkyItems = sgytDtl;
                    vm.editForm.sgytMemo = data.memo;
                    vm.editScope.bumon_kb = order.bumon_kb;

                    // 作業状態
                    vm.editScope.sgjtDisplay(sgyt.sg_jt_kb);
                    // PrintShow
                    //vm.editScope.printShow = false;
                    // DataPicker
                    vm.editScope.selectedDate = new Date();
                    vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

                    // 受注情報
                    // Form情報
                    vm.editForm.ju_no = sgyt.ju_no;             // 受注No.
                    vm.editForm.ju_tanto_cd = order.ju_tanto_cd; // 担当営業CD
                    vm.editForm.toku_cd = order.toku_cd;         // 得意先CD
                    vm.editForm.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名

                    // 表示項目
                    vm.editScope.item.hin_nm = order.hin_nm; // 作品名
                    vm.editScope.item.ju_tanto_nm = order.ju_tanto_nm; // 担当営業名
                    vm.editScope.item.ju_bumon_nm = order.ju_bumon_nm; // 受注部門名

                    // 作業予定部門 普通のDropdown
                    vm.editScope.sgytDropdown = [{'name':'－－', 'id': null}];
                    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
                        if(vm.editScope.bumon_kb === v.bumon_kb)
                            vm.editScope.sgytDropdown.push({'name':v.bumon_cd+' '+v.bumon_nm, 'id':v.bumon_cd});
                    });
                    
                    $timeout(function(){

                        $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                            url: dev.api + 'api/v1/tokuisakidata',
                            method: 'GET',
                            params: {cd:order.toku_cd}
                        }).success(function(tokuData) {
                            if(tokuData){
                                vm.editScope.item.toku_nm = tokuData.toku_nm;
                                vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;

                                // Printチェック
                                vm.sgytBmnCheck(sgyt.sg_yt_bmn_cd);
                                vm.sgKeitaiReadSleep = false;
                                
                                $timeout(function(){
                                    vm.changeGjKtPat1(0);
                                    vm.changeGjKtPat2(0);
                                    vm.changeGjKtPat3(0);
                                    vm.changeGjKtPat4(0);
                                },1000);
                            }
                        });
                    },500);

                }
            });
        }

        // 画面Open
        vm.openEdit();
    };
    // 作業項目名セット
    vm.setSgItemName = function(sg_item_cd){
        if(!sg_item_cd) return;
        var sgItemNm;
        angular.forEach(vm.commondata.sgItemKit.sgItem, function(v,k){
            if(v.sg_item_cd === sg_item_cd) sgItemNm = v.sg_item_nm;
        });
        return sgItemNm;
    };
    // 作業時間計算実行
    vm.setSgytTime = function(){
        if(vm.editForm.sg_yt_tm_fm && vm.editForm.sg_yt_tm_to){
            if(vm.editForm.sg_yt_tm_fm.length > 3 && vm.editForm.sg_yt_tm_to.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.sg_yt_tm_fm, vm.editForm.sg_yt_tm_to);
                //$log.debug(rt);
                if(rt.time < 0.1){
                    vm.editScope.sgytError = true;
                }else{
                    vm.editForm.sg_yt_time = rt.time;
                    vm.editForm.sg_yt_tm_fm = rt.fromStr;
                    vm.editForm.sg_yt_tm_to = rt.toStr;
                    vm.editScope.sg_yt_time = rt.time + 'H';
                    vm.editScope.sgytError = false;
                }
            }
        }
    };
    // 作業予定技術員１ 作業時間計算実行
    vm.setGjTime1 = function(){
        if(vm.editForm.gj_tm_fm_1 && vm.editForm.gj_tm_to_1){
            if(vm.editForm.gj_tm_fm_1.length > 3 && vm.editForm.gj_tm_to_1.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_1, vm.editForm.gj_tm_to_1);
                if(rt.time < 0.1){
                    vm.editScope.gjTime1Error = true;
                }else{
                    vm.editForm.gj_time_1 = rt.time;
                    vm.editForm.gj_tm_fm_1 = rt.fromStr;
                    vm.editForm.gj_tm_to_1 = rt.toStr;
                    vm.editScope.gj_time_1 = rt.time + 'H';
                    vm.editScope.gjTime1Error = false;
                }
            }
        }
    };

    // 作業予定技術員２ 作業時間計算実行
    vm.setGjTime2 = function(){
        if(vm.editForm.gj_tm_fm_2 && vm.editForm.gj_tm_to_2){
            if(vm.editForm.gj_tm_fm_2.length > 3 && vm.editForm.gj_tm_to_2.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_2, vm.editForm.gj_tm_to_2);
                if(rt.time < 0.1){
                    vm.editScope.gjTime2Error = true;
                }else{
                    vm.editForm.gj_time_2 = rt.time;
                    vm.editForm.gj_tm_fm_2 = rt.fromStr;
                    vm.editForm.gj_tm_to_2 = rt.toStr;
                    vm.editScope.gj_time_2 = rt.time + 'H';
                    vm.editScope.gjTime2Error = false;
                }
            }
        }
    };

    // 作業予定技術員３ 作業時間計算実行
    vm.setGjTime3 = function(){
        if(vm.editForm.gj_tm_fm_3 && vm.editForm.gj_tm_to_3){
            if(vm.editForm.gj_tm_fm_3.length > 3 && vm.editForm.gj_tm_to_3.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_3, vm.editForm.gj_tm_to_3);
                if(rt.time < 0.1){
                    vm.editScope.gjTime3Error = true;
                }else{
                    vm.editForm.gj_time_3 = rt.time;
                    vm.editForm.gj_tm_fm_3 = rt.fromStr;
                    vm.editForm.gj_tm_to_3 = rt.toStr;
                    vm.editScope.gj_time_3 = rt.time + 'H';
                    vm.editScope.gjTime3Error = false;
                }
            }
        }
    };

    // 外部技術員 作業時間計算実行
    vm.setGjTime4 = function(){
        if(vm.editForm.gj_tm_fm_4 && vm.editForm.gj_tm_to_4){
            if(vm.editForm.gj_tm_fm_4.length > 3 && vm.editForm.gj_tm_to_4.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_4, vm.editForm.gj_tm_to_4);
                if(rt.time < 0.1){
                    vm.editScope.gjTime4Error = true;
                }else{
                    vm.editForm.gj_time_4 = rt.time;
                    vm.editForm.gj_tm_fm_4 = rt.fromStr;
                    vm.editForm.gj_tm_to_4 = rt.toStr;
                    vm.editScope.gj_time_4 = rt.time + 'H';
                    vm.editScope.gjTime4Error = false;
                }
            }
        }
    };


    // 業務区分 普通のDropdown
    vm.editScope.gyomuDropdown = [{'name':'－－', 'id': null}];
    angular.forEach(vm.commondata.gyomu ,function(v,k){
        vm.editScope.gyomuDropdown.push({'name':v.gyomu_kb+' '+v.gyomu_nm, 'id':v.gyomu_kb});
    });

    // メディア 普通のDropdown
    vm.editScope.mediaDropdown = [{'name':'－－', 'id': null}];
    angular.forEach(vm.commondata.media ,function(v,k){
        vm.editScope.mediaDropdown.push({'name':v.media_cd+' '+v.media_nm, 'id':v.media_cd});
    });

    // 作業予定スタジオ 普通のDropdown
    vm.editScope.studioDropdown = [];
    /*
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.editScope.studioDropdown.push({'name':v.studio_nm, 'id':v.studio_cd});
    });
    */

    // 業務区分表示用
    vm.editScope.getGyomuName = function(cd){
        var name;
        angular.forEach(vm.commondata.gyomu, function(v,k){
            if(v.gyomu_kb === cd ){
                name = v.gyomu_nm;
            }
        });
        return name;
    };
    // スタジオ表示用
    vm.editScope.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };

    /*
     * プリント有り
     * MA:0310 ビデオ:0320 旧テレシネ:0321 プロセス:0330 DVD:0331 テレシネ：0333
     * プリント無し
     * オーディオ技術:0120 マルチメディア:0130 デジタルイメージ：0334 開発部技術:0850
     *
     */
    vm.bumonPrintCd = ['0310','0320','0321','0330','0331','0333'];
    vm.sgytBmnCheck = function(bumon_cd){
        vm.editScope.printShow = false;
        var breaks = false;
        angular.forEach(vm.bumonPrintCd, function(v, k) {
            breaks = v == bumon_cd;
            if(breaks){
                vm.editScope.printShow = true;
            }
        });
    };

    vm.changeSgBmnCd = function(){
        vm.editForm.sg_keitai_cd = '';
        vm.editForm.gyomu_kb = '';
    }
    
    // 作業予定部門選択 ⇒ 作業形態取得 プリント有無
    $scope.$watch(function() { return vm.editForm.sg_yt_bmn_cd;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            if(vm.editForm.sg_yt_bmn_cd)
                vm.editScope.getSgkt(newVal);
                vm.sgytBmnCheck(newVal);
        }
    }, true);

    // 作業形態・予定人員リスト取得
    vm.editScope.sgktDropdown = [{'name':'－－', 'id': null}];
    vm.editScope.sgktSyaDropdown1 = [{'text':'－－', 'click': 'planning.editScope.sgktSyaSelect1()'}];
    vm.editScope.sgktSyaDropdown2 = [{'text':'－－', 'click': 'planning.editScope.sgktSyaSelect2()'}];
    vm.editScope.gjktSyaDropdown1 = [{'name':'－－', 'gj_cd': null}];
    vm.editScope.gjktSyaDropdown2 = [{'name':'－－', 'gj_cd': null}];
    vm.editScope.gjktSyaDropdown3 = [{'name':'－－', 'gj_cd': null}];
    vm.editScope.gjktSyaDropdown4 = [{'name':'－－', 'gj_cd': null}];
    vm.editScope.gjktSyaDropdownItems = [];
    vm.editScope.gjPatternDropdown = [{'gj_kb':'1', 'text': '技術員1'},{'gj_kb':'2', 'text': '技術員2'},{'gj_kb':'3', 'text': '技術員3'},{'gj_kb':'4', 'text': '外部技術員'}];
    vm.editScope.getSgkt = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/sgktsya',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.editScope.sgktDropdown = [{'name':'－－', 'id': null}];
            vm.editScope.sgktSyaDropdown1 = [{'text':'－－', 'click': 'planning.editScope.sgktSyaSelect1()'}];
            vm.editScope.sgktSyaDropdown2 = [{'text':'－－', 'click': 'planning.editScope.sgktSyaSelect2()'}];
            vm.editScope.gjktSyaDropdown1 = [{'name':'－－', 'gj_cd': null}];
            vm.editScope.gjktSyaDropdown2 = [{'name':'－－', 'gj_cd': null}];
            vm.editScope.gjktSyaDropdown3 = [{'name':'－－', 'gj_cd': null}];
            vm.editScope.gjktSyaDropdown4 = [{'name':'－－', 'gj_cd': null}];
            //vm.editScope.gjktGaibuDropdown = [{'name':'－－', 'gj_cd': null}];
            vm.editScope.studioDropdown = [{'name':'－－', 'id': null}];
            vm.editScope.gjktSyaDropdownItems = [];
            if(data.sgkt){
                // 作業形態
                //var sgkt = $filter('orderBy')(data.sgkt,{'sg_keitai_cd':true});
                angular.forEach(data.sgkt ,function(v,k){
                    vm.editScope.sgktDropdown.push({'name':v.sg_keitai_nm, 'id':v.sg_keitai_cd});
                });
            }
            
            if(data.syain){
                // 指名作業員 作業技術員
                var syain = $filter('orderBy')(data.syain, 'syain_cd');
                //console.log(syain);
                angular.forEach(syain ,function(v,k){
                    //vm.editScope.sgktSyaDropdown.push({'name':v.syain_nm, 'id':v.syain_cd});
                    // 指名作業員
                    vm.editScope.sgktSyaDropdown1.push({'text':v.syain_cd + ' : '+ v.syain_nm,'click': 'planning.editScope.sgktSyaSelect1("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                    vm.editScope.sgktSyaDropdown2.push({'text':v.syain_cd + ' : '+ v.syain_nm,'click': 'planning.editScope.sgktSyaSelect2("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                    
                    // 作業技術員
                    vm.editScope.gjktSyaDropdown1.push({'name':v.syain_cd + ' : '+ v.syain_nm, 'gj_cd':v.syain_cd});
                    vm.editScope.gjktSyaDropdown2.push({'name':v.syain_cd + ' : '+ v.syain_nm, 'gj_cd':v.syain_cd});
                    vm.editScope.gjktSyaDropdown3.push({'name':v.syain_cd + ' : '+ v.syain_nm, 'gj_cd':v.syain_cd});
                });
            }
            if(data.gaibu){
                // 作業技術員(外部)
                angular.forEach(data.gaibu ,function(v,k){
                    vm.editScope.gjktSyaDropdown4.push({'name':v.gaibu_cd+' : '+v.simei, 'gj_cd':v.gaibu_cd});
                });
            }
            /*
             * 技術員選択処理の変更
             * 技術員1に技術員2が来たりなど柔軟性を持たせる修正
             * 2016/09/20
             */
            var itm1 = angular.copy(vm.editScope.gjktSyaDropdown1);
            var itm2 = angular.copy(vm.editScope.gjktSyaDropdown2);
            var itm3 = angular.copy(vm.editScope.gjktSyaDropdown3);
            var itm4 = angular.copy(vm.editScope.gjktSyaDropdown4);
            vm.editScope.gjktSyaDropdownItems = [
                            { kb : '1', 'item':itm1},
                            { kb : '2', 'item':itm2},
                            { kb : '3', 'item':itm3},
                            { kb : '4', 'item':itm4}
            ];

            if(data.studio){
                // スタジオ
                angular.forEach(data.studio ,function(v,k){
                    vm.editScope.studioDropdown.push({'name':v.studio_cd+' '+v.studio_nm, 'id':v.studio_cd});
                });
            }
        });
    };
    
    /*
     * 技術員選択処理の変更
     * 技術員1に技術員2が来たりなど柔軟性を持たせる修正
     * 2016/09/20
     */
    vm.changeGjKtPat1 = function(change){
        if(vm.editForm.gj_kb_1){
            if(change) vm.editForm.gj_cd_1 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_1});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown1 = ret[0].item;
        }
    };
    vm.changeGjKtPat2 = function(change){
        if(vm.editForm.gj_kb_2){
            if(change) vm.editForm.gj_cd_2 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_2});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown2 = ret[0].item;
        }
    };
    vm.changeGjKtPat3 = function(change){
        if(vm.editForm.gj_kb_3){
            if(change) vm.editForm.gj_cd_3 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_3});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown3 = ret[0].item;
        }
    };
    vm.changeGjKtPat4 = function(change){
        if(vm.editForm.gj_kb_4){
            if(change) vm.editForm.gj_cd_4 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_4});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown4 = ret[0].item;
        }
    };

    
    // 指名作業員１選択
    vm.editScope.sgktSyaSelect1 = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.editForm.simei_gj_cd_1 = syain_cd;
            vm.editScope.item.simei_gj_nm_1 = syain_nm;
        }else{
            vm.editForm.simei_gj_cd_1 = '';
            vm.editScope.item.simei_gj_nm_1 = '';
        }
    };
    // 指名作業員２選択
    vm.editScope.sgktSyaSelect2 = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.editForm.simei_gj_cd_2 = syain_cd;
            vm.editScope.item.simei_gj_nm_2 = syain_nm;
        }else{
            vm.editForm.simei_gj_cd_2 = '';
            vm.editScope.item.simei_gj_nm_2 = '';
        }
    };

    // 作業状態
    vm.editScope.sgjtDropdown = [];
    vm.editScope.sgjtDropdown.push({'text':'通常', 'click': 'planning.editScope.sgjtSelect(0,"通常")'});
    vm.editScope.sgjtDropdown.push({'text':'キャンセル', 'click': 'planning.editScope.sgjtSelect(1,"キャンセル")'});

    vm.editScope.sgjtSelect = function(sg_jt_kb, sg_jt_nm){
        vm.editScope.item.sg_jt_nm = sg_jt_nm;
        vm.editForm.sg_jt_kb = sg_jt_kb;
    };
 // 作業状態 Display
    vm.editScope.sgjtDisplay = function(sg_jt_kb){
        var txt;
        if(Number(sg_jt_kb) === 0) txt = '通常';
        if(Number(sg_jt_kb) === 1) txt = 'キャンセル';
        vm.editScope.item.sg_jt_nm = txt;
    };

    // 技術作業員区分
    vm.editScope.gjkbDropdown =[ {'name':'技術員１', 'gj_kb':'1'},{'name':'技術員２', 'gj_kb':'2'},{'name':'技術員３', 'gj_kb':'3'},{'name':'外部技術員', 'gj_kb':'4'}];

    // プリント
    vm.editScope.printStatus1 = [ {id : '1' ,name: 'AM便'}, {id : '2' ,name: 'PM便'}, {id : '3' ,name: 'カウンター止め'}, {id : '4' ,name: '持ち帰り'}, {id : '5' ,name: 'バイク便'}];
    vm.editScope.printStatus2 = [ {id : '1' ,name: '当社補完'}, {id : '2' ,name: '担当者へ'}, {id : '3' ,name: '同時返却'}];
    // プリント詳細
    vm.editScope.printStatus3 = [ {id : '1' ,name: '共通コード'}, {id : '2' ,name: 'DBCMコード'}, {id : '3' ,name: '10桁CMコード'}, {id : '4' ,name: '原版No.'}];
    // プリント時間単位
    vm.editScope.printUnit = [ {id : '1' ,name: '秒'}, {id : '2' ,name: '分'}, {id : '3' ,name: '時'}];


    // 作業形態選択 ⇒ 作業項目取得 ⇒ HTML反映
    $scope.$watch(function() { return vm.editForm.sg_keitai_cd;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            if(!vm.sgKeitaiReadSleep){
                //console.log(oldVal);
                if(oldVal){
                    vm.editScope.getSgkeitaiitem(newVal);
                    // 作業形態再設定時は作業詳細テンプレートをnewに変更
                    vm.templateUrl_1 = 'app/business-planning/newmode.html';
                }else{
                    vm.editScope.getSgkeitaiitem(newVal);
                }
            }
        }
    }, true);

    // 作業項目取得
    vm.editScope.getSgkeitaiitem = function(str){
        return $http({
            url: dev.api + 'api/v1/sgkeitaiitem',
            method: 'GET',
            params: {cd:str}
        }).success(function(data) {
            if(data){
                $log.debug(data);
                vm.editScope.sgkyItems = data;
            }
        });
    };

    /*
     * アイテム数量の計算と
     * ロックアウト（超過）設定の場合超過時アイテム追加
     */
    vm.changeSuryo = function($index){
        var sg_items = vm.commondata.sgItemKit.sgItem;
        var target_item_cd = vm.editForm.sgytDtl[$index].sg_item_cd;
        var arrTmp = $filter('filter')(sg_items, {sg_item_cd: target_item_cd});
        var sg_item = arrTmp[0];
        var ov_sg_item = {};
        var ov_sr = 0;
        var ov_goukei = 0;
        var tanka = vm.editForm.sgytDtl[$index].tanka;
        var suryo_2_flg = false;
        
        if( vm.editForm.sgytDtl[$index].suryo_1 ){
            // 入力数量
            var suryo = vm.editForm.sgytDtl[$index].suryo_1;
            if(vm.editForm.sgytDtl[$index].suryo_2 > 0){
                suryo = vm.editForm.sgytDtl[$index].suryo_2 * suryo;
                suryo_2_flg = true;
            }
            // ロックアウト（超過）対応
            if( Number(sg_item.over_fl) === 1 ){
                // 設定値より数量が多い場合
                if( suryo > sg_item.ov_suryo ){
                    ov_sr = suryo - sg_item.ov_suryo; // 元のアイテムは設定値に訂正
                    suryo = sg_item.ov_suryo;
                    // 追加アイテムの取得
                    ov_sg_item = $filter('filter')(sg_items, {sg_item_cd: sg_item.ov_sg_item_cd});
                    ov_goukei = ov_sg_item[0].base_tanka * ov_sr;
                    //$log.debug(vm.editScope.sgkyItems);
                    //$log.debug(vm.editForm.sgytDtl);
                    //var stt_tm = vm.editForm.sgytDtl[$index].stt_tm;
                    //var end_tm = vm.editForm.sgytDtl[$index].end_tm;
                    //var kitei = sg_item.ov_suryo;
                    //var timeItems = $rootScope.getSttAndEndTm(stt_tm, end_tm, kitei, ov_sr);
                    //vm.editForm.sgytDtl[$index].end_tm = timeItems.newEnd_tm;
                    
                    var suryo_1 = 0;
                    var suryo_2 = null;
                    if( Number(ov_sg_item[0].suryo_kbn_1) === 1 ){
                        suryo_1 = 1;
                        suryo_2 = ov_sr;
                    }else if( Number(ov_sg_item[0].suryo_kbn_1) === 2 ){
                        suryo_1 = ov_sr;
                    }
                    
                    var sgkyItems = {};
                    var sgkyItemsTmp = angular.copy(vm.editScope.sgkyItems[$index]);
                    // 新しい行を作る
                    angular.forEach(sgkyItemsTmp, function(v,k){
                        angular.forEach(ov_sg_item[0], function(va,ke){
                            if(k === ke) sgkyItems[k] = va;
                        });
                    });
                    sgkyItems.gyo_no = sgkyItemsTmp.gyo_no + 1;
                    sgkyItems.suryo_1 = suryo_1;
                    sgkyItems.suryo_2 = suryo_2;
                    sgkyItems.sg_bunrui_cd = ov_sg_item[0].sg_bunrui_cd;
                    sgkyItems.sg_item_cd = ov_sg_item[0].sg_item_cd;
                    sgkyItems.sg_item_nm = ov_sg_item[0].sg_item_nm;
                    sgkyItems.tani_1 = ov_sg_item[0].tani_1;
                    sgkyItems.tani_2 = ov_sg_item[0].tani_2;
                    sgkyItems.tanka = ov_sg_item[0].base_tanka;
                    sgkyItems.kin = ov_goukei;
                    
                    var sgytDtl = {};
                    var sgytDtlTmp = angular.copy(vm.editForm.sgytDtl[$index]);
                    sgytDtl.gyo_no = sgytDtlTmp.gyo_no + 1;
                    sgytDtl.sg_bunrui_cd = ov_sg_item[0].sg_bunrui_cd;
                    sgytDtl.sg_item_cd = ov_sg_item[0].sg_item_cd;
                    sgytDtl.sg_item_nm = ov_sg_item[0].sg_item_nm;
                    sgytDtl.suryo_1 = suryo_1;
                    sgytDtl.suryo_2 = suryo_2;
                    sgytDtl.tani_1 = ov_sg_item[0].tani_1;
                    sgytDtl.tani_2 = ov_sg_item[0].tani_2;
                    sgytDtl.tanka = ov_sg_item[0].base_tanka;
                    sgytDtl.kin = ov_goukei;
                    
                    vm.editScope.sgkyItems.splice($index+1, 0, sgkyItems);
                    // html内でindexを充てたのでobjになっている。一旦arrayに変換
                    var newItemsArr = $.map(vm.editForm.sgytDtl, function(value, index) {
                        return [value];
                    });
                    newItemsArr.splice($index+1, 0, sgytDtl);
                    // 再びobjに戻す
                    var newItemsObj = newItemsArr.reduce(function(o, v, i) {
                        o[i] = v; return o;
                    }, {});
                    vm.editForm.sgytDtl = newItemsObj;
                    if(suryo_2_flg){
                        vm.editForm.sgytDtl[$index].suryo_2 = (ov_sg_item[0].tani_2)?1:suryo;
                    }else{
                        vm.editForm.sgytDtl[$index].suryo_1 = (ov_sg_item[0].tani_2)?1:suryo;
                        vm.editForm.sgytDtl[$index].suryo_2 = (ov_sg_item[0].tani_2)?suryo:'';
                    }
                }
            }
        }
    }
    
    /************************************************** 作業項目Detail **********************************************/

    
    // Table Row追加
    vm.editScope.tableExtend = function(){
        var items = [];
        vm.editScope.sgkyItems.push(items);

        $log.debug(vm.editScope.sgkyItems);
        $log.debug(vm.editForm.sgytDtl);
    };
    // Table Row 複写
    vm.editScope.tableRowCopy = function($index){
        var sgkyItems = angular.copy(vm.editScope.sgkyItems[$index]);
        var sgytDtls = angular.copy(vm.editForm.sgytDtl[$index]);

        vm.editScope.sgkyItems.splice($index+1, 0, sgkyItems);

        // html内でindexを充てたのでobjになっている。一旦arrayに変換
        var newItemsArr = $.map(vm.editForm.sgytDtl, function(value, index) {
            return [value];
        });
        newItemsArr.splice($index+1, 0, sgytDtls);
        // 再びobjに戻す
        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
            o[i] = v; return o;
        }, {});
        vm.editForm.sgytDtl = newItemsObj;

        $log.debug(vm.editScope.sgkyItems);
        $log.debug(vm.editForm.sgytDtl);
    };
    // Table Row削除
    vm.editScope.tableCellDelete = function($index){
        vm.editScope.sgkyItems.splice($index , 1);
        // html内でindexを充てたのでobjになっている。一旦arrayに変換
        var newItemsArr = $.map(vm.editForm.sgytDtl, function(value, index) {
            return [value];
        });
        newItemsArr.splice($index , 1);
        // 再びobjに戻す
        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
            o[i] = v; return o;
        }, {});
        vm.editForm.sgytDtl = newItemsObj;

        $log.debug(vm.editScope.sgkyItems);
        $log.debug(vm.editForm.sgytDtl);

    };


    // 作業項目検索
    vm.editScope.sgItemApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/sgitem',
            method: "GET",
            params: {q:str}
        });
    };
    // 作業項目選択
    vm.editScope.sgItemSelected = function(selected) {
        var index = this.$parent.$index;// obj index
        if (selected) {
            //var res = selected.title.split(':');
            //vm.editForm.toku_cd = res[0];
            $http({
                url: dev.api + 'api/v1/sgitemdata',
                method: "GET",
                params: {cd:selected.originalObject.sg_item_cd}
            }).success(function(data) {
                if(data){
                    vm.editScope.sgkyItems[index].sg_item_nm = data.sg_item_nm;
                    vm.editScope.sgkyItems[index].tani_1 = data.tani_1;
                    vm.editScope.sgkyItems[index].tani_2 = data.tani_2;
                    vm.editForm.sgytDtl[index].sg_item_cd = data.sg_item_cd;
                    vm.editForm.sgytDtl[index].sg_bunrui_cd = data.sg_bunrui_cd;
                }
            });
        }
    };
    // 作業項目選択 Modalバージョン
    vm.editScope.sgItemModalSelected = function(sgItemCd,index) {
        //var index = this.$parent.$index;// obj index
        $http({
            url: dev.api + 'api/v1/sgitemdata',
            method: "GET",
            params: {cd:sgItemCd}
        }).success(function(data) {
            if(data){
                vm.editScope.sgkyItems[index].sg_item_nm = data.sg_item_nm;
                vm.editScope.sgkyItems[index].tani_1 = data.tani_1;
                vm.editScope.sgkyItems[index].tani_2 = data.tani_2;
                vm.editForm.sgytDtl[index].sg_item_cd = data.sg_item_cd;
                vm.editForm.sgytDtl[index].sg_bunrui_cd = data.sg_bunrui_cd;
            }
        });
    };


    /************************************************** /作業項目Detail **********************************************/


    // formSubmit
    /*
     * 作業予定作成時には、作業詳細は無くても登録できる
     * 詳細の予定がない場合もあるため（現場判断）
     */
    var message = {'POST':'登録','PUT':'更新','DELETE':'削除'};
    vm.editScope.planningSubmit = function(method){
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.sg_yt_day && is('Date', vm.editForm.sg_yt_day) ){
            vm.editForm.sg_yt_day = moment(vm.editForm.sg_yt_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.cancel_day && is('Date', vm.editForm.cancel_day) ){
            vm.editForm.cancel_day = moment(vm.editForm.cancel_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.print_nh_dt && is('Date', vm.editForm.print_nh_dt) ){
            vm.editForm.print_nh_dt = moment(vm.editForm.print_nh_dt).format('YYYY/MM/DD HH:mm');
        }

        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.sg_no){
                return false;
            }
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.sg_no){
                return false;
            }
            vm.editForm = {sg_no:vm.editForm.sg_no,ju_no:vm.editForm.ju_no};
        }

        $log.debug(vm.editForm);
        $http({
            url: dev.api + 'api/v1/planning' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            // formクリア
            if(method === 'POST'){
                vm.lead_ju_no = null;
                //vm.editScope.cancel(1);
                vm.hideEdit();
                $state.go($state.current, {juno:'000'}, {reload: true});

            }else{
                getResultsPage(1);//一覧更新
                vm.hideEdit();
            }
            var mess = message[method] + 'が完了しました。';
            toastr.info(mess, 'Info');
        });
    };

    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        if(mode !== 2){
            $state.go($state.current, {juno:'000'}, {reload: true});
        }else{
            vm.hideEdit();
        }
    };

    /*********************** 印刷 *****************************************/
    // 対象データ印刷

    vm.printSgyt = function(){
        if( vm.print_data ){
            storage.set('printTargetData', vm.print_data);
            if( $rootScope.openWindow ){
                $rootScope.openWindow.focus();
                $rootScope.openWindow.close();
            }
            $timeout(function(){
                $rootScope.openWindow = $window.open('#/print/sgyt','_blank','width=830,height=800,scrollbars=1,location=0');
            },500);
        }
    };

  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('OrdersController', OrdersController);

  /** @ngInject */
  /** @ngInject */
  function OrdersController($log, $timeout, $http, $auth, $stateParams,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, toastr) {

    $log.debug('OrdersController');

    var vm = this;
    vm.user = storage.get('user');
    
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    //console.log('isEditDisabled : ' + vm.isEditDisabled);
    
    // 既存受注に別の作業Noを紐付けるモード
    vm.isChangeJuNoEditMode = false;
    
    // Menu
    $rootScope.panelSelected(0,'001');
    vm.juNoChangeMode = false;
    // 受注No変更処理
    vm.lead_ju_no = null;
    vm.lead_sg_no = null;
    $log.debug($stateParams);
    if( $stateParams.param ){
        if($stateParams.param.juno && $stateParams.param.sgno){
            vm.lead_ju_no = $stateParams.param.juno;
            vm.lead_sg_no = $stateParams.param.sgno;
            $timeout(function(){
                vm.editModeInit(1, vm.lead_ju_no,vm.lead_sg_no);
            },1000);
        }else if( $stateParams.param.changeData ){
            vm.isChangeJuNoEditMode = true;
            vm.changeData = $stateParams.param.changeData;
            //storage.set('changeData', changeData);
            // Step1 該当する受注を絞込み検索
            vm.change_toku_cd = vm.changeData.toku_cd;
            vm.change_ju_day = vm.changeData.sg_day;
            // Step2 選択した受注に作業Noを紐付け
            // Step3　旧作業売上を削除,新しく選択した受注No.に紐づく作業報告を旧作業報告からコピー登録
            
        }
    }
    
    // Tooltip
    vm.editTooltip1 = {'title': '-受注編集-<br />受注の編集を行います'};
    vm.editTooltip2 = {'title': '-作業予定-<br />新規作業予定の入力を行います'};
    vm.editTooltip3 = {'title': '-作業売上-<br />作業報告無しで作業売上の入力を行います'};
    vm.editTooltip4 = {'title': '-作品完了-<br />作品を完了させます'};
    vm.editTooltip5 = {'title': '-売上-<br />売上の入力を行います'};

    /****************************************************** Search Area ************************************************/
    // フォーム初期化
    vm.formInit = function(toku_cd){
        // From初期化
        vm.form = {};
        vm.gyomu_nm = '';// 業務区分名
        vm.bumon_nm = '';// 受注部門名
        vm.ju_tanto_nm = '';// 担当営業名
        vm.toku_nm = ''; // 得意先名
        vm.form.fin_fl = '00';//作品Status
        vm.form.uriage_status_fl = '00'; // 売上Status
        vm.uriage_status = '問わず'; // 売上Status
        vm.fin_fl_nm = '問わず';
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        //console.log(vm.form.fromDate);
        vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };

        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 50;
        
        if(toku_cd){
            vm.form.toku_cd = toku_cd;
            vm.form.fromDate = new Date(vm.changeTargetData.ju_day);
        }
        if(vm.isChangeJuNoEditMode){
            vm.form.fin_fl = '01';
            vm.fin_fl_nm = '未完';
            vm.form.uriage_status_fl = '01';
            vm.uriage_status = '未計上';
            vm.form.toku_cd = vm.change_toku_cd;
            var fromBaseDate = new Date(vm.change_ju_day);
            fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
            vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
            vm.form.untilDate = new Date(vm.change_ju_day);
            /*
            $http({
                url: dev.api + 'api/v1/tokuisakicode',
                method: 'GET',
                params: {cd: vm.form.toku_cd}
            }).success(function(datas) {
                vm.toku_nm = datas.name;
            });
            */
        }
        vm.pagination = {
            current: 1
        };
        if( vm.user.tan_cd !== '9999' && vm.user.tan_cd !== '9998' ){
            var stChk = false;
            // 部門選択初期値
            angular.forEach(vm.commondata.bumon ,function(v,k){
                if(!stChk && vm.user.bumon_cd == v.bumon_cd){
                    vm.bumonSelect(v.bumon_cd, v.bumon_nm);
                    stChk = true;
                }
            });
            // 担当営業初期値
            if(stChk) vm.eigyoSelect(vm.user.tan_cd,　vm.user.syain_nm);
        }
        
        if(!vm.lead_ju_no){
            $timeout(function() {
                getResultsPage(1);
            }, 1500);
        }
        
    };
    
    vm.clearDates = function() {
        vm.selectedDate = null;
    };


    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    if( !vm.commondata ){
        $rootScope.getJuchuBumon();
        $timeout(function(){
            vm.commondata = storage.get('commondata');
        },3000);
    }
    // 受注部門
    vm.bumonDropdown = [{'text':'－－', 'click': 'orders.bumonSelect()'}];
    angular.forEach(vm.commondata.bumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'orders.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 業務区分
    vm.gyomuDropdown = [{'text':'－－', 'click': 'orders.kubunSelect()'}];
    angular.forEach(vm.commondata.gyomu ,function(v,k){
        vm.gyomuDropdown.push({'text':v.gyomu_kb + ' : '+ v.gyomu_nm, 'click': 'orders.kubunSelect("'+ v.gyomu_kb +'","'+ v.gyomu_nm +'")'});
    });
    // 表示用
    vm.getGyomuName = function(cd){
        var name;
        angular.forEach(vm.commondata.gyomu, function(v,k){
            if(v.gyomu_kb === cd ){
                name = v.gyomu_nm;
            }
        });
        return name;
    };
    // 業務区分選択
    vm.kubunSelect = function(gyomu_kb, gyomu_nm){
        if(gyomu_kb && gyomu_nm){
            vm.gyomu_nm = gyomu_nm;
            vm.form.gyomu_kb = gyomu_kb;
        }else{
            vm.gyomu_nm = '';
            vm.form.gyomu_kb = '';
        }
        
    };
    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.ju_bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        }else{
            vm.form.ins_bmn_cd = '';
            vm.bumon_nm = '';
        }
    };
    // 担当営業取得
    vm.eigyoDropdown = [];
    vm.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data, status, headers, config) {
            vm.eigyoDropdown = [{'text':'－－', 'click': 'orders.eigyoSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'orders.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 担当営業選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ju_tanto_cd = syain_cd;
            vm.ju_tanto_nm = syain_nm;
        }else{
            vm.form.ju_tanto_cd = '';
            vm.ju_tanto_nm = '';
        }
        
    };

    // 作品完了Status
    vm.workStatus = [{ id : '00' ,name: "問わず"}, {id : '01' ,name: "未完"}, {id : '02' ,name: "完了"}];
    vm.workStatusDropdown = [];
    angular.forEach(vm.workStatus ,function(v,k){
        vm.workStatusDropdown.push({'text':v.name, 'click': 'orders.workStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 作品完了選択
    vm.workStatusSelect = function(id, name){
        vm.form.fin_fl = id;
        vm.fin_fl_nm = name;
    };

    // 売上計上
    vm.uriageStatus = [{ id : '00' ,name: "問わず"}, {id : '01' ,name: "未計上"}, {id : '02' ,name: "計上済"}];
    vm.uriageStatusDropdown = [];
    angular.forEach(vm.uriageStatus ,function(v,k){
        vm.uriageStatusDropdown.push({'text':v.name, 'click': 'orders.uriageStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    //　売上計上選択
    vm.uriageStatusSelect = function(id, name){
        vm.form.uriage_status_fl = id;
        vm.uriage_status = name;
    };
    
    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            search = angular.copy(vm.form);
            if( search.fromDate && angular.isDate(search.fromDate) ){
                search.fromDate = moment(search.fromDate).format('YYYY/MM/DD');
            }
            if( search.untilDate && angular.isDate(search.untilDate) ){
                search.untilDate = moment(search.untilDate).format('YYYY/MM/DD');
            }
            angular.forEach(search,function(v,k){
                if(!v) delete search[k];//不要なparamは削除
             });
        }
        $http({
            url: dev.api + 'api/v1/order',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: "GET",
            params: {m:'ids',q:str,bumon_cd:vm.user.bumon_cd}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };
    
    vm.formInit();
    
    /***************************************************** 受注No.既存変更 *********************************************/
    
    // 登録/編集Modal
    vm.changeEditModal = $modal({
        templateUrl:'app/business-orders/change-modal.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openChangeModalEdit = function(){
        vm.changeEditModal.$promise.then(vm.changeEditModal.show);
    };
    // ModalClose
    vm.hideChangeModalEdit = function(){
        vm.changeEditModal.$promise.then(vm.changeEditModal.hide);
    };
    $scope.$on('vm.changeEditModal.hide',function(){
        //console.log('editModal.hide');
    });
    // 変更確認
    vm.changeJuNo = function(item){
        var changeData = vm.changeData;
        if( changeData.ju_no === item.ju_no){
            toastr.warning('同じ受注No.は選択できません', 'warning');
        }else{
            vm.changeTargetData = item;
            vm.openChangeModalEdit();
        }
    };
    // 変更登録実行
    vm.changeJuNoSubmit = function(){
        var params = {item:vm.changeData,target:vm.changeTargetData};
        $http({
            url: dev.api + 'api/v1/changejuno',
            method: "POST",
            params: {form:angular.toJson(params)}
        }).success(function(data) {
            //$state.go('app.business-earnings', {juno:'000',param:{ju_no:vm.changeTargetData.ju_no}} );
            vm.isChangeJuNoEditMode = false;
            toastr.info('受注No.変更が完了しました', 'info');
            vm.formInit(vm.form.toku_cd);
        });
    };

    /****************************************************** Edit Area ************************************************/
    // Scopeに注意

    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/business-orders/ordersedit.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    // ModalClose
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };
    $scope.$on('vm.editModal.hide',function(){
        //console.log('editModal.hide');
    });
    
    // 遷移確認Modal
    vm.selectModal = $modal({
        templateUrl:'app/business-orders/selectModal.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openSelect = function(){
        vm.selectModal.$promise.then(vm.selectModal.show);
    };
    // ModalClose
    vm.hideSelect = function(){
        vm.selectModal.$promise.then(vm.selectModal.hide);
        getResultsPage(1);
    };
    // Edit Disabled
    vm.isFromDisabled = false;

    // EditMode init
    vm.editForm = {};
    vm.editScope = {};
    vm.editModeInit = function(mode, ju_no, sg_no){
        vm.juNoChangeMode = false;
        vm.editScope.editMode = mode;
        // 新規登録
        if(mode === 1 && !ju_no && !sg_no){

            vm.isFromDisabled = false;

            // From初期化
            vm.editScope.item = {};
            vm.editForm = {};
            vm.editForm.fin_fl = '0';//作品Status
            vm.editForm.ju_tanka1 = '0';
            vm.editForm.ju_tanka2 = '0';
            vm.editForm.ju_tanka3 = '0';
            vm.editScope.selectedDate = new Date();
            vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);
            vm.editForm.ju_day = new Date();

            vm.editScope.getType = function(key) {
                return Object.prototype.toString.call(vm[key]);
            };
        // 編集モード
        }else if(mode === 2 && ju_no){
            vm.editScope.item = {};
            vm.editForm = {};

            $http({
                url: dev.api + 'api/v1/orderdetail',
                method: "GET",
                params: {ju_no:ju_no}
            }).success(function(data) {
                if(data){
                    $log.debug(data);
                    // Form情報セット
                    vm.editForm.fin_day = data.fin_day;
                    vm.editForm.fin_fl = data.fin_fl;
                    // 承認済みの場合は編集不可
                    if(vm.editForm.fin_fl > 0){
                        toastr.info('作品は完了しているため、編集できません', 'Info');
                        vm.isFromDisabled = true;
                    }
                    vm.editForm.gaibu_cd = data.gaibu_cd;
                    vm.editForm.gyomu_kb = data.gyomu_kb;
                    vm.editForm.hin_nm = data.hin_nm;
                    vm.editForm.hin_sm = data.hin_sm;
                    vm.editForm.ju_bumon_cd = data.ju_bumon_cd;
                    vm.editForm.ju_day = new Date(data.ju_day_time*1000);
                    vm.editForm.ju_no = data.ju_no;
                    vm.editForm.ju_tanka1 = data.ju_tanka1;
                    vm.editForm.ju_tanka2 = data.ju_tanka2;
                    vm.editForm.ju_tanka3 = data.ju_tanka3;
                    vm.editForm.ju_tanto_cd = data.ju_tanto_cd;
                    vm.editForm.memo = data.memo;
                    vm.editForm.studio_cd = data.studio_cd;
                    vm.editForm.toku_bumon_nm = data.toku_bumon_nm;
                    vm.editForm.toku_cd = data.toku_cd;
                    vm.editForm.toku_tanto_nm = data.toku_tanto_nm;
                    vm.editForm.toku_bumon_nm = data.toku_bumon_nm;

                    vm.editScope.item.ju_tanto_nm = data.ju_tanto_nm;
                    vm.editScope.item.ju_bumon_nm = data.ju_bumon_nm;
                    vm.editScope.item.gyomu_nm = vm.editScope.getGyomuName(data.gyomu_kb);
                    vm.editScope.item.studio_nm = vm.editScope.getStudioName(data.studio_cd);
                    vm.editScope.item.gaibu_nm = data.gaibu_nm;

                    $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                        url: dev.api + 'api/v1/tokuisakidata',
                        method: "GET",
                        params: {cd:data.toku_cd}
                    }).success(function(tokuData) {
                        if(tokuData){
                            vm.editScope.item.toku_nm = tokuData.toku_nm;
                            vm.editScope.item.adrs1 = tokuData.adrs1;
                            vm.editScope.item.adrs2 = tokuData.adrs2;
                            vm.editScope.item.tel_no = tokuData.tel_no;
                            vm.editScope.item.fax_no = tokuData.fax_no;
                            vm.editScope.item.shime_dd_nm = tokuData.shime_dd_nm;
                            vm.editScope.item.sk_shime_dd_nm = tokuData.sk_shime_dd_nm;
                            vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;

                        }
                    });
                }
            });
        // 受注No変更モード（受注No変更は結果で、目的を達成する手段）
        }else if(mode === 1 && ju_no && sg_no){
            vm.editScope.item = {};
            vm.editForm = {};
            vm.juNoChangeMode = true;
            $log.debug('juNoChangeMode');
            $http({
                url: dev.api + 'api/v1/orderdetail',
                method: "GET",
                params: {ju_no:ju_no}
            }).success(function(data) {
                if(data){
                    $log.debug(data);
                    // Form情報セット
                    vm.editForm.fin_day = data.fin_day;
                    vm.editForm.fin_fl = 0;
                    vm.editForm.gaibu_cd = data.gaibu_cd;
                    vm.editForm.gyomu_kb = data.gyomu_kb;
                    vm.editForm.hin_nm = data.hin_nm;
                    vm.editForm.hin_sm = data.hin_sm;
                    vm.editForm.ju_bumon_cd = data.ju_bumon_cd;
                    vm.editForm.ju_day = new Date(data.ju_day_time*1000);
                    vm.editForm.ju_tanka1 = 0;
                    vm.editForm.ju_tanka2 = 0;
                    vm.editForm.ju_tanka3 = 0;
                    vm.editForm.ju_tanto_cd = data.ju_tanto_cd;
                    vm.editForm.memo = data.memo;
                    vm.editForm.studio_cd = data.studio_cd;
                    vm.editForm.toku_bumon_nm = data.toku_bumon_nm;
                    vm.editForm.toku_cd = data.toku_cd;
                    vm.editForm.toku_tanto_nm = data.toku_tanto_nm;
                    vm.editForm.toku_bumon_nm = data.toku_bumon_nm;

                    vm.editScope.item.ju_tanto_nm = data.ju_tanto_nm;
                    vm.editScope.item.ju_bumon_nm = data.ju_bumon_nm;
                    vm.editScope.item.gyomu_nm = vm.editScope.getGyomuName(data.gyomu_kb);
                    vm.editScope.item.studio_nm = vm.editScope.getStudioName(data.studio_cd);
                    vm.editScope.item.gaibu_nm = data.gaibu_nm;

                    $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                        url: dev.api + 'api/v1/tokuisakidata',
                        method: "GET",
                        params: {cd:data.toku_cd}
                    }).success(function(tokuData) {
                        if(tokuData){
                            vm.editScope.item.toku_nm = tokuData.toku_nm;
                            vm.editScope.item.adrs1 = tokuData.adrs1;
                            vm.editScope.item.adrs2 = tokuData.adrs2;
                            vm.editScope.item.tel_no = tokuData.tel_no;
                            vm.editScope.item.fax_no = tokuData.fax_no;
                            vm.editScope.item.shime_dd_nm = tokuData.shime_dd_nm;
                            vm.editScope.item.sk_shime_dd_nm = tokuData.sk_shime_dd_nm;
                            vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;

                        }
                    });
                }
            });
        }
        // 画面Open
        vm.openEdit();
    };
    //console.log('isFromDisabled : ' + vm.isFromDisabled);

    // 受注部門
    vm.editScope.bumonDropdown = [{'text':'－－', 'click': 'orders.editScope.bumonSelect()'}];
    angular.forEach(vm.commondata.bumon ,function(v,k){
        vm.editScope.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'orders.editScope.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 業務区分
    vm.editScope.gyomuDropdown = [{'text':'－－', 'click': 'orders.editScope.kubunSelect()'}];
    angular.forEach(vm.commondata.gyomu ,function(v,k){
        vm.editScope.gyomuDropdown.push({'text':v.gyomu_kb + ' : '+ v.gyomu_nm, 'click': 'orders.editScope.kubunSelect("'+ v.gyomu_kb +'","'+ v.gyomu_nm +'")'});
    });
    // Studio
    vm.editScope.studioDropdown = [{'text':'－－', 'click': 'orders.editScope.studioSelect()'}];
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.editScope.studioDropdown.push({'text':v.studio_cd + ' : '+ v.studio_nm, 'click': 'orders.editScope.studioSelect("'+ v.studio_cd +'","'+ v.studio_nm +'")'});
    });
    // 業務区分表示用
    vm.editScope.getGyomuName = function(cd){
        var name;
        angular.forEach(vm.commondata.gyomu, function(v,k){
            if(v.gyomu_kb === cd ){
                name = v.gyomu_nm;
            }
        });
        return name;
    };
    // スタジオ表示用
    vm.editScope.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };
    // 業務区分選択
    vm.editScope.kubunSelect = function(gyomu_kb, gyomu_nm){
        if(gyomu_kb && gyomu_nm){
            vm.editScope.item.gyomu_nm = gyomu_nm;
            vm.editForm.gyomu_kb = gyomu_kb;
        }else{
            vm.editScope.item.gyomu_nm = '';
            vm.editForm.gyomu_kb = '';
        }
        
    };
    // 受注部門選択
    vm.editScope.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.editForm.ju_bumon_cd = bumon_cd;
            vm.editScope.item.ju_bumon_nm = bumon_nm;
            vm.editScope.getTantoEigyo(bumon_cd);
        }else{
            vm.editForm.ju_bumon_cd = '';
            vm.editScope.item.ju_bumon_nm = '';
        }
    };
    // Studio選択
    vm.editScope.studioSelect = function(studio_cd, studio_nm){
        if(studio_cd && studio_nm){
            vm.editForm.studio_cd = studio_cd;
            vm.editScope.item.studio_nm = studio_nm;
        }else{
            vm.editForm.studio_cd = '';
            vm.editScope.item.studio_nm = '';
        }
    };
    // 担当営業取得
    vm.editScope.eigyoDropdown = [];
    vm.editScope.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.editScope.eigyoDropdown = [{'text':'－－', 'click': 'orders.editScope.eigyoSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.editScope.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'orders.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 担当営業選択
    vm.editScope.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.editForm.ju_tanto_cd = syain_cd;
            vm.editScope.item.ju_tanto_nm = syain_nm;
        }else{
            vm.editForm.ju_tanto_cd = '';
            vm.editScope.item.ju_tanto_nm = '';
        }
    };

    // 作品完了Status
    vm.editScope.workStatus = [ {id : '0' ,name: "未完"}, {id : '1' ,name: "完了"}];

    // 得意先検索実行
    vm.editScope.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: "GET",
            params: {q:str,bumon_cd:vm.user.bumon_cd}
        });
    };
    
    // 得意先の選択
    vm.editScope.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.editForm.toku_cd = res[0];
            vm.editScope.item.toku_nm = res[1];
            $http({
                url: dev.api + 'api/v1/tokuisakidata',
                method: "GET",
                params: {cd:res[0]}
            }).success(function(data) {
                if(data){
                    vm.editScope.item.adrs1 = data.adrs1;
                    vm.editScope.item.adrs2 = data.adrs2;
                    vm.editScope.item.tel_no = data.tel_no;
                    vm.editScope.item.fax_no = data.fax_no;
                    vm.editScope.item.shime_dd_nm = data.shime_dd_nm;
                    vm.editScope.item.sk_shime_dd_nm = data.sk_shime_dd_nm;
                    vm.editScope.item.sk_tani_nm = data.sk_tani_nm;
                    vm.editForm.toku_tanto_nm = data.toku_tanto;
                    vm.editForm.toku_bumon_nm = data.toku_bumon_nm;
                }
            });
        }
    };
    // 外部関係者情報取得
    vm.editScope.gaibukankeiApiSearch = function(str) {
        //$log.debug('gaibukankei');
        return $http({
            url: dev.api + 'api/v1/gaibukankeiuser',
            method: "GET",
            params: {m:'name',q:str}
        });
    };
    // 外部関係者選択
    vm.editScope.gaibukanekiSelected = function(selected) {
        if (selected) {
            vm.editForm.gaibu_cd = selected.description;
            vm.editScope.item.gaibu_nm = selected.title;
        }
    };
    // 完了フラグ監視
    $scope.$watch(function() { return vm.editForm.fin_fl;},
        function(newVal,oldVal) {
            if(newVal !== oldVal){
                if(vm.editForm.fin_fl === '1'){
                    vm.editForm.fin_day = new Date();
                }else{
                    delete vm.editForm.fin_day;
                }
            }
        }, true);
    
    // formSubmit
    vm.editScope.orderSubmit = function(method){
        $log.debug(vm.editForm);

        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.ju_day && is('Date', vm.editForm.ju_day) ){
            vm.editForm.ju_day = moment(vm.editForm.ju_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.fin_day && is('Date', vm.editForm.fin_day) ){
            vm.editForm.fin_day = moment(vm.editForm.fin_day).format('YYYY/MM/DD');
        }

        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.ju_no){
                return false;
            }
        }
        // 変更モードでは旧ju_no,sg_noを追加
        vm.editForm.change_mode = false;
        if( vm.juNoChangeMode && vm.lead_sg_no){
            vm.editForm.change_mode = true;
            vm.editForm.sg_no = vm.lead_sg_no;
            vm.editForm.old_ju_no = vm.lead_ju_no;
        }
        $http({
            url: dev.api + 'api/v1/order' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            // formクリア
            if(method === 'POST') {
                if(data){
                    toastr.success('登録が完了しました。', 'Success');
                    vm.hideEdit();
                    vm.link_ju_no = data
                    //console.log(vm.link_ju_no);
                    if( vm.juNoChangeMode ){
                        $state.go($state.current, null, {reload: true});
                    }else{
                        $timeout(function(){
                            vm.openSelect();
                        },500);
                    }
                }
            }else{
                vm.hideEdit(); // ModalClose
                getResultsPage(1);//一覧更新
                toastr.success('変更が完了しました。', 'Success');
            }
        });
    };
    // 受注削除実行
    vm.editScope.oderDelete = function() {
        if(!vm.editForm.ju_no){
            return false;
        }
        // 削除対象チェック
        $http({
            url: dev.api + 'api/v1/deltargetcheck',
            method: 'GET',
            params: {ju_no:vm.editForm.ju_no}
        }).success(function(data) {
            
            if(data.result){
                // 削除実行
                $http({
                    url: dev.api + 'api/v1/order/delete',
                    method: "DELETE",
                    params: {ju_no:vm.editForm.ju_no}
                }).success(function(){
                    toastr.success('削除しました', 'Success');
                    getResultsPage(1);
                    vm.hideEdit();
                });                
            }else{
                toastr.warning('作業報告、作業売上、売上データが存在しているため削除できません', 'Warning');
            }
        });
    };
    // 登録/更新Formクリア
    vm.editScope.cancel = function(mode){
        vm.editModeInit(mode);
    };

    /****************************** 作品完了Area *****************************************/

    // Modal Error
    vm.modal1 = $modal({templateUrl:'app/business-orders/modal1.html', scope: $scope, show:false});
    vm.showErrorModal = function(){
        vm.modal1.$promise.then(vm.modal1.show);
    };
    vm.hideErrorModal = function(){
        vm.modal1.$promise.then(vm.modal1.hide);
    };

    // 登録Modal
    vm.completeModal = $modal({
        templateUrl:'app/business-orders/completeedit.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openComplete = function(){
        vm.completeModal.$promise.then(vm.completeModal.show);
    };
    // ModalClose
    vm.hideComplete = function(){
        vm.completeModal.$promise.then(vm.completeModal.hide);
    };

    vm.errorItems = null;
    vm.errorJuNo = null;

    // 作品完了
    vm.worksComplete = function(ju_no){
        $http({
            url: dev.api + 'api/v1/completecheck',
            method: 'GET',
            params: {ju_no:ju_no}
        }).success(function(data) {
            vm.errorItems = null;
            vm.errorJuNo = null;

            $log.debug(data);
            if( !data.check ){
                vm.errorItems = data.item;
                vm.errorJuNo = ju_no;
                vm.showErrorModal();
            }else{
                // 作業売上情報を取得
                $http({
                    url: dev.api + 'api/v1/completedetail',
                    method: 'GET',
                    params: {ju_no:ju_no}
                }).success(function(ret) {
                    if(ret){
                        $log.debug(ret);
                        vm.completeData = ret;

                        vm.openComplete();
                    }
                });
            }
        });
    };
    // Total金額
    vm.getTotalKin = function(item){
        var total = 0;
        angular.forEach(item, function(itm){
            total += itm.sgur.sg_kin;
        });
        return total;
    };
    // メディア取得
    vm.getMediaName = function(cd){
        var name;
        angular.forEach(vm.commondata.media, function(v,k){
            if(v.media_cd === cd ){
                name = v.media_nm;
            }
        });
        return name;
    };
    // 作品完了実行
    vm.completeSubmit = function(ju_no){
        $http({
            url: dev.api + 'api/v1/addcomplete',
            method: 'POST',
            params: { ju_no : ju_no }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideComplete();
        });
    };
    // 作品完了実行
    vm.completeSubmitCancel = function(ju_no){
        $http({
            url: dev.api + 'api/v1/addcompletecancel',
            method: 'POST',
            params: { ju_no : ju_no }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            vm.hideEdit(); // ModalClose
            getResultsPage(1);//一覧更新
            toastr.warning('作品完了をキャンセルしました。', 'Warning');
        });
    };

    // 売上実行/遷移
    vm.modal2 = $modal({templateUrl:'app/business-orders/modal2.html', scope: $scope, show:false});
    vm.showUriageChkModal = function(){
        vm.modal2.$promise.then(vm.modal2.show);
    };
    vm.hideUriageChkModal = function(){
        vm.modal2.$promise.then(vm.modal2.hide);
    };
    vm.addUriage = function(ju_no){
        $http({
            url: dev.api + 'api/v1/uriagecheck',
            method: 'GET',
            params: {ju_no:ju_no}
        }).success(function(data) {
            vm.uriageFlg = false;
            if( data.check ){
                vm.errorJuNo = ju_no;
                vm.showUriageChkModal();
            }else{
                $state.go('app.business-workearnings', {juno:ju_no});
            }
        });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('ExpensesController', ExpensesController);

  /** @ngInject */
  function ExpensesController($log, $timeout, $http, $auth, $window, $filter,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr) {

    /*
     * ■機能
     *  経理に支払依頼する経費データの新規作成、修正、削除を行います。特定の受注（作品）に関する直接原価は、
     *  作業伝票№の入力を行います。（月次処理にて原価配賦を行う際、入力された作業報告に配賦されます。）
     * ■説明
     *  ・”仮払い”についての入力は行いません。経理へ書面にて申請します。
     *  ・”テープ”についての立替分は、経費入力を行わず、在庫管理担当者へ申し出て下さい。
     *  ・新たに経費データを作成する場合の手順は以下の通りです。
     *  
     *  1.新規ボタンを押下します。
     *  2.左上から順に各項目の入力を行います。各項目については画面をクリックし項目説明を参照して下さい。
     *  3.入力内容を確認し、保存ボタンを押下します。（連続入力も可能です。）
     *  
     *  ・消費税は選択された経費分類が”交通費”の場合「内税」、”交通費”でない場合「外税」にて自動計算を行います。
     *  ・既に承認済の経費は修正できません。
     *  
     *  （経費承認が行われているかどうかは、経費一覧の「承認１」「承認２」を参照して下さい。）
     *  
     *  ・ログイン者と異なる部門に所属している社員が入力したデータは修正することができません。
     *  ・未払金、買掛金の管理を本システムにて行う為、未払金、買掛金の計上が伴う支払で、かつ在庫管理を行わないものは経費入力を行って下さい。（在庫管理を行うものは、仕入入力を行います。）
     */
      
    $log.debug('ExpensesController');

    var vm = this;
    vm.user = storage.get('user');
    vm.controllerAliasName = 'exp';
    
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    // 承認可能
    vm.approvalUser = false;
    if( vm.user.sys_admin_fl === '1' || vm.user.sys_admin_fl === '2' ){
        vm.approvalUser = true;
    }
    vm.acountingUserFlg = false;
    //console.log(vm.user);
    // 一般１で経理は許可 0420
    if( vm.user.sys_admin_fl === '1' || ( vm.user.sys_admin_fl === '2' && vm.user.bumon_cd === '0420') ){
        vm.acountingUserFlg = true;
    }
    // Menu
    $rootScope.panelSelected(0,'006');

    // Tooltip
    //vm.editTooltipText1 = {'title': '-作業売上編集-<br />作業売上の編集と承認を行います'};
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    vm.loginUser = storage.get('user');
    
    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.futan_bumon_nm = '';
        vm.ss_bumon_nm = '';
        vm.kh_bunrui_nm = '';
        vm.ss_tan_nm = '';
        vm.form.kr_sn_fl = '00';
        vm.form.sn_fl = '00';
        vm.sn_fl_nm = '問わず';
        vm.kr_sn_fl_nm = '問わず';
        vm.itemDetail = [];
        vm.editScope = {};
        vm.editForm ={};
        vm.editForm.detail = {};
        vm.set_sg_no = '';

        //vm.form.kh_noFrom = '13080191';//test 交通費&SG
        //vm.form.kh_noTo = '13080191';//test　交通費&SG
        //vm.form.kh_noFrom = '15060094';//test　交通費複数
        //vm.form.kh_noTo = '15060094';//test　交通費複数
        //vm.form.kh_noFrom = '15100060';//test
        //vm.form.kh_noTo = '15100060';//test
        
        
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-12);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        
        vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };
        
        vm.getKeihiOptionData();
        
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 15;
        if( $stateParams.param && $stateParams.param.sg_no){
            //vm.set_ju_no = $stateParams.param.ju_no;
            vm.set_sg_no = $stateParams.param.sg_no;
        }else{
            if( vm.loginUser.tan_cd !== '9999' && vm.loginUser.tan_cd !== '9998' ){
                var stChk = false;
                // 部門選択初期値
                angular.forEach(vm.commondata.bumon ,function(v,k){
                    if(!stChk && vm.loginUser.bumon_cd == v.bumon_cd){
                        vm.futanBumonSelect(v.bumon_cd, v.bumon_nm);
                        stChk = true;
                    }
                });
                // 担当営業初期値
                if(stChk) vm.eigyoSelect(vm.loginUser.tan_cd,　vm.loginUser.syain_nm);
            }
            getResultsPage(1);
        }
        vm.pagination = {
            current: 1
        };

    };

    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    if( vm.loginUser.sys_admin_fl === '5' || vm.loginUser.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    vm.approvalUser = false;
    if( vm.loginUser.sys_admin_fl === '1' || vm.loginUser.sys_admin_fl === '2' ){
        vm.approvalUser = true;
    }
    
    // 関係データ取得
    vm.getKeihiOptionData = function() {
        $http({
            url: dev.api + 'api/v1/getkeihioptiondata',
            method: 'GET',
            params: {bumon_cd:vm.loginUser.bumon_cd}
        }).success(function(data) {
            // 負担部門
            vm.futanBumonDropdown = [{'text':'－－', 'click': 'exp.futanBumonSelect()'}];
            vm.editScope.futanBumonDropdown = [{'text':'－－', 'click': 'exp.editScope.futanBumonSelect()'}];
            angular.forEach(data.keihi_bumon ,function(v,k){
                vm.futanBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'exp.futanBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.futanBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'exp.editScope.futanBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'","'+ v.bumon_syokusyu +'","'+ v.tec_bumon_kb +'")'});
            });
            // 経費分類
            vm.khBunruiDropdown = [{'text':'－－', 'click': 'exp.khBunruiSelect()'}];
            vm.editScope.khBunruiHDropdown = [{'text':'－－', 'click': 'exp.editScope.khBunruiSelect()'}];
            vm.editScope.khBunruiGDropdown = [{'text':'－－', 'click': 'exp.editScope.khBunruiSelect()'}];
            angular.forEach(data.keihi_bunrui ,function(v,k){
                vm.khBunruiDropdown.push({'text':v.kh_bunrui_cd + ' : '+ v.kh_bunrui_nm, 'click': 'exp.khBunruiSelect("'+ v.kh_bunrui_cd +'","'+ v.kh_bunrui_nm +'")'});
                if(v.kh_bunrui_nm.indexOf('H-') > -1){
                    vm.editScope.khBunruiHDropdown.push({'text':v.kh_bunrui_cd + ' : '+ v.kh_bunrui_nm, 'click': 'exp.editScope.khBunruiSelect("'+ v.kh_bunrui_cd +'","'+ v.kh_bunrui_nm +'","'+ v.kotuhi_fl +'","'+ v.kmk_kbn +'")'});
                }else if(v.kh_bunrui_nm.indexOf('G-') > -1){
                    vm.editScope.khBunruiGDropdown.push({'text':v.kh_bunrui_cd + ' : '+ v.kh_bunrui_nm, 'click': 'exp.editScope.khBunruiSelect("'+ v.kh_bunrui_cd +'","'+ v.kh_bunrui_nm +'","'+ v.kotuhi_fl +'","'+ v.kmk_kbn +'")'});
                }
            });
            vm.taxrate = data.taxrate;
            vm.keihiKamoku_origin = data.keihi_kamoku;
            vm.sinseiUser = data.sinseiUser;
            // 担当(申請者）
            vm.eigyoDropdown = [{'text':'－－', 'click': 'exp.eigyoSelect()'}];
            vm.editScope.eigyoDropdown = [{'text':'－－', 'click': 'exp.editScope.eigyoSelect()'}];
            angular.forEach(data.sinseiUser ,function(v,k){
                vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'exp.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                vm.editScope.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'exp.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
            });
        });
    };
    
    
    // 負担部門選択
    vm.futanBumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.futan_bmn_cd = bumon_cd;
            vm.futan_bmn_nm = bumon_nm;
        }else{
            vm.form.futan_bmn_cd = '';
            vm.futan_bmn_nm = '';
        }
        
    };
    // 経費分類選択
    vm.khBunruiSelect = function(kh_bunrui_cd, kh_bunrui_nm){
        if(kh_bunrui_cd && kh_bunrui_nm){
            vm.form.kh_bunrui_cd = kh_bunrui_cd;
            vm.kh_bunrui_nm = kh_bunrui_nm;
        }else{
            vm.form.kh_bunrui_cd = '';
            vm.kh_bunrui_nm = '';
        }
    };
    // 経費科目絞込み
    vm.khKamokuEdit = function(){
        vm.editScope.keihiKamokuDropdown = [];//{'text':'－－', 'click': 'exp.editScope.keihiKamokuSelect(key,null)'}
        angular.forEach(vm.keihiKamoku ,function(v,k){
            vm.editScope.keihiKamokuDropdown.push({'text':v.seq_no + ' : '+ v.dsp_nm, 'click': 'exp.editScope.keihiKamokuSelect(key,"'+k+'")'});
        });
    }

    // 担当(申請)者選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ss_tan_cd = syain_cd;
            vm.ss_tan_nm = syain_nm;
        }else{
            vm.form.ss_tan_cd = '';
            vm.ss_tan_nm = '';
        }
    };

    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            if( vm.form.sgFromDate && is('Date', vm.form.sgFromDate) ){
                vm.form.sgFromDate = moment(vm.form.sgFromDate).format('YYYY/MM/DD');
            }
            if( vm.form.sgUntilDate && is('Date', vm.form.sgUntilDate) ){
                vm.form.sgUntilDate = moment(vm.form.sgUntilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/expenses',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
            vm.itemDetail = [];
        });
    }

    // 支払い先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str,bumon_cd:vm.user.bumon_cd}
        });
    };

    // 支払い先選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.tori_cd = res[0];
            vm.tori_nm = res[1];
        }
    };

    // 承認状態
    vm.krSnfl = [{id:'00', name:'問わず'},{id:'01', name:'承認済み'}, {id:'02', name:'未承認'}];
    vm.krSnfllDropdown = [];
    vm.snflDropdown = [];
    angular.forEach(vm.krSnfl ,function(v,k){
        vm.krSnfllDropdown.push({'text':v.name, 'click': 'exp.krSnflSelect("'+ v.id +'","'+ v.name +'")'});
        vm.snflDropdown.push({'text':v.name, 'click': 'exp.snflSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 承認状態選択
    vm.krSnflSelect = function(id, name){
        vm.form.kr_sn_fl = id;
        vm.kr_sn_fl_nm = name;
    };
    // 承認状態選択
    vm.snflSelect = function(id, name){
        vm.form.sn_fl = id;
        vm.sn_fl_nm = name;
    };
    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    // 小窓セット
    vm.detailSet = function(detail){
        vm.itemDetail = detail;
    }
    
    vm.formInit();
    
    /****************************************************** Edit Area ************************************************/
    
    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/business-expenses/expensesEdit.html',
        scope: $scope,
        show:false
    });
    // モーダル監視
    $scope.$on('modal.hide', function() {
        //console.log('modal.hide');
        //console.log($stateParams.param);
        if( $stateParams.param && Object.keys($stateParams.param).length > 0 ){
            $stateParams.param = null;
            vm.formInit();
        }
    });
    
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };
    
    // 印刷確認Modal
    vm.comformModal = $modal({
        templateUrl:'app/business-expenses/comformModal.html',
        scope: $scope,
        show:false
    });
    vm.openComform = function(){
        vm.comformModal.$promise.then(vm.comformModal.show);
    };
    vm.hideComform = function(){
        vm.comformModal.$promise.then(vm.comformModal.hide);
    };

    // 作業報告データ取得
    vm.getSgHkData = function(sg_no){
        if(sg_no && vm.editForm){
            vm.editForm.sg_no = sg_no;
            vm.editForm.sg_toku_nm = '';
            vm.editForm.sg_day_time = '';
            vm.editForm.sg_bumon_nm = '';
            vm.editForm.sg_keitai_nm = '';
            vm.editForm.sg_studio_nm = '';
            vm.editForm.sg_bumon_nm = '';
            vm.editForm.sg_hin_nm = '';
            
            $http({
                url: dev.api + 'api/v1/getreportdetaildata',
                method: 'GET',
                params: {sg_no:sg_no}
            }).success(function(data) {
                //console.log(data)
                var sght = data.sght;
                var order = data.order;
                vm.editForm.sg_toku_nm = order.toku_nm;
                vm.editForm.sg_day_time = sght.sg_day_time;
                vm.editForm.sg_bumon_nm = sght.sg_bumon_nm;
                vm.editForm.sg_keitai_nm = sght.sg_keitai_nm;
                vm.editForm.sg_studio_nm = sght.sg_studio_nm;
                vm.editForm.sg_bumon_nm = sght.sg_bmn_nm;
                vm.editForm.sg_hin_nm = order.hin_nm;
            });
        }
    }
    
    // EditMode init
    vm.sgKeitaiReadSleep = false;
    vm.editForm = {};
    vm.editScope = {};
    vm.approvalEditCheck = true;
    vm.detailFormInit = function(mode, item){

        vm.editScope.khBunruiDropdown = [];
        vm.editScope.editMode = mode;
        vm.isFromDisabled = false;
        vm.approvalEditCheck = true;
        vm.editForm = {};
        vm.editForm.detail = [];
        // 経費分類種類(営業H、技術G）
        //vm.shu = [{id:'H', name:'H'},{id:'G', name:'G'}];
        vm.editScope.shuDropdown = [];
        //angular.forEach(vm.shu ,function(v,k){
        //    vm.editScope.shuDropdown.push({'text':v.name, 'click': 'exp.editScope.shuSelect("'+ v.id +'","'+ v.name +'")'});
        //});
        vm.editScope.shuSelect = function(id, name){
            //console.log('shuSelect');
            if( id === 'H'){
                vm.editScope.khBunruiDropdown = vm.editScope.khBunruiHDropdown;
            }else{
                vm.editScope.khBunruiDropdown = vm.editScope.khBunruiGDropdown;
            }
        };
        //vm.editScope.shuSelect('H','H');
        
        // 新規登録
        if(mode === 1){
            if(!item){
                vm.editForm.ss_day = new Date();
                vm.editForm.ss_day_time = moment().unix();
                vm.editForm.kotuhi_fl = '0';
                vm.editForm.futan_bmn_cd = vm.loginUser.bumon_cd;
                vm.editForm.futan_bmn_nm = vm.loginUser.bumon_nm;
                vm.editForm.ss_tan_cd = vm.loginUser.tan_cd;
                vm.editForm.ss_tan_nm = vm.loginUser.syain_nm;
                vm.editForm.sg_no = '';
                vm.editForm.sg_toku_nm = '';
                vm.editForm.sg_day_time = '';
                vm.editForm.sg_bumon_nm = '';
                vm.editForm.sg_keitai_nm = '';
                vm.editForm.sg_studio_nm = '';
                vm.editForm.sg_bumon_nm = '';
                vm.editForm.sg_hin_nm = '';
                // 作業報告からの遷移
                if(vm.set_sg_no){
                    vm.getSgHkData(vm.set_sg_no);
                }
                // 選択された部門によって経費分類を絞込み
                if( !vm.loginUser.tec_bumon_kb || Number(vm.loginUser.tec_bumon_kb) === 0 ){
                    if( Number(vm.loginUser.bumon_syokusyu) === 3 || vm.loginUser.bumon_cd === '0300' || vm.loginUser.bumon_cd === '0340'){
                        vm.editScope.shuSelect('G','G');
                    }else{
                        vm.editScope.shuSelect('H','H');
                    }
                }else{
                    vm.editScope.shuSelect('G','G');
                }
            }else{
                // 複写モード
                vm.editForm.sg_no = '';
                vm.editForm.sg_toku_nm = '';
                vm.editForm.sg_day_time = '';
                vm.editForm.sg_bumon_nm = '';
                vm.editForm.sg_keitai_nm = '';
                vm.editForm.sg_studio_nm = '';
                vm.editForm.sg_bumon_nm = '';
                vm.editForm.sg_hin_nm = '';
                vm.editForm = angular.copy(item);
                vm.editForm.kh_no = '';//新規扱い
                if(vm.editForm.sg_no){
                    // 作業Noは継承しない
                    //vm.getSgHkData(vm.set_sg_no);
                }
                vm.editForm.ss_day = new Date();
                vm.editForm.ss_day_time = moment().unix();
                if( vm.editForm.detail.length > 0 ){
                    angular.forEach(vm.editForm.detail, function(v,k){
                        if(v.siyo_day_time > 0) vm.editForm.detail[k].siyo_day = new Date(v.siyo_day_time*1000);
                    })
                }
                if( angular.isDefined(vm.editForm.detail) ){
                    var zBreak = false;
                    angular.forEach(vm.editForm.detail,function(v,k){
                        if(!zBreak && v.zei_kb) vm.editForm.zei_kb = v.zei_kb; zBreak = true;
                    });
                }
                vm.keihiKamoku = $filter('filter')(vm.keihiKamoku_origin, {kh_bunrui_cd: item.kh_bunrui_cd});
                vm.khKamokuEdit();
                
                if(vm.approvalUser){
                    $timeout(function(){
                        $scope.$watch(function() { return vm.editForm;}, function(newVal,oldVal) {
                            if( (newVal.kh_no === oldVal.kh_no) && (newVal !== oldVal) ){
                                vm.approvalEditCheck = false;
                            }
                        }, true);
                    },1500);
                }
                // 選択された部門によって経費分類を絞込み
                if( !item.futan_tec_bumon_kb || Number(item.futan_tec_bumon_kb) === 0 ){
                    if( Number(item.futan_bumon_syokusyu) === 3 || item.futan_bmn_cd === '0300' || item.futan_bmn_cd === '0340'){
                        vm.editScope.shuSelect('G','G');
                    }else{
                        vm.editScope.shuSelect('H','H');
                    }
                }else{
                    vm.editScope.shuSelect('G','G');
                }
            }
        // 編集モード
        }else if(mode === 2 && item){

            vm.sgKeitaiReadSleep = true;
            // 承認済みの場合は編集不可
            if(item.sn_fl_1 > 0){
                toastr.info('承認済みのため、編集できません', 'Info');
                vm.isFromDisabled = true;
            }
            //console.log(item);
            vm.editForm.sg_no = '';
            vm.editForm.sg_toku_nm = '';
            vm.editForm.sg_day_time = '';
            vm.editForm.sg_bumon_nm = '';
            vm.editForm.sg_keitai_nm = '';
            vm.editForm.sg_studio_nm = '';
            vm.editForm.sg_bumon_nm = '';
            vm.editForm.sg_hin_nm = '';
            vm.editForm = angular.copy(item);
            if(item.ss_day_time > 0){
                vm.editForm.ss_day = new Date(item.ss_day_time*1000);
            }
            if( vm.editForm.detail.length > 0 ){
                angular.forEach(vm.editForm.detail, function(v,k){
                    if(v.siyo_day_time > 0) vm.editForm.detail[k].siyo_day = new Date(v.siyo_day_time*1000);
                })
            }
            if( angular.isDefined(vm.editForm.detail) ){
                var zBreak = false;
                angular.forEach(vm.editForm.detail,function(v,k){
                    if(!zBreak && v.zei_kb) vm.editForm.zei_kb = v.zei_kb; zBreak = true;
                });
            }
            vm.keihiKamoku = $filter('filter')(vm.keihiKamoku_origin, {kh_bunrui_cd: item.kh_bunrui_cd});
            vm.khKamokuEdit();
            
            if(vm.approvalUser){
                $timeout(function(){
                    $scope.$watch(function() { return vm.editForm;}, function(newVal,oldVal) {
                        if( (newVal.kh_no === oldVal.kh_no) && (newVal !== oldVal) ){
                            vm.approvalEditCheck = false;
                        }
                    }, true);
                },1500);
            }
            //console.log('item.futan_tec_bumon_kb > '+item.futan_tec_bumon_kb);
            //console.log('item.futan_bumon_syokusyu > '+item.futan_bumon_syokusyu);
         // 選択された部門によって経費分類を絞込み
            if( !item.futan_tec_bumon_kb || Number(item.futan_tec_bumon_kb) === 0 ){
                if( Number(item.futan_bumon_syokusyu) === 3 || item.futan_bmn_cd === '0300' || item.futan_bmn_cd === '0340'){
                    vm.editScope.shuSelect('G','G');
                }else{
                    vm.editScope.shuSelect('H','H');
                }
            }else{
                vm.editScope.shuSelect('G','G');
            }
        }

        // 担当(申請者）切り替え
        vm.getSinseiUser = function(bumon_cd){
            $http({
                url: dev.api + 'api/v1/getkeihisinseisya',
                method: 'GET',
                params: {bumon_cd:bumon_cd}
            }).success(function(data) {
                vm.editScope.eigyoDropdown = [{'text':'－－', 'click': 'exp.editScope.eigyoSelect()'}];
                angular.forEach(data.sinseiUser ,function(v,k){
                    vm.editScope.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'exp.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            });
        }
        
        
        // 画面Open
        vm.openEdit();
        // Edit負担部門選択
        vm.editScope.futanBumonSelect = function(bumon_cd, bumon_nm, bumon_syokusyu, tec_bumon_kb){
            //console.log('bumon_syokusyu : ' + bumon_syokusyu);
            //console.log('tec_bumon_kb : ' + tec_bumon_kb);
            if(bumon_cd && bumon_nm){
                vm.editForm.futan_bmn_cd = bumon_cd;
                vm.editForm.futan_bmn_nm = bumon_nm;
                if( !tec_bumon_kb || Number(tec_bumon_kb) === 0 ){
                    if( Number(bumon_syokusyu) === 3 || bumon_cd === '0300' || bumon_cd === '0340'){
                        vm.editScope.shuSelect('G','G');
                    }else{
                        vm.editScope.shuSelect('H','H');
                    }
                }else{
                    vm.editScope.shuSelect('G','G');
                }
                vm.getSinseiUser(bumon_cd);
            }else{
                vm.editForm.futan_bmn_cd = '';
                vm.editForm.futan_bmn_nm = '';
            }
            
        };
        // Edit経費分類選択
        vm.editScope.khBunruiSelect = function(kh_bunrui_cd, kh_bunrui_nm, kotuhi_fl, kmk_kbn){
            vm.editForm.nuki_kin = 0;
            vm.editForm.zei_kin = 0;
            vm.editForm.komi_kin = 0;
            vm.keihiKamoku = [];
            if(kh_bunrui_cd && kh_bunrui_nm){
                vm.editForm.kh_bunrui_cd = kh_bunrui_cd;
                vm.editForm.kotuhi_fl = kotuhi_fl;
                vm.editForm.kh_bunrui_nm = kh_bunrui_nm;
                vm.editForm.kasi_knj_kb = kmk_kbn;
                
                vm.keihiKamoku = $filter('filter')(vm.keihiKamoku_origin, {kh_bunrui_cd: kh_bunrui_cd});
                //console.log(kmk_kbn);
                // torihikisakiの表示
                vm.editScope.torihikiFlg = '1';
                if( Number(kmk_kbn) === 3 || Number(kmk_kbn) === 2 ) {
                    vm.editScope.torihikiFlg = '2';
                }
                vm.khKamokuEdit();
            }else{
                vm.editForm.kh_bunrui_cd = '';
                vm.editForm.kotuhi_fl = '0';
                vm.editForm.kh_bunrui_nm = '';
                vm.editForm.kasi_knj_kb = '1';
                vm.keihiKamoku = [];
                vm.editForm.detail = [];
            }
            
            // 新規の場合科目の数だけ初期明細データを生成
            if( vm.keihiKamoku.length > 0 ){
                vm.editForm.detail = [];
                angular.forEach(vm.keihiKamoku, function(v, k){
                    vm.editForm.zei_kb = '2';
                    var zei_kb_nm = '内税';
                    //if(vm.editForm.kotuhi_fl === 1) zei_kb = '1';
                    if( Number(kmk_kbn) === 3 || Number(kmk_kbn) === 2 ) {
                        vm.editForm.zei_kb = '1';
                        zei_kb_nm = '外税';
                    }
                    
                    var detail = {
                            biko:'',
                            end_chi:'',
                            futan_bmn_cd:'',
                            futan_bmn_nm:'',
                            gyo_no: v.seq_no,
                            hojyo_kmk_cd: v.hojyo_kmk_cd,
                            ikisaki:'',
                            kamoku_nm: v.dsp_nm,
                            kin:0,
                            kmk_cd: v.kmk_cd,
                            komi_kin:0,
                            nuki_kin:0,
                            oufuku_fl:'0',
                            seq_no: v.seq_no,
                            shudan:'',
                            siyo_day:'',
                            stt_chi:'',
                            taisya:'',
                            tekiyo:'',
                            zei_kb: vm.editForm.zei_kb,
                            zei_kb_nm: zei_kb_nm,
                            zei_kin:0
                    };
                    vm.editForm.detail.push(detail);
                });
            }
        };

        // 経費科目選択
        vm.editScope.keihiKamokuSelect = function($index, itemKey){
            if($index !=null && itemKey !=null){
                var item = vm.keihiKamoku[itemKey];
                vm.editForm.detail[$index].seq_no = item.seq_no;
                vm.editForm.detail[$index].kamoku_nm = item.dsp_nm;
                vm.editForm.detail[$index].kmk_cd = item.kmk_cd;
                vm.editForm.detail[$index].hojyo_kmk_cd = item.hojyo_kmk_cd;
            }else{
                vm.editForm.detail[$index].seq_no = '';
                vm.editForm.detail[$index].kamoku_nm = '';
                vm.editForm.detail[$index].kmk_cd = '';
                vm.editForm.detail[$index].hojyo_kmk_cd = '';
            }
        };
        // 消費税計算時に％切り替えがあった場合を想定して入力（変更）時に判定させる
        $scope.$watch(function() { return vm.editForm.ss_day;}, function(newVal,oldVal) {
            if(newVal !== oldVal){
                vm.editForm.ss_day_time = moment(new Date(vm.editForm.ss_day)).unix();
            }
        });

        // 担当(申請)者選択
        vm.editScope.eigyoSelect = function(syain_cd, syain_nm){
            if(syain_cd && syain_nm){
                vm.editForm.ss_tan_cd = syain_cd;
                vm.editForm.ss_tan_nm = syain_nm;
            }else{
                vm.editForm.ss_tan_cd = '';
                vm.editForm.ss_tan_nm = '';
            }
        };
        
        // sg_no watch
        $scope.$watch(function() { return vm.editForm.sg_no;}, function(newVal,oldVal) {
            if( (newVal !== oldVal) ){
                vm.getSgHkData(vm.editForm.sg_no);
            }
        }, true);
        
        
    };
    
    // 作業報告からの経費登録遷移の場合
    if(vm.set_sg_no){
        vm.detailFormInit(1, null);
    }
    

    // 金額計算
    $scope.$watch(function() { return vm.editForm.detail;}, function(newVal,oldVal) {
        // 古い承認ずみのデータは再計算しない
        if(!vm.isFromDisabled && angular.isDefined(vm.editForm.detail) ){
            if(vm.editForm.detail.length > 0 && (newVal !== oldVal) ){
                // 消費税が10%になる日を想定。日付の境界をきちんと設定
                var ss_day = vm.editForm.ss_day_time*1000;
                var taxrate = 0;
                angular.forEach(vm.taxrate, function(v, k){
                    var start_day = v.start_day_time*1000;
                    var end_day = null;
                    if( v.end_day_time ) {
                        end_day = v.end_day_time*1000;
                    }
                    // 現在
                    if( start_day <= ss_day && !end_day){
                        taxrate = parseFloat(v.tax_rate);
                    }else if(end_day && (start_day <= ss_day) && (ss_day <= end_day) ){
                        // 古い値
                        taxrate = parseFloat(v.tax_rate);
                    }
                })

                var kotuhi_fl = vm.editForm.kotuhi_fl;
                var totalKin = [];
                var totalZeiKin = [];
                var totalNukiKin = [];
                var totalKomiKin = [];
                var totalshoukeiKin = [];
                angular.forEach(vm.editForm.detail, function(v, k){
                    //console.log('zei_kb :'+v.zei_kb);
                    if(v.kin && v.kin != 0) {
                        var zei_kin = 0;
                        var nukiKin = 0;
                        if( Number( v.zei_kb) !== 1 ){
                            nukiKin = Math.floor(v.kin / (1+taxrate));
                        }else{
                            nukiKin = v.kin;
                        }
                        if( Number( v.zei_kb ) === 1 ){
                            zei_kin =  Math.floor(v.kin*taxrate);
                        }else if( Number( v.zei_kb ) === 2 ) {
                            zei_kin = v.kin-nukiKin;
                        }
                        var kin = v.kin;
                        if( Number( v.zei_kb) === 1 ){
                            kin = v.kin+zei_kin;
                        }
                        totalNukiKin.push(nukiKin);
                        totalZeiKin.push(zei_kin);
                        totalshoukeiKin.push(v.kin);
                        totalKin.push(kin);
                        vm.editForm.detail[k].kin = v.kin;
                        vm.editForm.detail[k].nuki_kin = nukiKin;
                        vm.editForm.detail[k].zei_kin = zei_kin;
                        vm.editForm.detail[k].komi_kin = kin;
                    }
                    /*
                    if(v.kin && v.kin !== 0) {
                        var nukiKin = Math.floor(v.kin / (1+taxrate));
                        totalKin.push(v.kin);
                        totalNukiKin.push(nukiKin);
                        totalZeiKin.push(v.kin-nukiKin);
                        vm.editForm.detail[k].kin = v.kin;
                        vm.editForm.detail[k].nuki_kin = nukiKin;
                        vm.editForm.detail[k].zei_kin = v.kin-nukiKin;
                        vm.editForm.detail[k].komi_kin = v.kin;
                    }
                    */
                });
                //console.log(vm.editForm.detail);
                if(totalKin.length > 0){
                    vm.editForm.kei_kin = totalshoukeiKin.reduce(function(pre, curr) {
                        return Number(pre) + Number(curr);
                    });
                    vm.editForm.nuki_kin = totalNukiKin.reduce(function(pre, curr) {
                        return Number(pre) + Number(curr);
                    });
                    vm.editForm.zei_kin = totalZeiKin.reduce(function(pre, curr) {
                        return Number(pre) + Number(curr);
                    });
                    vm.editForm.komi_kin = totalKin.reduce(function(pre, curr) {
                        return Number(pre) + Number(curr);
                    });
                }
            }
        }
    }, true);

    // 作業項目取得
    vm.editScope.getSgkeitaiitem = function(str){
        return $http({
            url: dev.api + 'api/v1/sgkeitaiitem',
            method: 'GET',
            params: {cd:str}
        }).success(function(data) {
            if(data){
                $log.debug(data);
                vm.editScope.sgkyItems = data;
            }
        });
    };

    /************************************************** 作業項目Detail **********************************************/

    // Table Row追加
    vm.editScope.tableExtend = function(){
        var zei_kb = vm.editForm.zei_kb;
        //console.log(zei_kb);
        //if(vm.editForm.kotuhi_fl === 1) zei_kb = '1';
        var detail = {
                biko:'',
                end_chi:'',
                futan_bmn_cd:'',
                futan_bmn_nm:'',
                gyo_no: '',
                hojyo_kmk_cd:'',
                ikisaki:'',
                kamoku_nm: '',
                kin:0,
                kmk_cd: '',
                komi_kin:0,
                nuki_kin:0,
                oufuku_fl:'0',
                seq_no: '',
                shudan:'',
                siyo_day:'',
                stt_chi:'',
                taisya:'',
                tekiyo:'',
                zei_kb: zei_kb,
                zei_kb_nm: zei_kb==='2'?'内税':'外税',
                zei_kin:0
        };
        var base = angular.copy(vm.editForm.detail);
        base.push(detail);
        vm.editForm.detail = base;
    };
    // Table Row 複写
    vm.editScope.tableRowCopy = function($index){
        //console.log($index);
        var base = angular.copy(vm.editForm.detail);
        var detail = angular.copy(base[$index]);
        base.splice($index+1, 0, detail);
        vm.editForm.detail = base;
        $log.debug(vm.editForm.detail);
    };
    // Table Row削除
    vm.editScope.tableCellDelete = function($index){
        //console.log($index);
        var base = angular.copy(vm.editForm.detail);
        base.splice($index , 1);
        vm.editForm.detail = base;
        $log.debug(vm.editForm.detail);
    };

    /************************************************** /作業項目Detail **********************************************/
    
    // formSubmit
    vm.editScope.expensesSubmit = function(method){
        $log.debug(vm.editForm);
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.ss_day && is('Date', vm.editForm.ss_day) ){
            vm.editForm.ss_day = moment(vm.editForm.ss_day).format('YYYY/MM/DD');
        }
        angular.forEach(vm.editForm.detail, function(v,k){
            if( v.siyo_day && is('Date', v.siyo_day) ) {
                vm.editForm.detail[k].siyo_day = moment(v.siyo_day).format('YYYY/MM/DD');
            }
            if(!vm.editForm.detail[k].taisya || vm.editForm.detail[k].taisya === ''){
                vm.editForm.detail[k].taisya = null;
            }
        });
        var completeMessage = 'が完了しました';
        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.kh_no){
                return false;
            }
            completeMessage = '更新'+completeMessage;
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.kh_no){
                return false;
            }
            vm.editForm = {kh_no:vm.editForm.kh_no};
            completeMessage = '削除'+completeMessage;
        }else{
            completeMessage = '登録'+completeMessage;
        }

        $http({
            url: dev.api + 'api/v1/expenses' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            if(method === 'POST' ){
                vm.openComform();
                getResultsPage(1);//一覧更新
                vm.hideEdit();
            }else{
                getResultsPage(1);//一覧更新
                vm.hideEdit();
                toastr.info(completeMessage, 'Info');
            }
        });
    };

    // formSubmit 承認
    vm.editScope.approvalSubmit = function(){
        var params = {kh_no:vm.editForm.kh_no};
        $http({
            url: dev.api + 'api/v1/expensesapproval',
            method: 'POST',
            params: { form : params }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.info('承認しました', 'Info');
        });
    };

    // formSubmit 承認
    vm.editScope.disApprovalSubmit = function(){
        var params = {kh_no:vm.editForm.kh_no};
        $http({
            url: dev.api + 'api/v1/expensesdisapproval',
            method: 'POST',
            params: { form : params }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.info('承認取消しました', 'Info');
        });
    };
    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        vm.hideEdit();
    };

    // 明細印刷
    vm.editScope.goPrint = function(mode){
        if(!mode) mode = 2;
        var tmp = [];
        var items = angular.copy(vm.editForm);
        if(mode === 1){
            angular.forEach(items.detail, function(v,k){
                if( v.kin && Number(v.kin) !== 0) tmp.push(v); 
            });
            items.detail = tmp;
        }
        storage.set('printExpData', items);
        $rootScope.openWindow = $window.open('#/exp-print', '_blank','width=1100,height=800,scrollbars=1,location=0');
    };
    
    
  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('EarningsController', EarningsController);

  /** @ngInject */
  function EarningsController($log, $timeout, $http, $auth, $rootScope, $filter, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr) {

    $log.debug('EarningsController');
    $scope.controllerAliasName = 'earnings';
    /*
     * 作業報告の無い状態で、作業売上を新規登録できるのが元の仕様だが、
     * 結局作業報告が存在しないと、承認が通らない。
     * よって、作業売上の新規登録は廃止する
     */

    var vm = this;
    vm.user = storage.get('user');
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    // 承認可能
    vm.approvalUser = false;
    if( vm.user.sys_admin_fl === '1' || vm.user.sys_admin_fl === '2' || vm.user.sys_admin_fl === '3'){
        vm.approvalUser = true;
    }
    // Menu
    $rootScope.panelSelected(0,'004');

    // Tooltip
    vm.editTooltipText1 = {'title': '-作業売上編集-<br />作業売上の編集と承認を行います'};
    vm.editTooltipText2 = {'title': '-作業売上閲覧-<br />作業売上の確認を行います'};
    vm.editTooltipText3 = {'title': '作業項目検索<br />チェックONでスペース検索、チェックOFFで直接ID検索です'};
    
    // 他処理から引継ぎの場合
    vm.lead_ju_no = null;
    if( $stateParams.juno !== '000' && $stateParams.juno.length > 3 ){
        vm.lead_ju_no = $stateParams.juno;
        $timeout(function(){
            vm.editModeInit(1, $stateParams.juno);
        },1000);
    }


    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        //vm.form.sn_fl_1 = '0';
        vm.bumon_nm = '';// 受注部門名
        vm.ju_tanto_nm = '';// 担当営業名
        vm.sg_bmn_nm = ''; // 作業予定部門名
        vm.simei_gj_nm_1 = '';// 作業予定担当者名
        vm.studio_nm = ''; //スタジオ名
        vm.selectedDate = new Date();
        vm.selectedDateAsNumber = Date.UTC(2001, 1, 1);

        vm.form.sn_fl = '00';
        vm.sn_fl_nm = '問わず';
        vm.form.ur_fl = '00';
        vm.ur_fl_nm = '問わず';

        vm.totalKin = 0;
        // 3年前の1/1を基準とする
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-6);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        
        vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 30;
        
        if( vm.user.tan_cd !== '9999' && vm.user.tan_cd !== '9998' ){
            var stChk = false;
            // 部門選択初期値
            angular.forEach(vm.commondata.bumon ,function(v,k){
                if(!stChk && vm.user.bumon_cd == v.bumon_cd){
                    vm.bumonSelect(v.bumon_cd, v.bumon_nm);
                    stChk = true;
                }
            });
            // 担当営業初期値
            if(stChk) vm.eigyoSelect(vm.user.tan_cd,　vm.user.syain_nm);
        }
        
        if(!vm.lead_ju_no){
            // 受注指定検索
            if( $stateParams.param ){
                vm.form.fromDate = null;
                vm.form.untilDate = null;
                vm.form.ju_noFrom = $stateParams.param.ju_no;
                vm.form.ju_noTo = $stateParams.param.ju_no;
            }
            $timeout(function() {
                getResultsPage(1);
            }, 1500);
        }
        vm.pagination = {
            current: 1
        };

    };
    
    vm.clearDates = function() {
        vm.selectedDate = null;
    };


    // 使いましデータ取得
    vm.commondata = storage.get('commondata');

    // 受注部門
    vm.bumonDropdown = [{'text':'－－', 'click': 'earnings.bumonSelect()'}];
    angular.forEach(vm.commondata.bumon ,function(v,k){
        vm.bumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'earnings.bumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    // 作業部門
    vm.sghtDropdown = [{'text':'－－', 'click': 'earnings.sghtSelect()'}];
    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
        vm.sghtDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'earnings.sghtSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
    });
    //$log.debug(vm.sghtDropdown);
    // Studio
    vm.studioDropdown = [{'text':'－－', 'click': 'earnings.studioSelect()'}];
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.studioDropdown.push({'text':v.studio_cd + ' : '+ v.studio_nm, 'click': 'earnings.studioSelect("'+ v.studio_cd +'","'+ v.studio_nm +'")'});
    });

    // スタジオ表示用
    vm.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };
    // Studio選択
    vm.studioSelect = function(studio_cd, studio_nm){
        if(studio_cd && studio_nm){
            vm.form.studio_cd = studio_cd;
            vm.studio_nm = studio_nm;
        }else{
            vm.form.studio_cd = '';
            vm.studio_nm = '';
        }
    };

    // 作業部門選択
    vm.sghtSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.sg_bmn_nm = bumon_nm;
            vm.form.sg_bmn_cd = bumon_cd;
            vm.getsghtsyain(bumon_cd);
        }else{
            vm.sg_bmn_nm = '';
            vm.form.sg_bmn_cd = '';
        }
    };

    // 受注部門選択
    vm.bumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.ju_bumon_cd = bumon_cd;
            vm.bumon_nm = bumon_nm;
            vm.getTantoEigyo(bumon_cd);
        }else{
            vm.form.ju_bumon_cd = '';
            vm.bumon_nm = '';
        }
    };

    // 担当営業取得
    vm.eigyoDropdown = [];
    vm.getTantoEigyo = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data, status, headers, config) {
            vm.eigyoDropdown = [{'text':'－－', 'click': 'earnings.eigyoSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'earnings.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 担当営業選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ju_tanto_cd = syain_cd;
            vm.ju_tanto_nm = syain_nm;
        }else{
            vm.form.ju_tanto_cd = '';
            vm.ju_tanto_nm = '';
        }
    };

    // 作業担当取得
    vm.sghtsyaDropdown = [];
    vm.getsghtsyain = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/tantoueigyo',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.sghtsyaDropdown = [{'text':'－－', 'click': 'earnings.sghtSyaSelect()'}];
            if(data){
                angular.forEach(data ,function(v,k){
                    vm.sghtsyaDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'earnings.sghtSyaSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                });
            }
        });
    };
    // 作業担当選択
    vm.sghtSyaSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.gj_cd_1 = syain_cd;
            vm.gj_nm_1 = syain_nm;
        }else{
            vm.form.gj_cd_1 = '';
            vm.gj_nm_1 = '';
        }
    };

    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;


    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/earnings',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            vm.totalKin = datas.totalKin;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
        });
    }

    // 得意先検索実行
    vm.tokuisakiApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/tokuisaki',
            method: 'GET',
            params: {m:'ids',q:str}
        });
    };

    // 得意先の選択
    vm.tokuisakiSelected = function(selected) {
        if (selected) {
            var res = selected.title.split(':');
            vm.form.toku_cd = res[0];
            vm.toku_nm = res[1];
        }
    };

    // 承認状態
    vm.snflStatus = [{id:'00', name:'問わず'},{id:'01', name:'承認済み'}, {id:'02', name:'未承認'}];
    vm.snflStatusDropdown = [];
    angular.forEach(vm.snflStatus ,function(v,k){
        vm.snflStatusDropdown.push({'text':v.name, 'click': 'earnings.snflStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 承認状態選択
    vm.snflStatusSelect = function(id, name){
        vm.form.sn_fl = id;
        vm.sn_fl_nm = name;
    };
    // 売上状態
    vm.uriageStatus = [{id:'00', name:'問わず'},{id:'01', name:'計上済み'}, {id:'02', name:'未計上'}];
    vm.uriageStatusDropdown = [];
    angular.forEach(vm.uriageStatus ,function(v,k){
        vm.uriageStatusDropdown.push({'text':v.name, 'click': 'earnings.uriageStatusSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 売上状態選択
    vm.uriageStatusSelect = function(id, name){
        vm.form.ur_fl = id;
        vm.ur_fl_nm = name;
    };

    // 検索実行
    vm.goSearch = function(){

        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };
    
    vm.formInit();

    /****************************************************** Edit Area ************************************************/
    // Scopeに注意
    /*
     * 受注No(ju_no)を持って遷移してきた場合は
     * 新規作業予定登録画面を表示させる
     * （受注情報を取得）
     * 編集の場合は作業予定No.(sg_no）から情報を取得
     */

    // Formの無効化(disabled)
    vm.isFromDisabled = false;


    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/business-earnings/earningsedit.html',
        scope: $scope,
        show:false
    });
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };

    // EditMode init
    vm.sgKeitaiReadSleep = false;
    vm.editForm = {};
    vm.editForm.sgurDtl = {};
    vm.editForm.sgurMemo = {};
    vm.editScope = {};
    vm.approvalEditCheck = true;
    vm.creditNote = false;
    /*
     * 赤伝処理追加 2016/10/17
     */
    vm.editModeInit = function(mode, ju_no, sg_no, creditNote){
        if(!creditNote) {
            vm.creditNote = false;
        }else{
            vm.creditNote = true;
            //console.log('ju_no:'+ju_no, sg_no+', sg_no:'+ sg_no);
        }
        vm.editScope.editMode = mode;
        vm.isFromDisabled = false;
        vm.approvalEditCheck = true;
        
        /*
         * 作業売上は、作業報告承認⇒作業売上新規登録(画面無し)という流れとなる.
         * この新規登録画面は受注から作業報告無しで直接作業売上登録を行う場合に利用
         */

        // 新規登録
        if(mode === 1 && ju_no && !sg_no){

            vm.editScope.item = {};
            vm.editForm = {};
            vm.editScope.item.bumon_nm = '';        // 受注部門名
            vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
            vm.editScope.item.sg_bmn_nm = '';    // 作業部門
            vm.editForm.sg_time = '';
            vm.sgKeitaiReadSleep = true;

            $http({
                url: dev.api + 'api/v1/orderdetail',
                method: 'GET',
                params: {ju_no:ju_no}
            }).success(function(data) {
                $log.debug(data);
                var order = data;
                vm.editScope.sgkyItems = [];

                // 受注情報、売上情報初期値
                vm.editForm.sg_jt_kb = '0';     // 作業状態
                vm.editForm.gj_kb_1 = '1';      // 技術員区分(1～3+[4外部]とする-固定）
                vm.editForm.gj_kb_2 = '2';      // 技術員区分(1～3+[4外部]とする-固定）
                vm.editForm.gj_kb_3 = '3';      // 技術員区分(1～3+[4外部]とする-固定）
                vm.editForm.gj_kb_4 = '4';      // 技術員区分(1～3+[4外部]とする-固定）
                vm.editForm.sg_hk_fl = 0;       // 作業報告FLG(Default:0)
                vm.editForm.print_fl = 0;       // プリントFLG(Default:0)
                /*
                vm.editForm.sg_bmn_cd = '';         // 作業部門
                vm.editForm.gyomu_kb = '';           // 業務区分
                vm.editForm.sg_keitai_cd = '';       // 作業形態
                vm.editForm.studio_cd = '';         // 作業予定スタジオ
                vm.editForm.sg_day = new Date();
                vm.editForm.sg_tm_fm = '';  // 作業予定時間FROM
                vm.editForm.sg_tm_to = '';  // 作業予定時間TO
                vm.editForm.sg_time = '';        // 作業予定時間
                vm.editForm.gj_cd_1 = '';              // 作業技術員１
                vm.editForm.gj_tm_fm_1 = '';    // 作業時間FROM１
                vm.editForm.gj_tm_to_1 = '';    // 作業時間TO１
                vm.editForm.gj_time_mae_1 = '';  // 作業時間前１
                vm.editForm.gj_time_ato_1 = '';  // 作業時間後１
                vm.editForm.gj_time_1 = '';          // 作業時間１

                vm.editForm.gj_cd_2 = '';              // 作業技術員２
                vm.editForm.gj_tm_fm_2 = '';    // 作業時間FROM２
                vm.editForm.gj_tm_to_2 = '';    // 作業時間TO２
                vm.editForm.gj_time_2 = '';          // 作業時間２
                vm.editForm.gj_time_mae_2 = '';  // 作業時間前２
                vm.editForm.gj_time_ato_2 = '';  // 作業時間後２
                vm.editForm.gj_cd_3 = '';              // 作業技術員３
                vm.editForm.gj_tm_fm_3 = '';    // 作業時間FROM３
                vm.editForm.gj_tm_to_3 = '';    // 作業時間TO３
                vm.editForm.gj_time_3 = '';         // 作業時間３
                vm.editForm.gj_time_mae_3 = ''; // 作業時間前３
                vm.editForm.gj_time_ato_3 = ''; // 作業時間後３
                vm.editForm.gj_cd_4 = '';             // 作業技術員４
                vm.editForm.gj_tm_fm_4 = '';   // 作業時間FROM４
                vm.editForm.gj_tm_to_4 = '';   // 作業時間TO４
                vm.editForm.gj_time_4 = '';         // 作業時間４
                vm.editForm.gj_time_mae_4 = ''; // 作業時間前４
                vm.editForm.gj_time_ato_4 = ''; // 作業時間後４
                vm.editForm.print_nh_dt = null;                 // プリント納品日
                vm.editForm.nh_kb = '';                 // プリント納品区分
                vm.editForm.nh_hosoku = '';         // プリント納品補足
                vm.editForm.genban_kb = '';         // プリント原版区分
                */
                vm.editScope.sg_kin = 0;               // 作業金額
                vm.editScope.selectedDate = new Date();
                vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);

                //console.log(order);
                // 受注情報
                vm.editForm.ju_no = order.ju_no;                 // 受注No.
                vm.editForm.ju_tanto_cd = order.ju_tanto_cd; // 担当営業CD
                vm.editForm.toku_cd = order.toku_cd;         // 得意先CD
                vm.editForm.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名

                // 表示項目
                vm.editScope.item.hin_nm = order.hin_nm; // 作品名
                vm.editScope.item.ju_tanto_nm = order.ju_tanto_nm; // 担当営業名
                vm.editScope.item.ju_bumon_nm = order.ju_bumon_nm; // 受注部門名

                $timeout(function(){

                    $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                        url: dev.api + 'api/v1/tokuisakidata',
                        method: 'GET',
                        params: {cd:order.toku_cd}
                    }).success(function(tokuData) {
                        if(tokuData){
                            vm.editScope.item.toku_nm = tokuData.toku_nm;
                            vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;
                            vm.sgKeitaiReadSleep = false;
                            
                            $timeout(function(){
                                vm.changeGjKtPat1(0);
                                vm.changeGjKtPat2(0);
                                vm.changeGjKtPat3(0);
                                vm.changeGjKtPat4(0);
                            },1000);
                        }
                    });
                },500);
            });

        // 編集モード
        }else if(mode === 2 && ju_no && sg_no){

            vm.ju_no = ju_no;
            vm.sg_no = sg_no;
            
            // 月次実施済みか、実施月は正しいかチェックして表示
            vm.kaiKihon = {};
            vm.monthlyDateCheck = false;
            vm.monthlyDateLastCheck = false;
            vm.ShowAll = false;
            $http({
                url: dev.api + 'api/v1/getkaikihon',
                method: 'GET'
            }).success(function(datas) {
                vm.kaiKihon = datas;
                var ym = vm.kaiKihon.getuji_ym.toString();
                // 最終月次実施月末
                vm.last = moment(ym, 'YYYYMMDD').endOf('month').unix();
                vm.monthlyFlg = false;
            
                vm.editScope.item = {};
                vm.editForm = {};
                vm.editScope.item.bumon_nm = '';        // 受注部門名
                vm.editScope.item.ju_tanto_nm = '';     // 担当営業名
                vm.editScope.item.sg_bmn_nm = '';    // 作業予定部門名
                //vm.editScope.item.simei_gj_nm_1 = '';   // 作業予定担当者名
                //vm.editScope.item.studio_nm = '';     // スタジオ名
                vm.editForm.sg_time = '';
                vm.sgKeitaiReadSleep = true;
                vm.editScope.sgkyItems = [];
                
                var url = dev.api + 'api/v1/earningsdetail';
                if(vm.creditNote) url = dev.api + 'api/v1/earningsdetail-note';
                
                $http({
                    url: url,
                    method: 'GET',
                    params: {ju_no:ju_no,sg_no:sg_no}
                }).success(function(data) {
                    if(data.sgur){
                        $log.debug(data);
                        var sgur = data.sgur;
                        var order = data.order;
                        var sgurDtl = data.sgurDtl;
                        vm.sgur = sgur;
                        vm.order = order;
                        
                        // 承認済みの場合は編集不可
                        if(sgur.sn_fl_1 > 0){
                            if(!vm.creditNote){
                                toastr.info('承認済みのため、編集できません', 'Info');
                                vm.isFromDisabled = true;
                            }
                        }
    
                        // 作業予定
                        vm.editForm.ju_no = sgur.ju_no;                 // 受注No.
                        vm.editForm.sg_no = sgur.sg_no;                 // 作業No.
                        vm.editForm.sg_jt_kb = sgur.sg_jt_kb;           // 作業状態
                        vm.editForm.gj_kb_1 = sgur.gj_kb_1;             // 技術員区分
                        vm.editForm.gj_kb_2 = sgur.gj_kb_2;             // 技術員区分
                        vm.editForm.gj_kb_3 = sgur.gj_kb_3;             // 技術員区分
                        vm.editForm.gj_kb_4 = sgur.gj_kb_4;             // 技術員区分
                        vm.editForm.sg_hk_fl = Number(sgur.sg_hk_fl);   // 作業報告FLG(Default:0)
                        vm.editForm.print_fl = Number(sgur.print_fl);   // プリントFLG(Default:0)
                        vm.editForm.sg_bmn_cd = sgur.sg_bmn_cd;         // 作業部門
                        vm.editForm.gyomu_kb = sgur.gyomu_kb;           // 業務区分
                        vm.editForm.sg_keitai_cd = sgur.sg_kt_cd;       // 作業形態
                        vm.editForm.studio_cd = sgur.studio_cd;         // 作業予定スタジオ
                        vm.editForm.sg_day = null;
                        if(sgur.sg_day_time > 0){
                            //console.log(sgur.sg_day_time + ' SG Date : ' + moment(new Date(sgur.sg_day_time*1000)).format() );
                            //console.log(vm.last + ' LAST Date : ' + moment(new Date(vm.last*1000)).format() );
                            if(!vm.creditNote){
                                // 月次済み(作品完了済み)か判断
                                if( Number(order.fin_fl) > 0 ){
                                    vm.monthlyFlg = true;
                                }else{
                                    vm.monthlyFlg = false;
                                }
                            }else{
                                vm.sg_day_minDate = moment(sgur.sg_day_time*1000).format("YYYY/MM/DD");
                            }
                            vm.editForm.sg_day = new Date(sgur.sg_day_time*1000);// 作業日
                        }
                        vm.editForm.sg_tm_fm = sgur.sg_tm_fm_str;  // 作業予定時間FROM
                        vm.editForm.sg_tm_to = sgur.sg_tm_to_str;  // 作業予定時間TO
                        vm.setSgurTime();//時間整形
                        vm.editForm.sg_time = sgur.sg_time;        // 作業予定時間
                        vm.editForm.gj_cd_1 = sgur.gj_cd_1;              // 作業技術員１
                        vm.editForm.gj_tm_fm_1 = sgur.gj_tm_fm_1_str;    // 作業時間FROM１
                        vm.editForm.gj_tm_to_1 = sgur.gj_tm_to_1_str;    // 作業時間TO１
                        vm.setGjTime1();                                 //時間整形
                        vm.editForm.gj_time_mae_1 = sgur.gj_time_mae_1;  // 作業時間前１
                        vm.editForm.gj_time_ato_1 = sgur.gj_time_ato_1;  // 作業時間後１
                        vm.editForm.gj_time_1 = sgur.gj_time_1;          // 作業時間１
    
                        vm.editForm.gj_cd_2 = sgur.gj_cd_2;              // 作業技術員２
                        vm.editForm.gj_tm_fm_2 = sgur.gj_tm_fm_2_str;    // 作業時間FROM２
                        vm.editForm.gj_tm_to_2 = sgur.gj_tm_to_2_str;    // 作業時間TO２
                        vm.setGjTime2();//時間整形
                        vm.editForm.gj_time_2 = sgur.gj_time_2;          // 作業時間２
                        vm.editForm.gj_time_mae_2 = sgur.gj_time_mae_2;  // 作業時間前２
                        vm.editForm.gj_time_ato_2 = sgur.gj_time_ato_2;  // 作業時間後２
                        vm.editForm.gj_cd_3 = sgur.gj_cd_3;              // 作業技術員３
                        vm.editForm.gj_tm_fm_3 = sgur.gj_tm_fm_3_str;    // 作業時間FROM３
                        vm.editForm.gj_tm_to_3 = sgur.gj_tm_to_3_str;    // 作業時間TO３
                        vm.setGjTime3();//時間整形
                        vm.editForm.gj_time_3 = sgur.gj_time_3;         // 作業時間３
                        vm.editForm.gj_time_mae_3 = sgur.gj_time_mae_3; // 作業時間前３
                        vm.editForm.gj_time_ato_3 = sgur.gj_time_ato_3; // 作業時間後３
                        vm.editForm.gj_cd_4 = sgur.gj_cd_4;             // 作業技術員４
                        vm.editForm.gj_tm_fm_4 = sgur.gj_tm_fm_4_str;   // 作業時間FROM４
                        vm.editForm.gj_tm_to_4 = sgur.gj_tm_to_4_str;   // 作業時間TO４
                        vm.setGjTime4();//時間整形
                        vm.editForm.gj_time_4 = sgur.gj_time_4;         // 作業時間４
                        vm.editForm.gj_time_mae_4 = sgur.gj_time_mae_4; // 作業時間前４
                        vm.editForm.gj_time_ato_4 = sgur.gj_time_ato_4; // 作業時間後４
                        vm.editForm.print_nh_dt = null;                 // プリント納品日
                        if(sgur.print_nh_dt_time > 0){
                            vm.editForm.print_nh_dt = new Date(sgur.print_nh_dt_time*1000);
                        }
                        vm.editForm.nh_kb = sgur.nh_kb;                 // プリント納品区分
                        vm.editForm.nh_hosoku = sgur.nh_hosoku;         // プリント納品補足
                        vm.editForm.genban_kb = sgur.genban_kb;         // プリント原版区分
    
                        vm.editScope.sg_kin = sgur.sg_kin;               // 作業金額
                        
                        vm.editScope.sgkyItems = sgurDtl;
                        vm.editForm.sgurMemo = data.memo;
                        
    
                        // 作業状態
                        vm.editScope.sgjtDisplay(sgur.sg_jt_kb);
                        // PrintShow
                        //vm.editScope.printShow = false;
                        // DataPicker
                        vm.editScope.selectedDate = new Date();
                        vm.editScope.selectedDateAsNumber = Date.UTC(2001, 1, 1);
    
                        // 受注情報
                        // Form情報
                        vm.editForm.ju_no = sgur.ju_no;             // 受注No.
                        vm.editForm.ju_tanto_cd = order.ju_tanto_cd; // 担当営業CD
                        vm.editForm.toku_cd = order.toku_cd;         // 得意先CD
                        vm.editForm.toku_tanto_nm = order.toku_tanto_nm; // 得意先担当名
    
                        // 表示項目
                        vm.editScope.item.hin_nm = order.hin_nm; // 作品名
                        vm.editScope.item.ju_tanto_nm = order.ju_tanto_nm; // 担当営業名
                        vm.editScope.item.ju_bumon_nm = order.ju_bumon_nm; // 受注部門名
                        
                        $timeout(function(){
    
                            //console.log(vm.editScope);
                            
                            $http({ // 得意先情報取得（SQLが厄介なので本体にjoinしない）
                                url: dev.api + 'api/v1/tokuisakidata',
                                method: 'GET',
                                params: {cd:order.toku_cd}
                            }).success(function(tokuData) {
                                if(tokuData){
                                    vm.editScope.item.toku_nm = tokuData.toku_nm;
                                    vm.editScope.item.sk_tani_nm = tokuData.sk_tani_nm;
    
                                    // Printチェック
                                    vm.sgurBmnCheck(sgur.sg_bmn_cd);
                                    vm.sgKeitaiReadSleep = false;
                                    
                                    $timeout(function(){
                                        vm.changeGjKtPat1(0);
                                        vm.changeGjKtPat2(0);
                                        vm.changeGjKtPat3(0);
                                        vm.changeGjKtPat4(0);
                                    },1000);
                                }
                            });
                        },500);
    
                        if(vm.approvalUser){
                            $timeout(function(){
                                $scope.$watch(function() { return vm.editForm;}, function(newVal,oldVal) {
                                    if( (newVal.ju_no === oldVal.ju_no && newVal.sg_no === oldVal.sg_no) && (newVal !== oldVal) ){
                                        //console.log('check');
                                        vm.approvalEditCheck = false;
                                    }
                                }, true);
                            },5000);
                        }
                    }
                });
            });
        }

        // 画面Open
        vm.openEdit();
    };
    
    // 赤伝登録
    vm.creditNoteAdd = function(ju_no, sg_no){
        $timeout(function(){
            vm.editModeInit(2, ju_no, sg_no, true);
        },500);
    }

    // 作業時間計算実行( 作業詳細用 )
    vm.setSgTimeColumn = function($index){

        if(vm.editForm.sgurDtl[$index].stt_tm && vm.editForm.sgurDtl[$index].end_tm){
            var rt = $rootScope.fromToConvH(vm.editForm.sgurDtl[$index].stt_tm, vm.editForm.sgurDtl[$index].end_tm);
            $log.debug(rt);
            if(rt.time < -0.1){
                toastr.warning('作業時間入力が間違っています', 'Warning');
            }else{
                vm.editForm.sgurDtl[$index].suryo_1 = rt.time;
                vm.editForm.sgurDtl[$index].stt_tm = rt.fromStr;
                vm.editForm.sgurDtl[$index].end_tm = rt.toStr;
                //vm.editScope.item. = rt.time + 'H';
                vm.changeTanka($index);
            }
        }
    };
    // 作業時間計算実行
    vm.setSgurTime = function(){
        if(vm.editForm.sg_tm_fm && vm.editForm.sg_tm_to){
            //if(vm.editForm.sg_tm_fm.length > 3 && vm.editForm.sg_tm_to.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.sg_tm_fm, vm.editForm.sg_tm_to);
                //$log.debug(rt);
                if(rt.time < -0.1){
                    vm.editScope.sgurError = true;
                }else{
                    vm.editForm.sg_time = rt.time;
                    vm.editForm.sg_tm_fm = rt.fromStr;
                    vm.editForm.sg_tm_to = rt.toStr;
                    vm.editScope.sg_time = rt.time + 'H';
                    vm.editScope.sgurError = false;
                }
            //}
        }
    };
    // 作業技術員１ 作業時間計算実行
    vm.setGjTime1 = function(){
        if(vm.editForm.gj_tm_fm_1 && vm.editForm.gj_tm_to_1){
            //if(vm.editForm.gj_tm_fm_1.length > 3 && vm.editForm.gj_tm_to_1.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_1, vm.editForm.gj_tm_to_1);
                if(rt.time < -0.1){
                    toastr.warning('作業技術員１:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_1 = rt.time;
                    vm.editForm.gj_tm_fm_1 = rt.fromStr;
                    vm.editForm.gj_tm_to_1 = rt.toStr;
                    vm.editScope.gj_time_1 = rt.time + 'H';
                    vm.editScope.gjTime1Error = false;
                }
            //}
        }
    };

    // 作業技術員２ 作業時間計算実行
    vm.setGjTime2 = function(){
        if(vm.editForm.gj_tm_fm_2 && vm.editForm.gj_tm_to_2){
            //if(vm.editForm.gj_tm_fm_2.length > 3 && vm.editForm.gj_tm_to_2.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_2, vm.editForm.gj_tm_to_2);
                if(rt.time < -0.1){
                    toastr.warning('作業技術員２:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_2 = rt.time;
                    vm.editForm.gj_tm_fm_2 = rt.fromStr;
                    vm.editForm.gj_tm_to_2 = rt.toStr;
                    vm.editScope.gj_time_2 = rt.time + 'H';
                    vm.editScope.gjTime2Error = false;
                }
            //}
        }
    };

    // 作業技術員３ 作業時間計算実行
    vm.setGjTime3 = function(){
        if(vm.editForm.gj_tm_fm_3 && vm.editForm.gj_tm_to_3){
            //if(vm.editForm.gj_tm_fm_3.length > 3 && vm.editForm.gj_tm_to_3.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_3, vm.editForm.gj_tm_to_3);
                if(rt.time < -0.1){
                    toastr.warning('作業技術員３:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_3 = rt.time;
                    vm.editForm.gj_tm_fm_3 = rt.fromStr;
                    vm.editForm.gj_tm_to_3 = rt.toStr;
                    vm.editScope.gj_time_3 = rt.time + 'H';
                    vm.editScope.gjTime3Error = false;
                }
            //}
        }
    };

    // 外部技術員 作業時間計算実行
    vm.setGjTime4 = function(){
        if(vm.editForm.gj_tm_fm_4 && vm.editForm.gj_tm_to_4){
            //if(vm.editForm.gj_tm_fm_4.length > 3 && vm.editForm.gj_tm_to_4.length > 3){
                var rt = $rootScope.fromToConvH(vm.editForm.gj_tm_fm_4, vm.editForm.gj_tm_to_4);
                //console.log(rt);
                if(rt.time < -0.1){
                    toastr.warning('外部技術員:時間入力が間違っています', 'Warning');
                }else{
                    vm.editForm.gj_time_4 = rt.time;
                    vm.editForm.gj_tm_fm_4 = rt.fromStr;
                    vm.editForm.gj_tm_to_4 = rt.toStr;
                    vm.editScope.gj_time_4 = rt.time + 'H';
                    vm.editScope.gjTime4Error = false;
                }
            //}
        }
    };



    // 作業部門 普通のDropdown
    vm.editScope.sghtDropdown = [{'name':'－－', 'id':null}];
    angular.forEach(vm.commondata.sgytbumon ,function(v,k){
        vm.editScope.sghtDropdown.push({'name':v.bumon_nm, 'id':v.bumon_cd});
    });

    // 業務区分 普通のDropdown
    vm.editScope.gyomuDropdown = [{'name':'－－', 'id':null}];
    angular.forEach(vm.commondata.gyomu ,function(v,k){
        vm.editScope.gyomuDropdown.push({'name':v.gyomu_nm, 'id':v.gyomu_kb});
    });

    // メディア 普通のDropdown
    vm.editScope.mediaDropdown = [{'name':'－－', 'id':null}];
    angular.forEach(vm.commondata.media ,function(v,k){
        vm.editScope.mediaDropdown.push({'name':v.media_nm, 'id':v.media_cd});
    });

    // 作業予定スタジオ 普通のDropdown
    vm.editScope.studioDropdown = [{'name':'－－', 'id':null}];
    /*
    angular.forEach(vm.commondata.studio ,function(v,k){
        vm.editScope.studioDropdown.push({'name':v.studio_nm, 'id':v.studio_cd});
    });
    */

    // 業務区分表示用
    vm.editScope.getGyomuName = function(cd){
        var name;
        angular.forEach(vm.commondata.gyomu, function(v,k){
            if(v.gyomu_kb === cd ){
                name = v.gyomu_nm;
            }
        });
        return name;
    };
    // スタジオ表示用
    vm.editScope.getStudioName = function(cd){
        var name;
        angular.forEach(vm.commondata.studio, function(v,k){
            if(v.studio_cd === cd ){
                name = v.studio_nm;
            }
        });
        return name;
    };

    /*
     * プリント有り
     * MA:0310 ビデオ:0320 旧テレシネ:0321 プロセス:0330 DVD:0331 テレシネ：0333
     * プリント無し
     * オーディオ技術:0120 マルチメディア:0130 デジタルイメージ：0334 開発部技術:0850
     *
     */
    vm.bumonPrintCd = ['0310','0320','0321','0330','0331','0333'];
    vm.sgurBmnCheck = function(bumon_cd){
        vm.editScope.printShow = false;
        var breaks = false;
        angular.forEach(vm.bumonPrintCd, function(v, k) {
            breaks = v == bumon_cd;
            if(breaks){
                vm.editScope.printShow = true;
            }
        });
    };

    // 作業予定部門選択 ⇒ 作業形態取得 プリント有無
    $scope.$watch(function() { return vm.editForm.sg_bmn_cd;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            vm.editScope.getSgkt(newVal);
            vm.sgurBmnCheck(newVal);
        }
    }, true);

    // 作業形態取得
    vm.editScope.sgktDropdown = [{'name':'－－', 'id':null}];
    vm.editScope.sgktSyaDropdown1 = [{'name':'－－', 'id':null}];
    vm.editScope.sgktSyaDropdown2 = [{'name':'－－', 'id':null}];
    vm.editScope.gjktSyaDropdown1 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdown2 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdown3 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdown4 = [{'name':'－－', 'gj_cd':null}];
    vm.editScope.gjktSyaDropdownItems = [];
    vm.editScope.gjPatternDropdown = [{'gj_kb':'1', 'text': '技術員1'},{'gj_kb':'2', 'text': '技術員2'},{'gj_kb':'3', 'text': '技術員3'},{'gj_kb':'4', 'text': '外部技術員'}];
    vm.editScope.getSgkt = function(bumon_cd){
        $http({
            url: dev.api + 'api/v1/sgktsya',
            method: "GET",
            params: {'cd': bumon_cd}
        }).success(function(data) {
            vm.editScope.sgktDropdown = [{'name':'－－', 'id':null}];
            vm.editScope.sgktSyaDropdown1 = [{'name':'－－', 'id':null}];
            vm.editScope.sgktSyaDropdown2 = [{'name':'－－', 'id':null}];
            vm.editScope.gjktSyaDropdown1 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.gjktSyaDropdown2 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.gjktSyaDropdown3 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.gjktSyaDropdown4 = [{'name':'－－', 'gj_cd':null}];
            vm.editScope.studioDropdown = [{'name':'－－', 'id':null}];
            vm.editScope.gjktSyaDropdownItems = [];
            if(data.sgkt){
                // 作業形態
                angular.forEach(data.sgkt ,function(v,k){
                    vm.editScope.sgktDropdown.push({'name':v.sg_keitai_nm, 'id':v.sg_keitai_cd});
                });
            }
            if(data.syain){
                // 指名作業員 作業技術員
                angular.forEach(data.syain ,function(v,k){
                    //vm.editScope.sgktSyaDropdown.push({'name':v.syain_nm, 'id':v.syain_cd});
                    //vm.editScope.sgktSyaDropdown1.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'report.editScope.sgktSyaSelect1("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                    //vm.editScope.sgktSyaDropdown2.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'report.editScope.sgktSyaSelect2("'+ v.syain_cd +'","'+ v.syain_nm +'")'});

                    //
                    vm.editScope.gjktSyaDropdown1.push({'name':v.syain_nm, 'gj_cd':v.syain_cd});
                    vm.editScope.gjktSyaDropdown2.push({'name':v.syain_nm, 'gj_cd':v.syain_cd});
                    vm.editScope.gjktSyaDropdown3.push({'name':v.syain_nm, 'gj_cd':v.syain_cd});
                });
            }
            if(data.gaibu){
                // 作業技術員(外部)
                angular.forEach(data.gaibu ,function(v,k){
                    vm.editScope.gjktSyaDropdown4.push({'name':v.simei, 'gj_cd':v.gaibu_cd});
                });
            }
            /*
             * 技術員選択処理の変更
             * 技術員1に技術員2が来たりなど柔軟性を持たせる修正
             * 2016/09/20
             */
            var itm1 = angular.copy(vm.editScope.gjktSyaDropdown1);
            var itm2 = angular.copy(vm.editScope.gjktSyaDropdown2);
            var itm3 = angular.copy(vm.editScope.gjktSyaDropdown3);
            var itm4 = angular.copy(vm.editScope.gjktSyaDropdown4);
            vm.editScope.gjktSyaDropdownItems = [
                            { kb : '1', 'item':itm1},
                            { kb : '2', 'item':itm2},
                            { kb : '3', 'item':itm3},
                            { kb : '4', 'item':itm4}
            ];
            if(data.studio){
                // 作業技術員(外部)
                angular.forEach(data.studio ,function(v,k){
                    vm.editScope.studioDropdown.push({'name':v.studio_nm, 'id':v.studio_cd});
                });
            }
        });
    };

    /*
     * 技術員選択処理の変更
     * 技術員1に技術員2が来たりなど柔軟性を持たせる修正
     * 2016/09/20
     */
    vm.changeGjKtPat1 = function(change){
        if(vm.editForm.gj_kb_1){
            if(change) vm.editForm.gj_cd_1 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_1});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown1 = ret[0].item;
        }
    };
    vm.changeGjKtPat2 = function(change){
        if(vm.editForm.gj_kb_2){
            if(change) vm.editForm.gj_cd_2 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_2});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown2 = ret[0].item;
        }
    };
    vm.changeGjKtPat3 = function(change){
        if(vm.editForm.gj_kb_3){
            if(change) vm.editForm.gj_cd_3 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_3});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown3 = ret[0].item;
        }
    };
    vm.changeGjKtPat4 = function(change){
        if(vm.editForm.gj_kb_4){
            if(change) vm.editForm.gj_cd_4 = '';
            var ret =  $filter('filter')(vm.editScope.gjktSyaDropdownItems, {kb: vm.editForm.gj_kb_4});
            if(ret.length > 0) vm.editScope.gjktSyaDropdown4 = ret[0].item;
        }
    };
    
    // 指名作業員１選択
    vm.editScope.sgktSyaSelect1 = function(syain_cd, syain_nm){
        vm.editForm.simei_gj_cd_1 = syain_cd;
        vm.editScope.item.simei_gj_nm_1 = syain_nm;
    };
    // 指名作業員２選択
    vm.editScope.sgktSyaSelect2 = function(syain_cd, syain_nm){
        vm.editForm.simei_gj_cd_2 = syain_cd;
        vm.editScope.item.simei_gj_nm_2 = syain_nm;
    };

    // 作業状態
    vm.editScope.sgjtDropdown = [];
    vm.editScope.sgjtDropdown.push({'text':'通常', 'click': 'report.editScope.sgjtSelect(0,"通常")'});
    vm.editScope.sgjtDropdown.push({'text':'キャンセル', 'click': 'report.editScope.sgjtSelect(1,"キャンセル")'});

    vm.editScope.sgjtSelect = function(sg_jt_kb, sg_jt_nm){
        vm.editScope.item.sg_jt_nm = sg_jt_nm;
        vm.editForm.sg_jt_kb = sg_jt_kb;
    };
 // 作業状態 Display
    vm.editScope.sgjtDisplay = function(sg_jt_kb){
        var txt;
        if(Number(sg_jt_kb) === 0) txt = '通常';
        if(Number(sg_jt_kb) === 1) txt = 'キャンセル';
        vm.editScope.item.sg_jt_nm = txt;
    };

    // 技術作業員区分
    vm.editScope.gjkbDropdown =[ {'name':'技術員１', 'gj_kb':'1'},{'name':'技術員２', 'gj_kb':'2'},{'name':'技術員３', 'gj_kb':'3'},{'name':'外部技術員', 'gj_kb':'4'}];

    // プリント
    vm.editScope.printStatus1 = [ {id : '1' ,name: 'AM便'}, {id : '2' ,name: 'PM便'}, {id : '3' ,name: 'カウンター止め'}, {id : '4' ,name: '持ち帰り'}, {id : '5' ,name: 'バイク便'}];
    vm.editScope.printStatus2 = [ {id : '1' ,name: '当社補完'}, {id : '1' ,name: '担当者へ'}, {id : '3' ,name: '同時返却'}];
    // プリント詳細
    vm.editScope.printStatus3 = [ {id : '1' ,name: '共通コード'}, {id : '2' ,name: 'DBCMコード'}, {id : '3' ,name: '10桁CMコード'}, {id : '4' ,name: '原版No.'}];
    // プリント時間単位
    vm.editScope.printUnit = [ {id : '1' ,name: '秒'}, {id : '2' ,name: '分'}, {id : '3' ,name: '時'}];


    // 作業形態選択 ⇒ 作業項目取得 ⇒ HTML反映
    $scope.$watch(function() { return vm.editForm.sg_keitai_cd;}, function(newVal,oldVal) {
        if(newVal !== oldVal){
            if(!vm.sgKeitaiReadSleep)
                vm.editScope.getSgkeitaiitem(newVal);
        }
    }, true);

    // 作業項目取得
    vm.editScope.getSgkeitaiitem = function(str){
        return $http({
            url: dev.api + 'api/v1/sgkeitaiitem',
            method: 'GET',
            params: {cd:str}
        }).success(function(data) {
            if(data){
                $log.debug(data);
                vm.editScope.sgkyItems = data;
            }
        });
    };

    /************************************************** 作業項目Detail **********************************************/

    // Table Row追加
    vm.editScope.tableExtend = function(){
        var items = [];
        vm.editScope.sgkyItems.push(items);
    };
    // Table Row 複写
    vm.editScope.tableRowCopy = function($index){
        var sgkyItems = angular.copy(vm.editScope.sgkyItems[$index]);
        var sgurDtl = angular.copy(vm.editForm.sgurDtl[$index]);

        vm.editScope.sgkyItems.splice($index+1, 0, sgkyItems);

        // html内でindexを充てたのでobjになっている。一旦arrayに変換
        var newItemsArr = $.map(vm.editForm.sgurDtl, function(value, index) {
            return [value];
        });
        newItemsArr.splice($index+1, 0, sgurDtl);
        // 再びobjに戻す
        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
            o[i] = v; return o;
        }, {});
        vm.editForm.sgurDtl = newItemsObj;

        $log.debug(vm.editScope.sgkyItems);
        $log.debug(vm.editForm.sgurDtl);
    };
    // Table Row削除
    vm.editScope.tableCellDelete = function($index){

        vm.editScope.sgkyItems.splice($index , 1);
        // html内でindexを充てたのでobjになっている。一旦arrayに変換
        var newItemsArr = $.map(vm.editForm.sgurDtl, function(value, index) {
            return [value];
        });
        newItemsArr.splice($index , 1);
        // 再びobjに戻す
        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
            o[i] = v; return o;
        }, {});
        vm.editForm.sgurDtl = newItemsObj;

        $log.debug(vm.editScope.sgkyItems);
        $log.debug(vm.editForm.sgurDtl);
    };


    // 作業項目検索
    vm.editScope.sgItemApiSearch = function(str) {
        return $http({
            url: dev.api + 'api/v1/sgitem',
            method: "GET",
            params: {q:str}
        });
    };
    // 作業項目選択
    vm.editScope.sgItemSelected = function(selected) {
        var index = this.$parent.$index;// obj index
        if (selected) {
            //var res = selected.title.split(':');
            //vm.editForm.toku_cd = res[0];
            //vm.editScope.item.toku_nm = res[1];
            $http({
                url: dev.api + 'api/v1/sgitemdata',
                method: "GET",
                params: {cd:selected.originalObject.sg_item_cd}
            }).success(function(data) {
                if(data){
                    vm.editScope.sgkyItems[index].sg_item_nm = data.sg_item_nm;
                    vm.editScope.sgkyItems[index].tani_1 = data.tani_1;
                    vm.editScope.sgkyItems[index].tani_2 = data.tani_2;
                    vm.editScope.sgkyItems[index].time_fl = data.time_fl;
                    vm.editScope.sgkyItems[index].genka_fl = data.genka_fl;
                    vm.editForm.sgurDtl[index].sg_item_cd = data.sg_item_cd;
                    vm.editForm.sgurDtl[index].sg_item_nm = data.sg_item_nm;
                    vm.editForm.sgurDtl[index].tanka = data.base_tanka;
                    vm.editForm.sgurDtl[index].sg_bunrui_cd = data.sg_bunrui_cd;
                    //console.log(vm.editForm);
                }
            });
        }
    };
    // 作業項目選択 Modalバージョン
    vm.editScope.sgItemModalSelected = function(sgItemCd,index) {
        //var index = this.$parent.$index;// obj index
        $http({
            url: dev.api + 'api/v1/sgitemdata',
            method: "GET",
            params: {cd:sgItemCd}
        }).success(function(data) {
            //console.log(data);
            vm.editForm.sgurDtl[index].sg_item_nm = data.sg_item_nm;
            vm.editForm.sgurDtl[index].tani_1 = data.tani_1;
            vm.editForm.sgurDtl[index].tani_2 = data.tani_2;
            vm.editForm.sgurDtl[index].time_fl = data.time_fl;
            vm.editForm.sgurDtl[index].genka_fl = data.genka_fl;
            vm.editForm.sgurDtl[index].sg_item_cd = data.sg_item_cd;
            vm.editForm.sgurDtl[index].sg_bunrui_cd = data.sg_bunrui_cd;
            vm.editForm.sgurDtl[index].tanka = data.base_tanka;
            
            vm.editScope.sgkyItems[index].sg_item_nm = data.sg_item_nm;
            vm.editScope.sgkyItems[index].tani_1 = data.tani_1;
            vm.editScope.sgkyItems[index].tani_2 = data.tani_2;
            vm.editScope.sgkyItems[index].time_fl = data.time_fl;
            vm.editScope.sgkyItems[index].genka_fl = data.genka_fl;
            vm.editScope.sgkyItems[index].sg_item_cd = data.sg_item_cd;
            vm.editScope.sgkyItems[index].sg_bunrui_cd = data.sg_bunrui_cd;
            vm.editScope.sgkyItems[index].tanka = data.base_tanka;
            
            vm.changeTanka(index);
        });
    };

    //　数量の変更
    vm.changeSuryo = function($index){
        
        var sg_items = vm.commondata.sgItemKit.sgItem;
        var target_item_cd = vm.editForm.sgurDtl[$index].sg_item_cd;
        var arrTmp = $filter('filter')(sg_items, {sg_item_cd: target_item_cd});
        var sg_item = arrTmp[0];
        var ov_sg_item = {};
        var kin = 0;
        var ov_sr = 0;
        var ov_goukei = 0;
        var tanka = vm.editForm.sgurDtl[$index].tanka;
        // 赤伝
        if(vm.creditNote) tanka*-1;
        
        var suryo_2_flg = false;
        if( vm.editForm.sgurDtl[$index].suryo_1 ){
            var suryo = vm.editForm.sgurDtl[$index].suryo_1;
            if(vm.editForm.sgurDtl[$index].suryo_2 > 0){
                suryo = vm.editForm.sgurDtl[$index].suryo_2 * suryo;
                suryo_2_flg = true;
            }
            // ロックアウト対応
            //if ( vm.editForm.sgurDtl[$index].sg_item_nm.indexOf('ロックアウト') !== -1) {
                if( Number(sg_item.over_fl) === 1 ){
                    if( suryo > sg_item.ov_suryo ){
                        ov_sr = suryo - sg_item.ov_suryo;
                        suryo = sg_item.ov_suryo;
                        ov_sg_item = $filter('filter')(sg_items, {sg_item_cd: sg_item.ov_sg_item_cd});
                        ov_goukei = ov_sg_item[0].base_tanka * ov_sr;
                        //$log.debug(vm.editScope.sgkyItems);
                        //$log.debug(vm.editForm.sgurDtl);
                        var stt_tm = vm.editForm.sgurDtl[$index].stt_tm;
                        var end_tm = vm.editForm.sgurDtl[$index].end_tm;
                        var kitei = sg_item.ov_suryo;
                        var timeItems = {};
                        if(stt_tm && end_tm){
                            timeItems = $rootScope.getSttAndEndTm(stt_tm, end_tm, kitei, ov_sr);
                            vm.editForm.sgurDtl[$index].end_tm = timeItems.newEnd_tm;
                        }
                        var suryo_1 = 0;
                        var suryo_2 = null;
                        if( Number(ov_sg_item[0].suryo_kbn_1) === 1 ){
                            suryo_1 = 1;
                            suryo_2 = ov_sr;
                        }else if( Number(ov_sg_item[0].suryo_kbn_1) === 2 ){
                            suryo_1 = ov_sr;
                        }
                        var sgkyItems = {};
                        var sgkyItemsTmp = angular.copy(vm.editScope.sgkyItems[$index]);
                        // 新しい行を作る
                        angular.forEach(sgkyItemsTmp, function(v,k){
                            angular.forEach(ov_sg_item[0], function(va,ke){
                                if(k === ke) sgkyItems[k] = va;
                            });
                        });
                        sgkyItems.gyo_no = sgkyItemsTmp.gyo_no + 1;
                        sgkyItems.suryo_1 = suryo_1;
                        sgkyItems.suryo_2 = suryo_2;
                        sgkyItems.tanka = ov_sg_item[0].base_tanka;
                        sgkyItems.kin = ov_goukei;
                        sgkyItems.sg_bunrui_cd = ov_sg_item[0].sg_bunrui_cd;
                        sgkyItems.sg_item_cd = ov_sg_item[0].sg_item_cd;
                        sgkyItems.sg_item_nm = ov_sg_item[0].sg_item_nm;
                        sgkyItems.tani_1 = ov_sg_item[0].tani_1;
                        sgkyItems.tani_2 = ov_sg_item[0].tani_2;
                        sgkyItems.time_fl = ov_sg_item[0].time_fl;
                        sgkyItems.genka_fl = ov_sg_item[0].genka_fl;
                        sgkyItems.stt_tm = (timeItems)?timeItems.newEnd_tm:null;
                        sgkyItems.end_tm = (timeItems)?timeItems.overEnd:null;
                        
                        var sgurDtl = {};
                        var sgurDtlTmp = angular.copy(vm.editForm.sgurDtl[$index]);
                        sgurDtl.gyo_no = sgurDtlTmp.gyo_no + 1;
                        sgurDtl.sg_bunrui_cd = ov_sg_item[0].sg_bunrui_cd;
                        sgurDtl.sg_item_cd = ov_sg_item[0].sg_item_cd;
                        sgurDtl.sg_item_nm = ov_sg_item[0].sg_item_nm;
                        sgurDtl.suryo_1 = suryo_1;
                        sgurDtl.suryo_2 = suryo_2;
                        sgurDtl.tanka = ov_sg_item[0].base_tanka;
                        sgurDtl.kin = ov_goukei;
                        sgurDtl.tani_1 = ov_sg_item[0].tani_1;
                        sgurDtl.tani_2 = ov_sg_item[0].tani_2;
                        sgurDtl.time_fl = ov_sg_item[0].time_fl;
                        sgurDtl.genka_fl = ov_sg_item[0].genka_fl;
                        sgurDtl.stt_tm = (timeItems)?timeItems.newEnd_tm:null;
                        sgurDtl.end_tm = (timeItems)?timeItems.overEnd:null;

                        vm.editScope.sgkyItems.splice($index+1, 0, sgkyItems);
                        // html内でindexを充てたのでobjになっている。一旦arrayに変換
                        var newItemsArr = $.map(vm.editForm.sgurDtl, function(value, index) {
                            return [value];
                        });
                        newItemsArr.splice($index+1, 0, sgurDtl);
                        // 再びobjに戻す
                        var newItemsObj = newItemsArr.reduce(function(o, v, i) {
                            o[i] = v; return o;
                        }, {});
                        vm.editForm.sgurDtl = newItemsObj;
                        // 超過元アイテムの数量は規定値に設定する
                        if(suryo_2_flg){
                            vm.editForm.sgurDtl[$index].suryo_2 = (ov_sg_item[0].tani_2)?1:suryo;
                            tanka = tanka * sg_item.ov_suryo;
                        }else{
                            vm.editForm.sgurDtl[$index].suryo_1 = (ov_sg_item[0].tani_2)?1:suryo;
                            vm.editForm.sgurDtl[$index].suryo_2 = (ov_sg_item[0].tani_2)?suryo:'';
                        }
                    }
                    kin = tanka;// + ov_goukei;
                }else{
                    kin = tanka * suryo;
                }
            /*}else{
                if( Number(sg_item.over_fl) === 1 ){
                    if( suryo > sg_item.ov_suryo ){
                        ov_sr = suryo - sg_item.ov_suryo;
                        suryo = sg_item.ov_suryo;
                        ov_sg_item = $filter('filter')(sg_items, {sg_item_cd: sg_item.ov_sg_item_cd});
                        ov_goukei = ov_sg_item[0].base_tanka * ov_sr;
                    }
                    kin = (tanka * suryo) + ov_goukei;
                }else{
                    kin = tanka * suryo;
                }
            }
            */
            
        }
        vm.editForm.sgurDtl[$index].kin = kin;
    };
    
    // 単価の変更
    vm.changeTanka = function($index){
        
        vm.changeSuryo($index);
        /*
        if(vm.editForm.sgurDtl[$index].tanka){
            if(vm.editForm.sgurDtl[$index].suryo_2 > 0){
                //vm.editForm.sgurDtl[$index].kin = vm.editForm.sgurDtl[$index].tanka * vm.editForm.sgurDtl[$index].suryo_2;
            }else{
               // vm.editForm.sgurDtl[$index].kin = vm.editForm.sgurDtl[$index].tanka * vm.editForm.sgurDtl[$index].suryo_1;
            }
        }
        */
    };


    /************************************************** /作業項目Detail **********************************************/


    // formSubmit
    vm.editScope.eaningsSubmit = function(method){
        $log.debug(vm.editForm);
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.sg_day && is('Date', vm.editForm.sg_day) ){
            vm.editForm.sg_day = moment(vm.editForm.sg_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.print_nh_dt && is('Date', vm.editForm.print_nh_dt) ){
            vm.editForm.print_nh_dt = moment(vm.editForm.print_nh_dt).format('YYYY/MM/DD HH:mm');
        }

        var completeMessage = 'が完了しました';
        var subUrl = '';// POSTで切り分けてもいいかも
        if(method === 'PUT') {
            subUrl = '/put';
            if(!vm.editForm.sg_no){
                return false;
            }
            completeMessage = '更新'+completeMessage;
        }else if(method === 'DELETE') {
            subUrl = '/delete';
            if(!vm.editForm.sg_no){
                return false;
            }
            if( Number(vm.sgur.hk_umu_fl) === 1){
                toastr.error('作業報告が存在する作業売上データは削除できません');
                return false;
            }
            vm.editForm = {sg_no:vm.editForm.sg_no,ju_no:vm.editForm.ju_no};
            completeMessage = '削除'+completeMessage;
        }else{
            completeMessage = '登録'+completeMessage;
            if( vm.creditNote ){
                vm.editForm.creditNoteFlg = true;
            }
        }

        $http({
            url: dev.api + 'api/v1/earnings' + subUrl,
            method: method,
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            // formクリア
            if(method === 'POST'){
                vm.lead_ju_no = null;
                vm.lead_sg_no = null;
                //vm.editScope.cancel(1);
                vm.hideEdit();
                $state.go($state.current, {juno:'000',sgno:'000'}, {reload: true});

            }else{
                getResultsPage(1);//一覧更新
                vm.hideEdit();
            }
            toastr.info(completeMessage, 'Info');
        });

    };

    // formSubmit 承認
    vm.editScope.approvalSubmit = function(){
        $log.debug(vm.editForm);
        // 新規登録
        // 日付Fromat整形
        if( vm.editForm.sg_day && is('Date', vm.editForm.sg_day) ){
            vm.editForm.sg_day = moment(vm.editForm.sg_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.print_nh_dt && is('Date', vm.editForm.print_nh_dt) ){
            vm.editForm.print_nh_dt = moment(vm.editForm.print_nh_dt).format('YYYY/MM/DD HH:mm');
        }

        var params = {ju_no:vm.editForm.ju_no,sg_no:vm.editForm.sg_no};

        $http({
            url: dev.api + 'api/v1/earningsapproval',
            method: 'POST',
            params: { form : params }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.info('承認しました', 'Info');
        });
    };

    // formSubmit 承認取り消し
    vm.editScope.unApprovalSubmit = function(){
        $log.debug(vm.editForm);
        $log.debug(vm.order);
        $log.debug(vm.sgur);
        
        if( vm.sgur.ur_fl > 0 ){
            // 作品完了済み
            toastr.error('売上計上済みです。承認取消出来ません');
        }else if( Number(vm.order.fin_fl) === 1 ){
            // 作業売上承認済み
            toastr.error('作品完了済みです。承認取消出来ません');
        }else{
            $http({
                url: dev.api + 'api/v1/earningsunapproval',
                method: 'POST',
                params: {ju_no:vm.order.ju_no,sg_no:vm.editForm.sg_no}
            }).success(function(data) {
                // 登録完了
                $log.debug(data);
                getResultsPage(1);//一覧更新
                vm.hideEdit();
                toastr.info('承認取消しました', 'Info');
            });
        }
    };
    
    
    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        if(mode !== 2){
            $state.go($state.current, {juno:'000',sgno:'000'}, {reload: true});
        }else{
            vm.hideEdit();
        }
    };

    // 受注No.変更Modal
    vm.juNoChangeModal = $modal({
        templateUrl:'app/business-earnings/modal2.html',
        scope: $scope,
        show:false
    });
    // ModalOpen
    vm.openjuNoChange = function(){
        vm.juNoChangeModal.$promise.then(vm.juNoChangeModal.show);
    };
    // ModalClose
    vm.hidejuNoChange = function(){
        vm.juNoChangeModal.$promise.then(vm.juNoChangeModal.hide);
    };
    
    // 別受注に作業売上を追加（受注No既存への変更）
    vm.changeSgJuNo = function(){
        //vm.editForm
        var form  = angular.copy(vm.editForm);
        form.hin_nm = vm.order.hin_nm;
        vm.hideEdit();
        $state.go('app.business-orders', {param:{changeData:form}});
    };
    
  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('AccountingController', AccountingController);

  /** @ngInject */
  function AccountingController($log, $timeout, $http, $auth, $window, $filter,$rootScope, $scope, $state, $q, dev, $modal, storage, dateFormat, $stateParams, $popover, $element, toastr) {

    /*
    * ヘルプ抜粋
    * 
    * 財務会計システム・仕訳データは別システム連携なので無視
    * 
    * 経理承認
    * ■機能
    * 経費承認１、又は経費承認２にて承認済となった経費の経理承認、未払金・買掛金の計上、財務会計システム・仕訳データの作成を行います。
    * ■説明
    * ・未承認データを承認する際の手順は以下の通りです。
    *   1.検索条件を入力し、表示ボタンを押下します。
    *   2.一覧より対象データを選択（チェックON）し、選択ボタンを押下します。
    *   3.表示内容を確認し、変更箇所を修正後、承認ボタンを押下します。
    * ・財務会計システムへの仕訳は、貸方１行で起票します。
    * ・マイナス金額の場合も貸借の変更を行わず、財務会計システムの仕訳を起票します。
    * ・目的のデータが一覧に表示されない場合は、対象外となっているケースがあります。経費入力の経費一覧画面にて「承認１」「承認２」により現在の状態を確認して下さい。
    * 
    * ☆経理承認取消
    * ■ 機能
    * 経理承認にて承認済となった経費について、経理承認を行った単位で承認取消を行います。未払金・買掛金の計上取消は行いますが、財務会計システム・仕訳データは削除されません。
    * 本処理を行う前に、財務会計システムにて仕訳の削除を行って下さい。
    * ■ 説明
    * ・承認済データを承認する際の手順は以下の通りです。
    *   1.財務会計システムにて仕訳の削除を行います。
    *   2.検索条件を入力し、表示ボタンを押下します。
    *   3.一覧より対象データを選択し、選択ボタンを押下します。
    *   4.表示内容を確認し、取消ボタンを押下します。
    * ・月次処理が終了している伝票日付のデータは取消できません。経費入力よりマイナス金額で入力を行って下さい。
    *
    */
      
    $log.debug('ExpensesController');

    var vm = this;
    vm.controllerAliasName = 'acc';
    
    vm.user = storage.get('user');
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    //console.log('sys_admin_fl : ' + vm.user.sys_admin_fl);
    if( vm.user.sys_admin_fl === '5' || vm.user.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    // 承認可能
    vm.approvalUser = false;
    if( vm.user.sys_admin_fl === '1' || vm.user.sys_admin_fl === '2' ){
        vm.approvalUser = true;
    }
    // Menu
    $rootScope.panelSelected(0,'006');

    // Tooltip
    //vm.editTooltipText1 = {'title': '-作業売上編集-<br />作業売上の編集と承認を行います'};
    
    // フォーム初期化
    vm.formInit = function(){
        // From初期化
        vm.form = {};
        vm.futan_bumon_nm = '';
        vm.ss_bumon_nm = '';
        vm.kh_bunrui_nm = '';
        vm.ss_tan_nm = '';
        vm.form.kr_sn_fl = '00';
        vm.kr_sn_fl_nm = '問わず';
        vm.itemDetail = [];
        vm.editScope = {};
        vm.editForm ={};
        vm.editForm.detail = {};

        //vm.form.kh_noFrom = '13080191';//test 交通費&SG
        //vm.form.kh_noTo = '13080191';//test　交通費&SG
        //vm.form.kh_noFrom = '15060094';//test　交通費複数
        //vm.form.kh_noTo = '15060094';//test　交通費複数
        //vm.form.kh_noFrom = '15100060';//test
        //vm.form.kh_noTo = '15100060';//test
        
        
        var fromBaseDate = new Date();
        //fromBaseDate.setYear(fromBaseDate.getFullYear()-3);
        //vm.form.fromDate = new Date(fromBaseDate.getFullYear(), 1-1,1);
        fromBaseDate.setMonth(fromBaseDate.getMonth()-12);
        vm.form.fromDate = new Date(fromBaseDate.getFullYear(),fromBaseDate.getMonth(),1);
        
        vm.form.untilDate = new Date();
        vm.getType = function(key) {
          return Object.prototype.toString.call(vm[key]);
        };
        
        vm.getKeihiOptionData();
        
        // pagenation 設定
        vm.datas = [];
        vm.totalDatas = 0;
        vm.datasPerPage = 15;
        if(!vm.lead_ju_no){
            getResultsPage(1);
        }
        vm.pagination = {
            current: 1
        };

    };
    // 使いましデータ取得
    vm.commondata = storage.get('commondata');
    vm.loginUser = storage.get('user');
    // 管理者・一般１・一般２のみ編集可能
    vm.isEditDisabled = false;
    if( vm.loginUser.sys_admin_fl === '5' || vm.loginUser.sys_admin_fl === '6'){
        vm.isEditDisabled = true;
    }
    vm.approvalUser = false;
    if( vm.loginUser.sys_admin_fl === '1' || vm.loginUser.sys_admin_fl === '2' ){
        vm.approvalUser = true;
    }
    
    // 関係データ取得
    vm.getKeihiOptionData = function() {
        $http({
            url: dev.api + 'api/v1/getaccountingoptiondata',
            method: 'GET',
            params: {bumon_cd:vm.loginUser.bumon_cd}
        }).success(function(data) {
            // 部門
            vm.ssBumonDropdown = [{'text':'－－', 'click': 'acc.ssBumonSelect()'}];
            vm.editScope.kasiBumonDropdown = [{'text':'－－', 'click': 'acc.editScope.kasiBumonSelect()'}];
            vm.editScope.futanBumonDropdown = [{'text':'－－', 'click': 'acc.editScope.futanBumonSelect()'}];
            angular.forEach(data.keihi_bumon ,function(v,k){
                vm.ssBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'acc.ssBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.kasiBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'acc.editScope.kasiBumonSelect("'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
                vm.editScope.futanBumonDropdown.push({'text':v.bumon_cd + ' : '+ v.bumon_nm, 'click': 'acc.editScope.futanBumonSelect(key,"'+ v.bumon_cd +'","'+ v.bumon_nm +'")'});
            });
            // 経費分類
            vm.khBunruiDropdown = [{'text':'－－', 'click': 'acc.khBunruiSelect()'}];
            vm.editScope.khBunruiDropdown = [{'text':'－－', 'click': 'acc.editScope.khBunruiSelect()'}];
            angular.forEach(data.keihi_bunrui ,function(v,k){
                vm.khBunruiDropdown.push({'text':v.kh_bunrui_cd + ' : '+ v.kh_bunrui_nm, 'click': 'acc.khBunruiSelect("'+ v.kh_bunrui_cd +'","'+ v.kh_bunrui_nm +'")'});
                if(v.kh_bunrui_nm.indexOf('H-') > -1){
                    vm.editScope.khBunruiDropdown.push({'text':v.kh_bunrui_cd + ' : '+ v.kh_bunrui_nm, 'click': 'acc.editScope.khBunruiSelect("'+ v.kh_bunrui_cd +'","'+ v.kh_bunrui_nm +'","'+ v.kotuhi_fl +'","'+ v.kmk_kbn +'")'});
                }
            });
            vm.taxrate = data.taxrate;
            vm.keihiKamoku_origin = data.keihi_kamoku;
            vm.sinseiUser = data.sinseiUser;
            // 担当(申請者）
            vm.eigyoDropdown = [{'text':'－－', 'click': 'acc.eigyoSelect()'}];
            vm.editScope.eigyoDropdown = [{'text':'－－', 'click': 'acc.editScope.eigyoSelect()'}];
            angular.forEach(data.sinseiUser ,function(v,k){
                vm.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'acc.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
                vm.editScope.eigyoDropdown.push({'text':v.syain_cd + ' : '+ v.syain_nm, 'click': 'acc.editScope.eigyoSelect("'+ v.syain_cd +'","'+ v.syain_nm +'")'});
            });
        });
    };
    vm.formInit();
    
    // 申請部門選択
    vm.ssBumonSelect = function(bumon_cd, bumon_nm){
        if(bumon_cd && bumon_nm){
            vm.form.ss_bmn_cd = bumon_cd;
            vm.ss_bmn_nm = bumon_nm;
        }else{
            vm.form.ss_bmn_cd = '';
            vm.ss_bmn_nm = '';
        }
        
    };
    // 経費分類選択
    vm.khBunruiSelect = function(kh_bunrui_cd, kh_bunrui_nm){
        if(kh_bunrui_cd && kh_bunrui_nm){
            vm.form.kh_bunrui_cd = kh_bunrui_cd;
            vm.kh_bunrui_nm = kh_bunrui_nm;
        }else{
            vm.form.kh_bunrui_cd = '';
            vm.kh_bunrui_nm = '';
        }
    };
    // 経費科目絞込み
    vm.khKamokuEdit = function(){
        vm.editScope.keihiKamokuDropdown = [{'text':'－－', 'click': 'acc.editScope.keihiKamokuSelect(key,null)'}];
        angular.forEach(vm.keihiKamoku ,function(v,k){
            vm.editScope.keihiKamokuDropdown.push({'text':v.seq_no + ' : '+ v.dsp_nm, 'click': 'acc.editScope.keihiKamokuSelect(key,"'+k+'")'});
        });
    }

    // 担当(申請)者選択
    vm.eigyoSelect = function(syain_cd, syain_nm){
        if(syain_cd && syain_nm){
            vm.form.ss_tan_cd = syain_cd;
            vm.ss_tan_nm = syain_nm;
        }else{
            vm.form.ss_tan_cd = '';
            vm.ss_tan_nm = '';
        }
    };

    // 検索panel ON/OFF
    vm.panels = {};
    vm.panels.active = false;

    // 次のページ/前のページ
    vm.pageChanged = function(newPage) {
        getResultsPage(newPage);
    };
    // ページデータ取得
    function getResultsPage(pageNumber) {
        var search = null;
        if(vm.form){
            // 初期値がDateFormatになってるのでyyy/mm/dd形式に変更
            // (一度でも画面から日付の変更操作を行えば整う)
            if( vm.form.fromDate && is('Date', vm.form.fromDate) ){
                vm.form.fromDate = moment(vm.form.fromDate).format('YYYY/MM/DD');
            }
            if( vm.form.untilDate && is('Date', vm.form.untilDate) ){
                vm.form.untilDate = moment(vm.form.untilDate).format('YYYY/MM/DD');
            }
            search = vm.form;
            angular.forEach(search,function(v,k){
               if(!v) delete search[k];//不要なparamは削除
            });
        }
        $http({
            url: dev.api + 'api/v1/accounting',
            method: 'GET',
            params: {limit: vm.datasPerPage, page:  pageNumber, search: search}
        }).success(function(datas) {
            vm.datas = datas.data;
            vm.totalDatas = datas.total;
            if(vm.form) vm.search = vm.form;
            $log.debug(datas);
            vm.currentpage = datas.current_page;
            vm.itemDetail = [];
        });
    }

    // 承認状態
    vm.krSnfl = [{id:'00', name:'問わず'},{id:'01', name:'承認済み'}, {id:'02', name:'未承認'}];
    vm.krSnfllDropdown = [];
    vm.snflDropdown = [];
    angular.forEach(vm.krSnfl ,function(v,k){
        vm.krSnfllDropdown.push({'text':v.name, 'click': 'acc.krSnflSelect("'+ v.id +'","'+ v.name +'")'});
    });
    // 承認状態選択
    vm.krSnflSelect = function(id, name){
        vm.form.kr_sn_fl = id;
        vm.kr_sn_fl_nm = name;
    };
    // 検索実行
    vm.goSearch = function(){
        $log.debug(vm.form);
        getResultsPage(1);
        vm.pagination = { current: 1};
    };
    // 検索Formクリア
    vm.clear = function(){
        vm.formInit();
    };

    // 小窓セット
    vm.detailSet = function(detail){
        vm.itemDetail = detail;
    }
    
    /****************************************************** Edit Area ************************************************/
    
    // 登録/編集Modal
    vm.editModal = $modal({
        templateUrl:'app/business-accounting/accountingEdit.html',
        scope: $scope,
        show:false
    });
    vm.openEdit = function(){
        vm.editModal.$promise.then(vm.editModal.show);
    };
    vm.hideEdit = function(){
        vm.editModal.$promise.then(vm.editModal.hide);
    };

    // EditMode init
    vm.editForm = {};
    vm.editScope = {};
    vm.zeiKbStatus = [{id:'1', name:'外税'},{id:'2', name:'内税'}, {id:'3', name:'非課税'}];
    vm.editScope.zeiKbDropdown = [];
    angular.forEach(vm.zeiKbStatus ,function(v,k){
        vm.editScope.zeiKbDropdown.push({'text':v.name, 'click': 'acc.editScope.zeiKbSelect(key, "'+ v.id +'","'+ v.name +'")'});
    });
    vm.detailSet = function(item){

        vm.isFromDisabled = false;
        vm.editForm = {};
        vm.editForm.detail = [];
        // 承認済みの場合は編集不可
        if(item.kr_sn_fl > 0){
            toastr.info('経理承認済みのため、編集できません', 'Info');
            vm.isFromDisabled = true;
        }
        
        vm.editForm = angular.copy(item);
        // 登録ない場合の初期値
        if(!vm.editForm.kasi_bmn_cd){
            vm.editForm.kasi_bmn_cd = vm.user.bumon_cd;
            vm.editForm.kasi_bmn_nm = vm.user.bumon_nm;
        }
        // 各初期値設定
        if(item.ss_day_time > 0){
            vm.editForm.ss_day = new Date(item.ss_day_time*1000);
        }
        if(item.den_day_time > 0){
            vm.editForm.den_day = new Date(item.den_day_time*1000);
        }else{
            vm.editForm.den_day = new Date();
        }
        if(item.sh_yt_day_time > 0){
            vm.editForm.sh_yt_day = new Date(item.sh_yt_day_time*1000);
        }else{
            if( vm.editForm.kasi_kmk_cd === '1000' ){
                vm.editForm.sh_yt_day = new Date();
            }
        }
        //console.log(vm.editForm);

        // 画面Open
        vm.openEdit();

        // Edit貸方部門選択
        vm.editScope.kasiBumonSelect = function(bumon_cd, bumon_nm){
            if(bumon_cd && bumon_nm){
                vm.editForm.kasi_bmn_cd = bumon_cd;
                vm.editForm.kasi_bmn_nm = bumon_nm;
            }else{
                vm.editForm.kasi_bmn_cd = '';
                vm.editForm.kasi_bmn_nm = '';
            }
            
        };
        // 税区分選択
        vm.editScope.zeiKbSelect = function($index, id, name){
            vm.editForm.detail[$index].zei_kb = id;
            vm.editForm.detail[$index].zei_kb_nm = name;
        };
       
        // Edit負担部門選択
        vm.editScope.futanBumonSelect = function($index, bumon_cd, bumon_nm){
            if(bumon_cd && bumon_nm){
                vm.editForm.detail[$index].futan_bmn_cd = bumon_cd;
                vm.editForm.detail[$index].futan_bmn_nm = bumon_nm;
            }else{
                vm.editForm.detail[$index].futan_bmn_cd = '';
                vm.editForm.detail[$index].futan_bmn_nm = '';
            }
        };

        // 金額計算(すべて内税)
        $scope.$watch(function() { return vm.editForm.detail;}, function(newVal,oldVal) {
            // 古い承認ずみのデータは再計算しない
            if(!vm.isFromDisabled){
                if(newVal !== oldVal){
                    // 消費税が10%になる日を想定。日付の境界をきちんと設定
                    var ss_day = vm.editForm.ss_day_time*1000;
                    var taxrate = 0;
                    angular.forEach(vm.taxrate, function(v, k){
                        var start_day = v.start_day_time*1000;
                        var end_day = null;
                        if( v.end_day_time ) {
                            end_day = v.end_day_time*1000;
                        }
                        // 現在
                        if( start_day <= ss_day && !end_day){
                            taxrate = parseFloat(v.tax_rate);
                        }else if(end_day && (start_day <= ss_day) && (ss_day <= end_day) ){
                            // 古い値
                            taxrate = parseFloat(v.tax_rate);
                        }
                    })
                    var kotuhi_fl = vm.editForm.kotuhi_fl;
                    var totalKin = [];
                    var totalZeiKin = [];
                    var totalNukiKin = [];
                    var totalKomiKin = [];
                    angular.forEach(vm.editForm.detail, function(v, k){
                        if(v.kin && v.kin > 0) {
                            var zei_kin = 0;
                            var nukiKin = 0;
                            var komi_kin = 0;
                            if( Number(vm.editForm.detail[k].zei_kb) !== 1 ){
                                nukiKin = Math.floor(v.kin / (1+taxrate));
                            }else{
                                nukiKin = v.kin;
                            }
                            totalKin.push(v.kin);
                            totalNukiKin.push(nukiKin);
                            if( Number(vm.editForm.detail[k].zei_kb) === 1 ){
                                zei_kin =  Math.floor(v.kin*taxrate);
                                komi_kin = v.kin+zei_kin;
                            }else if( Number(vm.editForm.detail[k].zei_kb) === 2 ) {
                                zei_kin = v.kin-nukiKin;
                                komi_kin = v.kin;
                            }else{
                                komi_kin = v.kin;
                            }
                            totalZeiKin.push(zei_kin);
                            totalKomiKin.push(komi_kin);
                            vm.editForm.detail[k].kin = v.kin;
                            vm.editForm.detail[k].nuki_kin = nukiKin;
                            vm.editForm.detail[k].zei_kin = zei_kin;
                            vm.editForm.detail[k].komi_kin = komi_kin;
                        }
                    });
                    if(totalKin.length > 0){
                        vm.editForm.kei_kin = totalKin.reduce(function(pre, curr) {
                            return Number(pre) + Number(curr);
                        });
                        vm.editForm.nuki_kin = totalNukiKin.reduce(function(pre, curr) {
                            return Number(pre) + Number(curr);
                        });
                        vm.editForm.zei_kin = totalZeiKin.reduce(function(pre, curr) {
                            return Number(pre) + Number(curr);
                        });
                        vm.editForm.komi_kin = totalKomiKin.reduce(function(pre, curr) {
                            return Number(pre) + Number(curr);
                        });
                    }
                }
            }
        }, true);
    };

    // formSubmit 承認
    vm.editScope.approvalSubmit = function(mode){
        $log.debug(vm.editForm);
        vm.editForm.kr_sn_fl = mode;
        if( vm.editForm.den_day && is('Date', vm.editForm.den_day) ){
            vm.editForm.den_day = moment(vm.editForm.den_day).format('YYYY/MM/DD');
        }
        if( vm.editForm.sh_yt_day && is('Date', vm.editForm.sh_yt_day) ){
            vm.editForm.sh_yt_day = moment(vm.editForm.sh_yt_day).format('YYYY/MM/DD');
        }
        $http({
            url: dev.api + 'api/v1/accapproval',
            method: 'POST',
            params: { form : vm.editForm }
        }).success(function(data) {
            // 登録完了
            $log.debug(data);
            getResultsPage(1);//一覧更新
            vm.hideEdit();
            toastr.info('承認しました', 'Info');
        });
    };
    // キャンセル
    vm.editScope.cancel = function(mode){
        $log.debug('cancel mode :' +mode);
        vm.hideEdit();
    };
    
    
  }


})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log,storage, Permission, $rootScope, $state, $auth, toastrConfig, toastr, $timeout,$animate) {

      $log.info('Ready Run');
      
      $rootScope.stateData = $state;
      //console.log($rootScope.stateData);
      $animate.enabled(true);
      $rootScope.activePromises = [];

      //console.log( $animate.enabled() )
      
      // 印刷用window初期化
      if( $rootScope.openWindow ){
          $rootScope.openWindow.close();
      }
      $rootScope.openWindow = null;

    // ログアウト
    $rootScope.logout = function() {
        $auth.logout().then(function() {
            storage.remove('user');
            storage.remove('panelIndexies');
            $rootScope.currentUser = null;
            $state.go('/login');
            //$modal.hide();
        });
    };
    $rootScope.currentUser = storage.get('user');

    // ngModel Grovaltimeformat
    $rootScope.timeformat = function(modelValue, filter, defaultValue) {
        if (modelValue) {
            return filter('timeformat')(modelValue);
        }
        return defaultValue;
    };
    $rootScope.formatitem = function(modelValue, filter, defaultValue, format) {
        if (modelValue) {
            return filter('formatitem')(modelValue,format);
        }
        return defaultValue;
    };
    
    $rootScope.formatNumber = function(modelValue, filter, defaultValue, format) {
        if (modelValue) {
            return filter('formatNumber')(modelValue,format);
        }
        return defaultValue;
    };

    // ログイン状態を付与
    Permission
        .defineRole('anonymous', function () {
            //$log.debug('anonymous', $auth.isAuthenticated());
            if (!$auth.isAuthenticated()) {
                return true; // 未ログイン
            }
            return false;
        })
        .defineRole('isloggedin', function () {
            //$log.debug('isloggedin', $auth.isAuthenticated());
            if ($auth.isAuthenticated()) {
                return true; // ログイン済み
            }
            return false;
        });


    //Tokenチェック
    $rootScope.tokenAliveCheck = function(state){
        if (!$auth.isAuthenticated()) {
            toastrConfig.allowHtml = true;
            toastrConfig.timeOut = null;
            toastrConfig.positionClass = 'toast-top-right';
            toastrConfig.preventDuplicates = true;
            toastrConfig.progressBar = false;
            closeButton: true;
            $rootScope.logout();
            toastr.warning('ログイン有効期限が切れたためログアウトしました', 'Warning');
            $timeout(function(){
                $state.go('login', null, {reload: true}); 
            },5000);
        }
    };
    // Token有効状態ポーリング
    $rootScope.pollingToken = function() {
        $timeout(function() {
            if($rootScope.currentUser){
                $log.debug('pollingToken');
                $rootScope.tokenAliveCheck();
                $rootScope.pollingToken();
            }
        }, 6000*5);
    };

    /*
     * スタート,エンド時間から
     * 既定時間への修正と、
     * オーバー分のスタート,エンド時間算出
     */
    $rootScope.getSttAndEndTm = function(stt_tm, end_tm, kitei, ov_sr) {
        var h1 = stt_tm.substring(0, 2);
        var t1 = stt_tm.substring(2, 4);
        var h2 = end_tm.substring(0, 2);
        var t2 = end_tm.substring(2, 4);
        var res = {newStt_tm:'', newEnd_tm:'', overStt:'', overEnd:''};
        // float確認
        var chk1 = String(kitei).split('.');
        if( !chk1[1] ) chk1[1] = 0;
        var mat = 60*Number(chk1[1])*0.1;
        var en = (Number(mat)>0)?String(mat):'00';
        var ovSr = ov_sr*100;
        var chk2 = String(ov_sr).split('.');
        if( !chk2[1] ) chk2[1] = 0;
        var h3 = chk2[0];
        var t3 = chk2[1];
        var mat2 = 60*Number(t3)*0.1;
        var en2 = (Number(mat2)>0)?String(mat2):'00';
        

        res.newStt_tm = stt_tm;
        var newStartLf = Number(h1)+Number(chk1[0]);
        res.newEnd_tm = ( Number(h1)+Number(chk1[0]) ) + en;
        res.overStt = res.newEnd_tm;
        res.overEnd = String(Number(newStartLf)+Number(h3)) + en2;
        
        return res;
     }
    
    // 時間計算
    $rootScope.fromToConvH = function(from, to){
        var frms,tos;
        if( is('String', from) && from.indexOf(':') > -1){
            frms = from.split(':');

        }else{
            //0埋め
            from = ('000'+from).slice(-4);
            frms = [from.substring(0, 2),from.substring(2, 4)];

        }
        if( is('String', to) && to.indexOf(':') > -1){
            tos = to.split(':');
        }else{
            //0埋め
            to = ('000'+to).slice(-4);
            tos = [to.substring(0, 2),to.substring(2, 4)];
        }
        var min = Number(tos[0]) - Number(frms[0]);
        var ss = Number(tos[1]) - Number(frms[1]);
        //$log.debug(frms);
        //$log.debug(tos);
        if(frms[0] && frms[1] && tos[0] && tos[1]){
            if(from === '0000') return {'time': 0, 'fromStr':frms[0].toString()+frms[1].toString(),'toStr':tos[0].toString()+tos[1].toString()};
            if(to === '0000') return {'time': 0, 'fromStr':frms[0].toString()+frms[1].toString(),'toStr':tos[0].toString()+tos[1].toString()};
            return {'time': MathRound((min*60 + ss)/60,1), 'fromStr':frms[0].toString()+frms[1].toString(),'toStr':tos[0].toString()+tos[1].toString()};
        }else{
            return {'time' :0};
        }
    };

    //changeNumberType
    $rootScope.changeNumberType = function(str, type){
        if(type === 'Number') return Number(str);
        if(type === 'parseFloat') return parseFloat(str);
    };
    // 時間単位区分
    $rootScope.changeSecKbnName = function(kbn){
        if(kbn === '1' || kbn === 1) return '秒';
        if(kbn === '2' || kbn === 2) return '分';
        if(kbn === '3' || kbn === 3) return '時';
    };
    // 原版区分
    $rootScope.changeGenKbnName = function(kbn){
        if(kbn === '1' || kbn === 1) return '当社補完';
        if(kbn === '2' || kbn === 2) return '担当者へ';
        if(kbn === '3' || kbn === 3) return '同時返却';
    };

    // popupが生きてたら閉じる
    if( $rootScope.openWindow ){
        $log.warn('Kill all the popup zombies');
        $rootScope.openWindow.focus();
        $rootScope.openWindow.close();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
      /* 
       * ログイン後の利用機能権限
       * sys_admin_fl
       * 1 : Admin すべて操作可能
       * 2 : 一般社員1　一般業務/請求・納品/帳票 各承認
       * 3 : 一般社員2　一般業務/請求・納品/帳票
       * 4 : 一般社員3　一般業務のみ
       * 5 : 一般社員4　一般業務閲覧/印刷のみ
       * 6 : 権限剥奪(ログインのみ個人設定以外何も出来ない)
       */
      $stateProvider
        .state('/login', { // ログイン画面
          url: '/login',
          data: {
              permissions: {
                  except: ['isloggedin'],
                  redirectTo: 'app.dashboard'
              }
          },
          templateUrl: 'app/login/login.html',
          controller: 'LoginController',
          controllerAs: 'login'
        })
        .state('/print', { // プリント画面
            url: '/print/:mode',
            templateUrl: 'app/print/print.html',
            controller: 'PrintController',
            controllerAs: 'print'
        })
        .state('/ur-print', { // プリント画面
            url: '/ur-print/:mode',
            templateUrl: 'app/ur-print/print.html',
            controller: 'UrPrintController',
            controllerAs: 'urprint'
        })
        .state('/jt-print', { // プリント画面
            url: '/jt-print/:mode',
            templateUrl: 'app/analysis/jt-print/print.html',
            controller: 'JtPrintController',
            controllerAs: 'jtprint'
        })
        .state('/es-print', { // プリント画面
            url: '/es-print/:mode',
            templateUrl: 'app/analysis/es-print/print.html',
            controller: 'EsPrintController',
            controllerAs: 'esprint'
        })
        .state('/oa-prt', { // プリント画面
            url: '/oa-prt',
            templateUrl: 'app/analysis/oa-print-print/print.html',
            controller: 'OaPrintPrintController',
            controllerAs: 'oaprint'
        })
        .state('/mts-print', { // プリント画面
            url: '/mts-print',
            templateUrl: 'app/analysis/mts-print/print.html',
            controller: 'MtsPrintController',
            controllerAs: 'mtsprint'
        })
        .state('/sos-print', { // プリント画面
            url: '/sos-print',
            templateUrl: 'app/analysis/sos-print/print.html',
            controller: 'SosPrintController',
            controllerAs: 'sosprint'
        })
        .state('/m-print', { // プリント画面
            url: '/m-print',
            templateUrl: 'app/monthly-action/mprint/print.html',
            controller: 'MprintController',
            controllerAs: 'mp'
        })
        .state('/exp-print', { // プリント画面
            url: '/exp-print',
            templateUrl: 'app/business-expenses/exp-print/print.html',
            controller: 'ExpPrintController',
            controllerAs: 'ep'
        })
         .state('/ivl-print', { // プリント画面
            url: '/ivl-print',
            templateUrl: 'app/inventory/inventory-list/ivl-print/print.html',
            controller: 'IvlPrintController',
            controllerAs: 'ivlpr'
        })
        .state('/ivs-print', { // プリント画面
            url: '/ivs-print',
            templateUrl: 'app/inventory/inventory-studio/ivs-print/print.html',
            controller: 'IvsPrintController',
            controllerAs: 'ivspr'
        })
        .state('/ivi-print', { // プリント画面
            url: '/ivi-print',
            templateUrl: 'app/inventory/inventory-sgitem/ivi-print/print.html',
            controller: 'IviPrintController',
            controllerAs: 'ivipr'
        })
        .state('/ivis-print', { // プリント画面
            url: '/ivis-print',
            templateUrl: 'app/inventory/inventory-issue/ivis-print/print.html',
            controller: 'IvisPrintController',
            controllerAs: 'ivispr'
        })
        .state('/nkyt-print', { // プリント画面
            url: '/nkyt-print',
            templateUrl: 'app/nyukin-yotei/print/print.html',
            controller: 'nkytPrintController',
            controllerAs: 'nkytpr'
        })
        .state('/tkmt-print', { // プリント画面
            url: '/tkmt-print',
            templateUrl: 'app/tokuisaki-moto/print/print.html',
            controller: 'tkmtPrintController',
            controllerAs: 'tkmtpr'
        })
        .state('/mklist-print', { // プリント画面
            url: '/mklist-print',
            templateUrl: 'app/mklist/print/print.html',
            controller: 'mklistPrintController',
            controllerAs: 'mklistpr'
        })
        .state('/uriake-print', { // プリント画面
            url: '/uriake-print',
            templateUrl: 'app/urikake/print/print.html',
            controller: 'urkPrintController',
            controllerAs: 'urkpr'
        })
        // abstract
        .state('app', {
            abstract: true,
            url: '/',
            templateUrl: 'app/menu/menu.html',
            controller: 'MenuController',
            controllerAs: 'menu',
            resolve: {
                authenticate: function ($auth, $log, $state, $rootScope, storage) {
                    // ここでtoken(ログイン)チェックしておく
                    if (!$auth.isAuthenticated()) {
                        $rootScope.logout();
                    }else{
                        $log.debug('token check start');
                        $rootScope.pollingToken();
                    }
                }
            }
        })
        // HOME
        .state('app.dashboard', {
            parent :'app',
            url: 'dashboard',
            views: {
                '@app': {
                    templateUrl: 'app/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'dashboard'
                }
            },
            ncyBreadcrumb: {
                label: 'Top'
            }
        })
        // 受注
        .state('app.business-orders', {
            url: 'business/orders',
            params: {
                param: null
            },
            views: {
                '@app': {
                    name: 'orders',
                    templateUrl: 'app/business-orders/orders.html',
                    controller: 'OrdersController',
                    controllerAs: 'orders',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '受注一覧'
            }
        })
        .state('app.business-planning', {
            url: 'business/planning/:juno',
            params: {
                param: null
            },
            views: {
                '@app': {
                    name: 'planning',
                    templateUrl: 'app/business-planning/planning.html',
                    controller: 'PlanningController',
                    controllerAs: 'planning',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }

            },
            ncyBreadcrumb: {
                label: '作業予定一覧'
            }
        })
       /* 作業報告 */
        .state('app.business-report', {
            url: 'business/report/:juno/:sgno',
            params: {
                param: null
            },
            views: {
                '@app': {
                    name: 'report',
                    templateUrl: 'app/business-report/report.html',
                    controller: 'ReportController',
                    controllerAs: 'report',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '作業報告一覧'
            }
        })
        /* 作業売上 */
        .state('app.business-earnings', {
            url: 'business/earnings/:juno',
            params: {
                param: null
            },
            views: {
                '@app': {
                    name: 'earnings',
                    templateUrl: 'app/business-earnings/earnings.html',
                    controller: 'EarningsController',
                    controllerAs: 'earnings',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '作業売上一覧'
            }
        })
        /* 売上 */
        .state('app.business-workearnings', {
            url: 'business/workearnings/:juno',
            params: {
                param: null
            },
            views: {
                '@app': {
                    name: 'wkearn',
                    templateUrl: 'app/business-workearnings/wkearn.html',
                    controller: 'WkearnController',
                    controllerAs: 'wkearn',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '売上一覧'
            }
        })
         /* 経費 */
        .state('app.business-expenses', {
            url: 'business/expenses',
            params: {
                param: null
            },
            views: {
                '@app': {
                    name: 'expenses',
                    templateUrl: 'app/business-expenses/expenses.html',
                    controller: 'ExpensesController',
                    controllerAs: 'exp',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '経費一覧'
            }
        })
        /* 経費承認 */
        .state('app.business-accounting', {
            url: 'business/accounting',
            views: {
                '@app': {
                    name: 'expenses',
                    templateUrl: 'app/business-accounting/accounting.html',
                    controller: 'AccountingController',
                    controllerAs: 'acc',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if( user.sys_admin_fl !== '1' ){
                                // 経理は許可
                                if( user.sys_admin_fl === '2' && user.bumon_cd !== '0420'){
                                    $state.go('app.dashboard');
                                }
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '経理承認一覧'
            }
        })
        //　請求・納品書
        .state('app.invoice-data', {
            url: 'invoice/data',
            views: {
                '@app': {
                    name: 'invdata',
                    templateUrl: 'app/invoice-data/invoicedata.html',
                    controller: 'InvoicedataController',
                    controllerAs: 'invoicedata',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '請求書・納品書印刷'
            }
        })
        .state('app.invoice-add', {
            url: 'invoice/add',
            views: {
                '@app': {
                    name: 'invadd',
                    templateUrl: 'app/invoice-add/invoiceadd.html',
                    controller: 'InvoiceaddController',
                    controllerAs: 'invoiceadd',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '請求書/納品書生成'
            }
        })
        // 入金処理
        .state('app.payment', {
            url: 'payment',
            views: {
                '@app': {
                    name: 'payment',
                    templateUrl: 'app/payment/payment.html',
                    controller: 'PaymentController',
                    controllerAs: 'payment',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '入金処理'
            }
        })
        // 得意先元帳
        .state('app.tokumoto', {
            url: 'tokumoto',
            views: {
                '@app': {
                    name: 'tokumoto',
                    templateUrl: 'app/tokuisaki-moto/main.html',
                    controller: 'TokuisakiMotoController',
                    controllerAs: 'tkm',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '得意先元帳'
            }
        })
        // 入金予定
        .state('app.nkyt', {
            url: 'nkyt',
            views: {
                '@app': {
                    name: 'nkyt',
                    templateUrl: 'app/nyukin-yotei/main.html',
                    controller: 'NyukinYoteiController',
                    controllerAs: 'nky',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '入金予定'
            }
        })
        // 未回収一覧
        .state('app.mklist', {
            url: 'mklist',
            views: {
                '@app': {
                    name: 'mklist',
                    templateUrl: 'app/mklist/main.html',
                    controller: 'MklistController',
                    controllerAs: 'mklist',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '未回収一覧'
            }
        })
        // 売掛金一覧
        .state('app.urikake', {
            url: 'urikake',
            views: {
                '@app': {
                    name: 'urikake',
                    templateUrl: 'app/urikake/main.html',
                    controller: 'UrikakeController',
                    controllerAs: 'urk',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '売掛金一覧'
            }
        })
        // ユーザ個人設定
        .state('app.user', {
            url: 'user',
            views: {
                '@app': {
                    name: 'user',
                    templateUrl: 'app/user/user.html',
                    controller: 'UserController',
                    controllerAs: 'user'
                 }
            },
            ncyBreadcrumb: {
                label: '個人設定'
            }
        })
        // マスタ　基本情報
        .state('app.basic', {
            url: 'basic',
            views: {
                '@app': {
                    name: 'basic',
                    templateUrl: 'app/masta-basic/basic.html',
                    controller: 'BasicController',
                    controllerAs: 'basic',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '基本情報　入金口座マスタ・税率マスタ'
            }
        })
        // マスタ　社員
        .state('app.syain', {
            url: 'syain',
            views: {
                '@app': {
                    name: 'syain',
                    templateUrl: 'app/masta-syain/syain.html',
                    controller: 'SyainController',
                    controllerAs: 'syain',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '社員マスタ'
            }
        })
        // マスタ　外部関係者
        .state('app.gaibu', {
            url: 'gaibu',
            views: {
                '@app': {
                    name: 'gaibu',
                    templateUrl: 'app/masta-gaibu/gaibu.html',
                    controller: 'GaibuController',
                    controllerAs: 'ga',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '外部関係者マスタ'
            }
        })
        // マスタ　得意先
        .state('app.toku', {
            url: 'toku',
            views: {
                '@app': {
                    name: 'toku',
                    templateUrl: 'app/masta-toku/toku.html',
                    controller: 'TokuController',
                    controllerAs: 'tk',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '得意先マスタ'
            }
        })
        // マスタ　スタジオ
        .state('app.studio', {
            url: 'studio',
            views: {
                '@app': {
                    name: 'studio',
                    templateUrl: 'app/masta-studio/studio.html',
                    controller: 'StudioController',
                    controllerAs: 'std',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: 'スタジオマスタ'
            }
        })
        // マスタ　作業項目(作業アイテム)
        .state('app.sgitem', {
            url: 'sgitem',
            views: {
                '@app': {
                    name: 'sgitem',
                    templateUrl: 'app/masta-sgitem/sgitem.html',
                    controller: 'SgItemController',
                    controllerAs: 'sgi',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '作業項目マスタ'
            }
        })
         // マスタ　作業分類
        .state('app.bunrui', {
            url: 'bunrui',
            views: {
                '@app': {
                    name: 'bunrui',
                    templateUrl: 'app/masta-bunrui/bunrui.html',
                    controller: 'BunruiController',
                    controllerAs: 'bnr',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '作業分類マスタ'
            }
        })
        // マスタ　作業形態
        .state('app.sgkeitai', {
            url: 'sgkeitai',
            views: {
                '@app': {
                    name: 'sgkeitai',
                    templateUrl: 'app/masta-sgkeitai/sgkeitai.html',
                    controller: 'SgKeitaiController',
                    controllerAs: 'sgk',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '作業形態マスタ(下部作業パターン)'
            }
        })
        // マスタ　部門
        .state('app.bumon', {
            url: 'bumon',
            views: {
                '@app': {
                    name: 'bumon',
                    templateUrl: 'app/masta-bumon/bumon.html',
                    controller: 'BumonController',
                    controllerAs: 'bmn',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '部門マスタ'
            }
        })
        // マスタ　メディア
        .state('app.media', {
            url: 'media',
            views: {
                '@app': {
                    name: 'media',
                    templateUrl: 'app/masta-media/media.html',
                    controller: 'MediaController',
                    controllerAs: 'mda',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: 'メディアマスタ'
            }
        })
        // マスタ　CODE
        .state('app.code', {
            url: 'code',
            views: {
                '@app': {
                    name: 'code',
                    templateUrl: 'app/masta-codeval/codeval.html',
                    controller: 'CodeValController',
                    controllerAs: 'cd',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: 'コードマスタ'
            }
        })
         // マスタ　経費分類
        .state('app.keihi-bunrui', {
            url: 'keihi-bunrui',
            views: {
                '@app': {
                    name: 'keihi-bunrui',
                    templateUrl: 'app/masta-keihi-bunrui/keihi-bunrui.html',
                    controller: 'KeihiBunruiController',
                    controllerAs: 'kbun',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '経費分類マスタ'
            }
        })
        // マスタ 経費科目
        .state('app.keihi-kamoku', {
            url: 'keihi-kamoku',
            views: {
                '@app': {
                    name: 'keihi-kamoku',
                    templateUrl: 'app/masta-keihi-kamoku/keihi-kamoku.html',
                    controller: 'KeihiKamokuController',
                    controllerAs: 'kkm',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '経費科目マスタ'
            }
        })
         // マスタ　勘定科目
        .state('app.kanjyo-kamoku', {
            url: 'kanjyo-kamoku',
            views: {
                '@app': {
                    name: 'kanjyo-kamoku',
                    templateUrl: 'app/masta-kanjyo-kamoku/kanjyo-kamoku.html',
                    controller: 'KanjyoKamokuController',
                    controllerAs: 'kkm',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '勘定科目マスタ'
            }
        })
         // マスタ　補助科目
        .state('app.hojyo-kamoku', {
            url: 'hojyo-kamoku',
            views: {
                '@app': {
                    name: 'hojyo-kamoku',
                    templateUrl: 'app/masta-hojyo-kamoku/hojyo-kamoku.html',
                    controller: 'HojyoKamokuController',
                    controllerAs: 'hkm',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '補助科目マスタ'
            }
        })
        // マスタ　取引先
        .state('app.torihiki', {
            url: 'torihiki',
            views: {
                '@app': {
                    name: 'torihiki',
                    templateUrl: 'app/masta-torihiki/torihiki.html',
                    controller: 'TorihikiController',
                    controllerAs: 'thk',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '取引先マスタ'
            }
        })
        // 帳票　月別実績(担当者)
        .state('app.monthly-rep-tan', {
            url: 'monthly-rep-tan',
            views: {
                '@app': {
                    name: 'monthly-rep-tan',
                    templateUrl: 'app/analysis/monthly-report-tan/main.html',
                    controller: 'MonReportTanController',
                    controllerAs: 'mrt',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '月別実績(担当者)'
            }
        })
        // 帳票　月別実績(得意先)
        .state('app.monthly-rep-toku', {
            url: 'monthly-rep-toku',
            views: {
                '@app': {
                    name: 'monthly-rep-toku',
                    templateUrl: 'app/analysis/monthly-report-toku/main.html',
                    controller: 'MonReportTokuController',
                    controllerAs: 'mrk',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '月別実績(得意先)'
            }
        })
        // エンジニア指名状況
        .state('app.engineers', {
            url: 'engineers',
            views: {
                '@app': {
                    name: 'engineers',
                    templateUrl: 'app/analysis/engineers-specify/main.html',
                    controller: 'EngineersSpecifyController',
                    controllerAs: 'egs',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: 'エンジニア指名状況'
            }
        })
         // OAプリント本数
        .state('app.oa-print', {
            url: 'oa-print',
            views: {
                '@app': {
                    name: 'oa-print',
                    templateUrl: 'app/analysis/oa-print-count/main.html',
                    controller: 'OaPrintCountController',
                    controllerAs: 'opc',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '得意先別OAプリント本数'
            }
        })
        // 部門別売上推移
        .state('app.monthly-transition', {
            url: 'monthly-transition',
            views: {
                '@app': {
                    name: 'monthly-transition',
                    templateUrl: 'app/analysis/monthly-transition/main.html',
                    controller: 'MonthlyTransitionController',
                    controllerAs: 'mts',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '部門別売上推移'
            }
        })
        // スタッフ稼働状況
        .state('app.op-stasus', {
            url: 'op-stasus',
            views: {
                '@app': {
                    name: 'op-stasus',
                    templateUrl: 'app/analysis/staff-operating-status/main.html',
                    controller: 'StaffOperatingStatusController',
                    controllerAs: 'sos',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: 'スタッフ稼働状況'
            }
        })
         // 技術員作業明細一覧(管理者のみ)
        .state('app.work-spec', {
            url: 'work-spec',
            views: {
                '@app': {
                    name: 'work-spec',
                    templateUrl: 'app/analysis/work-specification/main.html',
                    controller: 'workSpecificationController',
                    controllerAs: 'ws',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl !== '1' ){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '技術員作業明細'
            }
        })
        // 各部屋別作業時間推移・作業金額
        .state('app.studio-transition', {
            url: 'studio-transition',
            views: {
                '@app': {
                    name: 'studio-transition',
                    templateUrl: 'app/analysis/studio-transition/main.html',
                    controller: 'StudioTransitionController',
                    controllerAs: 'str',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '各部屋別作業時間推移・作業金額'
            }
        })
        // 月次実行
        .state('app.monthly-action', {
            url: 'monthly-action',
            views: {
                '@app': {
                    name: 'monthly-action',
                    templateUrl: 'app/monthly-action/main.html',
                    controller: 'MonthlyActionController',
                    controllerAs: 'ma',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '月次実行'
            }
        })
        // 残在庫調整実行
        .state('app.zanzaiko-action', {
            url: 'zanzaiko-action',
            params: {
                zz_date: null
            },
            views: {
                '@app': {
                    name: 'zanzaiko-action',
                    templateUrl: 'app/zanzaiko-action/main.html',
                    controller: 'ZanzaikoActionController',
                    controllerAs: 'zz',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '残在庫調整実行'
            }
        })
        // スタッフ稼働状況集計実行
        .state('app.monthly-staff', {
            url: 'monthly-staff',
            views: {
                '@app': {
                    name: 'monthly-staff',
                    templateUrl: 'app/monthly-staff/main.html',
                    controller: 'MonthlyStaffController',
                    controllerAs: 'mtf',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: 'スタッフ稼働状況集計実行'
            }
        })
        // 在庫管理:仕入一覧
        .state('app.inventory-controll', {
            url: 'inventory/controll',
            views: {
                '@app': {
                    name: 'inventory-controll',
                    templateUrl: 'app/inventory/inventory-controll/controll.html',
                    controller: 'InventoryControllController',
                    controllerAs: 'icc',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '在庫管理:仕入一覧'
            }
        })
        // 在庫管理:振替一覧
        .state('app.inventory-transfer', {
            url: 'inventory/transfer',
            views: {
                '@app': {
                    name: 'inventory-transfer',
                    templateUrl: 'app/inventory/inventory-transfer/transfer.html',
                    controller: 'TransferControllController',
                    controllerAs: 'trf',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '在庫管理:振替一覧'
            }
        })
        // 在庫管理:在庫一覧
        .state('app.inventory-list', {
            url: 'inventory/list',
            views: {
                '@app': {
                    name: 'inventory-list',
                    templateUrl: 'app/inventory/inventory-list/main.html',
                    controller: 'InventoryListController',
                    controllerAs: 'ivl',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '在庫管理:在庫一覧'
            }
        })
        // 在庫管理:スタジオ別出庫集計表
        .state('app.inventory-studio', {
            url: 'inventory/studio',
            views: {
                '@app': {
                    name: 'inventory-list',
                    templateUrl: 'app/inventory/inventory-studio/main.html',
                    controller: 'InventoryStudioController',
                    controllerAs: 'ivs',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '在庫管理:スタジオ別出庫集計表'
            }
        })
        // 在庫管理:商品別出庫集計表
        .state('app.inventory-sgitem', {
            url: 'inventory/sgitem',
            views: {
                '@app': {
                    name: 'inventory-sgitem',
                    templateUrl: 'app/inventory/inventory-sgitem/main.html',
                    controller: 'InventorySgItemController',
                    controllerAs: 'ivi',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '在庫管理:商品別出庫集計表'
            }
        })
        // 在庫管理:出庫一覧表
        .state('app.inventory-issue', {
            url: 'inventory/issue',
            views: {
                '@app': {
                    name: 'inventory-issue',
                    templateUrl: 'app/inventory/inventory-issue/main.html',
                    controller: 'InventoryIssueController',
                    controllerAs: 'ivis',
                    resolve: {
                        // 基本的にメニューで表示するしないを操作するが、url直打ちへの対応
                        admincheck: function ($state, $rootScope, storage) {
                            var user = storage.get('user');
                            if(user.sys_admin_fl === '4' || user.sys_admin_fl === '5'
                                || user.sys_admin_fl === '6'){
                                $state.go('app.dashboard');
                            }
                        }
                    }
                }
            },
            ncyBreadcrumb: {
                label: '在庫管理:出庫一覧表'
            }
        });
      

      $urlRouterProvider.otherwise('/login');
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontend')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('dev', {
        debug: false,
        api : '../'
    })
     .constant('dateFormat', {
        format : function(v){
            var d = new Date(v);
            var curr_date = d.getDate();
            var curr_month = d.getMonth() + 1;
            var curr_year = d.getFullYear();
            return curr_year + '/' + curr_month + '/' + curr_date;
        }
    });

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .config(config)
    .value('cgBusyDefaults',{
        message:'',
        backdrop: true,
        delay: 100,
        minDuration: 500,
    });

  /** @ngInject */
  function config($logProvider, $httpProvider, toastrConfig, $stateProvider, $urlRouterProvider, $authProvider, dev, $dropdownProvider, $datepickerProvider, $modalProvider
          ,paginationTemplateProvider, $tooltipProvider, $popoverProvider, modelFormatConfig) {

      // cgBusy interceptors
      $httpProvider.interceptors.push('busyInterceptor');

      // ログdebug出力
      $logProvider.debugEnabled(dev.debug);

      //$animate.enabled(false);
      
      // トースター設定
      toastrConfig.allowHtml = true;
      toastrConfig.timeOut = 3000;
      toastrConfig.positionClass = 'toast-top-right';
      toastrConfig.preventDuplicates = false;
      toastrConfig.progressBar = true;

      // 開発時のURLと本番切り替え
      if(dev.debug)
          //dev.api = 'http://localhost:8000/';
          dev.api = 'http://local.visual.jp/';

      //$authProvider settings
      $authProvider.loginUrl = dev.api + 'api/v1/authenticate';
      $authProvider.httpInterceptor = true;


      //Dropdown default
      angular.extend($dropdownProvider.defaults, {
          animation: 'am-flip-x',
          trigger: 'click'
      });
      // date picker
      angular.extend($datepickerProvider.defaults, {
          dateFormat: 'yyyy/MM/dd',
          dateType : 'string',
          autoclose: 'true'
          //delay: { show: 500, hide: 1000000 }
      });

      // modal
      angular.extend($modalProvider.defaults, {
          animation: 'am-fade-and-scale',
          placement: 'center'
      });
      // tooltip
      angular.extend($tooltipProvider.defaults, {
          animation: 'am-flip-x',
          trigger: 'hover',
          html: true
      });

      var minus = function(event) {
          var which = event.which;
          return (which == 45 || which == 189);
      };

      // model formatter
      modelFormatConfig['number'] = {
          'formatter': function(args) {
              var modelValue = args.$modelValue,
                  filter = args.$filter;
              return filter('number')(modelValue);
          },
          'parser': function(args) {
              var val;
              //console.log(val);
              if(args.$viewValue){
                  val = parseInt(args.$viewValue.replace(/[^0-9\-]/g, ''), 10);
              }
              //console.log(val);
              return isNaN(val) ? undefined : val;
          },
          'isEmpty': function(value) {
              return !value.$modelValue;
          },
          'keyDown': function(args) {
              var event = args.$event;
              //if (!(gobal.keyHelper.smallKeyBoard(event) || gobal.keyHelper.numberKeyBpoard(event) || gobal.keyHelper.functionKeyBoard(event) || minus(event))) {
              if (minus(event)) {
                  event.stopPropagation();
                  event.preventDefault();
              }
          }
      };

      // Paagenation
      paginationTemplateProvider.setPath('app/components/dirPagination.tpl.html');

      // 存在しないURLの場合の戻り先
      $urlRouterProvider.otherwise('/login');

  }

})();

angular.module("frontend").run(["$templateCache", function($templateCache) {$templateCache.put("app/business-accounting/accounting.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-show=\"acc.form\"><button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button> <a ui-sref=\"app.business-expenses\" class=\"btn btn-default btn-xs\">経費一覧へ戻る</a><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">申請日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.form.fromDate\" data-max-date=\"{{acc.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">申請日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.form.untilDate\" data-min-date=\"{{acc.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"acc.khBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">経費分類 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.kh_bunrui_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">支払先</span><ac-torihikisaki ng-model=\"acc.form.tori_cd\"></ac-torihikisaki><span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.tori_nm\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">経費No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.form.kh_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">経費No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.form.kh_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"acc.ssBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">申請部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.ss_bmn_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"acc.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">申請者 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.ss_tan_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"acc.krSnfllDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">経理承認 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.kr_sn_fl_nm\" disabled=\"\"></div></div></div><div class=\"col-xs-7\"><p>経費承認済みのデータのみ表示されます</p></div><div class=\"col-xs-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"acc.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"acc.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"acc.datas\"><dir-pagination-controls on-page-change=\"acc.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"acc.pagination.current * acc.datasPerPage - (acc.datasPerPage -1) +\'～\'+((acc.pagination.current * acc.datasPerPage - acc.datasPerPage) + acc.datas.length) +\'件/\'+acc.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"acc.datas\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで承認画面が開きます</caption><thead><tr class=\"active\"><th>#</th><th style=\"width:10%\">申請日</th><th style=\"width:10%\">経費No.</th><th style=\"width:10%\">申請者</th><th style=\"width:15%\">負担部門</th><th style=\"width:15%\">支払先</th><th style=\"width:15%\">申請部門</th><th style=\"width:15%\">経費分類</th><th style=\"width:10%\">作業No.</th><th>合計金額</th><th>経理</th></tr></thead><tbody dir-paginate=\"item in acc.datas | itemsPerPage: acc.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"acc.totalDatas\" current-page=\"acc.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"acc.detailSet(item)\" style=\"cursor:pointer;\"><tr><td class=\"text-center\">{{ ($index + 1) + (acc.pagination.current - 1) * acc.datasPerPage }}</td><td>{{ item.ss_day_time * 1000 | date }}</td><td>{{ item.kh_no }}</td><td>{{ item.ss_tan_nm }}</td><td>{{ item.futan_bmn_nm }}</td><td><span bs-tooltip=\"item.tori_nm\">{{ item.tori_nm }}</span></td><td>{{ item.ss_bmn_nm }}</td><td><span bs-tooltip=\"item.kh_bunrui_nm\">{{ item.kh_bunrui_nm }}</span></td><td>{{ item.sg_no }}</td><td>{{ item.komi_kin | number }}</td><td><span class=\"label label-danger\" ng-if=\"item.kr_sn_fl == \'0\'\">未</span> <span class=\"label label-info\" ng-if=\"item.kr_sn_fl > 0\">済</span></td></tr></tbody></table></div><div class=\"col-12\"><div style=\"height:100px\"></div></div><div class=\"navbar navbar-fixed-bottom container-nav\" ng-if=\"acc.itemDetail.length > 0\"><div class=\"container\"><div class=\"list-box\"><ul class=\"list-group footer-list\"><li class=\"list-group-item\" ng-repeat=\"item in acc.itemDetail\" ng-if=\"item.biko\">{{ $index + 1}}&emsp;{{ item.biko }}</li></ul></div></div></div>");
$templateCache.put("app/business-accounting/accountingEdit.html","<div class=\"modal modal-wide modal-sgyt\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\">経理承認</h4></div><div class=\"col-xs-5 text-right\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"acc.isFromDisabled\" ng-click=\"acc.editScope.approvalSubmit(\'0\')\">承認取消</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-if=\"!acc.isFromDisabled\" ng-click=\"acc.editScope.approvalSubmit(\'1\')\">承認</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide();acc.editScope.cancel(acc.editScope.editMode)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit\" disable-all=\"acc.isFromDisabled || acc.isEditDisabled\"><form role=\"form\" name=\"reportForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-5\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:70px\" class=\"title text-center\">伝票日付</td><td style=\"width:75px\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.editForm.den_day\" name=\"ss_day\" bs-datepicker=\"\" placeholder=\"年月日\"></td><td style=\"width:70px\" class=\"title text-center\">支払予定日</td><td style=\"width:75px\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.editForm.sh_yt_day\" name=\"ss_day\" bs-datepicker=\"\" placeholder=\"年月日\"></td></tr></tbody></table></div><div class=\"col-md-7\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td colspan=\"5\" class=\"text-center title\">貸方</td></tr><tr><td style=\"width:80px\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"acc.editScope.kasiBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></td><td style=\"width:80px\" class=\"text-center title\">勘定科目</td><td style=\"width:250px\" class=\"text-center title\">補助科目</td><td style=\"width:60px\" class=\"text-center title\">合計</td></tr><tr><td class=\"text-center\">{{ acc.editForm.kasi_bmn_nm }}</td><td class=\"text-center\">{{ acc.editForm.kasi_kmk_nm }}</td><td><div class=\"input-group\"><ac-hojo-kamoku ng-model=\"acc.editForm.kasi_hj_cd\"></ac-hojo-kamoku><span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"acc.editForm.kasi_hj_nm\" disabled=\"\"></div></td><td class=\"text-right\">{{ acc.editForm.komi_kin | number }}</td></tr></tbody></table></div><div class=\"col-md-12\"><div style=\"height:20px\">&emsp;</div></div></div><div class=\"row\"><div class=\"col-md-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-md-12\" style=\"height:400px; overflow-y:auto;\"><div ng-include=\"\'app/business-accounting/editmode.html\'\"></div></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td class=\"text-center\">貸方合計</td><td class=\"text-right\">{{ acc.editForm.komi_kin | number }}</td><td class=\"text-center\">課税対象額</td><td class=\"text-right\">{{ acc.editForm.nuki_kin | number }}</td><td class=\"text-center\">消費税</td><td class=\"text-right\">{{ acc.editForm.zei_kin | number }}</td></tr></tbody></table></div><div class=\"col-xs-6\"><span ng-if=\"acc.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span><br></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();acc.editScope.cancel(acc.editScope.editMode)\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-accounting/editmode.html","<div disable-all=\"acc.isFromDisabled || acc.isEditDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:3%\">No.</th><th rowspan=\"2\" style=\"width:8%\">負担部門</th><th style=\"width:5%\">総勘</th><th colspan=\"2\" style=\"width:35%\">借方</th><th rowspan=\"2\">税区</th><th rowspan=\"2\" style=\"width:25%\">摘要</th><th rowspan=\"2\" style=\"width:25%\">備考</th></tr><tr class=\"active\"><th>補助</th><th style=\"width:20%\">科目名</th><th style=\"width:15%\">金額</th></tr></thead><tbody ng-repeat=\"( key, item ) in acc.editForm.detail\" class=\"fit\" disable-all=\"acc.isFromDisabled || acc.isEditDisabled\"><tr><td rowspan=\"2\" class=\"text-center\">{{ item.gyo_no }}</td><td><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" data-placement=\"top\" bs-dropdown=\"acc.editScope.futanBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{item.futan_bmn_cd}} <span class=\"caret\"></span></button></td><td><ac-kamoku-item ng-model=\"item.kmk_cd\"></ac-kamoku-item></td><td>{{ item.kmk_nm }}</td><td class=\"text-right\"><input type=\"text\" class=\"form-control input-sm\" name=\"kin\" ng-model=\"item.kin\"></td><td rowspan=\"2\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" data-placement=\"top\" bs-dropdown=\"acc.editScope.zeiKbDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{item.zei_kb_nm}} <span class=\"caret\"></span></button></td><td rowspan=\"2\"><textarea class=\"form-control input-sm\" name=\"tekiyo\" ng-model=\"item.tekiyo\"></textarea></td><td rowspan=\"2\"><textarea class=\"form-control input-sm\" name=\"biko\" ng-model=\"item.biko\"></textarea></td></tr><tr><td>{{item.futan_bmn_nm}}</td><td><ac-hojo-kamoku-item ng-model=\"item.hojyo_kmk_cd\" kmkcd=\"{{item.kmk_cd}}\"></ac-hojo-kamoku-item></td><td>{{ item.hojyo_kmk_nm }}</td><td class=\"text-right\">( {{ item.zei_kin }} )</td></tr></tbody></table></div>");
$templateCache.put("app/business-earnings/earnings.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-show=\"earnings.form\"><button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.form.fromDate\" data-max-date=\"{{earnings.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.form.untilDate\" data-min-date=\"{{earnings.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.form.ju_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.form.ju_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先</span><div angucomplete-alt=\"\" id=\"ex2\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"300\" selected-object=\"earnings.tokuisakiSelected\" remote-api-handler=\"earnings.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control input-sm\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作品名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"作品名\" ng-model=\"earnings.form.hin_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.studioDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">スタジオ <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.studio_nm\" disabled=\"\"> <input type=\"hidden\" name=\"studio_cd\" ng-model=\"earnings.form.studio_cd\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.snflStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">承認 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.sn_fl_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.uriageStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">売上 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.ur_fl_nm\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.form.sg_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.form.sg_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">受注部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ins_bmn_cd\" ng-model=\"earnings.form.ins_bmn_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.ju_tanto_nm\" placeholder=\"先に受注部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"ju_tanto_cd\" ng-model=\"earnings.form.ju_tanto_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.sghtDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.sg_bmn_nm\" disabled=\"\"> <input type=\"hidden\" name=\"gyomu_kb\" ng-model=\"earnings.form.sg_bmn_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"earnings.sghtsyaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業担当 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.gj_nm_1\" placeholder=\"先に作業予定部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"simei_gj_cd_1\" ng-model=\"earnings.form.gj_cd_1\"></div></div></div><div class=\"col-xs-7\"><div ng-if=\"dummy\">※本年から3年前までを標準出力しています。<br>※3年以上前のデータは日付指定で検索してください</div><div>※最初に別の条件を選択し、絞り込む必要があるものがあります（例：担当営業)</div></div><div class=\"col-xs-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"earnings.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"earnings.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"earnings.datas\"><dir-pagination-controls on-page-change=\"earnings.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"earnings.pagination.current * earnings.datasPerPage - (earnings.datasPerPage -1) +\'～\'+((earnings.pagination.current * earnings.datasPerPage - earnings.datasPerPage) + earnings.datas.length) +\'件/\'+earnings.totalDatas+\'件\'\"></span> <span class=\"goukei-label\">&nbsp;&nbsp;&nbsp;合計&nbsp;&nbsp;{{ earnings.totalKin | number}}円</span></div><div class=\"table-responsive item-table\" ng-show=\"earnings.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th rowspan=\"2\">#</th><th style=\"width:10%\">作業日</th><th style=\"width:10%\">作業伝票No.</th><th>受注No.</th><th style=\"width:15%\">得意先</th><th style=\"width:10%\">担当</th><th colspan=\"2\">作品名</th><th style=\"width:12%\">スタジオ</th><th rowspan=\"2\">操作</th><th rowspan=\"2\">報告</th><th rowspan=\"2\">売上</th><th rowspan=\"2\">承認</th></tr><tr class=\"active\"><th>受注部門</th><th>営業</th><th>作業部門</th><th style=\"width:15%\">技術１</th><th style=\"width:15%\">技術２</th><th style=\"width:15%\">技術３</th><th colspan=\"2\">作業金額</th></tr></thead><tbody dir-paginate=\"item in earnings.datas | itemsPerPage: earnings.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"earnings.totalDatas\" current-page=\"earnings.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (earnings.pagination.current - 1) * earnings.datasPerPage }}</td><td>{{ item.sg_day_time * 1000 | date }}</td><td>{{ item.sg_no }}</td><td>{{ item.ju_no }}</td><td><span bs-tooltip=\"item.toku_nm\">{{ item.toku_nm }}</span></td><td>{{ item.ju_tanto_nm }}</td><td colspan=\"2\"><span bs-tooltip=\"item.hin_nm\">{{ item.hin_nm }}</span></td><td><span bs-tooltip=\"item.studio_nm\">{{ item.studio_nm }}</span></td><td rowspan=\"2\"><span ng-if=\"item.sn_fl_1 == 0 && item.sn_fl_2 == 0\"><a href=\"\" ng-click=\"editEnabled=!editEnabled;earnings.editModeInit(2, item.ju_no, item.sg_no);\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" class=\"btn btn-danger btn-xs mini-button\" bs-tooltip=\"\'作業売上編集\'\">編集</a></span> <span ng-if=\"item.sn_fl_1 != 0 || item.sn_fl_2 != 0\"><a href=\"\" ng-click=\"editEnabled=!editEnabled;earnings.editModeInit(2, item.ju_no, item.sg_no);\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" class=\"btn btn-info btn-xs mini-button\" bs-tooltip=\"\'作業売上確認\'\">確認</a></span></td><td rowspan=\"2\"><span class=\"label label-danger label-mini\" ng-if=\"item.hk_umu_fl == 0\">無</span> <span class=\"label label-success label-mini\" ng-if=\"item.hk_umu_fl == 1\">有</span></td><td rowspan=\"2\"><span class=\"label label-danger label-mini\" ng-if=\"item.ur_fl == 0 || !item.ur_fl\">未</span> <span class=\"label label-info label-mini\" ng-if=\"item.ur_fl > 0\">済</span></td><td rowspan=\"2\"><span class=\"label label-danger label-mini\" ng-if=\"item.sn_fl_1 == 0 && item.sn_fl_2 == 0\">未</span> <span class=\"label label-info label-mini\" ng-if=\"item.sn_fl_1 != 0 || item.sn_fl_2 != 0\">済</span></td></tr><tr><td>{{ item.ju_bumon_nm }}</td><td>{{ item.ju_tanto_nm }}</td><td>{{ item.sg_bmn_nm }}</td><td>{{ item.gj_nm_1 }}</td><td>{{ item.gj_nm_2 }}</td><td>{{ item.gj_nm_3 }}</td><td colspan=\"2\">{{ item.sg_kin | number }}</td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"earnings.datas\"><dir-pagination-controls on-page-change=\"earnings.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"earnings.pagination.current * earnings.datasPerPage - (earnings.datasPerPage -1) +\'～\'+((earnings.pagination.current * earnings.datasPerPage - earnings.datasPerPage) + earnings.datas.length) +\'件/\'+earnings.totalDatas+\'件\'\"></span> <span class=\"goukei-label\">&nbsp;&nbsp;&nbsp;合計&nbsp;&nbsp;{{ earnings.totalKin | number}}円</span></div>");
$templateCache.put("app/business-earnings/earningsedit.html","<div class=\"modal modal-wide modal-sgyt\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title text-center\" ng-if=\"earnings.editScope.editMode == 2 && !earnings.creditNote\"><span>作業売上編集 <small class=\"text-danger\" style=\"font-size:10px\" ng-if=\"earnings.approvalUser && !earnings.isFromDisabled\">&nbsp;&nbsp;承認前に変更を行った場合はまず先に変更処理を行ってください。</small></span></h4><h4 class=\"modal-title text-center\" ng-if=\"earnings.editScope.editMode == 1 && !earnings.creditNote\">作業売上登録</h4><h4 class=\"modal-title text-center\" ng-if=\"earnings.creditNote\" style=\"color:red\">作業売上-赤伝登録</h4></div><div class=\"col-xs-6 text-right\" ng-if=\"earnings.editScope.editMode == 2 && !earnings.creditNote\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"earnings.creditNoteAdd(earnings.ju_no, earnings.sg_no);$hide();\" ng-if=\"!earnings.isEditDisabled && earnings.isFromDisabled && earnings.monthlyFlg\">赤伝</button><button type=\"button\" class=\"btn btn-success btn-sm\" ng-if=\"earnings.approvalUser && !earnings.isFromDisabled\" ng-click=\"earnings.editScope.approvalSubmit()\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled || earningsForm.$invalid || earnings.editScope.sgkyItems.length == 0\">承認</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"earnings.approvalUser && earnings.isFromDisabled && !earnings.monthlyFlg\" ng-click=\"earnings.editScope.unApprovalSubmit()\" ng-disabled=\"earnings.isEditDisabled\">承認取消</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"earnings.editScope.eaningsSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled || earningsForm.$invalid || earnings.editScope.sgkyItems.length == 0\">変更</button> <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"earnings.openjuNoChange()\" style=\"width:100px\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled\">受注No.変更</button><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"earnings.editScope.eaningsSubmit(\'DELETE\')\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled\">削除</button></div><div class=\"col-xs-5 text-right\" ng-if=\"earnings.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"earnings.editScope.eaningsSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled\">登録</button></div><div class=\"col-xs-5 text-right\" ng-if=\"earnings.creditNote\"><div class=\"input-group\"><span class=\"input-group-addon\">新しい作業日</span> <input type=\"text\" class=\"form-control input-sm\" data-min-date=\"{{earnings.sg_day_minDate}}\" ng-model=\"earnings.editForm.sg_day\" name=\"sg_day\" bs-datepicker=\"\" placeholder=\"yyyy-mm-dd\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"earnings.editScope.eaningsSubmit(\'POST\')\">登録</button></span></div></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide();earnings.editScope.cancel(earnings.editScope.editMode)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit\" disable-all=\"earnings.isFromDisabled || earnings.isEditDisabled || earnings.creditNote\"><form role=\"form\" name=\"earningsForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><tbody><tr><td style=\"width:15%\" class=\"title\">作業伝票No.</td><td style=\"width:15%\">{{ earnings.editForm.sg_no }} <input type=\"hidden\" name=\"sg_no\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.sg_no\"></td><td style=\"width:10%\" class=\"title\">得意先</td><td style=\"width:30%\">{{ earnings.editScope.item.toku_nm }}</td><td style=\"width:10%\" class=\"title\">担当営業</td><td>{{ earnings.editScope.item.ju_tanto_nm }}</td></tr><tr><td class=\"title\">受注No.</td><td>{{ earnings.editForm.ju_no }} <input type=\"hidden\" name=\"ju_no\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.ju_no\"></td><td class=\"title\">作品名</td><td colspan=\"3\">{{ earnings.editScope.item.hin_nm }} <input type=\"hidden\" name=\"hin_nm\" class=\"form-control input-sm\" ng-model=\"earnings.editScope.item.hin_nm\"></td></tr></tbody></table></div><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:15%\">作業部門</th><th style=\"width:15%\">業務区分</th><th style=\"width:15%\">作業形態</th><th>スタジオ</th><th style=\"width:83px\">作業日</th><th colspan=\"2\">作業時間(前後含)<span ng-if=\"earnings.editScope.sgytError\" class=\"text-danger\">※時間が間違っています</span></th><th style=\"width:83px\">作業金額</th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.sg_bmn_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.sghtDropdown\" bs-select=\"\" required=\"\" disabled=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"earnings.editForm.gyomu_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.gyomuDropdown\" bs-select=\"\" required=\"\" disabled=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"earnings.editForm.sg_keitai_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.sgktDropdown\" bs-select=\"\" required=\"\" disabled=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"earnings.editForm.studio_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.studioDropdown\" bs-select=\"\" required=\"\" disabled=\"\"><span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.sg_day\" name=\"sg_day\" bs-datepicker=\"\" placeholder=\"年月日\" style=\"width:80px\" required=\"\"></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"sg_tm_fm\" ng-model=\"earnings.editForm.sg_tm_fm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"width:50px;ime-mode:disabled\" ng-blur=\"earnings.setSgurTime()\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" name=\"sg_tm_to\" ng-model=\"earnings.editForm.sg_tm_to\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"width:50px;ime-mode:disabled\" ng-blur=\"earnings.setSgurTime()\" required=\"\"></td><td style=\"width:40px\"><input type=\"text\" id=\"sgyt-time\" class=\"form-control input-sm\" ng-model=\"earnings.editScope.sg_time\" disabled=\"\"></td><td style=\"width:80px\" class=\"active text-right\">{{earnings.editScope.sg_kin | number }}</td></tr></tbody></table><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th colspan=\"2\">作業技術員</th><th colspan=\"2\">作業時間(前後含)</th><th>前</th><th>後</th><th colspan=\"2\">作業技術員</th><th colspan=\"2\">作業時間(前後含)</th><th>前</th><th>後</th></tr></thead><tbody class=\"fit\"><tr><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_kb_1\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in earnings.editScope.gjPatternDropdown\" ng-change=\"earnings.changeGjKtPat1(1);\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_cd_1\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in earnings.editScope.gjktSyaDropdown1 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_1\" ng-model=\"earnings.editForm.gj_tm_fm_1\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime1()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_1\" ng-model=\"earnings.editForm.gj_tm_to_1\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime1()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_1\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.gj_time_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_1\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_mae_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_1\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_ato_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_kb_2\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in earnings.editScope.gjPatternDropdown\" ng-change=\"earnings.changeGjKtPat2(1);\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_cd_2\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in earnings.editScope.gjktSyaDropdown2 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_2\" ng-model=\"earnings.editForm.gj_tm_fm_2\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime2()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_2\" ng-model=\"earnings.editForm.gj_tm_to_2\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime2()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_2\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.gj_time_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_2\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_mae_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_2\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_ato_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td></tr><tr><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_kb_3\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in earnings.editScope.gjPatternDropdown\" ng-change=\"earnings.changeGjKtPat3(1);\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_cd_3\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in earnings.editScope.gjktSyaDropdown3 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_3\" ng-model=\"earnings.editForm.gj_tm_fm_3\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime3()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_3\" ng-model=\"earnings.editForm.gj_tm_to_3\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime3()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_3\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.gj_time_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"><br></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_3\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_mae_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_3\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_ato_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_kb_4\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in earnings.editScope.gjPatternDropdown\" ng-change=\"earnings.changeGjKtPat4(1);\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"earnings.editForm.gj_cd_4\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in earnings.editScope.gjktSyaDropdown4 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_4\" ng-model=\"earnings.editForm.gj_tm_fm_4\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime4()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_4\" ng-model=\"earnings.editForm.gj_tm_to_4\" model-view-value=\"true\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"earnings.setGjTime4()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_4\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.gj_time_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_4\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_mae_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_4\" class=\"form-control input-sm\" ng-disabled=\"!earnings.editForm.sg_bmn_cd || earnings.creditNote\" ng-model=\"earnings.editForm.gj_time_ato_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td></tr></tbody></table></div><div class=\"col-md-12\"><div class=\"well\" style=\"font-size:90%;padding-top:0;height:75px\" ng-if=\"earnings.editScope.printShow\"><div class=\"row\"><div class=\"col-xs-1\"><span style=\"font-size:80%;\">プリント</span> <input type=\"checkbox\" ng-model=\"earnings.editForm.print_fl\" ng-true-value=\"1\" ng-false-value=\"0\"></div><div class=\"col-xs-7\"><table><tr><td style=\"width:300px;text-align:top;\"><span style=\"font-size:75%;width:90px;height:25px\">納品日時</span><div class=\"form-inline\"><div class=\"form-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.print_nh_dt\" name=\"ju_day\" bs-datepicker=\"\" placeholder=\"年月日\" data-autoclose=\"false\" style=\"font-size:85%;width:115px;height:25px;\" ng-disabled=\"!earnings.editForm.print_fl\"></div><div class=\"form-group\"><input class=\"form-control input-sm\" size=\"8\" ng-model=\"earnings.editForm.print_nh_dt\" name=\"print_nh_dt_tm\" bs-timepicker=\"\" data-autoclose=\"false\" placeholder=\"時間\" data-time-format=\"HH:mm\" data-length=\"1\" data-minute-step=\"1\" data-arrow-behavior=\"picker\" type=\"text\" style=\"font-size:85%;width:60px;height:25px;\" ng-disabled=\"!earnings.editForm.print_fl\"></div></div><input type=\"text\" class=\"form-control input-sm\" placeholder=\"補足\" style=\"font-size:90%;width:180px;height:25px\" ng-model=\"earnings.editForm.nh_hosoku\" ng-disabled=\"!earnings.editForm.print_fl\"></td><td style=\"width:250px\"><div class=\"input-group\" style=\"font-size:90%;\"><label style=\"font-weight: normal;\" ng-repeat=\"status in earnings.editScope.printStatus1\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"earnings.editForm.nh_kb\" value=\"{{status.id}}\" ng-disabled=\"!earnings.editForm.print_fl\">&nbsp;&nbsp;</label></div></td></tr></table></div><div class=\"col-xs-4\" style=\"font-size:90%;\"><label style=\"font-size:75%;height:25px\">原版</label><div class=\"input-group\"><label style=\"font-weight: normal;\" ng-repeat=\"status in earnings.editScope.printStatus2\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"earnings.editForm.genban_kb\" value=\"{{status.id}}\" ng-disabled=\"!earnings.editForm.print_fl\">&nbsp;&nbsp;</label></div></div></div></div></div></div><div class=\"row\" ng-if=\"!earnings.editScope.printShow\"><div class=\"col-md-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-include=\"\'app/business-earnings/editmode.html\'\"></div><table class=\"table table-bordered table-striped fit\"><thead class=\"fit\"><tr class=\"active\"><th>メモ</th></tr></thead><tbody class=\"fit\"><tr><td><textarea type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurMemo\"></textarea></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><span ng-if=\"earnings.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span><br><span ng-if=\"earnings.editScope.sgkyItems.length == 0\" class=\"text-danger pull-left\">※1件以上は作業項目の登録が必要です</span><br><p class=\"text-left\" style=\"font-size:90%\">※作業項目コードが入力されていない行のデータは登録されません<br></p></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();earnings.editScope.cancel(earnings.editScope.editMode)\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-earnings/editmode.html","<div disable-all=\"earnings.isFromDisabled || earnings.isEditDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th colspan=\"3\" style=\"width:40%\">作業項目コード/作業内容</th><th style=\"width:15%\">時間/プリント</th><th colspan=\"3\" style=\"width:20%\">数量１/数量２/予定原価</th><th style=\"width:10%\">単価</th><th style=\"width:10%\">金額</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"earnings.editScope.tableExtend()\" ng-disabled=\"earnings.isFromDisabled || earnings.creditNote\">行追加</button></th></tr><tr class=\"active\" ng-if=\"!earnings.editForm.print_fl\"><th colspan=\"9\">補足説明</th></tr><tr class=\"active\" ng-if=\"earnings.editForm.print_fl\"><th colspan=\"2\">DBコード/原版No.</th><th colspan=\"3\">サブタイトル/秒数</th><th colspan=\"3\">補足説明</th><th>テープNo.</th></tr></thead><tbody ng-if=\"earnings.editScope.sgkyItems.length == 0\"><tr><td colspan=\"10\" style=\"height:245px\"></td></tr><tr></tr></tbody><tbody ng-repeat=\"item in earnings.editScope.sgkyItems\" class=\"fit\" disable-all=\"earnings.isFromDisabled || earnings.isEditDisabled\"><tr><td rowspan=\"2\" style=\"width:5%\">{{ $index+1 }} <input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].gyo_no\" ng-init=\"earnings.editForm.sgurDtl[$index].gyo_no = $index+1\"></td><td style=\"width:10%\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_item_cd = item.sg_item_cd\" disable-all=\"earnings.creditNote\"><div class=\"input-group\"><span class=\"input-group-addon mini-addon\" ng-if=\"!earnings.isFromDisabled && !earnings.isEditDisabled\"><input type=\"checkbox\" class=\"form-control input-sm keitai-select\" ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"item.inputChange\" ng-init=\"item.inputChange=true\" bs-tooltip=\"earnings.editTooltipText3\"></span><div angucomplete-alt=\"\" ng-if=\"!earnings.isFromDisabled && !earnings.isEditDisabled && !item.inputChange\" maxlength=\"8\" placeholder=\"直接入力\" pause=\"500\" selected-object=\"earnings.editScope.sgItemSelected\" remote-api-handler=\"earnings.editScope.sgItemApiSearch\" title-field=\"sg_item_cd\" description-field=\"sg_item_nm\" minlength=\"3\" field-required=\"true\" initial-value=\"item.sg_item_cd\" input-class=\"form-control form-control-small input-sm\"></div><sg-item sg-ktcd=\"{{earnings.editForm.sg_keitai_cd}}\" ng-if=\"!earnings.isFromDisabled && !earnings.isEditDisabled && item.inputChange\"></sg-item></div><input type=\"text\" ng-model=\"item.sg_item_cd\" ng-if=\"earnings.isFromDisabled || earnings.isEditDisabled\" required=\"\"></td><td colspan=\"2\" disable-all=\"earnings.creditNote\"><input type=\"text\" ng-if=\"!item.sg_item_nms\" ng-model=\"earnings.editForm.sgurDtl[$index].sg_item_nm\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_item_nm = item.sg_item_nm\" required=\"\"> <input type=\"text\" ng-if=\"item.sg_item_nms\" ng-model=\"earnings.editForm.sgurDtl[$index].sg_item_nm\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_item_nm = item.sg_item_nms\" required=\"\"><input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].sg_item_cd\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_item_cd = item.sg_item_cd\" required=\"\"> <input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].sg_bunrui_cd\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_bunrui_cd = item.sg_bunrui_cd\"></td><td ng-if=\"item.time_fl == 0 && earnings.editForm.sgurDtl[$index].sg_bunrui_cd == \'06\'\" disable-all=\"earnings.creditNote\"><div class=\"btn-group inline\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"earnings.editForm.sgurDtl[$index].media_cd_1 = item.media_cd_1\" ng-model=\"earnings.editForm.sgurDtl[$index].media_cd_1\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.mediaDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default space-btn\">⇒</button> <button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"earnings.editForm.sgurDtl[$index].media_cd_2 = item.media_cd_2\" ng-model=\"earnings.editForm.sgurDtl[$index].media_cd_2\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.mediaDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></div></td><td ng-if=\"item.time_fl == 1 && earnings.editForm.sgurDtl[$index].sg_bunrui_cd != \'06\'\" style=\"min-width:105px;\"><input type=\"text\" class=\"form-control input-sm\" name=\"stt_tm\" ng-init=\"earnings.editForm.sgurDtl[$index].stt_tm = item.stt_tm\" ng-model=\"earnings.editForm.sgurDtl[$index].stt_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"earnings.setSgTimeColumn($index)\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" name=\"end_tm\" ng-init=\"earnings.editForm.sgurDtl[$index].end_tm= item.end_tm\" ng-model=\"earnings.editForm.sgurDtl[$index].end_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"earnings.setSgTimeColumn($index)\" required=\"\"></td><td ng-if=\"!earnings.editForm.sgurDtl[$index].sg_item_cd && earnings.editForm.sgurDtl[$index].sg_bunrui_cd == \'06\'\" \"=\"\">&nbsp;</td><td ng-if=\"(item.time_fl == 0 || !item.time_fl) && ( earnings.editForm.sgurDtl[$index].sg_bunrui_cd != \'06\' || !earnings.editForm.sgurDtl[$index].sg_bunrui_cd )\">&nbsp;</td><td ng-init=\"earnings.editForm.sgurDtl[$index].suryo_1 = changeNumberType(item.suryo_1, \'parseFloat\')\" style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_1\" ng-model=\"earnings.editForm.sgurDtl[$index].suryo_1\" model-format=\"number\" ng-blur=\"earnings.changeSuryo($index)\" formatter=\"formatitem($modelValue,$filter, \'0.0\', item.tani_1 );\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" ng-if=\"!item.tani_1\" ng-model=\"earnings.editForm.sgurDtl[$index].suryo_1\" model-format=\"float\" ng-blur=\"earnings.changeSuryo($index)\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\" required=\"\"></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-init=\"earnings.editForm.sgurDtl[$index].suryo_2 = changeNumberType(item.suryo_2, \'parseFloat\')\" ng-if=\"item.tani_2\" ng-model=\"earnings.editForm.sgurDtl[$index].suryo_2\" model-format=\"float\" ng-blur=\"earnings.changeSuryo($index)\" formatter=\"formatitem($modelValue,$filter,\'0.0\', item.tani_2 );\" required=\"\"> <span ng-if=\"!item.tani_2\">&nbsp;</span></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.genka_fl == 1\" ng-model=\"earnings.editForm.sgurDtl[$index].genka\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\"> <span ng-if=\"item.genka_fl != 1\">&nbsp;</span></td><td><span ng-if=\"!item.tanka\" ng-init=\"earnings.editForm.sgurDtl[$index].tanka = changeNumberType(item.base_tanka, \'parseFloat\')\"></span> <span ng-if=\"item.tanka\" ng-init=\"earnings.editForm.sgurDtl[$index].tanka = changeNumberType(item.tanka, \'parseFloat\')\"></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.sgurDtl[$index].tanka\" model-format=\"number\" ng-blur=\"earnings.changeTanka($index)\" required=\"\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-init=\"earnings.editForm.sgurDtl[$index].kin = changeNumberType(item.kin, \'parseFloat\')\" ng-model=\"earnings.editForm.sgurDtl[$index].kin\" model-format=\"number\" required=\"\"></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"earnings.editScope.tableCellDelete($index)\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled || earnings.creditNote\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"earnings.editScope.tableRowCopy($index)\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled || earnings.creditNote\">行複写</button></td></tr><tr ng-if=\"!earnings.editForm.print_fl || (earnings.editForm.print_fl && earnings.editForm.sgurDtl[$index].sg_bunrui_cd != \'06\')\"><td colspan=\"9\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurDtl[$index].hosoku\" ng-init=\"earnings.editForm.sgurDtl[$index].hosoku = item.hosoku\"></td></tr><tr ng-if=\"earnings.editForm.print_fl && earnings.editForm.sgurDtl[$index].sg_bunrui_cd == \'06\'\"><td colspan=\"2\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default db-btn\" ng-init=\"earnings.editForm.sgurDtl[$index].db_cd_kb = item.db_cd_kb\" ng-model=\"earnings.editForm.sgurDtl[$index].db_cd_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.printStatus3\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.sgurDtl[$index].db_cd\" ng-init=\"earnings.editForm.sgurDtl[$index].db_cd = item.db_cd\"></div></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" placeholder=\"サブタイトル\" ng-model=\"earnings.editForm.sgurDtl[$index].sub_title\" ng-init=\"earnings.editForm.sgurDtl[$index].sub_title = item.sub_title\"></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"earnings.editForm.sgurDtl[$index].sec\" style=\"width:35px\" ng-init=\"earnings.editForm.sgurDtl[$index].sec = item.sec\"><div class=\"input-group-btn\" ng-init=\"earnings.editForm.sgurDtl[$index].sec_tani_kb = item.sec_tani_kb\"><button type=\"button\" class=\"btn btn-default ss-btn\" ng-model=\"earnings.editForm.sgurDtl[$index].sec_tani_kb\" placeholder=\"-\" bs-options=\"item.id as item.name for item in earnings.editScope.printUnit\" bs-select=\"\"><span class=\"caret\"></span></button></div></div></td><td colspan=\"3\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurDtl[$index].hosoku\" ng-init=\"earnings.editForm.sgurDtl[$index].hosoku = item.hosoku\"></td><td><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurDtl[$index].tape_no\" ng-init=\"earnings.editForm.sgurDtl[$index].tape_no = item.tape_no\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-earnings/modal2.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">機能選択</h4></div><div class=\"modal-body\"><h6>機能を選択してください</h6><p>新規に作成した受注の作業売上として登録する</p><a ui-sref=\"app.business-orders({param:{juno:earnings.editForm.ju_no,sgno:earnings.editForm.sg_no}})\" ng-click=\"$hide();earnings.hideEdit()\" class=\"btn btn-info btn-sm\" style=\"width:100px\">受注No.変更</a><p>既存の別の受注に作業売上として追加する</p><button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$hide();earnings.changeSgJuNo()\">作業No.追加</button></div></div></div></div>");
$templateCache.put("app/business-earnings/newmode.html","<div disable-all=\"earnings.isFromDisabled || earnings.isEditDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th colspan=\"3\" style=\"width:40%\">作業項目コード/作業内容</th><th style=\"width:15%\">時間/プリント</th><th colspan=\"3\" style=\"width:20%\">数量１/数量２/予定原価</th><th style=\"width:10%\">単価</th><th style=\"width:10%\">金額</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"earnings.editScope.tableExtend()\" ng-disabled=\"earnings.isFromDisabled\">行追加</button></th></tr><tr class=\"active\" ng-if=\"!earnings.editForm.print_fl\"><th colspan=\"9\">補足説明</th></tr><tr class=\"active\" ng-if=\"earnings.editForm.print_fl\"><th colspan=\"2\">DBコード/原版No.</th><th colspan=\"3\">サブタイトル/秒数/SHOW時間</th><th colspan=\"3\">補足説明</th><th>テープNo.</th></tr></thead><tbody ng-if=\"!earnings.editScope.sgkyItems\"><tr><td colspan=\"10\" style=\"height:245px\"></td></tr><tr></tr></tbody><tbody ng-repeat=\"item in earnings.editScope.sgkyItems\" class=\"fit\" disable-all=\"earnings.isFromDisabled || earnings.isEditDisabled\"><tr><td rowspan=\"2\" style=\"width:5%\">{{ $index+1 }} <input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].gyo_no\" ng-init=\"earnings.editForm.sgurDtl[$index].gyo_no = $index+1\"></td><td>{{ earnings.editForm.sgurDtl[$index].kmk_nm }} <input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].kmk_nm\" ng-init=\"earnings.editForm.sgurDtl[$index].kmk_nm = item.kmk_nm\"><sg-item ng-model=\"item.sg_item_cd\" sg-ktcd=\"{{earnings.editForm.sg_keitai_cd}}\" ng-if=\"!earnings.isFromDisabled && !earnings.isEditDisabled\"></sg-item><input type=\"text\" ng-model=\"item.sg_item_cd\" ng-if=\"earnings.isFromDisabled || earnings.isEditDisabled\"></td><td colspan=\"2\">{{ item.sg_item_nm }} <input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].sg_item_cd\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_item_cd = item.sg_item_cd\"> <input type=\"hidden\" ng-model=\"earnings.editForm.sgurDtl[$index].sg_bunrui_cd\" ng-init=\"earnings.editForm.sgurDtl[$index].sg_bunrui_cd = item.sg_bunrui_cd\"></td><td ng-if=\"item.time_fl == 0 && earnings.editForm.sgurDtl[$index].sg_bunrui_cd == \'06\'\"><div class=\"btn-group inline\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"earnings.editForm.sgytDtl[$index].media_cd_1 = item.media_cd_1\" ng-model=\"earnings.editForm.sgytDtl[$index].media_cd_1\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default space-btn\">⇒</button> <button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"earnings.editForm.sgytDtl[$index].media_cd_2 = item.media_cd_2\" ng-model=\"earnings.editForm.sgytDtl[$index].media_cd_2\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td ng-if=\"item.time_fl == 1 && earnings.editForm.sgurDtl[$index].sg_bunrui_cd != \'06\'\" style=\"min-width:105px;\"><input type=\"text\" class=\"form-control input-sm\" name=\"stt_tm\" ng-init=\"earnings.editForm.sgurDtl[$index].stt_tm = item.stt_tm\" ng-model=\"earnings.editForm.sgurDtl[$index].stt_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"earnings.setSgTimeColumn($index)\"> <input type=\"text\" class=\"form-control input-sm\" name=\"end_tm\" ng-init=\"earnings.editForm.sgurDtl[$index].end_tm= item.end_tm\" ng-model=\"earnings.editForm.sgurDtl[$index].end_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"earnings.setSgTimeColumn($index)\"></td><td ng-if=\"(item.time_fl == 0 || !item.time_fl) && ( earnings.editForm.sgurDtl[$index].sg_bunrui_cd != \'06\' || !earnings.editForm.sgurDtl[$index].sg_bunrui_cd )\"></td><td ng-init=\"earnings.editForm.sgurDtl[$index].suryo_1 = changeNumberType(item.suryo_1, \'parseFloat\')\" style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_1\" ng-model=\"earnings.editForm.sgurDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\', item.tani_1 );\"> <input type=\"text\" class=\"form-control input-sm\" ng-if=\"!item.tani_1\" ng-model=\"earnings.editForm.sgurDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\"></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-init=\"earnings.editForm.sgurDtl[$index].suryo_2 = changeNumberType(item.suryo_2, \'parseFloat\')\" ng-if=\"item.tani_2\" ng-model=\"earnings.editForm.sgurDtl[$index].suryo_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', item.tani_2 );\"> <span ng-if=\"!item.tani_2\">&nbsp;</span></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.genka_fl == 1\" ng-model=\"earnings.editForm.sgurDtl[$index].genka\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\"> <span ng-if=\"item.genka_fl != 1\">&nbsp;</span></td><td><input type=\"text\" class=\"form-control input-sm\" ng-init=\"earnings.editForm.sgurDtl[$index].tanka = changeNumberType(item.tanka, \'parseFloat\')\" ng-model=\"earnings.editForm.sgurDtl[$index].tanka\" model-format=\"number\" ng-blur=\"earnings.changeTanka($index)\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-init=\"earnings.editForm.sgurDtl[$index].kin = changeNumberType(item.kin, \'parseFloat\')\" ng-model=\"earnings.editForm.sgurDtl[$index].kin\" model-format=\"number\"></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"earnings.editScope.tableCellDelete($index)\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"earnings.editScope.tableRowCopy($index)\" ng-disabled=\"earnings.isFromDisabled || earnings.isEditDisabled\">行複写</button></td></tr><tr ng-if=\"!earnings.editForm.print_fl || (earnings.editForm.print_fl && earnings.editForm.sgurDtl[$index].sg_bunrui_cd != \'06\')\"><td colspan=\"9\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurDtl[$index].hosoku\" ng-init=\"earnings.editForm.sgurDtl[$index].hosoku = item.hosoku\"></td></tr><tr ng-if=\"earnings.editForm.print_fl && earnings.editForm.sgurDtl[$index].sg_bunrui_cd == \'06\'\"><td colspan=\"2\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"earnings.editForm.sgurDtl[$index].db_cd_kb = item.db_cd_kb\" ng-model=\"earnings.editForm.sgurDtl[$index].db_cd_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.printStatus3\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-model=\"earnings.editForm.sgurDtl[$index].db_cd\" ng-init=\"earnings.editForm.sgurDtl[$index].db_cd = item.db_cd\"></div></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" placeholder=\"サブタイトル\" ng-model=\"earnings.editForm.sgurDtl[$index].sub_title\" ng-init=\"earnings.editForm.sgurDtl[$index].sub_title = item.sub_title\"></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"earnings.editForm.sgurDtl[$index].sec\" style=\"width:60px\" ng-init=\"earnings.editForm.sgurDtl[$index].sec = item.sec\"><div class=\"input-group-btn\" ng-init=\"earnings.editForm.sgurDtl[$index].sec_tani_kb = item.sec_tani_kb\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"earnings.editForm.sgurDtl[$index].sec_tani_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in earnings.editScope.printUnit\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-init=\"earnings.editForm.sgurDtl[$index].show_time = item.show_time\" ng-model=\"earnings.editForm.sgurDtl[$index].show_time\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', \'分\');\"></div></td><td colspan=\"3\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurDtl[$index].hosoku\" ng-init=\"earnings.editForm.sgurDtl[$index].hosoku = item.hosoku\"></td><td><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"earnings.editForm.sgurDtl[$index].tape_no\" ng-init=\"earnings.editForm.sgurDtl[$index].tape_no = item.tape_no\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-orders/change-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">受注No.変更確認</h4></div><div class=\"modal-body\"><blockquote><ul class=\"list-inline\"><li>作業No.&nbsp;<span class=\"text-danger\">{{ orders.changeData.sg_no }}</span></li><li>受注No.&nbsp;{{ orders.changeData.ju_no }}</li><li>作品名:&nbsp;{{ orders.changeData.hin_nm }}</li></ul><footer>この作業伝票を</footer></blockquote><blockquote><ul class=\"list-inline\"><li>作業No.&nbsp;<span class=\"text-danger\">{{ orders.changeData.sg_no }}</span></li><li>受注No.&nbsp;{{ orders.changeTargetData.ju_no }}</li><li>作品名:&nbsp;{{ orders.changeTargetData.hin_nm }}</li></ul><footer>として、受注No変更登録します</footer></blockquote><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"$hide();orders.changeJuNoSubmit()\">実行</button></div></div></div></div></div>");
$templateCache.put("app/business-orders/completeedit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\">作品完了登録</h4></div><div class=\"col-xs-4 text-right\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"orders.completeSubmit(orders.completeData.order.ju_no)\" style=\"width:150px\" ng-disabled=\"orders.completeData.detail.length == 0\">完了登録</button></div><div class=\"col-xs-2\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body\"><form role=\"form\" name=\"completeForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><tbody><tr><td style=\"width:15%\" class=\"title\">受注No.</td><td style=\"width:15%\">{{ orders.completeData.order.ju_no }}</td><td style=\"width:10%\" class=\"title\">得意先</td><td style=\"width:30%\">{{ orders.completeData.order.toku_nm }}</td><td style=\"width:10%\" class=\"title\">担当営業</td><td>{{ orders.completeData.order.ju_tanto_nm }}</td></tr><tr><td class=\"title\">作品名</td><td colspan=\"3\">{{ orders.completeData.order.hin_nm }}</td><td class=\"title\">受注金額</td><td>{{ orders.completeData.order.ju_tanka1+orders.completeData.order.ju_tanka2+orders.completeData.order.ju_tanka3 }}</td></tr></tbody></table></div><div class=\"col-md-12\"><div id=\"scrollable-area\"><table class=\"table table-bordered fit\" style=\"min-height:200px\"><thead class=\"fit\"><tr class=\"active\"><th colspan=\"3\" style=\"width:15%\">作業日</th><th style=\"width:10%\">伝票No.</th><th style=\"width:10%\">作業部門</th><th style=\"width:10%\">業務区分</th><th colspan=\"2\" style=\"width:15%\">スタジオ</th><th colspan=\"3\" style=\"width:20%\">作業形態</th><th style=\"width:30px\">P</th><th style=\"width:15%\">作業金額合計</th></tr><tr class=\"active\"><th></th><th>No.</th><th colspan=\"4\">項目</th><th colspan=\"2\">時間/プリント</th><th colspan=\"2\" style=\"width:150px\">数量</th><th colspan=\"2\" style=\"width:150px\">単価</th><th>金額</th></tr></thead><tbody class=\"fit\" ng-repeat=\"detail in orders.completeData.detail\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr class=\"active-info text-center\"><td colspan=\"3\">{{detail.sgur.sg_day_time*1000 | date:\'yyyy/MM/dd\' }}</td><td>{{detail.sgur.sg_no}}</td><td>{{detail.sgur.bumon_nm}}</td><td>{{ orders.getGyomuName(detail.sgur.gyomu_kb) }}</td><td colspan=\"2\">{{ detail.sgur.studio_nm }}</td><td colspan=\"3\">{{ detail.sgur.sg_keitai_nm }}</td><td style=\"width:30px\"><span ng-if=\"detail.sgur.print_fl > 0\">●</span></td><td class=\"text-right\">{{detail.sgur.sg_kin | number }}</td></tr><tr ng-repeat=\"item in detail.sgurDtl\" class=\"text-center\"><td></td><td>{{ item.gyo_no }}</td><td>{{ item.sg_item_cd }}</td><td colspan=\"3\" class=\"text-left\">{{ item.sg_item_nms }}</td><td colspan=\"2\"><span ng-if=\"detail.sgur.print_fl > 0\"><span ng-if=\"item.media_cd_1 && item.media_cd_2\">{{ orders.getMediaName(item.media_cd_1) }} → {{ orders.getMediaName(item.media_cd_2) }}</span></span> <span ng-if=\"detail.sgur.print_fl == 0\"><span ng-if=\"(item.stt_tm && item.stt_tm !=\'00:00\') && (item.end_tm && item.end_tm !=\'00:00\')\">{{item.stt_tm}} ～ {{item.end_tm}}</span></span></td><td colspan=\"2\" style=\"width:100px\" class=\"text-right\"><span ng-if=\"item.suryo_kbn_2 != \'1\'\">{{ item.suryo_1 }}{{ item.tani_1 }}</span> <span ng-if=\"item.suryo_kbn_2 == \'1\'\">{{ item.suryo_1 }}{{ item.tani_1 }}/{{ item.suryo_2 }}{{ item.tani_2 }}</span></td><td colspan=\"2\" style=\"width:100px\" class=\"text-right\"><span ng-if=\"!item.tanka\">{{ item.base_tanka | number }}</span> <span ng-if=\"item.tanka\">{{ item.tanka | number }}</span></td><td class=\"text-right\">{{ item.kin | number }}</td></tr></tbody></table></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"pull-right\">合計：{{ orders.getTotalKin(orders.completeData.detail) | number }}</div></div></div></form></div><div class=\"modal-footer\"><div class=\"pull-left\" style=\"font-size:90%\">※作品完了実行で、売上登録されます。割引等の入力は売上情報で登録可能です</div><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();orders.hideComplete()\">キャンセル</button></div></div></div></div>");
$templateCache.put("app/business-orders/modal1.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">作品完了処理エラー</h4></div><div class=\"modal-body\"><h6>承認処理の行われていないデータが残っています<br>承認を行ってから作品完了処理を行ってください</h6><ul class=\"list-group\"><li class=\"list-group-item\" ng-repeat=\"item in orders.errorItems\"><span class=\"badge\">{{ item.cnt }}</span> {{ item.name }}</li></ul><p>受注No.: <input type=\"text\" value=\"{{ orders.errorJuNo }}\" readonly=\"\"></p></div></div></div></div>");
$templateCache.put("app/business-orders/modal2.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">売上確認</h4></div><div class=\"modal-body\"><h6>すでに、売上計上が行われている作品です。<br>売上一覧より確認してください。</h6><p>受注No.: <input type=\"text\" value=\"{{ orders.errorJuNo }}\" readonly=\"\"></p></div></div></div></div>");
$templateCache.put("app/business-orders/orders.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\"><div class=\"row\"><div class=\"col-md-6\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"orders.editModeInit(1);\" ng-if=\"!orders.isEditDisabled\">新規登録</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button></div></div><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.form.fromDate\" data-max-date=\"{{orders.form.untilDate}}\" placeholder=\"From\" data-autoclose=\"true\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.form.untilDate\" data-min-date=\"{{orders.form.fromDate}}\" placeholder=\"To\" data-autoclose=\"true\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.form.ju_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.form.ju_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先選択</span><div angucomplete-alt=\"\" id=\"ex2\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"orders.tokuisakiSelected\" remote-api-handler=\"orders.tokuisakiApiSearch\" title-field=\"names\" initial-value=\"orders.form.toku_cd\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作品名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"作品名\" ng-model=\"orders.form.hin_nm\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">受注部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ins_bmn_cd\" ng-model=\"orders.form.ins_bmn_cd\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.ju_tanto_nm\" placeholder=\"先に受注部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"ju_tanto_cd\" ng-model=\"orders.form.ju_tanto_cd\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.gyomuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">業務区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.gyomu_nm\" disabled=\"\"> <input type=\"hidden\" name=\"gyomu_kb\" ng-model=\"orders.form.gyomu_kb\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.workStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"orders.isChangeJuNoEditMode\">作品完了 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.fin_fl_nm\" disabled=\"\"> <input type=\"hidden\" name=\"fin_fl\" ng-model=\"orders.form.fin_fl\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.uriageStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"orders.isChangeJuNoEditMode\">売上計上 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.uriage_status\" disabled=\"\"> <input type=\"hidden\" name=\"uriage_status_fl\" ng-model=\"orders.form.uriage_status_fl\"></div></div></div><div class=\"col-md-7\"><div ng-if=\"orders.isChangeJuNoEditMode\"><span class=\"text-danger\">受注No.変更対象選択モード</span></div><div ng-if=\"dummy\">※本年から3年前までを標準出力しています。<br>※3年以上前のデータは受注日指定で検索してください</div><div>※最初に別の条件を選択し、絞り込む必要があるものがあります（例：担当営業)</div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"orders.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"orders.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\"><dir-pagination-controls on-page-change=\"orders.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"ordersPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"orders.pagination.current * orders.datasPerPage - (orders.datasPerPage -1) +\'～\'+((orders.pagination.current * orders.datasPerPage - orders.datasPerPage) + orders.datas.length) +\'件/\'+orders.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th rowspan=\"3\" style=\"width:15px\">#</th><th rowspan=\"3\" style=\"width:80px\">受注日</th><th>得意先名</th><th>業務区分</th><th>受注部門</th><th>受注No.</th></tr><tr class=\"active\"><th colspan=\"2\">作品名</th><th>担当営業</th><th>受注金額</th></tr><tr class=\"active\"><th colspan=\"5\">各種操作/状態</th></tr></thead><tbody dir-paginate=\"item in orders.datas | itemsPerPage: orders.datasPerPage\" pagination-id=\"ordersPaginate\" total-items=\"orders.totalDatas\" current-page=\"orders.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"3\" class=\"text-center\">{{ ($index + 1) + (orders.pagination.current - 1) * orders.datasPerPage }}</td><td rowspan=\"3\">{{ item.ju_day_time * 1000 | date }}</td><td>{{ item.toku_nm }}</td><td>{{ orders.getGyomuName(item.gyomu_kb) }}</td><td>{{ item.ju_bumon_nm }}</td><td><span><span ng-if=\"!orders.isChangeJuNoEditMode\">{{ item.ju_no }}</span> <span ng-if=\"orders.isChangeJuNoEditMode\"><a href=\"\" ng-click=\"orders.changeJuNo(item);\" bs-tooltip=\"\'この受注Noを選択\'\">{{ item.ju_no }}</a></span> <a ui-sref=\"app.business-planning({param:{ju_no:item.ju_no}})\" type=\"button\" class=\"btn btn-info btn-xs mini-button\" bs-tooltip=\"\'この受注の作業予定一覧\'\" ng-disabled=\"orders.isChangeJuNoEditMode\">予</a> <a ui-sref=\"app.business-report({juno:\'000\',sgno:\'000\',param:{ju_no:item.ju_no}})\" type=\"button\" class=\"btn btn-primary btn-xs mini-button\" bs-tooltip=\"\'この受注の作業報告一覧\'\" ng-disabled=\"orders.isChangeJuNoEditMode\">報</a> <a ui-sref=\"app.business-earnings({juno:\'000\',param:{ju_no:item.ju_no}})\" type=\"button\" class=\"btn btn-success btn-xs mini-button\" bs-tooltip=\"\'この受注の作業売上一覧\'\" ng-disabled=\"orders.isChangeJuNoEditMode\">売</a></span></td></tr><tr><td colspan=\"2\">{{ item.hin_nm }}</td><td>{{ item.ju_tanto_nm }}</td><td>{{ item.ju_tanka1 + item.ju_tanka2 + item.ju_tanka3 }}</td></tr><tr><td colspan=\"3\" style=\"border-right:none\"><a type=\"button\" style=\"width:100px\" class=\"btn btn-warning btn-xs\" ng-click=\"orders.editModeInit(2, item.ju_no);\" ng-disabled=\"orders.isEditDisabled || orders.isChangeJuNoEditMode\" bs-tooltip=\"orders.editTooltip1\">受注編集</a> <a ui-sref=\"app.business-planning({juno:item.ju_no})\" ng-if=\"!item.fin_fl || item.fin_fl == 0\" type=\"button\" style=\"width:100px\" class=\"btn btn-info btn-xs\" a-disabled=\"orders.isEditDisabled || orders.isChangeJuNoEditMode\" bs-tooltip=\"orders.editTooltip2\">新規作業予定</a><a href=\"\" ng-click=\"orders.worksComplete(item.ju_no);\" type=\"button\" style=\"width:100px\" class=\"btn btn-primary btn-xs\" ng-if=\"!item.fin_fl || item.fin_fl == 0\" ng-disabled=\"orders.isEditDisabled || orders.isChangeJuNoEditMode\" bs-tooltip=\"orders.editTooltip4\">作品完了登録</a> <a href=\"\" ng-click=\"orders.addUriage(item.ju_no);\" ng-if=\"item.fin_fl == 1 && !item.nh_no\" type=\"button\" style=\"width:100px\" class=\"btn btn-danger btn-xs\" ng-disabled=\"orders.isEditDisabled || orders.isChangeJuNoEditMode\" bs-tooltip=\"orders.editTooltip5\">新規売上登録</a></td><td style=\"border-left:none\"><span style=\"font-size:10px\">状態</span> <span ng-if=\"item.fin_fl == 1\" class=\"label label-success label-mini\">作品完了</span> <span ng-if=\"item.fin_fl != 1\" class=\"label label-primary label-mini\">未完作品</span> <span ng-if=\"item.nh_no\" class=\"label label-success label-mini\">売上計上</span> <span ng-if=\"!item.nh_no\" class=\"label label-primary label-mini\">売上未計上</span></td></tr></tbody></table></div><div class=\"text-center\"><dir-pagination-controls on-page-change=\"orders.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"ordersPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"orders.pagination.current * orders.datasPerPage - (orders.datasPerPage -1) +\'～\'+((orders.pagination.current * orders.datasPerPage - orders.datasPerPage) + orders.datas.length) +\'件/\'+orders.totalDatas+\'件\'\"></span></div>");
$templateCache.put("app/business-orders/ordersedit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\" ng-if=\"orders.editScope.editMode == 1\">受注新規登録<small ng-if=\"orders.juNoChangeMode\">&nbsp;(作業売上受注No変更処理)</small></h4><h4 class=\"modal-title text-center\" ng-if=\"orders.editScope.editMode == 2\">受注編集</h4></div><div class=\"col-xs-4 text-right\" ng-if=\"orders.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"orders.editScope.cancel(1)\">クリア</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"orders.editScope.orderSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"ordersForm.$invalid\">登録</button></div><div class=\"col-xs-4 text-right\" ng-if=\"orders.editScope.editMode == 2\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"orders.editScope.orderSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"orders.isFromDisabled || ordersForm.$invalid || orders.isEditDisabled\">変更</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"orders.editScope.oderDelete()\" style=\"width:80px\" ng-disabled=\"orders.isFromDisabled || orders.isEditDisabled\">削除</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"orders.completeSubmitCancel(orders.editForm.ju_no)\" ng-if=\"orders.editForm.fin_fl == \'1\'\">作品完了取消</button></div><div class=\"col-xs-2\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit\" disable-all=\"orders.isFromDisabled || orders.isEditDisabled\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"form-group col-xs-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.editForm.ju_no\" name=\"ju_no\" disabled=\"\"></div></div><div class=\"form-group col-xs-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.editForm.ju_day\" name=\"ju_day\" data-autoclose=\"true\" ng-required=\"true\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"1000\" selected-object=\"orders.editScope.tokuisakiSelected\" remote-api-handler=\"orders.editScope.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\" required=\"\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-7\"><table class=\"table table-hover table-bordered\"><tbody><tr style=\"height:65px\"><td colspan=\"2\">{{ orders.editScope.item.toku_nm}}<br><input type=\"text\" name=\"toku_bumon_nm\" class=\"form-control input-sm\" ng-model=\"orders.editForm.toku_bumon_nm\"> <input type=\"hidden\" name=\"toku_cd\" class=\"form-control input-sm\" ng-model=\"orders.editForm.toku_cd\" ng-required=\"true\"></td></tr><tr style=\"height:60px\"><td colspan=\"2\">{{ orders.editScope.item.adrs1}}<br>{{ orders.editScope.item.adrs2}}</td></tr><tr style=\"height:30px\"><td style=\"border-right-style:none;\">TEL: {{ orders.editScope.item.tel_no}}</td><td style=\"border-left-style:none;\">FAX: {{ orders.editScope.item.fax_no}}</td></tr><tr style=\"height:30px\"><td style=\"border-right-style:none;\">締日: {{ orders.editScope.item.shime_dd_nm}} <span ng-if=\"orders.editScope.item.sk_shime_dd_nm\">({{ orders.editScope.item.sk_shime_dd_nm }})</span></td><td style=\"border-left-style:none;\">請求: {{ orders.editScope.item.sk_tani_nm}}</td></tr></tbody></table></div><div class=\"col-xs-5\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.editScope.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">受注部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.editScope.item.ju_bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ju_bumon_cd\" ng-model=\"orders.editForm.ju_bumon_cd\" required=\"\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.editScope.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"先に受注部門を選択\" ng-model=\"orders.editScope.item.ju_tanto_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ju_tanto_cd\" ng-model=\"orders.editForm.ju_tanto_cd\" required=\"\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"orders.editScope.gyomuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">業務区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.editScope.item.gyomu_nm\" disabled=\"\"> <input type=\"hidden\" name=\"gyomu_kb\" ng-model=\"orders.editForm.gyomu_kb\" required=\"\"></div></div><div class=\"form-group\"><br><div class=\"input-group\"><span class=\"input-group-addon input-sm\">顧客担当</span> <input type=\"text\" name=\"toku_tanto_nm\" class=\"form-control input-sm\" ng-model=\"orders.editForm.toku_tanto_nm\"></div></div></div></div><div class=\"row\"><hr><div class=\"col-xs-12\"><div class=\"col-xs-12\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm on-width\">作品名</span> <input type=\"text\" name=\"hin_nm\" class=\"form-control input-sm\" ng-model=\"orders.editForm.hin_nm\" ng-required=\"true\"></div><div class=\"input-group\"><span class=\"input-group-addon input-sm on-width\">サブタイトル</span> <input type=\"text\" name=\"hin_sm\" class=\"form-control input-sm\" ng-model=\"orders.editForm.hin_sm\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" style=\"width:120px\" bs-dropdown=\"orders.editScope.studioDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">希望スタジオ <span class=\"caret\"></span></button></span> <input type=\"text\" style=\"width:200px\" class=\"form-control input-sm\" ng-model=\"orders.editScope.item.studio_nm\" disabled=\"\"> <input type=\"hidden\" name=\"studio_cd\" ng-model=\"orders.editForm.studio_cd\"> <span class=\"input-group-addon input-sm on-width\">外部関係者</span><div angucomplete-alt=\"\" initial-value=\"orders.editScope.item.gaibu_nm\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"1000\" selected-object=\"orders.editScope.gaibukanekiSelected\" remote-api-handler=\"orders.editScope.gaibukankeiApiSearch\" title-field=\"gaibu_nm\" description-field=\"gaibu_cd\" auto-match=\"true\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"><input type=\"hidden\" name=\"gaibu_cd\" ng-model=\"orders.editForm.gaibu_cd\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-12\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm on-width\">メモ</span> <input type=\"text\" name=\"memo\" class=\"form-control input-sm\" ng-model=\"orders.editForm.memo\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><label class=\"control-label\">受注金額</label><br><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm on-width\">単価</span> <input type=\"text\" name=\"ju_tanka1\" class=\"form-control input-sm\" ng-model=\"orders.editForm.ju_tanka1\" style=\"width:200px\"></div><div class=\"input-group\"><span class=\"input-group-addon input-sm on-width\">ロックアウト</span> <input type=\"text\" name=\"ju_tanka2\" class=\"form-control input-sm\" ng-model=\"orders.editForm.ju_tanka2\" style=\"width:200px\"></div><div class=\"input-group\"><span class=\"input-group-addon input-sm on-width\">総額</span> <input type=\"text\" name=\"ju_tanka3\" class=\"form-control input-sm\" ng-model=\"orders.editForm.ju_tanka3\" style=\"width:200px\"></div></div></div></div></div><div class=\"col-xs-6\"><div class=\"form-group col-xs-6 bottom-column\"><div class=\"input-group\"><span>作品完了 :</span> <label ng-repeat=\"status in orders.editScope.workStatus\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"orders.editForm.fin_fl\" value=\"{{status.id}}\" disabled=\"\">&nbsp;&nbsp;</label></div></div><div class=\"form-group col-xs-6 bottom-column\"><div class=\"input-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">完了日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"orders.editForm.fin_day\" name=\"fin_day\" bs-datepicker=\"\" disabled=\"\"></div></div></div></div></div><div class=\"col-xs-12\"></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-8\"><span ng-if=\"orders.juNoChangeMode\" class=\"text-danger pull-left\">作業No.[&nbsp;{{orders.lead_sg_no}}&nbsp;]のデータがここで新規作成される受注の受注Noに置き換わります</span> <span ng-if=\"orders.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide()\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-orders/selectModal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"orders.hideSelect()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">続けて作業予定を入力しますか？</h4></div><div class=\"modal-body\"><a ui-sref=\"app.business-planning({juno:orders.link_ju_no})\" ng-click=\"$hide()\">作業予定を入力する</a></div></div></div></div>");
$templateCache.put("app/business-orders/uriageedit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\" disable-all=\"orders.uriageFlg\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\">売上入力</h4></div><div class=\"col-xs-4 text-right\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"orders.uriageSubmit(orders.uriageData.order.ju_no)\" style=\"width:150px\" ng-disabled=\"orders.uriageData.detail.length == 0\">売上登録</button></div><div class=\"col-xs-2\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body\"><form role=\"form\" name=\"completeForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><tbody><tr><td style=\"width:15%\" class=\"title\">受注No.</td><td style=\"width:15%\">{{ orders.uriageData.order.ju_no }}</td><td style=\"width:10%\" class=\"title\">得意先</td><td style=\"width:30%\">{{ orders.uriageData.order.toku_nm }}</td><td style=\"width:10%\" class=\"title\">担当営業</td><td>{{ orders.uriageData.order.ju_tanto_nm }}</td></tr><tr><td class=\"title\">作品名</td><td colspan=\"3\">{{ orders.uriageData.order.hin_nm }}</td><td class=\"title\">受注金額</td><td>{{ orders.uriageData.order.ju_tanka1+orders.uriageData.order.ju_tanka2+orders.uriageData.order.ju_tanka3 }}</td></tr></tbody></table><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th>基準売上額</th><th>値引き額</th><th>実質売上額</th><th>消費税額</th><th>合計</th><th></th><th>値引率</th><th>値引理由</th></tr></thead><tbody class=\"fit\"><tr><td class=\"title\">{{ orders.uriageForm.kj_ur_kin | number }}</td><td class=\"title\">{{ orders.uriageForm.nebiki_kin | number }}</td><td><input type=\"text\" ng-model=\"orders.uriageForm.jt_ur_kin\"></td><td class=\"title\">{{ orders.uriageForm.zei_kin | number }}</td><td class=\"title\">{{ orders.uriageForm.goukei | number }}</td><td></td><td>{{ orders.uriageForm.nebiki_ritu | number }}</td><td><input type=\"text\" ng-model=\"orders.uriageForm.nebiki_riyu\"></td></tr></tbody></table></div><div class=\"col-md-12\"><div id=\"scrollable-area\"><table class=\"table table-bordered fit\" style=\"min-height:200px\"><thead class=\"fit\"><tr class=\"active\"><th colspan=\"3\" style=\"width:15%\">作業日</th><th style=\"width:10%\">伝票No.</th><th style=\"width:10%\">作業部門</th><th style=\"width:10%\">業務区分</th><th colspan=\"2\" style=\"width:15%\">スタジオ</th><th colspan=\"3\" style=\"width:20%\">作業形態</th><th style=\"width:30px\">P</th><th style=\"width:15%\">作業金額合計</th></tr><tr class=\"active\"><th></th><th>No.</th><th colspan=\"4\">項目</th><th colspan=\"2\">時間/プリント</th><th colspan=\"2\" style=\"width:150px\">数量</th><th colspan=\"2\" style=\"width:150px\">単価</th><th>金額</th></tr></thead><tbody class=\"fit\" ng-repeat=\"detail in orders.uriageData.detail\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr class=\"active-info text-center\"><td colspan=\"3\">{{detail.sgur.sg_day_time*1000 | date:\'yyyy/MM/dd\' }}</td><td>{{detail.sgur.sg_no}}</td><td>{{detail.sgur.bumon_nm}}</td><td>{{ orders.getGyomuName(detail.sgur.gyomu_kb) }}</td><td colspan=\"2\">{{ detail.sgur.studio_nm }}</td><td colspan=\"3\">{{ detail.sgur.sg_keitai_nm }}</td><td style=\"width:30px\"><span ng-if=\"detail.sgur.print_fl > 0\">●</span></td><td class=\"text-right\">{{detail.sgur.sg_kin | number }}</td></tr><tr ng-repeat=\"item in detail.sgurDtl\" class=\"text-center\"><td></td><td>{{ item.gyo_no }}</td><td>{{ item.sg_item_cd }}</td><td colspan=\"3\" class=\"text-left\">{{ item.sg_item_nm }}</td><td colspan=\"2\"><span ng-if=\"detail.sgur.print_fl > 0\"><span ng-if=\"item.media_cd_1 && item.media_cd_2\">{{ orders.getMediaName(item.media_cd_1) }} → {{ orders.getMediaName(item.media_cd_2) }}</span></span> <span ng-if=\"detail.sgur.print_fl == 0\"><span ng-if=\"(item.stt_tm && item.stt_tm !=\'00:00\') && (item.end_tm && item.end_tm !=\'00:00\')\">{{item.stt_tm}} ～ {{item.end_tm}}</span></span></td><td colspan=\"2\" style=\"width:100px\" class=\"text-right\"><span ng-if=\"item.suryo_1 && (item.suryo_2 != 0.0 && item.suryo_2 != 0)\">{{ item.suryo_2 }} {{ item.tani_2 }}</span> <span ng-if=\"item.suryo_1 && (item.suryo_2 == 0.0 || item.suryo_2 == 0)\">{{ item.suryo_1 }} {{ item.tani_1 }}</span></td><td colspan=\"2\" style=\"width:100px\" class=\"text-right\"><span ng-if=\"!item.tanka\">{{ item.base_tanka | number }}</span> <span ng-if=\"item.tanka\">{{ item.tanka | number }}</span></td><td class=\"text-right\">{{ item.kin | number }}</td></tr></tbody></table></div></div></div></form></div><div class=\"modal-footer\"><div class=\"pull-left\" style=\"font-size:90%\">※作品完了実行で、売上登録されます。割引等の入力は売上情報で登録可能です</div><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();orders.hideComplete()\">キャンセル</button></div></div></div></div>");
$templateCache.put("app/business-expenses/comformModal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷の確認</h4></div><div class=\"modal-body\"><h5 class=\"text-center\">続けて明細印刷しますか？</h5><button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-click=\"exp.editScope.goPrint(1);$hide()\" style=\"width:80px\">印刷</button></div></div></div></div>");
$templateCache.put("app/business-expenses/editmode.html","<div disable-all=\"exp.isFromDisabled || exp.isEditDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead ng-if=\"exp.editForm.kotuhi_fl != \'1\'\"><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th colspan=\"6\" style=\"width:40%\">用途</th><th style=\"width:10%\">金額</th><th style=\"width:10%\">税区</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"exp.editScope.tableExtend()\" ng-disabled=\"exp.isFromDisabled || exp.editForm.detail.length == 0\">行追加</button></th></tr><tr class=\"active\"><th colspan=\"8\">備考</th></tr></thead><thead ng-if=\"exp.editForm.kotuhi_fl == \'1\'\"><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th colspan=\"3\" style=\"width:40%\">用途</th><th style=\"width:15%\">使用日</th><th colspan=\"2\" style=\"width:20%\">先行</th><th style=\"width:10%\">金額</th><th style=\"width:10%\">往復</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"exp.editScope.tableExtend()\" ng-disabled=\"exp.isFromDisabled || exp.editForm.detail.length == 0\">行追加</button></th></tr><tr class=\"active\"><th>交通手段</th><th>～から</th><th>～まで</th><th>退社時間</th><th colspan=\"4\">備考</th></tr></thead><tbody ng-if=\"exp.editForm.detail.length == 0\"><tr><td colspan=\"10\"><div style=\"height:245px\">&emsp;</div></td></tr><tr></tr></tbody><tbody ng-repeat=\"( key, item ) in exp.editForm.detail\" class=\"fit\" disable-all=\"exp.isFromDisabled || exp.isEditDisabled\" ng-if=\"exp.editForm.kotuhi_fl == \'1\'\"><tr><td rowspan=\"2\" style=\"width:5%\" class=\"text-center\">{{ item.gyo_no }} <input type=\"hidden\" ng-model=\"item.gyo_no\" ng-init=\"item.gyo_no = $index+1\"></td><td colspan=\"3\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" data-placement=\"top\" bs-dropdown=\"exp.editScope.keihiKamokuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{item.kamoku_nm}} <span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.siyo_day\" name=\"siyo_day\" bs-datepicker=\"\" placeholder=\"年月日\"></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm\" name=\"ikisaki\" ng-model=\"item.ikisaki\"></td><td><input type=\"text\" class=\"form-control input-sm\" name=\"kin\" ng-model=\"item.kin\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-center\"><input type=\"checkbox\" class=\"form-control input-sm custom-select\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-model=\"item.oufuku_fl\"></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"exp.editScope.tableCellDelete($index)\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"exp.editScope.tableRowCopy($index)\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled\">行複写</button></td></tr><tr><td><input type=\"text\" class=\"form-control input-sm\" name=\"shudan\" ng-model=\"item.shudan\"></td><td><input type=\"text\" class=\"form-control input-sm\" name=\"stt_chi\" ng-model=\"item.stt_chi\"></td><td><input type=\"text\" class=\"form-control input-sm\" name=\"end_chi\" ng-model=\"item.end_chi\"></td><td class=\"text-center\"><input type=\"text\" class=\"form-control input-sm\" name=\"taisya\" ng-model=\"item.taisya\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"ime-mode:disabled\" ng-blur=\"exp.setTime()\"></td><td colspan=\"4\"><input type=\"text\" class=\"form-control input-sm\" name=\"biko\" ng-model=\"item.biko\"></td></tr></tbody><tbody ng-repeat=\"(key, item) in exp.editForm.detail\" class=\"fit\" disable-all=\"exp.isFromDisabled || exp.isEditDisabled\" ng-if=\"exp.editForm.kotuhi_fl != \'1\'\"><tr><td rowspan=\"2\" style=\"width:5%\" class=\"text-center\">{{ item.gyo_no }} <input type=\"hidden\" ng-model=\"item.gyo_no\" ng-init=\"item.gyo_no = $index+1\"></td><td colspan=\"6\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" data-placement=\"top\" bs-dropdown=\"exp.editScope.keihiKamokuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{item.kamoku_nm}} <span class=\"caret\"></span></button> <input type=\"hidden\" class=\"form-control input-sm\" ng-model=\"item.kmk_cd\" required=\"\"></td><td><input type=\"text\" class=\"form-control input-sm\" name=\"kin\" ng-model=\"item.kin\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-center\">{{ item.zei_kb_nm }}</td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"exp.editScope.tableCellDelete($index)\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"exp.editScope.tableRowCopy($index)\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled\">行複写</button></td></tr><tr><td colspan=\"8\"><input type=\"text\" class=\"form-control input-sm\" name=\"biko\" ng-model=\"item.biko\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-expenses/expenses.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-show=\"exp.form\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"exp.detailFormInit(1, null)\">新規登録</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">申請日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.fromDate\" data-max-date=\"{{exp.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">申請日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.untilDate\" data-min-date=\"{{exp.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.sgFromDate\" data-max-date=\"{{exp.form.sgUntilDate}}\" placeholder=\"From\" name=\"sgFromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.sgUntilDate\" data-min-date=\"{{exp.form.sgFromDate}}\" placeholder=\"To\" name=\"sgUntilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"exp.khBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">経費分類 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.kh_bunrui_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">支払先</span><torihikisaki ng-model=\"exp.form.tori_cd\"></torihikisaki><span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.tori_nm\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">経費No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.kh_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">経費No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.kh_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.sg_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.form.sg_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"exp.futanBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">負担部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.futan_bmn_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"exp.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">申請者 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.ss_tan_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"exp.snflDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">経費承認 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.sn_fl_nm\" disabled=\"\"></div></div></div><div class=\"col-xs-7\"></div><div class=\"col-xs-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"exp.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"exp.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"exp.datas\"><dir-pagination-controls on-page-change=\"exp.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"exp.pagination.current * exp.datasPerPage - (exp.datasPerPage -1) +\'～\'+((exp.pagination.current * exp.datasPerPage - exp.datasPerPage) + exp.datas.length) +\'件/\'+exp.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"exp.datas\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th rowspan=\"2\">#</th><th style=\"width:10%\">申請日</th><th style=\"width:10%\">経費No.</th><th style=\"width:10%\">申請者</th><th style=\"width:15%\">負担部門</th><th style=\"width:15%\">支払先</th><th style=\"width:15%\">経費分類</th><th style=\"width:10%\">作業No.</th><th>合計金額</th><th>承認</th></tr></thead><tbody dir-paginate=\"item in exp.datas | itemsPerPage: exp.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"exp.totalDatas\" current-page=\"exp.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"exp.detailFormInit(2, item)\" ng-click=\"exp.detailSet(item.detail)\" style=\"cursor:pointer;\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (exp.pagination.current - 1) * exp.datasPerPage }}</td><td>{{ item.ss_day_time * 1000 | date }}</td><td><a href=\"\" ng-click=\"exp.detailFormInit(1, item)\" bs-tooltip=\"\'この経費を複写して新規登録\'\">{{ item.kh_no }}</a></td><td>{{ item.ss_tan_nm }}</td><td>{{ item.futan_bmn_nm }}</td><td><span bs-tooltip=\"item.tori_nm\">{{ item.tori_nm }}</span></td><td><span bs-tooltip=\"item.kh_bunrui_nm\">{{ item.kh_bunrui_nm }}</span></td><td>{{ item.sg_no }}</td><td>{{ item.komi_kin | number }}</td><td><span class=\"label label-danger label-mini\" ng-if=\"item.sn_fl_1 == \'0\'\">未</span> <span class=\"label label-info label-mini\" ng-if=\"item.sn_fl_1 > 0\">済</span></td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"exp.datas\"><dir-pagination-controls on-page-change=\"exp.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"exp.pagination.current * exp.datasPerPage - (exp.datasPerPage -1) +\'～\'+((exp.pagination.current * exp.datasPerPage - exp.datasPerPage) + exp.datas.length) +\'件/\'+exp.totalDatas+\'件\'\"></span></div><div class=\"col-12\"><div style=\"height:100px\"></div></div><div class=\"navbar navbar-fixed-bottom container-nav\" ng-if=\"exp.itemDetail.length > 0\"><div class=\"container\"><div class=\"list-box\"><ul class=\"list-group footer-list\"><li class=\"list-group-item\" ng-repeat=\"item in exp.itemDetail\" ng-if=\"item.biko\">{{ $index + 1}}&emsp;{{ item.biko }}</li></ul></div></div></div>");
$templateCache.put("app/business-expenses/expensesEdit.html","<div class=\"modal modal-wide modal-sgyt\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\" ng-if=\"exp.editScope.editMode == 2\"><span>経費入力編集 <small class=\"text-danger\" style=\"font-size:10px\" ng-if=\"exp.approvalUser && !exp.isFromDisabled\">&nbsp;&nbsp;承認前に変更を行った場合はまず先に変更処理を行ってください。</small></span><h4 class=\"modal-title text-center\" ng-if=\"exp.editScope.editMode == 1\">経費入力登録</h4></h4></div><div class=\"col-xs-5 text-right\" ng-if=\"exp.editScope.editMode == 2\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"exp.editScope.disApprovalSubmit()\" ng-if=\"exp.approvalUser && exp.isFromDisabled\">承認取消</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"exp.editScope.approvalSubmit()\" ng-if=\"exp.approvalUser && !exp.isFromDisabled\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled\">承認</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"exp.editScope.expensesSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled || expForm.$invalid || exp.editForm.detail.length == 0\">変更</button> <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"exp.editScope.goPrint()\">明細印刷</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"exp.editScope.expensesSubmit(\'DELETE\')\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled\">削除</button></div><div class=\"col-xs-5 text-right\" ng-if=\"exp.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"exp.editScope.expensesSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"exp.isFromDisabled || exp.isEditDisabled || expForm.$invalid || exp.editForm.detail.length == 0\">登録</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide();exp.editScope.cancel(exp.editScope.editMode)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit\" disable-all=\"exp.isFromDisabled || exp.isEditDisabled\"><form role=\"form\" name=\"expForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-8\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:65px\" class=\"title text-center\">経費伝票No.</td><td style=\"width:65px\">{{ exp.editForm.kh_no }}</td><td style=\"width:65px\" class=\"title text-center\">作業伝票No.</td><td style=\"width:70px\"><sg-hk-sr ng-model=\"exp.editForm.sg_no\" sg-no=\"{{exp.editForm.sg_no}}\"></sg-hk-sr></td><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm mini\" bs-dropdown=\"exp.editScope.futanBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:90px\" required=\"\">負担部門 <span class=\"caret\"></span></button></span> <input type=\"hidden\" class=\"form-control input-sm\" ng-model=\"exp.editForm.futan_bmn_cd\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.editForm.futan_bmn_nm\" disabled=\"\"></div></td><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm mini\" bs-dropdown=\"exp.editScope.khBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:90px\" required=\"\">経費分類 <span class=\"caret\"></span></button></span> <input type=\"hidden\" class=\"form-control input-sm\" ng-model=\"exp.editForm.kh_bunrui_cd\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.editForm.kh_bunrui_nm\" disabled=\"\"></div></td></tr></tbody></table></div><div class=\"col-md-4\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:50px\" class=\"title text-center\">申請日</td><td style=\"width:80px\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.editForm.ss_day\" name=\"ss_day\" bs-datepicker=\"\" placeholder=\"年月日\" required=\"\"></td><td style=\"width:60px\" class=\"title\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"exp.editScope.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">申請者 <span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"hidden\" class=\"form-control input-sm\" ng-model=\"exp.editForm.ss_tan_cd\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.editForm.ss_tan_nm\" disabled=\"\"></td></tr></tbody></table></div><div class=\"col-md-12\"><div style=\"height:20px\">&emsp;</div></div><div class=\"col-md-10\"><table class=\"table table-bordered fit\"><tbody class=\"fit\"><tr><td style=\"width:12%\" class=\"title text-center\">作業日</td><td style=\"width:12%\"><span ng-if=\"exp.editForm.sg_day_time > 0\">{{ exp.editForm.sg_day_time*1000 | date:\'yyyy年MM月dd日\' }}</span></td><td style=\"width:10%\" class=\"title text-center\">作業部門</td><td style=\"width:12%\">{{ exp.editForm.sg_bumon_nm }}</td><td style=\"width:10%\" class=\"title text-center\">作業形態</td><td style=\"width:12%\">{{ exp.editForm.sg_keitai_nm }}</td><td style=\"width:10%\" class=\"title text-center\">スタジオ</td><td style=\"width:12%\">{{ exp.editForm.sg_studio_nm }}</td></tr><tr><td style=\"width:10%\" class=\"title text-center\">得意先</td><td colspan=\"3\">{{ exp.editForm.sg_toku_nm }}</td><td class=\"title text-center\">作品名</td><td colspan=\"3\">{{ exp.editForm.sg_hin_nm }}</td></tr></tbody></table><table class=\"table table-bordered fit\" style=\"width:520px\" ng-if=\"exp.editScope.torihikiFlg == \'2\'\"><tbody class=\"fit\"><tr><td style=\"width:120px\" class=\"title text-center\">支払先</td><td style=\"width:400px\"><div class=\"input-group\"><torihikisaki-edit ng-model=\"exp.editForm.tori_cd\"></torihikisaki-edit><span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"exp.editForm.tori_nm\" disabled=\"\"></div></td></tr></tbody></table></div><div class=\"col-md-2\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:65px\" class=\"title text-center\">小計</td><td style=\"width:120px\" class=\"text-right\"><span>{{ exp.editForm.nuki_kin | number }}</span></td></tr><tr><td style=\"width:65px\" class=\"title text-center\">消費税</td><td style=\"width:120px\" class=\"text-right\">{{ exp.editForm.zei_kin | number }}</td></tr><tr><td style=\"width:65px\" class=\"title text-center\">合計</td><td style=\"width:120px\" class=\"text-right\">{{ exp.editForm.komi_kin | number }}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-md-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-md-12\" style=\"height:400px; overflow-y:auto;\"><div ng-include=\"\'app/business-expenses/editmode.html\'\"></div></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><span class=\"text-danger pull-left\"><small>※作業伝票No.は&nbsp;<a ui-sref=\"app.business-report({juno:\'000\',sgno:\'000\'})\" ng-click=\"$hide()\">作業報告一覧</a>&nbsp;からも選択できます</small></span> <span ng-if=\"exp.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();exp.editScope.cancel(exp.editScope.editMode)\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-planning/editmode.html","<div id=\"scrollable-area\" disable-all=\"isFromDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th style=\"width:20%\">項目</th><th colspan=\"3\" style=\"width:40%\">作業項目コード/作業内容</th><th style=\"width:15%\">プリント</th><th colspan=\"2\" style=\"width:15%\">数量１/数量２</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"planning.editScope.tableExtend()\" ng-disabled=\"planning.isFromDisabled || planning.isEditDisabled\">行追加</button></th></tr><tr class=\"active\" ng-if=\"!planning.editForm.print_fl\"><th colspan=\"7\">補足説明</th></tr><tr class=\"active\" ng-if=\"planning.editForm.print_fl\"><th>DBコード/原版No.</th><th colspan=\"3\">サブタイトル/秒数</th><th colspan=\"2\">補足説明</th><th style=\"min-width:100px\">テープNo.</th></tr></thead><tbody ng-if=\"!planning.editScope.sgkyItems\"><tr><td colspan=\"9\" style=\"height:245px\"></td></tr><tr></tr></tbody><tbody ng-repeat=\"item in planning.editScope.sgkyItems\" class=\"fit\" disable-all=\"planning.isFromDisabled || planning.isEditDisabled\"><tr><td rowspan=\"2\" style=\"width:5%\" class=\"text-center\">{{ $index+1 }} <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].gyo_no\" ng-init=\"planning.editForm.sgytDtl[$index].gyo_no = $index+1\"></td><td><span ng-if=\"item.dsp_nm\">{{ item.dsp_nm }}</span> <span ng-if=\"!item.dsp_nm\">{{ item.kmk_nm }}</span> <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].kmk_nm\" ng-init=\"planning.editForm.sgytDtl[$index].kmk_nm = item.kmk_nm\"></td><td style=\"width:10%\" ng-init=\"planning.editForm.sgytDtl[$index].sg_item_cd = item.sg_item_cd\"><div class=\"input-group\"><span class=\"input-group-addon mini-addon\"><input type=\"checkbox\" class=\"form-control input-sm keitai-select\" ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"item.inputChange\" ng-init=\"item.inputChange=true\" bs-tooltip=\"planning.editTooltipText3\"></span><div angucomplete-alt=\"\" ng-if=\"!planning.isFromDisabled && !planning.isEditDisabled && !item.inputChange\" maxlength=\"8\" placeholder=\"直接入力\" pause=\"500\" selected-object=\"planning.editScope.sgItemSelected\" remote-api-handler=\"planning.editScope.sgItemApiSearch\" title-field=\"sg_item_cd\" description-field=\"sg_item_nm\" minlength=\"3\" initial-value=\"item.sg_item_cd\" input-class=\"form-control form-control-small input-sm\"></div><sg-item-no-req ng-model=\"item.sg_item_cd\" sg-ktcd=\"{{planning.editForm.sg_keitai_cd}}\" ng-if=\"!planning.isFromDisabled && !planning.isEditDisabled && item.inputChange\"></sg-item-no-req><input type=\"text\" ng-model=\"item.sg_item_cd\" ng-if=\"planning.isFromDisabled || planning.isEditDisabled\" required=\"\"></div></td><td colspan=\"2\">{{ item.sg_item_nm }} <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].sg_item_cd\" ng-init=\"planning.editForm.sgytDtl[$index].sg_item_cd = item.sg_item_cd\"> <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd\" ng-init=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd = item.sg_bunrui_cd\"></td><td ng-if=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd != \'06\'\"></td><td ng-if=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd == \'06\'\"><div class=\"btn-group inline\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"planning.editForm.sgytDtl[$index].media_cd_1 = item.media_cd_1\" ng-model=\"planning.editForm.sgytDtl[$index].media_cd_1\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default space-btn\">⇒</button> <button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"planning.editForm.sgytDtl[$index].media_cd_2 = item.media_cd_2\" ng-model=\"planning.editForm.sgytDtl[$index].media_cd_2\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td ng-init=\"planning.editForm.sgytDtl[$index].suryo_1 = changeNumberType(item.suryo_1, \'parseFloat\')\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_1\" ng-model=\"planning.editForm.sgytDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\', item.tani_1 );\" ng-blur=\"planning.changeSuryo($index)\"> <input type=\"text\" class=\"form-control input-sm\" ng-if=\"!item.tani_1\" ng-model=\"planning.editForm.sgytDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\" ng-blur=\"planning.changeSuryo($index)\"></td><td ng-init=\"planning.editForm.sgytDtl[$index].suryo_2 = changeNumberType(item.suryo_2, \'parseFloat\')\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_2\" ng-model=\"planning.editForm.sgytDtl[$index].suryo_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', item.tani_2 );\" ng-blur=\"planning.changeSuryo($index)\"> <span ng-if=\"!item.tani_2\" style=\"width:100px\"></span></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"planning.editScope.tableCellDelete($index)\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"planning.editScope.tableRowCopy($index)\">行複写</button></td></tr><tr ng-if=\"!planning.editForm.print_fl || (planning.editForm.print_fl && planning.editForm.sgytDtl[$index].sg_bunrui_cd != \'06\')\"><td colspan=\"7\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytDtl[$index].hosoku\" ng-init=\"planning.editForm.sgytDtl[$index].hosoku = item.hosoku\"></td></tr><tr ng-if=\"planning.editForm.print_fl && planning.editForm.sgytDtl[$index].sg_bunrui_cd == \'06\'\"><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default db-btn\" ng-init=\"planning.editForm.sgytDtl[$index].db_cd_kb = item.db_cd_kb\" ng-model=\"planning.editForm.sgytDtl[$index].db_cd_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.printStatus3\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editForm.sgytDtl[$index].db_cd\" ng-init=\"planning.editForm.sgytDtl[$index].db_cd = item.db_cd\"></div></td><td colspan=\"3\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm normal\" placeholder=\"サブタイトル\" style=\"width:100%\" ng-model=\"planning.editForm.sgytDtl[$index].sub_title\" ng-init=\"planning.editForm.sgytDtl[$index].sub_title = item.sub_title\"> <span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control\" ng-model=\"planning.editForm.sgytDtl[$index].sec\" style=\"width:45px\" ng-init=\"planning.editForm.sgytDtl[$index].sec = item.sec\"> <span class=\"input-group-btn\" style=\"width:0px;\" ng-init=\"planning.editForm.sgytDtl[$index].sec_tani_kb = item.sec_tani_kb\"></span> <button type=\"button\" class=\"btn btn-default media-btn\" style=\"width:100%\" ng-model=\"planning.editForm.sgytDtl[$index].sec_tani_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.printUnit\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytDtl[$index].hosoku\" ng-init=\"planning.editForm.sgytDtl[$index].hosoku = item.hosoku\"></td><td><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytDtl[$index].tape_no\" ng-init=\"planning.editForm.sgytDtl[$index].tape_no = item.tape_no\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-planning/newmode.html","<div id=\"scrollable-area\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th style=\"width:20%\">項目</th><th colspan=\"3\" style=\"width:40%\">作業項目コード/作業内容</th><th style=\"width:15%\">プリント</th><th colspan=\"2\" style=\"width:15%\">数量１/数量２</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"planning.editScope.tableExtend()\" ng-if=\"planning.editScope.sgkyItems\">行追加</button></th></tr><tr class=\"active\" ng-if=\"!planning.editForm.print_fl\"><th colspan=\"7\">補足説明</th></tr><tr class=\"active\" ng-if=\"planning.editForm.print_fl\"><th>DBコード/原版No.</th><th colspan=\"3\">サブタイトル/秒数</th><th colspan=\"2\">補足説明</th><th style=\"min-width:100px\">テープNo.</th></tr></thead><tbody ng-if=\"!planning.editScope.sgkyItems\"><tr><td colspan=\"9\" style=\"height:245px\"></td></tr><tr></tr></tbody><tbody ng-repeat=\"item in planning.editScope.sgkyItems\" class=\"fit\"><tr><td rowspan=\"2\" style=\"width:5%\">{{ $index+1 }} <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].gyo_no\" ng-init=\"planning.editForm.sgytDtl[$index].gyo_no = $index+1\"></td><td>{{ planning.editForm.sgytDtl[$index].kmk_nm }} <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].kmk_nm\" ng-init=\"planning.editForm.sgytDtl[$index].kmk_nm = item.dsp_nm\"></td><td style=\"width:10%\"><div class=\"input-group\"><span class=\"input-group-addon mini-addon\"><input type=\"checkbox\" class=\"form-control input-sm keitai-select\" ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"item.inputChange\" ng-init=\"item.inputChange=true\" bs-tooltip=\"planning.editTooltipText3\"></span><div angucomplete-alt=\"\" ng-if=\"!item.inputChange\" maxlength=\"8\" placeholder=\"直接入力\" pause=\"1000\" selected-object=\"planning.editScope.sgItemSelected\" remote-api-handler=\"planning.editScope.sgItemApiSearch\" title-field=\"sg_item_cd\" description-field=\"sg_item_nm\" minlength=\"3\" initial-value=\"item.sg_item_cd\" input-class=\"form-control form-control-small input-sm\"></div><sg-item-no-req ng-model=\"item.sg_item_cd\" sg-ktcd=\"{{planning.editForm.sg_keitai_cd}}\" ng-if=\"item.inputChange\"></sg-item-no-req></div></td><td colspan=\"2\">{{ item.sg_item_nm }} <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].sg_item_cd\" ng-init=\"planning.editForm.sgytDtl[$index].sg_item_cd = item.sg_item_cd\"> <input type=\"hidden\" ng-model=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd\" ng-init=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd = item.sg_bunrui_cd\"></td><td ng-if=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd != \'06\'\"></td><td ng-if=\"planning.editForm.sgytDtl[$index].sg_bunrui_cd == \'06\'\" \"=\"\"><div class=\"btn-group inline\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"planning.editForm.sgytDtl[$index].media_cd_1\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default space-btn\">⇒</button> <button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"planning.editForm.sgytDtl[$index].media_cd_2\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_1\" ng-model=\"planning.editForm.sgytDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\',item.tani_1);\" ng-blur=\"planning.changeSuryo($index)\"> <input type=\"text\" class=\"form-control input-sm\" ng-if=\"!item.tani_1\" ng-model=\"planning.editForm.sgytDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\" ng-blur=\"planning.changeSuryo($index)\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_2\" ng-model=\"planning.editForm.sgytDtl[$index].suryo_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', item.tani_2);\" ng-blur=\"planning.changeSuryo($index)\"> <span ng-if=\"!item.tani_2\" style=\"width:100px\"></span></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"planning.editScope.tableCellDelete($index)\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"planning.editScope.tableRowCopy($index)\">行複写</button></td></tr><tr ng-if=\"!planning.editForm.print_fl || (planning.editForm.print_fl && planning.editForm.sgytDtl[$index].sg_bunrui_cd != \'06\')\"><td colspan=\"7\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytDtl[$index].hosoku\"></td></tr><tr ng-if=\"planning.editForm.print_fl && planning.editForm.sgytDtl[$index].sg_bunrui_cd == \'06\'\"><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default db-btn\" ng-model=\"planning.editForm.sgytDtl[$index].db_cd_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.printStatus3\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editForm.sgytDtl[$index].db_cd\"></div></td><td colspan=\"3\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm normal\" placeholder=\"サブタイトル\" style=\"width:100%\" ng-model=\"planning.editForm.sgytDtl[$index].sub_title\"> <span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control\" placeholder=\"sec\" ng-model=\"planning.editForm.sgytDtl[$index].sec\" style=\"width:45px\"> <span class=\"input-group-btn\" style=\"width:0px;\"></span> <button type=\"button\" class=\"btn btn-default media-btn\" style=\"width:100%\" ng-model=\"planning.editForm.sgytDtl[$index].sec_tani_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.printUnit\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytDtl[$index].hosoku\"></td><td><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytDtl[$index].tape_no\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-planning/planning.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-show=\"planning.form\"><button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button><br><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body item-search\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>作業予定日</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.form.fromDate\" data-max-date=\"{{planning.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>作業予定日</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.form.untilDate\" data-min-date=\"{{planning.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.form.ju_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.form.ju_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"planning.tokuisakiSelected\" remote-api-handler=\"planning.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"><input type=\"hidden\" name=\"toku_no\" ng-model=\"planning.form.toku_no\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作品名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"作品名\" ng-model=\"planning.form.hin_nm\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.sgjtStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">状態 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.sg_jt_kb_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.sghkStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">報告 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.sg_hk_fl_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.studioDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">スタジオ <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.studio_nm\" disabled=\"\"> <input type=\"hidden\" name=\"studio_cd\" ng-model=\"planning.form.studio_cd\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>作業伝票No</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.form.sg_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>作業伝票No</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.form.sg_noTo\" placeholder=\"to\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">受注部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ins_bmn_cd\" ng-model=\"planning.form.ins_bmn_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.ju_tanto_nm\" placeholder=\"先に受注部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"ju_tanto_cd\" ng-model=\"planning.form.ju_tanto_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.sgytDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業予定部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.sg_yt_bmn_nm\" disabled=\"\"> <input type=\"hidden\" name=\"gyomu_kb\" ng-model=\"planning.form.sg_yt_bmn_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"planning.sgytsyaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業予定担当 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.simei_gj_nm_1\" placeholder=\"先に作業予定部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"simei_gj_cd_1\" ng-model=\"planning.form.simei_gj_cd_1\"></div></div></div><div class=\"col-md-7\"><div ng-if=\"dummy\">※本年から3年前までを標準出力しています。<br>※3年以上前のデータは作業予定日指定で検索してください</div><div>※最初に別の条件を選択し、絞り込む必要があるものがあります（例：担当営業)</div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"planning.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"planning.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"planning.datas\"><dir-pagination-controls on-page-change=\"planning.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"planningPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"planning.pagination.current * planning.datasPerPage - (planning.datasPerPage -1) +\'～\'+((planning.pagination.current * planning.datasPerPage - planning.datasPerPage) + planning.datas.length) +\'件/\'+planning.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"planning.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th rowspan=\"2\">#</th><th style=\"width:10%\">作業予定日</th><th style=\"width:10%\">作業伝票No.</th><th>受注No.</th><th style=\"width:15%\">得意先</th><th colspan=\"2\">作品名</th><th style=\"width:12%\">スタジオ</th><th>受注部門</th><th rowspan=\"2\">操作</th><th rowspan=\"2\">状態</th></tr><tr class=\"active\"><th>営業</th><th>作業部門</th><th style=\"width:15%\">技術1</th><th style=\"width:15%\">技術2</th><th style=\"width:15%\">技術3</th><th colspan=\"2\">作業予定時間</th><th style=\"width:20%\">作業状態</th></tr></thead><tbody dir-paginate=\"item in planning.datas | itemsPerPage: planning.datasPerPage\" pagination-id=\"planningPaginate\" total-items=\"planning.totalDatas\" current-page=\"planning.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (planning.pagination.current - 1) * planning.datasPerPage }}</td><td>{{ item.sg_yt_day_time * 1000 | date }}</td><td>{{ item.sg_no }}</td><td>{{ item.ju_no }}</td><td><span bs-tooltip=\"item.toku_nm\">{{ item.toku_nm }}</span></td><td colspan=\"2\"><span bs-tooltip=\"item.hin_nm\">{{ item.hin_nm }}</span></td><td><span bs-tooltip=\"item.studio_nm\">{{ item.studio_nm }}</span></td><td>{{ item.ju_bumon_nm }}</td><td rowspan=\"2\" class=\"text-center\" style=\"padding:2px;\"><a href=\"\" ng-click=\"planning.editModeInit(2, item.ju_no, item.sg_no)\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" class=\"btn btn-danger btn-xs mini-button\" bs-tooltip=\"\'作業予定の編集\'\" ng-if=\"item.sg_hk_fl != 1\">編集</a> <a href=\"\" ng-click=\"planning.editModeInit(2, item.ju_no, item.sg_no)\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" class=\"btn btn-info btn-xs mini-button\" bs-tooltip=\"\'作業予定の確認\'\" ng-if=\"item.sg_hk_fl == 1\">確認</a><br><span ng-if=\"(item.sn_fl_1 == 0 && item.sn_fl_2 == 0) || (!item.sn_fl_1 && !item.sn_fl_2) && item.fin_fl == 0\"><br><a ui-sref=\"app.business-report({juno:item.ju_no,sgno:item.sg_no})\" data-placement=\"top\" data-type=\"info\" a-disabled=\"planning.isEditDisabled\" data-container=\"body\" type=\"button\" class=\"btn btn-warning btn-xs mini-button\" bs-tooltip=\"\'作業報告を行う\'\" ng-if=\"item.sg_hk_fl != 1\">報告</a></span></td><td rowspan=\"2\" class=\"text-center\"><span class=\"label label-success label-mini\" ng-if=\"item.fin_fl > 0\">完</span> <span class=\"label label-danger label-mini\" ng-if=\"item.sg_hk_fl != 1\">未</span> <span class=\"label label-info label-mini\" ng-if=\"item.sg_hk_fl == 1\">済</span></td></tr><tr><td>{{ item.ju_tanto_nm }}</td><td>{{ item.sg_yt_bmn_nm }}</td><td>{{ item.gj_nm_1 }}</td><td>{{ item.gj_nm_2 }}</td><td>{{ item.gj_nm_3 }}</td><td colspan=\"2\"><span ng-if=\"item.sg_yt_tm_fm > 0\">{{ item.sg_yt_tm_fm | totime }}～{{ item.sg_yt_tm_to | totime }}</span></td><td><span ng-if=\"item.sg_jt_kb != 1\">通常</span> <span ng-if=\"item.sg_jt_kb == 1\">キャンセル</span><br><span ng-if=\"item.cancel_day_time\">{{ item.cancel_day_time * 1000 | date }}</span></td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"planning.datas\"><dir-pagination-controls on-page-change=\"planning.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"planningPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"planning.pagination.current * planning.datasPerPage - (planning.datasPerPage -1) +\'～\'+((planning.pagination.current * planning.datasPerPage - planning.datasPerPage) + planning.datas.length) +\'件/\'+planning.totalDatas+\'件\'\"></span></div>");
$templateCache.put("app/business-planning/planningedit.html","<div class=\"modal modal-wide modal-sgyt\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\" ng-if=\"planning.editScope.editMode == 1\">作業予定新規登録</h4><h4 class=\"modal-title text-center\" ng-if=\"planning.editScope.editMode == 2\">作業予定編集</h4></div><div class=\"col-xs-5 text-right\" ng-if=\"planning.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"planning.editScope.cancel(1)\">クリア</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"planning.editScope.planningSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"planning.editScope.sgytError || planningForm.$invalid\">登録</button></div><div class=\"col-xs-5 text-right\" ng-if=\"planning.editScope.editMode == 2\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"planning.editScope.planningSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"planning.isFromDisabled || planning.isEditDisabled || planningForm.$invalid\">変更</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"planning.editScope.planningSubmit(\'DELETE\')\" style=\"width:100px\" ng-disabled=\"planning.isFromDisabled || planning.isEditDisabled\">削除</button> <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"planning.printSgyt()\" style=\"width:80px\">印刷</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide();planning.editScope.cancel(planning.editScope.editMode)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit\" disable-all=\"planning.isFromDisabled || planning.isEditDisabled\"><form role=\"form\" name=\"planningForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><tbody><tr><td style=\"width:15%\" class=\"title\">作業伝票No.</td><td style=\"width:15%\" ng-class=\"{\'title\':planning.editScope.editMode == 1}\">{{ planning.editForm.sg_no }} <input type=\"hidden\" name=\"sg_no\" class=\"form-control input-sm\" ng-model=\"planning.editForm.sg_no\"></td><td style=\"width:10%\" class=\"title\">得意先</td><td style=\"width:30%\">{{ planning.editScope.item.toku_nm }}</td><td style=\"width:10%\" class=\"title\">担当営業</td><td>{{ planning.editScope.item.ju_tanto_nm }}</td></tr><tr><td class=\"title\">受注No.</td><td>{{ planning.editForm.ju_no }} <input type=\"hidden\" name=\"ju_no\" class=\"form-control input-sm\" ng-model=\"planning.editForm.ju_no\"></td><td class=\"title\">作品名</td><td colspan=\"3\">{{ planning.editScope.item.hin_nm }} <input type=\"hidden\" name=\"sg_no\" class=\"form-control input-sm\" ng-model=\"planning.editScope.item.hin_nm\"></td></tr></tbody></table></div><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:20%\">作業予定部門</th><th style=\"width:20%\">業務区分</th><th style=\"width:20%\">作業形態</th><th>作業予定スタジオ</th><th style=\"width:120px\">作業予定日</th><th colspan=\"2\" style=\"width:145px\">作業予定時間<span ng-if=\"planning.editScope.sgytError\" class=\"text-danger\">※時間が間違っています</span></th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.sg_yt_bmn_cd\" ng-change=\"planning.changeSgBmnCd()\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.sgytDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"planning.editForm.gyomu_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.gyomuDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"planning.editForm.sg_keitai_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.sgktDropdown | orderBy:[\'!!id\', \'id\']\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"planning.editForm.studio_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in planning.editScope.studioDropdown | orderBy:[\'!!id\', \'id\']\" bs-select=\"\"><span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editForm.sg_yt_day\" name=\"sg_yt_day\" bs-datepicker=\"\" placeholder=\"年月日\" style=\"width:115px\" required=\"\"></td><td><input type=\"text\" class=\"form-control input-sm\" name=\"sg_yt_tm_fm\" ng-model=\"planning.editForm.sg_yt_tm_fm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"width:50px;ime-mode:disabled\" ng-blur=\"planning.setSgytTime()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"sg_yt_tm_to\" ng-model=\"planning.editForm.sg_yt_tm_to\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"width:50px;ime-mode:disabled\" ng-blur=\"planning.setSgytTime()\"></td><td style=\"width:40px\"><input type=\"text\" id=\"sgyt-time\" class=\"form-control input-sm\" ng-model=\"planning.editScope.sg_yt_time\" disabled=\"\"></td></tr></tbody></table><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"planning.editScope.sgktSyaDropdown1\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:110px\">指名技術員１ <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editScope.item.simei_gj_nm_1\" disabled=\"\"> <input type=\"hidden\" name=\"simei_gj_cd_1\" ng-model=\"planning.editForm.simei_gj_cd_1\"></div></td><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"planning.editScope.sgktSyaDropdown2\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:110px\">指名技術員２ <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editScope.item.simei_gj_nm_2\" disabled=\"\"> <input type=\"hidden\" name=\"simei_gj_cd_2\" ng-model=\"planning.editForm.simei_gj_cd_2\"></div></td><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"planning.editScope.sgjtDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業状態 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editScope.item.sg_jt_nm\" disabled=\"\"> <input type=\"hidden\" name=\"sg_jt_kb\" ng-model=\"planning.editForm.sg_jt_kb\"></div></td><td><div class=\"input-group\"><span class=\"input-group-addon\" style=\"font-size:90%;\">キャンセル日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"planning.editForm.cancel_day\" name=\"cancel_day\" bs-datepicker=\"\" placeholder=\"年月日\" style=\"width:80px\"></div></td></tr></tbody></table><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th colspan=\"2\">作業予定技術員</th><th colspan=\"2\">作業予定時間(前後含)</th><th>前</th><th>後</th><th colspan=\"2\">作業予定技術員</th><th colspan=\"2\">作業予定時間(前後含)</th><th>前</th><th>後</th></tr></thead><tbody class=\"fit\"><tr><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_kb_1\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in planning.editScope.gjPatternDropdown\" ng-change=\"planning.changeGjKtPat1(1);\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_cd_1\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in planning.editScope.gjktSyaDropdown1 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_1\" ng-model=\"planning.editForm.gj_tm_fm_1\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime1()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_1\" ng-model=\"planning.editForm.gj_tm_to_1\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime1()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_1\" class=\"form-control input-sm\" ng-model=\"planning.editForm.gj_time_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_1\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_mae_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_1\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_ato_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_kb_2\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in planning.editScope.gjPatternDropdown\" ng-change=\"planning.changeGjKtPat2(1);\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_cd_2\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in planning.editScope.gjktSyaDropdown2 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_2\" ng-model=\"planning.editForm.gj_tm_fm_2\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime2()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_2\" ng-model=\"planning.editForm.gj_tm_to_2\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime2()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_2\" class=\"form-control input-sm\" ng-model=\"planning.editForm.gj_time_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_2\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_mae_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_2\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_ato_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td></tr><tr><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_kb_3\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in planning.editScope.gjPatternDropdown\" ng-change=\"planning.changeGjKtPat3(1);\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_cd_3\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in planning.editScope.gjktSyaDropdown3 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_3\" ng-model=\"planning.editForm.gj_tm_fm_3\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime3()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_3\" ng-model=\"planning.editForm.gj_tm_to_3\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime3()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_3\" class=\"form-control input-sm\" ng-model=\"planning.editForm.gj_time_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"><br></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_3\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_mae_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_3\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_ato_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_kb_4\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in planning.editScope.gjPatternDropdown\" ng-change=\"planning.changeGjKtPat4(1);\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"planning.editForm.gj_cd_4\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in planning.editScope.gjktSyaDropdown4 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_4\" ng-model=\"planning.editForm.gj_tm_fm_4\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime4()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_4\" ng-model=\"planning.editForm.gj_tm_to_4\" model-view-value=\"true\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"planning.setGjTime4()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_4\" class=\"form-control input-sm\" ng-model=\"planning.editForm.gj_time_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_4\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_mae_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_4\" class=\"form-control input-sm\" ng-disabled=\"!planning.editForm.sg_yt_bmn_cd\" ng-model=\"planning.editForm.gj_time_ato_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td></tr></tbody></table></div><div class=\"col-md-12\"><div class=\"well\" style=\"font-size:90%;padding-top:0;height:75px\" ng-if=\"planning.editScope.printShow\"><div class=\"row\"><div class=\"col-xs-1\"><span style=\"font-size:80%;\">プリント</span> <input type=\"checkbox\" ng-model=\"planning.editForm.print_fl\" ng-true-value=\"1\" ng-false-value=\"0\"></div><div class=\"col-xs-7\"><table><tr><td style=\"width:300px;text-align:top;\"><span style=\"font-size:75%;width:90px;height:25px\">納品日時</span><div class=\"form-inline\"><div class=\"form-group\"><div class=\"form-group\"><input size=\"10\" class=\"form-control input-sm\" ng-model=\"planning.editForm.print_nh_dt\" data-autoclose=\"1\" placeholder=\"年月日\" bs-datepicker=\"\" type=\"text\" style=\"font-size:85%;width:115px;height:25px;\" ng-disabled=\"!planning.editForm.print_fl\"></div><div class=\"form-group\"><input size=\"8\" class=\"form-control input-sm\" ng-model=\"planning.editForm.print_nh_dt\" data-time-format=\"HH:mm\" data-autoclose=\"1\" placeholder=\"時間\" bs-timepicker=\"\" type=\"text\" style=\"font-size:85%;width:80px;height:25px;\" ng-disabled=\"!planning.editForm.print_fl\"></div></div></div><input type=\"text\" class=\"form-control input-sm\" placeholder=\"補足\" style=\"font-size:90%;width:180px;height:25px\" ng-model=\"planning.editForm.nh_hosoku\" ng-disabled=\"!planning.editForm.print_fl\"></td><td style=\"width:250px\"><div class=\"input-group\" style=\"font-size:90%;\"><label style=\"font-weight: normal;\" ng-repeat=\"status in planning.editScope.printStatus1\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"planning.editForm.nh_kb\" value=\"{{status.id}}\" ng-disabled=\"!planning.editForm.print_fl\">&nbsp;&nbsp;</label></div></td></tr></table></div><div class=\"col-xs-4\" style=\"font-size:90%;\"><label style=\"font-size:75%;height:25px\">原版</label><div class=\"input-group\"><label style=\"font-weight: normal;\" ng-repeat=\"status in planning.editScope.printStatus2\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"planning.editForm.genban_kb\" value=\"{{status.id}}\" ng-disabled=\"!planning.editForm.print_fl\">&nbsp;&nbsp;</label></div></div></div></div></div></div><div class=\"row\" ng-if=\"!planning.editScope.printShow\"><div class=\"col-md-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-include=\"planning.templateUrl_1\" ng-if=\"planning.editScope.editMode == 2\"></div><div ng-include=\"planning.templateUrl_2\" ng-if=\"planning.editScope.editMode == 1\"></div><table class=\"table table-bordered table-striped fit\"><thead class=\"fit\"><tr class=\"active\"><th>メモ</th></tr></thead><tbody class=\"fit\"><tr><td><textarea type=\"text\" class=\"form-control input-sm normal\" ng-model=\"planning.editForm.sgytMemo\"></textarea></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><span ng-if=\"planning.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span><br><p class=\"text-left\" style=\"font-size:90%\">※作業項目コードが入力されていない行のデータは登録されません<br></p></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();planning.editScope.cancel(planning.editScope.editMode)\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-report/editmode.html","<div id=\"scrollable-area\" disable-all=\"report.isFromDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th style=\"width:20%\">項目</th><th colspan=\"3\" style=\"width:40%\">作業項目コード/作業内容</th><th style=\"width:15%\">時間/プリント</th><th colspan=\"3\" style=\"width:20%\">数量１/数量２/予定原価</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"report.editScope.tableExtend()\" ng-disabled=\"report.isFromDisabled || report.isEditDisabled\">行追加</button></th></tr><tr class=\"active\" ng-if=\"!report.editForm.print_fl\"><th colspan=\"8\">補足説明</th></tr><tr class=\"active\" ng-if=\"report.editForm.print_fl\"><th>DBコード/原版No.</th><th colspan=\"3\">サブタイトル/秒数</th><th colspan=\"2\">補足説明</th><th colspan=\"2\">テープNo.</th></tr></thead><tbody ng-if=\"!report.editScope.sgkyItems\"><tr><td colspan=\"10\" style=\"height:245px\"></td></tr><tr></tr></tbody><tbody ng-repeat=\"item in report.editScope.sgkyItems\" class=\"fit\" disable-all=\"report.isFromDisabled || report.isEditDisabled\"><tr><td rowspan=\"2\" style=\"width:5%\">{{ $index+1 }} <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].gyo_no\" ng-init=\"report.editForm.sghtDtl[$index].gyo_no = $index+1\"></td><td>{{ report.editForm.sghtDtl[$index].kmk_nm }} <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].kmk_nm\" ng-init=\"report.editForm.sghtDtl[$index].kmk_nm = item.kmk_nm\"></td><td style=\"width:10%\" ng-init=\"report.editForm.sghtDtl[$index].sg_item_cd = item.sg_item_cd\"><div class=\"input-group\"><span class=\"input-group-addon mini-addon\" ng-if=\"!report.isFromDisabled && !report.isEditDisabled\"><input type=\"checkbox\" class=\"form-control input-sm keitai-select\" ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"item.inputChange\" ng-init=\"item.inputChange=true\" bs-tooltip=\"report.editTooltipText3\"></span><div angucomplete-alt=\"\" ng-if=\"!report.isFromDisabled && !report.isEditDisabled && !item.inputChange\" maxlength=\"8\" placeholder=\"直接入力\" pause=\"500\" selected-object=\"report.editScope.sgItemSelected\" remote-api-handler=\"report.editScope.sgItemApiSearch\" title-field=\"sg_item_cd\" description-field=\"sg_item_nm\" minlength=\"3\" initial-value=\"item.sg_item_cd\" input-class=\"form-control form-control-small input-sm\"></div><sg-item-no-req ng-model=\"item.sg_item_cd\" sg-ktcd=\"{{report.editForm.sg_keitai_cd}}\" ng-if=\"!report.isFromDisabled && !report.isEditDisabled && item.inputChange\"></sg-item-no-req></div><input type=\"text\" ng-model=\"item.sg_item_cd\" ng-if=\"report.isFromDisabled || report.isEditDisabled\"></td><td colspan=\"2\">{{ item.sg_item_nm }} <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].sg_item_cd\" ng-init=\"report.editForm.sghtDtl[$index].sg_item_cd = item.sg_item_cd\"> <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].sg_bunrui_cd\" ng-init=\"report.editForm.sghtDtl[$index].sg_bunrui_cd = item.sg_bunrui_cd\"></td><td ng-if=\"item.time_fl != 0 && report.editForm.sghtDtl[$index].sg_bunrui_cd == \'06\'\"></td><td ng-if=\"item.time_fl == 0 && report.editForm.sghtDtl[$index].sg_bunrui_cd == \'06\'\"><div class=\"btn-group inline\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"report.editForm.sghtDtl[$index].media_cd_1 = item.media_cd_1\" ng-model=\"report.editForm.sghtDtl[$index].media_cd_1\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default space-btn\">⇒</button> <button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"report.editForm.sghtDtl[$index].media_cd_2 = item.media_cd_2\" ng-model=\"report.editForm.sghtDtl[$index].media_cd_2\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.mediaDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td ng-if=\"item.time_fl == 1 && report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\'\" style=\"min-width:105px;\"><input type=\"text\" class=\"form-control input-sm\" name=\"stt_tm\" ng-init=\"report.editForm.sghtDtl[$index].stt_tm = item.stt_tm\" ng-model=\"report.editForm.sghtDtl[$index].stt_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"report.setSghtColumnTime($index);report.changeSuryo($index)\"> <input type=\"text\" class=\"form-control input-sm\" name=\"end_tm\" ng-init=\"report.editForm.sghtDtl[$index].end_tm= item.end_tm\" ng-model=\"report.editForm.sghtDtl[$index].end_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"report.setSghtColumnTime($index);report.changeSuryo($index)\"></td><td ng-if=\"(item.time_fl == 0 || !item.time_fl) && ( report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\' || !report.editForm.sghtDtl[$index].sg_bunrui_cd )\"></td><td ng-init=\"report.editForm.sghtDtl[$index].suryo_1 = changeNumberType(item.suryo_1, \'parseFloat\')\" style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_1\" ng-model=\"report.editForm.sghtDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\', item.tani_1 );\" ng-blur=\"report.changeSuryo($index)\"> <input type=\"text\" class=\"form-control input-sm\" ng-if=\"!item.tani_1\" ng-model=\"report.editForm.sghtDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\" ng-blur=\"report.changeSuryo($index)\"></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-init=\"report.editForm.sghtDtl[$index].suryo_2 = changeNumberType(item.suryo_2, \'parseFloat\')\" ng-if=\"item.tani_2\" ng-model=\"report.editForm.sghtDtl[$index].suryo_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', item.tani_2 );\" ng-blur=\"report.changeSuryo($index)\"> <span ng-if=\"!item.tani_2\">&nbsp;</span></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.genka_fl == 1\" ng-model=\"report.editForm.sghtDtl[$index].genka\" model-format=\"number\"> <span ng-if=\"item.genka_fl != 1\">&nbsp;</span></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"report.editScope.tableCellDelete($index)\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"report.editScope.tableRowCopy($index, report.editForm)\">行複写</button></td></tr><tr ng-if=\"!report.editForm.print_fl || (report.editForm.print_fl && report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\')\"><td colspan=\"8\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtDtl[$index].hosoku\" ng-init=\"report.editForm.sghtDtl[$index].hosoku = item.hosoku\"></td></tr><tr ng-if=\"report.editForm.print_fl && report.editForm.sghtDtl[$index].sg_bunrui_cd == \'06\'\"><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-init=\"report.editForm.sghtDtl[$index].db_cd_kb = item.db_cd_kb\" ng-model=\"report.editForm.sghtDtl[$index].db_cd_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.printStatus3\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.editForm.sghtDtl[$index].db_cd\" ng-init=\"report.editForm.sghtDtl[$index].db_cd = item.db_cd\"></div></td><td colspan=\"3\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm normal\" placeholder=\"サブタイトル\" ng-model=\"report.editForm.sghtDtl[$index].sub_title\" style=\"width:100%\" ng-init=\"report.editForm.sghtDtl[$index].sub_title = item.sub_title\"> <span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control\" ng-model=\"report.editForm.sghtDtl[$index].sec\" style=\"width:45px\" ng-init=\"report.editForm.sghtDtl[$index].sec = item.sec\"> <span class=\"input-group-btn\" style=\"width:0px;\" ng-init=\"report.editForm.sghtDtl[$index].sec_tani_kb = item.sec_tani_kb\"></span> <button type=\"button\" class=\"btn btn-default media-btn\" style=\"width:100%\" ng-model=\"report.editForm.sghtDtl[$index].sec_tani_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.printUnit\" bs-select=\"\"><span class=\"caret\"></span></button></div></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtDtl[$index].hosoku\" ng-init=\"report.editForm.sghtDtl[$index].hosoku = item.hosoku\"></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtDtl[$index].tape_no\" ng-init=\"report.editForm.sghtDtl[$index].tape_no = item.tape_no\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-report/newmode.html","<div id=\"scrollable-area\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:5%\">No.</th><th style=\"width:20%\">項目</th><th colspan=\"3\" style=\"width:40%\">作業項目コード/作業内容</th><th style=\"width:15%\">時間/プリント</th><th colspan=\"3\" style=\"width:20%\">数量１/数量２/予定原価</th><th rowspan=\"2\" style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"report.editScope.tableExtend()\" ng-disabled=\"report.isFromDisabled || report.isEditDisabled\">行追加</button></th></tr><tr class=\"active\" ng-if=\"!report.editForm.print_fl\"><th colspan=\"8\">補足説明</th></tr><tr class=\"active\" ng-if=\"report.editForm.print_fl\"><th>DBコード/原版No.</th><th colspan=\"3\">サブタイトル/秒数</th><th colspan=\"2\">補足説明</th><th colspan=\"2\">テープNo.</th></tr></thead><tbody ng-if=\"!report.editScope.sgkyItems\"><tr><td colspan=\"10\" style=\"height:245px\"></td></tr><tr></tr></tbody><tbody ng-repeat=\"item in report.editScope.sgkyItems\" class=\"fit\" disable-all=\"report.isFromDisabled || report.isEditDisabled\"><tr><td rowspan=\"2\" style=\"width:5%\">{{ $index+1 }} <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].gyo_no\" ng-init=\"report.editForm.sghtDtl[$index].gyo_no = $index+1\"></td><td>{{ report.editForm.sghtDtl[$index].kmk_nm }} <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].kmk_nm\" ng-init=\"report.editForm.sghtDtl[$index].kmk_nm = item.dsp_nm\"></td><td style=\"width:10%\"><div class=\"input-group\"><span class=\"input-group-addon mini-addon\"><input type=\"checkbox\" class=\"form-control input-sm keitai-select\" ng-true-value=\"true\" ng-false-value=\"false\" ng-model=\"item.inputChange\" ng-init=\"item.inputChange=true\" bs-tooltip=\"report.editTooltipText3\"></span><div angucomplete-alt=\"\" ng-if=\"!item.inputChange\" maxlength=\"8\" placeholder=\"直接入力\" pause=\"500\" selected-object=\"report.editScope.sgItemSelected\" remote-api-handler=\"report.editScope.sgItemApiSearch\" title-field=\"sg_item_cd\" description-field=\"sg_item_nm\" minlength=\"3\" initial-value=\"item.sg_item_cd\" input-class=\"form-control form-control-small input-sm\"></div><sg-item ng-model=\"item.sg_item_cd\" sg-ktcd=\"{{report.editForm.sg_keitai_cd}}\" ng-if=\"!report.isFromDisabled && !report.isEditDisabled && item.inputChange\"></sg-item></div></td><td colspan=\"2\">{{ item.sg_item_nm }} <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].sg_item_cd\" ng-init=\"report.editForm.sghtDtl[$index].sg_item_cd = item.sg_item_cd\" required=\"\"> <input type=\"hidden\" ng-model=\"report.editForm.sghtDtl[$index].sg_bunrui_cd\" ng-init=\"report.editForm.sghtDtl[$index].sg_bunrui_cd = item.sg_bunrui_cd\"></td><td ng-if=\"report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\'\"></td><td ng-if=\"item.time_fl == 0 && report.editForm.sghtDtl[$index].sg_bunrui_cd == \'06\'\"><div class=\"btn-group inline\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"report.editForm.sghtDtl[$index].media_cd_1\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.mediaDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default space-btn\">⇒</button> <button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"report.editForm.sghtDtl[$index].media_cd_2\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.mediaDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></div></td><td ng-if=\"item.time_fl == 1 && report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\'\" style=\"min-width:105px;\"><input type=\"text\" class=\"form-control input-sm\" name=\"stt_tm\" ng-model=\"report.editForm.sghtDtl[$index].stt_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"report.setSghtColumnTime($index);report.changeSuryo($index)\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" name=\"end_tm\" ng-model=\"report.editForm.sghtDtl[$index].end_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:50px;ime-mode:disabled\" ng-blur=\"report.setSghtColumnTime($index);report.changeSuryo($index)\" required=\"\"></td><td ng-if=\"(item.time_fl == 0 || !item.time_fl) && ( report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\' || !report.editForm.sghtDtl[$index].sg_bunrui_cd )\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_1\" ng-model=\"report.editForm.sghtDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\',item.tani_1);\" ng-blur=\"report.changeSuryo($index)\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" ng-if=\"!item.tani_1\" ng-model=\"report.editForm.sghtDtl[$index].suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue, $filter, \'0.0\');\" ng-blur=\"report.changeSuryo($index)\" required=\"\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.tani_2\" ng-model=\"report.editForm.sghtDtl[$index].suryo_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', item.tani_2);\" ng-blur=\"report.changeSuryo($index)\" required=\"\"> <span ng-if=\"!item.tani_2\" style=\"width:100px\"></span></td><td style=\"width:60px\"><input type=\"text\" class=\"form-control input-sm\" ng-if=\"item.genka_fl == 1\" ng-model=\"report.editForm.sghtDtl[$index].genka\" model-format=\"number\"> <span ng-if=\"item.genka_fl != 1\">&nbsp;</span></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"report.editScope.tableCellDelete($index)\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"report.editScope.tableCellCopy($index)\">行複写</button></td></tr><tr ng-if=\"!report.editForm.print_fl || (report.editForm.print_fl && report.editForm.sghtDtl[$index].sg_bunrui_cd != \'06\')\"><td colspan=\"8\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtDtl[$index].hosoku\"></td></tr><tr ng-if=\"report.editForm.print_fl && report.editForm.sghtDtl[$index].sg_bunrui_cd == \'06\'\"><td><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"report.editForm.sghtDtl[$index].db_cd_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.printStatus3\" bs-select=\"\"><span class=\"caret\"></span></button></div><input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.editForm.sghtDtl[$index].db_cd\"></div></td><td style=\"width:20%\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm normal\" placeholder=\"サブタイトル\" ng-model=\"report.editForm.sghtDtl[$index].sub_title\"> <span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control\" ng-model=\"report.editForm.sghtDtl[$index].sec\" style=\"width:100px\"></div></td><td style=\"width:10%\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"report.editForm.sghtDtl[$index].sec\" style=\"width:100px\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default media-btn\" ng-model=\"report.editForm.sghtDtl[$index].sec_tani_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.printUnit\" bs-select=\"\"><span class=\"caret\"></span></button></div></div></td><td style=\"width:10%\"><input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"report.editForm.sghtDtl[$index].show_time\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0分\');\"></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtDtl[$index].hosoku\"></td><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtDtl[$index].tape_no\"></td></tr></tbody></table></div>");
$templateCache.put("app/business-report/report.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-show=\"report.form\"><button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.form.fromDate\" data-max-date=\"{{report.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.form.untilDate\" data-min-date=\"{{report.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.form.ju_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.form.ju_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"report.tokuisakiSelected\" remote-api-handler=\"report.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"><input type=\"hidden\" name=\"toku_no\" ng-model=\"report.form.toku_no\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作品名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"作品名\" ng-model=\"report.form.hin_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"report.studioDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">スタジオ <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.studio_nm\" disabled=\"\"> <input type=\"hidden\" name=\"studio_cd\" ng-model=\"report.form.studio_cd\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"report.snflStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">承認 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.sn_fl_nm\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>作業伝票No</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.form.sg_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>作業伝票No</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.form.sg_noTo\" placeholder=\"to\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"report.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">受注部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ins_bmn_cd\" ng-model=\"report.form.ins_bmn_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"report.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.ju_tanto_nm\" placeholder=\"先に受注部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"ju_tanto_cd\" ng-model=\"report.form.ju_tanto_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"report.sghtDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業予定部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.sg_bmn_nm\" disabled=\"\"> <input type=\"hidden\" name=\"gyomu_kb\" ng-model=\"report.form.sg_bmn_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"report.sghtsyaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業予定担当 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.gj_nm_1\" placeholder=\"先に作業予定部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"simei_gj_cd_1\" ng-model=\"report.form.gj_cd_1\"></div></div></div><div class=\"col-md-7\"><div ng-if=\"dummy\">※本年から3年前までを標準出力しています。<br>※3年以上前のデータは作業予定日指定で検索してください</div><div>※最初に別の条件を選択し、絞り込む必要があるものがあります（例：担当営業)</div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"report.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"report.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"report.datas\"><dir-pagination-controls on-page-change=\"report.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"reportPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"report.pagination.current * report.datasPerPage - (report.datasPerPage -1) +\'～\'+((report.pagination.current * report.datasPerPage - report.datasPerPage) + report.datas.length) +\'件/\'+report.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"report.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th rowspan=\"2\">#</th><th style=\"width:10%\">作業日</th><th style=\"width:10%\">作業伝票No.</th><th>受注No.</th><th style=\"width:15%\">得意先</th><th colspan=\"2\">作品名</th><th style=\"width:12%\">スタジオ</th><th rowspan=\"2\">操作</th><th rowspan=\"2\">承認</th></tr><tr class=\"active\"><th>受注部門</th><th>営業</th><th>作業部門</th><th style=\"width:15%\">技術１</th><th style=\"width:15%\">技術２</th><th style=\"width:15%\">技術３</th><th>作業時間</th></tr></thead><tbody dir-paginate=\"item in report.datas | itemsPerPage: report.datasPerPage\" pagination-id=\"reportPaginate\" total-items=\"report.totalDatas\" current-page=\"report.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (report.pagination.current - 1) * report.datasPerPage }}</td><td>{{ item.sg_day_time * 1000 | date }}</td><td style=\"cursor:default;\"><a ui-sref=\"app.business-expenses({param:{ju_no:item.ju_no,sg_no:item.sg_no}})\" bs-tooltip=\"\'この作業報告No.で経費登録します\'\">{{ item.sg_no }}</a></td><td>{{ item.ju_no }}</td><td><span bs-tooltip=\"item.toku_nm\">{{ item.toku_nm }}</span></td><td colspan=\"2\"><span bs-tooltip=\"item.hin_nm\">{{ item.hin_nm }}</span></td><td><span bs-tooltip=\"item.studio_nm\">{{ item.studio_nm }}</span></td><td rowspan=\"2\"><span ng-if=\"item.sn_fl_1 == 0 && item.sn_fl_2 == 0\"><a href=\"\" ng-click=\"editEnabled=!editEnabled;report.editModeInit(2, item.ju_no, item.sg_no);\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" bs-tooltip=\"\'作業報告編集\'\" class=\"btn btn-danger btn-xs mini-button\">編集</a></span> <span ng-if=\"item.sn_fl_1 != 0 || item.sn_fl_2 != 0\"><a href=\"\" ng-click=\"editEnabled=!editEnabled;report.editModeInit(2, item.ju_no, item.sg_no);\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" bs-tooltip=\"\'作業報告確認\'\" class=\"btn btn-info btn-xs mini-button\">確認</a></span></td><td rowspan=\"2\"><span class=\"label label-danger label-mini\" ng-if=\"item.sn_fl_1 == 0 && item.sn_fl_2 == 0\">未</span> <span class=\"label label-info label-mini\" ng-if=\"item.sn_fl_1 != 0 || item.sn_fl_2 != 0\">済</span></td></tr><tr><td>{{ item.ju_bumon_nm }}</td><td>{{ item.ju_tanto_nm }}</td><td>{{ item.sg_bmn_nm }}</td><td>{{ item.gj_nm_1 }}</td><td>{{ item.gj_nm_2 }}</td><td>{{ item.gj_nm_3 }}</td><td><span ng-if=\"item.sg_tm_fm > 0\">{{ item.sg_tm_fm | totime }}～{{ item.sg_tm_to | totime }}</span></td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"report.datas\"><dir-pagination-controls on-page-change=\"report.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"reportPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"report.pagination.current * report.datasPerPage - (report.datasPerPage -1) +\'～\'+((report.pagination.current * report.datasPerPage - report.datasPerPage) + report.datas.length) +\'件/\'+report.totalDatas+\'件\'\"></span></div>");
$templateCache.put("app/business-report/reportedit.html","<div class=\"modal modal-wide modal-sgyt\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\" ng-if=\"report.editScope.editMode == 1\">作業報告新規登録</h4><h4 class=\"modal-title text-center\" ng-if=\"report.editScope.editMode == 2\"><span>作業報告編集 <small class=\"text-danger\" style=\"font-size:10px\" ng-if=\"report.approvalUser && !report.isFromDisabled\">&nbsp;&nbsp;承認前に変更を行った場合はまず先に変更処理を行ってください。</small></span></h4></div><div class=\"col-xs-5 text-right\" ng-if=\"report.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"report.editScope.reportSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"report.editScope.sgytError || report.editScope.sgkyItems.length == 0 || reportForm.$invalid\">登録</button></div><div class=\"col-xs-5 text-right\" ng-if=\"report.editScope.editMode == 2\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-if=\"report.approvalUser && !report.isFromDisabled\" ng-click=\"report.editScope.approvalSubmit()\" ng-disabled=\"report.isFromDisabled || report.isEditDisabled || reportForm.$invalid\">承認</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"report.approvalUser && report.isFromDisabled\" ng-click=\"report.editScope.approvalResetSubmit()\" ng-disabled=\"report.isEditDisabled\">承認取消</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"report.editScope.reportSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"report.isFromDisabled || report.isEditDisabled || report.editScope.sgkyItems.length == 0 || reportForm.$invalid\">変更</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"report.editScope.reportSubmit(\'DELETE\')\" style=\"width:100px\" ng-disabled=\"report.isFromDisabled || report.isEditDisabled\">削除</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide();report.editScope.cancel(report.editScope.editMode)\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit\" disable-all=\"report.isFromDisabled || report.isEditDisabled\"><form role=\"form\" name=\"reportForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><tbody><tr><td style=\"width:12%\" class=\"title\">作業伝票No.</td><td style=\"width:12%\">{{ report.editForm.sg_no }} <input type=\"hidden\" name=\"sg_no\" class=\"form-control input-sm\" ng-model=\"report.editForm.sg_no\"></td><td style=\"width:10%\" class=\"title\">得意先</td><td style=\"width:40%\">{{ report.editScope.item.toku_nm }} {{ report.editScope.item.toku_bumon_nm }} {{ report.editScope.item.toku_tanto_nm }} 様</td><td style=\"width:10%\" class=\"title\">担当営業</td><td>{{ report.editScope.item.ju_tanto_nm }}</td></tr><tr><td class=\"title\">受注No.</td><td>{{ report.editForm.ju_no }} <input type=\"hidden\" name=\"ju_no\" class=\"form-control input-sm\" ng-model=\"report.editForm.ju_no\"></td><td class=\"title\">作品名</td><td colspan=\"3\">{{ report.editScope.item.hin_nm }} <input type=\"hidden\" name=\"sg_no\" class=\"form-control input-sm\" ng-model=\"report.editScope.item.hin_nm\"></td></tr></tbody></table></div><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:20%\">作業部門</th><th style=\"width:20%\">業務区分</th><th style=\"width:20%\">作業形態</th><th>スタジオ</th><th style=\"width:120px\">作業日</th><th colspan=\"2\" style=\"width:145px\">作業時間(前後含)<span ng-if=\"report.editScope.sgytError\" class=\"text-danger\">※時間が間違っています</span></th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.sg_bmn_cd\" ng-change=\"report.changeSgBmnCd()\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.sghtDropdown\" bs-select=\"\" disabled=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"report.editForm.gyomu_kb\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.gyomuDropdown\" bs-select=\"\" disabled=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"report.editForm.sg_keitai_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.sgktDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"report.editForm.studio_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in report.editScope.studioDropdown\" bs-select=\"\" required=\"\"><span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.editForm.sg_day\" name=\"sg_day\" bs-datepicker=\"\" placeholder=\"年月日\" style=\"width:115px\" required=\"\"></td><td><input type=\"text\" class=\"form-control input-sm\" name=\"sg_tm_fm\" ng-model=\"report.editForm.sg_tm_fm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"width:50px;ime-mode:disabled\" ng-blur=\"report.setsghtTime()\" required=\"\"> <input type=\"text\" class=\"form-control input-sm\" name=\"sg_tm_to\" ng-model=\"report.editForm.sg_tm_to\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"width:50px;ime-mode:disabled\" ng-blur=\"report.setsghtTime()\" required=\"\"></td><td style=\"width:40px\"><input type=\"text\" id=\"sgyt-time\" class=\"form-control input-sm\" ng-model=\"report.editScope.sg_time\" disabled=\"\"></td></tr></tbody></table><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th colspan=\"2\">作業技術員</th><th colspan=\"2\">作業時間(前後含)</th><th>前</th><th>後</th><th colspan=\"2\">作業技術員</th><th colspan=\"2\">作業時間(前後含)</th><th>前</th><th>後</th></tr></thead><tbody class=\"fit\"><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_kb_1\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in report.editScope.gjPatternDropdown\" ng-change=\"report.changeGjKtPat1(1);\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_cd_1\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in report.editScope.gjktSyaDropdown1 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_1\" ng-model=\"report.editForm.gj_tm_fm_1\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime1()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_1\" ng-model=\"report.editForm.gj_tm_to_1\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime1()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_1\" class=\"form-control input-sm\" ng-model=\"report.editForm.gj_time_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_1\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_mae_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_1\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_ato_1\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_kb_2\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in report.editScope.gjPatternDropdown\" ng-change=\"report.changeGjKtPat2(1);\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_cd_2\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in report.editScope.gjktSyaDropdown2 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_2\" ng-model=\"report.editForm.gj_tm_fm_2\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime2()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_2\" ng-model=\"report.editForm.gj_tm_to_2\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime2()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_2\" class=\"form-control input-sm\" ng-model=\"report.editForm.gj_time_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_2\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_mae_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_2\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_ato_2\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><tr><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_kb_3\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in report.editScope.gjPatternDropdown\" ng-change=\"report.changeGjKtPat3(1);\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_cd_3\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in report.editScope.gjktSyaDropdown3 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_3\" ng-model=\"report.editForm.gj_tm_fm_3\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime3()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_3\" ng-model=\"report.editForm.gj_tm_to_3\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime3()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_3\" class=\"form-control input-sm\" ng-model=\"report.editForm.gj_time_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"><br></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_3\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_mae_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_3\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_ato_3\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:100px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_kb_4\" placeholder=\"--\" bs-options=\"item.gj_kb as item.text for item in report.editScope.gjPatternDropdown\" ng-change=\"report.changeGjKtPat4(1);\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><button type=\"button\" class=\"btn btn-default btn-block normal\" ng-model=\"report.editForm.gj_cd_4\" placeholder=\"--\" bs-options=\"item.gj_cd as item.name for item in report.editScope.gjktSyaDropdown4 | orderBy:[\'!!gj_cd\', \'gj_cd\']\" ng-disabled=\"!report.editForm.sg_bmn_cd\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:120px\"><input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_fm_4\" ng-model=\"report.editForm.gj_tm_fm_4\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime4()\"> <input type=\"text\" class=\"form-control input-sm\" name=\"gj_tm_to_4\" ng-model=\"report.editForm.gj_tm_to_4\" model-view-value=\"true\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ui-mask=\"99:99\" style=\"width:57px;ime-mode:disabled\" ng-blur=\"report.setGjTime4()\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_4\" class=\"form-control input-sm\" ng-model=\"report.editForm.gj_time_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'0.0H\');\" disabled=\"\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_mae_4\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_mae_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td><td style=\"width:45px\"><input type=\"text\" id=\"gj_time_ato_4\" class=\"form-control input-sm\" ng-disabled=\"!report.editForm.sg_bmn_cd\" ng-model=\"report.editForm.gj_time_ato_4\" model-format=\"float\" formatter=\"timeformat($modelValue,$filter,\'\');\"></td></tr></tbody></table></div><div class=\"col-md-12\"><div class=\"well\" style=\"font-size:90%;padding-top:0;height:75px\" ng-if=\"report.editScope.printShow\"><div class=\"row\"><div class=\"col-xs-1\"><span style=\"font-size:80%;\">プリント</span> <input type=\"checkbox\" ng-model=\"report.editForm.print_fl\" ng-true-value=\"1\" ng-false-value=\"0\"></div><div class=\"col-xs-7\"><table><tr><td style=\"width:300px;text-align:top;\"><span style=\"font-size:75%;width:90px;height:25px\">納品日時</span><div class=\"form-inline\"><div class=\"form-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"report.editForm.print_nh_dt\" name=\"print_nh_dt\" bs-datepicker=\"\" placeholder=\"年月日\" data-autoclose=\"false\" style=\"font-size:85%;width:85px;height:25px;\" ng-disabled=\"!report.editForm.print_fl\"></div><div class=\"form-group\"><input class=\"form-control input-sm\" size=\"8\" ng-model=\"report.editForm.print_nh_dt\" name=\"print_nh_dt_tm\" bs-timepicker=\"\" data-autoclose=\"false\" placeholder=\"時間\" data-time-format=\"HH:mm\" data-length=\"1\" data-minute-step=\"1\" data-arrow-behavior=\"picker\" type=\"text\" style=\"font-size:85%;width:60px;height:25px;\" ng-disabled=\"!report.editForm.print_fl\"></div></div><input type=\"text\" class=\"form-control input-sm\" placeholder=\"補足\" style=\"font-size:90%;width:180px;height:25px\" ng-model=\"report.editForm.nh_hosoku\" ng-disabled=\"!report.editForm.print_fl\"></td><td style=\"width:250px\"><div class=\"input-group\" style=\"font-size:90%;\"><label style=\"font-weight: normal;\" ng-repeat=\"status in report.editScope.printStatus1\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"report.editForm.nh_kb\" value=\"{{status.id}}\" ng-disabled=\"!report.editForm.print_fl\">&nbsp;&nbsp;</label></div></td></tr></table></div><div class=\"col-xs-4\" style=\"font-size:90%;\"><label style=\"font-size:75%;height:25px\">原版</label><div class=\"input-group\"><label style=\"font-weight: normal;\" ng-repeat=\"status in report.editScope.printStatus2\">{{status.name}}&nbsp; <input type=\"radio\" ng-model=\"report.editForm.genban_kb\" value=\"{{status.id}}\" ng-disabled=\"!report.editForm.print_fl\">&nbsp;&nbsp;</label></div></div></div></div></div></div><div class=\"row\" ng-if=\"!report.editScope.printShow\"><div class=\"col-md-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-md-12\"><div ng-include=\"report.templateUrl_1\"></div><table class=\"table table-bordered table-striped fit\"><thead class=\"fit\"><tr class=\"active\"><th>メモ</th></tr></thead><tbody class=\"fit\"><tr><td><textarea type=\"text\" class=\"form-control input-sm normal\" ng-model=\"report.editForm.sghtMemo\"></textarea></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><span ng-if=\"report.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span><br><span ng-if=\"report.editScope.sgkyItems.length == 0\" class=\"text-danger pull-left\">※1件以上は作業項目の登録が必要です</span><br><p class=\"text-left\" style=\"font-size:90%\">※作業項目コードが入力されていない行のデータは登録されません</p></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();report.editScope.cancel(report.editScope.editMode)\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-workearnings/delcheck.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">削除の確認</h4></div><div class=\"modal-body\"><h5 class=\"text-center\" ng-if=\"wkearn.delCheck.type == 1\">同じ作品（受注No)で複数に売上が分けれている場合、すべての売上が削除されます。<br>売上計上をやり直す場合は受注一覧よりもう一度新規売上登録を行ってください。</h5><h5 class=\"text-center\" ng-if=\"wkearn.delCheck.type == 2\">同じ作品（受注No)で分割された売上があり、すでに承認済みです。この売上は削除できません。<br></h5><h5 class=\"text-center\" ng-if=\"wkearn.delCheck.type == 3\">削除を実行しますか？</h5><span ng-if=\"wkearn.delCheck.type != 3\"><h5>納品No.</h5><span ng-repeat=\"item in wkearn.delCheck.data\"><input type=\"text\" value=\"{{item}}\" style=\"width:180px\" readonly=\"\"></span></span><br><button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-if=\"wkearn.delCheck.type == 1 || wkearn.delCheck.type == 3\" ng-click=\"wkearn.editScope.uriageSubmit(\'DELETE\')\" style=\"width:80px\">削除実行</button></div></div></div></div>");
$templateCache.put("app/business-workearnings/error.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-danger\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">処理続行エラー</h4></div><div class=\"modal-body\"><h6 class=\"text-center\">{{ wkearn.errorMessage }}</h6></div></div></div></div>");
$templateCache.put("app/business-workearnings/print.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">見積もり印刷確認</h4></div><div class=\"modal-body\"><h5>料金交渉済（承認済）の明細を見積もりとして印刷します。</h5><h6>同じ作品(受注No)で分割された承認済のデータも合わせて印刷する場合はチェックしてください</h6><div class=\"row\"><div class=\"col-xs-8\"></div><div class=\"col-xs-4\"><input type=\"checkbox\" ng-model=\"print_all_check\">&nbsp;&nbsp;&nbsp; <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"wkearn.uriagePrint(print_all_check)\">印刷実行</button></div></div></div></div></div></div>");
$templateCache.put("app/business-workearnings/uriageedit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title text-center\" ng-if=\"wkearn.editMode == \'1\'\">売上新規入力</h4><h4 class=\"modal-title text-center\" ng-if=\"wkearn.editMode == \'2\'\"><span>売上変更 <small class=\"text-danger\" style=\"font-size:10px\" ng-if=\"wkearn.editMode == \'2\' && wkearn.approvalUser && !wkearn.isFromDisabled\">&nbsp;&nbsp;承認前に変更を行った場合はまず先に変更処理を行ってください。</small></span></h4></div><div class=\"col-xs-6 text-right\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-if=\"wkearn.editMode == \'2\' && wkearn.approvalUser && !wkearn.isFromDisabled\" ng-click=\"wkearn.editScope.wkApprovalSubmit(\'approval\')\" ng-disabled=\"wkearn.uriageData.detail.length == 0 || wkearn.editForm.nebiki_kin < 0 || !completeForm.jt_ur_kin.$valid || wkearn.isFromDisabled || wkearn.isEditDisabled || wkearn.isAddDisabled || wkearn.isFormKinAddErr || completeForm.$invalid || !wkearn.editForm.toku_cd\">承認</button> <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-if=\"wkearn.editMode == \'2\' && wkearn.approvalUser && wkearn.isFromDisabled\" ng-click=\"wkearn.editScope.unApprovalSubmit()\" ng-disabled=\"wkearn.isAddDisabled\">承認取消</button> <button type=\"button\" class=\"btn btn-info btn-sm\" ng-if=\"wkearn.editMode == \'2\' && !(wkearn.editForm.sn_fl_1 == 1 && wkearn.editForm.sn_fl_2 == 0)\" ng-click=\"wkearn.editScope.wkApprovalSubmit(\'request\')\" ng-disabled=\"wkearn.uriageData.detail.length == 0 || wkearn.editForm.nebiki_kin < 0 || !completeForm.jt_ur_kin.$valid || wkearn.isFromDisabled || wkearn.isEditDisabled || wkearn.isAddDisabled || wkearn.isFormKinAddErr\">承認要求</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-if=\"wkearn.editMode == \'2\'\" ng-click=\"wkearn.editScope.uriageSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"wkearn.editScope.uriageDtl.length == 0 || wkearn.editForm.nebiki_kin < 0 || !completeForm.jt_ur_kin.$valid || wkearn.isFromDisabled || wkearn.isEditDisabled || wkearn.isAddDisabled || wkearn.isFormKinAddErr || completeForm.$invalid || !wkearn.editForm.toku_cd\">売上更新</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-if=\"wkearn.editMode == \'1\'\" ng-click=\"wkearn.editScope.uriageSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"wkearn.editScope.uriageDtl.length == 0 || wkearn.editForm.nebiki_kin < 0 || !completeForm.jt_ur_kin.$valid || wkearn.isFromDisabled || wkearn.isAddDisabled || wkearn.isFormKinAddErr || completeForm.$invalid || !wkearn.editForm.toku_cd\">売上登録</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"wkearn.editMode == \'2\'\" ng-click=\"wkearn.editScope.uriageDelete()\" style=\"width:80px\" ng-disabled=\"wkearn.editScope.uriageDtl.length == 0 || wkearn.editForm.nebiki_kin < 0 || !completeForm.jt_ur_kin.$valid || wkearn.isFromDisabled || wkearn.isEditDisabled || wkearn.isAddDisabled || wkearn.isFormKinAddErr\">削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"wkearn.editMode == \'2\' && wkearn.uriagePrint\" ng-click=\"wkearn.addEstimate()\" style=\"width:80px\">見積印刷</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body\"><form role=\"form\" name=\"completeForm\" novalidate=\"\" disable-all=\"wkearn.isFromDisabled || wkearn.isEditDisabled\"><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:10%\">納品No.</th><th style=\"width:10%\">受注No.</th><th style=\"width:10%\">売上計上日</th><th colspan=\"2\">得意先</th><th style=\"width:10%\" ng-if=\"wkearn.editForm.sk_tani != 1\">請求単位</th></tr></thead><tbody class=\"fit\"><tr><td class=\"text-center\" ng-if=\"wkearn.editMode == \'2\'\"><span ng-if=\"wkearn.editScope.pagination.current == 1 && wkearn.editForm.nh_no\">{{ wkearn.editForm.nh_no }}</span></td><td class=\"title\" ng-if=\"wkearn.editMode == \'1\'\"></td><td class=\"text-center\">{{ wkearn.editForm.ju_no }}</td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.editForm.ur_day\" name=\"ur_day\" bs-datepicker=\"\" data-autoclose=\"true\" placeholder=\"年月日\" style=\"width:80px\" required=\"\"></td><td style=\"width:100px\"><div angucomplete-alt=\"\" initial-value=\"wkearn.editForm.toku_cd\" maxlength=\"8\" placeholder=\"得意先CD\" pause=\"1000\" selected-object=\"wkearn.editScope.tokuisakiSelected\" remote-api-handler=\"wkearn.editScope.tokuisakiApiSearch\" auto-match=\"true\" title-field=\"toku_cd\" description-field=\"name\" minlength=\"3\" field-required=\"true\" input-class=\"form-control form-control-small input-sm\" ng-disabled=\"wkearn.isEditDisabled\"></div></td><td>{{ wkearn.editForm.toku_nm }}</td><td ng-if=\"wkearn.editForm.sk_tani != 1\"><button type=\"button\" class=\"btn btn-default sktani-btn\" ng-model=\"wkearn.editForm.sk_tani\" placeholder=\"--\" bs-options=\"item.id as item.name for item in wkearn.editScope.seikyuTaniDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td></tr></tbody></table><table class=\"table table-bordered fit\"><tbody class=\"fit\"><tr><td class=\"title text-center\">得意先部署名</td><td style=\"width:350px\"><input type=\"text\" ng-model=\"wkearn.editForm.toku_busyo\"></td><td class=\"title text-center\">担当者名</td><td><input type=\"text\" ng-model=\"wkearn.editForm.toku_tanto\"></td><td style=\"width:45px\"><input type=\"text\" ng-model=\"wkearn.editForm.keisyo\"></td><td class=\"title text-center\">請求日</td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.editForm.sk_day\" name=\"ur_day\" bs-datepicker=\"\" data-autoclose=\"true\" placement=\"left\" placeholder=\"年月日\" style=\"width:80px\" required=\"\"></td></tr><tr><td class=\"title text-center\">作品名</td><td colspan=\"6\"><input type=\"text\" ng-model=\"wkearn.editForm.sakuhin_nm\"></td></tr></tbody></table><table class=\"table table-bordered fit\"><thead class=\"fit\"><tr class=\"active\"><th>基準売上額</th><th>値引き額</th><th>実質売上額</th><th>消費税額</th><th>合計</th><th style=\"border-top:none;border-bottom:none;background-color:#fff\"></th><th>値引率</th><th>値引理由</th></tr></thead><tbody class=\"fit\"><tr><td class=\"title text-right\">{{ wkearn.editForm.kj_ur_kin | number }}</td><td class=\"title text-right\">{{ wkearn.editForm.nebiki_kin | number }}</td><td class=\"title text-right\"><input type=\"text\" style=\"text-align:right\" name=\"jt_ur_kin\" ng-model=\"wkearn.editForm.jt_ur_kin\" ng-validate=\"required\" model-format=\"number\" numeric-only=\"\"></td><td class=\"title text-right\">{{ wkearn.editForm.zei_kin | number }}</td><td class=\"title text-right\">{{ wkearn.editScope.goukei | number }}</td><td style=\"border-top:none;border-bottom:none;background-color:#fff\"></td><td class=\"title text-right\">{{ wkearn.editForm.nebiki_ritu }}%</td><td><input type=\"text\" ng-model=\"wkearn.editForm.nebiki_riyu\"></td></tr></tbody></table><div class=\"col-md-12\"><div class=\"caption\"><button type=\"button\" class=\"btn btn-xs btn-default\" ng-model=\"sgSelected\" ng-click=\"wkearn.sgDtlSelectMode=!wkearn.sgDtlSelectMode\" bs-checkbox=\"\">明細選択</button> <button type=\"button\" class=\"btn btn-xs btn-danger\" ng-if=\"wkearn.sgDtlSelectMode\" ng-click=\"wkearn.editScope.dtlReflection()\" ng-disabled=\"wkearn.isAddDisabled\">選択反映</button><dir-pagination-controls ng-if=\"!wkearn.sgDtlSelectMode\" on-page-change=\"wkearn.editScope.pageChanged(newPageNumber)\" boundary-links=\"false\" direction-links=\"false\" template-url=\"app/components/pagination/dtlPagination.tpl.html\" pagination-id=\"dtlPaginate\"></dir-pagination-controls><button type=\"button\" class=\"btn btn-xs btn-success\" ng-if=\"wkearn.sgDtlSelectMode\" ng-click=\"wkearn.editModeInit(wkearn.editScope.editMode,wkearn.editForm.ju_no,wkearn.editForm.nh_no)\" ng-disabled=\"wkearn.isAddDisabled\">リセット</button> <small ng-if=\"wkearn.isFormKinAddErr\" class=\"text-danger\">&nbsp;※分割した明細のページを表示させ編集を行ってください</small></div><div class=\"text-center\"></div><label class=\"text-danger\" ng-if=\"wkearn.editForm.nebiki_kin < 0\">※値引き額がマイナスになっています。実質売上額を調整してください。</label></div></div><div class=\"col-md-12\" ng-if=\"!wkearn.sgDtlSelectMode\"><div dir-paginate=\"urDtl in wkearn.editScope.uriageDtl | itemsPerPage: 1\" pagination-id=\"dtlPaginate\" total-items=\"wkearn.editScope.uriageDtlTotal\" current-page=\"wkearn.editScope.pagination.current\"><div id=\"scrollable-area\"><table class=\"table table-bordered fit\" style=\"min-height:200px\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:5%\">No.</th><th style=\"width:50%\" colspan=\"2\">項目</th><th style=\"width:10%\">時間/プリント</th><th>数量</th><th>単価</th><th style=\"width:10%\">金額</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, items) in wkearn.filteredDtl | groupBy:\'sg_no\'\"><tr class=\"active-info\"><td colspan=\"7\" class=\"text-left\" style=\"margin-left:5%\">{{ items[0].sg_day_time*1000 | date:\'yyyy/MM/dd\' }}&nbsp;</td></tr><tr class=\"text-center\" ng-repeat=\"item in items | orderBy:\'sg_gyo_no\':false\"><td>{{ item.sg_gyo_no }}</td><td>{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nms }}</td><td><span ng-if=\"item.media_cd_1 && item.media_cd_2\">{{ wkearn.getMediaName(item.media_cd_1) }} → {{ wkearn.getMediaName(item.media_cd_2) }}</span> <span ng-if=\"(item.stt_tm && item.stt_tm !=\'00:00\') && (item.end_tm && item.end_tm !=\'00:00\')\">{{item.stt_tm_str}} ～ {{item.end_tm_str}}</span></td><td style=\"width:100px\" class=\"text-right\"><span ng-if=\"item.suryo_1 && (item.suryo_2 != 0.0 && item.suryo_2 != 0)\">{{item.suryo_1}}&nbsp;{{item.tani_1}}&nbsp;/&nbsp;{{ item.suryo_2 }}&nbsp;{{ item.tani_2 }}</span> <span ng-if=\"item.suryo_1 && (item.suryo_2 == 0.0 || item.suryo_2 == 0 || !item.suryo_2)\">{{ item.suryo_1 }}&nbsp;{{ item.tani_1 }}</span></td><td style=\"width:100px\" class=\"text-right\">{{ item.tanka | number }}</td><td class=\"text-right\">{{ item.kin | number }}</td></tr></tbody><tfoot class=\"fit\"><tr><td rowspan=\"3\" class=\"active\">備考</td><td colspan=\"6\"><input type=\"text\" ng-model=\"wkearn.editForm.biko_1\" maxlength=\"400\"></td></tr><tr><td colspan=\"6\"><input type=\"text\" ng-model=\"wkearn.editForm.biko_2\" maxlength=\"400\"></td></tr><tr><td colspan=\"6\"><input type=\"text\" ng-model=\"wkearn.editForm.biko_3\" maxlength=\"400\"></td></tr></tfoot></table></div></div></div><div class=\"col-md-12\" ng-if=\"wkearn.sgDtlSelectMode\"><div id=\"scrollable-area\"><table class=\"tg-table-green fit\" style=\"min-height:200px\"><thead class=\"fit\"><tr class=\"active\"><th colspan=\"4\" style=\"width:15%\">作業日</th><th style=\"width:10%\">伝票No.</th><th style=\"width:10%\">作業部門</th><th style=\"width:10%\">業務区分</th><th colspan=\"2\" style=\"width:15%\">スタジオ</th><th colspan=\"3\" style=\"width:20%\">作業形態</th><th style=\"width:30px\">P</th><th style=\"width:15%\">作業金額合計</th></tr><tr class=\"active\"><th></th><th>#</th><th>No.</th><th colspan=\"4\">項目</th><th colspan=\"2\">時間/プリント</th><th colspan=\"2\" style=\"width:150px\">数量</th><th colspan=\"2\" style=\"width:150px\">単価</th><th>金額</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, detail) in wkearn.completeData.detail\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr class=\"active-info text-center\"><td><input type=\"checkbox\" name=\"parentChl_{{key}}\" ng-model=\"detail.sgur.checked\" ng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"wkearn.completeScope.parentChkChange(detail.sgur.checked, key, detail.sgur.sg_no)\" ng-disabled=\"wkearn.completeData.desabledCheck(detail.sgurDtl)\"></td><td colspan=\"3\">{{detail.sgur.sg_day_time*1000 | date:\'yyyy/MM/dd\' }} {{ detail.disabled }}:{{ detail.sgur.disabled }}</td><td>{{detail.sgur.sg_no}}</td><td>{{detail.sgur.bumon_nm}}</td><td>{{ orders.getGyomuName(detail.sgur.gyomu_kb) }}</td><td colspan=\"2\">{{ detail.sgur.studio_nm }}</td><td colspan=\"3\">{{ detail.sgur.sg_keitai_nm }}</td><td style=\"width:30px\"><span ng-if=\"detail.sgur.print_fl > 0\">●</span></td><td class=\"text-right\">{{detail.sgur.sg_kin | number }}</td></tr><tr ng-repeat=\"item in detail.sgurDtl\" class=\"text-center\"><td></td><td><input type=\"checkbox\" ng-model=\"item.checked\" ng-checked=\"item.checked\" ng-true-value=\"1\" ng-false-value=\"0\" ng-change=\"wkearn.completeScope.childChkChange(item.checked, item.gyo_no, detail.sgur.sg_no,item.sg_item_cd, item.gr_arr_no, key, $index)\" ng-disabled=\"item.disabled || item.gr_arr_no == null || item.sliced_checked\"></td><td>{{ item.gyo_no }}</td><td>{{ item.sg_item_cd }}</td><td colspan=\"3\" class=\"text-left\">{{ item.sg_item_nm }}</td><td colspan=\"2\"><span ng-if=\"detail.sgur.print_fl > 0\"><span ng-if=\"item.media_cd_1 && item.media_cd_2\">{{ wkearn.getMediaName(item.media_cd_1) }} → {{ wkearn.getMediaName(item.media_cd_2) }}</span></span> <span ng-if=\"detail.sgur.print_fl == 0\"><span ng-if=\"(item.stt_tm && item.stt_tm !=\'00:00\') && (item.end_tm && item.end_tm !=\'00:00\')\">{{item.stt_tm}} ～ {{item.end_tm}}</span></span></td><td colspan=\"2\" style=\"width:100px\" class=\"text-right\"><span ng-if=\"item.suryo_1 && (item.suryo_2 != 0.0 && item.suryo_2 != 0)\">{{ item.suryo_2 }} {{ item.tani_2 }}</span> <span ng-if=\"item.suryo_1 && (item.suryo_2 == 0.0 || item.suryo_2 == 0 || !item.suryo_2)\">{{ item.suryo_1 }} {{ item.tani_1 }}</span></td><td colspan=\"2\" style=\"width:100px\" class=\"text-right\"><span ng-if=\"!item.tanka\">{{ item.base_tanka | number }}</span> <span ng-if=\"item.tanka\">{{ item.tanka | number }}</span></td><td class=\"text-right\">{{ item.kin | number }}</td></tr></tbody><tfoot><tr><td colspan=\"14\" class=\"text-right\">選択合計：{{ wkearn.getTotalKin(wkearn.editScope.dummyUriageDtl) | number }} | 合計：{{ wkearn.getSgTotalKin(wkearn.completeData.detail) | number }}</td></tr></tfoot></table></div></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-6\"><span ng-if=\"wkearn.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span><br><p class=\"text-left\" style=\"font-size:90%\" 　ng-if=\"wkearn.editMode==2\">※変更したデータ(値引等)を印刷するには一度｢売上更新｣を行ってください</p></div><div class=\"col-xs-6\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide();wkearn.editScope.cancel(wkearn.editMode)\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/business-workearnings/wkearn.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-show=\"wkearn.form\"><button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">計上日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.fromDate\" data-max-date=\"{{wkearn.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">計上日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.untilDate\" data-min-date=\"{{wkearn.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.ju_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">受注No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.ju_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先</span><div angucomplete-alt=\"\" id=\"ex2\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"300\" selected-object=\"wkearn.tokuisakiSelected\" remote-api-handler=\"wkearn.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control input-sm\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作品名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"作品名\" ng-model=\"wkearn.form.hin_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"wkearn.sgBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.sg_bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"sg_bumon_cd\" ng-model=\"wkearn.form.sg_bumon_cd\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.fromSkDate\" data-max-date=\"{{wkearn.form.untilSkDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.untilSkDate\" data-min-date=\"{{wkearn.form.fromSkDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">納品No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.nh_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">納品No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.form.nh_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"wkearn.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">受注部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.bumon_nm\" disabled=\"\"> <input type=\"hidden\" name=\"ins_bmn_cd\" ng-model=\"wkearn.form.ju_bumon_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"wkearn.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.ju_tanto_nm\" placeholder=\"先に受注部門を選択してください\" disabled=\"\"> <input type=\"hidden\" name=\"ju_tanto_cd\" ng-model=\"wkearn.form.ju_tanto_cd\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"wkearn.snflStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">承認 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.sn_fl_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"wkearn.skflStatusDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">請求 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"wkearn.sk_fl_nm\" disabled=\"\"></div></div></div><div class=\"col-xs-7\"><div style=\"font-size:85%\">※最初に別の条件を選択し、絞り込む必要があるものがあります（例：担当営業)</div><div style=\"font-size:85%\">※作業部門の絞込みは合計実質売上の確認にのみお使いください</div><div style=\"font-size:85%\">※受注部門を選択した場合は作業部門は無視されます</div></div><div class=\"col-xs-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"wkearn.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"wkearn.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"wkearn.datas\"><dir-pagination-controls on-page-change=\"wkearn.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"wkearn.pagination.current * wkearn.datasPerPage - (wkearn.datasPerPage -1) +\'～\'+((wkearn.pagination.current * wkearn.datasPerPage - wkearn.datasPerPage) + wkearn.datas.length) +\'件/\'+wkearn.totalDatas+\'件\'\"></span> <span class=\"goukei-label\">&nbsp;&nbsp;&nbsp;合計&nbsp;&nbsp;{{ wkearn.totalKin | number}}円</span></div><div class=\"table-responsive item-table\" ng-show=\"wkearn.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th rowspan=\"2\">#</th><th style=\"width:10%\">売上計上日</th><th style=\"width:8%\">納品No.</th><th style=\"width:15%\">担当営業</th><th>得意先</th><th rowspan=\"2\">操作</th><th rowspan=\"2\" style=\"width:5%\">承認</th><th rowspan=\"2\" style=\"width:5%\">請求</th><th rowspan=\"2\">売上合計<br>(税抜)</th></tr><tr class=\"active\"><th style=\"width:10%\">請求日</th><th style=\"width:12%\">受注No.</th><th>受注部門</th><th style=\"width:30%\">作品名</th></tr></thead><tbody dir-paginate=\"item in wkearn.datas | itemsPerPage: wkearn.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"wkearn.totalDatas\" current-page=\"wkearn.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (wkearn.pagination.current - 1) * wkearn.datasPerPage }}</td><td>{{ item.ur_day_time * 1000 | date }}</td><td>{{ item.nh_no }}</td><td>{{ item.ju_tanto_nm }}</td><td>{{ item.toku_nm }}</td><td rowspan=\"2\" class=\"text-center\"><a href=\"\" ng-click=\"wkearn.editModeInit(2, item.ju_no,item.nh_no);\" ng-if=\"(item.sn_fl_1 == 0 || item.sn_fl_1 == 1) && item.sn_fl_2 == 0\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" class=\"btn btn-danger btn-xs mini-button\" bs-tooltip=\"\'売上編集\'\">編集</a> <a href=\"\" ng-click=\"wkearn.editModeInit(2, item.ju_no,item.nh_no);\" ng-if=\"item.sn_fl_1 == 2 || item.sn_fl_2 > 0\" data-placement=\"top\" data-type=\"info\" data-container=\"body\" class=\"btn btn-info btn-xs mini-button\" bs-tooltip=\"\'売上確認\'\">確認</a></td><td rowspan=\"2\"><span class=\"label label-danger label-mini\" ng-if=\"item.sn_fl_1 == 0 && item.sn_fl_2 == 0\">未</span> <span class=\"label label-warning label-mini\" ng-if=\"item.sn_fl_1 == 1 && item.sn_fl_2 == 0\" bs-tooltip=\"\'{{item.sn_day_1_time* 1000|date:\'yyyy/MM/dd\'}}<br>{{item.sn_tan_1_nm}}\'\">要</span> <span class=\"label label-info label-mini\" ng-if=\"item.sn_fl_1 == 2 || item.sn_fl_2 == 1\" bs-tooltip=\"\'{{item.sn_day_1_time* 1000|date:\'yyyy/MM/dd\'}}<br>{{item.sn_tan_1_nm}}\'\">済</span></td><td rowspan=\"2\"><span class=\"label label-danger label-mini\" ng-if=\"item.sk_no == 0 || !item.sk_no\">未</span> <span class=\"label label-info label-mini\" ng-if=\"item.sk_no > 0\" bs-tooltip=\"\'{{item.sk_day_time* 1000|date:\'yyyy/MM/dd\'}}<br>{{item.sk_no}}\'\">済</span></td><td rowspan=\"2\" class=\"text-right\">{{ item.jt_ur_kin | number }}</td></tr><tr><td>{{ item.sk_day_time * 1000 | date }}</td><td>{{ item.ju_no }}</td><td>{{ item.ju_bumon_nm }}</td><td>{{ item.sakuhin_nm }}</td></tr></tbody></table></div><div class=\"text-center\" ng-show=\"wkearn.datas\"><dir-pagination-controls on-page-change=\"wkearn.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"wkearn.pagination.current * wkearn.datasPerPage - (wkearn.datasPerPage -1) +\'～\'+((wkearn.pagination.current * wkearn.datasPerPage - wkearn.datasPerPage) + wkearn.datas.length) +\'件/\'+wkearn.totalDatas+\'件\'\"></span> <span class=\"goukei-label\">&nbsp;&nbsp;&nbsp;合計&nbsp;&nbsp;{{ wkearn.totalKin | number}}円</span></div>");
$templateCache.put("app/dashboard/dashboard.html","<div ncy-breadcrumb=\"\"></div><div class=\"row\"><div class=\"col-md-6\">Dashbord</div><div class=\"col-md-6\"></div><div class=\"col-md-12\" ng-if=\"dashboard.isAdmin\"><h4>システム管理者にのみ見えるページです。</h4><hr><p>IE(インターネットエクスプローラー)での利用にいて<br>IEの場合、独自の通信量制限が設定されており、場合によっては正常に通信が完了しない可能性があります<br>(月次処理や帳票表示のようなデータ量の多い処理)<br>こういった問題が起こる可能性があるため、出来るだけGoogleChromeやFirefoxでの利用をお勧めします。</p><p>各機能ページにて旧システムで一覧表示できていたものがページングされている場合があります。<br>WEBの場合通信量が増えると途中切断など予期せぬ事象に対処する必要があることと、<br>ひとつのページ内で処理できるデータ量に制限があるのでこのような形を取っております。ご了承ください。</p><hr><p>権限による制限の確認<br>現在権限 ({{ dashboard.user.sys_admin_fl }})</p><ul ng-if=\"dashboard.debug\"><li><button ng-click=\"dashboard.debugAuthChange(\'1\')\">Admin (1)</button>: すべての操作が可能-マスタ操作はAdminのみ</li><li><button ng-click=\"dashboard.debugAuthChange(\'2\')\">一般１ (2)</button>: 一般業務・請求・納品・帳票の操作、承認操作が可能</li><li><button ng-click=\"dashboard.debugAuthChange(\'3\')\">一般２ (3)</button>: 一般業務・請求・納品・帳票の操作が可能</li><li><button ng-click=\"dashboard.debugAuthChange(\'4\')\">一般３ (4)</button>: 一般業務の操作が可能</li><li><button ng-click=\"dashboard.debugAuthChange(\'5\')\">一般４ (5)</button>: 一般業務の閲覧・印刷が可能</li><li><button ng-click=\"dashboard.debugAuthChange(\'6\')\">一般５ (6)</button>: 権限剥奪・ログイン・個人設定のみ</li></ul></div><div class=\"col-md-12\"><div style=\"height:50px\"></div></div></div><div class=\"row\" ng-if=\"dashboard.isAdmin && dashboard.datas.length > 0\"><div class=\"col-md-12\"><h5><span>承認要求中の売上一覧</span>&nbsp;&nbsp; <a ui-sref=\"app.business-workearnings({juno:\'000\',param:{mode:\'approval\'}})\">>>承認を行う</a></h5><div class=\"text-center\" ng-show=\"dashboard.datas\"><dir-pagination-controls on-page-change=\"dashboard.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"dashboard.pagination.current * dashboard.datasPerPage - (dashboard.datasPerPage -1) +\'～\'+((dashboard.pagination.current * dashboard.datasPerPage - dashboard.datasPerPage) + dashboard.datas.length) +\'件/\'+dashboard.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"dashboard.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th>#</th><th style=\"width:8%\">売上計上日</th><th style=\"width:8%\">納品No.</th><th style=\"width:8%\">受注No.</th><th style=\"width:15%\">担当営業</th><th>得意先</th><th style=\"width:30%\">作品名</th><th>売上合計<br>(税抜)</th></tr></thead><tbody dir-paginate=\"item in dashboard.datas | itemsPerPage: dashboard.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"dashboard.totalDatas\" current-page=\"dashboard.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td class=\"text-center\">{{ ($index + 1) + (dashboard.pagination.current - 1) * dashboard.datasPerPage }}</td><td>{{ item.ur_day_time * 1000 | date }}</td><td>{{ item.nh_no }}</td><td>{{ item.ju_no }}</td><td>{{ item.ju_tanto_nm }}</td><td>{{ item.toku_nm }}</td><td>{{ item.sakuhin_nm }}</td><td class=\"text-right\">{{ item.jt_ur_kin | number }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/invoice-add/detail-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">納品No.{{ invoiceadd.detail.uriage.nh_no }} 売上明細 <small>{{ invoiceadd.detail.uriage.toku_nm }}</small></h4></div><div class=\"modal-body\"><table class=\"table table-hover table-bordered item-table\"><thead><tr class=\"active\"><th style=\"width:10px\">#</th><th style=\"width:55px\">作業日</th><th>作業項目</th><th style=\"width:45px\">売上</th></tr></thead><tfoot><tr><td colspan=\"4\" class=\"text-right\"><small>売上：{{ invoiceadd.detail.uriage.kj_ur_kin | number }}<br>値引き：{{ invoiceadd.detail.uriage.nebiki_kin | number }}<br>消費税：{{ invoiceadd.detail.uriage.zei_kin | number }}<br></small><hr style=\"margin:1px;padding:1px\">請求金額：{{ invoiceadd.detail.uriage.jt_ur_kin + invoiceadd.detail.uriage.zei_kin | number }}</td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in invoiceadd.detail.uriageDtl\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td class=\"text-center\">{{ item.gyo_no }}</td><td>{{ item.sg_day_time*1000 | date }}</td><td>{{ item.sg_item_nms }}</td><td>{{ item.kin | number }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/invoice-add/invoiceadd.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"invoiceForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default input-sm dropdown-toggle\" bs-dropdown=\"invoiceadd.simeddDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" required=\"\"><span style=\"font-size:90%\">閉め日</span> <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoiceadd.sime_dd_nm\" disabled=\"\"> <span class=\"input-group-addon\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"invoiceadd.form.any_time_check\"> <span style=\"font-size:90%\">随時含む</span></label></span></div></div><div class=\"col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先指定</span><div angucomplete-alt=\"\" id=\"dr01\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"300\" selected-object=\"invoiceadd.tokuisakiSelected\" remote-api-handler=\"invoiceadd.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div><input type=\"hidden\" name=\"toku_cd\" ng-model=\"invoiceadd.form.toku_cd\"></div></div><div class=\"col-xs-12\">&nbsp;&nbsp;</div><div class=\"form-group col-xs-3\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoiceadd.form.fromDate\" data-max-date=\"{{invoiceadd.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-3\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoiceadd.form.untilDate\" data-min-date=\"{{invoiceadd.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"col-xs-6\"><div class=\"button-group pull-right\"><button type=\"button\" class=\"btn btn-success btn-sm\" style=\"width:150px\" ng-disabled=\"!invoiceadd.form.sk_sime_dd\" ng-click=\"invoiceadd.invoiceGenerate()\">発行</button></div></div></div></form></div></div></div><div class=\"text-left\"><h6>売上計上（承認）済みで、条件に一致する未請求の売上データから請求書データを生成します。<br>印刷はこちらより行ってください <a ui-sref=\"app.invoice-data\">請求書・納品書印刷</a></h6></div><hr><div class=\"text-center\" ng-if=\"invoiceadd.genEnd\">{{invoiceadd.genCnt}} 件の請求書データを生成しました</div><div class=\"text-center\" ng-if=\"invoiceadd.showSearch\"><dir-pagination-controls on-page-change=\"invoiceadd.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\" ng-if=\"invoiceadd.showSearch\"><span ng-if=\"invoiceadd.datasPerPage < invoiceadd.totalDatas\" ng-bind=\"invoiceadd.pagination.current * invoiceadd.datasPerPage - (invoiceadd.datasPerPage -1) +\'～\'+invoiceadd.pagination.current * invoiceadd.datasPerPage+\'件/\'+invoiceadd.totalDatas+\'件\'\"></span> <span ng-if=\"invoiceadd.datasPerPage > invoiceadd.totalDatas\" ng-bind=\"invoiceadd.totalDatas+\'件/\'+invoiceadd.totalDatas+\'件\'\"></span></div><div class=\"text-left\" ng-if=\"invoiceadd.showSearch\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"invoiceadd.invoiceGenerateCheck()\">選択した売上から請求書・納品書データを作成</button> <span ng-if=\"invoiceadd.generateCheckErr\" class=\"text-danger\">※選択してください。</span></div><div class=\"table-responsive item-table\" ng-show=\"invoiceadd.datas\" ng-if=\"invoiceadd.showSearch\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th style=\"width:20px\" rowspan=\"2\">#</th><th style=\"width:60px\">選択<br><a href=\"\" ng-click=\"invoiceadd.allChecked(invoiceadd.itemAllChecked)\"><span ng-if=\"invoiceadd.itemAllChecked\">全解除</span> <span ng-if=\"!invoiceadd.itemAllChecked\">全選択</span></a></th><th style=\"width:65px\">納品No.</th><th style=\"width:65px\">受注No.</th><th style=\"width:90px\">計上日</th><th style=\"width:90px\">請求日</th><th style=\"width:70px\">締め日</th><th colspan=\"2\">得意先</th><th style=\"width:70px\">請求単位</th><th style=\"width:70px\" rowspan=\"2\">売上</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in invoiceadd.datas | itemsPerPage: invoiceadd.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"invoiceadd.totalDatas\" current-page=\"invoiceadd.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (invoiceadd.pagination.current - 1) * invoiceadd.datasPerPage }}</td><td rowspan=\"2\"><input type=\"checkbox\" ng-model=\"item.checked\" ng-click=\"invoiceadd.checkSkTani(item, item.checked)\"></td><td><a href=\"\" ng-click=\"invoiceadd.getUriageDtl(item)\">{{ item.nh_no }}</a></td><td>{{ item.ju_no }}</td><td>{{ item.ur_day_time*1000 | date }}</td><td>{{ item.sk_day_time*1000 | date }}</td><td>{{ item.sime_dd_nm }}</td><td>{{ item.toku_cd }}</td><td>{{ item.toku_nm }}</td><td>{{ invoiceadd.getSeikyuTaniName(item.sk_tani) }}</td><td class=\"text-right\">{{ item.jt_ur_kin + item.zei_kin | number }}</td></tr></tbody></table></div>");
$templateCache.put("app/invoice-add/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください</h6><p><label><input type=\"radio\" value=\"1\" ng-model=\"invoicedata.printType\"> 請求書</label> <label><input type=\"radio\" value=\"2\" ng-model=\"invoicedata.printType\"> 請求書明細</label> <label><input type=\"radio\" value=\"3\" ng-model=\"invoicedata.printType\"> 納品書</label></p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"!invoicedata.printType\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/invoice-data/detail-modal.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\">請求No.{{ invoicedata.detail.uriage.sk_no }} <span ng-if=\"!invoicedata.sk_check\"><small class=\"text-danger\">&nbsp;&nbsp;&nbsp;(月次締処理済)</small></span></h4></div><div class=\"col-xs-6\"><span class=\"pull-right\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-disabled=\"!invoicedata.sk_check\" ng-click=\"invoicedata.seikyuDelete(invoicedata.detail.uriage.sk_no)\" style=\"width:150px\">請求を削除</button></span></div></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-xs-8\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\">請求日</td><td>{{ invoicedata.detail.uriage.sk_day_time*1000 | date }}</td><td class=\"active\">請求先</td><td>{{ invoicedata.detail.uriage.toku_cd }}</td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td style=\"height:58px\" colspan=\"2\">{{ invoicedata.detail.uriage.toku_toku_nm }}<br><br>{{ invoicedata.detail.uriage.toku_tanto_nm }}</td></tr><tr><td style=\"height:58px\" colspan=\"2\">〒{{ invoicedata.detail.uriage.toku_yubin_no }}<br>{{ invoicedata.detail.uriage.toku_adrs1 }}<br>{{ invoicedata.detail.uriage.toku_adrs2 }}</td></tr><tr><td style=\"width:50%\">TEL.{{ invoicedata.detail.uriage.toku_tel_no }}</td><td style=\"width:50%\">FAX.{{ invoicedata.detail.uriage.toku_fax_no }}</td></tr><tr><td style=\"width:50%\">締日 {{ invoicedata.detail.uriage.sime_dd_nm }}</td><td style=\"width:50%\">請求 {{ invoicedata.SetSeikyuTaniNm(invoicedata.detail.uriage.toku_sk_tani) }}</td></tr></tbody></table></div><div class=\"col-xs-4\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\" style=\"width:65px\">請求書</td><td></td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\" style=\"width:65px\">利用金額</td><td class=\"text-right\">{{ invoicedata.detailForm.kijun_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">値引額</td><td class=\"text-right\">{{ invoicedata.detailForm.nebiki_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">特別値引額</td><td class=\"text-right\"><input type=\"text\" style=\"text-align:right;\" ng-disabled=\"!invoicedata.sk_check\" ng-model=\"invoicedata.detailForm.tokubiki_kn\" model-format=\"number\" numeric-only=\"\"></td></tr><tr><td class=\"active\" style=\"width:65px\">特別値引率</td><td class=\"text-right\"><span ng-if=\"invoicedata.detailForm.tokubiki_ritu > 0\">{{ invoicedata.detailForm.tokubiki_ritu }}%</span> <span ng-if=\"!invoicedata.detailForm.tokubiki_ritu\">0%</span></td></tr><tr><td class=\"active\" style=\"width:65px\">差引金額</td><td class=\"text-right\">{{ invoicedata.detailForm.hiki_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">消費税</td><td class=\"text-right\">{{ invoicedata.detailForm.zei_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">請求金額</td><td class=\"text-right\">{{ invoicedata.detailForm.sk_kn | number }}</td></tr></tbody></table><div class=\"seikyu-foot\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"invoicedata.tokubikiSubmit()\" style=\"width:50px\" ng-disabled=\"invoicedata.detailForm.tokubiki_kn == invoicedata.detail.uriage.tokubiki_kn\">更新</button></div></div></div><table class=\"table table-hover table-bordered item-table\" style=\"min-height:100@x;\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:15px\" class=\"sk-fit\">#</th><th style=\"width:65px\" class=\"sk-fit\">納品No.</th><th class=\"sk-fit\">作品名</th><th style=\"width:55px\" class=\"sk-fit\">小計</th><th style=\"width:55px\" class=\"sk-fit\">消費税</th><th style=\"width:55px\" class=\"sk-fit\">合計</th></tr></thead><tbody ng-repeat=\"item in invoicedata.detail.uriageDtl\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" class=\"fit\"><tr><td class=\"text-center\">{{ $index+1 }}</td><td>{{ item.nh_no }}</td><td>{{ item.sakuhin_nm }}</td><td>{{ item.jt_ur_kin | number }}</td><td>{{ item.zei_kin | number }}</td><td>{{ item.jt_ur_kin + item.zei_kin | number }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/invoice-data/invoicedata.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-show=\"invoicedata.form\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.form.fromDate\" data-max-date=\"{{invoicedata.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.form.untilDate\" data-min-date=\"{{invoicedata.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.form.sk_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">請求No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.form.sk_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先</span><div angucomplete-alt=\"\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"300\" selected-object=\"invoicedata.tokuisakiSelected\" remote-api-handler=\"invoicedata.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div><input type=\"hidden\" name=\"toku_cd\" ng-model=\"invoicedata.form.toku_cd\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">発行日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.form.fromHkDate\" data-max-date=\"{{invoicedata.form.untilHkDate}}\" placeholder=\"From\" name=\"fromHkDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">発行日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.form.untilHkDate\" data-min-date=\"{{invoicedata.form.fromHkDate}}\" placeholder=\"To\" name=\"untilHkDate\" data-placement=\"left\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"invoicedata.simeddDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">締日 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"invoicedata.sime_dd_nm\" disabled=\"\"></div></div></div><div class=\"col-md-7\"><div>※本年から3年前までを標準出力しています。<br>※3年以上前のデータは日付指定で検索してください</div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"invoicedata.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"invoicedata.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"invoicedata.datas\"><dir-pagination-controls on-page-change=\"invoicedata.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"invoicedata.pagination.current * invoicedata.datasPerPage - (invoicedata.datasPerPage -1) +\'～\'+invoicedata.pagination.current * invoicedata.datasPerPage+\'件/\'+invoicedata.totalDatas+\'件\'\"></span></div><div class=\"text-left\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"invoicedata.invoiceGenerateCheck()\">選択したデータを印刷</button></div><div class=\"table-responsive item-table\" ng-show=\"invoicedata.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th style=\"width:20px\" rowspan=\"2\">#</th><th style=\"width:60px\">選択<br><a href=\"\" ng-click=\"invoicedata.allChecked(invoicedata.itemAllChecked)\"><span ng-if=\"invoicedata.itemAllChecked\">全解除</span> <span ng-if=\"!invoicedata.itemAllChecked\">全選択</span></a></th><th style=\"width:65px\">請求No.</th><th style=\"width:90px\">請求日</th><th style=\"width:90px\">発行日</th><th colspan=\"2\">得意先</th><th style=\"width:65px\">明細数</th><th style=\"width:70px\" rowspan=\"2\">請求金額</th></tr></thead><tbody dir-paginate=\"item in invoicedata.datas | itemsPerPage: invoicedata.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"invoicedata.totalDatas\" current-page=\"invoicedata.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (invoicedata.pagination.current - 1) * invoicedata.datasPerPage }}</td><td rowspan=\"2\"><input type=\"checkbox\" ng-model=\"item.checked\"></td><td><a href=\"\" ng-click=\"invoicedata.getUriageDtl(item)\" bs-tooltip=\"invoicedata.editTooltipText1\">{{ item.sk_no }}</a></td><td>{{ item.sk_day_time * 1000 | date }}</td><td>{{ item.hk_day_time * 1000 | date }}</td><td>{{ item.toku_cd }}</td><td>{{ item.ur_toku_nm }}</td><td>{{ item.nhin_su }}</td><td class=\"text-right\">{{ item.sk_kn | number }}</td></tr></tbody></table></div>");
$templateCache.put("app/invoice-data/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h5>選択してください</h5><h6>GoogleChromeを利用するとプレビューをPDF化できます<br><small class=\"text-danger\">※Chromeの仕様変更により今後利用出来なくなる可能性もあります</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\">&nbsp;{{ itm.name }}&nbsp;&nbsp;</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-6 col-md-offset-3\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong class=\"\">ログイン</strong></div><div class=\"panel-body\"><form class=\"form-horizontal\" role=\"form\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">ログインID</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" placeholder=\"ID\" required=\"\" ng-model=\"login.user_id\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-3 control-label\">パスワード</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" placeholder=\"Password\" required=\"\" ng-model=\"login.password\"></div></div><div class=\"form-group last\"><div class=\"col-sm-offset-3 col-sm-9\"><button type=\"submit\" class=\"btn btn-success btn-sm\" ng-click=\"login.login()\">ログイン</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/masta-basic/basic.html","<div ncy-breadcrumb=\"\"></div><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"basicForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">会社基本情報<br><div class=\"form-group col-md-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">会社名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"会社名\" ng-model=\"basic.form.kaisya_nm\"></div></div><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">郵便番号</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"〒\" ng-model=\"basic.form.yubin_no\"></div></div><div class=\"form-group col-md-6\"></div><div class=\"form-group col-md-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">住所</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"住所\" ng-model=\"basic.form.adrs\"></div></div><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">Tel</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"Tel\" ng-model=\"basic.form.tel_no\"></div></div><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">Fax</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"Fax\" ng-model=\"basic.form.fax_no\"></div></div></div><div class=\"col-md-12\">会社締/支払情報<br><div class=\"form-group col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">締日</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"締日\" ng-model=\"basic.form.sime_dd\"></div></div><div class=\"form-group col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">支払サイト</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"支払サイト\" ng-model=\"basic.form.site_mm\"></div></div><div class=\"form-group col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">支払日</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"支払日\" ng-model=\"basic.form.sh_dd\"></div></div><div class=\"form-group col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">会計年度</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"yyyy\" ng-model=\"basic.form.kaikei_nendo\"></div></div><div class=\"form-group col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">決算月</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"mm\" ng-model=\"basic.form.kessan_mm\"></div></div></div><div class=\"col-md-12\"></div><div class=\"col-md-12\">月次締情報<br><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:180px\">仮締年月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"basic.form.getuji_ym_kari\" placeholder=\"yyyymm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:180px\">締年月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"basic.form.getuji_ym\" placeholder=\"yyyymm\" disabled=\"\"></div></div></div><div class=\"col-md-12\">基準職務給掛率<br><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 1</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"basic.form.base_rate_over_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 2</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"basic.form.base_rate_over_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 3</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"basic.form.base_rate_over_3\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 4</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"basic.form.base_rate_over_4\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div></div><div class=\"col-md-7\"></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"basic.basicSubmit()\" style=\"width:150px\">更新</button></div></div></div></form></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"kozaForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">口座情報<br><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>銀行CD</th><th>銀行名</th><th>支店CD</th><th>支店名</th><th>預金種別</th><th>口座番号</th><th>口座名義</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"item in basic.koza\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr><td style=\"width:8%\"><input type=\"text\" name=\"bank_cd\" class=\"form-control input-sm\" ng-model=\"item.bank_cd\"></td><td style=\"width:20%\"><input type=\"text\" name=\"bank_nm\" class=\"form-control input-sm\" ng-model=\"item.bank_nm\"></td><td style=\"width:8%\"><input type=\"text\" name=\"siten_cd\" class=\"form-control input-sm\" ng-model=\"item.siten_cd\"></td><td><input type=\"text\" name=\"siten_nm\" class=\"form-control input-sm\" ng-model=\"item.siten_nm\"></td><td><button type=\"button\" class=\"btn btn-default normal\" style=\"width:80px\" ng-model=\"item.yokin_sb\" placeholder=\"--\" bs-options=\"itm.yokin_sb as itm.name for itm in basic.yokinSbDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:10%\"><input type=\"text\" name=\"koza_no\" class=\"form-control input-sm\" ng-model=\"item.koza_no\"></td><td><input type=\"text\" name=\"koza_meigi\" class=\"form-control input-sm\" ng-model=\"item.koza_meigi\"></td><td class=\"text-center\"><a href=\"\" ng-click=\"basic.kozaDelete($index)\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"basic.kozaExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"basic.kozaReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"basic.kozaSubmit(basic.koza)\" style=\"width:150px\">更新</button></div></div></div></form></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"zeiForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">税率管理<br><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>税率適用開始日</th><th>税率適用終了日</th><th>税率</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"item in basic.zei\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr><td style=\"width:20%\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.start_day\" data-max-date=\"{{item.end_day}}\" placeholder=\"開始日\" autoclose=\"true\" name=\"skDate1\" bs-datepicker=\"\"></td><td style=\"width:20%\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.end_day\" data-min-date=\"{{item.start_day}}\" placeholder=\"終了日\" autoclose=\"true\" name=\"skDate1\" bs-datepicker=\"\"></td><td><input type=\"text\" name=\"siten_cd\" class=\"form-control input-sm\" ng-model=\"item.tax_rate\"></td><td class=\"text-center\" 　style=\"width:5%\"><a href=\"\" ng-click=\"basic.zeiDelete($index)\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"basic.zeiExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"basic.zeiReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"basic.zeiSubmit(basic.zei)\" style=\"width:150px\">更新</button></div></div></div></form></div></div>");
$templateCache.put("app/masta-basic/detail-modal.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\">請求No.{{ invoicedata.detail.uriage.sk_no }}</h4></div><div class=\"col-xs-6\"><span class=\"pull-right\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"invoicedata.seikyuDelete(invoicedata.detail.uriage.sk_no)\" style=\"width:150px\">請求を削除</button></span></div></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-xs-8\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\">請求日</td><td>{{ invoicedata.detail.uriage.sk_day_time*1000 | date }}</td><td class=\"active\">請求先</td><td>{{ invoicedata.detail.uriage.toku_cd }}</td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td style=\"height:58px\" colspan=\"2\">{{ invoicedata.detail.uriage.toku_toku_nm }}<br><br>{{ invoicedata.detail.uriage.toku_tanto_nm }}</td></tr><tr><td style=\"height:58px\" colspan=\"2\">〒{{ invoicedata.detail.uriage.toku_yubin_no }}<br>{{ invoicedata.detail.uriage.toku_adrs1 }}<br>{{ invoicedata.detail.uriage.toku_adrs2 }}</td></tr><tr><td style=\"width:50%\">TEL.{{ invoicedata.detail.uriage.toku_tel_no }}</td><td style=\"width:50%\">FAX.{{ invoicedata.detail.uriage.toku_fax_no }}</td></tr><tr><td style=\"width:50%\">締日 {{ invoicedata.detail.uriage.sime_dd_nm }}</td><td style=\"width:50%\">請求 {{ invoicedata.SetSeikyuTaniNm(invoicedata.detail.uriage.toku_sk_tani) }}</td></tr></tbody></table></div><div class=\"col-xs-4\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\" style=\"width:65px\">請求書</td><td></td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\" style=\"width:65px\">利用金額</td><td class=\"text-right\">{{ invoicedata.detailForm.kijun_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">値引額</td><td class=\"text-right\">{{ invoicedata.detailForm.nebiki_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">特別値引額</td><td class=\"text-right\"><input type=\"text\" style=\"text-align:right;\" ng-model=\"invoicedata.detailForm.tokubiki_kn\" model-format=\"number\" numeric-only=\"\" ng-disabled=\"invoicedata.detail.uriage.nk_day_time > 0\"></td></tr><tr><td class=\"active\" style=\"width:65px\">特別値引率</td><td class=\"text-right\"><span ng-if=\"invoicedata.detailForm.tokubiki_ritu > 0\">{{ invoicedata.detailForm.tokubiki_ritu }}%</span> <span ng-if=\"!invoicedata.detailForm.tokubiki_ritu\">0%</span></td></tr><tr><td class=\"active\" style=\"width:65px\">差引金額</td><td class=\"text-right\">{{ invoicedata.detailForm.hiki_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">消費税</td><td class=\"text-right\">{{ invoicedata.detailForm.zei_kn | number }}</td></tr><tr><td class=\"active\" style=\"width:65px\">請求金額</td><td class=\"text-right\">{{ invoicedata.detailForm.sk_kn | number }}</td></tr></tbody></table><div class=\"seikyu-foot\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"invoicedata.tokubikiSubmit()\" style=\"width:50px\" ng-disabled=\"invoicedata.detailForm.tokubiki_kn == invoicedata.detail.uriage.tokubiki_kn\">更新</button></div></div></div><table class=\"table table-hover table-bordered item-table\" style=\"min-height:100@x;\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:15px\" class=\"sk-fit\">#</th><th style=\"width:65px\" class=\"sk-fit\">納品No.</th><th class=\"sk-fit\">作品名</th><th style=\"width:55px\" class=\"sk-fit\">小計</th><th style=\"width:55px\" class=\"sk-fit\">消費税</th><th style=\"width:55px\" class=\"sk-fit\">合計</th></tr></thead><tbody ng-repeat=\"item in invoicedata.detail.uriageDtl\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" class=\"fit\"><tr><td class=\"text-center\">{{ $index+1 }}</td><td>{{ item.nh_no }}</td><td>{{ item.sakuhin_nm }}</td><td>{{ item.kj_ur_kin | number }}</td><td>{{ item.zei_kin | number }}</td><td>{{ item.jt_ur_kin + item.zei_kin | number }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/masta-basic/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください<br><small class=\"text-warning\">印刷にはGoogleChromeが適しています。</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\"> {{ itm.name }}</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/masta-bumon/bumon.html","<div ncy-breadcrumb=\"\"></div><form role=\"form\" name=\"bumonForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">部門情報<br><small class=\"text-danger\">&nbsp;&nbsp;過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>（削除/追加は更新されるまで反映されません）</small><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>部門CD</th><th>部門名</th><th>部門略称</th><th>部門職種</th><th>技術部門区分</th><th>部署区分</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, item) in bmn.bumon\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-if=\"item.delete_flg == \'0\'\"><tr><td style=\"width:8%\"><input type=\"text\" name=\"bumon_cd\" class=\"form-control input-sm\" ng-model=\"item.bumon_cd\"></td><td style=\"width:25%\"><input type=\"text\" name=\"bumon_nm\" class=\"form-control input-sm\" ng-model=\"item.bumon_nm\"></td><td style=\"width:15%\"><input type=\"text\" name=\"bumon_rm\" class=\"form-control input-sm\" ng-model=\"item.bumon_rm\"></td><td style=\"width:80px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"bmn.syokusyuDropdown\" data-html=\"true\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ item.bumon_syokusyu_nm }} <span class=\"caret\"></span></button></span></div></td><td style=\"width:120px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"bmn.tecBumonKbDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ item.tec_bumon_kb_nm }} <span class=\"caret\"></span></button></span></div></td><td style=\"width:170px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"bmn.bumonKbDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ item.bumon_kb_nm }} <span class=\"caret\"></span></button></span></div></td><td class=\"text-center\"><a href=\"\" ng-click=\"bmn.bumonDelete($index)\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"bmn.bumonExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"><span class=\"text-danger\" ng-if=\"bmn.formError\">部門CDが入力されていないデータがあります。更新できません。</span> <span class=\"text-danger\" ng-if=\"bmn.duplicateError\">部門CDが重複しています。更新できません。</span></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"bmn.bumonReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"bmn.bumonSubmit(bmn.bumon)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-bunrui/bunrui.html","<div ncy-breadcrumb=\"\"></div><form role=\"form\" name=\"bunruiForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">作業分類情報<br><small class=\"text-danger\">過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>&nbsp;（削除/追加は更新されるまで反映されません）<br></small> <small class=\"text-danger\">作業分類 > [02:作業場所料金、03:技術員料金、06:プリント料金]の削除は出来ません</small></div><div class=\"col-md-2\"></div><div class=\"col-md-8\"><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>作業分類CD</th><th>作業分類名称</th><th>作業明細集計コード</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, item) in bnr.bunrui\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-if=\"item.delete_flg == \'0\'\"><tr><td style=\"width:8%\"><input type=\"text\" name=\"sg_bunrui_cd\" class=\"form-control input-sm\" ng-model=\"item.sg_bunrui_cd\" ng-disabled=\"item.sg_bunrui_cd == \'02\' || item.sg_bunrui_cd == \'03\' || item.sg_bunrui_cd == \'06\'\"></td><td style=\"width:25%\"><input type=\"text\" name=\"sg_bunrui_nm\" class=\"form-control input-sm\" ng-model=\"item.sg_bunrui_nm\"></td><td style=\"width:180px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"bnr.sumCdDropdown\" data-html=\"true\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ item.sg_bunrui_sum_cd_nm }} <span class=\"caret\"></span></button></span></div></td><td class=\"text-center\"><a href=\"\" ng-click=\"bnr.bunruiDelete($index)\" a-disabled=\"item.sg_bunrui_cd == \'02\' || item.sg_bunrui_cd == \'03\' || item.sg_bunrui_cd == \'06\'\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-2\"></div><div class=\"col-md-12\"></div><div class=\"col-md-3\"></div><div class=\"col-md-9\"><span class=\"text-danger\" ng-if=\"bnr.formError\">作業分類CDが入力されていないデータがあります。更新できません。</span> <span class=\"text-danger\" ng-if=\"bnr.duplicateError\">作業分類CDが重複しています。更新できません。</span></div><div class=\"col-md-3\"></div><div class=\"col-md-6\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"bnr.bunruiExtend()\" style=\"width:80px\">追加</button></div><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"bnr.bunruiReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"bnr.bunruiSubmit(bnr.bunrui)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-codeval/codeval.html","<div ncy-breadcrumb=\"\"></div><form role=\"form\" name=\"keitaiForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">コード値<br><small class=\"text-danger\">過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください&nbsp;（削除/追加は更新されるまで反映されません）</small></div><div class=\"col-md-5\" style=\"padding:0;\"><div class=\"col-md-12\" style=\"padding-top:10px;\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"cd.searchFilter.id_val\" value=\"0\" ng-change=\"cd.filterSelect(0)\">すべて</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"cd.searchFilter.id_val\" value=\"1\" ng-change=\"cd.filterSelect(1)\">コード</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"cd.searchFilter.id_val\" value=\"2\" ng-change=\"cd.filterSelect(2)\">区分</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"cd.searchFilter.id_val\" value=\"3\" ng-change=\"cd.filterSelect(3)\">フラグ</label></div><table class=\"table table-bordered table-striped fit\"><thead><tr class=\"active\"><th style=\"width:75px\">コードID</th><th style=\"width:140px\">コード名</th><th style=\"width:30px\">追</th><th style=\"width:30px\">修</th><th style=\"width:35px\">削</th></tr></thead><tbody class=\"fit\"><tr><td colspan=\"5\" style=\"margin:0;padding:0;\"><div style=\"margin:0;padding:0;height:400px; overflow:auto;\"><table class=\"table table-bordered\"><tbody ng-repeat=\"(key, item) in cd.code\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr ng-click=\"cd.codeSelect(item);cd.setActiveRow($index);\" ng-class=\"{\'active\':$index==cd.activeRow}\"><td class=\"text-center\" style=\"width:86px;\">{{item.code_id}}</td><td style=\"width:160px\">{{item.code_nm}}</td><td style=\"width:33px\" class=\"text-center\">{{item.ins_fl_nm}}</td><td style=\"width:33px\" class=\"text-center\">{{item.chg_fl_nm}}</td><td class=\"text-center\">{{item.del_fl_nm}}</td></tr></tbody></table></div></td></tr></tbody></table><div class=\"col-xs-12\"><p class=\"text-center\">{{cd.code.length}}件</p></div></div><div class=\"col-md-6\"><div class=\"col-md-12\" style=\"padding-top:10px;\"><div>コード: {{ cd.code_id }}</div></div><div class=\"col-md-12\"><table class=\"table table-bordered table-striped fit\"><thead class=\"small\"><tr class=\"active\"><th style=\"width:40px\">値</th><th style=\"width:100px\">名称</th><th style=\"width:100px\">略称</th><th style=\"width:60px\">削除</th></tr></thead><tbody class=\"fit\"><tr><td colspan=\"5\" style=\"margin:0;padding:0;\"><div style=\"margin:0;padding:0;height:400px; overflow:auto;\"><table class=\"table table-bordered\"><tbody ng-repeat=\"(key, item) in cd.codeVal\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-if=\"item.delete_flg == \'0\'\"><tr><td class=\"text-center fit2\" style=\"width:48px;\"><input type=\"text\" name=\"code_vl\" class=\"form-control input-sm\" ng-model=\"item.code_vl\" ng-disabled=\"cd.chg_fl == 1\"></td><td style=\"width:120px\" class=\"fit2\"><input type=\"text\" name=\"vl_nm\" class=\"form-control input-sm\" ng-model=\"item.vl_nm\" ng-disabled=\"cd.chg_fl == 1\"></td><td style=\"width:120px\" class=\"fit2\"><input type=\"text\" name=\"vl_rm\" class=\"form-control input-sm\" ng-model=\"item.vl_rm\" ng-disabled=\"cd.chg_fl == 1\"></td><td class=\"text-center fit2\"><a href=\"\" ng-click=\"cd.codeValDelete($index)\" a-disabled=\"cd.del_fl == 1\">削除</a></td></tr></tbody></table></div></td></tr></tbody></table><div class=\"col-xs-12\"><p class=\"text-center\">{{cd.codeVal.length}}件</p></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"cd.codeValExtend()\" ng-disabled=\"cd.ins_fl == 1\">追加</button></div><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"cd.codeValReset()\" style=\"width:80px\" ng-disabled=\"cd.ins_fl == 1 && cd.chg_fl == 1 && cd.del_fl == 1\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"cd.codeValSubmit()\" style=\"width:150px\" ng-disabled=\"cd.ins_fl == 1 && cd.chg_fl == 1 && cd.del_fl == 1\">更新</button></div></div></div></div><hr><div class=\"col-md-12\"></div><div class=\"col-md-3\"></div><div class=\"col-md-9\"><span class=\"text-danger\" ng-if=\"cd.formError\">値が入力されていません。更新できません。</span> <span class=\"text-danger\" ng-if=\"cd.duplicateError\">値が重複しています。更新できません。</span> <span class=\"text-danger\" ng-if=\"cd.formDupError\">値が重複しているか、未入力の行があります。更新できません。</span></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-gaibu/detail-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\" style=\"min-height:380px;\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\">外部関係者CD.{{ ga.detailForm.gaibu_cd }}</h4></div><div class=\"col-xs-6\"><span class=\"pull-right\" ng-if=\"ga.mode == 2\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"ga.addSubmit(\'DELETE\', ga.detailForm.gaibu_cd)\" style=\"width:80px\">削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"ga.addSubmit(\'PUT\', ga.detailForm)\" style=\"width:150px\" ng-disabled=\"!ga.detailForm.simei || !ga.detailForm.simei_km || !ga.detailForm.bumon_cd || !ga.detailForm.gyosyu_kb\">更新</button></span> <span class=\"pull-right\" ng-if=\"ga.mode == 1\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"ga.addSubmit(\'POST\',ga.detailForm)\" style=\"width:150px\" ng-disabled=\"!ga.detailForm.simei || !ga.detailForm.simei_km || !ga.detailForm.bumon_cd || !ga.detailForm.gyosyu_kb\">登録</button></span></div></div></div><div class=\"modal-body modal-fit\" style=\"min-height:350px;\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>外部関係者名カナ</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.simei_km\" ng-blur=\"ga.changeZen2Cana(\'detailForm\')\" placeholder=\"半角カナ\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>外部関係者名</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.simei\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>部門</td><td class=\"text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"margin:0;padding:0;\" bs-dropdown=\"ga.modalBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> {{ ga.detail.bumon_nm }}</button></span></div></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>業種</td><td class=\"text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"margin:0;padding:0;\" bs-dropdown=\"ga.modalGyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> {{ ga.getGyoName(ga.detailForm.gyosyu_kb) }}</button></span></div></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">生年月日</td><td class=\"text-center\" style=\"width:130px;\"><input type=\"text\" ng-model=\"ga.detailForm.born_day\" placeholder=\"yyyy/mm/dd\" autoclose=\"true\" name=\"born_day\" bs-datepicker=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">自宅郵便番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.yubin_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">自宅住所１</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.adrs1\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">自宅住所２</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.adrs2\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">自宅電話番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.tel_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">自宅FAX</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.fax_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">携帯電話番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.keitai_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">連絡先Email</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.email\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">会社郵便番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.kai_yubin_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">会社住所１</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.kai_adrs1\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">会社住所２</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.kai_adrs2\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">会社電話番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.kai_tel_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">会社FAX</td><td class=\"text-right\"><input type=\"text\" ng-model=\"ga.detailForm.kai_fax_no\" ng-disabled=\"\"></td></tr></tbody></table><div><span class=\"text-danger\" ng-if=\"ga.idError\"><small>※IDに使える文字は半角英数です</small></span></div></div></div></div></div></div></div>");
$templateCache.put("app/masta-gaibu/gaibu.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"gaForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">外部関係者名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"外部関係者名\" ng-model=\"ga.form.simei\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">外部関係者名カナ</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ga.form.simei_km\" ng-blur=\"ga.changeZen2Cana(\'form\')\" placeholder=\"外部関係者名カナ\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"ga.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ga.bumon_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"ga.gyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">業種 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ga.gyosyu_nm\" disabled=\"\"></div></div><div class=\"col-xs-6\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"ga.addGaibuDetail(1, item)\">新規登録</button></div></div><div class=\"col-xs-6\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"ga.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"ga.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"ga.datas\"><dir-pagination-controls on-page-change=\"ga.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"ga.pagination.current * ga.datasPerPage - (ga.datasPerPage -1) +\'～\'+((ga.pagination.current * ga.datasPerPage - ga.datasPerPage) + ga.datas.length) +\'件/\'+ga.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"ga.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:65px\">コード</th><th style=\"width:200px\">外部関係者名</th><th style=\"width:200px\">外部関係者名カナ</th><th>部門</th><th>業種</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in ga.datas | itemsPerPage: ga.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"ga.totalDatas\" current-page=\"ga.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"ga.addGaibuDetail(2, item)\" style=\"cursor:pointer;\"><tr bs-tooltip=\"ga.editTooltip1\"><td class=\"text-center\">{{ ($index + 1) + (ga.pagination.current - 1) * ga.datasPerPage }}</td><td>{{ item.gaibu_cd }}</td><td>{{ item.simei }}</td><td>{{ item.simei_km }}</td><td>{{ item.bumon_nm }}</td><td>{{ ga.getGyoName(item.gyosyu_kb) }}</td></tr></tbody></table></div>");
$templateCache.put("app/masta-gaibu/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください<br><small class=\"text-warning\">印刷にはGoogleChromeが適しています。</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\"> {{ itm.name }}</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/masta-hojyo-kamoku/hojyo-kamoku.html","<div ncy-breadcrumb=\"\"></div><div class=\"text-center\" ng-show=\"hkm.datas\"><dir-pagination-controls on-page-change=\"hkm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"hkm.pagination.current * hkm.datasPerPage - (hkm.datasPerPage -1) +\'～\'+((hkm.pagination.current * hkm.datasPerPage - hkm.datasPerPage) + hkm.datas.length) +\'件/\'+hkm.totalDatas+\'件\'\"></span></div><form role=\"form\" name=\"kbunForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\">補助科目情報<br><p><small class=\"text-danger\">&nbsp;&nbsp;過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>（削除/追加は更新されるまで反映されません）</small> <small class=\"text-danger\">&nbsp;&nbsp;変更後の更新はページ毎に行ってください</small></p><div class=\"col-xs-1\"><div style=\"height:500px\"></div></div><div class=\"col-xs-9\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><th>勘定科目CD</th><th>勘定科目名</th><th>補助科目CD</th><th>補助科目名</th><th>削除</th></thead><tbody dir-paginate=\"(key, item) in hkm.datas | itemsPerPage: hkm.datasPerPage\" pagination-id=\"earningsPaginate\" class=\"fit\" total-items=\"hkm.totalDatas\" current-page=\"hkm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" style=\"cursor:pointer;\"><tr ng-if=\"item.delete_flg == \'0\'\"><td style=\"width:15%\"><input type=\"text\" name=\"kmk_cd\" class=\"form-control input-sm\" ng-model=\"item.kmk_cd\" ng-if=\"item.new_flg == \'0\'\" ng-disabled=\"item.new_flg == \'0\'\"><mst-kamoku-item kmkcd=\"{{item.kmk_cd}}\" alias=\"hkm\" target=\"item\" ng-if=\"item.new_flg == \'1\'\"></mst-kamoku-item></td><td><input type=\"text\" name=\"kmk_nm\" class=\"form-control input-sm\" ng-model=\"item.kmk_nm\" disabled=\"\"></td><td style=\"width:15%\"><input type=\"text\" name=\"hojyo_cd\" class=\"form-control input-sm\" ng-model=\"item.hojyo_cd\" ng-disabled=\"item.new_flg == \'0\'\"></td><td><input type=\"text\" name=\"hj_kmk_nm\" class=\"form-control input-sm\" ng-model=\"item.hj_kmk_nm\"></td><td class=\"text-center\" style=\"width:15%\"><a href=\"\" ng-click=\"hkm.itemDelete($index)\">削除</a></td></tr></tbody></table></div><div class=\"col-xs-2\"></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><span class=\"text-danger\" ng-if=\"hkm.lastPage != hkm.currentpage\">追加は最後のページで行えます</span> <button type=\"button\" ng-if=\"hkm.lastPage == hkm.currentpage\" class=\"btn btn-warning btn-xs\" ng-click=\"hkm.itemExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"><span class=\"text-danger\" ng-if=\"hkm.formError\">勘定科目CDか補助科目CDが入力されていないデータがあります。更新できません。(勘定科目CDはSpace検索してください)</span> <span class=\"text-danger\" ng-if=\"hkm.duplicateError\">勘定科目CDと補助科目CDの組み合わせが重複しています。更新できません。<br><span ng-repeat=\"item in hkm.duplicateItem\">勘定科目CD:{{item.kmk_cd}},補助科目CD:{{item.hojyo_cd}}<br></span></span></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"hkm.itemReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"hkm.itemSubmit(hkm.datas)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-kanjyo-kamoku/kanjyo-kamoku.html","<div ncy-breadcrumb=\"\"></div><div class=\"text-center\" ng-show=\"kkm.datas\"><dir-pagination-controls on-page-change=\"kkm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"kkm.pagination.current * kkm.datasPerPage - (kkm.datasPerPage -1) +\'～\'+((kkm.pagination.current * kkm.datasPerPage - kkm.datasPerPage) + kkm.datas.length) +\'件/\'+kkm.totalDatas+\'件\'\"></span></div><form role=\"form\" name=\"kbunForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\">勘定科目情報<br><p><small class=\"text-danger\">&nbsp;&nbsp;過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>（削除/追加は更新されるまで反映されません）</small> <small class=\"text-danger\">&nbsp;&nbsp;変更後の更新はページ毎に行ってください</small></p><div class=\"col-xs-4\"><div style=\"height:500px\"></div></div><div class=\"col-xs-4\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><th>勘定科目CD</th><th>勘定科目名</th><th>削除</th></thead><tbody dir-paginate=\"(key, item) in kkm.datas | itemsPerPage: kkm.datasPerPage\" pagination-id=\"earningsPaginate\" class=\"fit\" total-items=\"kkm.totalDatas\" current-page=\"kkm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" style=\"cursor:pointer;\"><tr ng-if=\"item.delete_flg == \'0\'\"><td style=\"width:15%\"><input type=\"text\" name=\"kmk_cd\" class=\"form-control input-sm\" ng-model=\"item.kmk_cd\" ng-disabled=\"item.new_flg == \'0\'\"></td><td><input type=\"text\" name=\"kmk_nm\" class=\"form-control input-sm\" ng-model=\"item.kmk_nm\"></td><td class=\"text-center\" style=\"width:15%\"><a href=\"\" ng-click=\"kkm.itemDelete($index)\">削除</a></td></tr></tbody></table></div><div class=\"col-xs-3\"></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><span class=\"text-danger\" ng-if=\"kkm.lastPage != kkm.currentpage\">追加は最後のページで行えます</span> <button type=\"button\" ng-if=\"kkm.lastPage == kkm.currentpage\" class=\"btn btn-warning btn-xs\" ng-click=\"kkm.itemExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"><span class=\"text-danger\" ng-if=\"kkm.formError\">科目CDが入力されていないデータがあります。更新できません。</span> <span class=\"text-danger\" ng-if=\"kkm.duplicateError\">科目CDが重複しています。更新できません。<br><span ng-repeat=\"item in kkm.duplicateItem\">{{item.kmk_cd}}<br></span></span></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"kkm.itemReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"kkm.itemSubmit(kkm.datas)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-keihi-bunrui/keihi-bunrui.html","<div ncy-breadcrumb=\"\"></div><div class=\"text-center\" ng-show=\"kbun.datas\"><dir-pagination-controls on-page-change=\"kbun.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"kbun.pagination.current * kbun.datasPerPage - (kbun.datasPerPage -1) +\'～\'+((kbun.pagination.current * kbun.datasPerPage - kbun.datasPerPage) + kbun.datas.length) +\'件/\'+kbun.totalDatas+\'件\'\"></span></div><form role=\"form\" name=\"kbunForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">経費分類情報<br><small class=\"text-danger\">&nbsp;&nbsp;過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>（削除/追加は更新されるまで反映されません）</small> <small class=\"text-danger\">&nbsp;&nbsp;変更後の更新はページ毎に行ってください</small><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>分類CD</th><th>分類名</th><th>交通費区分</th><th>経費区分</th><th colspan=\"2\">貸方勘定科目&nbsp;&nbsp;CD／名</th><th colspan=\"2\">貸方補助科目&nbsp;&nbsp;CD／名</th><th>削除</th></tr></thead><tbody dir-paginate=\"(key, item) in kbun.datas | itemsPerPage: kbun.datasPerPage\" pagination-id=\"earningsPaginate\" class=\"fit\" total-items=\"kbun.totalDatas\" current-page=\"kbun.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" style=\"cursor:pointer;\"><tr ng-if=\"item.delete_flg == \'0\'\"><td style=\"width:8%\"><input type=\"text\" name=\"kh_bunrui_cd\" class=\"form-control input-sm\" ng-model=\"item.kh_bunrui_cd\" ng-disabled=\"item.new_flg == \'0\'\"></td><td style=\"width:30%\"><input type=\"text\" name=\"kh_bunrui_nm\" class=\"form-control input-sm\" ng-model=\"item.kh_bunrui_nm\"></td><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm mini\" style=\"width:85px\" bs-dropdown=\"kbun.kotuhiDropdown\" data-html=\"true\" aria-haspopup=\"true\" aria-expanded=\"false\"><small>{{ item.kotuhi_fl_nm }}</small> <span class=\"caret\"></span></button></span></div></td><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm mini\" bs-dropdown=\"kbun.keihiKbnDropdown\" style=\"width:65px\" data-html=\"true\" aria-haspopup=\"true\" aria-expanded=\"false\"><small>{{ item.kmk_kbn_nm }}</small> <span class=\"caret\"></span></button></span></div></td><td style=\"width:15%\"><mst-kamoku-item alias=\"kbun\" target=\"item\" kmkcd=\"{{item.kmk_cd}}\"></mst-kamoku-item></td><td style=\"width:20%\">{{item.kmk_nm}}</td><td style=\"width:15%\"><mst-hojyo-kamoku-item alias=\"kbun\" target=\"item\" kmkcd=\"{{item.kmk_cd}}\" hojyokmkcd=\"{{item.hojyo_kmk_cd}}\"></mst-hojyo-kamoku-item></td><td style=\"width:20%\">{{item.hojyo_kmk_nm}}</td><td class=\"text-center\"><a href=\"\" ng-click=\"kbun.itemDelete($index)\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><span class=\"text-danger\" ng-if=\"kbun.lastPage != kbun.currentpage\">追加は最後のページで行えます</span> <button type=\"button\" ng-if=\"kbun.lastPage == kbun.currentpage\" class=\"btn btn-warning btn-xs\" ng-click=\"kbun.itemExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"><span class=\"text-danger\" ng-if=\"kbun.formError\">分類CDが入力されていないデータがあります。更新できません。</span> <span class=\"text-danger\" ng-if=\"kbun.duplicateError\">分類CDが重複しています。更新できません。<br><span ng-repeat=\"item in kbun.duplicateItem\">{{item.kh_bunrui_cd}}<br></span></span></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"kbun.itemReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"kbun.itemSubmit(kbun.datas)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-keihi-kamoku/editmode.html","<div disable-all=\"kkm.isFromDisabled || kkm.isEditDisabled\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:5%\">No.</th><th style=\"width:10%\">勘定科目CD</th><th style=\"width:20%\">勘定科目名</th><th style=\"width:10%\">補助科目CD</th><th style=\"width:20%\">補助科目名</th><th>表示名称</th><th style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"kkm.editScope.tableExtend()\" ng-disabled=\"kkm.isFromDisabled\">行追加</button></th></tr></thead><tbody ng-if=\"kkm.editForm.detail.length == 0\"><tr><td colspan=\"8\"><div style=\"height:245px\">&emsp;</div></td></tr><tr></tr></tbody><tbody ng-repeat=\"( key, item ) in kkm.editForm.detail\" class=\"fit\" disable-all=\"kkm.isFromDisabled || kkm.isEditDisabled\"><tr><td class=\"text-center\">{{ item.seq_no }} <input type=\"hidden\" ng-model=\"item.seq_no\" ng-init=\"item.seq_no = $index+1\"></td><td><mst-kamoku-item kmkcd=\"{{item.kmk_cd}}\" alias=\"hkm\" target=\"item\"></mst-kamoku-item><input type=\"hidden\" ng-model=\"item.kmk_cd\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.kmk_nm\" disabled=\"\"></td><td><mst-hojyo-kamoku-item kmkcd=\"{{item.kmk_cd}}\" hojyokmkcd=\"{{item.hojyo_kmk_cd}}\" alias=\"hkm\" target=\"item\"></mst-hojyo-kamoku-item><input type=\"hidden\" ng-model=\"item.hojyo_kmk_cd\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.hojyo_kmk_nm\" disabled=\"\"></td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.dsp_nm\"></td><td class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-xs\" ng-click=\"kkm.editScope.tableCellDelete($index)\" ng-disabled=\"kkm.isFromDisabled || kkm.isEditDisabled\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"kkm.editScope.tableRowCopy($index)\" ng-disabled=\"kkm.isFromDisabled || kkm.isEditDisabled\">行複写</button></td></tr></tbody></table></div>");
$templateCache.put("app/masta-keihi-kamoku/keihi-kamoku.html","<div ncy-breadcrumb=\"\"></div><div class=\"text-center\" ng-show=\"kkm.datas\"><dir-pagination-controls on-page-change=\"kkm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"kkm.pagination.current * kkm.datasPerPage - (kkm.datasPerPage -1) +\'～\'+((kkm.pagination.current * kkm.datasPerPage - kkm.datasPerPage) + kkm.datas.length) +\'件/\'+kkm.totalDatas+\'件\'\"></span></div><form role=\"form\" name=\"kbunForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">経費科目情報(経費分類紐付)<br><p><small class=\"text-danger\">&nbsp;&nbsp;過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>（削除/追加は更新されるまで反映されません）</small> <small class=\"text-danger\">&nbsp;&nbsp;変更後の更新はページ毎に行ってください</small></p><div class=\"col-xs-3\"><div style=\"height:500px\"></div></div><div class=\"col-md-5\"><table class=\"table table-bordered table-striped\"><caption>行ダブルクリックで編集画面が開きます</caption><thead class=\"small\"><tr class=\"active\"><th>分類CD</th><th>分類名</th></tr></thead><tbody dir-paginate=\"(key, item) in kkm.datas | itemsPerPage: kkm.datasPerPage\" pagination-id=\"earningsPaginate\" class=\"fit\" total-items=\"kkm.totalDatas\" current-page=\"kkm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" style=\"cursor:pointer;\" ng-dblclick=\"kkm.editModeInit(item)\"><tr><td style=\"width:8%\" class=\"text-center\"><p>{{item.kh_bunrui_cd}}</p></td><td><p>{{item.kh_bunrui_nm}}</p></td></tr></tbody></table></div><div class=\"col-xs-4\"></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-keihi-kamoku/kkmedit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\">経費科目編集</h4></div><div class=\"col-xs-5 text-right\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"kkm.editScope.formSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"kkm.isFromDisabled || ordersForm.$invalid || kkm.isEditDisabled || kkm.editForm.detail.length == 0 || !siireForm.$valid || kkm.isFromDetailError\">変更</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"kkm.editScope.formSubmit(\'DELETE\')\" style=\"width:80px\" ng-disabled=\"kkm.isFromDisabled || kkm.isEditDisabled\">削除</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit modal-overFlow-non\" disable-all=\"kkm.isFromDisabled || kkm.isEditDisabled\"><form role=\"form\" name=\"siireForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-10\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:65px\" class=\"title text-center\">経費分類No.</td><td style=\"width:65px\">{{ kkm.editForm.kh_bunrui_cd }}</td><td style=\"width:65px\" class=\"title text-center\">経費分類名</td><td style=\"width:65px\">{{ kkm.editForm.kh_bunrui_nm }}</td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"modal-inner-block\"><div ng-include=\"\'app/masta-keihi-kamoku/editmode.html\'\"></div></div></div><div class=\"col-xs-12\"></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-8\"><span ng-if=\"kkm.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide()\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/masta-media/media.html","<div ncy-breadcrumb=\"\"></div><form role=\"form\" name=\"mediaForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">メディア情報<br><small class=\"text-danger\">過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>&nbsp;（削除/追加は更新されるまで反映されません）</small></div><div class=\"col-md-4\"></div><div class=\"col-md-4\"><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>メディアCD</th><th>メディア名称</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, item) in mda.media\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-if=\"item.delete_flg == \'0\'\"><tr><td style=\"width:8%\"><input type=\"text\" name=\"media_cd\" class=\"form-control input-sm\" ng-model=\"item.media_cd\"></td><td style=\"width:25%\"><input type=\"text\" name=\"media_nm\" class=\"form-control input-sm\" ng-model=\"item.media_nm\"></td><td class=\"text-center\"><a href=\"\" ng-click=\"mda.mediaDelete($index)\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-4\"></div><div class=\"col-md-12\"></div><div class=\"col-md-3\"></div><div class=\"col-md-9\"><span class=\"text-danger\" ng-if=\"mda.formError\">メディアCDが入力されていないデータがあります。更新できません。</span> <span class=\"text-danger\" ng-if=\"mda.duplicateError\">メディアCDが重複しています。更新できません。</span></div><div class=\"col-md-3\"></div><div class=\"col-md-6\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"mda.mediaExtend()\" style=\"width:80px\">追加</button></div><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"mda.mediaReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"mda.mediaSubmit(mda.media)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-studio/studio.html","<div ncy-breadcrumb=\"\"></div><form role=\"form\" name=\"studioForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">スタジオ情報<br><small class=\"text-danger\">&nbsp;&nbsp;過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください<br>（削除/追加は更新されるまで反映されません）</small><div class=\"col-md-12\"><table class=\"table table-bordered table-striped\"><thead class=\"small\"><tr class=\"active\"><th>スタジオCD</th><th>スタジオ名</th><th>スタジオ略称</th><th>部門</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, item) in std.studio\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-if=\"item.delete_flg == \'0\'\"><tr><td style=\"width:8%\"><input type=\"text\" name=\"studio_cd\" class=\"form-control input-sm\" ng-model=\"item.studio_cd\"></td><td style=\"width:25%\"><input type=\"text\" name=\"studio_nm\" class=\"form-control input-sm\" ng-model=\"item.studio_nm\"></td><td style=\"width:25%\"><input type=\"text\" name=\"studio_rm\" class=\"form-control input-sm\" ng-model=\"item.studio_rm\"></td><td style=\"width:150px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"std.bumonDropdown\" data-html=\"true\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ item.bumon_nm }} <span class=\"caret\"></span></button></span></div></td><td class=\"text-center\"><a href=\"\" ng-click=\"std.studioDelete($index)\">削除</a></td></tr></tbody></table></div></div><div class=\"col-md-12\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"std.studioExtend()\" style=\"width:80px\">追加</button></div></div><div class=\"col-md-7\"><span class=\"text-danger\" ng-if=\"std.formError\">スタジオCDが入力されていないデータがあります。更新できません。</span> <span class=\"text-danger\" ng-if=\"std.duplicateError\">スタジオCDが重複しています。更新できません。</span></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"std.studioReset()\" style=\"width:100px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"std.studioSubmit(std.studio)\" style=\"width:150px\">更新</button></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-sgkeitai/sgkeitai.html","<div ncy-breadcrumb=\"\"></div><form role=\"form\" name=\"keitaiForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">作業形態[ <span ng-if=\"sgk.showSearch\">編集モード<span ng-if=\"sgk.copyMode\" class=\"text-danger\">(コピー)</span></span><span ng-if=\"!sgk.showSearch\">新規登録モード</span> ]<br><small class=\"text-danger\">過去のデータすべてに影響を与える情報ですので、細心の注意を払って更新作業をしてください&nbsp;（削除/追加は更新されるまで反映されません）</small></div><div class=\"col-md-4\" style=\"padding:0;\"><table class=\"table table-bordered table-striped fit\" ng-if=\"sgk.showSearch\"><caption><div class=\"form-group col-xs-12\">検索<div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sgk.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgk.searchFilter.bumon_nm\" style=\"width:150px\" disabled=\"\"></div></div></caption><thead><tr class=\"active\"><th style=\"width:80px\"><small>作業形態CD</small></th><th style=\"width:140px\">作業形態名称</th><th style=\"width:120px\">部門</th></tr></thead><tbody class=\"fit\"><tr><td colspan=\"3\" style=\"margin:0;padding:0;\"><div style=\"margin:0;padding:0;height:300px; overflow:auto;\"><table class=\"table table-bordered\"><tbody ng-repeat=\"(key, item) in sgk.sgKeitai | filter:{ bumon_cd: sgk.searchFilter.bumon_cd}\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr ng-click=\"sgk.sgKeitaiSelect(item);sgk.setActiveRow($index);\" ng-class=\"{\'active\':$index==sgk.activeRow}\"><td class=\"text-center\" style=\"width:68px;\">{{item.sg_keitai_cd}}</td><td style=\"width:125px\">{{item.sg_keitai_nm}}</td><td>{{item.bumon_nm}}</td></tr></tbody></table></div></td></tr></tbody></table><div class=\"col-md-12\" ng-if=\"sgk.showSearch\"></div></div><div class=\"col-md-8\"><div class=\"col-md-12\"><table class=\"table table-bordered table-striped fit\"><caption><div class=\"form-group\"><div class=\"input-group col-xs-12\"><span class=\"input-group-addon\" style=\"font-size:95%\">作業形態CD&emsp;</span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"sgk.sgKeitaiForm.sg_keitai_cd\" style=\"width:60px;\"> <span class=\"pull-right\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"sgk.ptnFormInit(1)\" ng-if=\"sgk.showSearch\" ng-disabled=\"!sgk.sgKeitaiForm.sg_keitai_cd\">作業パターン</button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"sgk.sgKeitaiDelete()\" style=\"width:60px;\" ng-if=\"sgk.showSearch\" ng-disabled=\"!sgk.sgKeitaiForm.sg_keitai_cd\">削除</button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"sgk.setShowSearch(sgk.showSearch)\" style=\"width:60px;\" ng-if=\"sgk.showSearch\">新規</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"sgk.setShowSearch(sgk.showSearch)\" style=\"width:60px;\" ng-if=\"!sgk.showSearch\">編集</button></span></div><div class=\"input-group col-xs-12\"><div class=\"height:2px;\">&emsp;<span class=\"text-danger\" ng-if=\"sgk.duplicateError\">違う作業形態CDを入力してください</span></div></div><div class=\"input-group col-xs-12\"><span class=\"input-group-addon\" style=\"font-size:95%\">作業形態名称</span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"sgk.sgKeitaiForm.sg_keitai_nm\" style=\"width:150px;font-size:95%\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sgk.itmBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgk.sgKeitaiForm.bumon_nm\" style=\"width:150px\" disabled=\"\"></div></div></caption><thead class=\"small\"><tr class=\"active\"><th>表示順</th><th>作業分類</th><th>表示名</th><th>作業項目CD</th><th>項目名称</th><th>削除</th></tr></thead><tbody class=\"fit\" ng-repeat=\"(key, item) in sgk.sgKeitaiItemForm\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-if=\"item.delete_flg == \'0\'\"><tr><td style=\"width:8%\"><input type=\"text\" name=\"dsp_seq_no\" class=\"form-control input-sm\" ng-model=\"item.dsp_seq_no\"></td><td style=\"width:25%\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sgk.sgItemBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{item.sg_bunrui_nm}} <span class=\"caret\"></span></button></td><td style=\"width:25%\"><input type=\"text\" name=\"dsp_nm\" class=\"form-control input-sm\" ng-model=\"item.dsp_nm\"></td><td style=\"width:15%\"><mst-sg-item ng-model=\"item.sg_item_cd\"></mst-sg-item></td><td style=\"width:25%\">{{item.sg_item_nms}}</td><td class=\"text-center\"><a href=\"\" ng-click=\"sgk.sgkeitaiItemDelete($index)\">削除</a></td></tr></tbody></table><div class=\"col-md-12\" ng-if=\"sgk.schfilter.sg_keitai_cd != \'99999\'\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"sgk.sgkeitaiItemExtend()\">作業アイテム追加</button></div><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"sgk.sgkeitaiItemReset()\" style=\"width:80px\">リセット</button> <button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"sgk.sgkeitaiSubmit()\" style=\"width:150px\" ng-disabled=\"sgk.duplicateError || sgk.sgKeitaiItemForm.length == 0\">作業形態更新</button></div></div></div></div><hr><div class=\"col-md-12\"></div><div class=\"col-md-3\"></div><div class=\"col-md-9\"><span class=\"text-danger\" ng-if=\"sgk.formError\">作業形態CDが入力されていません。更新できません。</span> <span class=\"text-danger\" ng-if=\"sgk.duplicateError\">CDが重複しています。更新できません。</span> <span class=\"text-danger\" ng-if=\"sgk.formDupError\">表示順が重複しているか、未入力の行があります。更新できません。</span></div><div class=\"col-md-3\"></div><div class=\"col-md-6\"><div class=\"form-group pull-right\" ng-if=\"sgk.schfilter.sg_keitai_cd != \'99999\'\"></div></div></div></form><div class=\"row\" ng-if=\"!sgk.showPtn\"><div class=\"col-md-12\" style=\"height:150px\"></div></div><div ng-include=\"sgk.templateUrl\" ng-if=\"sgk.showPtn\"></div>");
$templateCache.put("app/masta-sgkeitai/sgptn.html","<hr><form role=\"form\" name=\"ptnForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">作業パターン</div><div class=\"col-md-3\" style=\"padding:0;\"><table class=\"table table-bordered table-striped fit\"><caption><p>選択後、作業パターンCDを変更すれば、複写して登録できます</p></caption><thead><tr class=\"active\"><th style=\"width:100px\">作業パターンCD</th><th style=\"width:130px\">作業パターン名称</th></tr></thead><tbody class=\"fit\"><tr><td colspan=\"3\" style=\"margin:0;padding:0;\"><div style=\"margin:0;padding:0;height:300px; overflow:auto;\"><table class=\"table table-bordered\"><tbody ng-repeat=\"(key, item) in sgk.sgPtn\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr ng-click=\"sgk.sgPtnSelect(item);sgk.sgPtnSetActiveRow($index);\" ng-class=\"{\'active\':$index==sgk.sgPtnActiveRow}\"><td style=\"width:98px\" class=\"text-center\">{{item.sg_ptn_cd}}</td><td style=\"width:120px\">{{item.sg_ptn_nm}}</td></tr></tbody></table></div></td></tr></tbody></table><div class=\"col-md-12\" ng-if=\"sgk.ptn.showSearch\"></div></div><div class=\"col-md-9\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"input-group col-xs-12\"><span class=\"input-group-addon\" style=\"font-size:90%\">作業形態</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgk.sgKeitaiForm.sg_keitai_nm\" style=\"width:150px;font-size:90%\" disabled=\"\"> <span class=\"pull-right\"><button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"sgk.sgPtnNew()\" style=\"width:60px;\">新規</button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"sgk.sgPtnDelete()\" style=\"width:60px;\">削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"sgk.sgPtnSubmit()\" style=\"width:60px;\" ng-disabled=\"sgk.sgPtnFormError || sgk.sgPtnItemForm.length === 0\">登録</button></span></div><div class=\"input-group col-xs-12\"><div class=\"height:2px;\">&emsp;<span class=\"text-danger\" ng-if=\"sgk.sgPtnDuplicateError\">違う作業パターンCDを入力してください</span></div></div><div class=\"input-group col-xs-12\"><span class=\"input-group-addon\" style=\"font-size:90%\">作業パターンCD</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgk.sgPtnForm.sg_ptn_cd\" style=\"width:90px;font-size:90%\" ng-disabled=\"!sgk.sgPtnInited\"> <span class=\"input-group-addon\" style=\"font-size:90%\">作業パターン名称</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgk.sgPtnForm.sg_ptn_nm\" style=\"width:150px;font-size:90%\" ng-disabled=\"!sgk.sgPtnInited\"></div></div></div><div class=\"col-md-6\"><table class=\"table table-bordered table-striped fit\"><caption><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sgk.sgPtnSgItemBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業分類 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgk.sgPtnForm.sg_bunrui_nm\" style=\"width:150px\" disabled=\"\"></div></caption><thead><tr class=\"active\"><th style=\"width:90px\">作業分類</th><th style=\"width:130px\">作業項目名</th></tr></thead><tbody class=\"fit\"><tr><td colspan=\"3\" style=\"margin:0;padding:0;\"><div style=\"margin:0;padding:0;height:300px; overflow:auto;\"><table class=\"table table-bordered\"><tbody ng-repeat=\"(key, item) in sgk.sgItemFilterd | orderBy:\'sg_item_cd\'\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr ng-click=\"sgk.sgPtnSgItemSelect(item,key)\"><td style=\"width:88px\" ng-if=\"$first\">{{ item.sg_bunrui_nm }}</td><td style=\"width:88px\" ng-if=\"!$first\"></td><td style=\"width:120px\">{{ item.sg_item_cd }}:{{ item.sg_item_nm }}</td></tr></tbody></table></div></td></tr></tbody></table><div class=\"col-md-12\"><span class=\"text-center\">{{ sgk.sgItemFilterd.length }}件</span></div></div><div class=\"col-md-6\"><table class=\"table table-bordered table-striped fit\"><caption></caption><thead><tr class=\"active\"><th style=\"width:90px\">作業分類</th><th style=\"width:130px\">作業項目名</th></tr></thead><tbody class=\"fit\"><tr><td colspan=\"3\" style=\"margin:0;padding:0;\"><div style=\"margin:0;padding:0;height:331px; overflow:auto;\"><table class=\"table table-bordered\"><tbody ng-repeat=\"(key, item) in sgk.sgPtnItemForm | orderBy:\'sg_item_cd\'\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\"><tr ng-click=\"sgk.sgPtnSgItemDeselect(item,key);\"><td style=\"width:88px\" ng-if=\"$first\">{{ item.sg_bunrui_nm }}</td><td style=\"width:88px\" ng-if=\"!$first\"></td><td style=\"width:120px\">{{ item.sg_item_cd }}:{{ item.sg_item_nm }}</td></tr></tbody></table></div></td></tr></tbody></table><div class=\"col-md-12\" ng-if=\"sgk.schfilter.sg_keitai_cd != \'99999\'\"><span class=\"text-center\">{{ sgk.sgPtnItemForm.length }}件</span><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"sgk.sgPtnItemFormReset()\" style=\"width:80px\" ng-disabled=\"sgk.selectedBunruiIndex == \'99999\'\">リセット</button></div></div></div></div><hr><div class=\"col-md-12\"></div><div class=\"col-md-3\"></div><div class=\"col-md-9\"><span class=\"text-danger\" ng-if=\"sgk.sgPtnFormError\">作業パターンCDが入力されていません。更新できません。</span> <span class=\"text-danger\" ng-if=\"sgk.duplicateError\">作業パターンCDが重複しています。更新できません。</span></div><div class=\"col-md-3\"></div><div class=\"col-md-6\"><div class=\"form-group pull-right\" ng-if=\"sgk.schfilter.sg_keitai_cd != \'99999\'\"></div></div></div></form><div class=\"row\"><div class=\"col-md-12\" style=\"height:150px\"></div></div>");
$templateCache.put("app/masta-sgitem/detail-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\" ng-if=\"sgi.detailForm.sg_item_cd\">作業項目CD.{{ sgi.detailForm.sg_item_cd }}</h4><h4 class=\"modal-title\" ng-if=\"!sgi.detailForm.sg_item_cd\">&nbsp;新規登録</h4></div><div class=\"col-xs-6\"><span class=\"pull-right\" ng-if=\"sgi.detailForm.sg_item_cd\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"sgi.sgItemSubmit(\'DELETE\')\" style=\"width:150px\">削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"sgi.sgItemSubmit(\'PUT\')\" style=\"width:80px\">更新</button></span> <span class=\"pull-right\" ng-if=\"!sgi.detailForm.sg_item_cd\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"sgi.sgItemSubmit(\'POST\')\" style=\"width:80px\">登録</button></span></div></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered\"><caption>※ロックアウトの登録は必ず全角文字で ロックアウト という文字列を追加してください</caption><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalSgBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業分類 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.sg_bunrui_nm\" disabled=\"\"></div></td><td class=\"active text-center\" style=\"width:130px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:129px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.bumon_nm\" disabled=\"\"></div></td></tr><tr><td class=\"active text-center\" style=\"width:150px\">作業項目名(請求用)</td><td class=\"text-right\" colspan=\"5\"><input type=\"text\" ng-model=\"sgi.detailForm.sg_item_nms\"></td></tr><tr><td class=\"active text-center\" style=\"width:150px\">作業項目名(作業報告用)</td><td class=\"text-right\" colspan=\"5\"><input type=\"text\" ng-model=\"sgi.detailForm.sg_item_nm\"></td></tr><tr><td class=\"active text-center\" style=\"width:150px\">基準売単価</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.base_tanka\" model-format=\"number\" numeric-only=\"\"></td><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalSgKubun1_Dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">数量区分1 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.suryo_kbn_1_nm\" disabled=\"\"></div></td><td class=\"active text-center\" style=\"width:130px\">単位1</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.tani_1\"></td></tr><tr><td class=\"active text-center\" style=\"width:150px\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalSgKubun2_Dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"sgi.detailForm.sg_bunrui_cd != \'07\'\">数量区分2 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.suryo_kbn_2_nm\" disabled=\"\"></div></td><td class=\"active text-center\" style=\"width:130px\">単位2</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.tani_2\" ng-disabled=\"sgi.detailForm.sg_bunrui_cd != \'07\' || sgi.detailForm.suryo_kbn_2 == \'0\'\"></td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalMediaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"( sgi.detailForm.sg_bunrui_cd != \'07\' && sgi.detailForm.sg_bunrui_cd != \'06\' )\">メディア <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.media_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalStudioDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" ng-disabled=\"sgi.detailForm.sg_bunrui_cd != \'02\'\">スタジオ <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.studio_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalTimeFlDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">時刻入力 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.time_fl_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalGenkaFlDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">原価入力 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.genka_fl_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalOverFlDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">超過 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.over_fl_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px\">超過作業項目CD</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.ov_sg_item_cd\" disabled=\"\" ng-if=\"sgi.detailForm.over_fl == \'0\'\"><m-sg-item ng-model=\"sgi.detailForm.ov_sg_item_cd\" ng-if=\"sgi.detailForm.over_fl == \'1\'\"></m-sg-item></td><td class=\"text-right\" colspan=\"2\"><input type=\"text\" ng-model=\"sgi.detailForm.ov_sg_item_nms\" disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:150px\">超過基準数量</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.ov_suryo\" ng-disabled=\"sgi.detailForm.over_fl == \'0\'\"></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"3\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalGenkaSumDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">原価集計 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.genka_sum_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"1\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalSkflDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">請求対象 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.sk_fl_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalOaPrtFlDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">OAプリント <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.oa_prt_fl_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:150px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:149px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalZaikoFlDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">在庫管理 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.zaiko_kb_nm\" disabled=\"\"></div></td><td class=\"active text-center\" style=\"width:130px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:129px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"sgi.modalZaikoBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-placement=\"top\" ng-disabled=\"sgi.detailForm.zaiko_kb == \'0\'\">在庫部門 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"sgi.detailForm.zk_bumon_nm\" disabled=\"\"></div></td></tr><tr><td class=\"active text-center\" style=\"width:150px\">最終仕入単価</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.siire_tanka\" disabled=\"\"></td><td class=\"active text-center\" style=\"width:130px\">在庫単価</td><td class=\"text-right\"><input type=\"text\" ng-model=\"sgi.detailForm.zaiko_tanka\" disabled=\"\"></td></tr></tbody></table></div><div class=\"col-xs-12\"><div class=\"col-xs-10\"><table class=\"table table-hover table-bordered item-table\" style=\"min-height:100px;\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:5%\" class=\"sk-fit\">#</th><th style=\"width:10%\" class=\"sk-fit\">得意先CD</th><th style=\"width:60%\" class=\"sk-fit\">得意先名称</th><th style=\"width:15%\" class=\"sk-fit\">売単価</th><th style=\"width:10%\" class=\"sk-fit\">削除</th></tr></thead><tbody ng-repeat=\"item in sgi.detailForm.sgTanka\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" class=\"fit\"><tr><td class=\"text-center\">{{ $index+1 }}</td><td class=\"text-left\"><toku-cd-search ng-model=\"item.toku_cd\"></toku-cd-search></td><td class=\"text-left\"><input type=\"text\" ng-model=\"item.toku_nm\" disabled=\"\"></td><td class=\"text-left\"><input type=\"text\" ng-model=\"item.toku_tanka\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-center\"><a href=\"\" ng-click=\"sgi.sgTankaDelete($index)\">削除</a></td></tr></tbody></table></div><div class=\"col-xs-2\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"sgi.sgTankaExtend(sgi.detailForm.sg_item_cd)\" style=\"width:80px\">追加</button></div></div></div><div class=\"col-xs-12\"><div style=\"height:60px\"></div></div></div></div></div></div></div>");
$templateCache.put("app/masta-sgitem/sgitem.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-show=\"sgi.form\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"sgItemForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\" disable-all=\"sgi.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sgi.sgBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">作業分類 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgi.sg_bunrui_nm\" style=\"width:200px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業項目名</span> <input type=\"text\" class=\"form-control input-sm\" name=\"sg_item_nm\" placeholder=\"あいまい可能\" ng-model=\"sgi.form.sg_item_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"sgi.setSgItemDetail(1, null)\">新規登録</button></div></div></div><div class=\"col-md-6\" disable-all=\"sgi.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sgi.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"sgi.bumon_nm\" style=\"width:200px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業項目CD</span> <input type=\"text\" class=\"form-control input-sm\" name=\"sg_item_cd\" placeholder=\"あいまい可能\" ng-model=\"sgi.form.sg_item_cd\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"sgi.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"sgi.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"sgi.datas\"><dir-pagination-controls on-page-change=\"sgi.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"sgi.datasPerPage < sgi.totalDatas\" ng-bind=\"sgi.pagination.current * sgi.datasPerPage - (sgi.datasPerPage -1) +\'～\'+sgi.pagination.current * sgi.datasPerPage+\'件/\'+sgi.totalDatas+\'件\'\"></span> <span ng-if=\"sgi.datasPerPage > sgi.totalDatas\" ng-bind=\"sgi.totalDatas+\'件/\'+sgi.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"sgi.datas\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:60px\">作業分類</th><th style=\"width:45px\">作業項目CD</th><th style=\"width:120px\">作業項目名称</th><th style=\"width:90px\">部門</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in sgi.datas | itemsPerPage: sgi.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"sgi.totalDatas\" current-page=\"sgi.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"sgi.setSgItemDetail(2, item)\" style=\"cursor:pointer;\"><tr><td class=\"text-center\">{{ ($index + 1) + (sgi.pagination.current - 1) * sgi.datasPerPage }}</td><td>{{ item.sg_bunrui_nm }}</td><td style=\"cursor:default;\"><a href=\"\" ng-click=\"sgi.setSgItemDetail(1, item)\" bs-tooltip=\"sgi.editTooltipText1\">{{ item.sg_item_cd }}</a></td><td style=\"margin:0;padding:0;\"><small>{{ item.sg_item_nm }}<br>{{ item.sg_item_nms }}</small></td><td>{{ item.bumon_nm }}</td></tr></tbody></table></div>");
$templateCache.put("app/masta-syain/detail-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\" style=\"min-height:380px;\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\">社員CD.{{ syain.detailForm.syain_cd }}</h4></div><div class=\"col-xs-6\"><span class=\"pull-right\" ng-if=\"syain.mode == 2\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"syain.paymentSubmit(\'DELETE\', syain.detailForm.syain_cd)\" style=\"width:80px\">削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"syain.paymentSubmit(\'PUT\', syain.detailForm)\" style=\"width:150px\" ng-disabled=\"!syain.detailForm.syain_nm || !syain.detailForm.bumon_cd || syain.pwError || syain.idError\">更新</button></span> <span class=\"pull-right\" ng-if=\"syain.mode == 1\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"syain.paymentSubmit(\'POST\',syain.detailForm)\" style=\"width:150px\" ng-disabled=\"!syain.detailForm.syain_nm || !syain.detailForm.password || !syain.detailForm.bumon_cd || syain.idError || syain.pwError\">登録</button></span></div></div></div><div class=\"modal-body modal-fit\" style=\"min-height:350px;\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>社員名カナ</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.syain_km\" ng-blur=\"syain.changeZen2Cana(\'detailForm\')\" placeholder=\"半角カナ\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>社員名</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.syain_nm\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>部門</td><td class=\"text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"margin:0;padding:0;\" bs-dropdown=\"syain.modalBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> {{ syain.detail.bumon_nm }}</button></span></div></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">役職</td><td class=\"text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"margin:0;padding:0;\" bs-dropdown=\"syain.modalYakusyokuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> {{ syain.detail.yakusyoku_nm }}</button></span></div></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">性別</td><td class=\"text-left\"><div class=\"radio-inline\"><label for=\"man\" style=\"font-size:90%;font-weight: 400;\">&emsp;男性&nbsp; <input type=\"radio\" value=\"0\" style=\"left:0;top:0;\" ng-model=\"syain.detailForm.sex_cd\" name=\"sex_cd\" id=\"man\"></label></div><div class=\"radio-inline\"><label for=\"woman\" style=\"font-size:90%;font-weight: 400;\">&emsp;女性&nbsp; <input type=\"radio\" value=\"1\" style=\"left:0;top:0;\" ng-model=\"syain.detailForm.sex_cd\" name=\"sex_cd\" id=\"woman\"></label></div></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">生年月日</td><td class=\"text-center\" style=\"width:130px;\"><input type=\"text\" ng-model=\"syain.detailForm.born_day\" placeholder=\"yyyy/mm/dd\" autoclose=\"true\" name=\"born_day\" bs-datepicker=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">郵便番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.yubin_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">住所１</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.adrs1\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">住所２</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.adrs2\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">電話番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.tel_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">入社年月日</td><td class=\"text-center\" style=\"width:130px;\"><input type=\"text\" ng-model=\"syain.detailForm.nyusya_day\" placeholder=\"yyyy/mm/dd\" autoclose=\"true\" placement=\"top\" name=\"nyusya_day\" bs-datepicker=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">退職年月日</td><td class=\"text-center\" style=\"width:130px;\"><input type=\"text\" ng-model=\"syain.detailForm.taisyoku_day\" placeholder=\"yyyy/mm/dd\" placement=\"top\" autoclose=\"true\" name=\"taisyoku_day\" bs-datepicker=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>権限</td><td><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"syain.authorityLevelsDropdown\" placement=\"top\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> {{ syain.detail.sys_admin_nm }}</button></span></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">ログインID</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.user_id\" ng-disabled=\"\" maxlength=\"20\" placeholder=\"空白の場合社員CDがIDとなります\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>パスワード</td><td class=\"text-right\"><input type=\"text\" ng-model=\"syain.detailForm.password\" maxlength=\"12\" ng-disabled=\"\" placeholder=\"{{syain.passwordMessage}}\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">基準職務給</td><td class=\"text-center\" style=\"width:130px;\"><input type=\"text\" ng-model=\"syain.detailForm.base_salary\" name=\"base_salary\" numeric-only=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>非表示</td><td class=\"text-right\"><input type=\"checkbox\" name=\"hiddenChk\" ng-model=\"syain.detailForm.hidden_flg\" ng-true-value=\"\'1\'\" ng-false-value=\"\'0\'\" ng-checked=\"syain.detailForm.hidden_flg == 1\"></td></tr></tbody></table><div><span class=\"text-danger\" ng-if=\"syain.pwLenError\"><small>※パスワードは5文字以上で入力してください</small></span> <span class=\"text-danger\" ng-if=\"syain.pwError\"><small>※パスワードに使える文字は半角英数記号です</small></span> <span class=\"text-danger\" ng-if=\"syain.idError\"><small>※IDに使える文字は半角英数です</small></span></div></div></div></div></div></div></div>");
$templateCache.put("app/masta-syain/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください<br><small class=\"text-warning\">印刷にはGoogleChromeが適しています。</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\"> {{ itm.name }}</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/masta-syain/syain.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-show=\"syain.form\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"syainForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">社員名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"社員名\" ng-model=\"syain.form.syain_nm\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">社員名カナ</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"syain.form.syain_km\" ng-blur=\"syain.changeZen2Cana(\'form\')\" placeholder=\"社員名カナ\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"syain.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"syain.bumon_nm\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"syain.taisyokuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">退職 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"syain.taisyoku_nm\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"input-group\"><label class=\"checkbox-inline\"><input type=\"checkbox\" name=\"hiddenChk\" ng-model=\"syain.form.hiddenChk\" ng-true-value=\"\'yes\'\" ng-false-value=\"\'no\'\" ng-checked=\"syain.form.hiddenChk == \'yes\'\"> <span>非表示を含めない</span></label></div></div><div class=\"col-xs-12\">&nbsp;</div><div class=\"col-xs-6\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"syain.addSyainDetail(1, item)\">新規登録</button></div></div><div class=\"col-xs-6\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"syain.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"syain.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"syain.datas\"><dir-pagination-controls on-page-change=\"syain.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"syain.pagination.current * syain.datasPerPage - (syain.datasPerPage -1) +\'～\'+((syain.pagination.current * syain.datasPerPage - syain.datasPerPage) + syain.datas.length) +\'件/\'+syain.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"syain.datas\"><table class=\"table table-hover table-bordered\"><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:65px\">コード</th><th>社員名</th><th>社員名カナ</th><th style=\"width:120px\">部門</th><th style=\"width:120px\">入社日</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in syain.datas | itemsPerPage: syain.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"syain.totalDatas\" current-page=\"syain.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"syain.addSyainDetail(2, item)\" style=\"cursor:pointer;\"><tr bs-tooltip=\"syain.editTooltip1\"><td class=\"text-center\">{{ ($index + 1) + (syain.pagination.current - 1) * syain.datasPerPage }}</td><td>{{ item.syain_cd }}</td><td>{{ item.syain_nm }}</td><td>{{ item.syain_km }}</td><td>{{ item.bumon_nm }}</td><td>{{ item.nyusya_day_time*1000 | date:\'yyyy年MM月dd日\' }}</td></tr></tbody></table></div>");
$templateCache.put("app/masta-toku/detail-modal.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-7\"><h4 class=\"modal-title\" ng-if=\"tk.detailForm.toku_cd\"><span ng-if=\"!tk.cd_editing\" ng-dblclick=\"tk.cd_editing=true;tk.changeForm.chg_toku_cd=tk.detailForm.toku_cd\">得意先CD.<a href=\"\">{{ tk.detailForm.toku_cd }}</a></span> <span ng-if=\"tk.cd_editing\">得意先CD.<form name=\"chngeTokucd\"><div class=\"input-group\"><input class=\"form-control\" name=\"chg_toku_cd\" ng-remote-validate=\"{{tk.changeFormUrl}}\" ng-remote-throttle=\"550\" ng-remote-method=\"GET\" ng-model=\"tk.changeForm.chg_toku_cd\" autofocus=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-secondary\" type=\"button\" ng-click=\"tk.cd_doneEditing()\" ng-disabled=\"chngeTokucd.chg_toku_cd.$error.ngRemoteValidate\">更新</button></span></div></form><span ng-show=\"chngeTokucd.chg_toku_cd.$error.ngRemoteValidate\" style=\"color:red;font-size:50%;\">すでに登録されている番号です。違う番号を設定してください</span></span></h4><h4 class=\"modal-title\" ng-if=\"!tk.detailForm.toku_cd\">&nbsp;新規登録</h4></div><div class=\"col-xs-5\"><span class=\"pull-right\" ng-if=\"tk.detailForm.toku_cd\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"tk.tokuSubmit(\'DELETE\')\" style=\"width:150px\">削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"tk.tokuSubmit(\'PUT\')\" style=\"width:80px\">更新</button></span> <span class=\"pull-right\" ng-if=\"!tk.detailForm.toku_cd\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"tk.tokuSubmit(\'POST\')\" style=\"width:80px\">登録</button></span></div></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:130px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:129px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalKubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">得意先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.toku_kb_nm\" disabled=\"\"></div></td><td class=\"active text-center\" style=\"width:130px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:129px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.bumon_nm\" disabled=\"\"></div></td><td class=\"text-center\" style=\"width:130px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:129px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalEigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.tan_nm\" disabled=\"\"></div></td></tr><tr><td class=\"active text-center\" style=\"width:130px\">得意先名称</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.toku_nm\"></td><td class=\"active text-center\" style=\"width:130px\">略称</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.toku_rm\"></td><td class=\"active text-center\" style=\"width:130px\">カナ名称</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.toku_km\"></td></tr><tr><td class=\"active text-center\" style=\"width:130px\">得意先部署名</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.toku_busyo\"></td><td class=\"active text-center\" style=\"width:130px\">担当者名</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.toku_tanto\"></td><td class=\"active text-center\" style=\"width:130px\">敬称</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.keisyo\"></td></tr><tr><td class=\"active text-center\" style=\"width:130px\">〒</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.yubin_no\"></td><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:130px\">住所1</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.adrs1\"></td><td class=\"active text-center\" style=\"width:130px\">住所2</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.adrs2\"></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:130px\">TEL</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.tel_no\"></td><td class=\"active text-center\" style=\"width:130px\">FAX</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.fax_no\"></td><td class=\"active text-center\" colspan=\"2\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:130px\">Email</td><td class=\"text-right\"><input type=\"text\" ng-model=\"tk.detailForm.email\"></td><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr></tbody></table></div><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered\"><thead　style=\"padding:0;margin:0;\"><small>未設定は0が入ります</small><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:100px\">決算月</td><td class=\"text-right\" style=\"width:60px\"><input type=\"text\" ng-model=\"tk.detailForm.kessan_mm\" placeholder=\"○月\" maxlength=\"2\" model-format=\"number\" formatter=\"formatNumber($modelValue,$filter,\'0\', \'月\');\" numeric-only=\"\"></td><td class=\"active text-center\" style=\"width:100px\">締日</td><td class=\"text-right\" style=\"width:60px\"><input type=\"text\" ng-model=\"tk.detailForm.sime_dd\" placeholder=\"○日\" maxlength=\"2\" model-format=\"number\" formatter=\"formatNumber($modelValue,$filter,\'0\', \'日\');\" numeric-only=\"\"></td><td class=\"active text-center\" style=\"width:100px\">請求締日</td><td class=\"text-right\" style=\"width:60px\"><input type=\"text\" ng-model=\"tk.detailForm.sk_sime_dd\" placeholder=\"○日\" maxlength=\"2\" model-format=\"number\" formatter=\"formatNumber($modelValue,$filter,\'0\', \'日\');\" numeric-only=\"\"></td><td class=\"text-center\" style=\"width:100px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:99px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalSkTaniDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">請求単位 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.sk_tani_nm\" disabled=\"\"></div></td><td class=\"active text-center\" style=\"width:100px\">入金サイト</td><td class=\"text-right\" style=\"width:60px\"><input type=\"text\" ng-model=\"tk.detailForm.nk_sight\" placeholder=\"○ヶ月\" maxlength=\"2\" model-format=\"number\" formatter=\"formatNumber($modelValue,$filter,\'0\', \'ヶ月\');\" numeric-only=\"\"></td><td class=\"active text-center\" style=\"width:100px\">入金日</td><td class=\"text-right\" style=\"width:60px\"><input type=\"text\" ng-model=\"tk.detailForm.nk_dd\" placeholder=\"○日\" maxlength=\"2\" model-format=\"number\" formatter=\"formatNumber($modelValue,$filter,\'0\', \'日\');\" numeric-only=\"\"></td></tr></tbody></thead　style=\"padding:0;margin:0;\"></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:100px\">限度額1</td><td class=\"text-right\" style=\"width:200px\"><input type=\"text\" ng-model=\"tk.detailForm.genkai_kin1\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-center\" style=\"width:100px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:99px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalNkKeitai1Dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金形態1 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.nk_ketai1_nm\" disabled=\"\"></div></td><td class=\"text-center\" style=\"width:100px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:99px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalOverNkKeitaiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">超過分入金形態 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.over_nk_keitai_nm\" disabled=\"\"></div></td><td class=\"text-center\" style=\"width:100px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:99px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalHkKubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">納品書発行区分 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.nohin_hakko_kb_nm\" disabled=\"\"></div></td></tr><tr><td class=\"active text-center\" style=\"width:100px\">限度額2</td><td class=\"text-right\" style=\"width:200px\"><input type=\"text\" ng-model=\"tk.detailForm.genkai_kin2\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-center\" style=\"width:100px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:99px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalNkKeitai2Dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金形態2 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.nk_ketai2_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:100px\">限度額3</td><td class=\"text-right\" style=\"width:200px\"><input type=\"text\" ng-model=\"tk.detailForm.genkai_kin3\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-center\" style=\"width:100px;\" colspan=\"2\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:99px;margin:0;padding:0;text-align:center;\" bs-dropdown=\"tk.modalNkKeitai3Dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金形態3 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"tk.detail.nk_ketai3_nm\" disabled=\"\"></div></td><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr><tr><td class=\"active text-center\" style=\"width:100px\">売掛率</td><td class=\"text-right\" style=\"width:200px\"><input type=\"text\" ng-model=\"tk.detailForm.kakeritu\" maxlength=\"3\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', \'0%\');\" numeric-only=\"\"></td><td class=\"active text-center\" style=\"width:100px\">特別値引</td><td class=\"text-left\" style=\"width:200px;\"><div class=\"input-group\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"tk.detailForm.nebiki_fl\" value=\"0\" ng-change=\"tk.modalChangeNebiki(tk.detailForm.nebiki_fl)\">&nbsp;&nbsp;無</label> <label class=\"radio-inline\"><input type=\"radio\" ng-model=\"tk.detailForm.nebiki_fl\" value=\"1\" ng-change=\"tk.modalChangeNebiki(tk.detailForm.nebiki_fl)\">&nbsp;&nbsp;有</label></div></td><td class=\"active text-center\" colspan=\"4\">&nbsp;</td></tr></tbody></table></div></div><div class=\"row\" ng-if=\"tk.detailForm.nebiki_fl == \'1\'\"><div class=\"col-xs-8\"><table class=\"table table-hover table-bordered item-table\" style=\"min-height:100px;\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:5%\" class=\"sk-fit\">#</th><th style=\"width:10%\" class=\"sk-fit\">売上額（以上）</th><th style=\"width:10%\" class=\"sk-fit\">売上額（以下）</th><th style=\"width:10%\" class=\"sk-fit\">値引率</th><th style=\"width:10%\" class=\"sk-fit\">削除</th></tr></thead><tbody ng-repeat=\"item in tk.detailForm.nebiki\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" class=\"fit\"><tr><td class=\"text-center\" ng-init=\"item.seq_no = $index+1\">{{ $index+1 }}</td><td class=\"text-left\"><input type=\"text\" ng-model=\"item.uriage_ijyo\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-left\"><input type=\"text\" ng-model=\"item.uriage_ika\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-left\"><input type=\"text\" ng-model=\"item.nebiki_ritu\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter,\'0.0\', \'0%\');\" numeric-only=\"\"></td><td class=\"text-center\"><a href=\"\" ng-click=\"tk.nebikiDelete($index)\">削除</a></td></tr></tbody></table></div><div class=\"col-xs-3\"><div class=\"form-group pull-left\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"tk.nebikiExtend()\" style=\"width:80px\" ng-if=\"tk.detailForm.nebiki.length < 3\">追加</button></div></div><div class=\"col-xs-1\"></div></div><div class=\"row\"><div class=\"col-md-12\" style=\"height:30px\"></div></div></div></div></div></div>");
$templateCache.put("app/masta-toku/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください<br><small class=\"text-warning\">印刷にはGoogleChromeが適しています。</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\"> {{ itm.name }}</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/masta-toku/toku.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-show=\"tk.form\" ng-cloak=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"tokuForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\" disable-all=\"tk.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"tk.kubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">得意先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"tk.toku_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先名称</span> <input type=\"text\" class=\"form-control input-sm\" name=\"toku_nm\" ng-model=\"tk.form.toku_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><div style=\"height:30px;\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"tk.setTokuDetail(1, null)\">新規登録</button></div></div></div><div class=\"col-md-6\" disable-all=\"tk.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先カナ</span> <input type=\"text\" class=\"form-control input-sm\" name=\"toku_km\" ng-model=\"tk.form.toku_km\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"tk.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">関係部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"tk.bumon_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"tk.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"tk.tan_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"tk.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"tk.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"tk.datas\"><dir-pagination-controls on-page-change=\"tk.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"tk.datasPerPage < tk.totalDatas\" ng-bind=\"tk.pagination.current * tk.datasPerPage - (tk.datasPerPage -1) +\'～\'+tk.pagination.current * tk.datasPerPage+\'件/\'+tk.totalDatas+\'件\'\"></span> <span ng-if=\"tk.datasPerPage > tk.totalDatas\" ng-bind=\"tk.totalDatas+\'件/\'+tk.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"tk.datas\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">得意先CD</th><th style=\"width:45px\">得意先区分</th><th style=\"width:75px\">関係部門</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">担当営業</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in tk.datas | itemsPerPage: tk.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"tk.totalDatas\" current-page=\"tk.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"tk.setTokuDetail(2, item)\" style=\"cursor:pointer;\"><tr><td class=\"text-center\">{{ ($index + 1) + (tk.pagination.current - 1) * tk.datasPerPage }}</td><td style=\"cursor:default;\"><a href=\"\" ng-click=\"tk.setTokuDetail(1, item)\" bs-tooltip=\"tk.editTooltipText1\">{{ item.toku_cd }}</a></td><td>{{ item.toku_kb_nm }}</td><td>{{ item.bumon_nm }}</td><td>{{ item.toku_nm }}</td><td>{{ item.tan_nm }}</td></tr></tbody></table></div>");
$templateCache.put("app/masta-torihiki/detail-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\" style=\"min-height:380px;\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\">取引先CD.{{ thk.detailForm.tori_cd }}</h4></div><div class=\"col-xs-6\"><span class=\"pull-right\" ng-if=\"thk.mode == 2\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"thk.torihikisakiSubmit(\'DELETE\', thk.detailForm.tori_cd)\" style=\"width:80px\">削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"thk.torihikisakiSubmit(\'PUT\', thk.detailForm)\" style=\"width:150px\" ng-disabled=\"!thk.detailForm.tori_nm || !thk.detailForm.tori_km || !thk.detailForm.tori_rm || !thk.detailForm.tori_kb\">更新</button></span> <span class=\"pull-right\" ng-if=\"thk.mode == 1\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"thk.torihikisakiSubmit(\'POST\',thk.detailForm)\" style=\"width:150px\" ng-disabled=\"!thk.detailForm.tori_nm || !thk.detailForm.tori_km || !thk.detailForm.tori_rm || !thk.detailForm.tori_kb\">登録</button></span></div></div></div><div class=\"modal-body modal-fit\" style=\"min-height:350px;\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>取引先名称カナ</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.tori_km\" ng-blur=\"thk.changeZen2Cana(\'detailForm\')\" placeholder=\"半角カナ\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>取引先名称</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.tori_nm\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>取引先名称(略称)</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.tori_rm\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\"><small class=\"text-danger\">*</small>取引先区分</td><td class=\"text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"margin:0;padding:0;\" bs-dropdown=\"thk.modalTorihikisakiKbnDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span class=\"caret\"></span> {{ thk.detailForm.tori_kb_nm }}</button></span></div></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">取引先部署</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.tori_busyo\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">取引先担当</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.tori_tanto\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">敬称</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.keisyo\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">郵便番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.yubin_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">住所１</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.adrs1\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">住所２</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.adrs2\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">電話番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.tel_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">FAX番号</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.fax_no\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">Email</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.email\" ng-disabled=\"\"></td></tr><tr><td class=\"active text-center\" style=\"width:30%\">支払CD</td><td class=\"text-right\"><input type=\"text\" ng-model=\"thk.detailForm.siharai_cd\" ng-disabled=\"\"></td></tr></tbody></table><div><span class=\"text-danger\" ng-if=\"thk.pwLenError\"><small>※パスワードは6文字以上で入力してください</small></span> <span class=\"text-danger\" ng-if=\"thk.pwError\"><small>※パスワードに使える文字は半角英数記号です</small></span> <span class=\"text-danger\" ng-if=\"thk.idError\"><small>※IDに使える文字は半角英数です</small></span></div></div></div></div></div></div></div>");
$templateCache.put("app/masta-torihiki/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください<br><small class=\"text-warning\">印刷にはGoogleChromeが適しています。</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\"> {{ itm.name }}</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/masta-torihiki/torihiki.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-show=\"thk.form\" ng-cloak=\"\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"thk.setTokuDetail(1, null)\">新規登録</button><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"tokuForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\" disable-all=\"thk.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">取引先名称</span> <input type=\"text\" class=\"form-control input-sm\" name=\"tori_nm\" ng-model=\"thk.form.tori_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">取引先部署</span> <input type=\"text\" class=\"form-control input-sm\" name=\"tori_busyo\" ng-model=\"thk.form.tori_busyo\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"thk.kubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">取引先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"thk.tori_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><div style=\"height:30px;\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"pull-left\"></div></div></div><div class=\"col-md-6\" disable-all=\"thk.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">取引先カナ</span> <input type=\"text\" class=\"form-control input-sm\" name=\"tori_km\" ng-model=\"thk.form.tori_km\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">取引先担当</span> <input type=\"text\" class=\"form-control input-sm\" name=\"tori_tanto\" ng-model=\"thk.form.tori_tanto\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"thk.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"thk.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"thk.datas\"><dir-pagination-controls on-page-change=\"thk.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"thk.datasPerPage < thk.totalDatas\" ng-bind=\"thk.pagination.current * thk.datasPerPage - (thk.datasPerPage -1) +\'～\'+thk.pagination.current * thk.datasPerPage+\'件/\'+thk.totalDatas+\'件\'\"></span> <span ng-if=\"thk.datasPerPage > thk.totalDatas\" ng-bind=\"thk.totalDatas+\'件/\'+thk.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"thk.datas\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">取引先CD</th><th style=\"width:45px\">取引先区分</th><th style=\"width:75px\">取引先名称</th><th style=\"width:90px\">取引先部署</th><th style=\"width:60px\">取引先担当</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in thk.datas | itemsPerPage: thk.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"thk.totalDatas\" current-page=\"thk.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"thk.setTokuDetail(2, item)\" style=\"cursor:pointer;\"><tr><td class=\"text-center\">{{ ($index + 1) + (thk.pagination.current - 1) * thk.datasPerPage }}</td><td style=\"cursor:default;\"><a href=\"\" ng-click=\"thk.setTokuDetail(1, item)\" bs-tooltip=\"thk.editTooltipText1\">{{ item.tori_cd }}</a></td><td>{{ item.tori_kb_nm }}</td><td>{{ item.tori_nm }}</td><td>{{ item.tori_busyo }}</td><td>{{ item.tori_tanto }}</td></tr></tbody></table></div>");
$templateCache.put("app/menu/menu.html","<div class=\"container-fluid\"><acme-navbar></acme-navbar><div class=\"row\"><div class=\"col-md-3\"><div class=\"aside\" role=\"dialog\"><div class=\"aside-dialog\"><div class=\"aside-content\"><div class=\"aside-header\"><h4 class=\"aside-title\"></h4></div><div class=\"aside-body\"><div class=\"panel-group\" ng-model=\"panels.activePanel\" role=\"tablist\" aria-multiselectable=\"false\" bs-collapse=\"\"><div class=\"panel panel-default\" ng-repeat=\"(key, menus) in menu.admin_menu\" ng-show=\"!menus.hidden\" ng-if=\"menu.getujiChk(key)\"><div class=\"list-group\" role=\"tab\"><a href=\"\" class=\"list-group-item list-group-item-success\" bs-collapse-toggle=\"\"><i class=\"glyphicon {{menus.icon}}\"></i> {{menus.name}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': panels.activePanel == key, \'glyphicon-chevron-right\': panels.activePanel != key}\"></i></a><div class=\"list-group\" role=\"tabpanel\" bs-collapse-target=\"\"><a ui-sref=\"{{item.link}}\" class=\"list-group-item list-group-item-warning\" ng-if=\"menu.meisaiChk(item.id)\" ng-repeat=\"(chKey,item) in menus.items\" ng-click=\"panelSelected(key, item.id)\" ng-class=\"{\'active\':panels.activePanelLink == item.id && panels.activePanel == key}\">{{ item.name }}<i class=\"pull-right glyphicon glyphicon-pushpin\" ng-if=\"panels.activePanelLink == item.id\"></i></a></div></div></div></div></div></div></div></div></div><div class=\"col-md-9\"><ui-view></ui-view></div></div></div>");
$templateCache.put("app/monthly-action/main.html","<div ncy-breadcrumb=\"\"></div><div class=\"panel panel-default\"><div class=\"panel-body\" ng-if=\"ma.ShowAll\"><form role=\"form\" name=\"basicForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><p>最終月次実施月:&nbsp;{{ma.lastY}}年{{ma.lastM}}月</p><p ng-if=\"ma.monthlyMainCheck && !ma.monthlyActionDateCheck\" class=\"text-info\">STEP2に進んでください</p><p ng-if=\"ma.monthlyMainCheck && ma.monthlyActionDateCheck\" class=\"text-warning\">再チェックOK&nbsp;STEP2に進んでください</p><p ng-if=\"!ma.monthlyMainCheck && ma.errorPrint\" class=\"text-danger\">データエラー印刷を準備しています</p></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-warning btn-block\" ng-click=\"ma.monthlyAction()\" ng-if=\"!ma.monthlyMainCheck\" ng-disabled=\"ma.monthlyDateCheck || ma.monthlyDateLastCheck\">STEP1 月次チェック処理実行</button> <button type=\"button\" class=\"btn btn-danger btn-block\" ng-click=\"ma.monthlyMainActionModal()\" ng-if=\"ma.monthlyMainCheck\">STEP2 月次処理実行</button></div><div class=\"col-md-4\"><ul><li>本日:&nbsp;{{ma.now*1000 | date:\'yyyy年MM月dd日\'}}</li><li ng-if=\"!ma.monthlyDateCheck && ma.monthlyDateLastCheck\" class=\"text-danger\">次の月次実施可能日時は<br>{{ma.nowLastFirst*1000 | date:\'yyyy年MM月dd日\'}}以降です</li><li ng-if=\"ma.monthlyDateCheck\" class=\"text-danger\">{{ma.lastY}}年{{ma.lastM}}月の月次は実施済みです</li><li ng-if=\"!ma.monthlyDateCheck && !ma.monthlyDateLastCheck\" class=\"text-info\">月次実施可能です</li></ul></div></div></form></div></div>");
$templateCache.put("app/monthly-action/modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">月次処理実行確認</h4></div><div class=\"modal-body\"><p class=\"text-danger\">月次処理は10数分かかる場合があります。<br>途中でブラウザを閉じたり、別のページへ遷移したりせず、完了までお待ちください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$hide()\">キャンセル</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"ma.monthlyMainAction()\">月次処理実行</button></p></div></div></div></div>");
$templateCache.put("app/monthly-action/modal2.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">残在庫差異調整処理</h4></div><div class=\"modal-body\"><p class=\"text-danger\">続いて{{ma.lastY}}/{{ma.lastM}}の残在庫差異調整処理を行ってください<br>途中でブラウザを閉じたり、別のページへ遷移したりせず、完了までお待ちください。<br>ここでキャンセルしても<a ui-sref=\"app.zanzaiko-action({zz_date:\'\'})\" ng-click=\"$hide()\">こちら</a>から任意のタイミングで実施できます</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$hide()\">キャンセル</button> <a type=\"button\" class=\"btn btn-success\" ui-sref=\"app.zanzaiko-action({zz_date:ma.lastY+\'/\'+ma.lastM})\" ng-click=\"$hide()\">残在庫差異調整実行</a></p></div></div></div></div>");
$templateCache.put("app/mklist/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"mklist.form.toDate\" data-autoclose=\"true\" name=\"toDate\" bs-datepicker=\"\" disabled=\"\"></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"mklist.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:80px\">部門選択 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:200px\" ng-model=\"mklist.bumon_nm\" disabled=\"\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"mklist.tokuisakiSelected\" remote-api-handler=\"mklist.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-2\"><label class=\"radio-inline\">並び順 ：</label></div><div class=\"col-xs-3\"><label class=\"radio-inline\"><input type=\"radio\" name=\"optradio\" ng-model=\"mklist.form.sort\" value=\"1\">得意先カナ</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"optradio\" ng-model=\"mklist.form.sort\" value=\"2\">担当者</label></div><div class=\"col-xs-8\"></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><span class=\"text-danger\" ng-if=\"mklist.dateError\">※期間は3ヶ月以内で設定してください</span></div><div class=\"col-xs-5\"><div class=\"pull-right\"><button class=\"btn btn-default btn-sm\" ng-click=\"mklist.clear()\">クリア</button> <button class=\"btn btn-success btn-sm\" ng-click=\"mklist.generateAnalysis()\" ng-disabled=\"!mklist.form.toDate\">帳票生成</button></div></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"mklist.error\">{{ mklist.error }}</div></div></div></div></div>");
$templateCache.put("app/monthly-staff/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"mtf.from_date\" data-date-format=\"yyyy/MM\" data-min-view=\"1\" placeholder=\"yyyy/mm\" name=\"fromDate\" max-length=\"7\" bs-datepicker=\"\"></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"></div><div class=\"col-xs-5\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"mtf.generateAnalysis()\">実行</button></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"mtf.error\">{{ mtf.error }}</div></div></div></div>");
$templateCache.put("app/nyukin-yotei/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"nky.form.fromDate\" data-max-date=\"{{nky.form.untilDate}}\" placeholder=\"From\" data-autoclose=\"true\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"nky.form.untilDate\" data-min-date=\"{{nky.form.fromDate}}\" placeholder=\"To\" data-autoclose=\"true\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"nky.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:80px\">部門選択 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:200px\" ng-model=\"nky.bumon_nm\" disabled=\"\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"nky.tokuisakiSelected\" remote-api-handler=\"nky.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><label class=\"radio-inline\"><input type=\"radio\" name=\"optradio\" ng-model=\"nky.form.nkyt\" value=\"1\">請求ベース</label> <label class=\"radio-inline\"><input type=\"radio\" name=\"optradio\" ng-model=\"nky.form.nkyt\" value=\"2\">売上ベース</label></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><span class=\"text-danger\" ng-if=\"nky.dateError\">※期間は3ヶ月以内で設定してください</span></div><div class=\"col-xs-5\"><div class=\"pull-right\"><button class=\"btn btn-default btn-sm\" ng-click=\"nky.clear()\">クリア</button> <button class=\"btn btn-success btn-sm\" ng-click=\"nky.generateAnalysis()\" ng-disabled=\"!nky.form.fromDate\">帳票生成</button></div></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"nky.error\">{{ nky.error }}</div></div></div></div></div>");
$templateCache.put("app/payment/detail-modal.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-5\"><h4 class=\"modal-title\">入金No.{{ payment.tokuDtl.nk_no }}</h4></div><div class=\"col-xs-6\"><span class=\"pull-right\" ng-if=\"payment.mode == 2\"><button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"payment.paymentSubmit(\'DELETE\', payment.skUrDetail)\" style=\"width:150px\">入金を削除</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" ng-click=\"payment.paymentSubmit(\'PUT\', payment.skUrDetail)\" style=\"width:80px\" ng-disabled=\"!payment.detailForm.nk_day || !payment.detailForm.nk_sb || !payment.detailForm.toku_cd || payment.skUrDetail.length == 0\">更新</button></span> <span class=\"pull-right\" ng-if=\"payment.mode == 1\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"payment.paymentSubmit(\'POST\',payment.skUrDetail)\" style=\"width:80px\" ng-disabled=\"!payment.detailForm.nk_day || !payment.detailForm.nk_sb || !payment.detailForm.toku_cd || payment.skUrDetail.length == 0\">登録</button></span></div></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-xs-8\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\">入金日</td><td class=\"text-center\" style=\"width:130px;\"><input type=\"text\" ng-model=\"payment.detailForm.nk_day\" placeholder=\"yyyy/mm/dd\" autoclose=\"true\" name=\"nk_day\" bs-datepicker=\"\"></td><td class=\"text-center\" style=\"width:200px;\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:100px;margin:0;padding:0;\" bs-dropdown=\"payment.modalNkTypeDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金種別 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"payment.detail.nk_sb_nm\" disabled=\"\"></div></td><td class=\"active text-center\">請求先</td><td class=\"text-center\" style=\"max-width:150px\" ng-if=\"payment.mode == 1\"><div angucomplete-alt=\"\" id=\"tokuSlc\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"300\" auto-close=\"true\" initial-value=\"payment.detailForm.toku_cd\" selected-object=\"payment.modalTokuisakiSelected\" remote-api-handler=\"payment.modakTokuisakiApiSearch\" title-field=\"toku_cd,toku_nm\" minlength=\"1\"></div></td><td class=\"text-center\" style=\"max-width:150px\" ng-if=\"payment.mode != 1\">{{payment.detailForm.toku_cd}}</td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td style=\"height:58px\" colspan=\"2\">{{ payment.tokuDtl.toku_toku_nm }}<br><br>{{ payment.tokuDtl.toku_tanto_nm }}</td></tr><tr><td style=\"height:58px\" colspan=\"2\">〒{{ payment.tokuDtl.toku_yubin_no }}<br>{{ payment.tokuDtl.toku_adrs1 }}<br>{{ payment.tokuDtl.toku_adrs2 }}</td></tr><tr><td style=\"width:50%\">TEL.{{ payment.tokuDtl.toku_tel_no }}</td><td style=\"width:50%\">FAX.{{ payment.tokuDtl.toku_fax_no }}</td></tr><tr><td style=\"width:50%\">締日 {{ payment.tokuDtl.sime_dd_nm }}日({{ payment.tokuDtl.sk_sime_dd_nm }} <span ng-if=\"payment.tokuDtl.sk_sime_dd_nm != \'随時\' && payment.tokuDtl.sk_sime_dd_nm != \'末日\'\">日</span>)</td><td style=\"width:50%\">サイト(支払日) {{ payment.tokuDtl.toku_nk_sight }}ヶ月({{ payment.tokuDtl.nk_dd_nm }} <span ng-if=\"payment.tokuDtl.nk_dd_nm != \'随時\' && payment.tokuDtl.nk_dd_nm != \'末日\'\">日</span>)</td></tr></tbody></table></div><div class=\"col-xs-4\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr ng-if=\"!payment.detailForm.nk_sb || payment.detailForm.nk_sb == \'1\'\"><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:85px;margin:0;padding:0;\" bs-dropdown=\"payment.modalNkKozaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金口座 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"payment.detail.bank_fl_nm\" disabled=\"\"></div></td></tr><tr ng-if=\"payment.detailForm.nk_sb && payment.detailForm.nk_sb != 1\"><td class=\"td-clear\"></td><td class=\"td-clear\"></td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:85px;margin:0;padding:0;\" bs-dropdown=\"payment.modalNkBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金部門 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"payment.detail.nk_bmn_nm\" disabled=\"\"></div></td></tr><tr><td><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-dafault btn-xs dropdown-toggle\" style=\"width:85px;margin:0;padding:0;\" bs-dropdown=\"payment.modalNkTantoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金担当 <span class=\"caret\"></span></button></span> <input type=\"text\" ng-model=\"payment.detail.nk_tan_nm\" disabled=\"\"></div></td></tr></tbody></table><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active\" style=\"width:65px\">摘要</td><td class=\"text-right\"><input type=\"text\" ng-model=\"payment.detailForm.tekiyo\" ng-disabled=\"\"></td></tr></tbody></table><div class=\"col-xs-2\"></div><div class=\"col-xs-10\"><table class=\"table table-hover table-bordered\"><tbody class=\"fit\"><tr><td class=\"active text-center\" style=\"width:120px\">未入金合計</td><td class=\"active text-center\" style=\"width:120px\">入金合計</td><td class=\"active text-center\" style=\"width:120px\">差引残高</td></tr></tbody><tbody class=\"fit\"><tr><td class=\"text-right\" style=\"width:120px\">{{ payment.npSum | number }}</td><td class=\"text-right\" style=\"width:120px\">{{ payment.nkSum + payment.tsSum + payment.ztSum | number }}</td><td class=\"text-right\" style=\"width:120px\">{{ payment.npSum | number }}</td></tr></tbody></table></div><div class=\"seikyu-foot\"></div></div></div><table class=\"table table-hover table-bordered item-table\" style=\"min-height:100@x;\"><thead class=\"fit\"><tr class=\"active\"><th style=\"width:5%\" rowspan=\"2\" class=\"sk-fit\">#</th><th style=\"width:10%\" rowspan=\"2\" class=\"sk-fit\">納品日</th><th style=\"width:10%\" class=\"sk-fit\">納品No.</th><th class=\"sk-fit\" rowspan=\"2\">作品名</th><th style=\"width:10%\" class=\"sk-fit\">請求金額</th><th style=\"width:10%\" rowspan=\"2\" class=\"sk-fit\">入金額</th><th style=\"width:10%\" rowspan=\"2\" class=\"sk-fit\">手数料</th><th style=\"width:10%\" rowspan=\"2\" class=\"sk-fit\">雑損他</th></tr><tr><th class=\"sk-fit active\">請求No.</th><th class=\"sk-fit active\">未入金金額</th></tr></thead><tbody ng-repeat=\"item in payment.skUrDetail\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" class=\"fit\"><tr><td class=\"text-center\" rowspan=\"2\">{{ $index+1 }}</td><td class=\"text-center\" rowspan=\"2\">{{ item.ur_day_time*1000 | date }}</td><td class=\"text-center\">{{ item.nh_no }}</td><td rowspan=\"2\">{{ item.sakuhin_nm }}</td><td class=\"text-right\">{{ item.jt_ur_kin + item.zei_kin | number }}</td><td class=\"text-right\" rowspan=\"2\" ng-init=\"item.nk_kn = item.nk_kn?item.nk_kn:0\"><input type=\"text\" style=\"text-align:right;\" ng-model=\"item.nk_kn\" value=\"0\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-right\" rowspan=\"2\" ng-init=\"item.tesu_kn = item.tesu_kn?item.tesu_kn:0\"><input type=\"text\" style=\"text-align:right;\" ng-model=\"item.tesu_kn\" value=\"0\" model-format=\"number\" numeric-only=\"\"></td><td class=\"text-right\" rowspan=\"2\" ng-init=\"item.son_kn = item.son_kn?item.son_kn:0\"><input type=\"text\" style=\"text-align:right;\" ng-model=\"item.son_kn\" value=\"0\" model-format=\"number\" numeric-only=\"\"></td></tr><tr><td class=\"text-center\">{{ item.sk_no }}</td><td class=\"text-right\">{{ payment.notPaymentDtlSum(item) | number }}</td></tr><tr ng-if=\"$last\"><td class=\"sk-fit\" colspan=\"4\"></td><td class=\"active text-center sk-fit\">合計</td><td class=\"sk-fit text-right\">{{ payment.nkSum | number }}</td><td class=\"sk-fit text-right\">{{ payment.tsSum | number }}</td><td class=\"sk-fit text-right\">{{ payment.ztSum | number }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/payment/payment.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-show=\"payment.form\" ng-cloak=\"\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"payment.addPaymentDetail(1, item)\">新規登録</button><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"invoiceForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\" disable-all=\"payment.form.allSelect\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">入金日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"payment.form.nkDateFrom\" placeholder=\"from\" autoclose=\"true\" name=\"nkDateFrom\" style=\"width:90px;\" data-max-date=\"{{payment.form.nkDateTo}}\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">入金日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"payment.form.nkDateTo\" placeholder=\"to\" name=\"nkDateTo\" autoclose=\"true\" bs-datepicker=\"\" style=\"width:90px;\" data-min-date=\"{{payment.form.nkDateFrom}}\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">入金No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"payment.form.skNoFrom\" placeholder=\"from\" name=\"skNoFrom\" style=\"width:90px;\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">入金No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"payment.form.skNoTo\" placeholder=\"to\" name=\"skNoTo\" style=\"width:90px;\"></div></div><div class=\"col-xs-12\"><div class=\"pull-left\"></div></div></div><div class=\"col-md-6\" disable-all=\"payment.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先指定</span><div angucomplete-alt=\"\" id=\"dr01\" maxlength=\"50\" placeholder=\"No. 又は 名称\" pause=\"300\" selected-object=\"payment.tokuisakiSelected\" remote-api-handler=\"payment.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div><input type=\"hidden\" name=\"toku_cd\" ng-model=\"payment.form.toku_cd\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"payment.nkTypeDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">入金種別 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"payment.nk_sb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"payment.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"payment.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div></form></div></div></div><hr><div class=\"text-center\" ng-show=\"payment.datas\"><dir-pagination-controls on-page-change=\"payment.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"payment.datasPerPage < payment.totalDatas\" ng-bind=\"payment.pagination.current * payment.datasPerPage - (payment.datasPerPage -1) +\'～\'+payment.pagination.current * payment.datasPerPage+\'件/\'+payment.totalDatas+\'件\'\"></span> <span ng-if=\"payment.datasPerPage > payment.totalDatas\" ng-bind=\"payment.totalDatas+\'件/\'+payment.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"payment.datas\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th style=\"width:20px\" rowspan=\"2\">#</th><th style=\"width:65px\" rowspan=\"2\">入金日</th><th colspan=\"3\">得意先名</th><th style=\"width:75px\" rowspan=\"2\">入金額</th><th style=\"width:75px\" rowspan=\"2\">手数料</th><th style=\"width:75px\" rowspan=\"2\">雑益他</th><th style=\"width:75px\" rowspan=\"2\">入金合計</th></tr><tr class=\"active\"><th colspan=\"2\">入金No.</th><th>入金種別</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in payment.datas | itemsPerPage: payment.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"payment.totalDatas\" current-page=\"payment.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"payment.addPaymentDetail(2, item)\" style=\"cursor:pointer;\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (payment.pagination.current - 1) * payment.datasPerPage }}</td><td rowspan=\"2\">{{ item.nk_day_time*1000 | date }}</td><td style=\"width:65px;cursor:default;\"><a href=\"\" ng-click=\"payment.addPaymentDetail(1, item)\" bs-tooltip=\"payment.editTooltipText1\">{{ item.toku_cd }}</a></td><td colspan=\"2\">{{ item.toku_toku_nm }}</td><td rowspan=\"2\">{{ item.nk_kei - (item.tesu_kei+item.son_kei) | number }}</td><td rowspan=\"2\">{{ item.tesu_kei | number }}</td><td rowspan=\"2\">{{ item.son_kei | number }}</td><td rowspan=\"2\">{{ item.nk_kei | number }}</td></tr><tr><td colspan=\"2\">{{ item.nk_no }}</td><td style=\"width:85px\">{{ payment.SetSeikyuTaniNm(item.nk_sb) }}</td></tr></tbody></table></div>");
$templateCache.put("app/payment/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください<br><small class=\"text-warning\">印刷にはGoogleChromeが適しています。</small></h6><p><label ng-repeat=\"itm in invoicedata.typeCheck\"><input type=\"checkbox\" ng-model=\"itm.checked\"> {{ itm.name }}</label></p><p class=\"text-danger\" ng-if=\"invoicedata.generateCheckErr\">印刷対象を選択してください。</p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"invoicedata.typeCheckErr || invoicedata.generateCheckErr\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/tokuisaki-moto/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"tkm.form.fromDate\" data-max-date=\"{{tkm.form.untilDate}}\" placeholder=\"From\" data-autoclose=\"true\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"tkm.form.untilDate\" data-min-date=\"{{tkm.form.fromDate}}\" placeholder=\"To\" data-autoclose=\"true\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"tkm.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:80px\">部門選択 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:200px\" ng-model=\"tkm.bumon_nm\" disabled=\"\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"tkm.tokuisakiSelected\" remote-api-handler=\"tkm.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"></div><div class=\"col-xs-5\"><div class=\"pull-right\"><button class=\"btn btn-default btn-sm\" ng-click=\"tkm.clear()\">クリア</button> <button class=\"btn btn-success btn-sm pull-right\" ng-click=\"tkm.generateAnalysis()\" ng-disabled=\"!tkm.form.fromDate\">帳票生成</button></div></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"tkm.error\">{{ tkm.error }}</div></div></div></div></div>");
$templateCache.put("app/print/detail.html","<div class=\"col-xs-12 print-page-sys detail-sys\" ng-repeat=\"(i, dtlItems) in item.detail\"><div class=\"col-xs-12\"><div class=\"col-xs-4\"><p class=\"text-left\" ng-if=\"mode == 1\"><small>({{ item.toku_bumon_hd }}-{{ dtlItems[0].sk_no }})</small></p></div><div class=\"col-xs-4\"><p class=\"text-center sk-number\" ng-if=\"mode == 1\" style=\"font-size:180%\">請求明細書</p><p class=\"text-center sk-number\" ng-if=\"mode == 2\" style=\"font-size:180%\">納品書</p></div><div class=\"col-xs-4\"><p class=\"text-right sk-number\">No. {{ item.toku_bumon_hd }}-{{ dtlItems[0].nh_no }}</p></div></div><div class=\"col-xs-12\"><div class=\"dtl-top-table\"><table><tbody><tr><td class=\"left\">得意先</td><td class=\"middle\">{{ dtlItems[0].toku_cd }}</td><td class=\"right\" colspan=\"4\" ng-if=\"!dtlItems[0].toku_tanto\">{{ dtlItems[0].toku_nm }}&emsp;<span ng-if=\"dtlItems[0].toku_busyo\">{{ dtlItems[0].toku_busyo }}</span><br>{{ dtlItems[0].toku_toku_tanto }}&emsp;{{ dtlItems[0].toku_toku_keisyo }}</td><td class=\"right\" colspan=\"4\" ng-if=\"dtlItems[0].toku_tanto\">{{ dtlItems[0].toku_nm }}&emsp;<span ng-if=\"dtlItems[0].toku_busyo\">{{ dtlItems[0].toku_busyo }}</span><br>{{ dtlItems[0].toku_tanto }}&emsp;{{ dtlItems[0].keisyo }}</td></tr><tr><td class=\"left\">題名</td><td class=\"right\" colspan=\"5\">{{ dtlItems[0].sakuhin_nm }}</td></tr><tr><td class=\"left-bottom\">受注No.</td><td class=\"middle\">{{ dtlItems[0].ju_no }}</td><td class=\"middle\">受注日</td><td class=\"middle\"><span ng-if=\"dtlItems[0].ju_day_time > 0\">{{ dtlItems[0].ju_day_time*1000 | date:\'yyyy年MM月dd日\' }}</span> <span ng-if=\"!dtlItems[0].ju_day_time\">&emsp;&emsp;&emsp;&emsp;&emsp;</span></td><td class=\"middle\">納品日</td><td class=\"right-bottom\">{{ dtlItems[0].ur_day_time*1000 | date:\'yyyy年MM月dd日\' }}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"dtl-main-table\"><table><thead><tr><th>項目</th><th>時間</th><th>数量</th><th>単位</th><th>単価</th><th>金額</th></tr></thead><tbody ng-repeat=\"(day, items) in dtlItems | groupBy:\'sg_day_time\'\"><tr ng-repeat-start=\"(idx, dtl) in items\" ng-if=\"$first\"><td class=\"left\"><small ng-if=\"day > 0\">{{ day*1000 | date }}</small></td><td></td><td></td><td></td><td></td><td class=\"right\"></td></tr><tr ng-repeat-end=\"\"><td class=\"text-left\"><span ng-if=\"dtl.sg_item_nms\">{{ dtl.sg_item_nms }}</span> <span ng-if=\"!dtl.sg_item_nms\">&emsp;</span></td><td class=\"text-center\"><span ng-if=\"dtl.stt_tm\">{{ dtl.stt_tm_str }} ～ {{ dtl.end_tm_str }}</span> <span ng-if=\"!dtl.stt_tm\">&emsp;</span></td><td class=\"text-right\"><span ng-if=\"!dtl.suryo_2 || dtl.suryo_2 == 0 || dtl.suryo_2 == 0.0\">{{ dtl.suryo_1 }}</span> <span ng-if=\"dtl.suryo_2 && dtl.suryo_2 > 0\">{{ dtl.suryo_2 }}</span></td><td class=\"text-left\"><span ng-if=\"!dtl.suryo_2 || dtl.suryo_2 == 0 || dtl.suryo_2 == 0.0\">{{ dtl.tani_1 }}</span> <span ng-if=\"dtl.suryo_2 && dtl.suryo_2 > 0\">{{ dtl.tani_2 }}</span></td><td class=\"text-right\">{{ dtl.tanka | number }}</td><td class=\"text-right\">{{ dtl.kin | number }}</td></tr></tbody></table></div><div class=\"dtl-foot-table\"><table><tbody><tr class=\"top\"><td class=\"text-right left\">小&emsp;&emsp;計<br>消費税額<br>合&emsp;&emsp;計<br></td><td class=\"text-right right\"><span ng-if=\"dtlItems[0].nh_no != item.detail[i+1][0].nh_no || !item.detail[i+1][0].nh_no\">{{ dtlItems[0].jt_ur_kin | number }}<br>{{ dtlItems[0].zei_kin | number }}<br>{{ dtlItems[0].jt_ur_kin + dtlItems[0].zei_kin | number }}</span></td></tr><tr class=\"middle\"><td class=\"text-left\" colspan=\"2\"><b>備考</b>&emsp; {{ dtlItems[0].biko_1 }}<br>{{ dtlItems[0].biko_2 }}<br>{{ dtlItems[0].biko_3 }}</td></tr><tr class=\"bottom\"><td colspan=\"2\"><div class=\"col-xs-5\"><b>{{ print.kihon.kaisya_nm }}</b><br>〒{{ print.kihon.yubin_no }}<br>{{ print.kihon.adrs }}<br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;担当：{{ dtlItems[0].ju_tan_nm }}</div><div class=\"col-xs-7\"><br><small>{{ print.kihon.tel1 }}<br>{{ print.kihon.tel2 }}</small></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/print/detail2.html","<div class=\"col-xs-12 print-page-sys detail-sys\" ng-repeat=\"(i, dtlItems) in item.detail\"><div class=\"col-xs-12\"><div class=\"col-xs-4\"><p class=\"text-left\" ng-if=\"mode == 1\"><small>({{ item.toku_bumon_hd }}-{{ dtlItems[0].sk_no }})</small></p></div><div class=\"col-xs-4\"><p class=\"text-center sk-number\" ng-if=\"mode == 2\" style=\"font-size:180%\">納品書控</p></div><div class=\"col-xs-4\"><p class=\"text-right sk-number\">No. {{ item.toku_bumon_hd }}-{{ dtlItems[0].nh_no }}</p></div></div><div class=\"col-xs-12\"><div class=\"dtl-top-table\"><table><tbody><tr><td class=\"left\">得意先</td><td class=\"middle\">{{ dtlItems[0].toku_cd }}</td><td class=\"right\" colspan=\"4\" ng-if=\"!dtlItems[0].toku_tanto\">{{ dtlItems[0].toku_nm }}&emsp;<span ng-if=\"dtlItems[0].toku_busyo\">{{ dtlItems[0].toku_busyo }}</span><br>{{ dtlItems[0].toku_toku_tanto }}&emsp;{{ dtlItems[0].toku_toku_keisyo }}</td><td class=\"right\" colspan=\"4\" ng-if=\"dtlItems[0].toku_tanto\">{{ dtlItems[0].toku_nm }}&emsp;<span ng-if=\"dtlItems[0].toku_busyo\">{{ dtlItems[0].toku_busyo }}</span><br>{{ dtlItems[0].toku_tanto }}&emsp;{{ dtlItems[0].keisyo }}</td></tr><tr><td class=\"left\">題名</td><td class=\"right\" colspan=\"5\">{{ dtlItems[0].sakuhin_nm }}</td></tr><tr><td class=\"left-bottom\">受注No.</td><td class=\"middle\">{{ dtlItems[0].ju_no }}</td><td class=\"middle\">受注日</td><td class=\"middle\"><span ng-if=\"dtlItems[0].ju_day_time > 0\">{{ dtlItems[0].ju_day_time*1000 | date:\'yyyy年MM月dd日\' }}</span> <span ng-if=\"!dtlItems[0].ju_day_time\">&emsp;&emsp;&emsp;&emsp;&emsp;</span></td><td class=\"middle\">納品日</td><td class=\"right-bottom\">{{ dtlItems[0].ur_day_time*1000 | date:\'yyyy年MM月dd日\' }}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"dtl-main-table\"><table><thead><tr><th>項目</th><th>時間</th><th>数量</th><th>単位</th><th>単価</th><th>金額</th></tr></thead><tbody ng-repeat=\"(day, items) in dtlItems | groupBy:\'sg_day_time\'\"><tr ng-repeat-start=\"(idx, dtl) in items\" ng-if=\"$first\"><td class=\"left\"><small ng-if=\"day > 0\">{{ day*1000 | date }}</small></td><td></td><td></td><td></td><td></td><td class=\"right\"></td></tr><tr ng-repeat-end=\"\"><td class=\"text-left\"><span ng-if=\"dtl.sg_item_nms\">{{ dtl.sg_item_nms }}</span> <span ng-if=\"!dtl.sg_item_nms\">&emsp;</span></td><td class=\"text-center\"><span ng-if=\"dtl.stt_tm\">{{ dtl.stt_tm_str }} ～ {{ dtl.end_tm_str }}</span> <span ng-if=\"!dtl.stt_tm\">&emsp;</span></td><td class=\"text-right\"><span ng-if=\"!dtl.suryo_2 || dtl.suryo_2 == 0 || dtl.suryo_2 == 0.0\">{{ dtl.suryo_1 }}</span> <span ng-if=\"dtl.suryo_2 && dtl.suryo_2 > 0\">{{ dtl.suryo_2 }}</span></td><td class=\"text-left\"><span ng-if=\"!dtl.suryo_2 || dtl.suryo_2 == 0 || dtl.suryo_2 == 0.0\">{{ dtl.tani_1 }}</span> <span ng-if=\"dtl.suryo_2 && dtl.suryo_2 > 0\">{{ dtl.tani_2 }}</span></td><td class=\"text-right\">{{ dtl.tanka | number }}</td><td class=\"text-right\">{{ dtl.kin | number }}</td></tr></tbody></table></div><div class=\"dtl-foot-table\"><table><tbody><tr class=\"top\"><td class=\"text-right left\">小&emsp;&emsp;計<br>消費税額<br>合&emsp;&emsp;計<br></td><td class=\"text-right right\"><span ng-if=\"dtlItems[0].nh_no != item.detail[i+1][0].nh_no || !item.detail[i+1][0].nh_no\">{{ dtlItems[0].jt_ur_kin | number }}<br>{{ dtlItems[0].zei_kin | number }}<br>{{ dtlItems[0].jt_ur_kin + dtlItems[0].zei_kin | number }}</span></td></tr><tr class=\"middle\"><td class=\"text-left\" colspan=\"2\"><b>備考</b>&emsp; {{ dtlItems[0].biko_1 }}<br>{{ dtlItems[0].biko_2 }}<br>{{ dtlItems[0].biko_3 }}</td></tr><tr class=\"bottom\"><td colspan=\"2\"><div class=\"col-xs-5\"><b>{{ print.kihon.kaisya_nm }}</b><br>〒{{ print.kihon.yubin_no }}<br>{{ print.kihon.adrs }}<br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;担当：{{ dtlItems[0].ju_tan_nm }}</div><div class=\"col-xs-7\"><br><small>{{ print.kihon.tel1 }}<br>{{ print.kihon.tel2 }}</small></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/print/invoice.html","<div class=\"print-page-invoice-sys\"><div class=\"print-page-invoice-content\"><h1 class=\"print-page-invoice-sk-number\">No. {{ item.toku_bumon_hd }}-{{ item.sk_no }}</h1><div class=\"print-page-invoice-sk-top-area\"><div class=\"print-page-invoice-sk-left-table\"><table><tr><td>〒 {{ item.toku_yubin_no }}</td></tr><tr><td>{{ item.toku_adrs1 }}<br>{{ item.toku_adrs2 }}</td></tr><tr><td>&nbsp;</td></tr><tr><td class=\"high\">{{ item.toku_toku_nm }} <span ng-if=\"item.ur_toku_busyo\"><br>{{ item.ur_toku_busyo }}</span></td></tr><tr><td class=\"text-right\" ng-if=\"item.ur_toku_tanto\">{{ item.ur_toku_tanto }} {{ item.ur_toku_keisyo }}</td><td class=\"text-right\" ng-if=\"!item.ur_toku_tanto\">{{ item.toku_tanto_nm }} {{ item.toku_toku_keisyo }}</td></tr><tr><td class=\"bottom\"><span>&nbsp;</span></td></tr></table></div><div class=\"print-page-invoice-sk-right-table\"><table><tr><td>ご利用金額</td><td class=\"text-right\">{{ print.setSasyhikiKin(item) | number }} 円</td></tr><tr><td class=\"left\"><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">特別値引額</span></td><td class=\"text-right\"><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">{{ item.tokubiki_kn | number }} 円</span></td></tr><tr><td></td><td></td></tr><tr><td>消費税額</td><td class=\"text-right\">{{ item.zei_kn | number }} 円</td></tr><tr><td class=\"bottom\">ご請求金額</td><td class=\"bottom text-right\">{{ item.sk_kn | number }} 円</td></tr></table></div></div><div class=\"print-page-invoice-sk-middle-area\"><h1>{{ item.sk_day_time*1000 | date:\'yyyy年MM月dd日\' }}&emsp;締切</h1><h2>件数&emsp;{{ item.nhin_su }}</h2><ul class=\"middle-ul\"><li ng-repeat=\"itm in print.kozaData\">{{ itm.bank_nm }}&emsp;{{ itm.siten_nm }}（{{ itm.yokin_sb_nm }}）&emsp;{{ itm.koza_no }}</li></ul></div><div class=\"print-page-invoice-sk-blank-area\"></div><h1 class=\"print-page-invoice-sk-number\">No. {{ item.toku_bumon_hd }}-{{ item.sk_no }}</h1><div class=\"print-page-invoice-sk-top-area\"><div class=\"print-page-invoice-sk-left-table\"><table><tr><td>〒 {{ item.toku_yubin_no }}</td></tr><tr><td>{{ item.toku_adrs1 }}<br>{{ item.toku_adrs2 }}</td></tr><tr><td>&nbsp;</td></tr><tr><td class=\"high\">{{ item.toku_toku_nm }} <span ng-if=\"item.ur_toku_busyo\"><br>{{ item.ur_toku_busyo }}</span></td></tr><tr><td class=\"text-right\" ng-if=\"item.ur_toku_tanto\">{{ item.ur_toku_tanto }} {{ item.ur_toku_keisyo }}</td><td class=\"text-right\" ng-if=\"!item.ur_toku_tanto\">{{ item.toku_tanto_nm }} {{ item.toku_toku_keisyo }}</td></tr><tr><td class=\"bottom\"><span>&nbsp;</span></td></tr></table></div><div class=\"print-page-invoice-sk-right-table\"><table><tr><td>ご利用金額</td><td class=\"text-right\">{{ print.setSasyhikiKin(item) | number }} 円</td></tr><tr><td class=\"left\"><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">特別値引額</span></td><td class=\"text-right\"><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">{{ item.tokubiki_kn | number }} 円</span></td></tr><tr><td></td><td></td></tr><tr><td>消費税額</td><td class=\"text-right\">{{ item.zei_kn | number }} 円</td></tr><tr><td class=\"bottom\">ご請求金額</td><td class=\"bottom text-right\">{{ item.sk_kn | number }} 円</td></tr></table></div></div><div class=\"print-page-invoice-sk-middle-area\"><h1>{{ item.sk_day_time*1000 | date:\'yyyy年MM月dd日\' }}&emsp;締切</h1><h2>件数&emsp;{{ item.nhin_su }}</h2><ul class=\"middle-ul\"><li ng-repeat=\"itm in print.kozaData\">{{ itm.bank_nm }}&emsp;{{ itm.siten_nm }}（{{ itm.yokin_sb_nm }}）&emsp;{{ itm.koza_no }}</li></ul></div></div></div>");
$templateCache.put("app/print/invoice_old.html","<div class=\"col-xs-12 print-page-invoice-sys\"><div class=\"col-xs-12 col-sys\"><p class=\"text-right sk-number\">No. {{ item.toku_bumon_hd }}-{{ item.sk_no }}</p></div><div class=\"col-xs-6\"><div class=\"sk-left-table\"><table><tr><td>〒 {{ item.toku_yubin_no }}</td></tr><tr><td>{{ item.toku_adrs1 }}<br>{{ item.toku_adrs2 }}</td></tr><tr><td>&emsp;</td></tr><tr><td>{{ item.toku_toku_nm }} <span ng-if=\"item.ur_toku_busyo\"><br>{{ item.ur_toku_busyo }}</span></td></tr><tr><td class=\"name\" ng-if=\"item.ur_toku_tanto\">{{ item.ur_toku_tanto }} {{ item.ur_toku_keisyo }}<hr style=\"margin-top:2px;\"></td><td class=\"name\" ng-if=\"!item.ur_toku_tanto\">{{ item.toku_tanto_nm }} {{ item.toku_toku_keisyo }}<hr style=\"margin-top:2px;\"></td></tr></table></div></div><div class=\"col-xs-6\"><div class=\"sk-right-table\"><table><tr class=\"top-middle\"><td class=\"left\">ご利用金額</td><td>{{ print.setSasyhikiKin(item) | number }} 円</td></tr><tr class=\"top-middle\"><td class=\"left\"><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">特別値引額</span></td><td><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">{{ item.tokubiki_kn | number }} 円</span></td></tr><tr class=\"top-middle\"><td class=\"left\"></td><td></td></tr><tr class=\"top-middle\"><td class=\"left\">消費税額</td><td>{{ item.zei_kn | number }} 円</td></tr><tr class=\"bottom\"><td class=\"left\">ご請求金額</td><td>{{ item.sk_kn | number }} 円</td></tr></table></div></div><div class=\"col-xs-12\"><p class=\"text-right\">{{ item.sk_day_time*1000 | date:\'yyyy年MM月dd日\' }}&emsp;締切</p><p class=\"text-right\">件数&emsp;{{ item.nhin_su }}</p></div><div class=\"col-xs-12\" style=\"margin-top:-3mm\"><ul class=\"text-left\" style=\"padding-left:4mm;\"><li ng-repeat=\"itm in print.kozaData\">{{ itm.bank_nm }}&emsp;{{ itm.siten_nm }}（{{ itm.yokin_sb_nm }}）&emsp;{{ itm.koza_no }}</li></ul></div><div class=\"col-xs-12\"><div style=\"height:60mm;\"></div></div><div class=\"col-xs-12\"><p class=\"text-right sk-number\">No. {{ item.toku_bumon_hd }}-{{ item.sk_no }}</p></div><div class=\"col-xs-6\"><div class=\"sk-left-table\"><table><tr><td>〒 {{ item.toku_yubin_no }}</td></tr><tr><td>{{ item.toku_adrs1 }}<br>{{ item.toku_adrs2 }}</td></tr><tr><td>&emsp;</td></tr><tr><td>{{ item.toku_toku_nm }} <span ng-if=\"item.ur_toku_busyo\"><br>{{ item.ur_toku_busyo }}</span></td></tr><tr><td class=\"name\" ng-if=\"item.ur_toku_tanto\">{{ item.ur_toku_tanto }} {{ item.ur_toku_keisyo }}<hr style=\"margin-top:2px;\"></td><td class=\"name\" ng-if=\"!item.ur_toku_tanto\">{{ item.toku_tanto_nm }} {{ item.toku_toku_keisyo }}<hr style=\"margin-top:2px;\"></td></tr></table><p class=\"text-left\">{{ item.hk_day_time*1000 | date:\'yyyy年MM月dd日\' }}&emsp;発行</p></div></div><div class=\"col-xs-6\"><div class=\"sk-right-table\"><table><tr class=\"top-middle\"><td class=\"left\">ご利用金額</td><td>{{ print.setSasyhikiKin(item) | number }} 円</td></tr><tr class=\"top-middle\"><td class=\"left\"><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">特別値引額</span></td><td><span ng-if=\"item.tokubiki_kn && item.tokubiki_kn > 0\">{{ item.tokubiki_kn | number }} 円</span></td></tr><tr class=\"top-middle\"><td class=\"left\"></td><td></td></tr><tr class=\"top-middle\"><td class=\"left\">消費税額</td><td>{{ item.zei_kn | number }} 円</td></tr><tr class=\"bottom\"><td class=\"left\">ご請求金額</td><td>{{ item.sk_kn | number }} 円</td></tr></table></div></div><div class=\"col-xs-12\" style=\"margin-top:-3mm\"><p class=\"text-right\">{{ item.sk_day_time*1000 | date:\'yyyy年MM月dd日\' }}&emsp;締切</p><p class=\"text-right\">件数&emsp;{{ item.nhin_su }}</p></div><div class=\"col-xs-12\"><ul class=\"text-left\" style=\"padding-left:4mm;padding-top:-5mm;\"><li ng-repeat=\"itm in print.kozaData\">{{ itm.bank_nm }}&emsp;{{ itm.siten_nm }}（{{ itm.yokin_sb_nm }}）&emsp;{{ itm.koza_no }}</li></ul></div></div>");
$templateCache.put("app/print/nhin.html","<div class=\"col-xs-12 print-page-sys detail-sys\" ng-repeat=\"(i, dtlItems) in item.detail\"><div class=\"col-xs-12\"><div class=\"col-xs-4\"><p class=\"text-left\" ng-if=\"mode == 1\"><small>({{ item.toku_bumon_hd }}-{{ dtlItems[0].sk_no }})</small></p></div><div class=\"col-xs-4\"><p class=\"text-center sk-number\" ng-if=\"mode == 1\" style=\"font-size:180%\">請求明細書</p><p class=\"text-center sk-number\" ng-if=\"mode == 2\" style=\"font-size:180%\">納品書</p></div><div class=\"col-xs-4\"><p class=\"text-right sk-number\">No. {{ item.toku_bumon_hd }}-{{ dtlItems[0].nh_no }}</p></div></div><div class=\"col-xs-12\"><div class=\"dtl-top-table\"><table><tbody><tr><td class=\"left\">得意先</td><td class=\"middle\">{{ dtlItems[0].toku_cd }}</td><td class=\"right\" colspan=\"4\" ng-if=\"!dtlItems[0].toku_tanto\">{{ dtlItems[0].toku_nm }}&emsp;<span ng-if=\"dtlItems[0].toku_busyo\">{{ dtlItems[0].toku_busyo }}</span><br>{{ dtlItems[0].toku_toku_tanto }}&emsp;{{ dtlItems[0].toku_toku_keisyo }}</td><td class=\"right\" colspan=\"4\" ng-if=\"dtlItems[0].toku_tanto\">{{ dtlItems[0].toku_nm }}&emsp;<span ng-if=\"dtlItems[0].toku_busyo\">{{ dtlItems[0].toku_busyo }}</span><br>{{ dtlItems[0].toku_tanto }}&emsp;{{ dtlItems[0].keisyo }}</td></tr><tr><td class=\"left\">題名</td><td class=\"right\" colspan=\"5\">{{ dtlItems[0].sakuhin_nm }}</td></tr><tr><td class=\"left-bottom\">受注No.</td><td class=\"middle\">{{ dtlItems[0].ju_no }}</td><td class=\"middle\">受注日</td><td class=\"middle\"><span ng-if=\"dtlItems[0].ju_day_time > 0\">{{ dtlItems[0].ju_day_time*1000 | date:\'yyyy年MM月dd日\' }}</span> <span ng-if=\"!dtlItems[0].ju_day_time\">&emsp;&emsp;&emsp;&emsp;&emsp;</span></td><td class=\"middle\">納品日</td><td class=\"right-bottom\">{{ dtlItems[0].ur_day_time*1000 | date:\'yyyy年MM月dd日\' }}</td></tr></tbody></table></div></div><div class=\"col-xs-12\"><div class=\"dtl-main-table\"><table><thead><tr><th>項目</th><th>時間</th><th>数量</th><th>単位</th><th>単価</th><th>金額</th></tr></thead><tbody ng-repeat=\"(idx, dtl) in dtlItems\"><tr ng-if=\"$first || dtl.sg_day_time != dtlItems[idx+1].sg_day_time\"><td class=\"left\"><small ng-if=\"dtl.sg_day_time > 0\">{{ dtl.sg_day_time*1000 | date }}</small></td><td></td><td></td><td></td><td></td><td class=\"right\"></td></tr><tr><td class=\"left\">{{ dtl.sg_item_nms }}</td><td><span ng-if=\"dtl.stt_tm\">{{ dtl.stt_tm }} ～ {{ dtl.end_tm }}</span></td><td><span ng-if=\"!dtl.suryo_2 || dtl.suryo_2 == 0 || dtl.suryo_2 == 0.0\">{{ dtl.suryo_1 }}</span> <span ng-if=\"dtl.suryo_2 && dtl.suryo_2 > 0\">{{ dtl.suryo_2 }}</span></td><td><span ng-if=\"!dtl.suryo_2 || dtl.suryo_2 == 0 || dtl.suryo_2 == 0.0\">{{ dtl.tani_1 }}</span> <span ng-if=\"dtl.suryo_2 && dtl.suryo_2 > 0\">{{ dtl.tani_2 }}</span></td><td>{{ dtl.tanka | number }}</td><td class=\"right\">{{ dtl.kin | number }}</td></tr></tbody></table></div><div class=\"dtl-foot-table\"><table><tbody><tr class=\"top\"><td class=\"text-right left\">小&emsp;&emsp;計<br>消費税額<br>合&emsp;&emsp;計<br></td><td class=\"text-right right\"><span ng-if=\"dtlItems[0].nh_no != item.detail[i+1][0].nh_no || !item.detail[i+1][0].nh_no\">{{ dtlItems[0].jt_ur_kin | number }}<br>{{ dtlItems[0].zei_kin | number }}<br>{{ dtlItems[0].jt_ur_kin + dtlItems[0].zei_kin | number }}</span></td></tr><tr class=\"middle\"><td class=\"text-left\" colspan=\"2\"><b>備考</b>&emsp; {{ dtlItems[0].biko_1 }}<br>{{ dtlItems[0].biko_2 }}<br>{{ dtlItems[0].biko_3 }}</td></tr><tr class=\"bottom\"><td colspan=\"2\"><div class=\"col-xs-5\"><b>{{ print.kihon.kaisya_nm }}</b><br>〒{{ print.kihon.yubin_no }}&emsp;{{ print.kihon.adrs }}<br>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;担当：{{ print.kihon.tantou }}</div><div class=\"col-xs-7\"><br><small>{{ print.kihon.tel1 }}<br>{{ print.kihon.tel2 }}</small></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/print/print.html","<style>\n@page {\n  size: A4!important;\n  margin: 0!important;\n}\n@media print {\n  html, body {\n    width: 210mm!important;\n    height: 297mm!important;\n  }\n}\n</style><nav ng-class=\"\" ng-if=\"print.printMode == \'invoice\'\"><dir-pagination-controls on-page-change=\"print.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"printPaginate\"></dir-pagination-controls><button ng-print=\"\" print-element-id=\"print-area\"><i class=\"fa fa-print\"></i> 印刷</button> 表示件数：<input type=\"text\" style=\"width:30px;top:2px;\" ng-model=\"print.datasPerPage\"></nav><nav ng-class=\"\" ng-if=\"print.printMode == \'sgyt\'\"><button ng-print=\"\" print-element-id=\"print-area\"><i class=\"fa fa-print\"></i> 印刷</button></nav><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br>{{ print.pagination.current }}</div><hr><div class=\"row preview-area\" ng-class=\"{\'preview-invoice\':print.printMode == \'invoice\'}\" ng-if=\"print.printMode == \'invoice\'\"><article id=\"print-area\" ng-class=\"{\'invoice\':print.printMode == \'invoice\'}\"><section class=\"col-xs-12\" dir-paginate=\"item in print.datas | itemsPerPage: print.datasPerPage\" pagination-id=\"printPaginate\" total-items=\"print.totalDatas\" current-page=\"print.pagination.current\"><span ng-if=\"print.inviceMode\" ng-include=\"\'app/print/invoice.html\'\"></span> <span ng-if=\"item.detail.length > 0 && print.inviceDtlMode\"><span ng-include=\"\'app/print/detail.html\'\" ng-init=\"mode = 1\"></span></span> <span ng-if=\"item.detail.length > 0 && print.nhinMode\" ng-init=\"mode = 2\"><span ng-include=\"\'app/print/detail.html\'\"></span> <span ng-include=\"\'app/print/detail2.html\'\"></span></span></section></article></div><div class=\"row preview-area\" ng-if=\"print.printMode == \'sgyt\'\"><article id=\"print-area\"><section class=\"col-xs-12\"><span ng-repeat=\"sgytDtl in print.sgytDtl\"><span ng-include=\"\'app/print/sgyt.html\'\"></span></span> <span ng-repeat=\"sgytDtl in print.sgytDtl\"><span ng-include=\"\'app/print/sgytfor.html\'\"></span></span></section></article></div>");
$templateCache.put("app/print/sgyt.html","<div class=\"col-xs-12 print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center yt-title\">物品受渡書</p></div><div class=\"col-xs-3 text-center yt-page\"><span ng-if=\"print.sgytDtl.length > 1\">{{ $index+1 }}</span></div></div><div class=\"col-xs-6\"><div class=\"yt-left-table\"><table><tr><td colspan=\"2\" style=\"width:90%\">{{ print.order.toku_nm }}</td><td style=\"width:10%\">&emsp;</td></tr><tr><td colspan=\"2\" style=\"width:90%\">{{ print.order.toku_bumon_nm }}</td><td style=\"width:10%\">&emsp;</td></tr><tr><td colspan=\"3\" class=\"name text-right\"><span ng-if=\"print.order.toku_tanto_nm\">{{ print.order.toku_tanto_nm }}&emsp;様</span> <span ng-if=\"!print.order.toku_tanto_nm\">&emsp;御中</span></td></tr><tr><td colspan=\"3\"><hr style=\"margin-top:2px;\"></td></tr></table></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><div class=\"yt-right-table\"><table><tr><td colspan=\"2\">{{ print.kihon.kaisya_nm }}</td></tr><tr class=\"kai_dtl\"><td colspan=\"2\">{{ print.kihon.yubin_no }}</td></tr><tr class=\"kai_dtl\"><td colspan=\"2\">{{ print.kihon.adrs }}</td></tr><tr class=\"kai_dtl\"><td class=\"text-left\"><small>{{ print.kihon.tel_sgyt1 }}&emsp;</small></td><td class=\"text-right\"><small>&emsp;{{ print.kihon.tel_sgyt2 }}</small></td></tr></table></div></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-10\"><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><div class=\"yt-title-table\"><table><tr><td class=\"left text-center\">題名</td><td class=\"right\" colspan=\"2\">{{ print.order.hin_nm }}</td></tr><tr><td class=\"left-bottom text-center\">納品日</td><td class=\"right\"><span ng-if=\"print.sgyt.print_nh_dt_time\">{{ print.sgyt.print_nh_dt_time*1000 | date:\'yyyy年MM月dd日\' }}</span> <span ng-if=\"!print.sgyt.print_nh_dt_time\">&emsp;</span></td><td class=\"text-right\">({{ print.order.ju_no }})</td></tr></table></div></div></div><div class=\"col-xs-2\"><div class=\"yt-tanto-table\"><table><tr><th class=\"text-center\">担当者</th></tr><tr class=\"top-middle\"><td class=\"text-center\">&emsp;</td></tr></table></div></div></div></div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><small>下記の内容で納品致しました。ご査収の程宜しくお願い申し上げます。</small></div><div class=\"col-xs-12\"><div class=\"yt-dtl-table\"><table><thead><tr><th class=\"text-center\">項目</th><th class=\"text-center\">数量</th><th class=\"text-center\">単位</th></tr></thead><tbody ng-repeat=\"item in sgytDtl\"><tr><td class=\"text-left\"><span ng-if=\"item.kmk_nm && item.sg_bunrui_cd != \'06\'\" \"=\"\">{{ item.kmk_nm }}</span> <span ng-if=\"item.kmk_nm && item.sg_bunrui_cd == \'06\'\">{{ item.db_cd }}&emsp;{{ item.sub_title }}&emsp; <span ng-if=\"item.media_cd_1_nm && !item.media_cd_2_nm\">{{ item.media_cd_1_nm }}&emsp;</span> <span ng-if=\"item.media_cd_1_nm && item.media_cd_2_nm\">{{ item.media_cd_2_nm }}&emsp;</span> {{ item.sec }}&emsp;{{ changeSecKbnName(item.sec_tani_kb) }}</span> <span ng-if=\"!item.kmk_nm && !item.sg_bunrui_cd\">&emsp;</span></td><td class=\"text-right\" style=\"width:80px\"><span ng-if=\"item.suryo_1 && !item.tani_2\">{{ item.suryo_1 }}</span> <span ng-if=\"item.suryo_1 && item.tani_2\">{{ item.suryo_2 }}</span> <span ng-if=\"!item.suryo_1 && !item.suryo_2\">&emsp;</span></td><td class=\"text-left\" style=\"width:80px\"><span ng-if=\"item.tani_1 && !item.tani_2\">{{ item.tani_1 }}</span> <span ng-if=\"item.tani_1 && item.tani_2\">{{ item.tani_2 }}</span> <span ng-if=\"!item.tani_1 && !item.tani_2\">&emsp;</span></td></tr><tbody></tbody></tbody></table></div></div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><div class=\"yt-title-table\"><table><tr><td class=\"left-bottom text-left\"><div style=\"min-height:100px;\"><p>備考</p></div></td></tr></table></div></div></div>");
$templateCache.put("app/print/sgytfor.html","<div class=\"col-xs-12 print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center yt-title\">物品受領書</p></div><div class=\"col-xs-3 text-center yt-page\"><span ng-if=\"print.sgytDtl.length > 1\">{{ $index+1 }}</span></div></div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><div class=\"col-xs-6\">{{ print.kihon.kaisya_nm }} 御中</div><div class=\"col-xs-3\"></div><div class=\"col-xs-3\"></div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-3\"></div><div class=\"col-xs-3\"></div><div class=\"col-xs-6 text-center\">{{ print.order.toku_nm }}</div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-10\"><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><div class=\"yt-title-table\"><table><tr><td class=\"left text-center\">題名</td><td class=\"right\" colspan=\"2\">{{ print.order.hin_nm }}</td></tr><tr><td class=\"left-bottom text-center\">納品日</td><td class=\"right\"><span ng-if=\"print.sgyt.print_nh_dt_time\">{{ print.sgyt.print_nh_dt_time*1000 | date:\'yyyy年MM月dd日\' }}</span> <span ng-if=\"!print.sgyt.print_nh_dt_time\">&emsp;</span></td><td class=\"text-right\">({{ print.order.ju_no }})</td></tr></table></div></div></div><div class=\"col-xs-2\"><div class=\"yt-tanto-table\"><table><tr><th class=\"text-center\">担当者</th></tr><tr class=\"top-middle\"><td class=\"text-center\">&emsp;</td></tr></table></div></div></div></div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><small>下記の内容で確かに受領しました。</small></div><div class=\"col-xs-12\"><div class=\"yt-dtl-table\"><table><thead><tr><th class=\"text-center\">項目</th><th class=\"text-center\">数量</th><th class=\"text-center\">単位</th></tr></thead><tbody ng-repeat=\"item in sgytDtl\"><tr><td class=\"text-left\"><span ng-if=\"item.kmk_nm && item.sg_bunrui_cd != \'06\'\" \"=\"\">{{ item.kmk_nm }}</span> <span ng-if=\"item.kmk_nm && item.sg_bunrui_cd == \'06\'\">{{ item.db_cd }}&emsp;{{ item.sub_title }}&emsp; <span ng-if=\"item.media_cd_1_nm && !item.media_cd_2_nm\">{{ item.media_cd_1_nm }}&emsp;</span> <span ng-if=\"item.media_cd_1_nm && item.media_cd_2_nm\">{{ item.media_cd_2_nm }}&emsp;</span> {{ item.sec }}&emsp;{{ changeSecKbnName(item.sec_tani_kb) }}</span> <span ng-if=\"!item.kmk_nm && !item.sg_bunrui_cd\">&emsp;</span></td><td class=\"text-right\" style=\"width:80px\"><span ng-if=\"item.suryo_1 && !item.tani_2\">{{ item.suryo_1 }}</span> <span ng-if=\"item.suryo_1 && item.tani_2\">{{ item.suryo_2 }}</span> <span ng-if=\"!item.suryo_1 && !item.suryo_2\">&emsp;</span></td><td class=\"text-left\" style=\"width:80px\"><span ng-if=\"item.tani_1 && !item.tani_2\">{{ item.tani_1 }}</span> <span ng-if=\"item.tani_1 && item.tani_2\">{{ item.tani_2 }}</span> <span ng-if=\"!item.tani_1 && !item.tani_2\">&emsp;</span></td></tr><tbody></tbody></tbody></table></div></div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-12\"><div class=\"yt-title-table\"><table><tr><td class=\"left-bottom text-left\"><div style=\"min-height:100px;\"><p>備考</p>作業伝票No.{{ print.sgyt.sg_no }}<br>原版：{{ changeGenKbnName(print.sgyt.genban_kb) }}</div></td></tr></table></div></div></div>");
$templateCache.put("app/urikake/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"urk.form.fromDate\" data-max-date=\"{{urk.form.untilDate}}\" placeholder=\"From\" data-autoclose=\"true\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"urk.form.untilDate\" data-min-date=\"{{urk.form.fromDate}}\" placeholder=\"To\" data-autoclose=\"true\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"col-xs-6\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"urk.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:80px\">部門選択 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:200px\" ng-model=\"urk.bumon_nm\" disabled=\"\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"urk.tokuisakiSelected\" remote-api-handler=\"urk.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"></div><div class=\"col-xs-5\"><div class=\"pull-right\"><button class=\"btn btn-default btn-sm\" ng-click=\"urk.clear()\">クリア</button> <button class=\"btn btn-success btn-sm pull-right\" ng-click=\"urk.generateAnalysis()\" ng-disabled=\"!urk.form.fromDate\">帳票生成</button></div></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"urk.error\">{{ urk.error }}</div></div></div></div></div>");
$templateCache.put("app/ur-print/print.html","<nav><button ng-if=\"!urprint.printEdit\" ng-print=\"\" print-element-id=\"ur-print-area\"><i class=\"fa fa-print\"></i> 印刷</button> <button ng-if=\"!urprint.printEdit\" ng-click=\"urprint.editUriage()\"><i class=\"fa fa-print\"></i> 見積もりデータ編集</button> <button ng-if=\"!urprint.printEdit\" ng-click=\"urprint.editReset()\"><i class=\"fa fa-print\"></i> リセット</button> <button ng-if=\"urprint.printEdit\" ng-click=\"urprint.execUriage()\"><i class=\"fa fa-print\"></i> 編集を反映して印刷に戻る</button><span ng-if=\"urprint.printEdit\"><br><span style=\"color:red\"><small>※ 小計、消費税、合計等は「単価」などを一度編集すると再計算されます。</small></span><br><span style=\"color:red\"><small>※ ロックアウトは反映されません。数量・単価などで調整してください。</small></span><br><span style=\"color:red\"><small>※ 金額を調整した場合、完全な数値は「編集を反映して印刷に戻る」で反映されます(小計・合計・カテゴリ金額等)。</small></span></span></nav><div class=\"text-center\"><span ng-if=\"!urprint.printEdit\">－&emsp;印刷プレビュー&emsp;－</span><br><span ng-if=\"urprint.printEdit\">－&emsp;編集モード&emsp;－</span><br></div><div class=\"row preview-area\" ng-if=\"!urprint.printEdit\"><article id=\"ur-print-area\"><section class=\"col-xs-12\"><div ng-repeat=\"(prKey, detail) in urprint.urDtl\"><div ng-include=\"\'app/ur-print/sgms.html\'\"></div></div></section></article></div><div class=\"row\" ng-if=\"urprint.printEdit\"><div class=\"col-xs-12\"><div ng-repeat=\"(prKey, detail) in urprint.urDtl\"><div ng-include=\"\'app/ur-print/sgmsEdit.html\'\"></div></div></div></div>");
$templateCache.put("app/ur-print/sgms.html","<div class=\"col-xs-12 ur-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ urprint.title }}</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE {{ $index+1 }}/{{ urprint.urDtl.length }}<br>{{urprint.nowDate*1000|date:\'yyyy年M月dd日\'}}作成</span></div></div><div class=\"col-xs-6\"><div class=\"ur-left-table\"><table><tr><td colspan=\"2\" style=\"width:90%\">{{ urprint.toku_nm }}</td><td style=\"width:10%\">&emsp;</td></tr><tr><td colspan=\"2\" style=\"width:90%\">{{ urprint.toku_bumon_nm }}</td><td style=\"width:10%\">&emsp;</td></tr><tr><td colspan=\"3\" class=\"name text-left\"><span ng-if=\"urprint.toku_tanto_nm\">{{ urprint.toku_tanto_nm }}&emsp;{{ urprint.keisho }}</span> <span ng-if=\"!urprint.toku_tanto_nm\">&emsp;{{ urprint.keisho }}</span></td></tr><tr><td colspan=\"3\"><hr style=\"margin-top:2px;\"></td></tr></table></div><div class=\"ur-left-table\"><table><tr><td colspan=\"3\">{{ urprint.hin_nm }}</td></tr><tr class=\"kai_dtl\"><td colspan=\"3\"></td></tr><tr class=\"kai_dtl\"><td class=\"text-left\"><small>{{ urprint.ju_no }}&emsp;</small></td><td class=\"text-center\"><small>&emsp;{{ urprint.ju_day_time*1000 | date:\'yyyy/MM/dd\' }}</small></td><td class=\"text-right\"><small>&emsp;{{ urprint.gyomu_nm }}&emsp;</small></td></tr></table></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\" style=\"height:25px\">&emsp;</div><div class=\"col-xs-12\">&emsp;<div class=\"ur-right-table\"><table><tr><td colspan=\"2\">{{ urprint.kihon.kaisya_nm }}</td></tr><tr><td colspan=\"2\" ng-if=\"urprint.kaisya_tanto\">{{ urprint.kaisya_tanto }}</td></tr><tr class=\"kai_dtl\"><td colspan=\"2\">{{ urprint.kihon.yubin_no }}</td></tr><tr class=\"kai_dtl\"><td colspan=\"2\">{{ urprint.kihon.adrs }}</td></tr><tr class=\"kai_dtl\"><td class=\"text-left\"><small>{{ urprint.kihon.tel_sgyt1 }}&emsp;</small></td><td class=\"text-right\"><small>&emsp;{{ urprint.kihon.tel_sgyt2 }}</small></td></tr></table></div></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ur-detail-table\"><table><thead><tr><th class=\"text-center\">項目コード</th><th class=\"text-center\">項目名</th><th class=\"text-center\">時間</th><th class=\"text-center\">数量/単位</th><th class=\"text-center\">単価</th><th class=\"text-center\">金額</th></tr></thead><tbody ng-repeat=\"(day, items) in urprint.orderByMin(detail) | groupBy:\'sg_no\' track by $index\"><tr ng-repeat-start=\"(idx, item) in items track by $index\" ng-if=\"$first\"><td class=\"left\" colspan=\"6\" ng-if=\"item.sg_no && day >0\"><small>■ 伝票No.:{{ item.sg_no }}&emsp;&emsp;作業日:{{ item.sg_day_time*1000 | date }}&emsp;&emsp;&emsp;{{ item.sg_bmn_cd }}&emsp;{{ item.sg_bmn_nm }}</small></td></tr><tr ng-repeat-end=\"\"><td>&emsp;{{ item.sg_item_cd }}:{{day}}</td><td class=\"text-left\">{{ item.sg_item_nms }}</td><td class=\"text-center\"><span ng-if=\"item.stt_tm\">{{ item.stt_tm_str }} ～ {{ item.end_tm_str }}</span></td><td class=\"text-center\" style=\"width:80px\"><span ng-if=\"item.suryo_1 && !item.tani_2\">{{ item.suryo_1 | number:1 }}</span> <span ng-if=\"item.suryo_1 && item.tani_2\">{{ item.suryo_2 | number:1 }}</span> <span ng-if=\"!item.suryo_1 && !item.suryo_2\">&emsp;</span> <span ng-if=\"(item.suryo_1 || item.tani_2) || (item.tani_1 && item.tani_2)\">/</span> <span ng-if=\"item.tani_1 && !item.tani_2\">{{ item.tani_1 }}</span> <span ng-if=\"item.tani_1 && item.tani_2\">{{ item.tani_2 }}</span> <span ng-if=\"!item.tani_1 && !item.tani_2\">&emsp;</span></td><td class=\"text-right\"><span ng-if=\"item.tanka\">{{ item.tanka | number }}</span></td><td class=\"text-right\"><span ng-if=\"item.kin\">{{ item.kin | number }}</span></td></tr><tr ng-repeat-start=\"(idx, item) in items\" ng-if=\"$first && ( items.length < 10 || urprint.uriageDtlCount[sgNo].length%urprint.chunk_size == 0 )\"><td class=\"text-right\" colspan=\"5\" ng-if=\"item.sg_no && day >0\">伝票計</td><td class=\"text-right\" ng-if=\"item.sg_no && day >0\">{{ item.den_kei | number }}</td></tr><tr ng-repeat-end=\"\"></tr><tbody></tbody></tbody></table></div><div class=\"ur-footer-table\" ng-if=\"prKey+1 === urprint.urDtl.length\"><table><tr><td class=\"text-right top\" colspan=\"5\">小計</td><td class=\"text-right top\" style=\"width:150px\">{{ detail[0].form_editForm.kj_ur_kin | number }}</td></tr><tr ng-if=\"detail[0].form_editForm.nebiki_kin != 0\"><td class=\"text-right\" colspan=\"5\">値引き</td><td class=\"text-right\" style=\"width:150px\">{{ detail[0].form_editForm.nebiki_kin*-1 | number }}</td></tr><tr><td class=\"text-right\" colspan=\"5\">消費税</td><td class=\"text-right\" style=\"width:150px\">{{ detail[0].form_editForm.zei_kin | number }}</td></tr><tr><td class=\"text-right\" colspan=\"5\">合計</td><td class=\"text-right\" style=\"width:150px\">{{ detail[0].form_editForm.jt_ur_kin + detail[0].form_editForm.zei_kin | number }}</td></tr></table></div><div class=\"ur-footer-table2\" ng-if=\"prKey+1 === urprint.urDtl.length\"><table><tr ng-repeat=\"item in urprint.sg_bunrui_type | orderBy:\'sum_cd\'\" style=\"width:100%\"><td>{{ item.name }}</td><td class=\"number\">{{ item.total | number }}</td><td colspan=\"2\"></td><td></td><td></td></tr><tr ng-if=\"$last\"><td>①＋②＋③</td><td class=\"number\">{{ urprint.sg_bunrui_type[0].allTotal | number}}</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/ur-print/sgmsEdit.html","<div class=\"col-xs-12 ur-print-page-dummy\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><input type=\"text\" class=\"form-control input-sm\" name=\"title\" placeholder=\"タイトル\" style=\"width:300px\" ng-model=\"urprint.title\"></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE {{ $index+1 }}/{{ urprint.urDtl.length }}<br>{{urprint.nowDate*1000|date:\'yyyy年M月dd日\'}}作成</span></div></div><div class=\"col-xs-6\"><div class=\"ur-left-table\"><table><tr><td colspan=\"2\" style=\"width:90%\"><input type=\"text\" class=\"form-control input-sm\" name=\"toku_nm\" ng-model=\"urprint.toku_nm\" placeholder=\"得意先名称\"></td><td style=\"width:10%\">&emsp;</td></tr><tr><td colspan=\"2\" style=\"width:90%\"><input type=\"text\" class=\"form-control input-sm\" name=\"toku_nm\" ng-model=\"urprint.toku_bumon_nm\" placeholder=\"部署\"></td><td style=\"width:10%\">&emsp;</td></tr><tr><td colspan=\"3\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" name=\"toku_nm\" ng-model=\"urprint.toku_tanto_nm\" placeholder=\"担当：\"> <span class=\"input-group-glue\"></span> <input type=\"text\" class=\"form-control input-sm\" name=\"keisho\" ng-model=\"urprint.keisho\" style=\"max-width:55px;\" placeholder=\"敬称\"></div></td></tr><tr><td colspan=\"3\"><hr style=\"margin-top:2px;\"></td></tr></table></div><div class=\"ur-left-table\"><table><tr><td colspan=\"3\"><input type=\"text\" class=\"form-control input-sm\" name=\"hin_nm\" ng-model=\"urprint.hin_nm\" placeholder=\"作品名\"></td></tr><tr class=\"kai_dtl\"><td colspan=\"3\"></td></tr><tr class=\"kai_dtl\"><td class=\"text-left\"><input type=\"text\" class=\"form-control input-sm\" name=\"ju_no\" ng-model=\"urprint.ju_no\"></td><td class=\"text-center\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"urprint.ju_day\" name=\"ju_day\" bs-datepicker=\"\" placeholder=\"yyyy/mm/dd\"></td><td class=\"text-right\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"urprint.gyomuDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{urprint.gyomu_nm}} <span class=\"caret\"></span></button></td></tr></table></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\" style=\"height:25px\">&emsp;</div><div class=\"col-xs-12\">&emsp;<div class=\"ur-right-table\"><table><tr><td colspan=\"2\">{{ urprint.kihon.kaisya_nm }}</td></tr><tr><td colspan=\"2\"><input type=\"text\" class=\"form-control input-sm\" name=\"kaisya_tanto\" placeholder=\"担当:\" ng-model=\"urprint.kaisya_tanto\"></td></tr><tr class=\"kai_dtl\"><td colspan=\"2\">{{ urprint.kihon.yubin_no }}</td></tr><tr class=\"kai_dtl\"><td colspan=\"2\">{{ urprint.kihon.adrs }}</td></tr><tr class=\"kai_dtl\"><td class=\"text-left\"><small>{{ urprint.kihon.tel_sgyt1 }}&emsp;</small></td><td class=\"text-right\"><small>&emsp;{{ urprint.kihon.tel_sgyt2 }}</small></td></tr></table></div></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ur-detail-table\"><table><thead><tr><th class=\"text-center\">項目コード</th><th class=\"text-center\">項目名</th><th class=\"text-center\">時間</th><th class=\"text-center\">数量/単位</th><th class=\"text-center\">単価</th><th class=\"text-center\">金額</th><th class=\"text-center\">操作</th></tr></thead><tbody ng-repeat=\"(sgNo, items) in detail | groupBy:\'sg_no\' track by $index\"><tr ng-repeat-start=\"(idx, item) in items track by $index\" ng-if=\"$first\"><td class=\"left\" colspan=\"2\" ng-if=\"item.sg_no && sgNo\"><div class=\"input-group\"><span class=\"input-group-addon\"><small>■ 伝票No.:</small></span> <input type=\"text\" class=\"form-control input-sm\" name=\"sg_no\" ng-model=\"item.sg_no\" disabled=\"\"></div></td><td class=\"left\" colspan=\"2\" ng-if=\"item.sg_no && sgNo\"><div class=\"input-group\"><span class=\"input-group-addon\"><small>作業日:</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.sg_day\" name=\"sg_day\" bs-datepicker=\"\" placeholder=\"yyyy/mm/dd\"></div></td><td class=\"left\" colspan=\"2\" ng-if=\"item.sg_no && sgNo\"><div class=\"input-group\"><span class=\"input-group-addon\"><small>部門名:{{item.sg_bmn_cd}}</small></span> <button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"urprint.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{item.sg_bmn_nm}} <span class=\"caret\"></span></button></div></td><td class=\"text-right\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"urprint.addRow(prKey, sgNo)\">追加</button> <button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"urprint.parentRowDelete(prKey, sgNo)\">削除</button></div></div></td></tr><tr ng-repeat-end=\"\"><td><ur-sg-item></ur-sg-item></td><td><input type=\"text\" style=\"width:200px;\" class=\"form-control input-sm\" name=\"sg_item_nms\" ng-model=\"item.sg_item_nms\"></td><td class=\"row\"><span ng-if=\"item.time_fl == \'1\'\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" name=\"stt_tm\" ng-model=\"item.stt_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:55px;ime-mode:disabled\" ng-blur=\"urprint.sttTmChange(prKey,sgNo,idx)\"> <span class=\"input-group-glue1\"></span> <input type=\"text\" class=\"form-control input-sm\" name=\"end_tm\" ng-model=\"item.end_tm\" model-view-value=\"true\" ui-mask=\"99:99\" style=\"max-width:55px;ime-mode:disabled\" ng-blur=\"urprint.endTmChange(prKey,sgNo,idx)\"></div></span> <span ng-if=\"item.time_fl != \'1\' && item.suryo_kbn_2 == \'1\'\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" name=\"suryo_1\" ng-model=\"item.suryo_1\" model-format=\"float\" style=\"max-width:55px;\" formatter=\"formatitem($modelValue,$filter, \'0.0\' );\" ng-blur=\"urprint.suryo1Change(prKey,sgNo,idx)\"> <span class=\"input-group-glue2\"></span> <input type=\"text\" class=\"form-control input-sm\" name=\"tani_1\" ng-model=\"item.tani_1\" style=\"max-width:55px;\"></div></span></td><td class=\"text-center\"><div class=\"input-group\" ng-if=\"item.suryo_kbn_2 != \'1\'\"><input type=\"text\" class=\"form-control input-sm\" name=\"suryo_1\" ng-model=\"item.suryo_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\' );\" style=\"max-width:55px;\" ng-blur=\"urprint.suryo1Change(prKey,sgNo,idx)\"> <span class=\"input-group-glue2\"></span> <input type=\"text\" class=\"form-control input-sm\" name=\"tani_1\" ng-model=\"item.tani_1\" style=\"max-width:55px;\"></div><div class=\"input-group\" ng-if=\"item.suryo_kbn_2 == \'1\'\"><input type=\"text\" class=\"form-control input-sm\" name=\"suryo_2\" ng-model=\"item.suryo_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\' );\" style=\"max-width:55px;\" ng-blur=\"urprint.suryo2Change(prKey,sgNo,idx)\"> <span class=\"input-group-glue2\"></span> <input type=\"text\" class=\"form-control input-sm\" name=\"tani_2\" ng-model=\"item.tani_2\" style=\"max-width:55px;\"></div></td><td class=\"text-right\"><span><input type=\"text\" style=\"width:100px\" class=\"form-control input-sm\" name=\"tanka\" ng-model=\"item.tanka\" ng-change=\"urprint.tankaChange(prKey,sgNo,idx)\" numeric-only=\"\"></span></td><td class=\"text-right\"><span ng-if=\"item.kin\"><input type=\"text\" style=\"width:100px\" class=\"form-control input-sm\" name=\"kin\" ng-model=\"item.kin\" numeric-only=\"\"></span></td><td class=\"text-right\"><div class=\"input-group\"><div class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"urprint.rowCopy(prKey, sgNo, item.gyo_no)\">複写</button> <button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"urprint.rowDelete(prKey, sgNo, item.gyo_no)\">削除</button></div></div></td></tr><tr ng-repeat-start=\"(idx, item) in items\" ng-if=\"$first && ( items.length < 10 || urprint.uriageDtlCount[sgNo].length%urprint.chunk_size == 0 )\"><td class=\"text-right\" colspan=\"5\" ng-if=\"item.sg_no && sgNo\"><span>伝票計</span></td><td class=\"text-right\" ng-if=\"item.sg_no && sgNo\"><span ng-if=\"!items.den_kei\">{{ item.den_kei | number }}</span> <span ng-if=\"items.den_kei\">{{ items.den_kei | number }}</span></td></tr><tr ng-repeat-end=\"\"></tr><tbody></tbody></tbody></table></div><div class=\"ur-footer-table\" ng-if=\"prKey+1 === urprint.urDtl.length\"><table><tr><td class=\"text-right top\" colspan=\"5\">小計</td><td class=\"text-right top\" style=\"width:150px\">{{ detail[0].form_editForm.kj_ur_kin | number }}</td></tr><tr><td class=\"text-right\" colspan=\"5\">値引き</td><td class=\"text-right\" style=\"width:150px\"><div class=\"input-group\"><span class=\"input-group-addon\">-</span> <input type=\"text\" class=\"form-control input-sm\" name=\"tanka\" ng-model=\"detail[0].form_editForm.nebiki_kin\" ng-change=\"urprint.nebikiChange(prKey,sgNo,idx)\" numeric-only=\"\"></div></td></tr><tr><td class=\"text-right\" colspan=\"5\">消費税</td><td class=\"text-right\" style=\"width:150px\">{{ detail[0].form_editForm.zei_kin | number }}</td></tr><tr><td class=\"text-right\" colspan=\"5\">合計</td><td class=\"text-right\" style=\"width:150px\">{{ detail[0].form_editForm.jt_ur_kin + detail[0].form_editForm.zei_kin | number }}</td></tr></table></div><div class=\"ur-footer-table2\" ng-if=\"prKey+1 === urprint.urDtl.length\"><table><tr ng-repeat=\"item in urprint.sg_bunrui_type | orderBy:\'sum_cd\'\" style=\"width:100%\"><td>{{ item.name }}</td><td>{{ item.total | number }}</td><td colspan=\"2\"></td><td></td><td></td></tr><tr ng-if=\"$last\"><td>①＋②＋③</td><td colspan=\"5\">{{ urprint.sg_bunrui_type[0].allTotal }}</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/user/modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">パスワード更新の確認</h4></div><div class=\"modal-body\"><p class=\"text-danger\">登録したパスワードは、セキュリティー上確認することが出来ません。<br>お忘れにならないようご自身で大切に管理するようお願い致します。<br><small>※ 万一忘れてしまった、ログイン出来ないなどお困りの場合は管理者にお問い合わせください。</small></p><p>入力PW確認：<input type=\"text\" value=\"{{user.pwForm.newPasswordConform}}\" readonly=\"readonly\"></p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$hide()\">キャンセル</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"user.updatePwSubmit()\">更新</button></p></div></div></div></div>");
$templateCache.put("app/user/user.html","<div ncy-breadcrumb=\"\"></div><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"basicForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">個人設定<br><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">名前カナ</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"user.form.syain_km\" ng-blur=\"user.changeZen2Cana(\'form\')\" placeholder=\"名前カナ\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">名前</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"〒\" ng-model=\"user.form.syain_nm\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">部門</span> <input type=\"text\" class=\"form-control input-sm\" value=\"{{ user.bumon_nm }}\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">役職</span> <input type=\"text\" class=\"form-control input-sm\" value=\"{{ user.yakusyoku_nm }}\" disabled=\"\"></div></div><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px;border-right:1px solid #ccc\">性別</span> &nbsp;<div class=\"radio-inline\"><label for=\"man\"><input type=\"radio\" value=\"0\" ng-model=\"user.form.sex_cd\" name=\"sex_cd\" id=\"man\"> &nbsp;男性</label></div><div class=\"radio-inline\"><label for=\"woman\"><input type=\"radio\" value=\"1\" ng-model=\"user.form.sex_cd\" name=\"sex_cd\" id=\"woman\"> &nbsp;女性</label></div></div></div><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">生年月日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"user.form.born_day\" placeholder=\"yyyy/mm/dd\" autoclose=\"true\" name=\"born_day\" bs-datepicker=\"\"></div></div></div><div class=\"col-md-7\"></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"user.updateSubmit()\" style=\"width:150px\">更新</button></div></div></div></form></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"passwdForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\">パスワード変更<br><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">新パスワード</span> <input type=\"text\" class=\"form-control input-sm\" 　name=\"newPassword\" maxlength=\"12\" ng-model=\"user.pwForm.newPassword\" str-matching=\"user.pwForm.newPasswordConform\"></div></div><div class=\"form-group col-md-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:150px\">新パスワード確認</span> <input type=\"text\" class=\"form-control input-sm\" name=\"newPasswordConform\" maxlength=\"12\" ng-model=\"user.pwForm.newPasswordConform\" str-matching=\"user.pwForm.newPassword\"></div></div></div><div class=\"col-md-7\"><div class=\"text-danger\" ng-if=\"passwdForm.newPassword.$error.strMatching || passwdForm.newPasswordConform.$error.strMatching\">新パスワードと新パスワード確認が違います</div><div class=\"text-danger\" ng-if=\"user.pwError\">パスワードに利用出来るのは半角英数記号です</div><div class=\"text-danger\" ng-if=\"user.pwLenError\">パスワードは5文字以上で設定してください</div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"user.openUserModal()\" style=\"width:150px\" ng-disabled=\"passwdForm.$invalid || !passwdForm.$dirty || user.pwLenError || user.pwError\">更新</button></div></div></div></form></div></div>");
$templateCache.put("app/zanzaiko-action/main.html","<div ncy-breadcrumb=\"\"></div><div class=\"panel panel-default\"><div class=\"panel-body\"><form role=\"form\" name=\"basicForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><p><span>調整したい年月を入力してください</span><br><span>調整できるのは月次処理を行った年月までです</span><br></p></div><div class=\"col-md-4\">年月入力</div><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"zz.zz_date\" data-date-format=\"yyyy/MM\" data-start-view=\"1\" data-min-view=\"1\" data-date-type=\"string\" placeholder=\"yyyy/mm\" name=\"zz_date\" bs-datepicker=\"\"><p ng-if=\"vm.errorMassage\" class=\"text-danger\">{{ vm.errorMassage }}</p></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-info btn-block\" ng-click=\"zz.mainActionModal()\" ng-disabled=\"!zz.zz_date\">残在庫調整実行</button></div></div></form></div><div class=\"col-md-12\"><p style=\"font-size:80%\" class=\"text-danger\"><span>※バックグランド処理は仕組み上プログラム実行後の終了通知がありません。</span><br><span>お急ぎで無い場合は通常実行してください。</span><br><span>また、複数実施を連続で行うとサーバがメモリ不足になる可能性があります。実行後は次の処理まで30分程度時間を空けてください</span><br></p></div></div>");
$templateCache.put("app/zanzaiko-action/modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">残在庫調整実行確認</h4></div><div class=\"modal-body\"><p class=\"text-danger\"><span>{{ zz.zz_date }}の残在庫調整実行を行います</span><br><span>残在庫調整処理は15分~20分程度かかります。</span><br><span>１．バックグラウンド実行は画面を閉じたり、別の画面へ移動して業務を続行できますが、終了の合図がありません</span><br><span>２．通常実行は終了まで画面を閉じたり、別の画面へ移動したりは出来ませんが終了をご確認いただけます。</span><br></p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$hide()\">キャンセル</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"zz.zanzaikoAction(1)\">バックグラウンド実行</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"zz.zanzaikoAction(2)\">通常実行</button></p></div></div></div></div>");
$templateCache.put("app/analysis/engineers-specify/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-if=\"egs.items.length > 0\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><dualmultiselect options=\"egs.options\" input-model=\"egs.items\" recursion-check=\"true\" output-all-info=\"false\" output-duplicate=\"true\" ng-model=\"egs.form.value\"></dualmultiselect><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"egs.from_date\" disabled=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-clear btn-sm\" type=\"button\" disabled=\"\">～</button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"egs.end_date\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"></div><div class=\"nyoro\">～</div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"egs.generateAnalysis()\">帳票生成</button></div></div></div></div></div></div>");
$templateCache.put("app/analysis/es-print/analysis.html","<div class=\"engineer-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ esprint.title }}</p><p class=\"text-center title-kikan\">({{esprint.y+\'/04\'}}～{{esprint.y+\'/\'+esprint.m}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(esprint.pagination.current * esprint.datasPerPage - (esprint.datasPerPage -1))+$index +\'/\'+ esprint.totalCount\"></span><br>{{ esprint.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-engineer-one\"><caption ng-if=\"detail.bumon_cd\">{{ detail.parent_bumon_cd }}&nbsp;{{ detail.parent_bumon_nm }}&nbsp;&nbsp;&nbsp;{{ detail.bumon_cd }}&nbsp;{{ detail.bumon_nm }}</caption><thead><tr><th class=\"title-tan\">担当者名</th><th class=\"title-clear\">&nbsp;</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:\'syain_km\' track by $index\"><tr><td class=\"name-left\"><span ng-if=\"dtl.tanto_cd != \'00000000\' && dtl.tanto_cd != \'99999999\' && dtl.tanto_cd != \'88888888\'\"><span ng-if=\"key==0\" ng-init=\"detail.parent_bumon_cd = dtl.parent_bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.parent_bumon_nm = dtl.parent_bumon_nm\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_cd = dtl.bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_nm = dtl.bumon_nm\"></span> <span ng-if=\"key==0\" ng-init=\"detail.tanto_cd = dtl.tanto_cd\"></span> &nbsp;{{ dtl.tanto_cd }}<br>{{ dtl.syain_nm }}</span> <span ng-if=\"dtl.tanto_cd == \'00000000\'\"><span ng-if=\"key==0\" ng-init=\"detail.parent_bumon_cd = dtl.parent_bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.parent_bumon_nm = dtl.parent_bumon_nm\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_cd = dtl.bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_nm = dtl.bumon_nm\"></span> <span>&nbsp;{{ dtl.bumon_rm }}合計</span></span> <span ng-if=\"dtl.tanto_cd == \'99999999\'\">&nbsp;合計 <span ng-if=\"key==0\" ng-init=\"detail.tanto_cd = dtl.tanto_cd\"></span></span> <span ng-if=\"dtl.tanto_cd == \'88888888\'\">&nbsp;{{detail.parent_bumon_nm}}合計 <span ng-if=\"key==0\" ng-init=\"detail.tanto_cd = dtl.tanto_cd\"></span></span></td><td class=\"center inner-title\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">4月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin04 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin04, dtl.preData.kj_ur_kin04) }}</td></tr><tr><td>{{ dtl.jt_ur_kin04 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin04, dtl.preData.jt_ur_kin04) }}</td></tr><tr><td>{{ dtl.jitu_genka04 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka04, dtl.preData.jitu_genka04) }}</td></tr></table></td><td class=\"center inner-title\">5月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin05 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin05, dtl.preData.kj_ur_kin05) }}</td></tr><tr><td>{{ dtl.jt_ur_kin05 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin05, dtl.preData.jt_ur_kin05) }}</td></tr><tr><td>{{ dtl.jitu_genka05 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka05, dtl.preData.jitu_genka05) }}</td></tr></table></td><td class=\"center inner-title\">6月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin06 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin06, dtl.preData.kj_ur_kin06) }}</td></tr><tr><td>{{ dtl.jt_ur_kin06 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin06, dtl.preData.jt_ur_kin06) }}</td></tr><tr><td>{{ dtl.jitu_genka06 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka06, dtl.preData.jitu_genka06) }}</td></tr></table></td><td class=\"center inner-title\">第1四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_1_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_1_kj_ur_kin, dtl.preData.hanki_1_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_1_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_1_jt_ur_kin, dtl.preData.hanki_1_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_1_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_1_jitu_genka, dtl.preData.hanki_1_jitu_genka) }}</td></tr></table></td><td class=\"center inner-title\">7月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin07 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin07, dtl.preData.kj_ur_kin07) }}</td></tr><tr><td>{{ dtl.jt_ur_kin07 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin07, dtl.preData.jt_ur_kin07) }}</td></tr><tr><td>{{ dtl.jitu_genka07 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka07, dtl.preData.jitu_genka07) }}</td></tr></table></td><td class=\"center inner-title\">8月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin08 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin08, dtl.preData.kj_ur_kin08) }}</td></tr><tr><td>{{ dtl.jt_ur_kin08 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin08, dtl.preData.jt_ur_kin08) }}</td></tr><tr><td>{{ dtl.jitu_genka08 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka08, dtl.preData.jitu_genka08) }}</td></tr></table></td><td class=\"center inner-title\">9月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin09 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin09, dtl.preData.kj_ur_kin09) }}</td></tr><tr><td>{{ dtl.jt_ur_kin09 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin09, dtl.preData.jt_ur_kin09) }}</td></tr><tr><td>{{ dtl.jitu_genka09 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka09, dtl.preData.jitu_genka09) }}</td></tr></table></td><td class=\"center inner-title\">第2四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_2_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_2_kj_ur_kin, dtl.preData.hanki_2_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_2_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_2_jt_ur_kin, dtl.preData.hanki_2_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_2_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_2_jitu_genka, dtl.preData.hanki_2_jitu_genka) }}</td></tr></table></td><td class=\"center inner-title\">上半期<table class=\"inner-middle\"><tr><td>{{ dtl.kami_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kami_hanki_kj_ur_kin, dtl.preData.kami_hanki_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.kami_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kami_hanki_jt_ur_kin, dtl.preData.kami_hanki_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.kami_hanki_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kami_hanki_jitu_genka, dtl.preData.kami_hanki_jitu_genka) }}</td></tr></table></td><td class=\"center inner-title\">累計<table class=\"inner-middle\"><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePerKjYear(dtl.rui_kj_ur_kin, dtl.preData) }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePerJtYear(dtl.rui_jt_ur_kin, dtl.preData) }}</td></tr><tr><td>{{ dtl.rui_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePerGnYear(dtl.rui_jitu_genka, dtl.preData) }}</td></tr></table></td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">10月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin10 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin10, dtl.preData.kj_ur_kin10) }}</td></tr><tr><td>{{ dtl.jt_ur_kin10 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin10, dtl.preData.jt_ur_kin10) }}</td></tr><tr><td>{{ dtl.jitu_genka10 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka10, dtl.preData.jitu_genka10) }}</td></tr></table></td><td class=\"center inner-title\">11月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin11 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin11, dtl.preData.kj_ur_kin11) }}</td></tr><tr><td>{{ dtl.jt_ur_kin11 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin11, dtl.preData.jt_ur_kin11) }}</td></tr><tr><td>{{ dtl.jitu_genka11 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka11, dtl.preData.jitu_genka11) }}</td></tr></table></td><td class=\"center inner-title\">12月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin12 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin12, dtl.preData.kj_ur_kin12) }}</td></tr><tr><td>{{ dtl.jt_ur_kin12 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin12, dtl.preData.jt_ur_kin12) }}</td></tr><tr><td>{{ dtl.jitu_genka12 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka12, dtl.preData.jitu_genka12) }}</td></tr></table></td><td class=\"center inner-title\">第3四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_3_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_3_kj_ur_kin, dtl.preData.hanki_3_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_3_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_3_jt_ur_kin, dtl.preData.hanki_3_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_3_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_3_jitu_genka, dtl.preData.hanki_3_jitu_genka) }}</td></tr></table></td><td class=\"center inner-title\">1月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin01 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin01, dtl.preData.kj_ur_kin01) }}</td></tr><tr><td>{{ dtl.jt_ur_kin01 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin01, dtl.preData.jt_ur_kin01) }}</td></tr><tr><td>{{ dtl.jitu_genka01 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka01, dtl.preData.jitu_genka01) }}</td></tr></table></td><td class=\"center inner-title\">2月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin02 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin02, dtl.preData.kj_ur_kin02) }}</td></tr><tr><td>{{ dtl.jt_ur_kin02 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin02, dtl.preData.jt_ur_kin02) }}</td></tr><tr><td>{{ dtl.jitu_genka02 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka02, dtl.preData.jitu_genka02) }}</td></tr></table></td><td class=\"center inner-title\">3月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin03 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.kj_ur_kin03, dtl.preData.kj_ur_kin03) }}</td></tr><tr><td>{{ dtl.jt_ur_kin03 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jt_ur_kin03, dtl.preData.jt_ur_kin03) }}</td></tr><tr><td>{{ dtl.jitu_genka03 | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.jitu_genka03, dtl.preData.jitu_genka03) }}</td></tr></table></td><td class=\"center inner-title\">第4四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_4_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_4_kj_ur_kin, dtl.preData.hanki_4_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_4_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_4_jt_ur_kin, dtl.preData.hanki_4_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_4_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.hanki_4_jitu_genka, dtl.preData.hanki_4_jitu_genka) }}</td></tr></table></td><td class=\"center inner-title\">下半期<table class=\"inner-middle\"><tr><td>{{ dtl.shimo_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.shimo_hanki_kj_ur_kin, dtl.preData.shimo_hanki_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.shimo_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.shimo_hanki_jt_ur_kin, dtl.preData.shimo_hanki_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.shimo_hanki_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.shimo_hanki_jitu_genka, dtl.preData.shimo_hanki_jitu_genka) }}</td></tr></table></td><td class=\"center inner-title\">年間<table class=\"inner-middle\"><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.rui_kj_ur_kin, dtl.preData.rui_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.rui_jt_ur_kin, dtl.preData.rui_jt_ur_kin) }}</td></tr><tr><td>{{ dtl.rui_jitu_genka | number}}</td><td class=\"td-middle\">{{ esprint.prePer(dtl.rui_jitu_genka, dtl.preData.rui_jitu_genka) }}</td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/analysis/es-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"esprint.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"esprint.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ esprint.pagination.current }})&emsp;－</span><br><span>部門：{{ esprint.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"esprint.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in esprint.datas | itemsPerPage: esprint.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"esprint.totalCount\" current-page=\"esprint.pagination.current\"><div ng-include=\"\'app/analysis/es-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/analysis/monthly-report-tan/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-if=\"mrt.items.length > 0\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><dualmultiselect options=\"mrt.options\" input-model=\"mrt.items\" recursion-check=\"true\" output-all-info=\"false\" output-duplicate=\"true\" ng-model=\"mrt.form.value\"></dualmultiselect><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"mrt.from_date\" disabled=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-clear btn-sm\" type=\"button\" disabled=\"\">～</button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"mrt.end_date\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"></div><div class=\"nyoro\">～</div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"mrt.generateAnalysis()\">帳票生成</button></div></div></div></div></div></div>");
$templateCache.put("app/analysis/jt-print/analysis-toku.html","<div class=\"mojt-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ jtprint.title }}</p><p class=\"text-center title-kikan\">({{jtprint.y+\'/04\'}}～{{jtprint.y+\'/\'+jtprint.m}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(jtprint.pagination.current * jtprint.datasPerPage - (jtprint.datasPerPage -1))+$index +\'/\'+ jtprint.totalCount\"></span><br>{{ jtprint.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"mojt-table-monthly-one\"><caption ng-if=\"detail.bumon_cd\">{{ detail.bumon_cd }}&nbsp;{{ detail.bumon_nm }}</caption><thead><tr><th class=\"title-tan\">担当者名</th><th class=\"title-clear\">&nbsp;</th><th class=\"title-body\">実績(前年比) 予算</th><th class=\"title-body\">実績(前年比) 予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:\'syain_km\'\"><tr><td class=\"name-left\"><span ng-if=\"dtl.toku_cd != \'00000000\' && dtl.toku_cd != \'99999999\'\"><span ng-if=\"key==0\" ng-init=\"detail.bumon_cd = dtl.bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_nm = dtl.bumon_nm\"></span> &nbsp;{{ dtl.toku_cd }}<br>{{ dtl.toku_nm }}</span> <span ng-if=\"dtl.toku_cd == \'00000000\'\"><span ng-if=\"key==0\" ng-init=\"detail.bumon_cd = dtl.bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_nm = dtl.bumon_nm\"></span> &nbsp;{{ dtl.bumon_nm}} 合計</span> <span ng-if=\"dtl.toku_cd == \'99999999\'\">&nbsp;合計</span></td><td class=\"center inner-title\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">4月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin04 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin04, dtl.preData.kj_ur_kin04) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin04 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin04, dtl.preData.jt_ur_kin04) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin04, dtl.jt_ur_kin04) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin04, dtl.jt_ur_kin04), jtprint.nebiki(dtl.preData.kj_ur_kin04, dtl.preData.jt_ur_kin04)) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.jitu_genka04 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka04, dtl.preData.jitu_genka04) }}</td><td>{{ dtl.yosan04 | number }}</td></tr></table></td><td class=\"center inner-title\">5月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin05 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin05, dtl.preData.kj_ur_kin05) }}</td><td>{{ dtl.yosan05 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin05 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin05, dtl.preData.jt_ur_kin05) }}</td><td>{{ dtl.yosan05 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin05, dtl.jt_ur_kin05) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin05, dtl.jt_ur_kin05), jtprint.nebiki(dtl.preData.kj_ur_kin05, dtl.preData.jt_ur_kin05)) }}</td><td>{{ dtl.yosan05 | number }}</td></tr><tr><td>{{ dtl.jitu_genka05 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka05, dtl.preData.jitu_genka05) }}</td><td>{{ dtl.yosan05 | number }}</td></tr></table></td><td class=\"center inner-title\">6月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin06 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin06, dtl.preData.kj_ur_kin06) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin06 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin06, dtl.preData.jt_ur_kin06) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin06, dtl.jt_ur_kin06) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin06, dtl.jt_ur_kin06), jtprint.nebiki(dtl.preData.kj_ur_kin06, dtl.preData.jt_ur_kin06)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.jitu_genka06 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka06, dtl.preData.jitu_genka06) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">第1四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_1_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_1_kj_ur_kin, dtl.preData.hanki_1_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_1_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_1_jt_ur_kin, dtl.preData.hanki_1_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_1_kj_ur_kin, dtl.hanki_1_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_1_kj_ur_kin, dtl.hanki_1_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_1_kj_ur_kin, dtl.preData.hanki_1_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_1_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_1_jitu_genka, dtl.preData.hanki_1_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center\">&nbsp;</td><td class=\"center\">&nbsp;</td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">7月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin07 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin07, dtl.preData.kj_ur_kin07) }}</td><td>{{ dtl.yosan07 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin07 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin07, dtl.preData.jt_ur_kin07) }}</td><td>{{ dtl.yosan07 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin07, dtl.jt_ur_kin07) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin07, dtl.jt_ur_kin07), jtprint.nebiki(dtl.preData.kj_ur_kin07, dtl.preData.jt_ur_kin07)) }}</td><td>{{ dtl.yosan07 | number }}</td></tr><tr><td>{{ dtl.jitu_genka07 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka07, dtl.preData.jitu_genka07) }}</td><td>{{ dtl.yosan07 | number }}</td></tr></table></td><td class=\"center inner-title\">8月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin08 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin08, dtl.preData.kj_ur_kin08) }}</td><td>{{ dtl.yosan08 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin08 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin08, dtl.preData.jt_ur_kin08) }}</td><td>{{ dtl.yosan08 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin08, dtl.jt_ur_kin08) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin08, dtl.jt_ur_kin08), jtprint.nebiki(dtl.preData.kj_ur_kin08, dtl.preData.jt_ur_kin08)) }}</td><td>{{ dtl.yosan08 | number }}</td></tr><tr><td>{{ dtl.jitu_genka08 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka08, dtl.preData.jitu_genka08) }}</td><td>{{ dtl.yosan08 | number }}</td></tr></table></td><td class=\"center inner-title\">9月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin09 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin09, dtl.preData.kj_ur_kin09) }}</td><td>{{ dtl.yosan09 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin09 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin09, dtl.preData.jt_ur_kin09) }}</td><td>{{ dtl.yosan09 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin09, dtl.jt_ur_kin09) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin09, dtl.jt_ur_kin09), jtprint.nebiki(dtl.preData.kj_ur_kin09, dtl.preData.jt_ur_kin09)) }}</td><td>{{ dtl.yosan09 | number }}</td></tr><tr><td>{{ dtl.jitu_genka09 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka09, dtl.preData.jitu_genka09) }}</td><td>{{ dtl.yosan09 | number }}</td></tr></table></td><td class=\"center inner-title\">第2四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_2_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_2_kj_ur_kin, dtl.preData.hanki_2_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_2_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_2_jt_ur_kin, dtl.preData.hanki_2_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_2_kj_ur_kin, dtl.hanki_2_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_2_kj_ur_kin, dtl.hanki_2_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_2_kj_ur_kin, dtl.preData.hanki_2_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_2_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_2_jitu_genka, dtl.preData.hanki_2_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">上半期<table class=\"inner-middle\"><tr><td>{{ dtl.kami_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kami_hanki_kj_ur_kin, dtl.preData.kami_hanki_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.kami_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kami_hanki_jt_ur_kin, dtl.preData.kami_hanki_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kami_hanki_kj_ur_kin, dtl.kami_hanki_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kami_hanki_kj_ur_kin, dtl.kami_hanki_jt_ur_kin), jtprint.nebiki(dtl.preData.kami_hanki_kj_ur_kin, dtl.preData.kami_hanki_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.kami_hanki_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kami_hanki_jitu_genka, dtl.preData.kami_hanki_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center\">&nbsp;</td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">10月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin10 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin10, dtl.preData.kj_ur_kin10) }}</td><td>{{ dtl.yosan10 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin10 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin10, dtl.preData.jt_ur_kin10) }}</td><td>{{ dtl.yosan10 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin10, dtl.jt_ur_kin10) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin10, dtl.jt_ur_kin10), jtprint.nebiki(dtl.preData.kj_ur_kin10, dtl.preData.jt_ur_kin10)) }}</td><td>{{ dtl.yosan10 | number }}</td></tr><tr><td>{{ dtl.jitu_genka10 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka10, dtl.preData.jitu_genka10) }}</td><td>{{ dtl.yosan10 | number }}</td></tr></table></td><td class=\"center inner-title\">11月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin11 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin11, dtl.preData.kj_ur_kin11) }}</td><td>{{ dtl.yosan11 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin11 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin11, dtl.preData.jt_ur_kin11) }}</td><td>{{ dtl.yosan11 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin11, dtl.jt_ur_kin11) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin11, dtl.jt_ur_kin11), jtprint.nebiki(dtl.preData.kj_ur_kin11, dtl.preData.jt_ur_kin11)) }}</td><td>{{ dtl.yosan11 | number }}</td></tr><tr><td>{{ dtl.jitu_genka11 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka11, dtl.preData.jitu_genka11) }}</td><td>{{ dtl.yosan11 | number }}</td></tr></table></td><td class=\"center inner-title\">12月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin12 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin12, dtl.preData.kj_ur_kin12) }}</td><td>{{ dtl.yosan12 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin12 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin12, dtl.preData.jt_ur_kin12) }}</td><td>{{ dtl.yosan12 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin12, dtl.jt_ur_kin12) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin12, dtl.jt_ur_kin12), jtprint.nebiki(dtl.preData.kj_ur_kin12, dtl.preData.jt_ur_kin12)) }}</td><td>{{ dtl.yosan12 | number }}</td></tr><tr><td>{{ dtl.jitu_genka12 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka12, dtl.preData.jitu_genka12) }}</td><td>{{ dtl.yosan12 | number }}</td></tr></table></td><td class=\"center inner-title\">第3四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_3_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_3_kj_ur_kin, dtl.preData.hanki_3_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_3_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_3_jt_ur_kin, dtl.preData.hanki_3_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_3_kj_ur_kin, dtl.hanki_3_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_3_kj_ur_kin, dtl.hanki_3_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_3_kj_ur_kin, dtl.preData.hanki_3_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_3_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_3_jitu_genka, dtl.preData.hanki_3_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center\">&nbsp;</td><td class=\"center inner-title\">累計<table class=\"inner-middle\"><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePerKjYear(dtl.rui_kj_ur_kin, dtl.preData) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePerJtYear(dtl.rui_jt_ur_kin, dtl.preData) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePerNbYear( dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin, dtl.preData) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.rui_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePerGnYear(dtl.rui_jitu_genka, dtl.preData) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">1月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin01 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin01, dtl.preData.kj_ur_kin01) }}</td><td>{{ dtl.yosan01 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin01 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin01, dtl.preData.jt_ur_kin01) }}</td><td>{{ dtl.yosan01 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin01, dtl.jt_ur_kin01) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin01, dtl.jt_ur_kin01), jtprint.nebiki(dtl.preData.kj_ur_kin01, dtl.preData.jt_ur_kin01)) }}</td><td>{{ dtl.yosan01 | number }}</td></tr><tr><td>{{ dtl.jitu_genka01 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka01, dtl.preData.jitu_genka01) }}</td><td>{{ dtl.yosan01 | number }}</td></tr></table></td><td class=\"center inner-title\">2月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin02 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin02, dtl.preData.kj_ur_kin02) }}</td><td>{{ dtl.yosan02 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin02 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin02, dtl.preData.jt_ur_kin02) }}</td><td>{{ dtl.yosan02 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin02, dtl.jt_ur_kin02) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin02, dtl.jt_ur_kin02), jtprint.nebiki(dtl.preData.kj_ur_kin02, dtl.preData.jt_ur_kin02)) }}</td><td>{{ dtl.yosan02 | number }}</td></tr><tr><td>{{ dtl.jitu_genka02 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka02, dtl.preData.jitu_genka02) }}</td><td>{{ dtl.yosan02 | number }}</td></tr></table></td><td class=\"center inner-title\">3月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin03 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin03, dtl.preData.kj_ur_kin03) }}</td><td>{{ dtl.yosan03 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin03 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin03, dtl.preData.jt_ur_kin03) }}</td><td>{{ dtl.yosan03 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin03, dtl.jt_ur_kin03) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin03, dtl.jt_ur_kin03), jtprint.nebiki(dtl.preData.kj_ur_kin03, dtl.preData.jt_ur_kin03)) }}</td><td>{{ dtl.yosan03 | number }}</td></tr><tr><td>{{ dtl.jitu_genka03 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka03, dtl.preData.jitu_genka03) }}</td><td>{{ dtl.yosan03 | number }}</td></tr></table></td><td class=\"center inner-title\">第4四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_4_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_4_kj_ur_kin, dtl.preData.hanki_4_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_4_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_4_jt_ur_kin, dtl.preData.hanki_4_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_4_kj_ur_kin, dtl.hanki_4_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_4_kj_ur_kin, dtl.hanki_4_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_4_kj_ur_kin, dtl.preData.hanki_4_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_4_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_4_jitu_genka, dtl.preData.hanki_4_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">下半期<table class=\"inner-middle\"><tr><td>{{ dtl.shimo_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.shimo_hanki_kj_ur_kin, dtl.preData.shimo_hanki_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.shimo_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.shimo_hanki_jt_ur_kin, dtl.preData.shimo_hanki_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.shimo_hanki_kj_ur_kin, dtl.shimo_hanki_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.shimo_hanki_kj_ur_kin, dtl.shimo_hanki_jt_ur_kin), jtprint.nebiki(dtl.preData.shimo_hanki_kj_ur_kin, dtl.preData.shimo_hanki_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.shimo_hanki_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.shimo_hanki_jitu_genka, dtl.preData.shimo_hanki_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">年間<table class=\"inner-middle\"><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.rui_kj_ur_kin, dtl.preData.rui_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.rui_jt_ur_kin, dtl.preData.rui_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin), jtprint.nebiki(dtl.preData.rui_kj_ur_kin, dtl.preData.rui_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.rui_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.rui_jitu_genka, dtl.preData.rui_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/analysis/jt-print/analysis.html","<div class=\"mojt-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ jtprint.title }}</p><p class=\"text-center title-kikan\">({{jtprint.y+\'/04\'}}～{{jtprint.y+\'/\'+jtprint.m}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(jtprint.pagination.current * jtprint.datasPerPage - (jtprint.datasPerPage -1))+$index +\'/\'+ jtprint.totalCount\"></span><br>{{ jtprint.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"mojt-table-monthly-one\"><caption ng-if=\"detail.bumon_cd\">{{ detail.bumon_cd }}&nbsp;{{ detail.bumon_nm }}</caption><thead><tr><th class=\"title-tan\">担当者名</th><th class=\"title-clear\">&nbsp;</th><th class=\"title-body\">実績(前年比) 予算</th><th class=\"title-body\">実績(前年比) 予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th><th class=\"title-body\">実績(前年比)&nbsp;&nbsp;予算</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:\'syain_km\'\"><tr><td class=\"name-left\"><span ng-if=\"dtl.tanto_cd != \'00000000\' && dtl.tanto_cd != \'99999999\'\"><span ng-if=\"key==0\" ng-init=\"detail.bumon_cd = dtl.bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_nm = dtl.bumon_nm\"></span> &nbsp;{{ dtl.tanto_cd }}<br>{{ dtl.syain_nm }}</span> <span ng-if=\"dtl.tanto_cd == \'00000000\'\"><span ng-if=\"key==0\" ng-init=\"detail.bumon_cd = dtl.bumon_cd\"></span> <span ng-if=\"key==0\" ng-init=\"detail.bumon_nm = dtl.bumon_nm\"></span> &nbsp;{{ dtl.syain_nm }}</span> <span ng-if=\"dtl.tanto_cd == \'99999999\'\">&nbsp;合計</span></td><td class=\"center inner-title\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">4月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin04 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin04, dtl.preData.kj_ur_kin04) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin04 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin04, dtl.preData.jt_ur_kin04) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin04, dtl.jt_ur_kin04) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin04, dtl.jt_ur_kin04), jtprint.nebiki(dtl.preData.kj_ur_kin04, dtl.preData.jt_ur_kin04)) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.jitu_genka04 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka04, dtl.preData.jitu_genka04) }}</td><td>{{ dtl.yosan04 | number }}</td></tr></table></td><td class=\"center inner-title\">5月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin05 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin05, dtl.preData.kj_ur_kin05) }}</td><td>{{ dtl.yosan05 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin05 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin05, dtl.preData.jt_ur_kin05) }}</td><td>{{ dtl.yosan05 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin05, dtl.jt_ur_kin05) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin05, dtl.jt_ur_kin05), jtprint.nebiki(dtl.preData.kj_ur_kin05, dtl.preData.jt_ur_kin05)) }}</td><td>{{ dtl.yosan05 | number }}</td></tr><tr><td>{{ dtl.jitu_genka05 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka05, dtl.preData.jitu_genka05) }}</td><td>{{ dtl.yosan05 | number }}</td></tr></table></td><td class=\"center inner-title\">6月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin06 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin06, dtl.preData.kj_ur_kin06) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin06 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin06, dtl.preData.jt_ur_kin06) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin06, dtl.jt_ur_kin06) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin06, dtl.jt_ur_kin06), jtprint.nebiki(dtl.preData.kj_ur_kin06, dtl.preData.jt_ur_kin06)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.jitu_genka06 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka06, dtl.preData.jitu_genka06) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">第1四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_1_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_1_kj_ur_kin, dtl.preData.hanki_1_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_1_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_1_jt_ur_kin, dtl.preData.hanki_1_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_1_kj_ur_kin, dtl.hanki_1_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_1_kj_ur_kin, dtl.hanki_1_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_1_kj_ur_kin, dtl.preData.hanki_1_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_1_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_1_jitu_genka, dtl.preData.hanki_1_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center\">&nbsp;</td><td class=\"center\">&nbsp;</td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">7月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin07 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin07, dtl.preData.kj_ur_kin07) }}</td><td>{{ dtl.yosan07 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin07 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin07, dtl.preData.jt_ur_kin07) }}</td><td>{{ dtl.yosan07 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin07, dtl.jt_ur_kin07) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin07, dtl.jt_ur_kin07), jtprint.nebiki(dtl.preData.kj_ur_kin07, dtl.preData.jt_ur_kin07)) }}</td><td>{{ dtl.yosan07 | number }}</td></tr><tr><td>{{ dtl.jitu_genka07 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka07, dtl.preData.jitu_genka07) }}</td><td>{{ dtl.yosan07 | number }}</td></tr></table></td><td class=\"center inner-title\">8月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin08 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin08, dtl.preData.kj_ur_kin08) }}</td><td>{{ dtl.yosan08 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin08 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin08, dtl.preData.jt_ur_kin08) }}</td><td>{{ dtl.yosan08 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin08, dtl.jt_ur_kin08) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin08, dtl.jt_ur_kin08), jtprint.nebiki(dtl.preData.kj_ur_kin08, dtl.preData.jt_ur_kin08)) }}</td><td>{{ dtl.yosan08 | number }}</td></tr><tr><td>{{ dtl.jitu_genka08 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka08, dtl.preData.jitu_genka08) }}</td><td>{{ dtl.yosan08 | number }}</td></tr></table></td><td class=\"center inner-title\">9月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin09 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin09, dtl.preData.kj_ur_kin09) }}</td><td>{{ dtl.yosan09 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin09 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin09, dtl.preData.jt_ur_kin09) }}</td><td>{{ dtl.yosan09 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin09, dtl.jt_ur_kin09) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin09, dtl.jt_ur_kin09), jtprint.nebiki(dtl.preData.kj_ur_kin09, dtl.preData.jt_ur_kin09)) }}</td><td>{{ dtl.yosan09 | number }}</td></tr><tr><td>{{ dtl.jitu_genka09 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka09, dtl.preData.jitu_genka09) }}</td><td>{{ dtl.yosan09 | number }}</td></tr></table></td><td class=\"center inner-title\">第2四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_2_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_2_kj_ur_kin, dtl.preData.hanki_2_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_2_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_2_jt_ur_kin, dtl.preData.hanki_2_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_2_kj_ur_kin, dtl.hanki_2_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_2_kj_ur_kin, dtl.hanki_2_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_2_kj_ur_kin, dtl.preData.hanki_2_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_2_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_2_jitu_genka, dtl.preData.hanki_2_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">上半期<table class=\"inner-middle\"><tr><td>{{ dtl.kami_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kami_hanki_kj_ur_kin, dtl.preData.kami_hanki_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.kami_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kami_hanki_jt_ur_kin, dtl.preData.kami_hanki_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kami_hanki_kj_ur_kin, dtl.kami_hanki_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kami_hanki_kj_ur_kin, dtl.kami_hanki_jt_ur_kin), jtprint.nebiki(dtl.preData.kami_hanki_kj_ur_kin, dtl.preData.kami_hanki_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.kami_hanki_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kami_hanki_jitu_genka, dtl.preData.kami_hanki_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center\">&nbsp;</td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">10月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin10 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin10, dtl.preData.kj_ur_kin10) }}</td><td>{{ dtl.yosan10 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin10 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin10, dtl.preData.jt_ur_kin10) }}</td><td>{{ dtl.yosan10 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin10, dtl.jt_ur_kin10) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin10, dtl.jt_ur_kin10), jtprint.nebiki(dtl.preData.kj_ur_kin10, dtl.preData.jt_ur_kin10)) }}</td><td>{{ dtl.yosan10 | number }}</td></tr><tr><td>{{ dtl.jitu_genka10 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka10, dtl.preData.jitu_genka10) }}</td><td>{{ dtl.yosan10 | number }}</td></tr></table></td><td class=\"center inner-title\">11月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin11 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin11, dtl.preData.kj_ur_kin11) }}</td><td>{{ dtl.yosan11 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin11 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin11, dtl.preData.jt_ur_kin11) }}</td><td>{{ dtl.yosan11 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin11, dtl.jt_ur_kin11) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin11, dtl.jt_ur_kin11), jtprint.nebiki(dtl.preData.kj_ur_kin11, dtl.preData.jt_ur_kin11)) }}</td><td>{{ dtl.yosan11 | number }}</td></tr><tr><td>{{ dtl.jitu_genka11 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka11, dtl.preData.jitu_genka11) }}</td><td>{{ dtl.yosan11 | number }}</td></tr></table></td><td class=\"center inner-title\">12月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin12 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin12, dtl.preData.kj_ur_kin12) }}</td><td>{{ dtl.yosan12 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin12 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin12, dtl.preData.jt_ur_kin12) }}</td><td>{{ dtl.yosan12 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin12, dtl.jt_ur_kin12) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin12, dtl.jt_ur_kin12), jtprint.nebiki(dtl.preData.kj_ur_kin12, dtl.preData.jt_ur_kin12)) }}</td><td>{{ dtl.yosan12 | number }}</td></tr><tr><td>{{ dtl.jitu_genka12 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka12, dtl.preData.jitu_genka12) }}</td><td>{{ dtl.yosan12 | number }}</td></tr></table></td><td class=\"center inner-title\">第3四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_3_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_3_kj_ur_kin, dtl.preData.hanki_3_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_3_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_3_jt_ur_kin, dtl.preData.hanki_3_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_3_kj_ur_kin, dtl.hanki_3_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_3_kj_ur_kin, dtl.hanki_3_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_3_kj_ur_kin, dtl.preData.hanki_3_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_3_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_3_jitu_genka, dtl.preData.hanki_3_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center\">&nbsp;</td><td class=\"center inner-title\">累計<table class=\"inner-middle\"><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePerKjYear(dtl.rui_kj_ur_kin, dtl.preData) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePerJtYear(dtl.rui_jt_ur_kin, dtl.preData) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePerNbYear( dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin, dtl.preData) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.rui_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePerGnYear(dtl.rui_jitu_genka, dtl.preData) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>値引率</td></tr><tr><td>実際原価</td></tr></table></td><td class=\"center inner-title\">1月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin01 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin01, dtl.preData.kj_ur_kin01) }}</td><td>{{ dtl.yosan01 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin01 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin01, dtl.preData.jt_ur_kin01) }}</td><td>{{ dtl.yosan01 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin01, dtl.jt_ur_kin01) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin01, dtl.jt_ur_kin01), jtprint.nebiki(dtl.preData.kj_ur_kin01, dtl.preData.jt_ur_kin01)) }}</td><td>{{ dtl.yosan01 | number }}</td></tr><tr><td>{{ dtl.jitu_genka01 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka01, dtl.preData.jitu_genka01) }}</td><td>{{ dtl.yosan01 | number }}</td></tr></table></td><td class=\"center inner-title\">2月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin02 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin02, dtl.preData.kj_ur_kin02) }}</td><td>{{ dtl.yosan02 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin02 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin02, dtl.preData.jt_ur_kin02) }}</td><td>{{ dtl.yosan02 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin02, dtl.jt_ur_kin02) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin02, dtl.jt_ur_kin02), jtprint.nebiki(dtl.preData.kj_ur_kin02, dtl.preData.jt_ur_kin02)) }}</td><td>{{ dtl.yosan02 | number }}</td></tr><tr><td>{{ dtl.jitu_genka02 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka02, dtl.preData.jitu_genka02) }}</td><td>{{ dtl.yosan02 | number }}</td></tr></table></td><td class=\"center inner-title\">3月<table class=\"inner-middle\"><tr><td>{{ dtl.kj_ur_kin03 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.kj_ur_kin03, dtl.preData.kj_ur_kin03) }}</td><td>{{ dtl.yosan03 | number }}</td></tr><tr><td>{{ dtl.jt_ur_kin03 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jt_ur_kin03, dtl.preData.jt_ur_kin03) }}</td><td>{{ dtl.yosan03 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.kj_ur_kin03, dtl.jt_ur_kin03) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.kj_ur_kin03, dtl.jt_ur_kin03), jtprint.nebiki(dtl.preData.kj_ur_kin03, dtl.preData.jt_ur_kin03)) }}</td><td>{{ dtl.yosan03 | number }}</td></tr><tr><td>{{ dtl.jitu_genka03 | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.jitu_genka03, dtl.preData.jitu_genka03) }}</td><td>{{ dtl.yosan03 | number }}</td></tr></table></td><td class=\"center inner-title\">第4四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_4_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_4_kj_ur_kin, dtl.preData.hanki_4_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.hanki_4_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_4_jt_ur_kin, dtl.preData.hanki_4_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.hanki_4_kj_ur_kin, dtl.hanki_4_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.hanki_4_kj_ur_kin, dtl.hanki_4_jt_ur_kin), jtprint.nebiki(dtl.preData.hanki_4_kj_ur_kin, dtl.preData.hanki_4_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.hanki_4_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.hanki_4_jitu_genka, dtl.preData.hanki_4_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">下半期<table class=\"inner-middle\"><tr><td>{{ dtl.shimo_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.shimo_hanki_kj_ur_kin, dtl.preData.shimo_hanki_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.shimo_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.shimo_hanki_jt_ur_kin, dtl.preData.shimo_hanki_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.shimo_hanki_kj_ur_kin, dtl.shimo_hanki_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.shimo_hanki_kj_ur_kin, dtl.shimo_hanki_jt_ur_kin), jtprint.nebiki(dtl.preData.shimo_hanki_kj_ur_kin, dtl.preData.shimo_hanki_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.shimo_hanki_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.shimo_hanki_jitu_genka, dtl.preData.shimo_hanki_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td><td class=\"center inner-title\">年間<table class=\"inner-middle\"><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.rui_kj_ur_kin, dtl.preData.rui_kj_ur_kin) }}</td><td>{{ dtl.yosan04 | number }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.rui_jt_ur_kin, dtl.preData.rui_jt_ur_kin) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ jtprint.nebiki(dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin) | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(jtprint.nebiki(dtl.rui_kj_ur_kin, dtl.rui_jt_ur_kin), jtprint.nebiki(dtl.preData.rui_kj_ur_kin, dtl.preData.rui_jt_ur_kin)) }}</td><td>{{ dtl.yosan06 | number }}</td></tr><tr><td>{{ dtl.rui_jitu_genka | number}}</td><td class=\"td-middle\">{{ jtprint.prePer(dtl.rui_jitu_genka, dtl.preData.rui_jitu_genka) }}</td><td>{{ dtl.yosan06 | number }}</td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/analysis/jt-print/print.html","<style>\n    @page {\n      size: A4 landscape!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"jtprint.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"jtprint.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ jtprint.pagination.current }})&emsp;－</span><br><span>部門：{{ jtprint.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><div ng-if=\"jtprint.datas.length > 0 && jtprint.mode == 1\"><article id=\"jt-print-area\"><section class=\"col-xs-12\" dir-paginate=\"detail in jtprint.datas | itemsPerPage: jtprint.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"jtprint.totalCount\" current-page=\"jtprint.pagination.current\"><span ng-include=\"\'app/analysis/jt-print/analysis.html\'\"></span></section></article></div><div ng-if=\"jtprint.datas.length > 0 && jtprint.mode == 2\"><article id=\"jt-print-area\"><section class=\"col-xs-12\" dir-paginate=\"detail in jtprint.datas | itemsPerPage: jtprint.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"jtprint.totalCount\" current-page=\"jtprint.pagination.current\"><span ng-include=\"\'app/analysis/jt-print/analysis-toku.html\'\"></span></section></article></div></div>");
$templateCache.put("app/analysis/monthly-transition/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"mts.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:80px\">部門選択 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:200px\" ng-model=\"mts.form.bumon_nm\" disabled=\"\"></div></div><div class=\"input-group\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"mts.form.parentBmnChk\"> <span>親部門を含める</span></label></div></div><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"mts.from_date\" disabled=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-clear btn-sm\" type=\"button\" disabled=\"\">～</button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"mts.end_date\" disabled=\"\"></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"></div><div class=\"col-xs-5\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"mts.generateAnalysis()\" ng-disabled=\"!mts.form.bumon_cd\">帳票生成</button></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"mts.error\">{{ mts.error }}</div></div></div></div></div>");
$templateCache.put("app/analysis/monthly-report-toku/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-if=\"mrk.items.length > 0\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><dualmultiselect options=\"mrk.options\" input-model=\"mrk.items\" recursion-check=\"true\" output-all-info=\"false\" output-duplicate=\"true\" ng-model=\"mrk.form.value\"></dualmultiselect><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"mrk.from_date\" disabled=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-clear btn-sm\" type=\"button\" disabled=\"\">～</button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"mrk.end_date\" disabled=\"\"></div></div><div class=\"form-group col-xs-6\"></div><div class=\"nyoro\">～</div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"mrk.generateAnalysis()\">帳票生成</button></div></div></div></div></div></div>");
$templateCache.put("app/analysis/mts-print/analysis.html","<div class=\"mts-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ mtsprint.title }}</p><p class=\"text-center title-kikan\">({{mtsprint.y+\'/04\'}}～{{mtsprint.y+\'/\'+mtsprint.m}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(mtsprint.pagination.current * mtsprint.datasPerPage - (mtsprint.datasPerPage -1))+$index +\'/\'+ mtsprint.totalCount\"></span><br>{{ mtsprint.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-mts-one\"><caption ng-if=\"mtsprint.parent_bumon_cd\">{{ mtsprint.parent_bumon_cd }}&nbsp;{{ mtsprint.parent_bumon_nm }}</caption><thead><tr><th class=\"title-tan\">担当者名</th><th class=\"title-clear\">&nbsp;</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th><th class=\"title-body\">実績(前年比)</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail track by $index\"><tr><td class=\"name-left\"><span ng-if=\"dtl.bumon_kb != \'0\'\">&nbsp;{{ dtl.bumon_nm }}</span> <span ng-if=\"dtl.bumon_kb == \'0\'\">&nbsp;合計</span></td><td class=\"center inner-title\">&nbsp;<table class=\"inner-left\"><tr><td>作業金額</td></tr><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>予算</td></tr></table></td><td class=\"center inner-title\">4月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin04 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin04, dtl.preData.sg_kin04) }}</td></tr><tr><td>{{ dtl.kj_ur_kin04 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin04, dtl.preData.kj_ur_kin04) }}</td></tr><tr><td>{{ dtl.jt_ur_kin04 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin04, dtl.preData.jt_ur_kin04) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">5月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin05 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin05, dtl.preData.sg_kin05) }}</td></tr><tr><td>{{ dtl.kj_ur_kin05 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin05, dtl.preData.kj_ur_kin05) }}</td></tr><tr><td>{{ dtl.jt_ur_kin05 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin05, dtl.preData.jt_ur_kin05) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">6月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin06 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin06, dtl.preData.sg_kin06) }}</td></tr><tr><td>{{ dtl.kj_ur_kin06 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin06, dtl.preData.kj_ur_kin06) }}</td></tr><tr><td>{{ dtl.jt_ur_kin06 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin06, dtl.preData.jt_ur_kin06) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">第1四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_1_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_1_sg_kin, dtl.preData.hanki_1_sg_kin) }}</td></tr><tr><td>{{ dtl.hanki_1_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_1_kj_ur_kin, dtl.preData.hanki_1_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_1_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_1_jt_ur_kin, dtl.preData.hanki_1_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">7月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin07 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin07, dtl.preData.sg_kin07) }}</td></tr><tr><td>{{ dtl.kj_ur_kin07 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin07, dtl.preData.kj_ur_kin07) }}</td></tr><tr><td>{{ dtl.jt_ur_kin07 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin07, dtl.preData.jt_ur_kin07) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">8月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin08 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin08, dtl.preData.sg_kin08) }}</td></tr><tr><td>{{ dtl.kj_ur_kin08 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin08, dtl.preData.kj_ur_kin08) }}</td></tr><tr><td>{{ dtl.jt_ur_kin08 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin08, dtl.preData.jt_ur_kin08) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">9月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin09 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin09, dtl.preData.sg_kin09) }}</td></tr><tr><td>{{ dtl.kj_ur_kin09 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin09, dtl.preData.kj_ur_kin09) }}</td></tr><tr><td>{{ dtl.jt_ur_kin09 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin09, dtl.preData.jt_ur_kin09) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">第2四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_2_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_2_sg_kin, dtl.preData.hanki_2_sg_kin) }}</td></tr><tr><td>{{ dtl.hanki_2_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_2_kj_ur_kin, dtl.preData.hanki_2_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_2_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_2_jt_ur_kin, dtl.preData.hanki_2_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">上半期<table class=\"inner-middle\"><tr><td>{{ dtl.kami_hanki_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kami_hanki_sg_kin, dtl.preData.kami_hanki_sg_kin) }}</td></tr><tr><td>{{ dtl.kami_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kami_hanki_kj_ur_kin, dtl.preData.kami_hanki_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.kami_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kami_hanki_jt_ur_kin, dtl.preData.kami_hanki_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">累計<table class=\"inner-middle\"><tr><td>{{ dtl.rui_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePerGnYear(dtl.rui_sg_kin, dtl.preData) }}</td></tr><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePerKjYear(dtl.rui_kj_ur_kin, dtl.preData) }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePerJtYear(dtl.rui_jt_ur_kin, dtl.preData) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>基準売上</td></tr><tr><td>実売上</td></tr><tr><td>実際原価</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">10月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin10 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin10, dtl.preData.sg_kin10) }}</td></tr><tr><td>{{ dtl.kj_ur_kin10 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin10, dtl.preData.kj_ur_kin10) }}</td></tr><tr><td>{{ dtl.jt_ur_kin10 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin10, dtl.preData.jt_ur_kin10) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">11月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin11 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin11, dtl.preData.sg_kin11) }}</td></tr><tr><td>{{ dtl.kj_ur_kin11 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin11, dtl.preData.kj_ur_kin11) }}</td></tr><tr><td>{{ dtl.jt_ur_kin11 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin11, dtl.preData.jt_ur_kin11) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">12月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin12 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin12, dtl.preData.sg_kin12) }}</td></tr><tr><td>{{ dtl.kj_ur_kin12 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin12, dtl.preData.kj_ur_kin12) }}</td></tr><tr><td>{{ dtl.jt_ur_kin12 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin12, dtl.preData.jt_ur_kin12) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">第3四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_3_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_3_sg_kin, dtl.preData.hanki_3_sg_kin) }}</td></tr><tr><td>{{ dtl.hanki_3_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_3_kj_ur_kin, dtl.preData.hanki_3_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_3_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_3_jt_ur_kin, dtl.preData.hanki_3_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">1月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin01 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin01, dtl.preData.sg_kin01) }}</td></tr><tr><td>{{ dtl.kj_ur_kin01 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin01, dtl.preData.kj_ur_kin01) }}</td></tr><tr><td>{{ dtl.jt_ur_kin01 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin01, dtl.preData.jt_ur_kin01) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">2月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin02 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin02, dtl.preData.sg_kin02) }}</td></tr><tr><td>{{ dtl.kj_ur_kin02 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin02, dtl.preData.kj_ur_kin02) }}</td></tr><tr><td>{{ dtl.jt_ur_kin02 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin02, dtl.preData.jt_ur_kin02) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">3月<table class=\"inner-middle\"><tr><td>{{ dtl.sg_kin03 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.sg_kin03, dtl.preData.sg_kin03) }}</td></tr><tr><td>{{ dtl.kj_ur_kin03 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.kj_ur_kin03, dtl.preData.kj_ur_kin03) }}</td></tr><tr><td>{{ dtl.jt_ur_kin03 | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.jt_ur_kin03, dtl.preData.jt_ur_kin03) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">第4四半期<table class=\"inner-middle\"><tr><td>{{ dtl.hanki_4_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_4_sg_kin, dtl.preData.hanki_4_sg_kin) }}</td></tr><tr><td>{{ dtl.hanki_4_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_4_kj_ur_kin, dtl.preData.hanki_4_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.hanki_4_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.hanki_4_jt_ur_kin, dtl.preData.hanki_4_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">下半期<table class=\"inner-middle\"><tr><td>{{ dtl.shimo_hanki_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.shimo_hanki_sg_kin, dtl.preData.shimo_hanki_sg_kin) }}</td></tr><tr><td>{{ dtl.shimo_hanki_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.shimo_hanki_kj_ur_kin, dtl.preData.shimo_hanki_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.shimo_hanki_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.shimo_hanki_jt_ur_kin, dtl.preData.shimo_hanki_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td><td class=\"center inner-title\">年間<table class=\"inner-middle\"><tr><td>{{ dtl.rui_sg_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.rui_sg_kin, dtl.preData.rui_sg_kin) }}</td></tr><tr><td>{{ dtl.rui_kj_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.rui_kj_ur_kin, dtl.preData.rui_kj_ur_kin) }}</td></tr><tr><td>{{ dtl.rui_jt_ur_kin | number}}</td><td class=\"td-middle\">{{ mtsprint.prePer(dtl.rui_jt_ur_kin, dtl.preData.rui_jt_ur_kin) }}</td></tr><tr><td>&nbsp;</td><td class=\"td-middle\">&nbsp;</td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/analysis/mts-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"mtsprint.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ mtsprint.pagination.current }})&emsp;－</span><br><span>部門：{{ mtsprint.parent_bumon_nm }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"mtsprint.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in mtsprint.datas | itemsPerPage: mtsprint.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"mtsprint.totalCount\" current-page=\"mtsprint.pagination.current\"><div ng-include=\"\'app/analysis/mts-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/analysis/oa-print-print/analysis.html","<div class=\"oap-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ oaprint.title }}</p><p class=\"text-center title-kikan\">({{oaprint.y+\'/04\'}}～{{oaprint.y+\'/\'+oaprint.m}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(oaprint.pagination.current * oaprint.datasPerPage - (oaprint.datasPerPage -1))+$index +\'/\'+ oaprint.totalCount\"></span><br>{{ oaprint.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table oap-table-monthly-one\"><caption ng-if=\"detail.bumon_cd\">{{ detail.bumon_cd }}&nbsp;{{ detail.bumon_nm }}</caption><thead><tr><th class=\"title-tan\">得意先名</th><th class=\"title-clear\">&nbsp;</th><th class=\"title-body\">本数(前年比)&nbsp;&nbsp;金額(前年比)</th><th class=\"title-body\">本数(前年比)&nbsp;&nbsp;金額(前年比)</th><th class=\"title-body\">本数(前年比)&nbsp;&nbsp;金額(前年比)</th><th class=\"title-body\">本数(前年比)&nbsp;&nbsp;金額(前年比)</th><th class=\"title-body\">本数(前年比)&nbsp;&nbsp;金額(前年比)</th><th class=\"title-body\">本数(前年比)&nbsp;&nbsp;金額(前年比)</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail track by $index\"><tr><td class=\"name-left\"><span ng-if=\"dtl.toku.toku_cd == \'99999999\'\">合計</span> <span ng-if=\"dtl.toku.toku_cd != \'99999999\'\">{{dtl.toku.toku_cd}}<br>{{dtl.toku.toku_nm}}</span></td><td class=\"center inner-title\">&nbsp;<table class=\"inner-left\"><tr><td>XDCAM</td></tr><tr><td>HD</td></tr><tr><td>その他</td></tr><tr><td>計</td></tr></table></td><td class=\"center inner-title\">4月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu04 }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu04, dtl.item[0].preData[0].honsu04) }}</td><td>{{ dtl.item[0].kin04 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin04, dtl.item[0].preData[0].kin04) }}</td></tr><tr><td>{{ dtl.item[1].honsu04 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu04, dtl.item[1].preData[0].honsu04) }}</td><td>{{ dtl.item[1].kin04 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin04, dtl.item[1].preData[0].kin04) }}</td></tr><tr><td>{{ dtl.item[2].honsu04 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu04, dtl.item[2].preData[0].honsu04) }}</td><td>{{ dtl.item[2].kin04 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin04, dtl.item[2].preData[0].kin04) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu04,dtl.item[1].honsu04,dtl.item[2].honsu04]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu04,dtl.item[1].honsu04,dtl.item[2].honsu04], [dtl.item[0].preData[0].honsu04,dtl.item[1].preData[0].honsu04,dtl.item[2].preData[0].honsu04] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin04,dtl.item[1].kin04,dtl.item[2].kin04]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin04,dtl.item[1].kin04,dtl.item[2].kin04], [dtl.item[0].preData[0].kin04,dtl.item[1].preData[0].kin04,dtl.item[2].preData[0].kin04] ) }}</td></tr></table></td><td class=\"center inner-title\">5月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu05 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu05, dtl.item[0].preData[0].honsu05) }}</td><td>{{ dtl.item[0].kin05 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin05, dtl.item[0].preData[0].kin05) }}</td></tr><tr><td>{{ dtl.item[1].honsu05 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu05, dtl.item[1].preData[0].honsu05) }}</td><td>{{ dtl.item[1].kin05 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin05, dtl.item[1].preData[0].kin05) }}</td></tr><tr><td>{{ dtl.item[2].honsu05 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu05, dtl.item[2].preData[0].honsu05) }}</td><td>{{ dtl.item[2].kin05 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin05, dtl.item[2].preData[0].kin05) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu05,dtl.item[1].honsu05,dtl.item[2].honsu05]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu05,dtl.item[1].honsu05,dtl.item[2].honsu05], [dtl.item[0].preData[0].honsu05,dtl.item[1].preData[0].honsu05,dtl.item[2].preData[0].honsu05] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin05,dtl.item[1].kin05,dtl.item[2].kin05]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin05,dtl.item[1].kin05,dtl.item[2].kin05], [dtl.item[0].preData[0].kin05,dtl.item[1].preData[0].kin05,dtl.item[2].preData[0].kin05] ) }}</td></tr></table></td><td class=\"center inner-title\">6月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu06 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu06, dtl.item[0].preData[0].honsu06) }}</td><td>{{ dtl.item[0].kin06 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin06, dtl.item[0].preData[0].kin06) }}</td></tr><tr><td>{{ dtl.item[1].honsu06 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu06, dtl.item[1].preData[0].honsu06) }}</td><td>{{ dtl.item[1].kin06 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin06, dtl.item[1].preData[0].kin06) }}</td></tr><tr><td>{{ dtl.item[2].honsu06 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu06, dtl.item[2].preData[0].honsu06) }}</td><td>{{ dtl.item[2].kin06 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin06, dtl.item[2].preData[0].kin06) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu06,dtl.item[1].honsu06,dtl.item[2].honsu06]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu06,dtl.item[1].honsu06,dtl.item[2].honsu06], [dtl.item[0].preData[0].honsu06,dtl.item[1].preData[0].honsu06,dtl.item[2].preData[0].honsu06] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin06,dtl.item[1].kin06,dtl.item[2].kin06]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin06,dtl.item[1].kin06,dtl.item[2].kin06], [dtl.item[0].preData[0].kin06,dtl.item[1].preData[0].kin06,dtl.item[2].preData[0].kin06] ) }}</td></tr></table></td><td class=\"center inner-title\">第1四半期<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].hanki_1_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_1_honsu, dtl.item[0].preData[0].hanki_1_honsu) }}</td><td>{{ dtl.item[0].hanki_1_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_1_kin, dtl.item[0].preData[0].hanki_1_kin) }}</td></tr><tr><td>{{ dtl.item[1].hanki_1_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_1_honsu, dtl.item[1].preData[0].hanki_1_honsu) }}</td><td>{{ dtl.item[1].hanki_1_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_1_kin, dtl.item[1].preData[0].hanki_1_kin) }}</td></tr><tr><td>{{ dtl.item[2].hanki_1_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_1_honsu, dtl.item[2].preData[0].hanki_1_honsu) }}</td><td>{{ dtl.item[2].hanki_1_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_1_kin, dtl.item[2].preData[0].hanki_1_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].hanki_1_honsu,dtl.item[1].hanki_1_honsu,dtl.item[2].hanki_1_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_1_honsu,dtl.item[1].hanki_1_honsu,dtl.item[2].hanki_1_honsu], [dtl.item[0].preData[0].hanki_1_honsu,dtl.item[1].preData[0].hanki_1_honsu,dtl.item[2].preData[0].hanki_1_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].hanki_1_kin,dtl.item[1].hanki_1_kin,dtl.item[2].hanki_1_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_1_kin,dtl.item[1].hanki_1_kin,dtl.item[2].hanki_1_kin], [dtl.item[0].preData[0].hanki_1_kin,dtl.item[1].preData[0].hanki_1_kin,dtl.item[2].preData[0].hanki_1_kin] ) }}</td></tr></table></td><td class=\"center\">&nbsp;</td><td class=\"center\">&nbsp;</td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>XDCAM</td></tr><tr><td>HD</td></tr><tr><td>その他</td></tr><tr><td>計</td></tr></table></td><td class=\"center inner-title\">7月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu07 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu07, dtl.item[0].preData[0].honsu07) }}</td><td>{{ dtl.item[0].kin07 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin07, dtl.item[0].preData[0].kin07) }}</td></tr><tr><td>{{ dtl.item[1].honsu07 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu07, dtl.item[1].preData[0].honsu07) }}</td><td>{{ dtl.item[1].kin07 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin07, dtl.item[1].preData[0].kin07) }}</td></tr><tr><td>{{ dtl.item[2].honsu07 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu07, dtl.item[2].preData[0].honsu07) }}</td><td>{{ dtl.item[2].kin07 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin07, dtl.item[2].preData[0].kin07) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu07,dtl.item[1].honsu07,dtl.item[2].honsu07]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu07,dtl.item[1].honsu07,dtl.item[2].honsu07], [dtl.item[0].preData[0].honsu07,dtl.item[1].preData[0].honsu07,dtl.item[2].preData[0].honsu07] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin07,dtl.item[1].kin07,dtl.item[2].kin07]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin07,dtl.item[1].kin07,dtl.item[2].kin07], [dtl.item[0].preData[0].kin07,dtl.item[1].preData[0].kin07,dtl.item[2].preData[0].kin07] ) }}</td></tr></table></td><td class=\"center inner-title\">8月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu08 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu08, dtl.item[0].preData[0].honsu08) }}</td><td>{{ dtl.item[0].kin08 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin08, dtl.item[0].preData[0].kin08) }}</td></tr><tr><td>{{ dtl.item[1].honsu08 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu08, dtl.item[1].preData[0].honsu08) }}</td><td>{{ dtl.item[1].kin08 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin08, dtl.item[1].preData[0].kin08) }}</td></tr><tr><td>{{ dtl.item[2].honsu08 }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu08, dtl.item[2].preData[0].honsu08) }}</td><td>{{ dtl.item[2].kin08 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin08, dtl.item[2].preData[0].kin08) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu08,dtl.item[1].honsu08,dtl.item[2].honsu08]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu08,dtl.item[1].honsu08,dtl.item[2].honsu08], [dtl.item[0].preData[0].honsu08,dtl.item[1].preData[0].honsu08,dtl.item[2].preData[0].honsu08] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin08,dtl.item[1].kin08,dtl.item[2].kin08]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin08,dtl.item[1].kin08,dtl.item[2].kin08], [dtl.item[0].preData[0].kin08,dtl.item[1].preData[0].kin08,dtl.item[2].preData[0].kin08] ) }}</td></tr></table></td><td class=\"center inner-title\">9月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu09 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu09, dtl.item[0].preData[0].honsu09) }}</td><td>{{ dtl.item[0].kin09 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin09, dtl.item[0].preData[0].kin09) }}</td></tr><tr><td>{{ dtl.item[1].honsu09 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu09, dtl.item[1].preData[0].honsu09) }}</td><td>{{ dtl.item[1].kin09 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin09, dtl.item[1].preData[0].kin09) }}</td></tr><tr><td>{{ dtl.item[2].honsu09 }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu09, dtl.item[2].preData[0].honsu09) }}</td><td>{{ dtl.item[2].kin09 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin09, dtl.item[2].preData[0].kin09) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu09,dtl.item[1].honsu09,dtl.item[2].honsu09]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu09,dtl.item[1].honsu09,dtl.item[2].honsu09], [dtl.item[0].preData[0].honsu09,dtl.item[1].preData[0].honsu09,dtl.item[2].preData[0].honsu09] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin09,dtl.item[1].kin09,dtl.item[2].kin09]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin09,dtl.item[1].kin09,dtl.item[2].kin09], [dtl.item[0].preData[0].kin09,dtl.item[1].preData[0].kin09,dtl.item[2].preData[0].kin09] ) }}</td></tr></table></td><td class=\"center inner-title\">第2四半期<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].hanki_2_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_2_honsu, dtl.item[0].preData[0].hanki_2_honsu) }}</td><td>{{ dtl.item[0].hanki_2_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_2_kin, dtl.item[0].preData[0].hanki_2_kin) }}</td></tr><tr><td>{{ dtl.item[1].hanki_2_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_2_honsu, dtl.item[1].preData[0].hanki_2_honsu) }}</td><td>{{ dtl.item[1].hanki_2_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_2_kin, dtl.item[1].preData[0].hanki_2_kin) }}</td></tr><tr><td>{{ dtl.item[2].hanki_2_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_2_honsu, dtl.item[2].preData[0].hanki_2_honsu) }}</td><td>{{ dtl.item[2].hanki_2_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_2_kin, dtl.item[2].preData[0].hanki_2_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].hanki_2_honsu,dtl.item[1].hanki_2_honsu,dtl.item[2].hanki_2_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_2_honsu,dtl.item[1].hanki_2_honsu,dtl.item[2].hanki_2_honsu], [dtl.item[0].preData[0].hanki_2_honsu,dtl.item[1].preData[0].hanki_2_honsu,dtl.item[2].preData[0].hanki_2_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].hanki_2_kin,dtl.item[1].hanki_2_kin,dtl.item[2].hanki_2_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_2_kin,dtl.item[1].hanki_2_kin,dtl.item[2].hanki_2_kin], [dtl.item[0].preData[0].hanki_2_kin,dtl.item[1].preData[0].hanki_2_kin,dtl.item[2].preData[0].hanki_2_kin] ) }}</td></tr></table></td><td class=\"center inner-title\">上半期<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].kami_hanki_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kami_hanki_honsu, dtl.item[0].preData[0].kami_hanki_honsu) }}</td><td>{{ dtl.item[0].kami_hanki_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kami_hanki_kin, dtl.item[0].preData[0].kami_hanki_kin) }}</td></tr><tr><td>{{ dtl.item[1].kami_hanki_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kami_hanki_honsu, dtl.item[1].preData[0].kami_hanki_honsu) }}</td><td>{{ dtl.item[1].kami_hanki_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kami_hanki_kin, dtl.item[1].preData[0].kami_hanki_kin) }}</td></tr><tr><td>{{ dtl.item[2].kami_hanki_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kami_hanki_honsu, dtl.item[2].preData[0].kami_hanki_honsu) }}</td><td>{{ dtl.item[2].kami_hanki_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kami_hanki_kin, dtl.item[2].preData[0].kami_hanki_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].kami_hanki_honsu,dtl.item[1].kami_hanki_honsu,dtl.item[2].kami_hanki_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kami_hanki_honsu,dtl.item[1].kami_hanki_honsu,dtl.item[2].kami_hanki_honsu], [dtl.item[0].preData[0].kami_hanki_honsu,dtl.item[1].preData[0].kami_hanki_honsu,dtl.item[2].preData[0].kami_hanki_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kami_hanki_kin,dtl.item[1].kami_hanki_kin,dtl.item[2].kami_hanki_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kami_hanki_kin,dtl.item[1].kami_hanki_kin,dtl.item[2].kami_hanki_kin], [dtl.item[0].preData[0].kami_hanki_kin,dtl.item[1].preData[0].kami_hanki_kin,dtl.item[2].preData[0].kami_hanki_kin] ) }}</td></tr></table></td><td class=\"center\">&nbsp;</td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>XDCAM</td></tr><tr><td>HD</td></tr><tr><td>その他</td></tr><tr><td>計</td></tr></table></td><td class=\"center inner-title\">10月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu10 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu10, dtl.item[0].preData[0].honsu10) }}</td><td>{{ dtl.item[0].kin10 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin10, dtl.item[0].preData[0].kin10) }}</td></tr><tr><td>{{ dtl.item[1].honsu10 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu10, dtl.item[1].preData[0].honsu10) }}</td><td>{{ dtl.item[1].kin10 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin10, dtl.item[1].preData[0].kin10) }}</td></tr><tr><td>{{ dtl.item[2].honsu10 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu10, dtl.item[2].preData[0].honsu10) }}</td><td>{{ dtl.item[2].kin10 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin10, dtl.item[2].preData[0].kin10) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu10,dtl.item[1].honsu10,dtl.item[2].honsu10]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu10,dtl.item[1].honsu10,dtl.item[2].honsu10], [dtl.item[0].preData[0].honsu10,dtl.item[1].preData[0].honsu10,dtl.item[2].preData[0].honsu10] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin10,dtl.item[1].kin10,dtl.item[2].kin10]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin10,dtl.item[1].kin10,dtl.item[2].kin10], [dtl.item[0].preData[0].kin10,dtl.item[1].preData[0].kin10,dtl.item[2].preData[0].kin10] ) }}</td></tr></table></td><td class=\"center inner-title\">11月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu11 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu11, dtl.item[0].preData[0].honsu11) }}</td><td>{{ dtl.item[0].kin11 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin11, dtl.item[0].preData[0].kin11) }}</td></tr><tr><td>{{ dtl.item[1].honsu11 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu11, dtl.item[1].preData[0].honsu11) }}</td><td>{{ dtl.item[1].kin11 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin11, dtl.item[1].preData[0].kin11) }}</td></tr><tr><td>{{ dtl.item[2].honsu11 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu11, dtl.item[2].preData[0].honsu11) }}</td><td>{{ dtl.item[2].kin11 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin11, dtl.item[2].preData[0].kin11) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu11,dtl.item[1].honsu11,dtl.item[2].honsu11]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu11,dtl.item[1].honsu11,dtl.item[2].honsu11], [dtl.item[0].preData[0].honsu11,dtl.item[1].preData[0].honsu11,dtl.item[2].preData[0].honsu11] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin11,dtl.item[1].kin11,dtl.item[2].kin11]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin11,dtl.item[1].kin11,dtl.item[2].kin11], [dtl.item[0].preData[0].kin11,dtl.item[1].preData[0].kin11,dtl.item[2].preData[0].kin11] ) }}</td></tr></table></td><td class=\"center inner-title\">12月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu12 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu12, dtl.item[0].preData[0].honsu12) }}</td><td>{{ dtl.item[0].kin12 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin12, dtl.item[0].preData[0].kin12) }}</td></tr><tr><td>{{ dtl.item[1].honsu12 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu12, dtl.item[1].preData[0].honsu12) }}</td><td>{{ dtl.item[1].kin12 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin12, dtl.item[1].preData[0].kin12) }}</td></tr><tr><td>{{ dtl.item[2].honsu12 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu12, dtl.item[2].preData[0].honsu12) }}</td><td>{{ dtl.item[2].kin12 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin12, dtl.item[2].preData[0].kin12) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu12,dtl.item[1].honsu12,dtl.item[2].honsu12]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu12,dtl.item[1].honsu12,dtl.item[2].honsu12], [dtl.item[0].preData[0].honsu12,dtl.item[1].preData[0].honsu12,dtl.item[2].preData[0].honsu12] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin12,dtl.item[1].kin12,dtl.item[2].kin12]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin12,dtl.item[1].kin12,dtl.item[2].kin12], [dtl.item[0].preData[0].kin12,dtl.item[1].preData[0].kin12,dtl.item[2].preData[0].kin12] ) }}</td></tr></table></td><td class=\"center inner-title\">第3四半期<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].hanki_3_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_3_honsu, dtl.item[0].preData[0].hanki_3_honsu) }}</td><td>{{ dtl.item[0].hanki_3_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_3_kin, dtl.item[0].preData[0].hanki_3_kin) }}</td></tr><tr><td>{{ dtl.item[1].hanki_3_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_3_honsu, dtl.item[1].preData[0].hanki_3_honsu) }}</td><td>{{ dtl.item[1].hanki_3_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_3_kin, dtl.item[1].preData[0].hanki_3_kin) }}</td></tr><tr><td>{{ dtl.item[2].hanki_3_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_3_honsu, dtl.item[2].preData[0].hanki_3_honsu) }}</td><td>{{ dtl.item[2].hanki_3_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_3_kin, dtl.item[2].preData[0].hanki_3_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].hanki_3_honsu,dtl.item[1].hanki_3_honsu,dtl.item[2].hanki_3_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_3_honsu,dtl.item[1].hanki_3_honsu,dtl.item[2].hanki_3_honsu], [dtl.item[0].preData[0].hanki_3_honsu,dtl.item[1].preData[0].hanki_3_honsu,dtl.item[2].preData[0].hanki_3_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].hanki_3_kin,dtl.item[1].hanki_3_kin,dtl.item[2].hanki_3_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_3_kin,dtl.item[1].hanki_3_kin,dtl.item[2].hanki_3_kin], [dtl.item[0].preData[0].hanki_3_kin,dtl.item[1].preData[0].hanki_3_kin,dtl.item[2].preData[0].hanki_3_kin] ) }}</td></tr></table></td><td class=\"center\">&nbsp;</td><td class=\"center inner-title\">累計<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].rui_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePerHonYear(dtl.item[0].rui_honsu, dtl.item[0].preData[0]) }}</td><td>{{ dtl.item[0].rui_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKinYear(dtl.item[0].rui_kin, dtl.item[0].preData[0]) }}</td></tr><tr><td>{{ dtl.item[1].rui_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePerHonYear(dtl.item[1].rui_honsu, dtl.item[1].preData[0]) }}</td><td>{{ dtl.item[1].rui_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKinYear(dtl.item[1].rui_kin, dtl.item[1].preData[0]) }}</td></tr><tr><td>{{ dtl.item[2].rui_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePerHonYear(dtl.item[2].rui_honsu, dtl.item[2].preData[0]) }}</td><td>{{ dtl.item[2].rui_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKinYear(dtl.item[2].rui_kin, dtl.item[2].preData[0]) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].rui_honsu,dtl.item[1].rui_honsu,dtl.item[2].rui_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerHonNbYear([ dtl.item[0].rui_honsu, dtl.item[1].rui_honsu, dtl.item[2].rui_honsu ], [dtl.item[0].preData[0],dtl.item[1].preData[0],dtl.item[2].preData[0]] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].rui_kin,dtl.item[1].rui_kin,dtl.item[2].rui_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKinNbYear([dtl.item[0].rui_kin,dtl.item[1].rui_kin,dtl.item[2].rui_kin], [dtl.item[0].preData[0],dtl.item[1].preData[0],dtl.item[2].preData[0]] ) }}</td></tr></table></td></tr><tr><td class=\"name-left\">&nbsp;</td><td class=\"center\">&nbsp;<table class=\"inner-left\"><tr><td>XDCAM</td></tr><tr><td>HD</td></tr><tr><td>その他</td></tr><tr><td>計</td></tr></table></td><td class=\"center inner-title\">1月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu01 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu01, dtl.item[0].preData[0].honsu01) }}</td><td>{{ dtl.item[0].kin01 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin01, dtl.item[0].preData[0].kin01) }}</td></tr><tr><td>{{ dtl.item[1].honsu01 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu01, dtl.item[1].preData[0].honsu01) }}</td><td>{{ dtl.item[1].kin01 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin01, dtl.item[1].preData[0].kin01) }}</td></tr><tr><td>{{ dtl.item[2].honsu01 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu01, dtl.item[2].preData[0].honsu01) }}</td><td>{{ dtl.item[2].kin01 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin01, dtl.item[2].preData[0].kin01) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu01,dtl.item[1].honsu01,dtl.item[2].honsu01]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu01,dtl.item[1].honsu01,dtl.item[2].honsu01], [dtl.item[0].preData[0].honsu01,dtl.item[1].preData[0].honsu01,dtl.item[2].preData[0].honsu01] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin01,dtl.item[1].kin01,dtl.item[2].kin01]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin01,dtl.item[1].kin01,dtl.item[2].kin01], [dtl.item[0].preData[0].kin01,dtl.item[1].preData[0].kin01,dtl.item[2].preData[0].kin01] ) }}</td></tr></table></td><td class=\"center inner-title\">2月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu02 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu02, dtl.item[0].preData[0].honsu02) }}</td><td>{{ dtl.item[0].kin02 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin02, dtl.item[0].preData[0].kin02) }}</td></tr><tr><td>{{ dtl.item[1].honsu02 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu02, dtl.item[1].preData[0].honsu02) }}</td><td>{{ dtl.item[1].kin02 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin02, dtl.item[1].preData[0].kin02) }}</td></tr><tr><td>{{ dtl.item[2].honsu02 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu02, dtl.item[2].preData[0].honsu02) }}</td><td>{{ dtl.item[2].kin02 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin02, dtl.item[2].preData[0].kin02) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu02,dtl.item[1].honsu02,dtl.item[2].honsu02]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu02,dtl.item[1].honsu02,dtl.item[2].honsu02], [dtl.item[0].preData[0].honsu02,dtl.item[1].preData[0].honsu02,dtl.item[2].preData[0].honsu02] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin02,dtl.item[1].kin02,dtl.item[2].kin02]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin02,dtl.item[1].kin02,dtl.item[2].kin02], [dtl.item[0].preData[0].kin02,dtl.item[1].preData[0].kin02,dtl.item[2].preData[0].kin02] ) }}</td></tr></table></td><td class=\"center inner-title\">3月<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].honsu03 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].honsu03, dtl.item[0].preData[0].honsu03) }}</td><td>{{ dtl.item[0].kin03 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].kin03, dtl.item[0].preData[0].kin03) }}</td></tr><tr><td>{{ dtl.item[1].honsu03 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].honsu03, dtl.item[1].preData[0].honsu03) }}</td><td>{{ dtl.item[1].kin03 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].kin03, dtl.item[1].preData[0].kin03) }}</td></tr><tr><td>{{ dtl.item[2].honsu03 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].honsu03, dtl.item[2].preData[0].honsu03) }}</td><td>{{ dtl.item[2].kin03 | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].kin03, dtl.item[2].preData[0].kin03) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].honsu03,dtl.item[1].honsu03,dtl.item[2].honsu03]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].honsu03,dtl.item[1].honsu03,dtl.item[2].honsu03], [dtl.item[0].preData[0].honsu03,dtl.item[1].preData[0].honsu03,dtl.item[2].preData[0].honsu03] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].kin03,dtl.item[1].kin03,dtl.item[2].kin03]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].kin03,dtl.item[1].kin03,dtl.item[2].kin03], [dtl.item[0].preData[0].kin03,dtl.item[1].preData[0].kin03,dtl.item[2].preData[0].kin03] ) }}</td></tr></table></td><td class=\"center inner-title\">第4四半期<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].hanki_4_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_4_honsu, dtl.item[0].preData[0].hanki_4_honsu) }}</td><td>{{ dtl.item[0].hanki_4_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].hanki_4_kin, dtl.item[0].preData[0].hanki_4_kin) }}</td></tr><tr><td>{{ dtl.item[1].hanki_4_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_4_honsu, dtl.item[1].preData[0].hanki_4_honsu) }}</td><td>{{ dtl.item[1].hanki_4_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].hanki_4_kin, dtl.item[1].preData[0].hanki_4_kin) }}</td></tr><tr><td>{{ dtl.item[2].hanki_4_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_4_honsu, dtl.item[2].preData[0].hanki_4_honsu) }}</td><td>{{ dtl.item[2].hanki_4_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].hanki_4_kin, dtl.item[2].preData[0].hanki_4_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].hanki_4_honsu,dtl.item[1].hanki_4_honsu,dtl.item[2].hanki_4_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_4_honsu,dtl.item[1].hanki_4_honsu,dtl.item[2].hanki_4_honsu], [dtl.item[0].preData[0].hanki_4_honsu,dtl.item[1].preData[0].hanki_4_honsu,dtl.item[2].preData[0].hanki_4_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].hanki_4_kin,dtl.item[1].hanki_4_kin,dtl.item[2].hanki_4_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].hanki_4_kin,dtl.item[1].hanki_4_kin,dtl.item[2].hanki_4_kin], [dtl.item[0].preData[0].hanki_4_kin,dtl.item[1].preData[0].hanki_4_kin,dtl.item[2].preData[0].hanki_4_kin] ) }}</td></tr></table></td><td class=\"center inner-title\">下半期<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].shimo_hanki_honsu }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].shimo_hanki_honsu, dtl.item[0].preData[0].shimo_hanki_honsu) }}</td><td>{{ dtl.item[0].shimo_hanki_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].shimo_hanki_kin, dtl.item[0].preData[0].shimo_hanki_kin) }}</td></tr><tr><td>{{ dtl.item[1].shimo_hanki_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].shimo_hanki_honsu, dtl.item[1].preData[0].shimo_hanki_honsu) }}</td><td>{{ dtl.item[1].shimo_hanki_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].shimo_hanki_kin, dtl.item[1].preData[0].shimo_hanki_kin) }}</td></tr><tr><td>{{ dtl.item[2].shimo_hanki_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].shimo_hanki_honsu, dtl.item[2].preData[0].shimo_hanki_honsu) }}</td><td>{{ dtl.item[2].shimo_hanki_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].shimo_hanki_kin, dtl.item[2].preData[0].shimo_hanki_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].shimo_hanki_honsu,dtl.item[1].shimo_hanki_honsu,dtl.item[2].shimo_hanki_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].shimo_hanki_honsu,dtl.item[1].shimo_hanki_honsu,dtl.item[2].shimo_hanki_honsu], [dtl.item[0].preData[0].shimo_hanki_honsu,dtl.item[1].preData[0].shimo_hanki_honsu,dtl.item[2].preData[0].shimo_hanki_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].shimo_hanki_kin,dtl.item[1].shimo_hanki_kin,dtl.item[2].shimo_hanki_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].shimo_hanki_kin,dtl.item[1].shimo_hanki_kin,dtl.item[2].shimo_hanki_kin], [dtl.item[0].preData[0].shimo_hanki_kin,dtl.item[1].preData[0].shimo_hanki_kin,dtl.item[2].preData[0].shimo_hanki_kin] ) }}</td></tr></table></td><td class=\"center inner-title\">年間<table class=\"inner-middle\"><tr><td>{{ dtl.item[0].rui_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].rui_honsu, dtl.item[0].preData[0].rui_honsu) }}</td><td>{{ dtl.item[0].rui_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[0].rui_kin, dtl.item[0].preData[0].rui_kin) }}</td></tr><tr><td>{{ dtl.item[1].rui_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].rui_honsu, dtl.item[1].preData[0].rui_honsu) }}</td><td>{{ dtl.item[1].rui_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[1].rui_kin, dtl.item[1].preData[0].rui_kin) }}</td></tr><tr><td>{{ dtl.item[2].rui_honsu | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].rui_honsu, dtl.item[2].preData[0].rui_honsu) }}</td><td>{{ dtl.item[2].rui_kin | number }}</td><td class=\"td-middle\">{{ oaprint.prePer(dtl.item[2].rui_kin, dtl.item[2].preData[0].rui_kin) }}</td></tr><tr><td>{{ oaprint.reduceItem([dtl.item[0].rui_honsu,dtl.item[1].rui_honsu,dtl.item[2].rui_honsu]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].rui_honsu,dtl.item[1].rui_honsu,dtl.item[2].rui_honsu], [dtl.item[0].preData[0].rui_honsu,dtl.item[1].preData[0].rui_honsu,dtl.item[2].preData[0].rui_honsu] ) }}</td><td>{{ oaprint.reduceItem([dtl.item[0].rui_kin,dtl.item[1].rui_kin,dtl.item[2].rui_kin]) | number }}</td><td class=\"td-middle\">{{ oaprint.prePerKei([dtl.item[0].rui_kin,dtl.item[1].rui_kin,dtl.item[2].rui_kin], [dtl.item[0].preData[0].rui_kin,dtl.item[1].preData[0].rui_kin,dtl.item[2].preData[0].rui_kin] ) }}</td></tr></table></td></tr></tbody></table></div></div>");
$templateCache.put("app/analysis/oa-print-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"oaprint.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ oaprint.pagination.current }})&emsp;－</span><br><span>部門：{{ oaprint.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"oaprint.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"detail in oaprint.datas | itemsPerPage: oaprint.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"oaprint.totalCount\" current-page=\"oaprint.pagination.current\"><div ng-include=\"\'app/analysis/oa-print-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/analysis/oa-print-count/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-if=\"opc.items.length > 0\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><dualmultiselect options=\"opc.options\" input-model=\"opc.items\" recursion-check=\"true\" output-all-info=\"false\" output-duplicate=\"true\" ng-model=\"opc.form.value\"></dualmultiselect><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"opc.from_date\" disabled=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-clear btn-sm\" type=\"button\" disabled=\"\">～</button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"opc.end_date\" disabled=\"\"></div></div><div class=\"col-xs-6\"></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\"><div>対象商品：XDCAM、DVCAM、その他</div><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"opc.generateAnalysis()\">帳票生成</button></div></div></div></div></div></div>");
$templateCache.put("app/analysis/staff-operating-status/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\" ng-if=\"sos.items.length > 0\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><dualmultiselect options=\"sos.options\" input-model=\"sos.items\" recursion-check=\"true\" output-all-info=\"false\" output-duplicate=\"true\" ng-model=\"sos.form.value\"></dualmultiselect><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"sos.from_date\" data-max-date=\"{{sos.getMaxDate()}}\" data-date-format=\"yyyy/MM\" data-start-view=\"1\" data-min-view=\"1\" data-date-type=\"string\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-clear btn-sm\" type=\"button\" disabled=\"\">～</button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"sos.end_date\" data-min-date=\"{{sos.getMinDate()}}\" data-date-format=\"yyyy/MM\" data-start-view=\"1\" data-min-view=\"1\" data-date-type=\"string\" placeholder=\"To\" name=\"endDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"></div><div class=\"col-xs-12\"><p>Toの入力無しでFromにて指定した年月の範囲を出力します</p></div></div><div class=\"col-xs-6\"><div class=\"col-xs-12\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"sos.generateAnalysis()\" ng-disabled=\"sos.form.value.length == 0 || !sos.from_date\">帳票生成</button></div></div></div></div></div></div>");
$templateCache.put("app/analysis/sos-print/analysis.html","<div class=\"sos-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ sosprint.title }}</p><p class=\"text-center title-kikan\" ng-if=\"sosprint.frmEnd.from_date && sosprint.frmEnd.end_date\">({{sosprint.frmEnd.from_date}}～{{sosprint.frmEnd.end_date}})</p><p class=\"text-center title-kikan\" ng-if=\"sosprint.frmEnd.from_date && !sosprint.frmEnd.end_date\">({{sosprint.frmEnd.from_date}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(sosprint.pagination.current * sosprint.datasPerPage - (sosprint.datasPerPage -1))+$index +\'/\'+ sosprint.totalCount\"></span><br>{{ sosprint.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-staff-ope\"><caption ng-if=\"detail[0].bumon_cd\">部門&nbsp;{{ detail[0].bumon_cd }}&nbsp;{{ detail[0].bumon_nm }}</caption><thead><tr><th class=\"title-tan\">氏名</th><th class=\"title-body\">1技術員時間</th><th class=\"title-body\">件数</th><th class=\"title-body\">2技術員時間</th><th class=\"title-body\">件数</th><th class=\"title-body\">3技術員時間</th><th class=\"title-body\">実時間合計</th><th class=\"title-body\">作業件数</th><th class=\"title-body\">前作業時間</th><th class=\"title-body\">後作業時間</th><th class=\"title-body\">作業時間合計</th><th class=\"title-body\">指名率(時間)</th><th class=\"title-body\">指名率(件数)</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:\'yakusyoku_cd\' track by $index\"><tr ng-class=\"{\'last\':dtl.tanto_cd == \'99999\'}\"><td ng-if=\"dtl.tanto_cd != \'99999\'\" rowspan=\"2\" class=\"name-left\">{{ dtl.tanto_cd }}<br>{{ dtl.syain_nm }}</td><td ng-if=\"dtl.tanto_cd == \'99999\'\" rowspan=\"2\" class=\"name-right\">{{ dtl.syain_nm }}</td><td>{{ dtl.giju1_j | number}}</td><td>{{ dtl.giju1_k | number}}</td><td>{{ dtl.giju2_j | number}}</td><td>{{ dtl.giju2_k | number}}</td><td>{{ dtl.giju3_j | number}}</td><td>{{ dtl.giju_j_kei | number}}</td><td>{{ dtl.giju_k_kei | number}}</td><td>{{ dtl.mae_j | number}}</td><td>{{ dtl.ato_j | number}}</td><td>{{ dtl.j_rui | number}}</td><td rowspan=\"2\">{{ sosprint.makeKado_j(dtl) | number}}&nbsp;%</td><td rowspan=\"2\">{{ sosprint.makeKado_k(dtl) | number}}&nbsp;%</td></tr><tr><td>{{ dtl.giju1_js | number}}</td><td>{{ dtl.giju1_ks | number}}</td><td>{{ dtl.giju2_js | number}}</td><td>{{ dtl.giju2_ks | number}}</td><td>&nbsp;</td><td>{{ dtl.giju_js_kei | number}}</td><td>{{ dtl.giju_ks_kei | number}}</td><td>&nbsp;</td><td>&nbsp;</td><td>{{ dtl.k_rui | number}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/analysis/sos-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"sosprint.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"sosprint.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ sosprint.pagination.current }})&emsp;－</span><br><span>{{ sosprint.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"sosprint.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in sosprint.datas | itemsPerPage: sosprint.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"sosprint.totalCount\" current-page=\"sosprint.pagination.current\"><div ng-include=\"\'app/analysis/sos-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/analysis/studio-transition/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-xs-1\"></div><div class=\"col-xs-5\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"str.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" style=\"width:80px\">部門選択 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:200px\" ng-model=\"str.form.bumon_nm\" disabled=\"\"></div></div></div><div class=\"col-xs-4\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">対象月</span> <input type=\"text\" class=\"form-control input-sm\" style=\"width:80px\" ng-model=\"str.form.target_date\" data-max-date=\"{{str.getMaxDate()}}\" data-date-format=\"yyyy/MM\" data-start-view=\"1\" data-min-view=\"1\" data-date-type=\"string\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"> <span class=\"input-group-btn\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"str.generateAnalysis()\">データ取得</button></span></div></div></div><div class=\"col-xs-2\"></div><div class=\"col-xs-12\" ng-if=\"str.error\">{{ str.error }}</div></div></div></div></div><hr><div class=\"row\"><div class=\"col-xs-12 table-fixed\" ng-if=\"str.getLength(str.mainDatas) > 0\"><button type=\"button\" class=\"btn btn-warning btn-xs\" ng-csv=\"str.csvItems\" csv-header=\"str.csvHeaders\" filename=\"studio-transition.csv\">CSV</button><div class=\"table-fixed-left\"><table><tr><th class=\"left-header\">部門</th><th class=\"left-header\">項目</th></tr><tbody ng-repeat=\"(bumon,itm) in str.mainDatas | toArray | orderBy:\'bumon_cd\'\"><tr ng-repeat=\"(i, head) in itm\"><th><span ng-if=\"i == 0\">{{itm.bumon_nm}}</span><span ng-if=\"i != 0\">&nbsp;</span></th><th>{{ head.studio_nm }}</th></tr></tbody></table></div><div class=\"table-fixed-right\"><table><tr><th class=\"right-header\">月間合計</th><th colspan=\"2\" class=\"right-header\" ng-repeat=\"i in str.item\"><span ng-if=\"i < 31\">{{i+1}}&nbsp;({{ str.getWeek(i) }})</span> <span ng-if=\"i > 32\">&nbsp;</span></th></tr><tbody ng-repeat=\"(bumon,itms) in str.mainDatas | toArray | orderBy:\'bumon_cd\'\"><tr ng-repeat=\"(i, dtl) in itms\"><td>{{ str.makeMonthTotal(dtl, 1) | number }}</td><td>{{ str.kinFilter(dtl.kin1) | number }}</td><td>{{ str.makeAchievementRate( dtl,1) | number }}</td><td>{{ str.kinFilter(dtl.kin2) | number }}</td><td>{{ str.makeAchievementRate( dtl,2) | number }}</td><td>{{ str.kinFilter(dtl.kin3) | number }}</td><td>{{ str.makeAchievementRate( dtl,3) | number }}</td><td>{{ str.kinFilter(dtl.kin4) | number }}</td><td>{{ str.makeAchievementRate( dtl,4) | number }}</td><td>{{ str.kinFilter(dtl.kin5) | number }}</td><td>{{ str.makeAchievementRate( dtl,5) | number }}</td><td>{{ str.kinFilter(dtl.kin6) | number }}</td><td>{{ str.makeAchievementRate( dtl,6) | number }}</td><td>{{ str.kinFilter(dtl.kin7) | number }}</td><td>{{ str.makeAchievementRate( dtl,7) | number }}</td><td>{{ str.kinFilter(dtl.kin8) | number }}</td><td>{{ str.makeAchievementRate( dtl,8) | number }}</td><td>{{ str.kinFilter(dtl.kin9) | number }}</td><td>{{ str.makeAchievementRate( dtl,9) | number }}</td><td>{{ str.kinFilter(dtl.kin10) | number }}</td><td>{{ str.makeAchievementRate( dtl,10) | number }}</td><td>{{ str.kinFilter(dtl.kin11) | number }}</td><td>{{ str.makeAchievementRate( dtl,11) | number }}</td><td>{{ str.kinFilter(dtl.kin12) | number }}</td><td>{{ str.makeAchievementRate( dtl,12) | number }}</td><td>{{ str.kinFilter(dtl.kin13) | number }}</td><td>{{ str.makeAchievementRate( dtl,13) | number }}</td><td>{{ str.kinFilter(dtl.kin14) | number }}</td><td>{{ str.makeAchievementRate( dtl,14) | number }}</td><td>{{ str.kinFilter(dtl.kin15) | number }}</td><td>{{ str.makeAchievementRate( dtl,15) | number }}</td><td>{{ str.kinFilter(dtl.kin16) | number }}</td><td>{{ str.makeAchievementRate( dtl,16) | number }}</td><td>{{ str.kinFilter(dtl.kin17) | number }}</td><td>{{ str.makeAchievementRate( dtl,17) | number }}</td><td>{{ str.kinFilter(dtl.kin18) | number }}</td><td>{{ str.makeAchievementRate( dtl,18) | number }}</td><td>{{ str.kinFilter(dtl.kin19) | number }}</td><td>{{ str.makeAchievementRate( dtl,19) | number }}</td><td>{{ str.kinFilter(dtl.kin20) | number }}</td><td>{{ str.makeAchievementRate( dtl,20) | number }}</td><td>{{ str.kinFilter(dtl.kin21) | number }}</td><td>{{ str.makeAchievementRate( dtl,21) | number }}</td><td>{{ str.kinFilter(dtl.kin22) | number }}</td><td>{{ str.makeAchievementRate( dtl,22) | number }}</td><td>{{ str.kinFilter(dtl.kin23) | number }}</td><td>{{ str.makeAchievementRate( dtl,23) | number }}</td><td>{{ str.kinFilter(dtl.kin24) | number }}</td><td>{{ str.makeAchievementRate( dtl,24) | number }}</td><td>{{ str.kinFilter(dtl.kin25) | number }}</td><td>{{ str.makeAchievementRate( dtl,25) | number }}</td><td>{{ str.kinFilter(dtl.kin26) | number }}</td><td>{{ str.makeAchievementRate( dtl,26) | number }}</td><td>{{ str.kinFilter(dtl.kin27) | number }}</td><td>{{ str.makeAchievementRate( dtl,27) | number }}</td><td>{{ str.kinFilter(dtl.kin28) | number }}</td><td>{{ str.makeAchievementRate( dtl,28) | number }}</td><td>{{ str.kinFilter(dtl.kin29) | number }}</td><td>{{ str.makeAchievementRate( dtl,29) | number }}</td><td>{{ str.kinFilter(dtl.kin30) | number }}</td><td>{{ str.makeAchievementRate( dtl,30) | number }}</td><td>{{ str.kinFilter(dtl.kin31) | number }}</td><td>{{ str.makeAchievementRate( dtl,31) | number }}</td></tr></tbody></table></div><br><br><br></div></div>");
$templateCache.put("app/analysis/studio-transition/select-modal.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">印刷対象選択</h4></div><div class=\"modal-body\"><h6>選択してください</h6><p><label><input type=\"radio\" value=\"1\" ng-model=\"invoicedata.printType\"> 請求書</label> <label><input type=\"radio\" value=\"2\" ng-model=\"invoicedata.printType\"> 請求書明細</label> <label><input type=\"radio\" value=\"3\" ng-model=\"invoicedata.printType\"> 納品書</label></p><p class=\"text-right\"><button type=\"button\" class=\"btn btn-success\" ng-disabled=\"!invoicedata.printType\" ng-click=\"invoicedata.invoiceGenerate()\">発行</button></p></div></div></div></div>");
$templateCache.put("app/business-accounting/acc-print/detail.html","<div class=\"col-xs-12 sos-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ ep.title }}</p></div><div class=\"col-xs-3 text-right yt-page\">{{ ep.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</div></div><div class=\"col-xs-12\"><p><span>経費伝票No.{{ ep.printTargetData.kh_no }}&emsp;&emsp;</span> <span>作業伝票No.{{ ep.printTargetData.sg_no }}&emsp;&emsp;</span> <span>経費分類{{ ep.printTargetData.kh_bunrui_nm }}&emsp;&emsp;&emsp;&emsp;</span> <span>申請日{{ ep.printTargetData.ss_day_time*1000|date:\'yyyy/M/dd\' }}</span></p><p class=\"pull-right\"><span>小計：{{ ep.printTargetData.kei_kin | number }}&emsp;&emsp;</span> <span>消費税：{{ ep.printTargetData.zei_kin | number }}&emsp;&emsp;</span> <span>合計：{{ ep.printTargetData.komi_kin | number }}</span></p><table class=\"table table-print-simple\" ng-if=\"ep.printTargetData.kotuhi_fl == \'1\'\"><thead><tr><th rowspan=\"2\">#</th><th>用途</th><th>交通手段</th><th>金額</th></tr><tr><th colspan=\"3\">備考</th></tr></thead><tbody ng-repeat=\"item in ep.printTargetData.detail\"><tr><td rowspan=\"2\" class=\"name-center\">{{ $index+1 }}</td><td>{{ item.kamoku_nm }}</td><td>{{ item.shudan }} &emsp;&emsp;{{ item.stt_chi }}～{{ item.end_chi }}</td><td class=\"name-right\">{{ item.kin | number }}</td></tr><tr><td colspan=\"3\">{{ item.biko }}</td></tr></tbody></table><table class=\"table table-print-simple\" ng-if=\"ep.printTargetData.kotuhi_fl != \'1\'\"><thead><tr><th rowspan=\"2\">#</th><th>用途</th><th>金額</th></tr><tr><th colspan=\"2\">備考</th></tr></thead><tbody ng-repeat=\"item in ep.printTargetData.detail\"><tr><td rowspan=\"2\" class=\"name-center\">{{ $index+1 }}</td><td>{{ item.kamoku_nm }}</td><td class=\"name-right\">{{ item.kin | number }}</td></tr><tr><td colspan=\"3\">{{ item.biko }}</td></tr></tbody></table></div><div class=\"col-xs-12\"><hr><p><span>申請部門：{{ ep.printTargetData.ss_bmn_cd }}&emsp;{{ ep.printTargetData.ss_bmn_nm }}</span><br><span>申請者：{{ ep.printTargetData.ss_tan_cd }}&emsp;{{ ep.printTargetData.ss_tan_nm }}</span></p></div></div>");
$templateCache.put("app/business-accounting/acc-print/print.html","<style type=\"text/css\">\n@media print {\n    @page {\n        size: A4 landscape;\n        margin: 0;\n    }\n}\n</style><button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"sos-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br></div><hr><div class=\"row sos-virtical-preview-area\"><article id=\"sos-print-area\" ng-if=\"ep.printTargetData.detail.length > 0\"><section class=\"col-xs-12\"><div ng-include=\"\'app/business-expenses/exp-print/detail.html\'\"></div></section></article></div>");
$templateCache.put("app/analysis/work-specification/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><h5>技術員作業明細は管理者にのみメニュー表示されるページです。</h5></div><div class=\"panel-body\" 　=\"\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\" style=\"width:100px\">年月指定</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ws.form.fromDate\" data-date-format=\"yyyyMM\" data-start-view=\"1\" data-min-view=\"1\" data-date-type=\"string\" placeholder=\"yyyymm\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"col-xs-12\"><small style=\"color:red;\">※掛率は基本情報マスタでデフォルト設定可能です</small></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 1</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ws.form.base_rate_over_1\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 2</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ws.form.base_rate_over_2\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 3</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ws.form.base_rate_over_3\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">基準職務給掛率 4</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ws.form.base_rate_over_4\" model-format=\"float\" formatter=\"formatitem($modelValue,$filter, \'0.0\');\"></div></div><div class=\"col-md-7\"><div class=\"col-md-12 form-group pull-left\"></div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"ws.generateAnalysis()\" style=\"width:150px\">帳票生成</button></div></div><div class=\"col-xs-12\"><small style=\"color:red;\"><span>※仕組み上完全な数値は出し切れません。疑わしい場合は個別に確認してください。<br></span> <span>(前、後で作業時間が相殺されてしまっていたり作業時間がマイナスになっている場合、30分刻みで無い作業時間が設定されているなど)</span></small></div></div></form></div></div></div>");
$templateCache.put("app/analysis/work-specification/modal1.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-warning\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">技術員作業明細ダウンロード</h4></div><div class=\"modal-body\"><h6>リンクをクリックしてファイルをダウンロードしてください</h6><a href=\"{{ws.downloadPath}}\">Download</a></div></div></div></div>");
$templateCache.put("app/business-expenses/exp-print/detail.html","<div class=\"row print-page-simple-content\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ ep.title }}</p></div><div class=\"col-xs-3 text-right yt-page\">PAGE <span ng-bind=\"(ep.pagination.current * ep.datasPerPage - (ep.datasPerPage -1))+$index +\'/\'+ ep.totalCount\"></span><br>{{ ep.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</div></div><div class=\"col-xs-12\"><p><span>経費伝票No.{{ ep.printTargetData.kh_no }}&emsp;&emsp;</span> <span>作業伝票No.{{ ep.printTargetData.sg_no }}&emsp;&emsp;</span> <span>経費分類{{ ep.printTargetData.kh_bunrui_nm }}&emsp;&emsp;&emsp;&emsp;</span> <span>申請日{{ ep.printTargetData.ss_day_time*1000|date:\'yyyy/M/dd\' }}</span></p><p class=\"pull-right\"><span>小計：{{ ep.printTargetData.nuki_kin | number }}&emsp;&emsp;</span> <span>消費税：{{ ep.printTargetData.zei_kin | number }}&emsp;&emsp;</span> <span>合計：{{ ep.printTargetData.komi_kin | number }}</span></p><table class=\"table table-print-simple\" ng-if=\"ep.printTargetData.kotuhi_fl == \'1\'\"><thead><tr><th rowspan=\"2\">#</th><th>用途</th><th>交通手段</th><th>金額</th></tr><tr><th colspan=\"3\">備考</th></tr></thead><tbody ng-repeat=\"item in items\"><tr><td rowspan=\"2\" class=\"name-center\">{{ $index+1 }}</td><td>{{ item.kamoku_nm }}</td><td>{{ item.shudan }} &emsp;&emsp;{{ item.stt_chi }}～{{ item.end_chi }}</td><td class=\"name-right\">{{ item.kin | number }}</td></tr><tr><td colspan=\"3\">{{ item.biko }}</td></tr></tbody></table><table class=\"table table-print-simple\" ng-if=\"ep.printTargetData.kotuhi_fl != \'1\'\"><thead><tr><th rowspan=\"2\">#</th><th>用途</th><th>金額</th></tr><tr><th colspan=\"2\">備考</th></tr></thead><tbody ng-repeat=\"item in items\"><tr><td rowspan=\"2\" class=\"name-center\">{{ $index+1 }}</td><td>{{ item.kamoku_nm }}</td><td class=\"name-right\">{{ item.kin | number }}</td></tr><tr><td colspan=\"3\">{{ item.biko }}</td></tr></tbody></table></div><div class=\"col-xs-12\"><hr><p><span>申請部門：{{ ep.printTargetData.ss_bmn_cd }}&emsp;{{ ep.printTargetData.ss_bmn_nm }}</span><br><span>申請者：{{ ep.printTargetData.ss_tan_cd }}&emsp;{{ ep.printTargetData.ss_tan_nm }}</span></p></div></div>");
$templateCache.put("app/business-expenses/exp-print/print.html","<style type=\"text/css\">\n@page {\n  size: A4 portrait!important;\n  margin: 0!important;\n}\n@media print {\n  html, body {\n    width: 285mm!important;\n    height: 210mm!important;\n  }\n}\n</style><nav><dir-pagination-controls on-page-change=\"ep.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"printPaginate\"></dir-pagination-controls><button ng-print=\"\" print-element-id=\"simple-preview-area\"><i class=\"fa fa-print\"></i> 印刷</button></nav><div class=\"text-center\"><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br>{{ print.pagination.current }}</div></div><hr><div class=\"print-page-simple-preview-area\"><article id=\"simple-preview-area\" ng-if=\"ep.datas.length > 0\"><section class=\"print-page-simple\" dir-paginate=\"(epKey, items) in ep.datas | itemsPerPage: ep.datasPerPage\" pagination-id=\"printPaginate\" total-items=\"ep.totalDatas\" current-page=\"ep.pagination.current\"><div ng-include=\"\'app/business-expenses/exp-print/detail.html\'\"></div></section></article></div>");
$templateCache.put("app/business-expenses/sghksr/index.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><div class=\"row\"><div class=\"col-xs-8\"><h5>作業報告簡易検索</h5></div><div class=\"col-xs-4\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideItemModal()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"col-xs-12\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.form.fromDate\" data-max-date=\"{{vm.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作業日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"vm.form.untilDate\" data-min-date=\"{{vm.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"col-xs-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">得意先検索</span><div angucomplete-alt=\"\" id=\"ex1\" maxlength=\"50\" placeholder=\"No. 又は 名称入力であいまい検索します\" pause=\"300\" selected-object=\"vm.tokuisakiSelected\" remote-api-handler=\"vm.tokuisakiApiSearch\" title-field=\"names\" minlength=\"1\" input-class=\"form-control form-control-small input-sm\"><input type=\"hidden\" name=\"toku_no\" ng-model=\"vm.form.toku_no\"></div></div></div></div><div class=\"col-xs-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">作品名</span> <input type=\"text\" class=\"form-control input-sm\" placeholder=\"作品名\" ng-model=\"vm.form.hin_nm\"></div></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"vm.goSearch()\" style=\"width:150px\">検索</button></div></div></form><div class=\"col-xs-12\"><hr></div><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><dir-pagination-controls on-page-change=\"vm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"sghksrPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"vm.datasPerPage < vm.totalDatas\" ng-bind=\"vm.pagination.current * vm.datasPerPage - (vm.datasPerPage -1) +\'～\'+vm.pagination.current * vm.datasPerPage+\'件/\'+vm.totalDatas+\'件\'\"></span> <span ng-if=\"vm.datasPerPage > vm.totalDatas\" ng-bind=\"vm.totalDatas+\'件/\'+vm.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">作業No.</th><th style=\"width:45px\">受注No.</th><th style=\"width:90px\">得意先</th><th style=\"width:60px\">作品名</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in vm.datas | itemsPerPage: vm.datasPerPage\" pagination-id=\"sghksrPaginate\" total-items=\"vm.totalDatas\" current-page=\"vm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setSghkItem(item)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ ($index + 1) + (vm.pagination.current - 1) * vm.datasPerPage }}</td><td>{{ item.sg_no }}</td><td>{{ item.ju_no }}</td><td><span bs-tooltip=\"item.toku_nm\">{{ item.toku_nm }}</span></td><td><span bs-tooltip=\"item.hin_nm\">{{ item.hin_nm }}</span></td></tr></tbody></table></div></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\"><small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/achojokamoku/achojokamoku.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">補助科目検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">補助科目名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"hojo_nm\" ng-model=\"vm.form.hojo_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">科目CD</th><th style=\"width:45px\">補助科目CD</th><th style=\"width:90px\">補助科目名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {tori_nm:vm.form.hojo_nm} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.hojyo_cd, item.kmk_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.kmk_cd }}</td><td>{{ item.hojyo_cd }}</td><td>{{ item.kmk_nm }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/achojokamokuitem/achojokamokuitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">補助科目検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">補助科目名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"hojo_nm\" ng-model=\"vm.form.hojo_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">補助科目CD</th><th style=\"width:90px\">補助科目名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {kmk_nm:vm.form.hojo_nm} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.hojyo_cd, item.kmk_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.hojyo_kmk_cd }}</td><td>{{ item.kmk_nm }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/actorihikisaki/actorihikisaki.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">取引先検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.toriKbnDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">取引先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.tori_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_nm\" ng-model=\"vm.form.tori_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先カナ</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_km\" ng-model=\"vm.form.tori_km\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">取引先CD</th><th style=\"width:45px\">取引先区分</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">カナ名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {tori_kb:vm.form.tori_kb} | filter: {tori_nm:vm.form.tori_nm} | filter: {tori_km:vm.form.tori_km} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.tori_cd, item.tori_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.tori_cd }}</td><td>{{ item.tori_kb_nm }}</td><td>{{ item.tori_nm }}</td><td>{{ item.tori_km }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/ackamokuitem/ackamokuitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">科目検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">科目名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"hojo_nm\" ng-model=\"vm.form.hojo_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.khBunruiDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">経費分類 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.kh_bunrui_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">科目CD</th><th style=\"width:90px\">科目名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {dsp_nm:vm.form.dsp_nm} | filter: {kh_bunrui_cd:vm.form.kh_bunrui_cd} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.kmk_cd, item.dsp_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.kmk_cd }}</td><td>{{ item.dsp_nm }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/iccItem/iccitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><caption>検索</caption><thead><tr class=\"active\"><th class=\"title\">メディア</th><th class=\"title\">商品名</th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"vm.mediaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ vm.media_nm }} <span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-xs\" name=\"tori_nm\" ng-model=\"vm.form.sg_item_nm\"></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sgItem | filter:{\'media_cd\':vm.form.media_cd} | filter:{\'sg_item_nm\':vm.form.sg_item_nm} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/icctorihikisaki/icctorihikisaki.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">取引先検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.toriKbnDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">取引先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.tori_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"tori_nm\" ng-model=\"vm.form.tori_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先カナ</span> <input type=\"text\" class=\"form-control input-xs\" name=\"tori_km\" ng-model=\"vm.form.tori_km\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><dir-pagination-controls on-page-change=\"vm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"iccEditPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"vm.datasPerPage < vm.totalDatas\" ng-bind=\"vm.pagination.current * vm.datasPerPage - (vm.datasPerPage -1) +\'～\'+vm.pagination.current * vm.datasPerPage+\'件/\'+vm.totalDatas+\'件\'\"></span> <span ng-if=\"vm.datasPerPage > vm.totalDatas\" ng-bind=\"vm.totalDatas+\'件/\'+vm.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">取引先CD</th><th style=\"width:45px\">取引先区分</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">カナ名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in vm.datas | itemsPerPage: vm.datasPerPage\" pagination-id=\"iccEditPaginate\" total-items=\"vm.totalDatas\" current-page=\"vm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.tori_cd }}</td><td>{{ item.tori_kb_nm }}</td><td>{{ item.tori_nm }}</td><td>{{ item.tori_km }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/icctorihikisakiedit/icctorihikisakiedit.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">取引先検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.toriKbnDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">取引先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.tori_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"tori_nm\" ng-model=\"vm.form.tori_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先カナ</span> <input type=\"text\" class=\"form-control input-xs\" name=\"tori_km\" ng-model=\"vm.form.tori_km\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><dir-pagination-controls on-page-change=\"vm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"iccEditPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"vm.datasPerPage < vm.totalDatas\" ng-bind=\"vm.pagination.current * vm.datasPerPage - (vm.datasPerPage -1) +\'～\'+vm.pagination.current * vm.datasPerPage+\'件/\'+vm.totalDatas+\'件\'\"></span> <span ng-if=\"vm.datasPerPage > vm.totalDatas\" ng-bind=\"vm.totalDatas+\'件/\'+vm.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">取引先CD</th><th style=\"width:45px\">取引先区分</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">カナ名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in vm.datas | itemsPerPage: vm.datasPerPage\" pagination-id=\"iccEditPaginate\" total-items=\"vm.totalDatas\" current-page=\"vm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.tori_cd }}</td><td>{{ item.tori_kb_nm }}</td><td>{{ item.tori_nm }}</td><td>{{ item.tori_km }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/ivItem/ivitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><caption>検索</caption><thead><tr class=\"active\"><th class=\"title\">メディア</th><th class=\"title\">アイテム名</th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"vm.mediaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ vm.media_nm }} <span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-xs\" name=\"tori_nm\" ng-model=\"vm.form.sg_item_nm\"></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sgItem | filter:{\'media_cd\':vm.form.media_cd} | filter:{\'sg_item_nm\':vm.form.sg_item_nm} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>メディア名:[ {{ item.media_nm }} ]、アイテム名:[ {{ item.sg_item_nm }} ]</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/msgitem/msgitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><thead><tr class=\"active\"><th class=\"title\">作業分類</th><th class=\"title\">部門</th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_bunrui_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bunruiDropdown\" ng-disabled=\"vm.sg_bunrui_cd_selected\" bs-select=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.bumon_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bumonDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sagyoDtl | filter:{\'bumon_cd\':vm.bumon_cd} | filter:{\'sg_bunrui_cd\':vm.sg_bunrui_cd} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item.sg_item_cd, item.sg_item_nm)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/msthojyokamokuitem/msthojyokamoku.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">補助科目検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">補助科目名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"hojo_nm\" ng-model=\"vm.form.hojo_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">科目CD</th><th style=\"width:45px\">補助科目CD</th><th style=\"width:90px\">補助科目名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {kmk_nm:vm.form.hojo_nm} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.hojyo_cd, item.kmk_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.kmk_cd }}</td><td>{{ item.hojyo_cd }}</td><td>{{ item.kmk_nm }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/mstkamokuitem/mstkamokuitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">科目検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">勘定科目名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"kmk_nm\" ng-model=\"vm.form.kmk_nm\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">勘定科目CD</span> <input type=\"text\" class=\"form-control input-xs\" name=\"kmk_nm\" ng-model=\"vm.form.kmk_cd\"></div></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">勘定科目CD</th><th style=\"width:90px\">勘定科目名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {kmk_nm:vm.form.kmk_nm} | filter: {kmk_cd:vm.form.kmk_cd})\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.kmk_cd, item.kmk_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.kmk_cd }}</td><td>{{ item.kmk_nm }}</td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/components/mstsgitem/mstsgitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><thead><tr class=\"active\"><th class=\"title\">作業分類</th><th class=\"title\">部門</th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_bunrui_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bunruiDropdown\" ng-disabled=\"vm.sg_bunrui_cd_selected\" bs-select=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.bumon_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bumonDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sagyoDtl | filter:{\'bumon_cd\':vm.bumon_cd} | filter:{\'sg_bunrui_cd\':vm.sg_bunrui_cd} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item.sg_item_cd, item.sg_item_nm)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/pagination/dirPagination.tpl.html","<ul class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\" ng-cloak=\"\"><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(1)\"><i class=\"glyphicon glyphicon-step-backward\"></i></a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\"><i class=\"glyphicon glyphicon-chevron-left\"></i></a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\"><i class=\"glyphicon glyphicon-chevron-right\"></i></a></li><li ng-if=\"boundaryLinks\" ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.last)\"><i class=\"glyphicon glyphicon-step-forward\"></i></a></li></ul>");
$templateCache.put("app/components/pagination/dtlPagination.tpl.html","<span ng-if=\"1 < pages.length || !autoHide\" ng-cloak=\"\"><span class=\"btn-group\"><span ng-if=\"boundaryLinks\"><button class=\"btn btn-default btn-xs\" ng-click=\"setCurrent(1)\"><<</button></span> <span ng-if=\"directionLinks\" tyle=\"float:left;\"><button class=\"btn btn-default btn-xs\" ng-click=\"setCurrent(pagination.current - 1)\"><</button></span> <span ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\"><button class=\"btn btn-info btn-xs\" ng-click=\"setCurrent(pageNumber)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\">{{ pageNumber }}</button></span> <span ng-if=\"directionLinks\" tyle=\"float:left;\"><button class=\"btn btn-default btn-xs\" ng-click=\"setCurrent(pagination.current + 1)\">></button></span> <span ng-if=\"boundaryLinks\" tyle=\"float:left;\"><button class=\"btn btn-default btn-xs\" ng-click=\"setCurrent(pagination.last)\">>></button></span></span></span>");
$templateCache.put("app/components/pagination/normPagination.tpl.html","<span ng-if=\"1 < pages.length || !autoHide\" ng-cloak=\"\"><span ng-if=\"boundaryLinks\"><button ng-click=\"setCurrent(1)\"><<</button></span> <span ng-if=\"directionLinks\" tyle=\"float:left;\"><button ng-click=\"setCurrent(pagination.current - 1)\"><</button></span> <span ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" tyle=\"float:left;\"><button ng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</button></span> <span ng-if=\"directionLinks\" tyle=\"float:left;\"><button ng-click=\"setCurrent(pagination.current + 1)\">></button></span> <span ng-if=\"boundaryLinks\" tyle=\"float:left;\"><button ng-click=\"setCurrent(pagination.last)\">>></button></span></span>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-default\"><div class=\"container-fluid\"><div class=\"navbar-header\"><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav navbar-left acme-navbar-text\"><li><a ui-sref=\"app.user({\'mode\':settings})\"><i class=\"glyphicon glyphicon-user\"></i> {{vm.user.syain_nm}}</a></li></ul></div><a class=\"navbar-center navbar-brand\" ui-sref=\"app.business\">基幹業務システム</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li><a ui-sref=\"app.user\"><i class=\"glyphicon glyphicon-cog\"></i> 個人設定</a></li><li><a href=\"\" ng-click=\"vm.logout()\">Logout</a></li></ul></div></div></nav>");
$templateCache.put("app/components/pdf/viewer.html","<nav ng-class=\"getNavStyle(scroll)\"><button ng-click=\"goPrevious()\"><</button> <button ng-click=\"goNext()\">></button> <button ng-click=\"zoomIn()\">+</button> <button ng-click=\"fit()\">100%</button> <button ng-click=\"zoomOut()\">-</button> <button ng-click=\"rotate()\">90</button> <span>Page:</span> <input type=\"text\" min=\"1\" ng-model=\"pageNum\"> <span>/ {{pageCount}}</span> &nbsp;&nbsp; <span>Document URL:</span> <input type=\"text\" ng-model=\"pdfUrl\"></nav><hr>{{loading}}<canvas id=\"pdf\" class=\"rotate0\"></canvas>");
$templateCache.put("app/components/sgitem/sgitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><thead><tr class=\"active\"><th class=\"title\">作業形態</th><th class=\"title\">作業分類</th><th class=\"title\">作業パターン</th></tr></thead><tbody class=\"fit\"><tr><td>{{ vm.setSgKeitaiName(vm.sg_keitai_cd) }}</td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_bunrui_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bunruiDropdown\" ng-disabled=\"vm.sg_bunrui_cd_selected\" bs-select=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_ptn_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.ptrnDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sagyoDtl | filter:{\'sg_ptn_cd\':vm.sg_ptn_cd} | filter:{\'sg_bunrui_cd\':vm.sg_bunrui_cd} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item.sg_item_cd, item.sg_item_nm)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/sgitemNoReq/sgitemnoreq.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><thead><tr class=\"active\"><th class=\"title\">作業形態</th><th class=\"title\">作業分類</th><th class=\"title\">作業パターン</th></tr></thead><tbody class=\"fit\"><tr><td>{{ vm.setSgKeitaiName(vm.sg_keitai_cd) }}</td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_bunrui_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bunruiDropdown\" ng-disabled=\"vm.sg_bunrui_cd_selected\" bs-select=\"\"><span class=\"caret\"></span></button></td><td><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_ptn_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.ptrnDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sagyoDtl | filter:{\'sg_ptn_cd\':vm.sg_ptn_cd} | filter:{\'sg_bunrui_cd\':vm.sg_bunrui_cd} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item.sg_item_cd, item.sg_item_nm)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/components/tokucd/tokucd.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">得意先検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.kubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">得意先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.toku_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">得意先名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_nm\" ng-model=\"vm.form.toku_nm\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">得意先カナ</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_km\" ng-model=\"vm.form.toku_km\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">関係部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.bumon_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">担当営業 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.tan_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-xs\" ng-click=\"vm.goSearch()\" style=\"width:150px\">検索</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><dir-pagination-controls on-page-change=\"vm.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"earningsPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-if=\"vm.datasPerPage < vm.totalDatas\" ng-bind=\"vm.pagination.current * vm.datasPerPage - (vm.datasPerPage -1) +\'～\'+vm.pagination.current * vm.datasPerPage+\'件/\'+vm.totalDatas+\'件\'\"></span> <span ng-if=\"vm.datasPerPage > vm.totalDatas\" ng-bind=\"vm.totalDatas+\'件/\'+vm.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">得意先CD</th><th style=\"width:45px\">得意先区分</th><th style=\"width:75px\">関係部門</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">担当営業</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody dir-paginate=\"item in vm.datas | itemsPerPage: vm.datasPerPage\" pagination-id=\"earningsPaginate\" total-items=\"vm.totalDatas\" current-page=\"vm.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setSgItemCd(item.toku_cd, item.toku_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ ($index + 1) + (vm.pagination.current - 1) * vm.datasPerPage }}</td><td style=\"cursor:default;\">{{ item.toku_cd }}</td><td>{{ item.toku_kb_nm }}</td><td>{{ item.bumon_nm }}</td><td>{{ item.toku_nm }}</td><td>{{ item.tan_nm }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/torihikisaki/torihikisaki.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">取引先検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.toriKbnDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">取引先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.tori_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_nm\" ng-model=\"vm.form.tori_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先カナ</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_km\" ng-model=\"vm.form.tori_km\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">取引先CD</th><th style=\"width:45px\">取引先区分</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">カナ名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {tori_kb:vm.form.tori_kb} | filter: {tori_nm:vm.form.tori_nm} | filter: {tori_km:vm.form.tori_km} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.tori_cd, item.tori_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.tori_cd }}</td><td>{{ item.tori_kb_nm }}</td><td>{{ item.tori_nm }}</td><td>{{ item.tori_km }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/torihikisakiedit/torihikisakiedit.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"modal-title\">取引先検索</h5></div></div><div class=\"modal-body modal-fit seikyu-modal\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" bs-dropdown=\"vm.toriKbnDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">取引先区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-xs\" ng-model=\"vm.tori_kb_nm\" style=\"width:150px\" disabled=\"\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先名称</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_nm\" ng-model=\"vm.form.tori_nm\"></div></div></div><div class=\"col-md-6\" disable-all=\"vm.form.allSelect\"><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-xs\">取引先カナ</span> <input type=\"text\" class=\"form-control input-xs\" name=\"toku_km\" ng-model=\"vm.form.tori_km\"></div></div><div class=\"col-xs-12\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"vm.clear()\">クリア</button></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-show=\"vm.datas\"><small ng-if=\"filterd.length > 0\">{{filterd.length}}件</small></div><div class=\"table-responsive item-table\" ng-show=\"vm.datas\" style=\"height:300px;overflow-y: scroll;\"><table class=\"table table-hover table-bordered fit\"><caption>行ダブルクリックで選択</caption><thead><tr class=\"active\"><th style=\"width:20px\">#</th><th style=\"width:45px\">取引先CD</th><th style=\"width:45px\">取引先区分</th><th style=\"width:90px\">得意先名称</th><th style=\"width:60px\">カナ名称</th></tr></thead><tfoot><tr><td colspan=\"11\" class=\"clear\"></td></tr><tr></tr></tfoot><tbody ng-repeat=\"item in filterd =(vm.datas | filter: {tori_kb:vm.form.tori_kb} | filter: {tori_nm:vm.form.tori_nm} | filter: {tori_km:vm.form.tori_km} )\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"vm.setToriCd(item.tori_cd, item.tori_nm)\" style=\"cursor:pointer;\" class=\"fit\"><tr><td class=\"text-center\">{{ $index + 1 }}</td><td>{{ item.tori_cd }}</td><td>{{ item.tori_kb_nm }}</td><td>{{ item.tori_nm }}</td><td>{{ item.tori_km }}</td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/trfItem/trfitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><caption>検索</caption><thead><tr class=\"active\"><th class=\"title\">メディア</th><th class=\"title\">商品名</th></tr></thead><tbody class=\"fit\"><tr><td><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"vm.mediaDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ vm.media_nm }} <span class=\"caret\"></span></button></td><td><input type=\"text\" class=\"form-control input-xs\" name=\"tori_nm\" ng-model=\"vm.form.sg_item_nm\"></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sgItem | filter:{\'media_cd\':vm.form.media_cd} | filter:{\'sg_item_nm\':vm.form.sg_item_nm} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-controll/controll.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"icc.editModeInit(1);\" ng-if=\"!icc.isEditDisabled\">新規登録</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button></div></div><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">仕入日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.form.fromDate\" data-max-date=\"{{icc.form.untilDate}}\" placeholder=\"From\" data-autoclose=\"true\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">仕入日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.form.untilDate\" data-min-date=\"{{icc.form.fromDate}}\" placeholder=\"To\" data-autoclose=\"true\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">仕入No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.form.sr_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">仕入No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.form.sr_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">取引先</span><icc-torihikisaki ng-model=\"icc.form.tori_cd\"></icc-torihikisaki><span class=\"input-group-btn\" style=\"width:0px;\"></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.tori_nm\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"icc.srBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">仕入部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.sr_bmn_nm\" disabled=\"\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"icc.zaikoBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">在庫部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.zaiko_bmn_nm\" disabled=\"\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"icc.srDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">仕入区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.sr_kb_nm\" disabled=\"\"></div></div></div><div class=\"col-md-7\"><div class=\"col-md-12 form-group pull-left\"></div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"icc.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"icc.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\"><dir-pagination-controls on-page-change=\"icc.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"iccPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"icc.pagination.current * icc.datasPerPage - (icc.datasPerPage -1) +\'～\'+((icc.pagination.current * icc.datasPerPage - icc.datasPerPage) + icc.datas.length) +\'件/\'+icc.totalDatas+\'件\'\"></span> <span class=\"goukei-label\">&nbsp;&nbsp;&nbsp;合計&nbsp;&nbsp;{{ icc.totalKin | number}}円</span></div><div class=\"table-responsive item-table\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:15px\">#</th><th rowspan=\"2\" style=\"width:80px\">仕入日</th><th>仕入No.</th><th colspan=\"2\">取引先</th><th>支払予定日</th><th rowspan=\"2\">入金金額</th></tr><tr class=\"active\"><th>仕入区分</th><th>在庫部門</th><th>仕入部門</th><th>仕入担当</th></tr></thead><tbody dir-paginate=\"item in icc.datas | itemsPerPage: icc.datasPerPage\" pagination-id=\"iccPaginate\" total-items=\"icc.totalDatas\" current-page=\"icc.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"icc.editModeInit(2, item)\" style=\"cursor:pointer;\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (icc.pagination.current - 1) * icc.datasPerPage }}</td><td rowspan=\"2\">{{ item.sr_day_time * 1000 | date }}</td><td>{{ item.sr_no }}</td><td colspan=\"2\">{{ item.tori_cd }}&nbsp;:&nbsp;{{ item.tori_nm }}</td><td>{{ item.yotei_day_time * 1000 | date }}</td><td rowspan=\"2\" class=\"text-right\">{{ item.kei_kn | number }}</td></tr><tr><td>{{ item.sr_kb_nm }}</td><td>{{ item.zaiko_bmn_nm }}</td><td>{{ item.sr_bmn_nm }}</td><td>{{ item.sr_tan_nm }}</td></tr></tbody></table></div>");
$templateCache.put("app/inventory/inventory-controll/controlledit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\" ng-if=\"icc.editScope.editMode == 1\">仕入新規登録</h4><h4 class=\"modal-title text-center\" ng-if=\"icc.editScope.editMode == 2\">仕入編集</h4></div><div class=\"col-xs-5 text-right\" ng-if=\"icc.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"icc.editScope.cancel(1)\">クリア</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"icc.editScope.formSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"icc.editForm.detail.length == 0 || !siireForm.$valid || icc.isFromDetailError\">登録</button></div><div class=\"col-xs-5 text-right\" ng-if=\"icc.editScope.editMode == 2\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"icc.editScope.formSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"icc.isFromDisabled || ordersForm.$invalid || icc.isEditDisabled || icc.editForm.detail.length == 0 || !siireForm.$valid || icc.isFromDetailError\">変更</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"icc.editScope.formSubmit(\'DELETE\')\" style=\"width:80px\" ng-disabled=\"icc.isFromDisabled || icc.isEditDisabled\">削除</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit modal-overFlow-non\" disable-all=\"icc.isFromDisabled || icc.isEditDisabled\"><form role=\"form\" name=\"siireForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-10\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:65px\" class=\"title text-center\">仕入No.</td><td style=\"width:65px\">{{ icc.editForm.sr_no }}</td><td style=\"width:65px\" class=\"title text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"icc.editScope.srDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" required=\"\">仕入区分 <span class=\"caret\"></span></button></span></div></td><td style=\"width:65px\">{{ icc.editForm.sr_kb_nm }}</td><td style=\"width:65px\" class=\"title text-center\">仕入日</td><td style=\"width:115px\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.editForm.sr_day\" name=\"ss_day\" data-min-date=\"{{icc.editScope.min_day}}\" bs-datepicker=\"\" placeholder=\"年月日\" required=\"\"></div></td><td style=\"width:65px\" class=\"title text-center\">取引先</td><td style=\"width:200px\"><icc-torihikisaki-edit ng-model=\"icc.editForm.tori_cd\"></icc-torihikisaki-edit></td></tr></tbody></table></div><div class=\"col-xs-2\">&emsp;</div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-7\"><table class=\"table table-hover table-bordered\"><tbody><tr style=\"height:60px\"><td colspan=\"2\">{{ icc.editForm.tori_nm}}<br><span ng-if=\"icc.editForm.tori_busyo\">{{ icc.editForm.tori_busyo}}&emsp;</span></td></tr><tr style=\"height:60px\"><td colspan=\"2\"><span ng-if=\"icc.editForm.yubin_no\">〒{{ icc.editForm.yubin_no}}<br></span> {{ icc.editForm.adrs1}}<br>{{ icc.editForm.adrs2}}</td></tr><tr style=\"height:30px\"><td style=\"border-right-style:none;\">TEL: {{ icc.editForm.tel_no}}</td><td style=\"border-left-style:none;\">FAX: {{ icc.editForm.fax_no}}</td></tr></tbody></table><div class=\"input-group\"><span class=\"input-group-addon input-xs\">仕入先担当者</span> <input type=\"text\" name=\"tori_tan_nm\" class=\"form-control input-xs\" ng-model=\"icc.editForm.tori_tan_nm\"></div></div><div class=\"col-xs-5\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:65px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"icc.editScope.srBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">仕入部門 <span class=\"caret\"></span></button></span></div></td><td style=\"width:200px\" class=\"title text-center\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.editForm.sr_bmn_nm\" disabled=\"\" required=\"\"></td></tr><tr><td style=\"width:65px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"icc.editScope.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">仕入担当 <span class=\"caret\"></span></button></span></div></td><td style=\"width:200px\" class=\"title text-center\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.editForm.sr_tan_nm\" placeholder=\"先に仕入部門を選択\" disabled=\"\" required=\"\"></td></tr><tr><td style=\"width:65px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"icc.editScope.zaikoBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">在庫部門 <span class=\"caret\"></span></button></span></div></td><td style=\"width:200px\" class=\"title text-center\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.editForm.zaiko_bmn_nm\" disabled=\"\" required=\"\"></td></tr><tr><td style=\"width:65px\" class=\"title text-center\">摘要</td><td style=\"width:200px\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.editForm.tekiyo\"></td></tr><tr><td style=\"width:65px\" class=\"title text-center\">支払予定日</td><td style=\"width:200px\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"icc.editForm.yotei_day\" name=\"yotei_day\" bs-datepicker=\"\" placeholder=\"年月日\"></div></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12\"><span style=\"color:red;font-size:70%\">※数量・単価の記入があるもののみ登録されます</span></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"modal-inner-block\"><div ng-include=\"\'app/inventory/inventory-controll/editmode.html\'\"></div></div></div><div class=\"col-xs-12\"><table class=\"table table-bordered table-striped fit table-custom1\"><tr><td class=\"text-left\" style=\"width:48%\"><span>区&emsp;（１：税抜、&emsp;２：税込、&emsp;３：非課税、&emsp;７：値引、&emsp;９：消費税）</span></td><td class=\"text-center\" style=\"width:12%\"><span>合計</span></td><td class=\"text-right\" style=\"width:15%\"><span>{{ icc.editScope.goukei_kin | number}}</span></td><td class=\"text-right\"></td></tr></table></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-8\"><span ng-if=\"icc.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide()\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-controll/editmode.html","<div disable-all=\"icc.isFromDisabled || icc.isEditDisabled\" class=\"table-scroll-area\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead class=\"fit\" fix-head=\"\"><tr class=\"active\"><th style=\"width:5%\">No.</th><th style=\"width:5%\">区</th><th style=\"width:30%\">商品名</th><th style=\"width:10%\">数量</th><th style=\"width:5%\">単位</th><th style=\"width:10%\">単価</th><th style=\"width:10%\">金額</th><th>備考</th><th style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"icc.editScope.tableExtend()\" ng-disabled=\"icc.isFromDisabled\">行追加</button></th></tr></thead><tbody ng-if=\"icc.editForm.detail.length == 0\"><tr><td colspan=\"8\"><div style=\"height:245px\">&emsp;</div></td></tr><tr></tr></tbody><tbody ng-repeat=\"( key, item ) in icc.editForm.detail\" class=\"fit\" disable-all=\"icc.isFromDisabled || icc.isEditDisabled\"><tr><td rowspan=\"2\" class=\"text-center\">{{ item.gyo_no }} <input type=\"hidden\" ng-model=\"item.gyo_no\" ng-init=\"item.gyo_no = $index+1\"></td><td class=\"bd-bottom-none\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.mei_kb\" ng-change=\"icc.editScope.changeMeiKb(key)\" numeric-only=\"\"></td><td class=\"bd-bottom-none\"><span ng-if=\"item.mei_kb != 9 && item.mei_kb != 7\"><icc-item ng-model=\"item.hin_cd\"></icc-item></span></td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\"><span ng-if=\"item.mei_kb == 1 || item.mei_kb == 2 || item.mei_kb == 3\">{{ icc.editScope.setMeiKbName(item.mei_kb) }}<span item.mei_kb=\"\" !=\'3\"\'>&emsp;&emsp;課</span></span></td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"icc.editScope.tableCellDelete($index)\" ng-disabled=\"icc.isFromDisabled || icc.isEditDisabled\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"icc.editScope.tableRowCopy($index)\" ng-disabled=\"icc.isFromDisabled || icc.isEditDisabled\">行複写</button></td></tr><tr><td class=\"bd-top-none\"><span ng-if=\"item.error\" class=\"text-danger\">Error</span> <span ng-if=\"!item.error\">&emsp;</span></td><td class=\"bd-top-none\">{{ item.hin_nm }}</td><td class=\"bd-top-none\"><span ng-if=\"item.mei_kb != 9 && item.mei_kb != 7\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.suryo\" model-format=\"number\" numeric-only=\"\"></span></td><td class=\"bd-top-none\"><span ng-if=\"item.mei_kb != 9 && item.mei_kb != 7\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.tani\" disabled=\"\"></span></td><td class=\"bd-top-none\"><span ng-if=\"item.mei_kb != 9 && item.mei_kb != 7\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.tanka\" model-format=\"number\" numeric-only=\"\"></span> <span ng-if=\"item.mei_kb == 9\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"icc.getZeinukiItemZei(key)\" ng-disabled=\"icc.isFromDisabled || icc.isEditDisabled\">税計算</button></span></td><td class=\"bd-top-none\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.total_kn\" model-format=\"number\" numeric-only=\"\"></td><td class=\"bd-top-none\"><span ng-if=\"item.mei_kb == 2\">&emsp;&emsp;&emsp;&emsp;{{ item.zei_kn }}</span></td></tr></tbody></table></div>");
$templateCache.put("app/inventory/inventory-issue/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivis.form.fromDate\" data-max-date=\"{{ivis.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivis.form.untilDate\" data-min-date=\"{{ivis.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>部門選択<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-click=\"ivis.bumonListCheck()\"> <span ng-if=\"ivis.bumonListCheckAll==\'1\'\">すべてはずす</span> <span ng-if=\"ivis.bumonListCheckAll==\'0\'\">すべてチェック</span></label></p><span ng-repeat=\"(key, item) in ivis.bumonList\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"item.checked\" ng-true-value=\"1\" ng-false-value=\"0\">{{item.bumon_nm}}</label></span></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>作業項目(商品)選択<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"ivis.mediaListCheckAll\" ng-true-value=\"1\" ng-false-value=\"0\" ng-click=\"ivis.mediaListCheck()\">すべて</label></p><span ng-if=\"!ivis.mediaListCheckAll\"><iv-item cont-name=\"ivis\" ng-model=\"ivis.sg_item\"></iv-item></span></div></div><div class=\"form-group col-xs-12\"><span ng-if=\"ivis.form.sgItem.length > 0\">選択したアイテム(追加可)</span><ul class=\"list-inline\"><li ng-repeat=\"(key, item) in ivis.form.sgItem\"><span ng-if=\"$first\">{{item}}</span> <span ng-if=\"!$first\">, {{item}}</span></li></ul></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><p class=\"text-danger\" ng-if=\"ivis.formError\">部門、項目はそれぞれひとつ以上選択してください</p><p class=\"text-danger\" ng-if=\"ivis.formDateError\">対象期間Fromは必ずセットしてください</p></div><div class=\"col-xs-5\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"ivis.generateInventoryIssue()\">帳票生成</button></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"ivis.error\">{{ ivis.error }}</div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-sgitem/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivi.form.fromDate\" data-max-date=\"{{ivi.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivi.form.untilDate\" data-min-date=\"{{ivi.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>期間中動きの無いもの<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"ivi.form.sgswitch\" ng-true-value=\"2\" ng-false-value=\"1\"></label></p></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>作業項目(商品)選択<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"ivi.mediaListCheckAll\" ng-true-value=\"1\" ng-false-value=\"0\" ng-click=\"ivi.mediaListCheck()\">すべて</label></p><span ng-if=\"!ivi.mediaListCheckAll\"><iv-item cont-name=\"ivi\" ng-model=\"ivi.sg_item\"></iv-item></span></div></div><div class=\"form-group col-xs-12\"><span ng-if=\"ivi.form.sgItem.length > 0\">選択したアイテム(追加可)</span><ul class=\"list-inline\"><li ng-repeat=\"(key, item) in ivi.form.sgItem\"><span ng-if=\"$first\">{{item}}</span> <span ng-if=\"!$first\">, {{item}}</span></li></ul></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><p class=\"text-danger\" ng-if=\"ivi.formError\">部門、項目はそれぞれひとつ以上選択してください</p><p class=\"text-danger\" ng-if=\"ivi.formDateError\">対象期間Fromは必ずセットしてください</p></div><div class=\"col-xs-5\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"ivi.generateInventoryStudio()\">帳票生成</button></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"ivi.error\">{{ ivi.error }}</div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-list/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><p class=\"text-danger\" style=\"font-size:80%\">※最大1ヶ月の範囲で指定してください</p><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivl.form.fromDate\" data-max-date=\"{{ivl.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivl.form.untilDate\" data-min-date=\"{{ivl.form.fromDate}}\" data-max-date=\"{{ivl.maxDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>部門選択</p><span ng-repeat=\"(key, item) in ivl.bumonList\"><label class=\"radio-inline\"><input type=\"radio\" ng-model=\"ivl.form.bumon_cd\" value=\"{{item.bumon_cd}}\">{{item.bumon_nm}}</label></span></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>作業項目(商品)選択<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"ivl.mediaListCheckAll\" ng-true-value=\"1\" ng-false-value=\"0\" ng-click=\"ivl.mediaListCheck()\">すべて</label></p><span ng-if=\"!ivl.mediaListCheckAll\"><iv-item cont-name=\"ivl\" ng-model=\"ivl.sg_item\"></iv-item></span></div></div><div class=\"form-group col-xs-12\"><span ng-if=\"ivl.form.sgItem.length > 0\">選択したアイテム(追加可)</span><ul class=\"list-inline\"><li ng-repeat=\"(key, item) in ivl.form.sgItem\"><span ng-if=\"$first\">{{item}}</span> <span ng-if=\"!$first\">, {{item}}</span></li></ul></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><p class=\"text-danger\" ng-if=\"ivl.formError\">部門、メディアはそれぞれひとつ以上選択してください</p><p class=\"text-danger\" ng-if=\"ivl.formDateError\">対象期間Fromは必ずセットしてください</p></div><div class=\"col-xs-5\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"ivl.generateInventoryList()\">帳票生成</button></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"ivl.error\">{{ ivl.error }}</div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-studio/main.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"true\"><div class=\"panel panel-default\"><div class=\"panel-body\" 　=\"\"><div class=\"row\"><div class=\"col-xs-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivs.form.fromDate\" data-max-date=\"{{ivs.form.untilDate}}\" placeholder=\"From\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\"><small>対象期間</small></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"ivs.form.untilDate\" data-min-date=\"{{ivs.form.fromDate}}\" placeholder=\"To\" name=\"untilDate\" bs-datepicker=\"\"></div></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>部門選択<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-click=\"ivs.bumonListCheck()\"> <span ng-if=\"ivs.bumonListCheckAll==\'1\'\">すべてはずす</span> <span ng-if=\"ivs.bumonListCheckAll==\'0\'\">すべてチェック</span></label></p><span ng-repeat=\"(key, item) in ivs.bumonList\"><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"item.checked\" ng-true-value=\"1\" ng-false-value=\"0\">{{item.bumon_nm}}</label></span></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><p>作業項目(商品)選択<br><label class=\"checkbox-inline\"><input type=\"checkbox\" ng-model=\"ivs.mediaListCheckAll\" ng-true-value=\"1\" ng-false-value=\"0\" ng-click=\"ivs.mediaListCheck()\">すべて</label></p><span ng-if=\"!ivs.mediaListCheckAll\"><iv-item cont-name=\"ivs\" ng-model=\"ivs.sg_item\"></iv-item></span></div></div><div class=\"form-group col-xs-12\"><span ng-if=\"ivs.form.sgItem.length > 0\">選択したアイテム(追加可)</span><ul class=\"list-inline\"><li ng-repeat=\"(key, item) in ivs.form.sgItem\"><span ng-if=\"$first\">{{item}}</span> <span ng-if=\"!$first\">, {{item}}</span></li></ul></div><div class=\"col-xs-12\"><div class=\"col-xs-6\"><p class=\"text-danger\" ng-if=\"ivs.formError\">部門、項目はそれぞれひとつ以上選択してください</p><p class=\"text-danger\" ng-if=\"ivs.formDateError\">対象期間Fromは必ずセットしてください</p></div><div class=\"col-xs-5\"><button class=\"btn btn-success btn-sm pull-right\" ng-click=\"ivs.generateInventoryStudio()\">帳票生成</button></div><div class=\"col-xs-1\"></div></div><div class=\"col-xs-12\" ng-if=\"ivs.error\">{{ ivs.error }}</div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-transfer/editmode.html","<div disable-all=\"trf.isFromDisabled || trf.isEditDisabled\" class=\"table-scroll-area\"><table class=\"table table-bordered table-striped fit table-custom1\"><thead class=\"fit\" fix-head=\"\"><tr class=\"active\"><th style=\"width:5%\">No.</th><th style=\"width:5%\">区</th><th style=\"width:15%\" class=\"border-right-none\">商品名</th><th style=\"width:15%\" class=\"border-left-none\">在庫部門</th><th style=\"width:10%\">数量</th><th style=\"width:5%\">単位</th><th style=\"width:10%\">単価</th><th style=\"width:10%\">金額</th><th style=\"width:5%\"><button type=\"button\" class=\"btn btn-info btn-fit\" ng-click=\"trf.editScope.tableExtend()\" ng-disabled=\"trf.isFromDisabled\">行追加</button></th></tr></thead><tbody ng-if=\"trf.editForm.detail.length == 0\"><tr><td colspan=\"8\"><div style=\"height:245px\">&emsp;</div></td></tr><tr></tr></tbody><tbody ng-repeat=\"( key, item ) in trf.editForm.detail\" class=\"fit\" disable-all=\"trf.isFromDisabled || trf.isEditDisabled\"><tr><td rowspan=\"2\" class=\"text-center\">{{ item.gyo_no }} <input type=\"hidden\" ng-model=\"item.gyo_no\" ng-init=\"item.gyo_no = $index+1\"></td><td class=\"bd-bottom-none\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.mei_kb\" numeric-only=\"\"></td><td class=\"bd-bottom-none\"><trf-item ng-model=\"item.hin_cd\"></trf-item></td><td class=\"bd-bottom-none\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"trf.editScope.frItemBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">{{ item.bumon_nm }} <span class=\"caret\"></span></button></span></div></td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\">&emsp;</td><td class=\"bd-bottom-none\">&emsp;</td><td rowspan=\"2\" class=\"icon-area\"><button type=\"button\" class=\"btn btn-select btn-sm\" ng-click=\"trf.editScope.tableCellDelete($index)\" ng-disabled=\"trf.isFromDisabled || trf.isEditDisabled\">行削除</button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"trf.editScope.tableRowCopy($index)\" ng-disabled=\"trf.isFromDisabled || trf.isEditDisabled\">行複写</button></td></tr><tr><td class=\"bd-top-none\"><span ng-if=\"item.error\" class=\"text-danger\">Error</span> <span ng-if=\"!item.error\">&emsp;</span></td><td class=\"bd-top-none\" colspan=\"2\">{{ item.hin_nm }}</td><td class=\"bd-top-none\"><input type=\"text\" class=\"form-control input-sm\" style=\"text-align: right\" ng-model=\"item.suryo\" model-format=\"number\" numeric-only=\"\"></td><td class=\"bd-top-none\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"item.tani\" disabled=\"\"></td><td class=\"bd-top-none text-right\"><input type=\"text\" class=\"form-control input-sm\" style=\"text-align: right\" ng-model=\"item.tanka\" model-format=\"number\" ng-disabled=\"trf.editForm.den_kb ==\'1\'\" numeric-only=\"\"></td><td class=\"bd-top-none text-right\"><input type=\"text\" class=\"form-control input-sm\" style=\"text-align: right\" ng-model=\"item.total_kn\" model-format=\"number\" ng-disabled=\"trf.editForm.den_kb ==\'1\'\" numeric-only=\"\"></td></tr></tbody></table></div>");
$templateCache.put("app/inventory/inventory-transfer/transfer.html","<div ncy-breadcrumb=\"\"></div><div bs-collapse=\"\" start-collapsed=\"false\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-info btn-xs\" ng-click=\"trf.editModeInit(1);\" ng-if=\"!trf.isEditDisabled\">新規登録</button> <button type=\"button\" class=\"btn btn-warning btn-xs\" bs-collapse-toggle=\"\">検索</button></div></div><div class=\"panel panel-default\" bs-collapse-target=\"\"><div class=\"panel-body\"><form role=\"form\" name=\"ordersForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">振替日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.form.fromDate\" data-max-date=\"{{trf.form.untilDate}}\" placeholder=\"From\" data-autoclose=\"true\" name=\"fromDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">振替日</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.form.untilDate\" data-min-date=\"{{trf.form.fromDate}}\" placeholder=\"To\" data-autoclose=\"true\" name=\"untilDate\" bs-datepicker=\"\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">振替No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.form.ido_noFrom\" placeholder=\"From\"></div></div><div class=\"form-group col-xs-6\"><div class=\"input-group\"><span class=\"input-group-addon input-sm\">振替No.</span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.form.ido_noTo\" placeholder=\"To\"></div></div><div class=\"form-group col-xs-12\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"trf.denKubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">伝票区分 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.den_kb_nm\" disabled=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"trf.frBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">振替部門 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.bmn_nm\" disabled=\"\"></div></div><div class=\"form-group\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"trf.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">振替担当 <span class=\"caret\"></span></button></span> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.tan_nm\" disabled=\"\"></div></div></div><div class=\"col-md-7\"><div class=\"col-md-12 form-group pull-left\"></div></div><div class=\"col-md-5\"><div class=\"form-group pull-right\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"trf.clear()\">クリア</button> <button type=\"button\" class=\"btn btn-success btn-sm\" ng-click=\"trf.goSearch()\" style=\"width:150px\">検索</button></div></div></div></form></div></div></div><hr><div class=\"text-center\"><dir-pagination-controls on-page-change=\"trf.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/dirPagination.tpl.html\" pagination-id=\"iccPaginate\"></dir-pagination-controls></div><div class=\"text-center\"><span ng-bind=\"trf.pagination.current * trf.datasPerPage - (trf.datasPerPage -1) +\'～\'+((trf.pagination.current * trf.datasPerPage - trf.datasPerPage) + trf.datas.length) +\'件/\'+trf.totalDatas+\'件\'\"></span></div><div class=\"table-responsive item-table\"><table class=\"table table-hover table-bordered\"><caption>行ダブルクリックで編集画面が開きます</caption><thead><tr class=\"active\"><th rowspan=\"2\" style=\"width:15px\">#</th><th rowspan=\"2\" style=\"width:80px\">振替日</th><th rowspan=\"2\" style=\"width:50px\">伝区</th><th>振替No.</th><th style=\"width:35%\">振替部門</th><th style=\"width:30%\">振替担当</th></tr><tr class=\"active\"><th colspan=\"3\">摘要</th></tr></thead><tbody dir-paginate=\"item in trf.datas | itemsPerPage: trf.datasPerPage\" pagination-id=\"iccPaginate\" total-items=\"trf.totalDatas\" current-page=\"trf.pagination.current\" ng-class-odd=\"\'odd\'\" ng-class-even=\"\'even\'\" ng-cloak=\"\" ng-dblclick=\"trf.editModeInit(2, item)\" style=\"cursor:pointer;\"><tr><td rowspan=\"2\" class=\"text-center\">{{ ($index + 1) + (trf.pagination.current - 1) * trf.datasPerPage }}</td><td rowspan=\"2\">{{ item.ido_day_time * 1000 | date }}</td><td rowspan=\"2\">{{ item.den_kb_nm }}</td><td>{{ item.ido_no }}</td><td>{{ item.bmn_nm }}</td><td>{{ item.tan_nm }}</td></tr><tr><td colspan=\"3\">{{ item.tekiyo }}</td></tr></tbody></table></div>");
$templateCache.put("app/inventory/inventory-transfer/transferedit.html","<div class=\"modal modal-wide\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><div class=\"row\"><div class=\"col-xs-6\"><h4 class=\"modal-title text-center\" ng-if=\"trf.editScope.editMode == 1\">振替新規登録</h4><h4 class=\"modal-title text-center\" ng-if=\"trf.editScope.editMode == 2\">振替編集</h4></div><div class=\"col-xs-5 text-right\" ng-if=\"trf.editScope.editMode == 1\"><button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"trf.editScope.cancel(1)\">クリア</button> <button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"trf.editScope.formSubmit(\'POST\')\" style=\"width:150px\" ng-disabled=\"trf.editForm.detail.length == 0 || !siireForm.$valid || trf.isFromDetailError\">登録</button></div><div class=\"col-xs-5 text-right\" ng-if=\"trf.editScope.editMode == 2\"><button type=\"button\" class=\"btn btn-warning btn-sm\" ng-click=\"trf.editScope.formSubmit(\'PUT\')\" style=\"width:150px\" ng-disabled=\"trf.isFromDisabled || ordersForm.$invalid || trf.isEditDisabled || trf.editForm.detail.length == 0 || !siireForm.$valid || trf.isFromDetailError\">変更</button> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"trf.editScope.formSubmit(\'DELETE\')\" style=\"width:80px\" ng-disabled=\"trf.isFromDisabled || trf.isEditDisabled\">削除</button></div><div class=\"col-xs-1\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$hide()\"><span aria-hidden=\"true\">&times;</span></button></div></div></div><div class=\"modal-body modal-fit modal-overFlow-non\" disable-all=\"trf.isFromDisabled || trf.isEditDisabled\"><form role=\"form\" name=\"siireForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-5\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:70px\" class=\"title text-center\">振替No.</td><td style=\"width:65px\" class=\"text-right\">{{ trf.editForm.ido_no }}</td><td style=\"width:70px\" class=\"title text-center\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"trf.editScope.denKubunDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" required=\"\">伝票区分 <span class=\"caret\"></span></button></span></div></td><td style=\"width:65px\">{{ trf.editForm.den_kb_nm }}</td><td style=\"width:70px\" class=\"title text-center\">振替日</td><td style=\"width:90px\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.editForm.ido_day\" name=\"ss_day\" data-min-date=\"{{trf.editScope.min_day}}\" bs-datepicker=\"\" placeholder=\"年月日\" required=\"\"></div></td></tr></tbody></table></div><div class=\"col-xs-7\">&emsp;</div><div class=\"col-xs-12\">&emsp;</div><div class=\"col-xs-6\"><table class=\"table table-bordered fit selected-table\"><tbody class=\"fit\"><tr><td style=\"width:65px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"trf.editScope.frBumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">振替部門 <span class=\"caret\"></span></button></span></div></td><td style=\"width:200px\" class=\"title text-center\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.editForm.bmn_nm\" disabled=\"\" required=\"\"></td></tr><tr><td style=\"width:65px\"><div class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-select btn-sm dropdown-toggle\" bs-dropdown=\"trf.editScope.eigyoDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">振替担当 <span class=\"caret\"></span></button></span></div></td><td style=\"width:200px\" class=\"title text-center\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.editForm.tan_nm\" placeholder=\"先に仕入部門を選択\" disabled=\"\" required=\"\"></td></tr></tbody></table></div><div class=\"col-xs-6\"><table class=\"table table-bordered fit selected-table border-none\"><tbody class=\"fit\"><tr class=\"border-none\"><td class=\"border-none\">&emsp;</td><td class=\"border-none\"></td></tr><tr><td style=\"width:65px\" class=\"title text-center\">摘要</td><td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"trf.editForm.tekiyo\"></td></tr></tbody></table></div></div><div class=\"row\"><div class=\"col-xs-12\">&emsp;</div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"modal-inner-block\"><div ng-include=\"\'app/inventory/inventory-transfer/editmode.html\'\"></div></div></div><div class=\"col-xs-12\"><table class=\"table table-bordered table-striped fit table-custom1\"><tr><td class=\"text-left\"><span ng-if=\"trf.editForm.den_kb == \'1\'\">区&emsp;（１：社員販売、&emsp;２：社内利用、&emsp;３：破棄、&emsp;４：移動出庫、&emsp;５：移動入庫）</span> <span ng-if=\"trf.editForm.den_kb == \'2\'\">区&emsp;（６：棚出庫、&emsp;７：棚入庫、&emsp;８：調整出庫、&emsp;９：調整入庫）</span></td></tr></table></div></div></form></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-8\"><span ng-if=\"trf.isEditDisabled\" class=\"text-danger pull-left\">※閲覧のみ許可されたユーザです</span></div><div class=\"col-xs-4\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$hide()\">キャンセル</button></div></div></div></div></div></div>");
$templateCache.put("app/monthly-action/mprint/detail.html","<div class=\"col-xs-12 check-print-page\" ng-repeat=\"( i, dtlItems ) in item.data\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">月次チェックリスト</p></div><div class=\"col-xs-3 text-right yt-page\" style=\"font-size:90%\"><span>PAGE <span ng-bind=\"mp.getInnerPageCnt(key,i) + \'/\' + mp.pageLength\"></span><br>{{ mp.now*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><br><div><table class=\"table-checklist\" ng-if=\"item.type == \'sgHkcheck\' || item.type == \'sgUrCheck\'\"><thead><tr><th class=\"title-head\">&emsp;</th><th class=\"title-head\">作業伝票No.</th><th class=\"title-head\">受注伝票No.</th><th class=\"title-body\">内容</th></tr></thead><tbody ng-repeat=\"itm in dtlItems\"><tr><td class=\"td-left\"><span ng-if=\"$first\">{{ item.name }}</span></td><td class=\"td-middle\">{{itm.sg_no}}</td><td class=\"td-middle\">{{itm.ju_no}}</td><td class=\"td-right\">承認が行われていません</td></tr></tbody></table><table class=\"table-checklist\" ng-if=\"item.type == \'khCheck\'\"><thead><tr><th class=\"title-head\">&emsp;</th><th class=\"title-head\">経費伝票No.</th><th class=\"title-head\">作業伝票No.</th><th class=\"title-body\">内容</th></tr></thead><tbody ng-repeat=\"itm in dtlItems\"><tr><td class=\"td-left\"><span ng-if=\"$first\">{{ item.name }}</span></td><td class=\"td-middle\">{{itm.kh_no}}</td><td class=\"td-middle\">{{itm.sg_no}}</td><td class=\"td-right\">承認が行われていません</td></tr></tbody></table><table class=\"table-checklist\" ng-if=\"item.type == \'uriageCntCheck\'\"><thead><tr><th class=\"title-head\">&emsp;</th><th class=\"title-head\">納品伝票No.</th><th class=\"title-head\">作業伝票No.</th><th class=\"title-body\">内容</th></tr></thead><tbody ng-repeat=\"itm in dtlItems\"><tr><td class=\"td-left\"><span ng-if=\"$first\">{{ item.name }}</span></td><td class=\"td-middle\">{{itm.nh_no}}</td><td class=\"td-middle\">{{itm.ju_no}}</td><td class=\"td-right\">同じ受注Noで複数売上の承認が行われていません</td></tr></tbody></table><table class=\"table-checklist\" ng-if=\"item.type == \'sgUrCntCheck\'\"><thead><tr><th class=\"title-head\">&emsp;</th><th class=\"title-head\">作業伝票No.</th><th class=\"title-head\">受注伝票No.</th><th class=\"title-body\">内容</th></tr></thead><tbody ng-repeat=\"itm in dtlItems\"><tr><td class=\"td-left\"><span ng-if=\"$first\">{{ item.name }}</span></td><td class=\"td-middle\">{{itm.sg_no}}</td><td class=\"td-middle\">{{itm.ju_no}}</td><td class=\"td-right\">同じ受注Noで複数作業売上の承認が行われていません</td></tr></tbody></table><table class=\"table-checklist\" ng-if=\"item.type == \'uriageCheck\'\"><thead><tr><th class=\"title-head\">&emsp;</th><th class=\"title-head\">納品伝票No.</th><th class=\"title-head\">作業伝票No.</th><th class=\"title-body\">内容</th></tr></thead><tbody ng-repeat=\"itm in dtlItems\"><tr><td class=\"td-left\"><span ng-if=\"$first\">{{ item.name }}</span></td><td class=\"td-middle\">{{itm.nh_no}}</td><td class=\"td-middle\">{{itm.ju_no}}</td><td class=\"td-right\">承認が行われていません</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/monthly-action/mprint/print.html","<style type=\"text/css\">\n@media print {\n    @page {\n        size: A4 landscape;\n        margin: 0;\n    }\n}\n</style><nav><button ng-print=\"\" print-element-id=\"check-print-area\"><i class=\"fa fa-mp\"></i> 印刷</button></nav><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span></div><hr><div class=\"row check-virtical-preview-area\"><article id=\"check-print-area\"><section class=\"col-xs-12\"><div ng-repeat=\"(key, item) in mp.printData\"><div><div ng-include=\"\'app/monthly-action/mprint/detail.html\'\"></div></div></div></section></article></div>");
$templateCache.put("app/mklist/print/mklist1.html","<div class=\"col-xs-12 mklist-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">未回収一覧</p><p class=\"text-center title-kikan\">({{mklistpr.to*1000|date:\'yyyy年M月dd日\'}} 現在)</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(mklistpr.pagination.current * mklistpr.datasPerPage - (mklistpr.datasPerPage -1))+$index +\'/\'+ mklistpr.totalCount\"></span><br>{{ mklistpr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-6\"><div class=\"mklist-left-table\"><table><tr><td style=\"width:20%\">部門名</td><td style=\"width:20%\">{{ detail[0].bumon_cd }}【{{ detail[0].bumon_nm }}】</td></tr></table></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"mklist-print-table\"><table><thead><tr><th class=\"text-center\">得意先名</th><th class=\"text-center\">作品名</th><th class=\"text-center\">顧客担当</th><th class=\"text-center\">受注No.</th><th class=\"text-center\">請求No.</th><th class=\"text-center\">請求年月日</th><th class=\"text-center\">予定年月日</th><th class=\"text-center\">請求額</th><th class=\"text-center\">未入金額</th><th class=\"text-center\">担当者</th></tr></thead><tbody ng-repeat=\"(key, item) in detail\"><tr><td><span ng-if=\"item.toku_cd != detail[$index - 1].toku_cd\">{{ item.toku_cd }} {{ item.toku_nm }}</span></td><td><span class=\"mklist-hinnm\">{{ item.sakuhin_nm }}</span></td><td><span>{{ item.toku_tanto }}</span></td><td><span>{{ item.ju_no }}</span></td><td><span>{{ item.sk_no }}</span></td><td><span>{{ item.sk_day_time*1000|date:\'yy/MM/dd\' }}</span></td><td><span>{{ item.nk_yt_day_time*1000|date:\'yy/MM/dd\' }}</span></td><td class=\"text-right\"><span>{{ item.ur_kin | number }}</span></td><td class=\"text-right\"><span ng-if=\"item.nk_kin\">{{ item.ur_kin - item.nk_kin | number }}</span> <span ng-if=\"!item.nk_kin\">{{ item.ur_kin | number}}</span></td><td><span>{{ item.tan_nm }}</span></td></tr><tr ng-if=\"$last && $parent.$last && ( mklistpr.pagination.current * mklistpr.datasPerPage - (mklistpr.datasPerPage -1))+dtIndex == mklistpr.totalCount\" class=\"tr-border\"><td></td><td class=\"text-left\">部 門 合 計</td><td></td><td></td><td></td><td></td><td></td><td class=\"text-right\"><span>{{ mklistpr.setBmnSkKei() | number }}</span></td><td class=\"text-right\"><span>{{ mklistpr.setBmnMiKei() | number }}</span></td><td></td></tr><tr ng-if=\"mklistpr.checkLastBmn(detail[0].bumon_cd) && $last && $parent.$last && ( mklistpr.pagination.current * mklistpr.datasPerPage - (mklistpr.datasPerPage -1))+dtIndex == mklistpr.totalCount\" class=\"tr-border\"><td></td><td class=\"text-left\">総 合 計</td><td></td><td></td><td></td><td></td><td></td><td class=\"text-right\"><span>{{ mklistpr.setSouGouSkkei() | number }}</span></td><td class=\"text-right\"><span>{{ mklistpr.setSouGouMikei() | number }}</span></td><td></td></tr><tbody></tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/mklist/print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n</style><nav><dir-pagination-controls on-page-change=\"mklistpr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"mklistpr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br><span>部門：{{ mklistpr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in mklistpr.datas | itemsPerPage: mklistpr.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"mklistpr.totalCount\" current-page=\"mklistpr.pagination.current\"><div ng-include=\"\'app/mklist/print/mklist1.html\'\"></div></section></article></div>");
$templateCache.put("app/nyukin-yotei/print/nkyt1.html","<div class=\"col-xs-12 nkyt-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">入金予定</p><p class=\"text-center title-kikan\">({{nkytpr.frm*1000|date:\'yyyy年M月dd日\'}}～{{nkytpr.to*1000|date:\'yyyy年M月dd日\'}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE {{ $index+1 }}/{{ nkytpr.datas.length }}<br>{{nkytpr.nowDate*1000|date:\'yyyy年M月dd日\'}}作成</span></div></div><div class=\"col-xs-6\"><div class=\"ur-left-table\"><table><tr><td style=\"width:20%\">部門名</td><td style=\"width:20%\">{{ detail[0][0].bumon_cd }}【{{ detail[0][0].bumon_nm }}】</td></tr></table></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"nkyt-print-table\"><table><thead><tr><th class=\"text-center\">入金予定日</th><th class=\"text-center\">得意先名</th><th class=\"text-center\">予定金額</th></tr></thead><tbody ng-repeat=\"(key, items) in detail\"><tr ng-repeat=\"(k, item) in items | orderBy:\'nk_yt_day\'| orderBy:\'-toku_cd\'\" ng-class=\"{\'tr-border\':item.toku_cd == \'000000\'}\"><td><span ng-if=\"$first\">{{ item.nk_yt_day_time*1000|date:\'yyyy年M月dd日\' }}</span></td><td class=\"text-left\"><span ng-if=\"item.toku_cd != \'000000\'\">{{ item.toku_cd }}</span> {{ item.toku_nm }}</td><td class=\"text-right\"><span>{{ item.yotei_kin | number }}</span></td></tr><tr ng-if=\"$last && $parent.$last\" class=\"tr-border\"><td></td><td class=\"text-left\">部 門 合 計</td><td class=\"text-right\"><span>{{ nkytpr.getBmnKei() | number }}</span></td></tr><tr dir-paginate-end=\"\" ng-if=\"$last && $parent.$last\" class=\"tr-border\"><td></td><td class=\"text-left\">期 間 合 計</td><td class=\"text-right\"><span>{{ nkytpr.getKikanKei() | number }}</span></td></tr><tbody></tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/nyukin-yotei/print/nkyt2.html","<div class=\"col-xs-12 nkyt-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">入金予定</p><p class=\"text-center title-kikan\">({{nkytpr.frm*1000|date:\'yyyy年M月dd日\'}}～{{nkytpr.to*1000|date:\'yyyy年M月dd日\'}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE {{ $index+1 }}/{{ nkytpr.datas.length }}<br>{{nkytpr.nowDate*1000|date:\'yyyy年M月dd日\'}}作成</span></div></div><div class=\"col-xs-6\"><div class=\"nkyt-left-table\"><table><tr><td style=\"width:20%\">部門名</td><td style=\"width:20%\">{{ detail[0][0].bumon_cd }}【{{ detail[0][0].bumon_nm }}】</td></tr></table></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"nkyt-print-table\"><table><thead><tr><th class=\"text-center\">入金予定日</th><th class=\"text-center\">得意先名</th><th class=\"text-center\">前回残高</th><th class=\"text-center\">今回回収額</th><th class=\"text-center\">合計回収額</th><th class=\"text-center\">振込回収額</th><th class=\"text-center\">手形回収額</th><th class=\"text-center\">その他回収額</th></tr></thead><tbody ng-repeat=\"(key, items) in detail\"><tr ng-repeat=\"(k, item) in items | orderBy:\'nk_yt_day\'| orderBy:\'-toku_km\'\" ng-class=\"{\'tr-border\':item.toku_cd == \'000000\'}\"><td><span ng-if=\"$first\">{{ item.nk_yt_day_time*1000|date:\'yyyy年M月dd日\' }}</span></td><td class=\"text-left\"><span ng-if=\"item.toku_cd != \'000000\'\">{{ item.toku_cd }}</span> {{ item.toku_nm }}</td><td class=\"text-right\"><span ng-if=\"item.toku_cd != \'000000\'\">{{ item.zen_zan_kin | number}}</span> <span ng-if=\"item.toku_cd == \'000000\'\">{{ nkytpr.getZenGoukei(items) | number }}</span></td><td class=\"text-right\"><span>{{ item.yotei_kin | number}}</span></td><td class=\"text-right\"><span ng-if=\"item.toku_cd != \'000000\'\">{{ nkytpr.getGoukei(item.zen_zan_kin, item.yotei_kin) | number }}</span> <span ng-if=\"item.toku_cd == \'000000\'\">{{ nkytpr.getGoukei(nkytpr.getZenGoukei(items),item.yotei_kin) | number }}</span></td><td class=\"text-right\"><span ng-if=\"item.toku_cd != \'000000\'\"><span ng-init=\"item.furi_kai_kin = nkytpr.getNyukinYotei(item,1)\">{{ item.furi_kai_kin | number }}</span></span> <span ng-if=\"item.toku_cd == \'000000\'\"><span>{{ nkytpr.getFuriGoukei(1, item.nk_yt_day_time) | number }}</span></span></td><td class=\"text-right\"><span ng-if=\"item.toku_cd != \'000000\'\"><span ng-init=\"item.tegata_kai_kin = nkytpr.getNyukinYotei(item,2)\">{{ item.tegata_kai_kin | number }}</span></span> <span ng-if=\"item.toku_cd == \'000000\'\"><span>{{ nkytpr.getFuriGoukei(2, item.nk_yt_day_time) | number }}</span></span></td><td class=\"text-right\"><span ng-if=\"item.toku_cd != \'000000\'\"><span ng-init=\"item.sonota_kai_kin = nkytpr.getNyukinYotei(item,3)\">{{ item.sonota_kai_kin | number }}</span></span> <span ng-if=\"item.toku_cd == \'000000\'\"><span>{{ nkytpr.getFuriGoukei(3, item.nk_yt_day_time) | number }}</span></span></td></tr><tr ng-if=\"$last && $parent.$last\" class=\"tr-border\"><td></td><td class=\"text-left\">部 門 合 計</td><td class=\"text-right\"><span>{{ nkytpr.getBmnZenKei() | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getBmnKonKei() | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getGoukei(nkytpr.getBmnZenKei(), nkytpr.getBmnKonKei()) | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getBmnFuriKei(1) | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getBmnFuriKei(2) | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getBmnFuriKei(3) | number }}</span></td></tr><tr ng-if=\"nkytpr.checkLastBmn(detail[0].bumon_cd) && $last && $parent.$last && ( nkytpr.pagination.current * nkytpr.datasPerPage - (nkytpr.datasPerPage -1))+dtIndex == nkytpr.totalCount\" class=\"tr-border\"><td></td><td class=\"text-left\">総 合 計</td><td class=\"text-right\"><span>{{ nkytpr.getZenSouKei() | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getKonSouKei() | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getGoukei(nkytpr.getZenSouKei(), nkytpr.getKonSouKei()) | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getFuriSouKei(1) | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getFuriSouKei(2) | number }}</span></td><td class=\"text-right\"><span>{{ nkytpr.getFuriSouKei(3) | number }}</span></td></tr><tbody></tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/nyukin-yotei/print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n</style><nav><dir-pagination-controls on-page-change=\"nkytpr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"nkytpr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br><span>部門：{{ nkytpr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\"><section class=\"col-xs-12\" ng-if=\"nkytpr.mode == \'2\'\" dir-paginate=\"(dtIndex, detail) in nkytpr.datas | itemsPerPage: nkytpr.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"nkytpr.totalCount\" current-page=\"nkytpr.pagination.current\"><div ng-include=\"\'app/nyukin-yotei/print/nkyt1.html\'\"></div></section><section class=\"col-xs-12\" ng-if=\"nkytpr.mode == \'1\'\" dir-paginate=\"(dtIndex, detail) in nkytpr.datas | itemsPerPage: nkytpr.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"nkytpr.totalCount\" current-page=\"nkytpr.pagination.current\"><div ng-include=\"\'app/nyukin-yotei/print/nkyt2.html\'\"></div></section></article></div>");
$templateCache.put("app/tokuisaki-moto/print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n</style><nav><dir-pagination-controls on-page-change=\"tkmtpr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"tkmtpr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br><span>部門：{{ tkmtpr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in tkmtpr.datas | orderBy:\'_toku_cd\':false | itemsPerPage: tkmtpr.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"tkmtpr.totalCount\" current-page=\"tkmtpr.pagination.current\"><div ng-include=\"\'app/tokuisaki-moto/print/tkmt.html\'\"></div></section></article></div>");
$templateCache.put("app/tokuisaki-moto/print/tkmt.html","<div class=\"col-xs-12 tkmt-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">得意先元帳</p><p class=\"text-center title-kikan\">({{tkmtpr.frm*1000|date:\'yyyy年M月dd日\'}}～{{tkmtpr.to*1000|date:\'yyyy年M月dd日\'}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(tkmtpr.pagination.current * tkmtpr.datasPerPage - (tkmtpr.datasPerPage -1))+$index +\'/\'+ tkmtpr.totalCount\"></span><br>{{ tkmtpr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><div class=\"tkmt-left-table\"><table><tr><td style=\"width:width:130px\">部門名</td><td class=\"text-left\">{{ detail[0][0].bumon_cd }}【{{ detail[0][0].bumon_nm }}】</td></tr><tr><td style=\"width:130px\">( {{ detail[0].toku_cd }} )</td><td class=\"text-left\">{{ detail[0].toku_nm }}</td></tr></table></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"tkmt-print-table\"><table><thead><tr><th class=\"text-center\">日付</th><th class=\"text-center\">納品No.</th><th class=\"text-center\">担当者</th><th class=\"text-center\">作品名</th><th class=\"text-center\">売上金額</th><th class=\"text-center\">消費税額</th><th class=\"text-center\">合計金額</th><th class=\"text-center\">入金金額</th><th class=\"text-center\">差引残高</th><th class=\"text-center\">請求月</th><th class=\"text-center\">請求No.</th><th class=\"text-center\">受注No.</th></tr></thead><tbody ng-repeat=\"(key, items) in detail\"><tr ng-repeat=\"(k, item) in items | orderBy:\'ur_day\'\" ng-class=\"{\'tr-border-tkmt\':item.nh_no == \'000000\' && item.sk_no != \'999999\'}\"><td><span ng-init=\"detail[key].toku_nm = item.toku_nm\"></span> <span ng-init=\"detail[key].toku_cd = item.toku_cd\"></span> <span ng-if=\"item.nh_no != \'000000\'\">{{ item.ur_day_time*1000|date:\'MM/dd\' }}</span></td><td class=\"text-left\"><span ng-if=\"item.nh_no != \'000000\'\">{{ item.nh_no }}</span></td><td class=\"text-left\"><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ item.tan_nm }}</span></td><td class=\"text-left\"><span>{{ item.sakuhin_nm }}</span></td><td class=\"text-right\"><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ item.jt_ur_kin | number}}</span></td><td class=\"text-right\"><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ item.zei_kin | number}}</span></td><td class=\"text-right\"><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ tkmtpr.getGoukei(item.jt_ur_kin, item.zei_kin) | number }}</span></td><td class=\"text-right\"><span ng-if=\"item.nh_no != \'000000\'\">{{ item.nk_kin | number}}</span></td><td class=\"text-right\"><span ng-init=\"items[key].sasi_zan = tkmtpr.getSasiZan(k, items)\">{{ tkmtpr.getSasiZan(k, items) | number }}</span></td><td><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ item.sk_day_time*1000|date:\'yy/MM\' }}</span></td><td><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ item.sk_no }}</span></td><td><span ng-if=\"item.nh_no != \'000000\' && item.sk_no != \'999999\'\">{{ item.ju_no }}</span></td></tr><tr ng-if=\"$last\" class=\"tr-border\"><td></td><td></td><td></td><td class=\"text-left\">【 期 間 合 計 】</td><td class=\"text-right\"><span>{{ tkmtpr.setKikanGoukeiUri(items) | number }}</span></td><td class=\"text-right\"><span>{{ tkmtpr.setKikanGoukeiZei(items) | number }}</span></td><td class=\"text-right\"><span>{{ tkmtpr.getGoukei(tkmtpr.setKikanGoukeiUri(items), tkmtpr.setKikanGoukeiZei(items)) | number }}</span></td><td class=\"text-right\"><span>{{ tkmtpr.setKikanGoukeiNyukin(items) | number }}</span></td><td class=\"text-right\"><span>{{ tkmtpr.setKikanGoukeiHikikin(items) | number }}</span></td><td></td><td></td><td></td></tr><tbody></tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/urikake/print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n</style><nav><dir-pagination-controls on-page-change=\"urkpr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"urkpr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー&emsp;－</span><br><span>部門：{{ urkpr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in urkpr.datas | orderBy:\'_toku_cd\':false | itemsPerPage: urkpr.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"urkpr.totalCount\" current-page=\"urkpr.pagination.current\"><div ng-include=\"\'app/urikake/print/urk.html\'\"></div></section></article></div>");
$templateCache.put("app/urikake/print/urk.html","<div class=\"col-xs-12 urk-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">売掛一覧</p><p class=\"text-center title-kikan\">({{urkpr.frm*1000|date:\'yyyy年M月dd日\'}}～{{urkpr.to*1000|date:\'yyyy年M月dd日\'}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(urkpr.pagination.current * urkpr.datasPerPage - (urkpr.datasPerPage -1))+$index +\'/\'+ urkpr.totalCount\"></span><br>{{ urkpr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><div class=\"urk-left-table\"><table><tr><td style=\"width:width:130px\">部門名</td><td class=\"text-left\">{{ detail[0].bumon_cd }}【{{ detail[0].bumon_nm }}】</td></tr></table></div></div><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"urk-print-table\"><table><thead><tr><th class=\"text-center\">得意先名</th><th class=\"text-center\">前月残高</th><th class=\"text-center\">売上高</th><th class=\"text-center\">消費税額</th><th class=\"text-center\">合計売上高</th><th class=\"text-center\">振込入金額</th><th class=\"text-center\">その他入金額</th><th class=\"text-center\">振込手数料</th><th class=\"text-center\">雑損他</th><th class=\"text-center\">当月残高</th></tr></thead><tbody ng-repeat=\"(key, item) in detail | orderBy:\'toku_km\'\"><tr><td class=\"text-left\"><span>{{ item.toku_cd }} {{ item.toku_nm }}</span></td><td class=\"text-right\"><span>{{ item.zen_zan | number }}</span></td><td class=\"text-right\"><span>{{ item.uriage | number }}</span></td><td class=\"text-right\"><span>{{ item.zei | number }}</span></td><td class=\"text-right\"><span>{{ item.goukei | number }}</span></td><td class=\"text-right\"><span>{{ item.furi_nk_kin | number }}</span></td><td class=\"text-right\"><span>{{ item.ta_nk_kin | number }}</span></td><td class=\"text-right\"><span>{{ item.furi_tes_kin | number }}</span></td><td class=\"text-right\"><span>{{ item.zatsu_son | number }}</span></td><td class=\"text-right\"><span ng-init=\"urkpr.setGetsuZan(dtIndex,key,item);\"></span> <span>{{ item.getsu_zan | number }}</span></td></tr><tr ng-if=\"$last && $parent.$last && ( urkpr.pagination.current * urkpr.datasPerPage - (urkpr.datasPerPage -1))+dtIndex == urkpr.totalCount\" class=\"tr-border\"><td class=\"text-right\">部 門 合 計</td><td class=\"text-right\"><span>{{ urkpr.setBmnZenZanKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnUriageKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnZeiKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnGoukeiKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnFuriNkKinKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnTaNkKinKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnFuriTesKinKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnZatsuSonKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setBmnGetsuZanKei() | number }}</span></td></tr><tr ng-if=\"urkpr.checkLastBmn(detail[0].bumon_cd) && $last && $parent.$last && ( urkpr.pagination.current * urkpr.datasPerPage - (urkpr.datasPerPage -1))+dtIndex == urkpr.totalCount\" class=\"tr-border\"><td class=\"text-right\">期 間 合 計</td><td class=\"text-right\"><span>{{ urkpr.setSoZenZanKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoUriageKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoZeiKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoGoukeiKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoFuriNkKinKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoTaNkKinKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoFuriTesKinKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoZatsuSonKei() | number }}</span></td><td class=\"text-right\"><span>{{ urkpr.setSoGetsuZanKei() | number }}</span></td></tr><tbody></tbody></tbody></table></div></div></div></div></div>");
$templateCache.put("app/ur-print/urSgItem/ursgitem.html","<div class=\"modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header modal-header-default\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.hideSgItemModal()\"><span aria-hidden=\"true\">&times;</span></button><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit\"><thead><tr class=\"active\"><th class=\"title\">作業分類</th><th class=\"title\">部門</th></tr></thead><tbody class=\"fit\"><tr><td style=\"width:50%\"><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.sg_bunrui_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bunruiDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td><td style=\"width:50%\"><button type=\"button\" class=\"btn btn-default normal\" ng-model=\"vm.bumon_cd\" placeholder=\"--\" bs-options=\"item.id as item.name for item in vm.bumonDropdown\" bs-select=\"\"><span class=\"caret\"></span></button></td></tr></tbody></table></div></div></div><div class=\"modal-body modal-fit sg-item-modal\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-hover table-bordered fit sg-itm\"><thead><tr class=\"active\"><th class=\"title\">コード</th><th class=\"title\">作業内容</th></tr></thead><tbody ng-repeat=\"item in filtered = (vm.sagyoDtl | filter:{\'bumon_cd\':vm.bumon_cd} | filter:{\'sg_bunrui_cd\':vm.sg_bunrui_cd} ) track by $index |orderBy:\'sg_item_cd\'\" ng-dblclick=\"vm.setSgItemCd(item)\"><tr><td style=\"width:15%\" class=\"text-center\">{{ item.sg_item_cd }}</td><td>{{ item.sg_item_nm }}</td></tr></tbody></table></div></div></div><div class=\"modal-footer sg-item-modal-footer\"><div class=\"row\"><div class=\"cpl-xs-1\"></div><div class=\"cpl-xs-11\"><p class=\"text-left\">&emsp;{{ filtered.length }} 件&emsp;<small class=\"text-danger\">※ダブルクリックで反映されます</small></p></div></div></div></div></div></div>");
$templateCache.put("app/inventory/inventory-issue/ivis-print/analysis.html","<div class=\"sos-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ ivispr.title }}</p><p class=\"text-center title-kikan\">({{ivispr.fromDate}}～{{ivispr.toDate}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(ivispr.pagination.current * ivispr.datasPerPage - (ivispr.datasPerPage -1))+$index +\'/\'+ ivispr.totalCount\"></span><br>{{ ivispr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-staff-ope\"><caption ng-if=\"detail[0].bumon_cd\">部門&nbsp;{{ detail[0].bumon_cd }}&nbsp;{{ detail[0].bumon_nm }}</caption><thead><tr><th class=\"title-tan\" colspan=\"3\" style=\"width:250px\">商品名</th><th class=\"title-body\" style=\"width:60px\">日付</th><th class=\"title-body\" style=\"width:45px\">受注No.</th><th class=\"title-body\">作品名</th><th class=\"title-body\" style=\"width:45px\" \"=\"\">作業伝票No.</th><th class=\"title-body\" style=\"width:40px\">数量</th><th class=\"title-body\" style=\"width:40px\">単位</th><th class=\"title-body\" style=\"width:100px\">得意先名</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:[\'sg_day_time\',\'media_cd\',\'sg_item_cd\'] track by $index\"><tr ng-if=\"dtl.ju_no != \'9999\'\"><td class=\"name-left\" colspan=\"2\" style=\"width:120px\"><span ng-if=\"$first\">{{ dtl.studio_nm}}</span><div ng-if=\"!$first\">&nbsp;</div></td><td class=\"name-left\">{{ dtl.sg_item_cd}}&nbsp;{{ dtl.sg_item_nm}}</td><td class=\"name-left\">{{ dtl.sg_day_time*1000 | date:\'MM/dd\' }}</td><td class=\"name-left\">{{ dtl.ju_no}}</td><td class=\"name-left\" style=\"min-width:120px\">{{ dtl.hin_nm}}</td><td class=\"name-left\">{{ dtl.sg_no}}</td><td>{{ dtl.syukko_suryo}}</td><td class=\"name-center\">{{ dtl.tani}}</td><td class=\"name-left\">{{ dtl.toku_nm}}</td></tr><tr ng-class=\"{\'last\':dtl.ju_no == \'9999\'}\" ng-if=\"dtl.ju_no == \'9999\'\"><td>&nbsp;</td><td>&nbsp;</td><td colspan=\"3\" class=\"name-center\">{{ dtl.studio_nm}}&nbsp;{{ dtl.sg_item_nm}}</td><td>&nbsp;</td><td>計</td><td>{{ dtl.syukko_suryo}}</td><td>&nbsp;</td><td>&nbsp;</td></tr></tbody></table></div></div>");
$templateCache.put("app/inventory/inventory-issue/ivis-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"ivispr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"ivispr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ ivispr.pagination.current }})&emsp;－</span><br><span>{{ ivispr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"ivispr.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in ivispr.datas | itemsPerPage: ivispr.datasPerPage track by $index\" pagination-id=\"monthlyPrint\" total-items=\"ivispr.totalCount\" current-page=\"ivispr.pagination.current\"><div ng-include=\"\'app/inventory/inventory-issue/ivis-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/inventory/inventory-sgitem/ivi-print/analysis.html","<div class=\"sos-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ ivipr.title }}</p><p class=\"text-center title-kikan\">({{ivipr.fromDate}}～{{ivipr.toDate}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(ivipr.pagination.current * ivipr.datasPerPage - (ivipr.datasPerPage -1))+$index +\'/\'+ ivipr.totalCount\"></span><br>{{ ivipr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-staff-ope\"><thead><tr><th class=\"title-tan\" style=\"width:69%\">商品名</th><th class=\"title-body\" style=\"width:10%\">出庫数量</th><th class=\"title-body\" style=\"width:10%\">単位</th><th class=\"title-body\" style=\"width:10%\">在庫数量</th><th class=\"title-body\" style=\"width:10%\">単位</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:[\'media_cd\',\'sg_item_cd\'] track by $index\"><tr><td class=\"name-left\">{{ dtl.sg_item_cd}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ dtl.sg_item_nm}}</td><td>{{ dtl.syukko_suryo | number }}</td><td class=\"name-center\">{{ dtl.tani}}</td><td><span ng-if=\"dtl.suryo > 0\">{{ dtl.suryo | number }}</span> <span ng-if=\"dtl.suryo*-1 > 0\">0</span> <span ng-if=\"dtl.suryo == 0\">0</span></td><td class=\"name-center\">{{ dtl.tani}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/inventory/inventory-sgitem/ivi-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"ivipr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ ivipr.pagination.current }})&emsp;－</span><br><span>{{ ivipr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"ivipr.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in ivipr.datas | itemsPerPage: ivipr.datasPerPage track by $index\" pagination-id=\"monthlyPrint\" total-items=\"ivipr.totalCount\" current-page=\"ivipr.pagination.current\"><div ng-include=\"\'app/inventory/inventory-sgitem/ivi-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/inventory/inventory-list/ivl-print/analysis.html","<div class=\"sos-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ ivlpr.title }}</p><p class=\"text-center title-kikan\">({{ivlpr.fromDate}}～{{ivlpr.toDate}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(ivlpr.pagination.current * ivlpr.datasPerPage - (ivlpr.datasPerPage -1))+$index +\'/\'+ ivlpr.totalCount\"></span><br>{{ ivlpr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-staff-ope\"><caption ng-if=\"detail[0].bumon_cd\">部門&nbsp;{{ detail[0].bumon_cd }}&nbsp;{{ detail[0].bumon_nm }}</caption><thead><tr><th class=\"title-tan\" colspan=\"2\">商品名</th><th class=\"title-body\">最新単価</th><th class=\"title-body\">平均単価</th><th class=\"title-body\">繰越数量</th><th class=\"title-body\">繰越金額</th><th class=\"title-body\">入庫数量<br>(移動入庫)</th><th class=\"title-body\">入庫金額<br>(移動入庫)</th><th class=\"title-body\">出庫数量<br>(移動出庫)</th><th class=\"title-body\">出庫金額<br>(移動出庫)</th><th class=\"title-body\">調整金額</th><th class=\"title-body\">在庫数量</th><th class=\"title-body\">在庫金額</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:[\'media_cd_num\',\'sg_item_cd\'] track by $index\"><tr ng-if=\"dtl.media_cd != \'99999\'\"><td>{{ dtl.sg_item_cd}}</td><td class=\"name-left\">&nbsp;&nbsp;{{ dtl.sg_item_nm}}</td><td ng-if=\"dtl.sin_tanka != 0\">{{ dtl.sin_tanka | number}}</td><td ng-if=\"dtl.sin_tanka == 0\">{{ dtl.avg_tanka | number}}</td><td>{{ dtl.avg_tanka | number}}</td><td>{{ dtl.kuri_suryo | number}}</td><td>{{ dtl.kuri_kin | number}}</td><td>{{ dtl.nyuko_suryo | number}}<br>{{ dtl.zai_nyuko_suryo | number}}</td><td>{{ dtl.nyuko_kin | number}}<br>{{ dtl.zai_nyuko_kin | number}}</td><td>{{ dtl.syukko_suryo | number}}<br>{{ dtl.zai_ido_suryo | number}}</td><td>{{ dtl.syukko_kin | number}}<br>{{ dtl.zai_ido_kin | number}}</td><td>{{ ivlpr.chouseiSum(dtl.kuri_kin ,dtl.nyuko_kin,dtl.zai_nyuko_kin,dtl.syukko_kin,dtl.zai_ido_kin,dtl.sou_kin) | number}}</td><td>{{ dtl.sou_suryo | number}}</td><td>{{ dtl.sou_kin | number}}</td></tr><tr ng-class=\"{\'last\':dtl.media_cd == \'99999\'}\" ng-if=\"dtl.media_cd == \'99999\'\"><td>&nbsp;</td><td>&nbsp;</td><td colspan=\"3\" class=\"name-center\">{{ dtl.bumon_nm}}</td><td>{{ dtl.sum_kuri_kin | number}}</td><td>&nbsp;</td><td>{{ dtl.sum_nyuko_kin | number}}<br>{{ dtl.sum_zai_nyuko_kin | number}}</td><td>&nbsp;</td><td>{{ dtl.sum_syukko_kin | number}}<br>{{ dtl.sum_zai_ido_kin | number}}</td><td>&nbsp;</td><td>&nbsp;</td><td>{{ dtl.sum_sou_kin | number}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/inventory/inventory-list/ivl-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"ivlpr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-warning btn-sm dropdown-toggle\" ng-if=\"!ivlpr.zeroDataSwitch\" ng-click=\"ivlpr.pageEngneerInit(true)\">移動・繰越の無いデータを表示</button> <button type=\"button\" class=\"btn btn-info btn-sm dropdown-toggle\" ng-if=\"ivlpr.zeroDataSwitch\" ng-click=\"ivlpr.pageEngneerInit(false)\">移動・繰越の無いデータを非表示</button> <button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"ivlpr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ ivlpr.pagination.current }})&emsp;－</span><br><span>{{ ivlpr.bumonName }}</span></div><div class=\"text-left\"><ul type=\"circle\" class=\"print-description\"><li>最新単価 <small>期間内における最終仕入単価</small></li><li>平均単価 <small>（繰越金額＋入荷（仕入）金額＋調整（振替）金額）÷（繰越数量＋入荷（仕入）数量＋調整（振替）数量）</small></li><li>繰越数量 <small>期間（FROM）の前日時点の在庫数量</small></li><li>繰越金額 <small>繰越数量×前日繰越単価</small></li><li>入庫数量 <small>期間内における入庫数量</small></li><li>入庫金額 <small>期間内における入庫金額</small></li><li>出庫数量 <small>期間内における出庫数量</small></li><li>出庫金額 <small>出庫数量×平均単価</small></li><li>調整金額 <small>平均単価を使用した場合の誤差調整金額＝（繰越金額＋入庫（仕入）金額）－（出庫（売上）金額＋在庫金額）</small></li><li>出庫金額 <small>期間（TO）時点の在庫数量</small></li><li>在庫金額 <small>期間(TO）時点の在庫金額（在庫数量×平均単価）</small></li></ul></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"ivlpr.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in ivlpr.datas | itemsPerPage: ivlpr.datasPerPage\" pagination-id=\"monthlyPrint\" total-items=\"ivlpr.totalCount\" current-page=\"ivlpr.pagination.current\"><div ng-include=\"\'app/inventory/inventory-list/ivl-print/analysis.html\'\"></div></section></article></div>");
$templateCache.put("app/inventory/inventory-studio/ivs-print/analysis.html","<div class=\"sos-print-page\"><div class=\"col-xs-12\"><div class=\"col-xs-3\"></div><div class=\"col-xs-6\"><p class=\"text-center ur-title\">{{ ivspr.title }}</p><p class=\"text-center title-kikan\">({{ivspr.fromDate}}～{{ivspr.toDate}})</p></div><div class=\"col-xs-3 text-right yt-page\"><span>PAGE <span ng-bind=\"(ivspr.pagination.current * ivspr.datasPerPage - (ivspr.datasPerPage -1))+$index +\'/\'+ ivspr.totalCount\"></span><br>{{ ivspr.nowDate*1000|date:\'yyyy年M月dd日\' }}作成</span></div></div><div class=\"col-xs-12\"><table class=\"table table-staff-ope\"><caption ng-if=\"detail[0].bumon_cd\">部門&nbsp;{{ detail[0].bumon_cd }}&nbsp;{{ detail[0].bumon_nm }}</caption><thead><tr><th class=\"title-tan\" style=\"width:30%\">スタジオ</th><th class=\"title-tan\" colspan=\"3\" style=\"width:250px\">商品名</th><th class=\"title-body\" style=\"width:10%\">数量</th><th class=\"title-body\" style=\"width:10%\">単位</th></tr></thead><tbody ng-repeat=\"( key, dtl ) in detail | orderBy:[\'studio_cd\',\'media_cd\',\'sg_item_cd\'] track by $index\"><tr><td class=\"name-left\"><span ng-if=\"detail[key-1].studio_cd != dtl.studio_cd\">{{ dtl.studio_nm }}</span></td><td class=\"name-left\" colspan=\"3\">{{ dtl.sg_item_cd}}&nbsp;{{ dtl.sg_item_nm}}</td><td>{{ dtl.syukko_suryo}}</td><td class=\"name-center\">{{ dtl.tani}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/inventory/inventory-studio/ivs-print/print.html","<style>\n    @page {\n      size: A4!important;\n      margin: 0!important;\n    }\n    @media print {\n      html, body {\n        width: 297mm!important;\n        height: 210mm!important;\n      }\n    }\n}\n</style><nav><dir-pagination-controls on-page-change=\"ivspr.pageChanged(newPageNumber)\" boundary-links=\"true\" template-url=\"app/components/pagination/normPagination.tpl.html\" pagination-id=\"monthlyPrint\"></dir-pagination-controls></nav><button type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\" bs-dropdown=\"ivspr.bumonDropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">部門選択 <span class=\"caret\"></span></button> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-print=\"\" print-element-id=\"jt-print-area\"><i class=\"fa fa-print\"></i> 印刷</button><div class=\"text-center\"><span>－&emsp;印刷プレビュー({{ ivspr.pagination.current }})&emsp;－</span><br><span>{{ ivspr.bumonName }}</span></div><hr><div class=\"row virtical-preview-area\"><article id=\"jt-print-area\" ng-if=\"ivspr.datas.length > 0\"><section class=\"col-xs-12\" dir-paginate=\"(dtIndex, detail) in ivspr.datas | itemsPerPage: ivspr.datasPerPage track by $index\" pagination-id=\"monthlyPrint\" total-items=\"ivspr.totalCount\" current-page=\"ivspr.pagination.current\"><div ng-include=\"\'app/inventory/inventory-studio/ivs-print/analysis.html\'\"></div></section></article></div>");}]);